/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(163);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Main = __webpack_require__(147);
	
	var _Main2 = _interopRequireDefault(_Main);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Render the main component into the dom
	_reactDom2.default.render(_react2.default.createElement(_Main2.default, null), document.getElementById('app'));

/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(303);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 3 */
/***/ function(module, exports) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	// css base code, injected by the css-loader
	module.exports = function() {
		var list = [];
	
		// return the list of modules as css string
		list.toString = function toString() {
			var result = [];
			for(var i = 0; i < this.length; i++) {
				var item = this[i];
				if(item[2]) {
					result.push("@media " + item[2] + "{" + item[1] + "}");
				} else {
					result.push(item[1]);
				}
			}
			return result.join("");
		};
	
		// import a list of modules into the list
		list.i = function(modules, mediaQuery) {
			if(typeof modules === "string")
				modules = [[null, modules, ""]];
			var alreadyImportedModules = {};
			for(var i = 0; i < this.length; i++) {
				var id = this[i][0];
				if(typeof id === "number")
					alreadyImportedModules[id] = true;
			}
			for(i = 0; i < modules.length; i++) {
				var item = modules[i];
				// skip already imported module
				// this implementation is not 100% perfect for weird media query combinations
				//  when a module is imported multiple times with different media queries.
				//  I hope this will never occur (Hey this way we have smaller bundles)
				if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
					if(mediaQuery && !item[2]) {
						item[2] = mediaQuery;
					} else if(mediaQuery) {
						item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
					}
					list.push(item);
				}
			}
		};
		return list;
	};


/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/*
		MIT License http://www.opensource.org/licenses/mit-license.php
		Author Tobias Koppers @sokra
	*/
	var stylesInDom = {},
		memoize = function(fn) {
			var memo;
			return function () {
				if (typeof memo === "undefined") memo = fn.apply(this, arguments);
				return memo;
			};
		},
		isOldIE = memoize(function() {
			return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
		}),
		getHeadElement = memoize(function () {
			return document.head || document.getElementsByTagName("head")[0];
		}),
		singletonElement = null,
		singletonCounter = 0,
		styleElementsInsertedAtTop = [];
	
	module.exports = function(list, options) {
		if(false) {
			if(typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
		}
	
		options = options || {};
		// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
		// tags it will allow on a page
		if (typeof options.singleton === "undefined") options.singleton = isOldIE();
	
		// By default, add <style> tags to the bottom of <head>.
		if (typeof options.insertAt === "undefined") options.insertAt = "bottom";
	
		var styles = listToStyles(list);
		addStylesToDom(styles, options);
	
		return function update(newList) {
			var mayRemove = [];
			for(var i = 0; i < styles.length; i++) {
				var item = styles[i];
				var domStyle = stylesInDom[item.id];
				domStyle.refs--;
				mayRemove.push(domStyle);
			}
			if(newList) {
				var newStyles = listToStyles(newList);
				addStylesToDom(newStyles, options);
			}
			for(var i = 0; i < mayRemove.length; i++) {
				var domStyle = mayRemove[i];
				if(domStyle.refs === 0) {
					for(var j = 0; j < domStyle.parts.length; j++)
						domStyle.parts[j]();
					delete stylesInDom[domStyle.id];
				}
			}
		};
	}
	
	function addStylesToDom(styles, options) {
		for(var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];
			if(domStyle) {
				domStyle.refs++;
				for(var j = 0; j < domStyle.parts.length; j++) {
					domStyle.parts[j](item.parts[j]);
				}
				for(; j < item.parts.length; j++) {
					domStyle.parts.push(addStyle(item.parts[j], options));
				}
			} else {
				var parts = [];
				for(var j = 0; j < item.parts.length; j++) {
					parts.push(addStyle(item.parts[j], options));
				}
				stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
			}
		}
	}
	
	function listToStyles(list) {
		var styles = [];
		var newStyles = {};
		for(var i = 0; i < list.length; i++) {
			var item = list[i];
			var id = item[0];
			var css = item[1];
			var media = item[2];
			var sourceMap = item[3];
			var part = {css: css, media: media, sourceMap: sourceMap};
			if(!newStyles[id])
				styles.push(newStyles[id] = {id: id, parts: [part]});
			else
				newStyles[id].parts.push(part);
		}
		return styles;
	}
	
	function insertStyleElement(options, styleElement) {
		var head = getHeadElement();
		var lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
		if (options.insertAt === "top") {
			if(!lastStyleElementInsertedAtTop) {
				head.insertBefore(styleElement, head.firstChild);
			} else if(lastStyleElementInsertedAtTop.nextSibling) {
				head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling);
			} else {
				head.appendChild(styleElement);
			}
			styleElementsInsertedAtTop.push(styleElement);
		} else if (options.insertAt === "bottom") {
			head.appendChild(styleElement);
		} else {
			throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
		}
	}
	
	function removeStyleElement(styleElement) {
		styleElement.parentNode.removeChild(styleElement);
		var idx = styleElementsInsertedAtTop.indexOf(styleElement);
		if(idx >= 0) {
			styleElementsInsertedAtTop.splice(idx, 1);
		}
	}
	
	function createStyleElement(options) {
		var styleElement = document.createElement("style");
		styleElement.type = "text/css";
		insertStyleElement(options, styleElement);
		return styleElement;
	}
	
	function createLinkElement(options) {
		var linkElement = document.createElement("link");
		linkElement.rel = "stylesheet";
		insertStyleElement(options, linkElement);
		return linkElement;
	}
	
	function addStyle(obj, options) {
		var styleElement, update, remove;
	
		if (options.singleton) {
			var styleIndex = singletonCounter++;
			styleElement = singletonElement || (singletonElement = createStyleElement(options));
			update = applyToSingletonTag.bind(null, styleElement, styleIndex, false);
			remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true);
		} else if(obj.sourceMap &&
			typeof URL === "function" &&
			typeof URL.createObjectURL === "function" &&
			typeof URL.revokeObjectURL === "function" &&
			typeof Blob === "function" &&
			typeof btoa === "function") {
			styleElement = createLinkElement(options);
			update = updateLink.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
				if(styleElement.href)
					URL.revokeObjectURL(styleElement.href);
			};
		} else {
			styleElement = createStyleElement(options);
			update = applyToTag.bind(null, styleElement);
			remove = function() {
				removeStyleElement(styleElement);
			};
		}
	
		update(obj);
	
		return function updateStyle(newObj) {
			if(newObj) {
				if(newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap)
					return;
				update(obj = newObj);
			} else {
				remove();
			}
		};
	}
	
	var replaceText = (function () {
		var textStore = [];
	
		return function (index, replacement) {
			textStore[index] = replacement;
			return textStore.filter(Boolean).join('\n');
		};
	})();
	
	function applyToSingletonTag(styleElement, index, remove, obj) {
		var css = remove ? "" : obj.css;
	
		if (styleElement.styleSheet) {
			styleElement.styleSheet.cssText = replaceText(index, css);
		} else {
			var cssNode = document.createTextNode(css);
			var childNodes = styleElement.childNodes;
			if (childNodes[index]) styleElement.removeChild(childNodes[index]);
			if (childNodes.length) {
				styleElement.insertBefore(cssNode, childNodes[index]);
			} else {
				styleElement.appendChild(cssNode);
			}
		}
	}
	
	function applyToTag(styleElement, obj) {
		var css = obj.css;
		var media = obj.media;
	
		if(media) {
			styleElement.setAttribute("media", media)
		}
	
		if(styleElement.styleSheet) {
			styleElement.styleSheet.cssText = css;
		} else {
			while(styleElement.firstChild) {
				styleElement.removeChild(styleElement.firstChild);
			}
			styleElement.appendChild(document.createTextNode(css));
		}
	}
	
	function updateLink(linkElement, obj) {
		var css = obj.css;
		var sourceMap = obj.sourceMap;
	
		if(sourceMap) {
			// http://stackoverflow.com/a/26603875
			css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
		}
	
		var blob = new Blob([css], { type: "text/css" });
	
		var oldSrc = linkElement.href;
	
		linkElement.href = URL.createObjectURL(blob);
	
		if(oldSrc)
			URL.revokeObjectURL(oldSrc);
	}


/***/ },
/* 5 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(10);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  (function () {
	    var printWarning = function printWarning(format) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    };
	
	    warning = function warning(condition, format) {
	      if (format === undefined) {
	        throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	      }
	
	      if (format.indexOf('Failed Composite propType: ') === 0) {
	        return; // Ignore CompositeComponent proptype check.
	      }
	
	      if (!condition) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        printWarning.apply(undefined, [format].concat(args));
	      }
	    };
	  })();
	}
	
	module.exports = warning;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMProperty = __webpack_require__(25);
	var ReactDOMComponentFlags = __webpack_require__(111);
	
	var invariant = __webpack_require__(2);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 9 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 10 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(204);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./button.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./button.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(210);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./icon.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./icon.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactCurrentOwner = __webpack_require__(20);
	
	var warning = __webpack_require__(6);
	var canDefineProperty = __webpack_require__(124);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	    var shadowChildren = Array.isArray(props.children) ? props.children.slice(0) : props.children;
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      Object.defineProperty(element, '_shadowChildren', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: shadowChildren
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._shadowChildren = shadowChildren;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(107);
	var PooledClass = __webpack_require__(19);
	var ReactFeatureFlags = __webpack_require__(114);
	var ReactReconciler = __webpack_require__(26);
	var Transaction = __webpack_require__(36);
	
	var invariant = __webpack_require__(2);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(40);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(19);
	
	var emptyFunction = __webpack_require__(10);
	var warning = __webpack_require__(6);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else if (typeof event.returnValue !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // eslint-disable-line valid-typeof
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 18 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 20 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(206);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./dimmer.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./dimmer.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  function ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	
	  function bisector(compare) {
	    if (compare.length === 1) compare = ascendingComparator(compare);
	    return {
	      left: function(a, x, lo, hi) {
	        if (lo == null) lo = 0;
	        if (hi == null) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1;
	          else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (lo == null) lo = 0;
	        if (hi == null) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid;
	          else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	
	  function ascendingComparator(f) {
	    return function(d, x) {
	      return ascending(f(d), x);
	    };
	  }
	
	  var ascendingBisect = bisector(ascending);
	  var bisectRight = ascendingBisect.right;
	  var bisectLeft = ascendingBisect.left;
	
	  function descending(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  }
	
	  function number(x) {
	    return x === null ? NaN : +x;
	  }
	
	  function variance(array, f) {
	    var n = array.length,
	        m = 0,
	        a,
	        d,
	        s = 0,
	        i = -1,
	        j = 0;
	
	    if (f == null) {
	      while (++i < n) {
	        if (!isNaN(a = number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	
	    else {
	      while (++i < n) {
	        if (!isNaN(a = number(f(array[i], i, array)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	
	    if (j > 1) return s / (j - 1);
	  }
	
	  function deviation(array, f) {
	    var v = variance(array, f);
	    return v ? Math.sqrt(v) : v;
	  }
	
	  function extent(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b,
	        c;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	
	    return [a, c];
	  }
	
	  var array = Array.prototype;
	
	  var slice = array.slice;
	  var map = array.map;
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function identity(x) {
	    return x;
	  }
	
	  function range(start, stop, step) {
	    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	    var i = -1,
	        n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	        range = new Array(n);
	
	    while (++i < n) {
	      range[i] = start + i * step;
	    }
	
	    return range;
	  }
	
	  var e10 = Math.sqrt(50);
	  var e5 = Math.sqrt(10);
	  var e2 = Math.sqrt(2);
	  function ticks(start, stop, count) {
	    var step = tickStep(start, stop, count);
	    return range(
	      Math.ceil(start / step) * step,
	      Math.floor(stop / step) * step + step / 2, // inclusive
	      step
	    );
	  }
	
	  function tickStep(start, stop, count) {
	    var step0 = Math.abs(stop - start) / Math.max(0, count),
	        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	        error = step0 / step1;
	    if (error >= e10) step1 *= 10;
	    else if (error >= e5) step1 *= 5;
	    else if (error >= e2) step1 *= 2;
	    return stop < start ? -step1 : step1;
	  }
	
	  function sturges(values) {
	    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	  }
	
	  function histogram() {
	    var value = identity,
	        domain = extent,
	        threshold = sturges;
	
	    function histogram(data) {
	      var i,
	          n = data.length,
	          x,
	          values = new Array(n);
	
	      for (i = 0; i < n; ++i) {
	        values[i] = value(data[i], i, data);
	      }
	
	      var xz = domain(values),
	          x0 = xz[0],
	          x1 = xz[1],
	          tz = threshold(values, x0, x1);
	
	      // Convert number of thresholds into uniform thresholds.
	      if (!Array.isArray(tz)) tz = ticks(x0, x1, tz);
	
	      // Remove any thresholds outside the domain.
	      var m = tz.length;
	      while (tz[0] <= x0) tz.shift(), --m;
	      while (tz[m - 1] >= x1) tz.pop(), --m;
	
	      var bins = new Array(m + 1),
	          bin;
	
	      // Initialize bins.
	      for (i = 0; i <= m; ++i) {
	        bin = bins[i] = [];
	        bin.x0 = i > 0 ? tz[i - 1] : x0;
	        bin.x1 = i < m ? tz[i] : x1;
	      }
	
	      // Assign data to bins by value, ignoring any outside the domain.
	      for (i = 0; i < n; ++i) {
	        x = values[i];
	        if (x0 <= x && x <= x1) {
	          bins[bisectRight(tz, x, 0, m)].push(data[i]);
	        }
	      }
	
	      return bins;
	    }
	
	    histogram.value = function(_) {
	      return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	    };
	
	    histogram.domain = function(_) {
	      return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	    };
	
	    histogram.thresholds = function(_) {
	      return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	    };
	
	    return histogram;
	  }
	
	  function quantile(array, p, f) {
	    if (f == null) f = number;
	    if (!(n = array.length)) return;
	    if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
	    if (p >= 1) return +f(array[n - 1], n - 1, array);
	    var n,
	        h = (n - 1) * p,
	        i = Math.floor(h),
	        a = +f(array[i], i, array),
	        b = +f(array[i + 1], i + 1, array);
	    return a + (b - a) * (h - i);
	  }
	
	  function freedmanDiaconis(values, min, max) {
	    values = map.call(values, number).sort(ascending);
	    return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	  }
	
	  function scott(values, min, max) {
	    return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	  }
	
	  function max(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
	    }
	
	    return a;
	  }
	
	  function mean(array, f) {
	    var s = 0,
	        n = array.length,
	        a,
	        i = -1,
	        j = n;
	
	    if (f == null) {
	      while (++i < n) if (!isNaN(a = number(array[i]))) s += a; else --j;
	    }
	
	    else {
	      while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) s += a; else --j;
	    }
	
	    if (j) return s / j;
	  }
	
	  function median(array, f) {
	    var numbers = [],
	        n = array.length,
	        a,
	        i = -1;
	
	    if (f == null) {
	      while (++i < n) if (!isNaN(a = number(array[i]))) numbers.push(a);
	    }
	
	    else {
	      while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) numbers.push(a);
	    }
	
	    return quantile(numbers.sort(ascending), 0.5);
	  }
	
	  function merge(arrays) {
	    var n = arrays.length,
	        m,
	        i = -1,
	        j = 0,
	        merged,
	        array;
	
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	
	    return merged;
	  }
	
	  function min(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
	    }
	
	    return a;
	  }
	
	  function pairs(array) {
	    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [p, p = array[++i]];
	    return pairs;
	  }
	
	  function permute(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  }
	
	  function scan(array, compare) {
	    if (!(n = array.length)) return;
	    var i = 0,
	        n,
	        j = 0,
	        xi,
	        xj = array[j];
	
	    if (!compare) compare = ascending;
	
	    while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
	
	    if (compare(xj, xj) === 0) return j;
	  }
	
	  function shuffle(array, i0, i1) {
	    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	        t,
	        i;
	
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0];
	      array[m + i0] = array[i + i0];
	      array[i + i0] = t;
	    }
	
	    return array;
	  }
	
	  function sum(array, f) {
	    var s = 0,
	        n = array.length,
	        a,
	        i = -1;
	
	    if (f == null) {
	      while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
	    }
	
	    else {
	      while (++i < n) if (a = +f(array[i], i, array)) s += a;
	    }
	
	    return s;
	  }
	
	  function transpose(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  }
	
	  function length(d) {
	    return d.length;
	  }
	
	  function zip() {
	    return transpose(arguments);
	  }
	
	  exports.bisect = bisectRight;
	  exports.bisectRight = bisectRight;
	  exports.bisectLeft = bisectLeft;
	  exports.ascending = ascending;
	  exports.bisector = bisector;
	  exports.descending = descending;
	  exports.deviation = deviation;
	  exports.extent = extent;
	  exports.histogram = histogram;
	  exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	  exports.thresholdScott = scott;
	  exports.thresholdSturges = sturges;
	  exports.max = max;
	  exports.mean = mean;
	  exports.median = median;
	  exports.merge = merge;
	  exports.min = min;
	  exports.pairs = pairs;
	  exports.permute = permute;
	  exports.quantile = quantile;
	  exports.range = range;
	  exports.scan = scan;
	  exports.shuffle = shuffle;
	  exports.sum = sum;
	  exports.ticks = ticks;
	  exports.tickStep = tickStep;
	  exports.transpose = transpose;
	  exports.variance = variance;
	  exports.zip = zip;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  // Computes the decimal coefficient and exponent of the specified number x with
	  // significant digits p, where x is positive and p is in [1, 21] or undefined.
	  // For example, formatDecimal(1.23) returns ["123", 0].
	  function formatDecimal(x, p) {
	    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	    var i, coefficient = x.slice(0, i);
	
	    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	    return [
	      coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	      +x.slice(i + 1)
	    ];
	  }
	
	  function exponent(x) {
	    return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	  }
	
	  function formatGroup(grouping, thousands) {
	    return function(value, width) {
	      var i = value.length,
	          t = [],
	          j = 0,
	          g = grouping[0],
	          length = 0;
	
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = grouping[j = (j + 1) % grouping.length];
	      }
	
	      return t.reverse().join(thousands);
	    };
	  }
	
	  function formatDefault(x, p) {
	    x = x.toPrecision(p);
	
	    out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	      switch (x[i]) {
	        case ".": i0 = i1 = i; break;
	        case "0": if (i0 === 0) i0 = i; i1 = i; break;
	        case "e": break out;
	        default: if (i0 > 0) i0 = 0; break;
	      }
	    }
	
	    return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	  }
	
	  var prefixExponent;
	
	  function formatPrefixAuto(x, p) {
	    var d = formatDecimal(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1],
	        i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	        n = coefficient.length;
	    return i === n ? coefficient
	        : i > n ? coefficient + new Array(i - n + 1).join("0")
	        : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	        : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	  }
	
	  function formatRounded(x, p) {
	    var d = formatDecimal(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1];
	    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	        : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	        : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	  }
	
	  var formatTypes = {
	    "": formatDefault,
	    "%": function(x, p) { return (x * 100).toFixed(p); },
	    "b": function(x) { return Math.round(x).toString(2); },
	    "c": function(x) { return x + ""; },
	    "d": function(x) { return Math.round(x).toString(10); },
	    "e": function(x, p) { return x.toExponential(p); },
	    "f": function(x, p) { return x.toFixed(p); },
	    "g": function(x, p) { return x.toPrecision(p); },
	    "o": function(x) { return Math.round(x).toString(8); },
	    "p": function(x, p) { return formatRounded(x * 100, p); },
	    "r": formatRounded,
	    "s": formatPrefixAuto,
	    "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	    "x": function(x) { return Math.round(x).toString(16); }
	  };
	
	  // [[fill]align][sign][symbol][0][width][,][.precision][type]
	  var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	  function formatSpecifier(specifier) {
	    return new FormatSpecifier(specifier);
	  }
	
	  function FormatSpecifier(specifier) {
	    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	    var match,
	        fill = match[1] || " ",
	        align = match[2] || ">",
	        sign = match[3] || "-",
	        symbol = match[4] || "",
	        zero = !!match[5],
	        width = match[6] && +match[6],
	        comma = !!match[7],
	        precision = match[8] && +match[8].slice(1),
	        type = match[9] || "";
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // Map invalid types to the default format.
	    else if (!formatTypes[type]) type = "";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    this.fill = fill;
	    this.align = align;
	    this.sign = sign;
	    this.symbol = symbol;
	    this.zero = zero;
	    this.width = width;
	    this.comma = comma;
	    this.precision = precision;
	    this.type = type;
	  }
	
	  FormatSpecifier.prototype.toString = function() {
	    return this.fill
	        + this.align
	        + this.sign
	        + this.symbol
	        + (this.zero ? "0" : "")
	        + (this.width == null ? "" : Math.max(1, this.width | 0))
	        + (this.comma ? "," : "")
	        + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	        + this.type;
	  };
	
	  var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	  function identity(x) {
	    return x;
	  }
	
	  function formatLocale(locale) {
	    var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	        currency = locale.currency,
	        decimal = locale.decimal;
	
	    function newFormat(specifier) {
	      specifier = formatSpecifier(specifier);
	
	      var fill = specifier.fill,
	          align = specifier.align,
	          sign = specifier.sign,
	          symbol = specifier.symbol,
	          zero = specifier.zero,
	          width = specifier.width,
	          comma = specifier.comma,
	          precision = specifier.precision,
	          type = specifier.type;
	
	      // Compute the prefix and suffix.
	      // For SI-prefix, the suffix is lazily computed.
	      var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	          suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? "%" : "";
	
	      // What format function should we use?
	      // Is this an integer type?
	      // Can this type generate exponential notation?
	      var formatType = formatTypes[type],
	          maybeSuffix = !type || /[defgprs%]/.test(type);
	
	      // Set the default precision if not specified,
	      // or clamp the specified precision to the supported range.
	      // For significant precision, it must be in [1, 21].
	      // For fixed precision, it must be in [0, 20].
	      precision = precision == null ? (type ? 6 : 12)
	          : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	          : Math.max(0, Math.min(20, precision));
	
	      function format(value) {
	        var valuePrefix = prefix,
	            valueSuffix = suffix,
	            i, n, c;
	
	        if (type === "c") {
	          valueSuffix = formatType(value) + valueSuffix;
	          value = "";
	        } else {
	          value = +value;
	
	          // Convert negative to positive, and compute the prefix.
	          // Note that -0 is not less than 0, but 1 / -0 is!
	          var valueNegative = (value < 0 || 1 / value < 0) && (value *= -1, true);
	
	          // Perform the initial formatting.
	          value = formatType(value, precision);
	
	          // If the original value was negative, it may be rounded to zero during
	          // formatting; treat this as (positive) zero.
	          if (valueNegative) {
	            i = -1, n = value.length;
	            valueNegative = false;
	            while (++i < n) {
	              if (c = value.charCodeAt(i), (48 < c && c < 58)
	                  || (type === "x" && 96 < c && c < 103)
	                  || (type === "X" && 64 < c && c < 71)) {
	                valueNegative = true;
	                break;
	              }
	            }
	          }
	
	          // Compute the prefix and suffix.
	          valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	          valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	          // Break the formatted value into the integer “value” part that can be
	          // grouped, and fractional or exponential “suffix” part that is not.
	          if (maybeSuffix) {
	            i = -1, n = value.length;
	            while (++i < n) {
	              if (c = value.charCodeAt(i), 48 > c || c > 57) {
	                valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	                value = value.slice(0, i);
	                break;
	              }
	            }
	          }
	        }
	
	        // If the fill character is not "0", grouping is applied before padding.
	        if (comma && !zero) value = group(value, Infinity);
	
	        // Compute the padding.
	        var length = valuePrefix.length + value.length + valueSuffix.length,
	            padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	        // If the fill character is "0", grouping is applied after padding.
	        if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	        // Reconstruct the final output based on the desired alignment.
	        switch (align) {
	          case "<": return valuePrefix + value + valueSuffix + padding;
	          case "=": return valuePrefix + padding + value + valueSuffix;
	          case "^": return padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
	        }
	        return padding + valuePrefix + value + valueSuffix;
	      }
	
	      format.toString = function() {
	        return specifier + "";
	      };
	
	      return format;
	    }
	
	    function formatPrefix(specifier, value) {
	      var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	          e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	          k = Math.pow(10, -e),
	          prefix = prefixes[8 + e / 3];
	      return function(value) {
	        return f(k * value) + prefix;
	      };
	    }
	
	    return {
	      format: newFormat,
	      formatPrefix: formatPrefix
	    };
	  }
	
	  var locale;
	  defaultLocale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [3],
	    currency: ["$", ""]
	  });
	
	  function defaultLocale(definition) {
	    locale = formatLocale(definition);
	    exports.format = locale.format;
	    exports.formatPrefix = locale.formatPrefix;
	    return locale;
	  }
	
	  function precisionFixed(step) {
	    return Math.max(0, -exponent(Math.abs(step)));
	  }
	
	  function precisionPrefix(step, value) {
	    return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	  }
	
	  function precisionRound(step, max) {
	    step = Math.abs(step), max = Math.abs(max) - step;
	    return Math.max(0, exponent(max) - exponent(step)) + 1;
	  }
	
	  exports.formatDefaultLocale = defaultLocale;
	  exports.formatLocale = formatLocale;
	  exports.formatSpecifier = formatSpecifier;
	  exports.precisionFixed = precisionFixed;
	  exports.precisionPrefix = precisionPrefix;
	  exports.precisionRound = precisionRound;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(60);
	var setInnerHTML = __webpack_require__(46);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(74);
	var setTextContent = __webpack_require__(131);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(331);
	var ReactInstrumentation = __webpack_require__(11);
	
	var warning = __webpack_require__(6);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID // 0 in production and for roots
	  ) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var prefix = "$";
	
	  function Map() {}
	
	  Map.prototype = map.prototype = {
	    constructor: Map,
	    has: function(key) {
	      return (prefix + key) in this;
	    },
	    get: function(key) {
	      return this[prefix + key];
	    },
	    set: function(key, value) {
	      this[prefix + key] = value;
	      return this;
	    },
	    remove: function(key) {
	      var property = prefix + key;
	      return property in this && delete this[property];
	    },
	    clear: function() {
	      for (var property in this) if (property[0] === prefix) delete this[property];
	    },
	    keys: function() {
	      var keys = [];
	      for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	      return keys;
	    },
	    values: function() {
	      var values = [];
	      for (var property in this) if (property[0] === prefix) values.push(this[property]);
	      return values;
	    },
	    entries: function() {
	      var entries = [];
	      for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	      return entries;
	    },
	    size: function() {
	      var size = 0;
	      for (var property in this) if (property[0] === prefix) ++size;
	      return size;
	    },
	    empty: function() {
	      for (var property in this) if (property[0] === prefix) return false;
	      return true;
	    },
	    each: function(f) {
	      for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	    }
	  };
	
	  function map(object, f) {
	    var map = new Map;
	
	    // Copy constructor.
	    if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	    // Index array by numeric index or specified key function.
	    else if (Array.isArray(object)) {
	      var i = -1,
	          n = object.length,
	          o;
	
	      if (f == null) while (++i < n) map.set(i, object[i]);
	      else while (++i < n) map.set(f(o = object[i], i, object), o);
	    }
	
	    // Convert object to map.
	    else if (object) for (var key in object) map.set(key, object[key]);
	
	    return map;
	  }
	
	  function nest() {
	    var keys = [],
	        sortKeys = [],
	        sortValues,
	        rollup,
	        nest;
	
	    function apply(array, depth, createResult, setResult) {
	      if (depth >= keys.length) return rollup != null
	          ? rollup(array) : (sortValues != null
	          ? array.sort(sortValues)
	          : array);
	
	      var i = -1,
	          n = array.length,
	          key = keys[depth++],
	          keyValue,
	          value,
	          valuesByKey = map(),
	          values,
	          result = createResult();
	
	      while (++i < n) {
	        if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	          values.push(value);
	        } else {
	          valuesByKey.set(keyValue, [value]);
	        }
	      }
	
	      valuesByKey.each(function(values, key) {
	        setResult(result, key, apply(values, depth, createResult, setResult));
	      });
	
	      return result;
	    }
	
	    function entries(map, depth) {
	      if (++depth > keys.length) return map;
	      var array, sortKey = sortKeys[depth - 1];
	      if (rollup != null && depth >= keys.length) array = map.entries();
	      else array = [], map.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	      return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	    }
	
	    return nest = {
	      object: function(array) { return apply(array, 0, createObject, setObject); },
	      map: function(array) { return apply(array, 0, createMap, setMap); },
	      entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	      key: function(d) { keys.push(d); return nest; },
	      sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	      sortValues: function(order) { sortValues = order; return nest; },
	      rollup: function(f) { rollup = f; return nest; }
	    };
	  }
	
	  function createObject() {
	    return {};
	  }
	
	  function setObject(object, key, value) {
	    object[key] = value;
	  }
	
	  function createMap() {
	    return map();
	  }
	
	  function setMap(map, key, value) {
	    map.set(key, value);
	  }
	
	  function Set() {}
	
	  var proto = map.prototype;
	
	  Set.prototype = set.prototype = {
	    constructor: Set,
	    has: proto.has,
	    add: function(value) {
	      value += "";
	      this[prefix + value] = value;
	      return this;
	    },
	    remove: proto.remove,
	    clear: proto.clear,
	    values: proto.keys,
	    size: proto.size,
	    empty: proto.empty,
	    each: proto.each
	  };
	
	  function set(object, f) {
	    var set = new Set;
	
	    // Copy constructor.
	    if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	    // Otherwise, assume it’s an array.
	    else if (object) {
	      var i = -1, n = object.length;
	      if (f == null) while (++i < n) set.add(object[i]);
	      else while (++i < n) set.add(f(object[i], i, object));
	    }
	
	    return set;
	  }
	
	  function keys(map) {
	    var keys = [];
	    for (var key in map) keys.push(key);
	    return keys;
	  }
	
	  function values(map) {
	    var values = [];
	    for (var key in map) values.push(map[key]);
	    return values;
	  }
	
	  function entries(map) {
	    var entries = [];
	    for (var key in map) entries.push({key: key, value: map[key]});
	    return entries;
	  }
	
	  exports.nest = nest;
	  exports.set = set;
	  exports.map = map;
	  exports.keys = keys;
	  exports.values = values;
	  exports.entries = entries;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(22), __webpack_require__(27), __webpack_require__(51), __webpack_require__(23), __webpack_require__(93), __webpack_require__(30), __webpack_require__(227)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	  var array = Array.prototype;
	
	  var map$1 = array.map;
	  var slice = array.slice;
	
	  var implicit = {name: "implicit"};
	
	  function ordinal(range) {
	    var index = d3Collection.map(),
	        domain = [],
	        unknown = implicit;
	
	    range = range == null ? [] : slice.call(range);
	
	    function scale(d) {
	      var key = d + "", i = index.get(key);
	      if (!i) {
	        if (unknown !== implicit) return unknown;
	        index.set(key, i = domain.push(d));
	      }
	      return range[(i - 1) % range.length];
	    }
	
	    scale.domain = function(_) {
	      if (!arguments.length) return domain.slice();
	      domain = [], index = d3Collection.map();
	      var i = -1, n = _.length, d, key;
	      while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	      return scale;
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), scale) : range.slice();
	    };
	
	    scale.unknown = function(_) {
	      return arguments.length ? (unknown = _, scale) : unknown;
	    };
	
	    scale.copy = function() {
	      return ordinal()
	          .domain(domain)
	          .range(range)
	          .unknown(unknown);
	    };
	
	    return scale;
	  }
	
	  function band() {
	    var scale = ordinal().unknown(undefined),
	        domain = scale.domain,
	        ordinalRange = scale.range,
	        range = [0, 1],
	        step,
	        bandwidth,
	        round = false,
	        paddingInner = 0,
	        paddingOuter = 0,
	        align = 0.5;
	
	    delete scale.unknown;
	
	    function rescale() {
	      var n = domain().length,
	          reverse = range[1] < range[0],
	          start = range[reverse - 0],
	          stop = range[1 - reverse];
	      step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	      if (round) step = Math.floor(step);
	      start += (stop - start - step * (n - paddingInner)) * align;
	      bandwidth = step * (1 - paddingInner);
	      if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	      var values = d3Array.range(n).map(function(i) { return start + step * i; });
	      return ordinalRange(reverse ? values.reverse() : values);
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain(_), rescale()) : domain();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	    };
	
	    scale.rangeRound = function(_) {
	      return range = [+_[0], +_[1]], round = true, rescale();
	    };
	
	    scale.bandwidth = function() {
	      return bandwidth;
	    };
	
	    scale.step = function() {
	      return step;
	    };
	
	    scale.round = function(_) {
	      return arguments.length ? (round = !!_, rescale()) : round;
	    };
	
	    scale.padding = function(_) {
	      return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	    };
	
	    scale.paddingInner = function(_) {
	      return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	    };
	
	    scale.paddingOuter = function(_) {
	      return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	    };
	
	    scale.align = function(_) {
	      return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	    };
	
	    scale.copy = function() {
	      return band()
	          .domain(domain())
	          .range(range)
	          .round(round)
	          .paddingInner(paddingInner)
	          .paddingOuter(paddingOuter)
	          .align(align);
	    };
	
	    return rescale();
	  }
	
	  function pointish(scale) {
	    var copy = scale.copy;
	
	    scale.padding = scale.paddingOuter;
	    delete scale.paddingInner;
	    delete scale.paddingOuter;
	
	    scale.copy = function() {
	      return pointish(copy());
	    };
	
	    return scale;
	  }
	
	  function point() {
	    return pointish(band().paddingInner(1));
	  }
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function number(x) {
	    return +x;
	  }
	
	  var unit = [0, 1];
	
	  function deinterpolate(a, b) {
	    return (b -= (a = +a))
	        ? function(x) { return (x - a) / b; }
	        : constant(b);
	  }
	
	  function deinterpolateClamp(deinterpolate) {
	    return function(a, b) {
	      var d = deinterpolate(a = +a, b = +b);
	      return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	    };
	  }
	
	  function reinterpolateClamp(reinterpolate) {
	    return function(a, b) {
	      var r = reinterpolate(a = +a, b = +b);
	      return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	    };
	  }
	
	  function bimap(domain, range, deinterpolate, reinterpolate) {
	    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	    if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	    else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	    return function(x) { return r0(d0(x)); };
	  }
	
	  function polymap(domain, range, deinterpolate, reinterpolate) {
	    var j = Math.min(domain.length, range.length) - 1,
	        d = new Array(j),
	        r = new Array(j),
	        i = -1;
	
	    // Reverse descending domains.
	    if (domain[j] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	
	    while (++i < j) {
	      d[i] = deinterpolate(domain[i], domain[i + 1]);
	      r[i] = reinterpolate(range[i], range[i + 1]);
	    }
	
	    return function(x) {
	      var i = d3Array.bisect(domain, x, 1, j) - 1;
	      return r[i](d[i](x));
	    };
	  }
	
	  function copy(source, target) {
	    return target
	        .domain(source.domain())
	        .range(source.range())
	        .interpolate(source.interpolate())
	        .clamp(source.clamp());
	  }
	
	  // deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	  // reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	  function continuous(deinterpolate$$, reinterpolate) {
	    var domain = unit,
	        range = unit,
	        interpolate = d3Interpolate.interpolate,
	        clamp = false,
	        piecewise,
	        output,
	        input;
	
	    function rescale() {
	      piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	      output = input = null;
	      return scale;
	    }
	
	    function scale(x) {
	      return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate$$) : deinterpolate$$, interpolate)))(+x);
	    }
	
	    scale.invert = function(y) {
	      return (input || (input = piecewise(range, domain, deinterpolate, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	    };
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	    };
	
	    scale.rangeRound = function(_) {
	      return range = slice.call(_), interpolate = d3Interpolate.interpolateRound, rescale();
	    };
	
	    scale.clamp = function(_) {
	      return arguments.length ? (clamp = !!_, rescale()) : clamp;
	    };
	
	    scale.interpolate = function(_) {
	      return arguments.length ? (interpolate = _, rescale()) : interpolate;
	    };
	
	    return rescale();
	  }
	
	  function tickFormat(domain, count, specifier) {
	    var start = domain[0],
	        stop = domain[domain.length - 1],
	        step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	        precision;
	    specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	    switch (specifier.type) {
	      case "s": {
	        var value = Math.max(Math.abs(start), Math.abs(stop));
	        if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	        return d3Format.formatPrefix(specifier, value);
	      }
	      case "":
	      case "e":
	      case "g":
	      case "p":
	      case "r": {
	        if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	        break;
	      }
	      case "f":
	      case "%": {
	        if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	        break;
	      }
	    }
	    return d3Format.format(specifier);
	  }
	
	  function linearish(scale) {
	    var domain = scale.domain;
	
	    scale.ticks = function(count) {
	      var d = domain();
	      return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	    };
	
	    scale.tickFormat = function(count, specifier) {
	      return tickFormat(domain(), count, specifier);
	    };
	
	    scale.nice = function(count) {
	      var d = domain(),
	          i = d.length - 1,
	          n = count == null ? 10 : count,
	          start = d[0],
	          stop = d[i],
	          step = d3Array.tickStep(start, stop, n);
	
	      if (step) {
	        step = d3Array.tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	        d[0] = Math.floor(start / step) * step;
	        d[i] = Math.ceil(stop / step) * step;
	        domain(d);
	      }
	
	      return scale;
	    };
	
	    return scale;
	  }
	
	  function linear() {
	    var scale = continuous(deinterpolate, d3Interpolate.interpolateNumber);
	
	    scale.copy = function() {
	      return copy(scale, linear());
	    };
	
	    return linearish(scale);
	  }
	
	  function identity() {
	    var domain = [0, 1];
	
	    function scale(x) {
	      return +x;
	    }
	
	    scale.invert = scale;
	
	    scale.domain = scale.range = function(_) {
	      return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	    };
	
	    scale.copy = function() {
	      return identity().domain(domain);
	    };
	
	    return linearish(scale);
	  }
	
	  function nice(domain, interval) {
	    domain = domain.slice();
	
	    var i0 = 0,
	        i1 = domain.length - 1,
	        x0 = domain[i0],
	        x1 = domain[i1],
	        t;
	
	    if (x1 < x0) {
	      t = i0, i0 = i1, i1 = t;
	      t = x0, x0 = x1, x1 = t;
	    }
	
	    domain[i0] = interval.floor(x0);
	    domain[i1] = interval.ceil(x1);
	    return domain;
	  }
	
	  function deinterpolate$1(a, b) {
	    return (b = Math.log(b / a))
	        ? function(x) { return Math.log(x / a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    return a < 0
	        ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	        : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	  }
	
	  function pow10(x) {
	    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	  }
	
	  function powp(base) {
	    return base === 10 ? pow10
	        : base === Math.E ? Math.exp
	        : function(x) { return Math.pow(base, x); };
	  }
	
	  function logp(base) {
	    return base === Math.E ? Math.log
	        : base === 10 && Math.log10
	        || base === 2 && Math.log2
	        || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	  }
	
	  function reflect(f) {
	    return function(x) {
	      return -f(-x);
	    };
	  }
	
	  function log() {
	    var scale = continuous(deinterpolate$1, reinterpolate).domain([1, 10]),
	        domain = scale.domain,
	        base = 10,
	        logs = logp(10),
	        pows = powp(10);
	
	    function rescale() {
	      logs = logp(base), pows = powp(base);
	      if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	      return scale;
	    }
	
	    scale.base = function(_) {
	      return arguments.length ? (base = +_, rescale()) : base;
	    };
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain(_), rescale()) : domain();
	    };
	
	    scale.ticks = function(count) {
	      var d = domain(),
	          u = d[0],
	          v = d[d.length - 1],
	          r;
	
	      if (r = v < u) i = u, u = v, v = i;
	
	      var i = logs(u),
	          j = logs(v),
	          p,
	          k,
	          t,
	          n = count == null ? 10 : +count,
	          z = [];
	
	      if (!(base % 1) && j - i < n) {
	        i = Math.round(i) - 1, j = Math.round(j) + 1;
	        if (u > 0) for (; i < j; ++i) {
	          for (k = 1, p = pows(i); k < base; ++k) {
	            t = p * k;
	            if (t < u) continue;
	            if (t > v) break;
	            z.push(t);
	          }
	        } else for (; i < j; ++i) {
	          for (k = base - 1, p = pows(i); k >= 1; --k) {
	            t = p * k;
	            if (t < u) continue;
	            if (t > v) break;
	            z.push(t);
	          }
	        }
	      } else {
	        z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	      }
	
	      return r ? z.reverse() : z;
	    };
	
	    scale.tickFormat = function(count, specifier) {
	      if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	      if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	      if (count === Infinity) return specifier;
	      if (count == null) count = 10;
	      var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	      return function(d) {
	        var i = d / pows(Math.round(logs(d)));
	        if (i * base < base - 0.5) i *= base;
	        return i <= k ? specifier(d) : "";
	      };
	    };
	
	    scale.nice = function() {
	      return domain(nice(domain(), {
	        floor: function(x) { return pows(Math.floor(logs(x))); },
	        ceil: function(x) { return pows(Math.ceil(logs(x))); }
	      }));
	    };
	
	    scale.copy = function() {
	      return copy(scale, log().base(base));
	    };
	
	    return scale;
	  }
	
	  function raise(x, exponent) {
	    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	  }
	
	  function pow() {
	    var exponent = 1,
	        scale = continuous(deinterpolate, reinterpolate),
	        domain = scale.domain;
	
	    function deinterpolate(a, b) {
	      return (b = raise(b, exponent) - (a = raise(a, exponent)))
	          ? function(x) { return (raise(x, exponent) - a) / b; }
	          : constant(b);
	    }
	
	    function reinterpolate(a, b) {
	      b = raise(b, exponent) - (a = raise(a, exponent));
	      return function(t) { return raise(a + b * t, 1 / exponent); };
	    }
	
	    scale.exponent = function(_) {
	      return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	    };
	
	    scale.copy = function() {
	      return copy(scale, pow().exponent(exponent));
	    };
	
	    return linearish(scale);
	  }
	
	  function sqrt() {
	    return pow().exponent(0.5);
	  }
	
	  function quantile$1() {
	    var domain = [],
	        range = [],
	        thresholds = [];
	
	    function rescale() {
	      var i = 0, n = Math.max(1, range.length);
	      thresholds = new Array(n - 1);
	      while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	      return scale;
	    }
	
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3Array.bisect(thresholds, x)];
	    }
	
	    scale.invertExtent = function(y) {
	      var i = range.indexOf(y);
	      return i < 0 ? [NaN, NaN] : [
	        i > 0 ? thresholds[i - 1] : domain[0],
	        i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	      ];
	    };
	
	    scale.domain = function(_) {
	      if (!arguments.length) return domain.slice();
	      domain = [];
	      for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	      domain.sort(d3Array.ascending);
	      return rescale();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	    };
	
	    scale.quantiles = function() {
	      return thresholds.slice();
	    };
	
	    scale.copy = function() {
	      return quantile$1()
	          .domain(domain)
	          .range(range);
	    };
	
	    return scale;
	  }
	
	  function quantize() {
	    var x0 = 0,
	        x1 = 1,
	        n = 1,
	        domain = [0.5],
	        range = [0, 1];
	
	    function scale(x) {
	      if (x <= x) return range[d3Array.bisect(domain, x, 0, n)];
	    }
	
	    function rescale() {
	      var i = -1;
	      domain = new Array(n);
	      while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	      return scale;
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (n = (range = slice.call(_)).length - 1, rescale()) : range.slice();
	    };
	
	    scale.invertExtent = function(y) {
	      var i = range.indexOf(y);
	      return i < 0 ? [NaN, NaN]
	          : i < 1 ? [x0, domain[0]]
	          : i >= n ? [domain[n - 1], x1]
	          : [domain[i - 1], domain[i]];
	    };
	
	    scale.copy = function() {
	      return quantize()
	          .domain([x0, x1])
	          .range(range);
	    };
	
	    return linearish(scale);
	  }
	
	  function threshold() {
	    var domain = [0.5],
	        range = [0, 1],
	        n = 1;
	
	    function scale(x) {
	      if (x <= x) return range[d3Array.bisect(domain, x, 0, n)];
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	    };
	
	    scale.invertExtent = function(y) {
	      var i = range.indexOf(y);
	      return [domain[i - 1], domain[i]];
	    };
	
	    scale.copy = function() {
	      return threshold()
	          .domain(domain)
	          .range(range);
	    };
	
	    return scale;
	  }
	
	  var durationSecond = 1000;
	  var durationMinute = durationSecond * 60;
	  var durationHour = durationMinute * 60;
	  var durationDay = durationHour * 24;
	  var durationWeek = durationDay * 7;
	  var durationMonth = durationDay * 30;
	  var durationYear = durationDay * 365;
	  function date(t) {
	    return new Date(t);
	  }
	
	  function number$1(t) {
	    return t instanceof Date ? +t : +new Date(+t);
	  }
	
	  function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
	    var scale = continuous(deinterpolate, d3Interpolate.interpolateNumber),
	        invert = scale.invert,
	        domain = scale.domain;
	
	    var formatMillisecond = format(".%L"),
	        formatSecond = format(":%S"),
	        formatMinute = format("%I:%M"),
	        formatHour = format("%I %p"),
	        formatDay = format("%a %d"),
	        formatWeek = format("%b %d"),
	        formatMonth = format("%B"),
	        formatYear = format("%Y");
	
	    var tickIntervals = [
	      [second,  1,      durationSecond],
	      [second,  5,  5 * durationSecond],
	      [second, 15, 15 * durationSecond],
	      [second, 30, 30 * durationSecond],
	      [minute,  1,      durationMinute],
	      [minute,  5,  5 * durationMinute],
	      [minute, 15, 15 * durationMinute],
	      [minute, 30, 30 * durationMinute],
	      [  hour,  1,      durationHour  ],
	      [  hour,  3,  3 * durationHour  ],
	      [  hour,  6,  6 * durationHour  ],
	      [  hour, 12, 12 * durationHour  ],
	      [   day,  1,      durationDay   ],
	      [   day,  2,  2 * durationDay   ],
	      [  week,  1,      durationWeek  ],
	      [ month,  1,      durationMonth ],
	      [ month,  3,  3 * durationMonth ],
	      [  year,  1,      durationYear  ]
	    ];
	
	    function tickFormat(date) {
	      return (second(date) < date ? formatMillisecond
	          : minute(date) < date ? formatSecond
	          : hour(date) < date ? formatMinute
	          : day(date) < date ? formatHour
	          : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	          : year(date) < date ? formatMonth
	          : formatYear)(date);
	    }
	
	    function tickInterval(interval, start, stop, step) {
	      if (interval == null) interval = 10;
	
	      // If a desired tick count is specified, pick a reasonable tick interval
	      // based on the extent of the domain and a rough estimate of tick size.
	      // Otherwise, assume interval is already a time interval and use it.
	      if (typeof interval === "number") {
	        var target = Math.abs(stop - start) / interval,
	            i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	        if (i === tickIntervals.length) {
	          step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	          interval = year;
	        } else if (i) {
	          i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	          step = i[1];
	          interval = i[0];
	        } else {
	          step = d3Array.tickStep(start, stop, interval);
	          interval = millisecond;
	        }
	      }
	
	      return step == null ? interval : interval.every(step);
	    }
	
	    scale.invert = function(y) {
	      return new Date(invert(y));
	    };
	
	    scale.domain = function(_) {
	      return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	    };
	
	    scale.ticks = function(interval, step) {
	      var d = domain(),
	          t0 = d[0],
	          t1 = d[d.length - 1],
	          r = t1 < t0,
	          t;
	      if (r) t = t0, t0 = t1, t1 = t;
	      t = tickInterval(interval, t0, t1, step);
	      t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	      return r ? t.reverse() : t;
	    };
	
	    scale.tickFormat = function(count, specifier) {
	      return specifier == null ? tickFormat : format(specifier);
	    };
	
	    scale.nice = function(interval, step) {
	      var d = domain();
	      return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	          ? domain(nice(d, interval))
	          : scale;
	    };
	
	    scale.copy = function() {
	      return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
	    };
	
	    return scale;
	  }
	
	  function time() {
	    return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	  }
	
	  function utcTime() {
	    return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	  }
	
	  function colors(s) {
	    return s.match(/.{6}/g).map(function(x) {
	      return "#" + x;
	    });
	  }
	
	  var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	  var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	  var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	  var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	  var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	  var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	  var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	  var rainbow = d3Color.cubehelix();
	
	  function rainbow$1(t) {
	    if (t < 0 || t > 1) t -= Math.floor(t);
	    var ts = Math.abs(t - 0.5);
	    rainbow.h = 360 * t - 100;
	    rainbow.s = 1.5 - 1.5 * ts;
	    rainbow.l = 0.8 - 0.9 * ts;
	    return rainbow + "";
	  }
	
	  function ramp(range) {
	    var n = range.length;
	    return function(t) {
	      return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	    };
	  }
	
	  var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	  var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	  var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	  var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	  function sequential(interpolator) {
	    var x0 = 0,
	        x1 = 1,
	        clamp = false;
	
	    function scale(x) {
	      var t = (x - x0) / (x1 - x0);
	      return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	    };
	
	    scale.clamp = function(_) {
	      return arguments.length ? (clamp = !!_, scale) : clamp;
	    };
	
	    scale.interpolator = function(_) {
	      return arguments.length ? (interpolator = _, scale) : interpolator;
	    };
	
	    scale.copy = function() {
	      return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	    };
	
	    return linearish(scale);
	  }
	
	  exports.scaleBand = band;
	  exports.scalePoint = point;
	  exports.scaleIdentity = identity;
	  exports.scaleLinear = linear;
	  exports.scaleLog = log;
	  exports.scaleOrdinal = ordinal;
	  exports.scaleImplicit = implicit;
	  exports.scalePow = pow;
	  exports.scaleSqrt = sqrt;
	  exports.scaleQuantile = quantile$1;
	  exports.scaleQuantize = quantize;
	  exports.scaleThreshold = threshold;
	  exports.scaleTime = time;
	  exports.scaleUtc = utcTime;
	  exports.schemeCategory10 = category10;
	  exports.schemeCategory20b = category20b;
	  exports.schemeCategory20c = category20c;
	  exports.schemeCategory20 = category20;
	  exports.interpolateCubehelixDefault = cubehelix$1;
	  exports.interpolateRainbow = rainbow$1;
	  exports.interpolateWarm = warm;
	  exports.interpolateCool = cool;
	  exports.interpolateViridis = viridis;
	  exports.interpolateMagma = magma;
	  exports.interpolateInferno = inferno;
	  exports.interpolatePlasma = plasma;
	  exports.scaleSequential = sequential;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-selection/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var xhtml = "http://www.w3.org/1999/xhtml";
	
	  var namespaces = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: xhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	
	  function namespace(name) {
	    var prefix = name += "", i = prefix.indexOf(":");
	    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	    return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	  }
	
	  function creatorInherit(name) {
	    return function() {
	      var document = this.ownerDocument,
	          uri = this.namespaceURI;
	      return uri === xhtml && document.documentElement.namespaceURI === xhtml
	          ? document.createElement(name)
	          : document.createElementNS(uri, name);
	    };
	  }
	
	  function creatorFixed(fullname) {
	    return function() {
	      return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	    };
	  }
	
	  function creator(name) {
	    var fullname = namespace(name);
	    return (fullname.local
	        ? creatorFixed
	        : creatorInherit)(fullname);
	  }
	
	  var nextId = 0;
	
	  function local() {
	    return new Local;
	  }
	
	  function Local() {
	    this._ = "@" + (++nextId).toString(36);
	  }
	
	  Local.prototype = local.prototype = {
	    constructor: Local,
	    get: function(node) {
	      var id = this._;
	      while (!(id in node)) if (!(node = node.parentNode)) return;
	      return node[id];
	    },
	    set: function(node, value) {
	      return node[this._] = value;
	    },
	    remove: function(node) {
	      return this._ in node && delete node[this._];
	    },
	    toString: function() {
	      return this._;
	    }
	  };
	
	  var matcher = function(selector) {
	    return function() {
	      return this.matches(selector);
	    };
	  };
	
	  if (typeof document !== "undefined") {
	    var element = document.documentElement;
	    if (!element.matches) {
	      var vendorMatches = element.webkitMatchesSelector
	          || element.msMatchesSelector
	          || element.mozMatchesSelector
	          || element.oMatchesSelector;
	      matcher = function(selector) {
	        return function() {
	          return vendorMatches.call(this, selector);
	        };
	      };
	    }
	  }
	
	  var matcher$1 = matcher;
	
	  var filterEvents = {};
	
	  exports.event = null;
	
	  if (typeof document !== "undefined") {
	    var element$1 = document.documentElement;
	    if (!("onmouseenter" in element$1)) {
	      filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	    }
	  }
	
	  function filterContextListener(listener, index, group) {
	    listener = contextListener(listener, index, group);
	    return function(event) {
	      var related = event.relatedTarget;
	      if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	        listener.call(this, event);
	      }
	    };
	  }
	
	  function contextListener(listener, index, group) {
	    return function(event1) {
	      var event0 = exports.event; // Events can be reentrant (e.g., focus).
	      exports.event = event1;
	      try {
	        listener.call(this, this.__data__, index, group);
	      } finally {
	        exports.event = event0;
	      }
	    };
	  }
	
	  function parseTypenames(typenames) {
	    return typenames.trim().split(/^|\s+/).map(function(t) {
	      var name = "", i = t.indexOf(".");
	      if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	      return {type: t, name: name};
	    });
	  }
	
	  function onRemove(typename) {
	    return function() {
	      var on = this.__on;
	      if (!on) return;
	      for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	        if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	          this.removeEventListener(o.type, o.listener, o.capture);
	        } else {
	          on[++i] = o;
	        }
	      }
	      if (++i) on.length = i;
	      else delete this.__on;
	    };
	  }
	
	  function onAdd(typename, value, capture) {
	    var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	    return function(d, i, group) {
	      var on = this.__on, o, listener = wrap(value, i, group);
	      if (on) for (var j = 0, m = on.length; j < m; ++j) {
	        if ((o = on[j]).type === typename.type && o.name === typename.name) {
	          this.removeEventListener(o.type, o.listener, o.capture);
	          this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	          o.value = value;
	          return;
	        }
	      }
	      this.addEventListener(typename.type, listener, capture);
	      o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	      if (!on) this.__on = [o];
	      else on.push(o);
	    };
	  }
	
	  function selection_on(typename, value, capture) {
	    var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
	
	    if (arguments.length < 2) {
	      var on = this.node().__on;
	      if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	        for (i = 0, o = on[j]; i < n; ++i) {
	          if ((t = typenames[i]).type === o.type && t.name === o.name) {
	            return o.value;
	          }
	        }
	      }
	      return;
	    }
	
	    on = value ? onAdd : onRemove;
	    if (capture == null) capture = false;
	    for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	    return this;
	  }
	
	  function customEvent(event1, listener, that, args) {
	    var event0 = exports.event;
	    event1.sourceEvent = exports.event;
	    exports.event = event1;
	    try {
	      return listener.apply(that, args);
	    } finally {
	      exports.event = event0;
	    }
	  }
	
	  function sourceEvent() {
	    var current = exports.event, source;
	    while (source = current.sourceEvent) current = source;
	    return current;
	  }
	
	  function point(node, event) {
	    var svg = node.ownerSVGElement || node;
	
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      point.x = event.clientX, point.y = event.clientY;
	      point = point.matrixTransform(node.getScreenCTM().inverse());
	      return [point.x, point.y];
	    }
	
	    var rect = node.getBoundingClientRect();
	    return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	  }
	
	  function mouse(node) {
	    var event = sourceEvent();
	    if (event.changedTouches) event = event.changedTouches[0];
	    return point(node, event);
	  }
	
	  function none() {}
	
	  function selector(selector) {
	    return selector == null ? none : function() {
	      return this.querySelector(selector);
	    };
	  }
	
	  function selection_select(select) {
	    if (typeof select !== "function") select = selector(select);
	
	    for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	        if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          subgroup[i] = subnode;
	        }
	      }
	    }
	
	    return new Selection(subgroups, this._parents);
	  }
	
	  function empty() {
	    return [];
	  }
	
	  function selectorAll(selector) {
	    return selector == null ? empty : function() {
	      return this.querySelectorAll(selector);
	    };
	  }
	
	  function selection_selectAll(select) {
	    if (typeof select !== "function") select = selectorAll(select);
	
	    for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	        if (node = group[i]) {
	          subgroups.push(select.call(node, node.__data__, i, group));
	          parents.push(node);
	        }
	      }
	    }
	
	    return new Selection(subgroups, parents);
	  }
	
	  function selection_filter(match) {
	    if (typeof match !== "function") match = matcher$1(match);
	
	    for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	        if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	          subgroup.push(node);
	        }
	      }
	    }
	
	    return new Selection(subgroups, this._parents);
	  }
	
	  function sparse(update) {
	    return new Array(update.length);
	  }
	
	  function selection_enter() {
	    return new Selection(this._enter || this._groups.map(sparse), this._parents);
	  }
	
	  function EnterNode(parent, datum) {
	    this.ownerDocument = parent.ownerDocument;
	    this.namespaceURI = parent.namespaceURI;
	    this._next = null;
	    this._parent = parent;
	    this.__data__ = datum;
	  }
	
	  EnterNode.prototype = {
	    constructor: EnterNode,
	    appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	    insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	    querySelector: function(selector) { return this._parent.querySelector(selector); },
	    querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	  };
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	  function bindIndex(parent, group, enter, update, exit, data) {
	    var i = 0,
	        node,
	        groupLength = group.length,
	        dataLength = data.length;
	
	    // Put any non-null nodes that fit into update.
	    // Put any null nodes into enter.
	    // Put any remaining data into enter.
	    for (; i < dataLength; ++i) {
	      if (node = group[i]) {
	        node.__data__ = data[i];
	        update[i] = node;
	      } else {
	        enter[i] = new EnterNode(parent, data[i]);
	      }
	    }
	
	    // Put any non-null nodes that don’t fit into exit.
	    for (; i < groupLength; ++i) {
	      if (node = group[i]) {
	        exit[i] = node;
	      }
	    }
	  }
	
	  function bindKey(parent, group, enter, update, exit, data, key) {
	    var i,
	        node,
	        nodeByKeyValue = {},
	        groupLength = group.length,
	        dataLength = data.length,
	        keyValues = new Array(groupLength),
	        keyValue;
	
	    // Compute the key for each node.
	    // If multiple nodes have the same key, the duplicates are added to exit.
	    for (i = 0; i < groupLength; ++i) {
	      if (node = group[i]) {
	        keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	        if (keyValue in nodeByKeyValue) {
	          exit[i] = node;
	        } else {
	          nodeByKeyValue[keyValue] = node;
	        }
	      }
	    }
	
	    // Compute the key for each datum.
	    // If there a node associated with this key, join and add it to update.
	    // If there is not (or the key is a duplicate), add it to enter.
	    for (i = 0; i < dataLength; ++i) {
	      keyValue = keyPrefix + key.call(parent, data[i], i, data);
	      if (node = nodeByKeyValue[keyValue]) {
	        update[i] = node;
	        node.__data__ = data[i];
	        nodeByKeyValue[keyValue] = null;
	      } else {
	        enter[i] = new EnterNode(parent, data[i]);
	      }
	    }
	
	    // Add any remaining nodes that were not bound to data to exit.
	    for (i = 0; i < groupLength; ++i) {
	      if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	        exit[i] = node;
	      }
	    }
	  }
	
	  function selection_data(value, key) {
	    if (!value) {
	      data = new Array(this.size()), j = -1;
	      this.each(function(d) { data[++j] = d; });
	      return data;
	    }
	
	    var bind = key ? bindKey : bindIndex,
	        parents = this._parents,
	        groups = this._groups;
	
	    if (typeof value !== "function") value = constant(value);
	
	    for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	      var parent = parents[j],
	          group = groups[j],
	          groupLength = group.length,
	          data = value.call(parent, parent && parent.__data__, j, parents),
	          dataLength = data.length,
	          enterGroup = enter[j] = new Array(dataLength),
	          updateGroup = update[j] = new Array(dataLength),
	          exitGroup = exit[j] = new Array(groupLength);
	
	      bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	      // Now connect the enter nodes to their following update node, such that
	      // appendChild can insert the materialized enter node before this node,
	      // rather than at the end of the parent node.
	      for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	        if (previous = enterGroup[i0]) {
	          if (i0 >= i1) i1 = i0 + 1;
	          while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	          previous._next = next || null;
	        }
	      }
	    }
	
	    update = new Selection(update, parents);
	    update._enter = enter;
	    update._exit = exit;
	    return update;
	  }
	
	  function selection_exit() {
	    return new Selection(this._exit || this._groups.map(sparse), this._parents);
	  }
	
	  function selection_merge(selection) {
	
	    for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	      for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	        if (node = group0[i] || group1[i]) {
	          merge[i] = node;
	        }
	      }
	    }
	
	    for (; j < m0; ++j) {
	      merges[j] = groups0[j];
	    }
	
	    return new Selection(merges, this._parents);
	  }
	
	  function selection_order() {
	
	    for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	      for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	
	    return this;
	  }
	
	  function selection_sort(compare) {
	    if (!compare) compare = ascending;
	
	    function compareNode(a, b) {
	      return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	    }
	
	    for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	        if (node = group[i]) {
	          sortgroup[i] = node;
	        }
	      }
	      sortgroup.sort(compareNode);
	    }
	
	    return new Selection(sortgroups, this._parents).order();
	  }
	
	  function ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	
	  function selection_call() {
	    var callback = arguments[0];
	    arguments[0] = this;
	    callback.apply(null, arguments);
	    return this;
	  }
	
	  function selection_nodes() {
	    var nodes = new Array(this.size()), i = -1;
	    this.each(function() { nodes[++i] = this; });
	    return nodes;
	  }
	
	  function selection_node() {
	
	    for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	      for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	
	    return null;
	  }
	
	  function selection_size() {
	    var size = 0;
	    this.each(function() { ++size; });
	    return size;
	  }
	
	  function selection_empty() {
	    return !this.node();
	  }
	
	  function selection_each(callback) {
	
	    for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	        if (node = group[i]) callback.call(node, node.__data__, i, group);
	      }
	    }
	
	    return this;
	  }
	
	  function attrRemove(name) {
	    return function() {
	      this.removeAttribute(name);
	    };
	  }
	
	  function attrRemoveNS(fullname) {
	    return function() {
	      this.removeAttributeNS(fullname.space, fullname.local);
	    };
	  }
	
	  function attrConstant(name, value) {
	    return function() {
	      this.setAttribute(name, value);
	    };
	  }
	
	  function attrConstantNS(fullname, value) {
	    return function() {
	      this.setAttributeNS(fullname.space, fullname.local, value);
	    };
	  }
	
	  function attrFunction(name, value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) this.removeAttribute(name);
	      else this.setAttribute(name, v);
	    };
	  }
	
	  function attrFunctionNS(fullname, value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	      else this.setAttributeNS(fullname.space, fullname.local, v);
	    };
	  }
	
	  function selection_attr(name, value) {
	    var fullname = namespace(name);
	
	    if (arguments.length < 2) {
	      var node = this.node();
	      return fullname.local
	          ? node.getAttributeNS(fullname.space, fullname.local)
	          : node.getAttribute(fullname);
	    }
	
	    return this.each((value == null
	        ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	        ? (fullname.local ? attrFunctionNS : attrFunction)
	        : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	  }
	
	  function defaultView(node) {
	    return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	        || (node.document && node) // node is a Window
	        || node.defaultView; // node is a Document
	  }
	
	  function styleRemove(name) {
	    return function() {
	      this.style.removeProperty(name);
	    };
	  }
	
	  function styleConstant(name, value, priority) {
	    return function() {
	      this.style.setProperty(name, value, priority);
	    };
	  }
	
	  function styleFunction(name, value, priority) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) this.style.removeProperty(name);
	      else this.style.setProperty(name, v, priority);
	    };
	  }
	
	  function selection_style(name, value, priority) {
	    var node;
	    return arguments.length > 1
	        ? this.each((value == null
	              ? styleRemove : typeof value === "function"
	              ? styleFunction
	              : styleConstant)(name, value, priority == null ? "" : priority))
	        : defaultView(node = this.node())
	            .getComputedStyle(node, null)
	            .getPropertyValue(name);
	  }
	
	  function propertyRemove(name) {
	    return function() {
	      delete this[name];
	    };
	  }
	
	  function propertyConstant(name, value) {
	    return function() {
	      this[name] = value;
	    };
	  }
	
	  function propertyFunction(name, value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) delete this[name];
	      else this[name] = v;
	    };
	  }
	
	  function selection_property(name, value) {
	    return arguments.length > 1
	        ? this.each((value == null
	            ? propertyRemove : typeof value === "function"
	            ? propertyFunction
	            : propertyConstant)(name, value))
	        : this.node()[name];
	  }
	
	  function classArray(string) {
	    return string.trim().split(/^|\s+/);
	  }
	
	  function classList(node) {
	    return node.classList || new ClassList(node);
	  }
	
	  function ClassList(node) {
	    this._node = node;
	    this._names = classArray(node.getAttribute("class") || "");
	  }
	
	  ClassList.prototype = {
	    add: function(name) {
	      var i = this._names.indexOf(name);
	      if (i < 0) {
	        this._names.push(name);
	        this._node.setAttribute("class", this._names.join(" "));
	      }
	    },
	    remove: function(name) {
	      var i = this._names.indexOf(name);
	      if (i >= 0) {
	        this._names.splice(i, 1);
	        this._node.setAttribute("class", this._names.join(" "));
	      }
	    },
	    contains: function(name) {
	      return this._names.indexOf(name) >= 0;
	    }
	  };
	
	  function classedAdd(node, names) {
	    var list = classList(node), i = -1, n = names.length;
	    while (++i < n) list.add(names[i]);
	  }
	
	  function classedRemove(node, names) {
	    var list = classList(node), i = -1, n = names.length;
	    while (++i < n) list.remove(names[i]);
	  }
	
	  function classedTrue(names) {
	    return function() {
	      classedAdd(this, names);
	    };
	  }
	
	  function classedFalse(names) {
	    return function() {
	      classedRemove(this, names);
	    };
	  }
	
	  function classedFunction(names, value) {
	    return function() {
	      (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	    };
	  }
	
	  function selection_classed(name, value) {
	    var names = classArray(name + "");
	
	    if (arguments.length < 2) {
	      var list = classList(this.node()), i = -1, n = names.length;
	      while (++i < n) if (!list.contains(names[i])) return false;
	      return true;
	    }
	
	    return this.each((typeof value === "function"
	        ? classedFunction : value
	        ? classedTrue
	        : classedFalse)(names, value));
	  }
	
	  function textRemove() {
	    this.textContent = "";
	  }
	
	  function textConstant(value) {
	    return function() {
	      this.textContent = value;
	    };
	  }
	
	  function textFunction(value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    };
	  }
	
	  function selection_text(value) {
	    return arguments.length
	        ? this.each(value == null
	            ? textRemove : (typeof value === "function"
	            ? textFunction
	            : textConstant)(value))
	        : this.node().textContent;
	  }
	
	  function htmlRemove() {
	    this.innerHTML = "";
	  }
	
	  function htmlConstant(value) {
	    return function() {
	      this.innerHTML = value;
	    };
	  }
	
	  function htmlFunction(value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    };
	  }
	
	  function selection_html(value) {
	    return arguments.length
	        ? this.each(value == null
	            ? htmlRemove : (typeof value === "function"
	            ? htmlFunction
	            : htmlConstant)(value))
	        : this.node().innerHTML;
	  }
	
	  function raise() {
	    if (this.nextSibling) this.parentNode.appendChild(this);
	  }
	
	  function selection_raise() {
	    return this.each(raise);
	  }
	
	  function lower() {
	    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	  }
	
	  function selection_lower() {
	    return this.each(lower);
	  }
	
	  function selection_append(name) {
	    var create = typeof name === "function" ? name : creator(name);
	    return this.select(function() {
	      return this.appendChild(create.apply(this, arguments));
	    });
	  }
	
	  function constantNull() {
	    return null;
	  }
	
	  function selection_insert(name, before) {
	    var create = typeof name === "function" ? name : creator(name),
	        select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	    return this.select(function() {
	      return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	    });
	  }
	
	  function remove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	
	  function selection_remove() {
	    return this.each(remove);
	  }
	
	  function selection_datum(value) {
	    return arguments.length
	        ? this.property("__data__", value)
	        : this.node().__data__;
	  }
	
	  function dispatchEvent(node, type, params) {
	    var window = defaultView(node),
	        event = window.CustomEvent;
	
	    if (event) {
	      event = new event(type, params);
	    } else {
	      event = window.document.createEvent("Event");
	      if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	      else event.initEvent(type, false, false);
	    }
	
	    node.dispatchEvent(event);
	  }
	
	  function dispatchConstant(type, params) {
	    return function() {
	      return dispatchEvent(this, type, params);
	    };
	  }
	
	  function dispatchFunction(type, params) {
	    return function() {
	      return dispatchEvent(this, type, params.apply(this, arguments));
	    };
	  }
	
	  function selection_dispatch(type, params) {
	    return this.each((typeof params === "function"
	        ? dispatchFunction
	        : dispatchConstant)(type, params));
	  }
	
	  var root = [null];
	
	  function Selection(groups, parents) {
	    this._groups = groups;
	    this._parents = parents;
	  }
	
	  function selection() {
	    return new Selection([[document.documentElement]], root);
	  }
	
	  Selection.prototype = selection.prototype = {
	    constructor: Selection,
	    select: selection_select,
	    selectAll: selection_selectAll,
	    filter: selection_filter,
	    data: selection_data,
	    enter: selection_enter,
	    exit: selection_exit,
	    merge: selection_merge,
	    order: selection_order,
	    sort: selection_sort,
	    call: selection_call,
	    nodes: selection_nodes,
	    node: selection_node,
	    size: selection_size,
	    empty: selection_empty,
	    each: selection_each,
	    attr: selection_attr,
	    style: selection_style,
	    property: selection_property,
	    classed: selection_classed,
	    text: selection_text,
	    html: selection_html,
	    raise: selection_raise,
	    lower: selection_lower,
	    append: selection_append,
	    insert: selection_insert,
	    remove: selection_remove,
	    datum: selection_datum,
	    on: selection_on,
	    dispatch: selection_dispatch
	  };
	
	  function select(selector) {
	    return typeof selector === "string"
	        ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	        : new Selection([[selector]], root);
	  }
	
	  function selectAll(selector) {
	    return typeof selector === "string"
	        ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	        : new Selection([selector == null ? [] : selector], root);
	  }
	
	  function touch(node, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	    for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return point(node, touch);
	      }
	    }
	
	    return null;
	  }
	
	  function touches(node, touches) {
	    if (touches == null) touches = sourceEvent().touches;
	
	    for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	      points[i] = point(node, touches[i]);
	    }
	
	    return points;
	  }
	
	  exports.creator = creator;
	  exports.local = local;
	  exports.matcher = matcher$1;
	  exports.mouse = mouse;
	  exports.namespace = namespace;
	  exports.namespaces = namespaces;
	  exports.select = select;
	  exports.selectAll = selectAll;
	  exports.selection = selection;
	  exports.selector = selector;
	  exports.selectorAll = selectorAll;
	  exports.touch = touch;
	  exports.touches = touches;
	  exports.window = defaultView;
	  exports.customEvent = customEvent;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ Version 2.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(93)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, function (exports,d3Time) { 'use strict';
	
	  function localDate(d) {
	    if (0 <= d.y && d.y < 100) {
	      var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	      date.setFullYear(d.y);
	      return date;
	    }
	    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	  }
	
	  function utcDate(d) {
	    if (0 <= d.y && d.y < 100) {
	      var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	      date.setUTCFullYear(d.y);
	      return date;
	    }
	    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	  }
	
	  function newYear(y) {
	    return {y: y, m: 0, d: 1, H: 0, M: 0, S: 0, L: 0};
	  }
	
	  function formatLocale(locale) {
	    var locale_dateTime = locale.dateTime,
	        locale_date = locale.date,
	        locale_time = locale.time,
	        locale_periods = locale.periods,
	        locale_weekdays = locale.days,
	        locale_shortWeekdays = locale.shortDays,
	        locale_months = locale.months,
	        locale_shortMonths = locale.shortMonths;
	
	    var periodRe = formatRe(locale_periods),
	        periodLookup = formatLookup(locale_periods),
	        weekdayRe = formatRe(locale_weekdays),
	        weekdayLookup = formatLookup(locale_weekdays),
	        shortWeekdayRe = formatRe(locale_shortWeekdays),
	        shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	        monthRe = formatRe(locale_months),
	        monthLookup = formatLookup(locale_months),
	        shortMonthRe = formatRe(locale_shortMonths),
	        shortMonthLookup = formatLookup(locale_shortMonths);
	
	    var formats = {
	      "a": formatShortWeekday,
	      "A": formatWeekday,
	      "b": formatShortMonth,
	      "B": formatMonth,
	      "c": null,
	      "d": formatDayOfMonth,
	      "e": formatDayOfMonth,
	      "H": formatHour24,
	      "I": formatHour12,
	      "j": formatDayOfYear,
	      "L": formatMilliseconds,
	      "m": formatMonthNumber,
	      "M": formatMinutes,
	      "p": formatPeriod,
	      "S": formatSeconds,
	      "U": formatWeekNumberSunday,
	      "w": formatWeekdayNumber,
	      "W": formatWeekNumberMonday,
	      "x": null,
	      "X": null,
	      "y": formatYear,
	      "Y": formatFullYear,
	      "Z": formatZone,
	      "%": formatLiteralPercent
	    };
	
	    var utcFormats = {
	      "a": formatUTCShortWeekday,
	      "A": formatUTCWeekday,
	      "b": formatUTCShortMonth,
	      "B": formatUTCMonth,
	      "c": null,
	      "d": formatUTCDayOfMonth,
	      "e": formatUTCDayOfMonth,
	      "H": formatUTCHour24,
	      "I": formatUTCHour12,
	      "j": formatUTCDayOfYear,
	      "L": formatUTCMilliseconds,
	      "m": formatUTCMonthNumber,
	      "M": formatUTCMinutes,
	      "p": formatUTCPeriod,
	      "S": formatUTCSeconds,
	      "U": formatUTCWeekNumberSunday,
	      "w": formatUTCWeekdayNumber,
	      "W": formatUTCWeekNumberMonday,
	      "x": null,
	      "X": null,
	      "y": formatUTCYear,
	      "Y": formatUTCFullYear,
	      "Z": formatUTCZone,
	      "%": formatLiteralPercent
	    };
	
	    var parses = {
	      "a": parseShortWeekday,
	      "A": parseWeekday,
	      "b": parseShortMonth,
	      "B": parseMonth,
	      "c": parseLocaleDateTime,
	      "d": parseDayOfMonth,
	      "e": parseDayOfMonth,
	      "H": parseHour24,
	      "I": parseHour24,
	      "j": parseDayOfYear,
	      "L": parseMilliseconds,
	      "m": parseMonthNumber,
	      "M": parseMinutes,
	      "p": parsePeriod,
	      "S": parseSeconds,
	      "U": parseWeekNumberSunday,
	      "w": parseWeekdayNumber,
	      "W": parseWeekNumberMonday,
	      "x": parseLocaleDate,
	      "X": parseLocaleTime,
	      "y": parseYear,
	      "Y": parseFullYear,
	      "Z": parseZone,
	      "%": parseLiteralPercent
	    };
	
	    // These recursive directive definitions must be deferred.
	    formats.x = newFormat(locale_date, formats);
	    formats.X = newFormat(locale_time, formats);
	    formats.c = newFormat(locale_dateTime, formats);
	    utcFormats.x = newFormat(locale_date, utcFormats);
	    utcFormats.X = newFormat(locale_time, utcFormats);
	    utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	    function newFormat(specifier, formats) {
	      return function(date) {
	        var string = [],
	            i = -1,
	            j = 0,
	            n = specifier.length,
	            c,
	            pad,
	            format;
	
	        if (!(date instanceof Date)) date = new Date(+date);
	
	        while (++i < n) {
	          if (specifier.charCodeAt(i) === 37) {
	            string.push(specifier.slice(j, i));
	            if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	            else pad = c === "e" ? " " : "0";
	            if (format = formats[c]) c = format(date, pad);
	            string.push(c);
	            j = i + 1;
	          }
	        }
	
	        string.push(specifier.slice(j, i));
	        return string.join("");
	      };
	    }
	
	    function newParse(specifier, newDate) {
	      return function(string) {
	        var d = newYear(1900),
	            i = parseSpecifier(d, specifier, string += "", 0);
	        if (i != string.length) return null;
	
	        // The am-pm flag is 0 for AM, and 1 for PM.
	        if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	        // Convert day-of-week and week-of-year to day-of-year.
	        if ("W" in d || "U" in d) {
	          if (!("w" in d)) d.w = "W" in d ? 1 : 0;
	          var day = "Z" in d ? utcDate(newYear(d.y)).getUTCDay() : newDate(newYear(d.y)).getDay();
	          d.m = 0;
	          d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	        }
	
	        // If a time zone is specified, all fields are interpreted as UTC and then
	        // offset according to the specified time zone.
	        if ("Z" in d) {
	          d.H += d.Z / 100 | 0;
	          d.M += d.Z % 100;
	          return utcDate(d);
	        }
	
	        // Otherwise, all fields are in local time.
	        return newDate(d);
	      };
	    }
	
	    function parseSpecifier(d, specifier, string, j) {
	      var i = 0,
	          n = specifier.length,
	          m = string.length,
	          c,
	          parse;
	
	      while (i < n) {
	        if (j >= m) return -1;
	        c = specifier.charCodeAt(i++);
	        if (c === 37) {
	          c = specifier.charAt(i++);
	          parse = parses[c in pads ? specifier.charAt(i++) : c];
	          if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	        } else if (c != string.charCodeAt(j++)) {
	          return -1;
	        }
	      }
	
	      return j;
	    }
	
	    function parsePeriod(d, string, i) {
	      var n = periodRe.exec(string.slice(i));
	      return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	    }
	
	    function parseShortWeekday(d, string, i) {
	      var n = shortWeekdayRe.exec(string.slice(i));
	      return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	    }
	
	    function parseWeekday(d, string, i) {
	      var n = weekdayRe.exec(string.slice(i));
	      return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	    }
	
	    function parseShortMonth(d, string, i) {
	      var n = shortMonthRe.exec(string.slice(i));
	      return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	    }
	
	    function parseMonth(d, string, i) {
	      var n = monthRe.exec(string.slice(i));
	      return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	    }
	
	    function parseLocaleDateTime(d, string, i) {
	      return parseSpecifier(d, locale_dateTime, string, i);
	    }
	
	    function parseLocaleDate(d, string, i) {
	      return parseSpecifier(d, locale_date, string, i);
	    }
	
	    function parseLocaleTime(d, string, i) {
	      return parseSpecifier(d, locale_time, string, i);
	    }
	
	    function formatShortWeekday(d) {
	      return locale_shortWeekdays[d.getDay()];
	    }
	
	    function formatWeekday(d) {
	      return locale_weekdays[d.getDay()];
	    }
	
	    function formatShortMonth(d) {
	      return locale_shortMonths[d.getMonth()];
	    }
	
	    function formatMonth(d) {
	      return locale_months[d.getMonth()];
	    }
	
	    function formatPeriod(d) {
	      return locale_periods[+(d.getHours() >= 12)];
	    }
	
	    function formatUTCShortWeekday(d) {
	      return locale_shortWeekdays[d.getUTCDay()];
	    }
	
	    function formatUTCWeekday(d) {
	      return locale_weekdays[d.getUTCDay()];
	    }
	
	    function formatUTCShortMonth(d) {
	      return locale_shortMonths[d.getUTCMonth()];
	    }
	
	    function formatUTCMonth(d) {
	      return locale_months[d.getUTCMonth()];
	    }
	
	    function formatUTCPeriod(d) {
	      return locale_periods[+(d.getUTCHours() >= 12)];
	    }
	
	    return {
	      format: function(specifier) {
	        var f = newFormat(specifier += "", formats);
	        f.toString = function() { return specifier; };
	        return f;
	      },
	      parse: function(specifier) {
	        var p = newParse(specifier += "", localDate);
	        p.toString = function() { return specifier; };
	        return p;
	      },
	      utcFormat: function(specifier) {
	        var f = newFormat(specifier += "", utcFormats);
	        f.toString = function() { return specifier; };
	        return f;
	      },
	      utcParse: function(specifier) {
	        var p = newParse(specifier, utcDate);
	        p.toString = function() { return specifier; };
	        return p;
	      }
	    };
	  }
	
	  var pads = {"-": "", "_": " ", "0": "0"};
	  var numberRe = /^\s*\d+/;
	  var percentRe = /^%/;
	  var requoteRe = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
	  function pad(value, fill, width) {
	    var sign = value < 0 ? "-" : "",
	        string = (sign ? -value : value) + "",
	        length = string.length;
	    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	  }
	
	  function requote(s) {
	    return s.replace(requoteRe, "\\$&");
	  }
	
	  function formatRe(names) {
	    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	  }
	
	  function formatLookup(names) {
	    var map = {}, i = -1, n = names.length;
	    while (++i < n) map[names[i].toLowerCase()] = i;
	    return map;
	  }
	
	  function parseWeekdayNumber(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 1));
	    return n ? (d.w = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseWeekNumberSunday(d, string, i) {
	    var n = numberRe.exec(string.slice(i));
	    return n ? (d.U = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseWeekNumberMonday(d, string, i) {
	    var n = numberRe.exec(string.slice(i));
	    return n ? (d.W = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseFullYear(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 4));
	    return n ? (d.y = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseYear(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	  }
	
	  function parseZone(d, string, i) {
	    var n = /^(Z)|([+-]\d\d)(?:\:?(\d\d))?/.exec(string.slice(i, i + 6));
	    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	  }
	
	  function parseMonthNumber(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	  }
	
	  function parseDayOfMonth(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.d = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseDayOfYear(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 3));
	    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseHour24(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.H = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseMinutes(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.M = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseSeconds(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 2));
	    return n ? (d.S = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseMilliseconds(d, string, i) {
	    var n = numberRe.exec(string.slice(i, i + 3));
	    return n ? (d.L = +n[0], i + n[0].length) : -1;
	  }
	
	  function parseLiteralPercent(d, string, i) {
	    var n = percentRe.exec(string.slice(i, i + 1));
	    return n ? i + n[0].length : -1;
	  }
	
	  function formatDayOfMonth(d, p) {
	    return pad(d.getDate(), p, 2);
	  }
	
	  function formatHour24(d, p) {
	    return pad(d.getHours(), p, 2);
	  }
	
	  function formatHour12(d, p) {
	    return pad(d.getHours() % 12 || 12, p, 2);
	  }
	
	  function formatDayOfYear(d, p) {
	    return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	  }
	
	  function formatMilliseconds(d, p) {
	    return pad(d.getMilliseconds(), p, 3);
	  }
	
	  function formatMonthNumber(d, p) {
	    return pad(d.getMonth() + 1, p, 2);
	  }
	
	  function formatMinutes(d, p) {
	    return pad(d.getMinutes(), p, 2);
	  }
	
	  function formatSeconds(d, p) {
	    return pad(d.getSeconds(), p, 2);
	  }
	
	  function formatWeekNumberSunday(d, p) {
	    return pad(d3Time.timeSunday.count(d3Time.timeYear(d), d), p, 2);
	  }
	
	  function formatWeekdayNumber(d) {
	    return d.getDay();
	  }
	
	  function formatWeekNumberMonday(d, p) {
	    return pad(d3Time.timeMonday.count(d3Time.timeYear(d), d), p, 2);
	  }
	
	  function formatYear(d, p) {
	    return pad(d.getFullYear() % 100, p, 2);
	  }
	
	  function formatFullYear(d, p) {
	    return pad(d.getFullYear() % 10000, p, 4);
	  }
	
	  function formatZone(d) {
	    var z = d.getTimezoneOffset();
	    return (z > 0 ? "-" : (z *= -1, "+"))
	        + pad(z / 60 | 0, "0", 2)
	        + pad(z % 60, "0", 2);
	  }
	
	  function formatUTCDayOfMonth(d, p) {
	    return pad(d.getUTCDate(), p, 2);
	  }
	
	  function formatUTCHour24(d, p) {
	    return pad(d.getUTCHours(), p, 2);
	  }
	
	  function formatUTCHour12(d, p) {
	    return pad(d.getUTCHours() % 12 || 12, p, 2);
	  }
	
	  function formatUTCDayOfYear(d, p) {
	    return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	  }
	
	  function formatUTCMilliseconds(d, p) {
	    return pad(d.getUTCMilliseconds(), p, 3);
	  }
	
	  function formatUTCMonthNumber(d, p) {
	    return pad(d.getUTCMonth() + 1, p, 2);
	  }
	
	  function formatUTCMinutes(d, p) {
	    return pad(d.getUTCMinutes(), p, 2);
	  }
	
	  function formatUTCSeconds(d, p) {
	    return pad(d.getUTCSeconds(), p, 2);
	  }
	
	  function formatUTCWeekNumberSunday(d, p) {
	    return pad(d3Time.utcSunday.count(d3Time.utcYear(d), d), p, 2);
	  }
	
	  function formatUTCWeekdayNumber(d) {
	    return d.getUTCDay();
	  }
	
	  function formatUTCWeekNumberMonday(d, p) {
	    return pad(d3Time.utcMonday.count(d3Time.utcYear(d), d), p, 2);
	  }
	
	  function formatUTCYear(d, p) {
	    return pad(d.getUTCFullYear() % 100, p, 2);
	  }
	
	  function formatUTCFullYear(d, p) {
	    return pad(d.getUTCFullYear() % 10000, p, 4);
	  }
	
	  function formatUTCZone() {
	    return "+0000";
	  }
	
	  function formatLiteralPercent() {
	    return "%";
	  }
	
	  var locale;
	  defaultLocale({
	    dateTime: "%x, %X",
	    date: "%-m/%-d/%Y",
	    time: "%-I:%M:%S %p",
	    periods: ["AM", "PM"],
	    days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	    shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	    months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	    shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	  });
	
	  function defaultLocale(definition) {
	    locale = formatLocale(definition);
	    exports.timeFormat = locale.format;
	    exports.timeParse = locale.parse;
	    exports.utcFormat = locale.utcFormat;
	    exports.utcParse = locale.utcParse;
	    return locale;
	  }
	
	  var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	  function formatIsoNative(date) {
	    return date.toISOString();
	  }
	
	  var formatIso = Date.prototype.toISOString
	      ? formatIsoNative
	      : exports.utcFormat(isoSpecifier);
	
	  function parseIsoNative(string) {
	    var date = new Date(string);
	    return isNaN(date) ? null : date;
	  }
	
	  var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	      ? parseIsoNative
	      : exports.utcParse(isoSpecifier);
	
	  exports.timeFormatDefaultLocale = defaultLocale;
	  exports.timeFormatLocale = formatLocale;
	  exports.isoFormat = formatIso;
	  exports.isoParse = parseIso;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventPluginRegistry = __webpack_require__(61);
	var EventPluginUtils = __webpack_require__(62);
	var ReactErrorUtils = __webpack_require__(68);
	
	var accumulateInto = __webpack_require__(123);
	var forEachAccumulated = __webpack_require__(125);
	var invariant = __webpack_require__(2);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventPluginHub = __webpack_require__(32);
	var EventPluginUtils = __webpack_require__(62);
	
	var accumulateInto = __webpack_require__(123);
	var forEachAccumulated = __webpack_require__(125);
	var warning = __webpack_require__(6);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 34 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(17);
	
	var getEventTarget = __webpack_require__(77);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 37 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-axis/ Version 1.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var slice = Array.prototype.slice;
	
	  function identity(x) {
	    return x;
	  }
	
	  var top = 1;
	  var right = 2;
	  var bottom = 3;
	  var left = 4;
	  var epsilon = 1e-6;
	  function translateX(scale0, scale1, d) {
	    var x = scale0(d);
	    return "translate(" + (isFinite(x) ? x : scale1(d)) + ",0)";
	  }
	
	  function translateY(scale0, scale1, d) {
	    var y = scale0(d);
	    return "translate(0," + (isFinite(y) ? y : scale1(d)) + ")";
	  }
	
	  function center(scale) {
	    var offset = scale.bandwidth() / 2;
	    if (scale.round()) offset = Math.round(offset);
	    return function(d) {
	      return scale(d) + offset;
	    };
	  }
	
	  function entering() {
	    return !this.__axis;
	  }
	
	  function axis(orient, scale) {
	    var tickArguments = [],
	        tickValues = null,
	        tickFormat = null,
	        tickSizeInner = 6,
	        tickSizeOuter = 6,
	        tickPadding = 3;
	
	    function axis(context) {
	      var values = tickValues == null ? (scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain()) : tickValues,
	          format = tickFormat == null ? (scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity) : tickFormat,
	          spacing = Math.max(tickSizeInner, 0) + tickPadding,
	          transform = orient === top || orient === bottom ? translateX : translateY,
	          range = scale.range(),
	          range0 = range[0] + 0.5,
	          range1 = range[range.length - 1] + 0.5,
	          position = (scale.bandwidth ? center : identity)(scale.copy()),
	          selection = context.selection ? context.selection() : context,
	          path = selection.selectAll(".domain").data([null]),
	          tick = selection.selectAll(".tick").data(values, scale).order(),
	          tickExit = tick.exit(),
	          tickEnter = tick.enter().append("g").attr("class", "tick"),
	          line = tick.select("line"),
	          text = tick.select("text"),
	          k = orient === top || orient === left ? -1 : 1,
	          x, y = orient === left || orient === right ? (x = "x", "y") : (x = "y", "x");
	
	      path = path.merge(path.enter().insert("path", ".tick")
	          .attr("class", "domain")
	          .attr("stroke", "#000"));
	
	      tick = tick.merge(tickEnter);
	
	      line = line.merge(tickEnter.append("line")
	          .attr("stroke", "#000")
	          .attr(x + "2", k * tickSizeInner)
	          .attr(y + "1", 0.5)
	          .attr(y + "2", 0.5));
	
	      text = text.merge(tickEnter.append("text")
	          .attr("fill", "#000")
	          .attr(x, k * spacing)
	          .attr(y, 0.5)
	          .attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
	
	      if (context !== selection) {
	        path = path.transition(context);
	        tick = tick.transition(context);
	        line = line.transition(context);
	        text = text.transition(context);
	
	        tickExit = tickExit.transition(context)
	            .attr("opacity", epsilon)
	            .attr("transform", function(d) { return transform(position, this.parentNode.__axis || position, d); });
	
	        tickEnter
	            .attr("opacity", epsilon)
	            .attr("transform", function(d) { return transform(this.parentNode.__axis || position, position, d); });
	      }
	
	      tickExit.remove();
	
	      path
	          .attr("d", orient === left || orient == right
	              ? "M" + k * tickSizeOuter + "," + range0 + "H0.5V" + range1 + "H" + k * tickSizeOuter
	              : "M" + range0 + "," + k * tickSizeOuter + "V0.5H" + range1 + "V" + k * tickSizeOuter);
	
	      tick
	          .attr("opacity", 1)
	          .attr("transform", function(d) { return transform(position, position, d); });
	
	      line
	          .attr(x + "2", k * tickSizeInner);
	
	      text
	          .attr(x, k * spacing)
	          .text(format);
	
	      selection.filter(entering)
	          .attr("fill", "none")
	          .attr("font-size", 10)
	          .attr("font-family", "sans-serif")
	          .attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
	
	      selection
	          .each(function() { this.__axis = position; });
	    }
	
	    axis.scale = function(_) {
	      return arguments.length ? (scale = _, axis) : scale;
	    };
	
	    axis.ticks = function() {
	      return tickArguments = slice.call(arguments), axis;
	    };
	
	    axis.tickArguments = function(_) {
	      return arguments.length ? (tickArguments = _ == null ? [] : slice.call(_), axis) : tickArguments.slice();
	    };
	
	    axis.tickValues = function(_) {
	      return arguments.length ? (tickValues = _ == null ? null : slice.call(_), axis) : tickValues && tickValues.slice();
	    };
	
	    axis.tickFormat = function(_) {
	      return arguments.length ? (tickFormat = _, axis) : tickFormat;
	    };
	
	    axis.tickSize = function(_) {
	      return arguments.length ? (tickSizeInner = tickSizeOuter = +_, axis) : tickSizeInner;
	    };
	
	    axis.tickSizeInner = function(_) {
	      return arguments.length ? (tickSizeInner = +_, axis) : tickSizeInner;
	    };
	
	    axis.tickSizeOuter = function(_) {
	      return arguments.length ? (tickSizeOuter = +_, axis) : tickSizeOuter;
	    };
	
	    axis.tickPadding = function(_) {
	      return arguments.length ? (tickPadding = +_, axis) : tickPadding;
	    };
	
	    return axis;
	  }
	
	  function axisTop(scale) {
	    return axis(top, scale);
	  }
	
	  function axisRight(scale) {
	    return axis(right, scale);
	  }
	
	  function axisBottom(scale) {
	    return axis(bottom, scale);
	  }
	
	  function axisLeft(scale) {
	    return axis(left, scale);
	  }
	
	  exports.axisTop = axisTop;
	  exports.axisRight = axisRight;
	  exports.axisBottom = axisBottom;
	  exports.axisLeft = axisLeft;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-shape/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(226)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-path'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Path) { 'use strict';
	
	var constant$1 = function(x) {
	  return function constant() {
	    return x;
	  };
	};
	
	var epsilon = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var tau = 2 * pi;
	
	function arcInnerRadius(d) {
	  return d.innerRadius;
	}
	
	function arcOuterRadius(d) {
	  return d.outerRadius;
	}
	
	function arcStartAngle(d) {
	  return d.startAngle;
	}
	
	function arcEndAngle(d) {
	  return d.endAngle;
	}
	
	function arcPadAngle(d) {
	  return d && d.padAngle; // Note: optional!
	}
	
	function asin(x) {
	  return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
	}
	
	function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
	  var x10 = x1 - x0, y10 = y1 - y0,
	      x32 = x3 - x2, y32 = y3 - y2,
	      t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / (y32 * x10 - x32 * y10);
	  return [x0 + t * x10, y0 + t * y10];
	}
	
	// Compute perpendicular offset line of length rc.
	// http://mathworld.wolfram.com/Circle-LineIntersection.html
	function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
	  var x01 = x0 - x1,
	      y01 = y0 - y1,
	      lo = (cw ? rc : -rc) / Math.sqrt(x01 * x01 + y01 * y01),
	      ox = lo * y01,
	      oy = -lo * x01,
	      x11 = x0 + ox,
	      y11 = y0 + oy,
	      x10 = x1 + ox,
	      y10 = y1 + oy,
	      x00 = (x11 + x10) / 2,
	      y00 = (y11 + y10) / 2,
	      dx = x10 - x11,
	      dy = y10 - y11,
	      d2 = dx * dx + dy * dy,
	      r = r1 - rc,
	      D = x11 * y10 - x10 * y11,
	      d = (dy < 0 ? -1 : 1) * Math.sqrt(Math.max(0, r * r * d2 - D * D)),
	      cx0 = (D * dy - dx * d) / d2,
	      cy0 = (-D * dx - dy * d) / d2,
	      cx1 = (D * dy + dx * d) / d2,
	      cy1 = (-D * dx + dy * d) / d2,
	      dx0 = cx0 - x00,
	      dy0 = cy0 - y00,
	      dx1 = cx1 - x00,
	      dy1 = cy1 - y00;
	
	  // Pick the closer of the two intersection points.
	  // TODO Is there a faster way to determine which intersection to use?
	  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
	
	  return {
	    cx: cx0,
	    cy: cy0,
	    x01: -ox,
	    y01: -oy,
	    x11: cx0 * (r1 / r - 1),
	    y11: cy0 * (r1 / r - 1)
	  };
	}
	
	var arc = function() {
	  var innerRadius = arcInnerRadius,
	      outerRadius = arcOuterRadius,
	      cornerRadius = constant$1(0),
	      padRadius = null,
	      startAngle = arcStartAngle,
	      endAngle = arcEndAngle,
	      padAngle = arcPadAngle,
	      context = null;
	
	  function arc() {
	    var buffer,
	        r,
	        r0 = +innerRadius.apply(this, arguments),
	        r1 = +outerRadius.apply(this, arguments),
	        a0 = startAngle.apply(this, arguments) - halfPi,
	        a1 = endAngle.apply(this, arguments) - halfPi,
	        da = Math.abs(a1 - a0),
	        cw = a1 > a0;
	
	    if (!context) context = buffer = d3Path.path();
	
	    // Ensure that the outer radius is always larger than the inner radius.
	    if (r1 < r0) r = r1, r1 = r0, r0 = r;
	
	    // Is it a point?
	    if (!(r1 > epsilon)) context.moveTo(0, 0);
	
	    // Or is it a circle or annulus?
	    else if (da > tau - epsilon) {
	      context.moveTo(r1 * Math.cos(a0), r1 * Math.sin(a0));
	      context.arc(0, 0, r1, a0, a1, !cw);
	      if (r0 > epsilon) {
	        context.moveTo(r0 * Math.cos(a1), r0 * Math.sin(a1));
	        context.arc(0, 0, r0, a1, a0, cw);
	      }
	    }
	
	    // Or is it a circular or annular sector?
	    else {
	      var a01 = a0,
	          a11 = a1,
	          a00 = a0,
	          a10 = a1,
	          da0 = da,
	          da1 = da,
	          ap = padAngle.apply(this, arguments) / 2,
	          rp = (ap > epsilon) && (padRadius ? +padRadius.apply(this, arguments) : Math.sqrt(r0 * r0 + r1 * r1)),
	          rc = Math.min(Math.abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)),
	          rc0 = rc,
	          rc1 = rc,
	          t0,
	          t1;
	
	      // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
	      if (rp > epsilon) {
	        var p0 = asin(rp / r0 * Math.sin(ap)),
	            p1 = asin(rp / r1 * Math.sin(ap));
	        if ((da0 -= p0 * 2) > epsilon) p0 *= (cw ? 1 : -1), a00 += p0, a10 -= p0;
	        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
	        if ((da1 -= p1 * 2) > epsilon) p1 *= (cw ? 1 : -1), a01 += p1, a11 -= p1;
	        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
	      }
	
	      var x01 = r1 * Math.cos(a01),
	          y01 = r1 * Math.sin(a01),
	          x10 = r0 * Math.cos(a10),
	          y10 = r0 * Math.sin(a10);
	
	      // Apply rounded corners?
	      if (rc > epsilon) {
	        var x11 = r1 * Math.cos(a11),
	            y11 = r1 * Math.sin(a11),
	            x00 = r0 * Math.cos(a00),
	            y00 = r0 * Math.sin(a00);
	
	        // Restrict the corner radius according to the sector angle.
	        if (da < pi) {
	          var oc = da0 > epsilon ? intersect(x01, y01, x00, y00, x11, y11, x10, y10) : [x10, y10],
	              ax = x01 - oc[0],
	              ay = y01 - oc[1],
	              bx = x11 - oc[0],
	              by = y11 - oc[1],
	              kc = 1 / Math.sin(Math.acos((ax * bx + ay * by) / (Math.sqrt(ax * ax + ay * ay) * Math.sqrt(bx * bx + by * by))) / 2),
	              lc = Math.sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
	          rc0 = Math.min(rc, (r0 - lc) / (kc - 1));
	          rc1 = Math.min(rc, (r1 - lc) / (kc + 1));
	        }
	      }
	
	      // Is the sector collapsed to a line?
	      if (!(da1 > epsilon)) context.moveTo(x01, y01);
	
	      // Does the sector’s outer ring have rounded corners?
	      else if (rc1 > epsilon) {
	        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
	        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
	
	        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc1, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r1, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
	          context.arc(t1.cx, t1.cy, rc1, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the outer ring just a circular arc?
	      else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
	
	      // Is there no inner ring, and it’s a circular sector?
	      // Or perhaps it’s an annular sector collapsed due to padding?
	      if (!(r0 > epsilon) || !(da0 > epsilon)) context.lineTo(x10, y10);
	
	      // Does the sector’s inner ring (or point) have rounded corners?
	      else if (rc0 > epsilon) {
	        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
	        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
	
	        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
	
	        // Have the corners merged?
	        if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t1.y01, t1.x01), !cw);
	
	        // Otherwise, draw the two corners and the ring.
	        else {
	          context.arc(t0.cx, t0.cy, rc0, Math.atan2(t0.y01, t0.x01), Math.atan2(t0.y11, t0.x11), !cw);
	          context.arc(0, 0, r0, Math.atan2(t0.cy + t0.y11, t0.cx + t0.x11), Math.atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
	          context.arc(t1.cx, t1.cy, rc0, Math.atan2(t1.y11, t1.x11), Math.atan2(t1.y01, t1.x01), !cw);
	        }
	      }
	
	      // Or is the inner ring just a circular arc?
	      else context.arc(0, 0, r0, a10, a00, cw);
	    }
	
	    context.closePath();
	
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  arc.centroid = function() {
	    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2,
	        a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
	    return [Math.cos(a) * r, Math.sin(a) * r];
	  };
	
	  arc.innerRadius = function(_) {
	    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : innerRadius;
	  };
	
	  arc.outerRadius = function(_) {
	    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : outerRadius;
	  };
	
	  arc.cornerRadius = function(_) {
	    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant$1(+_), arc) : cornerRadius;
	  };
	
	  arc.padRadius = function(_) {
	    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), arc) : padRadius;
	  };
	
	  arc.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : startAngle;
	  };
	
	  arc.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : endAngle;
	  };
	
	  arc.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), arc) : padAngle;
	  };
	
	  arc.context = function(_) {
	    return arguments.length ? ((context = _ == null ? null : _), arc) : context;
	  };
	
	  return arc;
	};
	
	function Linear(context) {
	  this._context = context;
	}
	
	Linear.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: this._context.lineTo(x, y); break;
	    }
	  }
	};
	
	var curveLinear = function(context) {
	  return new Linear(context);
	};
	
	function x(p) {
	  return p[0];
	}
	
	function y(p) {
	  return p[1];
	}
	
	var line = function() {
	  var x$$1 = x,
	      y$$1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function line(data) {
	    var i,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer;
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) output.lineStart();
	        else output.lineEnd();
	      }
	      if (defined0) output.point(+x$$1(d, i, data), +y$$1(d, i, data));
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  line.x = function(_) {
	    return arguments.length ? (x$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : x$$1;
	  };
	
	  line.y = function(_) {
	    return arguments.length ? (y$$1 = typeof _ === "function" ? _ : constant$1(+_), line) : y$$1;
	  };
	
	  line.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), line) : defined;
	  };
	
	  line.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
	  };
	
	  line.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
	  };
	
	  return line;
	};
	
	var area = function() {
	  var x0 = x,
	      x1 = null,
	      y0 = constant$1(0),
	      y1 = y,
	      defined = constant$1(true),
	      context = null,
	      curve = curveLinear,
	      output = null;
	
	  function area(data) {
	    var i,
	        j,
	        k,
	        n = data.length,
	        d,
	        defined0 = false,
	        buffer,
	        x0z = new Array(n),
	        y0z = new Array(n);
	
	    if (context == null) output = curve(buffer = d3Path.path());
	
	    for (i = 0; i <= n; ++i) {
	      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
	        if (defined0 = !defined0) {
	          j = i;
	          output.areaStart();
	          output.lineStart();
	        } else {
	          output.lineEnd();
	          output.lineStart();
	          for (k = i - 1; k >= j; --k) {
	            output.point(x0z[k], y0z[k]);
	          }
	          output.lineEnd();
	          output.areaEnd();
	        }
	      }
	      if (defined0) {
	        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
	        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
	      }
	    }
	
	    if (buffer) return output = null, buffer + "" || null;
	  }
	
	  function arealine() {
	    return line().defined(defined).curve(curve).context(context);
	  }
	
	  area.x = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), x1 = null, area) : x0;
	  };
	
	  area.x0 = function(_) {
	    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant$1(+_), area) : x0;
	  };
	
	  area.x1 = function(_) {
	    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : x1;
	  };
	
	  area.y = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), y1 = null, area) : y0;
	  };
	
	  area.y0 = function(_) {
	    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant$1(+_), area) : y0;
	  };
	
	  area.y1 = function(_) {
	    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant$1(+_), area) : y1;
	  };
	
	  area.lineX0 =
	  area.lineY0 = function() {
	    return arealine().x(x0).y(y0);
	  };
	
	  area.lineY1 = function() {
	    return arealine().x(x0).y(y1);
	  };
	
	  area.lineX1 = function() {
	    return arealine().x(x1).y(y0);
	  };
	
	  area.defined = function(_) {
	    return arguments.length ? (defined = typeof _ === "function" ? _ : constant$1(!!_), area) : defined;
	  };
	
	  area.curve = function(_) {
	    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
	  };
	
	  area.context = function(_) {
	    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
	  };
	
	  return area;
	};
	
	var descending = function(a, b) {
	  return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	};
	
	var identity = function(d) {
	  return d;
	};
	
	var pie = function() {
	  var value = identity,
	      sortValues = descending,
	      sort = null,
	      startAngle = constant$1(0),
	      endAngle = constant$1(tau),
	      padAngle = constant$1(0);
	
	  function pie(data) {
	    var i,
	        n = data.length,
	        j,
	        k,
	        sum = 0,
	        index = new Array(n),
	        arcs = new Array(n),
	        a0 = +startAngle.apply(this, arguments),
	        da = Math.min(tau, Math.max(-tau, endAngle.apply(this, arguments) - a0)),
	        a1,
	        p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)),
	        pa = p * (da < 0 ? -1 : 1),
	        v;
	
	    for (i = 0; i < n; ++i) {
	      if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) {
	        sum += v;
	      }
	    }
	
	    // Optionally sort the arcs by previously-computed values or by data.
	    if (sortValues != null) index.sort(function(i, j) { return sortValues(arcs[i], arcs[j]); });
	    else if (sort != null) index.sort(function(i, j) { return sort(data[i], data[j]); });
	
	    // Compute the arcs! They are stored in the original data's order.
	    for (i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1) {
	      j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
	        data: data[j],
	        index: i,
	        value: v,
	        startAngle: a0,
	        endAngle: a1,
	        padAngle: p
	      };
	    }
	
	    return arcs;
	  }
	
	  pie.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), pie) : value;
	  };
	
	  pie.sortValues = function(_) {
	    return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
	  };
	
	  pie.sort = function(_) {
	    return arguments.length ? (sort = _, sortValues = null, pie) : sort;
	  };
	
	  pie.startAngle = function(_) {
	    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : startAngle;
	  };
	
	  pie.endAngle = function(_) {
	    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : endAngle;
	  };
	
	  pie.padAngle = function(_) {
	    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant$1(+_), pie) : padAngle;
	  };
	
	  return pie;
	};
	
	var curveRadialLinear = curveRadial(curveLinear);
	
	function Radial(curve) {
	  this._curve = curve;
	}
	
	Radial.prototype = {
	  areaStart: function() {
	    this._curve.areaStart();
	  },
	  areaEnd: function() {
	    this._curve.areaEnd();
	  },
	  lineStart: function() {
	    this._curve.lineStart();
	  },
	  lineEnd: function() {
	    this._curve.lineEnd();
	  },
	  point: function(a, r) {
	    this._curve.point(r * Math.sin(a), r * -Math.cos(a));
	  }
	};
	
	function curveRadial(curve) {
	
	  function radial(context) {
	    return new Radial(curve(context));
	  }
	
	  radial._curve = curve;
	
	  return radial;
	}
	
	function radialLine(l) {
	  var c = l.curve;
	
	  l.angle = l.x, delete l.x;
	  l.radius = l.y, delete l.y;
	
	  l.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return l;
	}
	
	var radialLine$1 = function() {
	  return radialLine(line().curve(curveRadialLinear));
	};
	
	var radialArea = function() {
	  var a = area().curve(curveRadialLinear),
	      c = a.curve,
	      x0 = a.lineX0,
	      x1 = a.lineX1,
	      y0 = a.lineY0,
	      y1 = a.lineY1;
	
	  a.angle = a.x, delete a.x;
	  a.startAngle = a.x0, delete a.x0;
	  a.endAngle = a.x1, delete a.x1;
	  a.radius = a.y, delete a.y;
	  a.innerRadius = a.y0, delete a.y0;
	  a.outerRadius = a.y1, delete a.y1;
	  a.lineStartAngle = function() { return radialLine(x0()); }, delete a.lineX0;
	  a.lineEndAngle = function() { return radialLine(x1()); }, delete a.lineX1;
	  a.lineInnerRadius = function() { return radialLine(y0()); }, delete a.lineY0;
	  a.lineOuterRadius = function() { return radialLine(y1()); }, delete a.lineY1;
	
	  a.curve = function(_) {
	    return arguments.length ? c(curveRadial(_)) : c()._curve;
	  };
	
	  return a;
	};
	
	var circle = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / pi);
	    context.moveTo(r, 0);
	    context.arc(0, 0, r, 0, tau);
	  }
	};
	
	var cross = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / 5) / 2;
	    context.moveTo(-3 * r, -r);
	    context.lineTo(-r, -r);
	    context.lineTo(-r, -3 * r);
	    context.lineTo(r, -3 * r);
	    context.lineTo(r, -r);
	    context.lineTo(3 * r, -r);
	    context.lineTo(3 * r, r);
	    context.lineTo(r, r);
	    context.lineTo(r, 3 * r);
	    context.lineTo(-r, 3 * r);
	    context.lineTo(-r, r);
	    context.lineTo(-3 * r, r);
	    context.closePath();
	  }
	};
	
	var tan30 = Math.sqrt(1 / 3);
	var tan30_2 = tan30 * 2;
	
	var diamond = {
	  draw: function(context, size) {
	    var y = Math.sqrt(size / tan30_2),
	        x = y * tan30;
	    context.moveTo(0, -y);
	    context.lineTo(x, 0);
	    context.lineTo(0, y);
	    context.lineTo(-x, 0);
	    context.closePath();
	  }
	};
	
	var ka = 0.89081309152928522810;
	var kr = Math.sin(pi / 10) / Math.sin(7 * pi / 10);
	var kx = Math.sin(tau / 10) * kr;
	var ky = -Math.cos(tau / 10) * kr;
	
	var star = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size * ka),
	        x = kx * r,
	        y = ky * r;
	    context.moveTo(0, -r);
	    context.lineTo(x, y);
	    for (var i = 1; i < 5; ++i) {
	      var a = tau * i / 5,
	          c = Math.cos(a),
	          s = Math.sin(a);
	      context.lineTo(s * r, -c * r);
	      context.lineTo(c * x - s * y, s * x + c * y);
	    }
	    context.closePath();
	  }
	};
	
	var square = {
	  draw: function(context, size) {
	    var w = Math.sqrt(size),
	        x = -w / 2;
	    context.rect(x, x, w, w);
	  }
	};
	
	var sqrt3 = Math.sqrt(3);
	
	var triangle = {
	  draw: function(context, size) {
	    var y = -Math.sqrt(size / (sqrt3 * 3));
	    context.moveTo(0, y * 2);
	    context.lineTo(-sqrt3 * y, -y);
	    context.lineTo(sqrt3 * y, -y);
	    context.closePath();
	  }
	};
	
	var c = -0.5;
	var s = Math.sqrt(3) / 2;
	var k = 1 / Math.sqrt(12);
	var a = (k / 2 + 1) * 3;
	
	var wye = {
	  draw: function(context, size) {
	    var r = Math.sqrt(size / a),
	        x0 = r / 2,
	        y0 = r * k,
	        x1 = x0,
	        y1 = r * k + r,
	        x2 = -x1,
	        y2 = y1;
	    context.moveTo(x0, y0);
	    context.lineTo(x1, y1);
	    context.lineTo(x2, y2);
	    context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
	    context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
	    context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
	    context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
	    context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
	    context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
	    context.closePath();
	  }
	};
	
	var symbols = [
	  circle,
	  cross,
	  diamond,
	  square,
	  star,
	  triangle,
	  wye
	];
	
	var symbol = function() {
	  var type = constant$1(circle),
	      size = constant$1(64),
	      context = null;
	
	  function symbol() {
	    var buffer;
	    if (!context) context = buffer = d3Path.path();
	    type.apply(this, arguments).draw(context, +size.apply(this, arguments));
	    if (buffer) return context = null, buffer + "" || null;
	  }
	
	  symbol.type = function(_) {
	    return arguments.length ? (type = typeof _ === "function" ? _ : constant$1(_), symbol) : type;
	  };
	
	  symbol.size = function(_) {
	    return arguments.length ? (size = typeof _ === "function" ? _ : constant$1(+_), symbol) : size;
	  };
	
	  symbol.context = function(_) {
	    return arguments.length ? (context = _ == null ? null : _, symbol) : context;
	  };
	
	  return symbol;
	};
	
	var noop = function() {};
	
	function point(that, x, y) {
	  that._context.bezierCurveTo(
	    (2 * that._x0 + that._x1) / 3,
	    (2 * that._y0 + that._y1) / 3,
	    (that._x0 + 2 * that._x1) / 3,
	    (that._y0 + 2 * that._y1) / 3,
	    (that._x0 + 4 * that._x1 + x) / 6,
	    (that._y0 + 4 * that._y1 + y) / 6
	  );
	}
	
	function Basis(context) {
	  this._context = context;
	}
	
	Basis.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 3: point(this, this._x1, this._y1); // proceed
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basis = function(context) {
	  return new Basis(context);
	};
	
	function BasisClosed(context) {
	  this._context = context;
	}
	
	BasisClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x2, this._y2);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
	        this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x2, this._y2);
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x2 = x, this._y2 = y; break;
	      case 1: this._point = 2; this._x3 = x, this._y3 = y; break;
	      case 2: this._point = 3; this._x4 = x, this._y4 = y; this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6); break;
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisClosed = function(context) {
	  return new BasisClosed(context);
	};
	
	function BasisOpen(context) {
	  this._context = context;
	}
	
	BasisOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6; this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0); break;
	      case 3: this._point = 4; // proceed
	      default: point(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	  }
	};
	
	var basisOpen = function(context) {
	  return new BasisOpen(context);
	};
	
	function Bundle(context, beta) {
	  this._basis = new Basis(context);
	  this._beta = beta;
	}
	
	Bundle.prototype = {
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	    this._basis.lineStart();
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        j = x.length - 1;
	
	    if (j > 0) {
	      var x0 = x[0],
	          y0 = y[0],
	          dx = x[j] - x0,
	          dy = y[j] - y0,
	          i = -1,
	          t;
	
	      while (++i <= j) {
	        t = i / j;
	        this._basis.point(
	          this._beta * x[i] + (1 - this._beta) * (x0 + t * dx),
	          this._beta * y[i] + (1 - this._beta) * (y0 + t * dy)
	        );
	      }
	    }
	
	    this._x = this._y = null;
	    this._basis.lineEnd();
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	var bundle = (function custom(beta) {
	
	  function bundle(context) {
	    return beta === 1 ? new Basis(context) : new Bundle(context, beta);
	  }
	
	  bundle.beta = function(beta) {
	    return custom(+beta);
	  };
	
	  return bundle;
	})(0.85);
	
	function point$1(that, x, y) {
	  that._context.bezierCurveTo(
	    that._x1 + that._k * (that._x2 - that._x0),
	    that._y1 + that._k * (that._y2 - that._y0),
	    that._x2 + that._k * (that._x1 - x),
	    that._y2 + that._k * (that._y1 - y),
	    that._x2,
	    that._y2
	  );
	}
	
	function Cardinal(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	Cardinal.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: point$1(this, this._x1, this._y1); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; this._x1 = x, this._y1 = y; break;
	      case 2: this._point = 3; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinal = (function custom(tension) {
	
	  function cardinal(context) {
	    return new Cardinal(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalClosed(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalClosed = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalClosed(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function CardinalOpen(context, tension) {
	  this._context = context;
	  this._k = (1 - tension) / 6;
	}
	
	CardinalOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$1(this, x, y); break;
	    }
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var cardinalOpen = (function custom(tension) {
	
	  function cardinal(context) {
	    return new CardinalOpen(context, tension);
	  }
	
	  cardinal.tension = function(tension) {
	    return custom(+tension);
	  };
	
	  return cardinal;
	})(0);
	
	function point$2(that, x, y) {
	  var x1 = that._x1,
	      y1 = that._y1,
	      x2 = that._x2,
	      y2 = that._y2;
	
	  if (that._l01_a > epsilon) {
	    var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a,
	        n = 3 * that._l01_a * (that._l01_a + that._l12_a);
	    x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
	    y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
	  }
	
	  if (that._l23_a > epsilon) {
	    var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a,
	        m = 3 * that._l23_a * (that._l23_a + that._l12_a);
	    x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
	    y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
	  }
	
	  that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
	}
	
	function CatmullRom(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRom.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x2, this._y2); break;
	      case 3: this.point(this._x2, this._y2); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRom = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRom(context, alpha) : new Cardinal(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomClosed(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 =
	    this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 1: {
	        this._context.moveTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 2: {
	        this._context.lineTo(this._x3, this._y3);
	        this._context.closePath();
	        break;
	      }
	      case 3: {
	        this.point(this._x3, this._y3);
	        this.point(this._x4, this._y4);
	        this.point(this._x5, this._y5);
	        break;
	      }
	    }
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; this._x3 = x, this._y3 = y; break;
	      case 1: this._point = 2; this._context.moveTo(this._x4 = x, this._y4 = y); break;
	      case 2: this._point = 3; this._x5 = x, this._y5 = y; break;
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomClosed = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomClosed(context, alpha) : new CardinalClosed(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function CatmullRomOpen(context, alpha) {
	  this._context = context;
	  this._alpha = alpha;
	}
	
	CatmullRomOpen.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 = this._x2 =
	    this._y0 = this._y1 = this._y2 = NaN;
	    this._l01_a = this._l12_a = this._l23_a =
	    this._l01_2a = this._l12_2a = this._l23_2a =
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line || (this._line !== 0 && this._point === 3)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	
	    if (this._point) {
	      var x23 = this._x2 - x,
	          y23 = this._y2 - y;
	      this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
	    }
	
	    switch (this._point) {
	      case 0: this._point = 1; break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2); break;
	      case 3: this._point = 4; // proceed
	      default: point$2(this, x, y); break;
	    }
	
	    this._l01_a = this._l12_a, this._l12_a = this._l23_a;
	    this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
	    this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
	    this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
	  }
	};
	
	var catmullRomOpen = (function custom(alpha) {
	
	  function catmullRom(context) {
	    return alpha ? new CatmullRomOpen(context, alpha) : new CardinalOpen(context, 0);
	  }
	
	  catmullRom.alpha = function(alpha) {
	    return custom(+alpha);
	  };
	
	  return catmullRom;
	})(0.5);
	
	function LinearClosed(context) {
	  this._context = context;
	}
	
	LinearClosed.prototype = {
	  areaStart: noop,
	  areaEnd: noop,
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._point) this._context.closePath();
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    if (this._point) this._context.lineTo(x, y);
	    else this._point = 1, this._context.moveTo(x, y);
	  }
	};
	
	var linearClosed = function(context) {
	  return new LinearClosed(context);
	};
	
	function sign(x) {
	  return x < 0 ? -1 : 1;
	}
	
	// Calculate the slopes of the tangents (Hermite-type interpolation) based on
	// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
	// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
	// NOV(II), P. 443, 1990.
	function slope3(that, x2, y2) {
	  var h0 = that._x1 - that._x0,
	      h1 = x2 - that._x1,
	      s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0),
	      s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0),
	      p = (s0 * h1 + s1 * h0) / (h0 + h1);
	  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
	}
	
	// Calculate a one-sided slope.
	function slope2(that, t) {
	  var h = that._x1 - that._x0;
	  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
	}
	
	// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
	// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
	// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
	function point$3(that, t0, t1) {
	  var x0 = that._x0,
	      y0 = that._y0,
	      x1 = that._x1,
	      y1 = that._y1,
	      dx = (x1 - x0) / 3;
	  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
	}
	
	function MonotoneX(context) {
	  this._context = context;
	}
	
	MonotoneX.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x0 = this._x1 =
	    this._y0 = this._y1 =
	    this._t0 = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    switch (this._point) {
	      case 2: this._context.lineTo(this._x1, this._y1); break;
	      case 3: point$3(this, this._t0, slope2(this, this._t0)); break;
	    }
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    var t1 = NaN;
	
	    x = +x, y = +y;
	    if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; break;
	      case 2: this._point = 3; point$3(this, slope2(this, t1 = slope3(this, x, y)), t1); break;
	      default: point$3(this, this._t0, t1 = slope3(this, x, y)); break;
	    }
	
	    this._x0 = this._x1, this._x1 = x;
	    this._y0 = this._y1, this._y1 = y;
	    this._t0 = t1;
	  }
	};
	
	function MonotoneY(context) {
	  this._context = new ReflectContext(context);
	}
	
	(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
	  MonotoneX.prototype.point.call(this, y, x);
	};
	
	function ReflectContext(context) {
	  this._context = context;
	}
	
	ReflectContext.prototype = {
	  moveTo: function(x, y) { this._context.moveTo(y, x); },
	  closePath: function() { this._context.closePath(); },
	  lineTo: function(x, y) { this._context.lineTo(y, x); },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) { this._context.bezierCurveTo(y1, x1, y2, x2, y, x); }
	};
	
	function monotoneX(context) {
	  return new MonotoneX(context);
	}
	
	function monotoneY(context) {
	  return new MonotoneY(context);
	}
	
	function Natural(context) {
	  this._context = context;
	}
	
	Natural.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = [];
	    this._y = [];
	  },
	  lineEnd: function() {
	    var x = this._x,
	        y = this._y,
	        n = x.length;
	
	    if (n) {
	      this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
	      if (n === 2) {
	        this._context.lineTo(x[1], y[1]);
	      } else {
	        var px = controlPoints(x),
	            py = controlPoints(y);
	        for (var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1) {
	          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
	        }
	      }
	    }
	
	    if (this._line || (this._line !== 0 && n === 1)) this._context.closePath();
	    this._line = 1 - this._line;
	    this._x = this._y = null;
	  },
	  point: function(x, y) {
	    this._x.push(+x);
	    this._y.push(+y);
	  }
	};
	
	// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
	function controlPoints(x) {
	  var i,
	      n = x.length - 1,
	      m,
	      a = new Array(n),
	      b = new Array(n),
	      r = new Array(n);
	  a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
	  for (i = 1; i < n - 1; ++i) a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
	  a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
	  for (i = 1; i < n; ++i) m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
	  a[n - 1] = r[n - 1] / b[n - 1];
	  for (i = n - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b[i];
	  b[n - 1] = (x[n] + a[n - 1]) / 2;
	  for (i = 0; i < n - 1; ++i) b[i] = 2 * x[i + 1] - a[i + 1];
	  return [a, b];
	}
	
	var natural = function(context) {
	  return new Natural(context);
	};
	
	function Step(context, t) {
	  this._context = context;
	  this._t = t;
	}
	
	Step.prototype = {
	  areaStart: function() {
	    this._line = 0;
	  },
	  areaEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._x = this._y = NaN;
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
	    if (this._line || (this._line !== 0 && this._point === 1)) this._context.closePath();
	    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
	  },
	  point: function(x, y) {
	    x = +x, y = +y;
	    switch (this._point) {
	      case 0: this._point = 1; this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y); break;
	      case 1: this._point = 2; // proceed
	      default: {
	        if (this._t <= 0) {
	          this._context.lineTo(this._x, y);
	          this._context.lineTo(x, y);
	        } else {
	          var x1 = this._x * (1 - this._t) + x * this._t;
	          this._context.lineTo(x1, this._y);
	          this._context.lineTo(x1, y);
	        }
	        break;
	      }
	    }
	    this._x = x, this._y = y;
	  }
	};
	
	var step = function(context) {
	  return new Step(context, 0.5);
	};
	
	function stepBefore(context) {
	  return new Step(context, 0);
	}
	
	function stepAfter(context) {
	  return new Step(context, 1);
	}
	
	var slice = Array.prototype.slice;
	
	var none = function(series, order) {
	  if (!((n = series.length) > 1)) return;
	  for (var i = 1, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i) {
	    s0 = s1, s1 = series[order[i]];
	    for (var j = 0; j < m; ++j) {
	      s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
	    }
	  }
	};
	
	var none$1 = function(series) {
	  var n = series.length, o = new Array(n);
	  while (--n >= 0) o[n] = n;
	  return o;
	};
	
	function stackValue(d, key) {
	  return d[key];
	}
	
	var stack = function() {
	  var keys = constant$1([]),
	      order = none$1,
	      offset = none,
	      value = stackValue;
	
	  function stack(data) {
	    var kz = keys.apply(this, arguments),
	        i,
	        m = data.length,
	        n = kz.length,
	        sz = new Array(n),
	        oz;
	
	    for (i = 0; i < n; ++i) {
	      for (var ki = kz[i], si = sz[i] = new Array(m), j = 0, sij; j < m; ++j) {
	        si[j] = sij = [0, +value(data[j], ki, j, data)];
	        sij.data = data[j];
	      }
	      si.key = ki;
	    }
	
	    for (i = 0, oz = order(sz); i < n; ++i) {
	      sz[oz[i]].index = i;
	    }
	
	    offset(sz, oz);
	    return sz;
	  }
	
	  stack.keys = function(_) {
	    return arguments.length ? (keys = typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : keys;
	  };
	
	  stack.value = function(_) {
	    return arguments.length ? (value = typeof _ === "function" ? _ : constant$1(+_), stack) : value;
	  };
	
	  stack.order = function(_) {
	    return arguments.length ? (order = _ == null ? none$1 : typeof _ === "function" ? _ : constant$1(slice.call(_)), stack) : order;
	  };
	
	  stack.offset = function(_) {
	    return arguments.length ? (offset = _ == null ? none : _, stack) : offset;
	  };
	
	  return stack;
	};
	
	var expand = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var i, n, j = 0, m = series[0].length, y; j < m; ++j) {
	    for (y = i = 0; i < n; ++i) y += series[i][j][1] || 0;
	    if (y) for (i = 0; i < n; ++i) series[i][j][1] /= y;
	  }
	  none(series, order);
	};
	
	var silhouette = function(series, order) {
	  if (!((n = series.length) > 0)) return;
	  for (var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j) {
	    for (var i = 0, y = 0; i < n; ++i) y += series[i][j][1] || 0;
	    s0[j][1] += s0[j][0] = -y / 2;
	  }
	  none(series, order);
	};
	
	var wiggle = function(series, order) {
	  if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
	  for (var y = 0, j = 1, s0, m, n; j < m; ++j) {
	    for (var i = 0, s1 = 0, s2 = 0; i < n; ++i) {
	      var si = series[order[i]],
	          sij0 = si[j][1] || 0,
	          sij1 = si[j - 1][1] || 0,
	          s3 = (sij0 - sij1) / 2;
	      for (var k = 0; k < i; ++k) {
	        var sk = series[order[k]],
	            skj0 = sk[j][1] || 0,
	            skj1 = sk[j - 1][1] || 0;
	        s3 += skj0 - skj1;
	      }
	      s1 += sij0, s2 += s3 * sij0;
	    }
	    s0[j - 1][1] += s0[j - 1][0] = y;
	    if (s1) y -= s2 / s1;
	  }
	  s0[j - 1][1] += s0[j - 1][0] = y;
	  none(series, order);
	};
	
	var ascending = function(series) {
	  var sums = series.map(sum);
	  return none$1(series).sort(function(a, b) { return sums[a] - sums[b]; });
	};
	
	function sum(series) {
	  var s = 0, i = -1, n = series.length, v;
	  while (++i < n) if (v = +series[i][1]) s += v;
	  return s;
	}
	
	var descending$1 = function(series) {
	  return ascending(series).reverse();
	};
	
	var insideOut = function(series) {
	  var n = series.length,
	      i,
	      j,
	      sums = series.map(sum),
	      order = none$1(series).sort(function(a, b) { return sums[b] - sums[a]; }),
	      top = 0,
	      bottom = 0,
	      tops = [],
	      bottoms = [];
	
	  for (i = 0; i < n; ++i) {
	    j = order[i];
	    if (top < bottom) {
	      top += sums[j];
	      tops.push(j);
	    } else {
	      bottom += sums[j];
	      bottoms.push(j);
	    }
	  }
	
	  return bottoms.reverse().concat(tops);
	};
	
	var reverse = function(series) {
	  return none$1(series).reverse();
	};
	
	exports.arc = arc;
	exports.area = area;
	exports.line = line;
	exports.pie = pie;
	exports.radialArea = radialArea;
	exports.radialLine = radialLine$1;
	exports.symbol = symbol;
	exports.symbols = symbols;
	exports.symbolCircle = circle;
	exports.symbolCross = cross;
	exports.symbolDiamond = diamond;
	exports.symbolSquare = square;
	exports.symbolStar = star;
	exports.symbolTriangle = triangle;
	exports.symbolWye = wye;
	exports.curveBasisClosed = basisClosed;
	exports.curveBasisOpen = basisOpen;
	exports.curveBasis = basis;
	exports.curveBundle = bundle;
	exports.curveCardinalClosed = cardinalClosed;
	exports.curveCardinalOpen = cardinalOpen;
	exports.curveCardinal = cardinal;
	exports.curveCatmullRomClosed = catmullRomClosed;
	exports.curveCatmullRomOpen = catmullRomOpen;
	exports.curveCatmullRom = catmullRom;
	exports.curveLinearClosed = linearClosed;
	exports.curveLinear = curveLinear;
	exports.curveMonotoneX = monotoneX;
	exports.curveMonotoneY = monotoneY;
	exports.curveNatural = natural;
	exports.curveStep = step;
	exports.curveStepAfter = stepAfter;
	exports.curveStepBefore = stepBefore;
	exports.stack = stack;
	exports.stackOffsetExpand = expand;
	exports.stackOffsetNone = none;
	exports.stackOffsetSilhouette = silhouette;
	exports.stackOffsetWiggle = wiggle;
	exports.stackOrderAscending = ascending;
	exports.stackOrderDescending = descending$1;
	exports.stackOrderInsideOut = insideOut;
	exports.stackOrderNone = none$1;
	exports.stackOrderReverse = reverse;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(307);


/***/ },
/* 42 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getHostProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var hostProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        hostProps[key] = props[key];
	      }
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventConstants = __webpack_require__(16);
	var EventPluginRegistry = __webpack_require__(61);
	var ReactEventEmitterMixin = __webpack_require__(323);
	var ViewportMetrics = __webpack_require__(122);
	
	var getVendorPrefixedEventName = __webpack_require__(354);
	var isEventSupported = __webpack_require__(78);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(35);
	var ViewportMetrics = __webpack_require__(122);
	
	var getEventModifierState = __webpack_require__(76);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	var DOMNamespaces = __webpack_require__(60);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(74);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 47 */
/***/ function(module, exports) {

	var core = module.exports = {version: '2.4.0'};
	if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(49)(function(){
	  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports = function(exec){
	  try {
	    return !!exec();
	  } catch(e){
	    return true;
	  }
	};

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports = function(it){
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ Version 1.1.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(225)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, function (exports,d3Color) { 'use strict';
	
	  function basis(t1, v0, v1, v2, v3) {
	    var t2 = t1 * t1, t3 = t2 * t1;
	    return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	        + (4 - 6 * t2 + 3 * t3) * v1
	        + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	        + t3 * v3) / 6;
	  }
	
	  function basis$1(values) {
	    var n = values.length - 1;
	    return function(t) {
	      var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	          v1 = values[i],
	          v2 = values[i + 1],
	          v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	          v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	      return basis((t - i / n) * n, v0, v1, v2, v3);
	    };
	  }
	
	  function basisClosed(values) {
	    var n = values.length;
	    return function(t) {
	      var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	          v0 = values[(i + n - 1) % n],
	          v1 = values[i % n],
	          v2 = values[(i + 1) % n],
	          v3 = values[(i + 2) % n];
	      return basis((t - i / n) * n, v0, v1, v2, v3);
	    };
	  }
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function linear(a, d) {
	    return function(t) {
	      return a + t * d;
	    };
	  }
	
	  function exponential(a, b, y) {
	    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	      return Math.pow(a + t * b, y);
	    };
	  }
	
	  function hue(a, b) {
	    var d = b - a;
	    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	  }
	
	  function gamma(y) {
	    return (y = +y) === 1 ? nogamma : function(a, b) {
	      return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	    };
	  }
	
	  function nogamma(a, b) {
	    var d = b - a;
	    return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	  }
	
	  var rgb$1 = (function rgbGamma(y) {
	    var color = gamma(y);
	
	    function rgb(start, end) {
	      var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	          g = color(start.g, end.g),
	          b = color(start.b, end.b),
	          opacity = color(start.opacity, end.opacity);
	      return function(t) {
	        start.r = r(t);
	        start.g = g(t);
	        start.b = b(t);
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    rgb.gamma = rgbGamma;
	
	    return rgb;
	  })(1);
	
	  function rgbSpline(spline) {
	    return function(colors) {
	      var n = colors.length,
	          r = new Array(n),
	          g = new Array(n),
	          b = new Array(n),
	          i, color;
	      for (i = 0; i < n; ++i) {
	        color = d3Color.rgb(colors[i]);
	        r[i] = color.r || 0;
	        g[i] = color.g || 0;
	        b[i] = color.b || 0;
	      }
	      r = spline(r);
	      g = spline(g);
	      b = spline(b);
	      color.opacity = 1;
	      return function(t) {
	        color.r = r(t);
	        color.g = g(t);
	        color.b = b(t);
	        return color + "";
	      };
	    };
	  }
	
	  var rgbBasis = rgbSpline(basis$1);
	  var rgbBasisClosed = rgbSpline(basisClosed);
	
	  function array(a, b) {
	    var nb = b ? b.length : 0,
	        na = a ? Math.min(nb, a.length) : 0,
	        x = new Array(nb),
	        c = new Array(nb),
	        i;
	
	    for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	    for (; i < nb; ++i) c[i] = b[i];
	
	    return function(t) {
	      for (i = 0; i < na; ++i) c[i] = x[i](t);
	      return c;
	    };
	  }
	
	  function date(a, b) {
	    var d = new Date;
	    return a = +a, b -= a, function(t) {
	      return d.setTime(a + b * t), d;
	    };
	  }
	
	  function number(a, b) {
	    return a = +a, b -= a, function(t) {
	      return a + b * t;
	    };
	  }
	
	  function object(a, b) {
	    var i = {},
	        c = {},
	        k;
	
	    if (a === null || typeof a !== "object") a = {};
	    if (b === null || typeof b !== "object") b = {};
	
	    for (k in b) {
	      if (k in a) {
	        i[k] = value(a[k], b[k]);
	      } else {
	        c[k] = b[k];
	      }
	    }
	
	    return function(t) {
	      for (k in i) c[k] = i[k](t);
	      return c;
	    };
	  }
	
	  var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g;
	  var reB = new RegExp(reA.source, "g");
	  function zero(b) {
	    return function() {
	      return b;
	    };
	  }
	
	  function one(b) {
	    return function(t) {
	      return b(t) + "";
	    };
	  }
	
	  function string(a, b) {
	    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	        am, // current match in a
	        bm, // current match in b
	        bs, // string preceding current number in b, if any
	        i = -1, // index in s
	        s = [], // string constants and placeholders
	        q = []; // number interpolators
	
	    // Coerce inputs to strings.
	    a = a + "", b = b + "";
	
	    // Interpolate pairs of numbers in a & b.
	    while ((am = reA.exec(a))
	        && (bm = reB.exec(b))) {
	      if ((bs = bm.index) > bi) { // a string precedes the next number in b
	        bs = b.slice(bi, bs);
	        if (s[i]) s[i] += bs; // coalesce with previous string
	        else s[++i] = bs;
	      }
	      if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	        if (s[i]) s[i] += bm; // coalesce with previous string
	        else s[++i] = bm;
	      } else { // interpolate non-matching numbers
	        s[++i] = null;
	        q.push({i: i, x: number(am, bm)});
	      }
	      bi = reB.lastIndex;
	    }
	
	    // Add remains of b.
	    if (bi < b.length) {
	      bs = b.slice(bi);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	
	    // Special optimization for only a single match.
	    // Otherwise, interpolate each of the numbers and rejoin the string.
	    return s.length < 2 ? (q[0]
	        ? one(q[0].x)
	        : zero(b))
	        : (b = q.length, function(t) {
	            for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	            return s.join("");
	          });
	  }
	
	  function value(a, b) {
	    var t = typeof b, c;
	    return b == null || t === "boolean" ? constant(b)
	        : (t === "number" ? number
	        : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb$1) : string)
	        : b instanceof d3Color.color ? rgb$1
	        : b instanceof Date ? date
	        : Array.isArray(b) ? array
	        : isNaN(b) ? object
	        : number)(a, b);
	  }
	
	  function round(a, b) {
	    return a = +a, b -= a, function(t) {
	      return Math.round(a + b * t);
	    };
	  }
	
	  var degrees = 180 / Math.PI;
	
	  var identity = {
	    translateX: 0,
	    translateY: 0,
	    rotate: 0,
	    skewX: 0,
	    scaleX: 1,
	    scaleY: 1
	  };
	
	  function decompose(a, b, c, d, e, f) {
	    var scaleX, scaleY, skewX;
	    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	    return {
	      translateX: e,
	      translateY: f,
	      rotate: Math.atan2(b, a) * degrees,
	      skewX: Math.atan(skewX) * degrees,
	      scaleX: scaleX,
	      scaleY: scaleY
	    };
	  }
	
	  var cssNode;
	  var cssRoot;
	  var cssView;
	  var svgNode;
	  function parseCss(value) {
	    if (value === "none") return identity;
	    if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	    cssNode.style.transform = value;
	    value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	    cssRoot.removeChild(cssNode);
	    value = value.slice(7, -1).split(",");
	    return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	  }
	
	  function parseSvg(value) {
	    if (value == null) return identity;
	    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	    svgNode.setAttribute("transform", value);
	    if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	    value = value.matrix;
	    return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	  }
	
	  function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	    function pop(s) {
	      return s.length ? s.pop() + " " : "";
	    }
	
	    function translate(xa, ya, xb, yb, s, q) {
	      if (xa !== xb || ya !== yb) {
	        var i = s.push("translate(", null, pxComma, null, pxParen);
	        q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	      } else if (xb || yb) {
	        s.push("translate(" + xb + pxComma + yb + pxParen);
	      }
	    }
	
	    function rotate(a, b, s, q) {
	      if (a !== b) {
	        if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	        q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	      } else if (b) {
	        s.push(pop(s) + "rotate(" + b + degParen);
	      }
	    }
	
	    function skewX(a, b, s, q) {
	      if (a !== b) {
	        q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	      } else if (b) {
	        s.push(pop(s) + "skewX(" + b + degParen);
	      }
	    }
	
	    function scale(xa, ya, xb, yb, s, q) {
	      if (xa !== xb || ya !== yb) {
	        var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	        q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	      } else if (xb !== 1 || yb !== 1) {
	        s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	      }
	    }
	
	    return function(a, b) {
	      var s = [], // string constants and placeholders
	          q = []; // number interpolators
	      a = parse(a), b = parse(b);
	      translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	      rotate(a.rotate, b.rotate, s, q);
	      skewX(a.skewX, b.skewX, s, q);
	      scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	      a = b = null; // gc
	      return function(t) {
	        var i = -1, n = q.length, o;
	        while (++i < n) s[(o = q[i]).i] = o.x(t);
	        return s.join("");
	      };
	    };
	  }
	
	  var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	  var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	  var rho = Math.SQRT2;
	  var rho2 = 2;
	  var rho4 = 4;
	  var epsilon2 = 1e-12;
	  function cosh(x) {
	    return ((x = Math.exp(x)) + 1 / x) / 2;
	  }
	
	  function sinh(x) {
	    return ((x = Math.exp(x)) - 1 / x) / 2;
	  }
	
	  function tanh(x) {
	    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	  }
	
	  // p0 = [ux0, uy0, w0]
	  // p1 = [ux1, uy1, w1]
	  function zoom(p0, p1) {
	    var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	        ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	        dx = ux1 - ux0,
	        dy = uy1 - uy0,
	        d2 = dx * dx + dy * dy,
	        i,
	        S;
	
	    // Special case for u0 ≅ u1.
	    if (d2 < epsilon2) {
	      S = Math.log(w1 / w0) / rho;
	      i = function(t) {
	        return [
	          ux0 + t * dx,
	          uy0 + t * dy,
	          w0 * Math.exp(rho * t * S)
	        ];
	      }
	    }
	
	    // General case.
	    else {
	      var d1 = Math.sqrt(d2),
	          b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	          b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	          r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	          r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	      S = (r1 - r0) / rho;
	      i = function(t) {
	        var s = t * S,
	            coshr0 = cosh(r0),
	            u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	        return [
	          ux0 + u * dx,
	          uy0 + u * dy,
	          w0 * coshr0 / cosh(rho * s + r0)
	        ];
	      }
	    }
	
	    i.duration = S * 1000;
	
	    return i;
	  }
	
	  function hsl$1(hue) {
	    return function(start, end) {
	      var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(t);
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	  }
	
	  var hsl$2 = hsl$1(hue);
	  var hslLong = hsl$1(nogamma);
	
	  function lab$1(start, end) {
	    var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	        a = nogamma(start.a, end.a),
	        b = nogamma(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.l = l(t);
	      start.a = a(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  function hcl$1(hue) {
	    return function(start, end) {
	      var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	          c = nogamma(start.c, end.c),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.c = c(t);
	        start.l = l(t);
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	  }
	
	  var hcl$2 = hcl$1(hue);
	  var hclLong = hcl$1(nogamma);
	
	  function cubehelix$1(hue) {
	    return (function cubehelixGamma(y) {
	      y = +y;
	
	      function cubehelix(start, end) {
	        var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	            s = nogamma(start.s, end.s),
	            l = nogamma(start.l, end.l),
	            opacity = nogamma(start.opacity, end.opacity);
	        return function(t) {
	          start.h = h(t);
	          start.s = s(t);
	          start.l = l(Math.pow(t, y));
	          start.opacity = opacity(t);
	          return start + "";
	        };
	      }
	
	      cubehelix.gamma = cubehelixGamma;
	
	      return cubehelix;
	    })(1);
	  }
	
	  var cubehelix$2 = cubehelix$1(hue);
	  var cubehelixLong = cubehelix$1(nogamma);
	
	  function quantize(interpolator, n) {
	    var samples = new Array(n);
	    for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	    return samples;
	  }
	
	  exports.interpolate = value;
	  exports.interpolateArray = array;
	  exports.interpolateBasis = basis$1;
	  exports.interpolateBasisClosed = basisClosed;
	  exports.interpolateDate = date;
	  exports.interpolateNumber = number;
	  exports.interpolateObject = object;
	  exports.interpolateRound = round;
	  exports.interpolateString = string;
	  exports.interpolateTransformCss = interpolateTransformCss;
	  exports.interpolateTransformSvg = interpolateTransformSvg;
	  exports.interpolateZoom = zoom;
	  exports.interpolateRgb = rgb$1;
	  exports.interpolateRgbBasis = rgbBasis;
	  exports.interpolateRgbBasisClosed = rgbBasisClosed;
	  exports.interpolateHsl = hsl$2;
	  exports.interpolateHslLong = hslLong;
	  exports.interpolateLab = lab$1;
	  exports.interpolateHcl = hcl$2;
	  exports.interpolateHclLong = hclLong;
	  exports.interpolateCubehelix = cubehelix$2;
	  exports.interpolateCubehelixLong = cubehelixLong;
	  exports.quantize = quantize;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 52 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 53 */
/***/ function(module, exports) {

	module.exports = {
		"dateTime": "%A, der %e. %B %Y, %X",
		"date": "%d.%m.%Y",
		"time": "%H:%M:%S",
		"periods": [
			"vormittags",
			"nachmittags"
		],
		"days": [
			"Sonntag",
			"Montag",
			"Dienstag",
			"Mittwoch",
			"Donnerstag",
			"Freitag",
			"Samstag"
		],
		"shortDays": [
			"So",
			"Mo",
			"Di",
			"Mi",
			"Do",
			"Fr",
			"Sa"
		],
		"months": [
			"Januar",
			"Februar",
			"März",
			"April",
			"Mai",
			"Juni",
			"Juli",
			"August",
			"September",
			"Oktober",
			"November",
			"Dezember"
		],
		"shortMonths": [
			"Jan",
			"Feb",
			"Mrz",
			"Apr",
			"Mai",
			"Jun",
			"Jul",
			"Aug",
			"Sep",
			"Okt",
			"Nov",
			"Dez"
		],
		"decimal": ",",
		"thousands": "'",
		"grouping": [
			3
		],
		"currency": [
			"",
			" CHF"
		]
	};

/***/ },
/* 54 */
/***/ function(module, exports) {

	module.exports = [
		{
			"": 48,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1635,
			"SteuerEinkommen_P25": 18.6,
			"SteuerEinkommen_Median": 39.8,
			"SteuerEinkommen_P75": 65.1,
			"eink_arm_Sum": 383,
			"ant_eink_arm": 23.4,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 49,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 286,
			"SteuerEinkommen_P25": 48,
			"SteuerEinkommen_Median": 80.4,
			"SteuerEinkommen_P75": 127.85,
			"eink_arm_Sum": 40,
			"ant_eink_arm": 14,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 70,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 321,
			"SteuerEinkommen_P25": 12.4,
			"SteuerEinkommen_Median": 31.05,
			"SteuerEinkommen_P75": 55.2,
			"eink_arm_Sum": 99,
			"ant_eink_arm": 30.8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 71,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 76,
			"SteuerEinkommen_P25": 52,
			"SteuerEinkommen_Median": 89.2,
			"SteuerEinkommen_P75": 178.7,
			"eink_arm_Sum": 8,
			"ant_eink_arm": 10.5,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 91,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1206,
			"SteuerEinkommen_P25": 7.7,
			"SteuerEinkommen_Median": 21.5,
			"SteuerEinkommen_P75": 45.7,
			"eink_arm_Sum": 468,
			"ant_eink_arm": 38.8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 92,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 150,
			"SteuerEinkommen_P25": 52.22,
			"SteuerEinkommen_Median": 97,
			"SteuerEinkommen_P75": 150.7,
			"eink_arm_Sum": 18,
			"ant_eink_arm": 12,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 111,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1305,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 6.2,
			"SteuerEinkommen_P75": 20.3,
			"eink_arm_Sum": 925,
			"ant_eink_arm": 70.9,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 112,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 115,
			"SteuerEinkommen_P25": 31.4,
			"SteuerEinkommen_Median": 63.75,
			"SteuerEinkommen_P75": 93.1,
			"eink_arm_Sum": 29,
			"ant_eink_arm": 25.2,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 156,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6234,
			"SteuerEinkommen_P25": 19.8,
			"SteuerEinkommen_Median": 36.8,
			"SteuerEinkommen_P75": 55.4,
			"eink_arm_Sum": 1350,
			"ant_eink_arm": 21.7,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 157,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2756,
			"SteuerEinkommen_P25": 48.4,
			"SteuerEinkommen_Median": 67.8,
			"SteuerEinkommen_P75": 94.95,
			"eink_arm_Sum": 296,
			"ant_eink_arm": 10.7,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 180,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1498,
			"SteuerEinkommen_P25": 19.1,
			"SteuerEinkommen_Median": 33.3,
			"SteuerEinkommen_P75": 50.55,
			"eink_arm_Sum": 345,
			"ant_eink_arm": 23,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 181,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 975,
			"SteuerEinkommen_P25": 47.55,
			"SteuerEinkommen_Median": 66.2,
			"SteuerEinkommen_P75": 91.4,
			"eink_arm_Sum": 96,
			"ant_eink_arm": 9.8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 203,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3438,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 43.4,
			"SteuerEinkommen_P75": 67.7,
			"eink_arm_Sum": 710,
			"ant_eink_arm": 20.7,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 204,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1192,
			"SteuerEinkommen_P25": 53,
			"SteuerEinkommen_Median": 80.6,
			"SteuerEinkommen_P75": 131.4,
			"eink_arm_Sum": 138,
			"ant_eink_arm": 11.6,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 249,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6175,
			"SteuerEinkommen_P25": 20.4,
			"SteuerEinkommen_Median": 36.8,
			"SteuerEinkommen_P75": 55,
			"eink_arm_Sum": 1257,
			"ant_eink_arm": 20.4,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 250,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2036,
			"SteuerEinkommen_P25": 40,
			"SteuerEinkommen_Median": 62.1,
			"SteuerEinkommen_P75": 90,
			"eink_arm_Sum": 332,
			"ant_eink_arm": 16.3,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 272,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3009,
			"SteuerEinkommen_P25": 12.2,
			"SteuerEinkommen_Median": 26.5,
			"SteuerEinkommen_P75": 43.4,
			"eink_arm_Sum": 971,
			"ant_eink_arm": 32.3,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 273,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1945,
			"SteuerEinkommen_P25": 46.1,
			"SteuerEinkommen_Median": 61.5,
			"SteuerEinkommen_P75": 79.9,
			"eink_arm_Sum": 186,
			"ant_eink_arm": 9.6,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 294,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8866,
			"SteuerEinkommen_P25": 17.4,
			"SteuerEinkommen_Median": 32.2,
			"SteuerEinkommen_P75": 49.2,
			"eink_arm_Sum": 2203,
			"ant_eink_arm": 24.8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 295,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2787,
			"SteuerEinkommen_P25": 37,
			"SteuerEinkommen_Median": 55.1,
			"SteuerEinkommen_P75": 74.2,
			"eink_arm_Sum": 501,
			"ant_eink_arm": 18,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 341,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1958,
			"SteuerEinkommen_P25": 15.7,
			"SteuerEinkommen_Median": 33.1,
			"SteuerEinkommen_P75": 52.6,
			"eink_arm_Sum": 537,
			"ant_eink_arm": 27.4,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 342,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 400,
			"SteuerEinkommen_P25": 33.6,
			"SteuerEinkommen_Median": 54.1,
			"SteuerEinkommen_P75": 76.4,
			"eink_arm_Sum": 88,
			"ant_eink_arm": 22,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 363,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5066,
			"SteuerEinkommen_P25": 12.8,
			"SteuerEinkommen_Median": 28.4,
			"SteuerEinkommen_P75": 47.8,
			"eink_arm_Sum": 1639,
			"ant_eink_arm": 32.4,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 364,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1071,
			"SteuerEinkommen_P25": 33.3,
			"SteuerEinkommen_Median": 51.4,
			"SteuerEinkommen_P75": 73.05,
			"eink_arm_Sum": 243,
			"ant_eink_arm": 22.7,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 386,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4855,
			"SteuerEinkommen_P25": 15,
			"SteuerEinkommen_Median": 27.2,
			"SteuerEinkommen_P75": 41.85,
			"eink_arm_Sum": 1399,
			"ant_eink_arm": 28.8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 387,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2012,
			"SteuerEinkommen_P25": 35.8,
			"SteuerEinkommen_Median": 51.5,
			"SteuerEinkommen_P75": 69,
			"eink_arm_Sum": 381,
			"ant_eink_arm": 18.9,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 432,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4213,
			"SteuerEinkommen_P25": 15.4,
			"SteuerEinkommen_Median": 31.8,
			"SteuerEinkommen_P75": 48.2,
			"eink_arm_Sum": 1160,
			"ant_eink_arm": 27.5,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 433,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1132,
			"SteuerEinkommen_P25": 37.7,
			"SteuerEinkommen_Median": 54,
			"SteuerEinkommen_P75": 72.9,
			"eink_arm_Sum": 218,
			"ant_eink_arm": 19.3,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 455,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 787,
			"SteuerEinkommen_P25": 18.2,
			"SteuerEinkommen_Median": 35.5,
			"SteuerEinkommen_P75": 56.8,
			"eink_arm_Sum": 186,
			"ant_eink_arm": 23.6,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 456,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 254,
			"SteuerEinkommen_P25": 34.9,
			"SteuerEinkommen_Median": 55.45,
			"SteuerEinkommen_P75": 77.9,
			"eink_arm_Sum": 50,
			"ant_eink_arm": 19.7,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 499,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8298,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 36.2,
			"SteuerEinkommen_P75": 56.2,
			"eink_arm_Sum": 1919,
			"ant_eink_arm": 23.1,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 500,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3003,
			"SteuerEinkommen_P25": 45.6,
			"SteuerEinkommen_Median": 63.8,
			"SteuerEinkommen_P75": 89.8,
			"eink_arm_Sum": 357,
			"ant_eink_arm": 11.9,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 522,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4090,
			"SteuerEinkommen_P25": 19.6,
			"SteuerEinkommen_Median": 41.55,
			"SteuerEinkommen_P75": 66.5,
			"eink_arm_Sum": 931,
			"ant_eink_arm": 22.8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 523,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1396,
			"SteuerEinkommen_P25": 58.7,
			"SteuerEinkommen_Median": 91,
			"SteuerEinkommen_P75": 149,
			"eink_arm_Sum": 112,
			"ant_eink_arm": 8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 569,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2756,
			"SteuerEinkommen_P25": 17.1,
			"SteuerEinkommen_Median": 46.4,
			"SteuerEinkommen_P75": 77.6,
			"eink_arm_Sum": 697,
			"ant_eink_arm": 25.3,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 570,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1196,
			"SteuerEinkommen_P25": 70.4,
			"SteuerEinkommen_Median": 113.3,
			"SteuerEinkommen_P75": 199.8,
			"eink_arm_Sum": 86,
			"ant_eink_arm": 7.2,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 592,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4460,
			"SteuerEinkommen_P25": 18.2,
			"SteuerEinkommen_Median": 41.1,
			"SteuerEinkommen_P75": 66.1,
			"eink_arm_Sum": 1080,
			"ant_eink_arm": 24.2,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 593,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1422,
			"SteuerEinkommen_P25": 58.35,
			"SteuerEinkommen_Median": 93.8,
			"SteuerEinkommen_P75": 153.55,
			"eink_arm_Sum": 140,
			"ant_eink_arm": 9.8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 614,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3096,
			"SteuerEinkommen_P25": 18.1,
			"SteuerEinkommen_Median": 38.9,
			"SteuerEinkommen_P75": 61,
			"eink_arm_Sum": 740,
			"ant_eink_arm": 23.9,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 615,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 964,
			"SteuerEinkommen_P25": 50.1,
			"SteuerEinkommen_Median": 79.5,
			"SteuerEinkommen_P75": 135.6,
			"eink_arm_Sum": 106,
			"ant_eink_arm": 11,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 635,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3565,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 42.6,
			"SteuerEinkommen_P75": 64.7,
			"eink_arm_Sum": 797,
			"ant_eink_arm": 22.4,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 636,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1968,
			"SteuerEinkommen_P25": 57.3,
			"SteuerEinkommen_Median": 85.2,
			"SteuerEinkommen_P75": 129.1,
			"eink_arm_Sum": 179,
			"ant_eink_arm": 9.1,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 682,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2660,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 42.2,
			"SteuerEinkommen_P75": 65.4,
			"eink_arm_Sum": 527,
			"ant_eink_arm": 19.8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 683,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 504,
			"SteuerEinkommen_P25": 47,
			"SteuerEinkommen_Median": 75.8,
			"SteuerEinkommen_P75": 120.8,
			"eink_arm_Sum": 63,
			"ant_eink_arm": 12.5,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 705,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2744,
			"SteuerEinkommen_P25": 20.3,
			"SteuerEinkommen_Median": 40.2,
			"SteuerEinkommen_P75": 62,
			"eink_arm_Sum": 583,
			"ant_eink_arm": 21.2,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 706,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 639,
			"SteuerEinkommen_P25": 50.5,
			"SteuerEinkommen_Median": 77.5,
			"SteuerEinkommen_P75": 115.7,
			"eink_arm_Sum": 77,
			"ant_eink_arm": 12.1,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 727,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1872,
			"SteuerEinkommen_P25": 17.5,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 60.9,
			"eink_arm_Sum": 463,
			"ant_eink_arm": 24.7,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 728,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 731,
			"SteuerEinkommen_P25": 55.4,
			"SteuerEinkommen_Median": 78.75,
			"SteuerEinkommen_P75": 127.4,
			"eink_arm_Sum": 65,
			"ant_eink_arm": 8.9,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 773,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6166,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 34.9,
			"SteuerEinkommen_P75": 51,
			"eink_arm_Sum": 1298,
			"ant_eink_arm": 21.1,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 774,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3203,
			"SteuerEinkommen_P25": 45.6,
			"SteuerEinkommen_Median": 61,
			"SteuerEinkommen_P75": 83.9,
			"eink_arm_Sum": 352,
			"ant_eink_arm": 11,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 795,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9973,
			"SteuerEinkommen_P25": 18.2,
			"SteuerEinkommen_Median": 33.4,
			"SteuerEinkommen_P75": 49.4,
			"eink_arm_Sum": 2377,
			"ant_eink_arm": 23.8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 796,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5344,
			"SteuerEinkommen_P25": 43.1,
			"SteuerEinkommen_Median": 58.2,
			"SteuerEinkommen_P75": 78.3,
			"eink_arm_Sum": 663,
			"ant_eink_arm": 12.4,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 841,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7594,
			"SteuerEinkommen_P25": 21.6,
			"SteuerEinkommen_Median": 42.1,
			"SteuerEinkommen_P75": 61.9,
			"eink_arm_Sum": 1477,
			"ant_eink_arm": 19.4,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 842,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4035,
			"SteuerEinkommen_P25": 54.2,
			"SteuerEinkommen_Median": 74.9,
			"SteuerEinkommen_P75": 106.4,
			"eink_arm_Sum": 364,
			"ant_eink_arm": 9,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 864,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6579,
			"SteuerEinkommen_P25": 18.1,
			"SteuerEinkommen_Median": 34.2,
			"SteuerEinkommen_P75": 52.4,
			"eink_arm_Sum": 1568,
			"ant_eink_arm": 23.8,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 865,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2078,
			"SteuerEinkommen_P25": 41.9,
			"SteuerEinkommen_Median": 59.4,
			"SteuerEinkommen_P75": 81.9,
			"eink_arm_Sum": 317,
			"ant_eink_arm": 15.3,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 911,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5664,
			"SteuerEinkommen_P25": 17.5,
			"SteuerEinkommen_Median": 32.8,
			"SteuerEinkommen_P75": 48.6,
			"eink_arm_Sum": 1389,
			"ant_eink_arm": 24.5,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 912,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3678,
			"SteuerEinkommen_P25": 44.4,
			"SteuerEinkommen_Median": 60.6,
			"SteuerEinkommen_P75": 81.3,
			"eink_arm_Sum": 428,
			"ant_eink_arm": 11.6,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 935,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6599,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 37,
			"SteuerEinkommen_P75": 53.9,
			"eink_arm_Sum": 1389,
			"ant_eink_arm": 21,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 936,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2556,
			"SteuerEinkommen_P25": 42.9,
			"SteuerEinkommen_Median": 63.85,
			"SteuerEinkommen_P75": 89.7,
			"eink_arm_Sum": 332,
			"ant_eink_arm": 13,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 957,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5920,
			"SteuerEinkommen_P25": 17.7,
			"SteuerEinkommen_Median": 32,
			"SteuerEinkommen_P75": 48.3,
			"eink_arm_Sum": 1449,
			"ant_eink_arm": 24.5,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 958,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3301,
			"SteuerEinkommen_P25": 40,
			"SteuerEinkommen_Median": 56.7,
			"SteuerEinkommen_P75": 77.7,
			"eink_arm_Sum": 473,
			"ant_eink_arm": 14.3,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1004,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1728,
			"SteuerEinkommen_P25": 14.9,
			"SteuerEinkommen_Median": 27.1,
			"SteuerEinkommen_P75": 41.5,
			"eink_arm_Sum": 519,
			"ant_eink_arm": 30,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1005,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1345,
			"SteuerEinkommen_P25": 39.4,
			"SteuerEinkommen_Median": 53.6,
			"SteuerEinkommen_P75": 69.6,
			"eink_arm_Sum": 207,
			"ant_eink_arm": 15.4,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1025,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3697,
			"SteuerEinkommen_P25": 17.5,
			"SteuerEinkommen_Median": 30,
			"SteuerEinkommen_P75": 45,
			"eink_arm_Sum": 913,
			"ant_eink_arm": 24.7,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1026,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1897,
			"SteuerEinkommen_P25": 39.9,
			"SteuerEinkommen_Median": 56.8,
			"SteuerEinkommen_P75": 75.6,
			"eink_arm_Sum": 308,
			"ant_eink_arm": 16.2,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1047,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3597,
			"SteuerEinkommen_P25": 14.9,
			"SteuerEinkommen_Median": 26.6,
			"SteuerEinkommen_P75": 42,
			"eink_arm_Sum": 1053,
			"ant_eink_arm": 29.3,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1048,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2129,
			"SteuerEinkommen_P25": 40.4,
			"SteuerEinkommen_Median": 55,
			"SteuerEinkommen_P75": 70.9,
			"eink_arm_Sum": 274,
			"ant_eink_arm": 12.9,
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1117,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1663,
			"SteuerEinkommen_P25": 19.1,
			"SteuerEinkommen_Median": 42.3,
			"SteuerEinkommen_P75": 70,
			"eink_arm_Sum": 400,
			"ant_eink_arm": 24.1,
			"SozialQuote": 3.9,
			"SozialBeziehende": 105,
			"Mietpreis": "NA"
		},
		{
			"": 1118,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 277,
			"SteuerEinkommen_P25": 51.8,
			"SteuerEinkommen_Median": 85.45,
			"SteuerEinkommen_P75": 131.6,
			"eink_arm_Sum": 42,
			"ant_eink_arm": 15.2,
			"SozialQuote": 3.9,
			"SozialBeziehende": 105,
			"Mietpreis": "NA"
		},
		{
			"": 1140,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 327,
			"SteuerEinkommen_P25": 13.55,
			"SteuerEinkommen_Median": 32.35,
			"SteuerEinkommen_P75": 59.45,
			"eink_arm_Sum": 96,
			"ant_eink_arm": 29.4,
			"SozialQuote": 3.4,
			"SozialBeziehende": 20,
			"Mietpreis": "NA"
		},
		{
			"": 1141,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 72,
			"SteuerEinkommen_P25": 53.35,
			"SteuerEinkommen_Median": 96.65,
			"SteuerEinkommen_P75": 188,
			"eink_arm_Sum": 8,
			"ant_eink_arm": 11.1,
			"SozialQuote": 3.4,
			"SozialBeziehende": 20,
			"Mietpreis": "NA"
		},
		{
			"": 1161,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1214,
			"SteuerEinkommen_P25": 3.35,
			"SteuerEinkommen_Median": 20.95,
			"SteuerEinkommen_P75": 46.05,
			"eink_arm_Sum": 518,
			"ant_eink_arm": 42.7,
			"SozialQuote": 0.5,
			"SozialBeziehende": 8,
			"Mietpreis": "NA"
		},
		{
			"": 1162,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 150,
			"SteuerEinkommen_P25": 41.7,
			"SteuerEinkommen_Median": 94.4,
			"SteuerEinkommen_P75": 172.8,
			"eink_arm_Sum": 28,
			"ant_eink_arm": 18.7,
			"SozialQuote": 0.5,
			"SozialBeziehende": 8,
			"Mietpreis": "NA"
		},
		{
			"": 1183,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1338,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 4.35,
			"SteuerEinkommen_P75": 20.2,
			"eink_arm_Sum": 982,
			"ant_eink_arm": 73.4,
			"SozialQuote": 3.9,
			"SozialBeziehende": 74,
			"Mietpreis": "NA"
		},
		{
			"": 1184,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 114,
			"SteuerEinkommen_P25": 37.2,
			"SteuerEinkommen_Median": 72,
			"SteuerEinkommen_P75": 98.7,
			"eink_arm_Sum": 25,
			"ant_eink_arm": 21.9,
			"SozialQuote": 3.9,
			"SozialBeziehende": 74,
			"Mietpreis": "NA"
		},
		{
			"": 1228,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6325,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 38,
			"SteuerEinkommen_P75": 58.4,
			"eink_arm_Sum": 1417,
			"ant_eink_arm": 22.4,
			"SozialQuote": 2.9,
			"SozialBeziehende": 442,
			"Mietpreis": "NA"
		},
		{
			"": 1229,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2714,
			"SteuerEinkommen_P25": 51,
			"SteuerEinkommen_Median": 69.8,
			"SteuerEinkommen_P75": 100,
			"eink_arm_Sum": 272,
			"ant_eink_arm": 10,
			"SozialQuote": 2.9,
			"SozialBeziehende": 442,
			"Mietpreis": "NA"
		},
		{
			"": 1252,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1512,
			"SteuerEinkommen_P25": 18.4,
			"SteuerEinkommen_Median": 32.85,
			"SteuerEinkommen_P75": 51.9,
			"eink_arm_Sum": 371,
			"ant_eink_arm": 24.5,
			"SozialQuote": 2.9,
			"SozialBeziehende": 130,
			"Mietpreis": "NA"
		},
		{
			"": 1253,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 968,
			"SteuerEinkommen_P25": 48.6,
			"SteuerEinkommen_Median": 69.4,
			"SteuerEinkommen_P75": 93.5,
			"eink_arm_Sum": 84,
			"ant_eink_arm": 8.7,
			"SozialQuote": 2.9,
			"SozialBeziehende": 130,
			"Mietpreis": "NA"
		},
		{
			"": 1275,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3485,
			"SteuerEinkommen_P25": 21.6,
			"SteuerEinkommen_Median": 45.8,
			"SteuerEinkommen_P75": 71.2,
			"eink_arm_Sum": 708,
			"ant_eink_arm": 20.3,
			"SozialQuote": 2.5,
			"SozialBeziehende": 187,
			"Mietpreis": "NA"
		},
		{
			"": 1276,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1201,
			"SteuerEinkommen_P25": 55.4,
			"SteuerEinkommen_Median": 87.1,
			"SteuerEinkommen_P75": 142.7,
			"eink_arm_Sum": 124,
			"ant_eink_arm": 10.3,
			"SozialQuote": 2.5,
			"SozialBeziehende": 187,
			"Mietpreis": "NA"
		},
		{
			"": 1320,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6276,
			"SteuerEinkommen_P25": 21.1,
			"SteuerEinkommen_Median": 38.9,
			"SteuerEinkommen_P75": 57.4,
			"eink_arm_Sum": 1279,
			"ant_eink_arm": 20.4,
			"SozialQuote": 6.2,
			"SozialBeziehende": 810,
			"Mietpreis": "NA"
		},
		{
			"": 1321,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1962,
			"SteuerEinkommen_P25": 42.7,
			"SteuerEinkommen_Median": 64.6,
			"SteuerEinkommen_P75": 93,
			"eink_arm_Sum": 312,
			"ant_eink_arm": 15.9,
			"SozialQuote": 6.2,
			"SozialBeziehende": 810,
			"Mietpreis": "NA"
		},
		{
			"": 1343,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2959,
			"SteuerEinkommen_P25": 12.2,
			"SteuerEinkommen_Median": 28,
			"SteuerEinkommen_P75": 44.5,
			"eink_arm_Sum": 964,
			"ant_eink_arm": 32.6,
			"SozialQuote": 4.9,
			"SozialBeziehende": 471,
			"Mietpreis": "NA"
		},
		{
			"": 1344,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1905,
			"SteuerEinkommen_P25": 47.3,
			"SteuerEinkommen_Median": 63.4,
			"SteuerEinkommen_P75": 82.3,
			"eink_arm_Sum": 192,
			"ant_eink_arm": 10.1,
			"SozialQuote": 4.9,
			"SozialBeziehende": 471,
			"Mietpreis": "NA"
		},
		{
			"": 1365,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8917,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 34.1,
			"SteuerEinkommen_P75": 51.5,
			"eink_arm_Sum": 2202,
			"ant_eink_arm": 24.7,
			"SozialQuote": 7.4,
			"SozialBeziehende": 1372,
			"Mietpreis": "NA"
		},
		{
			"": 1366,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2732,
			"SteuerEinkommen_P25": 38.2,
			"SteuerEinkommen_Median": 56.4,
			"SteuerEinkommen_P75": 75.3,
			"eink_arm_Sum": 503,
			"ant_eink_arm": 18.4,
			"SozialQuote": 7.4,
			"SozialBeziehende": 1372,
			"Mietpreis": "NA"
		},
		{
			"": 1411,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1913,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 35.1,
			"SteuerEinkommen_P75": 55.1,
			"eink_arm_Sum": 509,
			"ant_eink_arm": 26.6,
			"SozialQuote": 8.4,
			"SozialBeziehende": 291,
			"Mietpreis": "NA"
		},
		{
			"": 1412,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 399,
			"SteuerEinkommen_P25": 35.8,
			"SteuerEinkommen_Median": 56.2,
			"SteuerEinkommen_P75": 80.4,
			"eink_arm_Sum": 90,
			"ant_eink_arm": 22.6,
			"SozialQuote": 8.4,
			"SozialBeziehende": 291,
			"Mietpreis": "NA"
		},
		{
			"": 1434,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5060,
			"SteuerEinkommen_P25": 15,
			"SteuerEinkommen_Median": 30.9,
			"SteuerEinkommen_P75": 50,
			"eink_arm_Sum": 1532,
			"ant_eink_arm": 30.3,
			"SozialQuote": 11.1,
			"SozialBeziehende": 977,
			"Mietpreis": "NA"
		},
		{
			"": 1435,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1023,
			"SteuerEinkommen_P25": 34.7,
			"SteuerEinkommen_Median": 53,
			"SteuerEinkommen_P75": 75.9,
			"eink_arm_Sum": 235,
			"ant_eink_arm": 23,
			"SozialQuote": 11.1,
			"SozialBeziehende": 977,
			"Mietpreis": "NA"
		},
		{
			"": 1456,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4956,
			"SteuerEinkommen_P25": 15.6,
			"SteuerEinkommen_Median": 28.1,
			"SteuerEinkommen_P75": 43.2,
			"eink_arm_Sum": 1445,
			"ant_eink_arm": 29.2,
			"SozialQuote": 9.2,
			"SozialBeziehende": 1074,
			"Mietpreis": "NA"
		},
		{
			"": 1457,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1964,
			"SteuerEinkommen_P25": 37.4,
			"SteuerEinkommen_Median": 53.4,
			"SteuerEinkommen_P75": 70,
			"eink_arm_Sum": 381,
			"ant_eink_arm": 19.4,
			"SozialQuote": 9.2,
			"SozialBeziehende": 1074,
			"Mietpreis": "NA"
		},
		{
			"": 1502,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4379,
			"SteuerEinkommen_P25": 17.7,
			"SteuerEinkommen_Median": 34.5,
			"SteuerEinkommen_P75": 51.5,
			"eink_arm_Sum": 1124,
			"ant_eink_arm": 25.7,
			"SozialQuote": 9.1,
			"SozialBeziehende": 767,
			"Mietpreis": "NA"
		},
		{
			"": 1503,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1109,
			"SteuerEinkommen_P25": 40,
			"SteuerEinkommen_Median": 55.95,
			"SteuerEinkommen_P75": 75.8,
			"eink_arm_Sum": 191,
			"ant_eink_arm": 17.2,
			"SozialQuote": 9.1,
			"SozialBeziehende": 767,
			"Mietpreis": "NA"
		},
		{
			"": 1525,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 843,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 40.4,
			"SteuerEinkommen_P75": 62.3,
			"eink_arm_Sum": 179,
			"ant_eink_arm": 21.2,
			"SozialQuote": 7,
			"SozialBeziehende": 119,
			"Mietpreis": "NA"
		},
		{
			"": 1526,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 253,
			"SteuerEinkommen_P25": 40.4,
			"SteuerEinkommen_Median": 59.1,
			"SteuerEinkommen_P75": 80.7,
			"eink_arm_Sum": 43,
			"ant_eink_arm": 17,
			"SozialQuote": 7,
			"SozialBeziehende": 119,
			"Mietpreis": "NA"
		},
		{
			"": 1570,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8262,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 37.6,
			"SteuerEinkommen_P75": 58.2,
			"eink_arm_Sum": 1923,
			"ant_eink_arm": 23.3,
			"SozialQuote": 3.5,
			"SozialBeziehende": 624,
			"Mietpreis": "NA"
		},
		{
			"": 1571,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2897,
			"SteuerEinkommen_P25": 46.7,
			"SteuerEinkommen_Median": 66.3,
			"SteuerEinkommen_P75": 94.1,
			"eink_arm_Sum": 343,
			"ant_eink_arm": 11.8,
			"SozialQuote": 3.5,
			"SozialBeziehende": 624,
			"Mietpreis": "NA"
		},
		{
			"": 1593,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4094,
			"SteuerEinkommen_P25": 20.7,
			"SteuerEinkommen_Median": 43.6,
			"SteuerEinkommen_P75": 70.3,
			"eink_arm_Sum": 880,
			"ant_eink_arm": 21.5,
			"SozialQuote": 1.5,
			"SozialBeziehende": 131,
			"Mietpreis": "NA"
		},
		{
			"": 1594,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1388,
			"SteuerEinkommen_P25": 65,
			"SteuerEinkommen_Median": 97.2,
			"SteuerEinkommen_P75": 161,
			"eink_arm_Sum": 110,
			"ant_eink_arm": 7.9,
			"SozialQuote": 1.5,
			"SozialBeziehende": 131,
			"Mietpreis": "NA"
		},
		{
			"": 1640,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2744,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 48.2,
			"SteuerEinkommen_P75": 80,
			"eink_arm_Sum": 695,
			"ant_eink_arm": 25.3,
			"SozialQuote": 0.8,
			"SozialBeziehende": 50,
			"Mietpreis": "NA"
		},
		{
			"": 1641,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1198,
			"SteuerEinkommen_P25": 76.6,
			"SteuerEinkommen_Median": 127.6,
			"SteuerEinkommen_P75": 226.7,
			"eink_arm_Sum": 62,
			"ant_eink_arm": 5.2,
			"SozialQuote": 0.8,
			"SozialBeziehende": 50,
			"Mietpreis": "NA"
		},
		{
			"": 1662,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4501,
			"SteuerEinkommen_P25": 18.8,
			"SteuerEinkommen_Median": 42.7,
			"SteuerEinkommen_P75": 71.2,
			"eink_arm_Sum": 1088,
			"ant_eink_arm": 24.2,
			"SozialQuote": 2,
			"SozialBeziehende": 187,
			"Mietpreis": "NA"
		},
		{
			"": 1663,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1388,
			"SteuerEinkommen_P25": 62.2,
			"SteuerEinkommen_Median": 101.7,
			"SteuerEinkommen_P75": 172.3,
			"eink_arm_Sum": 130,
			"ant_eink_arm": 9.4,
			"SozialQuote": 2,
			"SozialBeziehende": 187,
			"Mietpreis": "NA"
		},
		{
			"": 1684,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3156,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 63.9,
			"eink_arm_Sum": 750,
			"ant_eink_arm": 23.8,
			"SozialQuote": 2.4,
			"SozialBeziehende": 150,
			"Mietpreis": "NA"
		},
		{
			"": 1685,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 943,
			"SteuerEinkommen_P25": 55.5,
			"SteuerEinkommen_Median": 86.9,
			"SteuerEinkommen_P75": 141.3,
			"eink_arm_Sum": 74,
			"ant_eink_arm": 7.8,
			"SozialQuote": 2.4,
			"SozialBeziehende": 150,
			"Mietpreis": "NA"
		},
		{
			"": 1706,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3551,
			"SteuerEinkommen_P25": 20.7,
			"SteuerEinkommen_Median": 44.4,
			"SteuerEinkommen_P75": 67.1,
			"eink_arm_Sum": 775,
			"ant_eink_arm": 21.8,
			"SozialQuote": 1.2,
			"SozialBeziehende": 114,
			"Mietpreis": "NA"
		},
		{
			"": 1707,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1956,
			"SteuerEinkommen_P25": 57.7,
			"SteuerEinkommen_Median": 88.4,
			"SteuerEinkommen_P75": 140.9,
			"eink_arm_Sum": 158,
			"ant_eink_arm": 8.1,
			"SozialQuote": 1.2,
			"SozialBeziehende": 114,
			"Mietpreis": "NA"
		},
		{
			"": 1753,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2652,
			"SteuerEinkommen_P25": 23.8,
			"SteuerEinkommen_Median": 46.2,
			"SteuerEinkommen_P75": 70.8,
			"eink_arm_Sum": 486,
			"ant_eink_arm": 18.3,
			"SozialQuote": 2.3,
			"SozialBeziehende": 104,
			"Mietpreis": "NA"
		},
		{
			"": 1754,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 505,
			"SteuerEinkommen_P25": 50.9,
			"SteuerEinkommen_Median": 83,
			"SteuerEinkommen_P75": 132.4,
			"eink_arm_Sum": 60,
			"ant_eink_arm": 11.9,
			"SozialQuote": 2.3,
			"SozialBeziehende": 104,
			"Mietpreis": "NA"
		},
		{
			"": 1775,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2775,
			"SteuerEinkommen_P25": 21,
			"SteuerEinkommen_Median": 43,
			"SteuerEinkommen_P75": 66,
			"eink_arm_Sum": 590,
			"ant_eink_arm": 21.3,
			"SozialQuote": 2.2,
			"SozialBeziehende": 113,
			"Mietpreis": "NA"
		},
		{
			"": 1776,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 636,
			"SteuerEinkommen_P25": 52.7,
			"SteuerEinkommen_Median": 83.4,
			"SteuerEinkommen_P75": 122,
			"eink_arm_Sum": 66,
			"ant_eink_arm": 10.4,
			"SozialQuote": 2.2,
			"SozialBeziehende": 113,
			"Mietpreis": "NA"
		},
		{
			"": 1797,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1893,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 41.95,
			"SteuerEinkommen_P75": 63.6,
			"eink_arm_Sum": 443,
			"ant_eink_arm": 23.4,
			"SozialQuote": 1.7,
			"SozialBeziehende": 73,
			"Mietpreis": "NA"
		},
		{
			"": 1798,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 713,
			"SteuerEinkommen_P25": 60,
			"SteuerEinkommen_Median": 84,
			"SteuerEinkommen_P75": 134.4,
			"eink_arm_Sum": 36,
			"ant_eink_arm": 5,
			"SozialQuote": 1.7,
			"SozialBeziehende": 73,
			"Mietpreis": "NA"
		},
		{
			"": 1843,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6331,
			"SteuerEinkommen_P25": 20.3,
			"SteuerEinkommen_Median": 35.7,
			"SteuerEinkommen_P75": 52.8,
			"eink_arm_Sum": 1346,
			"ant_eink_arm": 21.3,
			"SozialQuote": 4,
			"SozialBeziehende": 633,
			"Mietpreis": "NA"
		},
		{
			"": 1844,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3149,
			"SteuerEinkommen_P25": 46.6,
			"SteuerEinkommen_Median": 63.4,
			"SteuerEinkommen_P75": 88,
			"eink_arm_Sum": 336,
			"ant_eink_arm": 10.7,
			"SozialQuote": 4,
			"SozialBeziehende": 633,
			"Mietpreis": "NA"
		},
		{
			"": 1866,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 10124,
			"SteuerEinkommen_P25": 19.1,
			"SteuerEinkommen_Median": 34.7,
			"SteuerEinkommen_P75": 51.2,
			"eink_arm_Sum": 2393,
			"ant_eink_arm": 23.6,
			"SozialQuote": 6.3,
			"SozialBeziehende": 1707,
			"Mietpreis": "NA"
		},
		{
			"": 1867,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5372,
			"SteuerEinkommen_P25": 44.8,
			"SteuerEinkommen_Median": 60.3,
			"SteuerEinkommen_P75": 81.2,
			"eink_arm_Sum": 667,
			"ant_eink_arm": 12.4,
			"SozialQuote": 6.3,
			"SozialBeziehende": 1707,
			"Mietpreis": "NA"
		},
		{
			"": 1912,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7721,
			"SteuerEinkommen_P25": 22.5,
			"SteuerEinkommen_Median": 43.4,
			"SteuerEinkommen_P75": 64.4,
			"eink_arm_Sum": 1494,
			"ant_eink_arm": 19.3,
			"SozialQuote": 2.7,
			"SozialBeziehende": 534,
			"Mietpreis": "NA"
		},
		{
			"": 1913,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3930,
			"SteuerEinkommen_P25": 55.8,
			"SteuerEinkommen_Median": 77.9,
			"SteuerEinkommen_P75": 110.15,
			"eink_arm_Sum": 309,
			"ant_eink_arm": 7.9,
			"SozialQuote": 2.7,
			"SozialBeziehende": 534,
			"Mietpreis": "NA"
		},
		{
			"": 1935,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6725,
			"SteuerEinkommen_P25": 19,
			"SteuerEinkommen_Median": 36.9,
			"SteuerEinkommen_P75": 55.3,
			"eink_arm_Sum": 1596,
			"ant_eink_arm": 23.7,
			"SozialQuote": 6,
			"SozialBeziehende": 826,
			"Mietpreis": "NA"
		},
		{
			"": 1936,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2061,
			"SteuerEinkommen_P25": 44.1,
			"SteuerEinkommen_Median": 62.1,
			"SteuerEinkommen_P75": 86.1,
			"eink_arm_Sum": 292,
			"ant_eink_arm": 14.2,
			"SozialQuote": 6,
			"SozialBeziehende": 826,
			"Mietpreis": "NA"
		},
		{
			"": 1982,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5745,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 33.6,
			"SteuerEinkommen_P75": 50,
			"eink_arm_Sum": 1455,
			"ant_eink_arm": 25.3,
			"SozialQuote": 4.8,
			"SozialBeziehende": 847,
			"Mietpreis": "NA"
		},
		{
			"": 1983,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3653,
			"SteuerEinkommen_P25": 45.8,
			"SteuerEinkommen_Median": 62.9,
			"SteuerEinkommen_P75": 83.4,
			"eink_arm_Sum": 408,
			"ant_eink_arm": 11.2,
			"SozialQuote": 4.8,
			"SozialBeziehende": 847,
			"Mietpreis": "NA"
		},
		{
			"": 2006,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6730,
			"SteuerEinkommen_P25": 20.2,
			"SteuerEinkommen_Median": 38.3,
			"SteuerEinkommen_P75": 56.1,
			"eink_arm_Sum": 1468,
			"ant_eink_arm": 21.8,
			"SozialQuote": 5.5,
			"SozialBeziehende": 858,
			"Mietpreis": "NA"
		},
		{
			"": 2007,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2601,
			"SteuerEinkommen_P25": 45.3,
			"SteuerEinkommen_Median": 65.6,
			"SteuerEinkommen_P75": 93.1,
			"eink_arm_Sum": 329,
			"ant_eink_arm": 12.6,
			"SozialQuote": 5.5,
			"SozialBeziehende": 858,
			"Mietpreis": "NA"
		},
		{
			"": 2029,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5934,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 33.2,
			"SteuerEinkommen_P75": 49.7,
			"eink_arm_Sum": 1501,
			"ant_eink_arm": 25.3,
			"SozialQuote": 7.5,
			"SozialBeziehende": 1247,
			"Mietpreis": "NA"
		},
		{
			"": 2030,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3270,
			"SteuerEinkommen_P25": 41.6,
			"SteuerEinkommen_Median": 58.6,
			"SteuerEinkommen_P75": 79.8,
			"eink_arm_Sum": 472,
			"ant_eink_arm": 14.4,
			"SozialQuote": 7.5,
			"SozialBeziehende": 1247,
			"Mietpreis": "NA"
		},
		{
			"": 2075,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1732,
			"SteuerEinkommen_P25": 15.3,
			"SteuerEinkommen_Median": 29,
			"SteuerEinkommen_P75": 42.8,
			"eink_arm_Sum": 510,
			"ant_eink_arm": 29.4,
			"SozialQuote": 7.6,
			"SozialBeziehende": 473,
			"Mietpreis": "NA"
		},
		{
			"": 2076,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1297,
			"SteuerEinkommen_P25": 40.3,
			"SteuerEinkommen_Median": 54.9,
			"SteuerEinkommen_P75": 72.1,
			"eink_arm_Sum": 192,
			"ant_eink_arm": 14.8,
			"SozialQuote": 7.6,
			"SozialBeziehende": 473,
			"Mietpreis": "NA"
		},
		{
			"": 2098,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3720,
			"SteuerEinkommen_P25": 18.1,
			"SteuerEinkommen_Median": 31.6,
			"SteuerEinkommen_P75": 46.9,
			"eink_arm_Sum": 927,
			"ant_eink_arm": 24.9,
			"SozialQuote": 7.5,
			"SozialBeziehende": 736,
			"Mietpreis": "NA"
		},
		{
			"": 2099,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1899,
			"SteuerEinkommen_P25": 40.2,
			"SteuerEinkommen_Median": 57.9,
			"SteuerEinkommen_P75": 77,
			"eink_arm_Sum": 294,
			"ant_eink_arm": 15.5,
			"SozialQuote": 7.5,
			"SozialBeziehende": 736,
			"Mietpreis": "NA"
		},
		{
			"": 2120,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3585,
			"SteuerEinkommen_P25": 15.3,
			"SteuerEinkommen_Median": 28.1,
			"SteuerEinkommen_P75": 42.5,
			"eink_arm_Sum": 1057,
			"ant_eink_arm": 29.5,
			"SozialQuote": 5.7,
			"SozialBeziehende": 616,
			"Mietpreis": "NA"
		},
		{
			"": 2121,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2148,
			"SteuerEinkommen_P25": 41.5,
			"SteuerEinkommen_Median": 56.3,
			"SteuerEinkommen_P75": 73.1,
			"eink_arm_Sum": 288,
			"ant_eink_arm": 13.4,
			"SozialQuote": 5.7,
			"SozialBeziehende": 616,
			"Mietpreis": "NA"
		},
		{
			"": 2190,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1704,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 45,
			"SteuerEinkommen_P75": 72.7,
			"eink_arm_Sum": 417,
			"ant_eink_arm": 24.5,
			"SozialQuote": 3.5,
			"SozialBeziehende": 96,
			"Mietpreis": "NA"
		},
		{
			"": 2191,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 278,
			"SteuerEinkommen_P25": 52.2,
			"SteuerEinkommen_Median": 93.3,
			"SteuerEinkommen_P75": 141.7,
			"eink_arm_Sum": 40,
			"ant_eink_arm": 14.4,
			"SozialQuote": 3.5,
			"SozialBeziehende": 96,
			"Mietpreis": "NA"
		},
		{
			"": 2213,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 336,
			"SteuerEinkommen_P25": 12.1,
			"SteuerEinkommen_Median": 35.3,
			"SteuerEinkommen_P75": 62.6,
			"eink_arm_Sum": 114,
			"ant_eink_arm": 33.9,
			"SozialQuote": 3.2,
			"SozialBeziehende": 19,
			"Mietpreis": "NA"
		},
		{
			"": 2214,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 66,
			"SteuerEinkommen_P25": 47,
			"SteuerEinkommen_Median": 99.65,
			"SteuerEinkommen_P75": 191.3,
			"eink_arm_Sum": 10,
			"ant_eink_arm": 15.2,
			"SozialQuote": 3.2,
			"SozialBeziehende": 19,
			"Mietpreis": "NA"
		},
		{
			"": 2234,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1228,
			"SteuerEinkommen_P25": 3.7,
			"SteuerEinkommen_Median": 21.3,
			"SteuerEinkommen_P75": 47.65,
			"eink_arm_Sum": 536,
			"ant_eink_arm": 43.6,
			"SozialQuote": 0.4,
			"SozialBeziehende": 6,
			"Mietpreis": "NA"
		},
		{
			"": 2235,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 139,
			"SteuerEinkommen_P25": 49.85,
			"SteuerEinkommen_Median": 107.5,
			"SteuerEinkommen_P75": 178.3,
			"eink_arm_Sum": 29,
			"ant_eink_arm": 20.9,
			"SozialQuote": 0.4,
			"SozialBeziehende": 6,
			"Mietpreis": "NA"
		},
		{
			"": 2256,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1319,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 4.9,
			"SteuerEinkommen_P75": 19.95,
			"eink_arm_Sum": 973,
			"ant_eink_arm": 73.8,
			"SozialQuote": 2.9,
			"SozialBeziehende": 55,
			"Mietpreis": "NA"
		},
		{
			"": 2257,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 113,
			"SteuerEinkommen_P25": 40.4,
			"SteuerEinkommen_Median": 74.9,
			"SteuerEinkommen_P75": 101.9,
			"eink_arm_Sum": 27,
			"ant_eink_arm": 23.9,
			"SozialQuote": 2.9,
			"SozialBeziehende": 55,
			"Mietpreis": "NA"
		},
		{
			"": 2301,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6340,
			"SteuerEinkommen_P25": 20.7,
			"SteuerEinkommen_Median": 39.8,
			"SteuerEinkommen_P75": 60.5,
			"eink_arm_Sum": 1429,
			"ant_eink_arm": 22.5,
			"SozialQuote": 2.9,
			"SozialBeziehende": 440,
			"Mietpreis": "NA"
		},
		{
			"": 2302,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2668,
			"SteuerEinkommen_P25": 52.8,
			"SteuerEinkommen_Median": 73.4,
			"SteuerEinkommen_P75": 105.9,
			"eink_arm_Sum": 252,
			"ant_eink_arm": 9.4,
			"SozialQuote": 2.9,
			"SozialBeziehende": 440,
			"Mietpreis": "NA"
		},
		{
			"": 2325,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1529,
			"SteuerEinkommen_P25": 19.7,
			"SteuerEinkommen_Median": 35,
			"SteuerEinkommen_P75": 53.5,
			"eink_arm_Sum": 363,
			"ant_eink_arm": 23.7,
			"SozialQuote": 3.2,
			"SozialBeziehende": 145,
			"Mietpreis": "NA"
		},
		{
			"": 2326,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 973,
			"SteuerEinkommen_P25": 48.9,
			"SteuerEinkommen_Median": 70.3,
			"SteuerEinkommen_P75": 97.6,
			"eink_arm_Sum": 95,
			"ant_eink_arm": 9.8,
			"SozialQuote": 3.2,
			"SozialBeziehende": 145,
			"Mietpreis": "NA"
		},
		{
			"": 2348,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3512,
			"SteuerEinkommen_P25": 22.5,
			"SteuerEinkommen_Median": 47.6,
			"SteuerEinkommen_P75": 76.6,
			"eink_arm_Sum": 721,
			"ant_eink_arm": 20.5,
			"SozialQuote": 2.2,
			"SozialBeziehende": 167,
			"Mietpreis": "NA"
		},
		{
			"": 2349,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1180,
			"SteuerEinkommen_P25": 59.2,
			"SteuerEinkommen_Median": 92.75,
			"SteuerEinkommen_P75": 153.4,
			"eink_arm_Sum": 116,
			"ant_eink_arm": 9.8,
			"SozialQuote": 2.2,
			"SozialBeziehende": 167,
			"Mietpreis": "NA"
		},
		{
			"": 2393,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6373,
			"SteuerEinkommen_P25": 21.9,
			"SteuerEinkommen_Median": 39.8,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 1285,
			"ant_eink_arm": 20.2,
			"SozialQuote": 5.6,
			"SozialBeziehende": 733,
			"Mietpreis": "NA"
		},
		{
			"": 2394,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1939,
			"SteuerEinkommen_P25": 44.3,
			"SteuerEinkommen_Median": 67.15,
			"SteuerEinkommen_P75": 97.6,
			"eink_arm_Sum": 304,
			"ant_eink_arm": 15.7,
			"SozialQuote": 5.6,
			"SozialBeziehende": 733,
			"Mietpreis": "NA"
		},
		{
			"": 2416,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3012,
			"SteuerEinkommen_P25": 12.7,
			"SteuerEinkommen_Median": 30,
			"SteuerEinkommen_P75": 46.9,
			"eink_arm_Sum": 969,
			"ant_eink_arm": 32.2,
			"SozialQuote": 4.5,
			"SozialBeziehende": 436,
			"Mietpreis": "NA"
		},
		{
			"": 2417,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1897,
			"SteuerEinkommen_P25": 49.1,
			"SteuerEinkommen_Median": 64,
			"SteuerEinkommen_P75": 85,
			"eink_arm_Sum": 180,
			"ant_eink_arm": 9.5,
			"SozialQuote": 4.5,
			"SozialBeziehende": 436,
			"Mietpreis": "NA"
		},
		{
			"": 2438,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8953,
			"SteuerEinkommen_P25": 19.8,
			"SteuerEinkommen_Median": 35.6,
			"SteuerEinkommen_P75": 53.7,
			"eink_arm_Sum": 2127,
			"ant_eink_arm": 23.8,
			"SozialQuote": 6.6,
			"SozialBeziehende": 1228,
			"Mietpreis": "NA"
		},
		{
			"": 2439,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2705,
			"SteuerEinkommen_P25": 39.6,
			"SteuerEinkommen_Median": 58.3,
			"SteuerEinkommen_P75": 78.1,
			"eink_arm_Sum": 489,
			"ant_eink_arm": 18.1,
			"SozialQuote": 6.6,
			"SozialBeziehende": 1228,
			"Mietpreis": "NA"
		},
		{
			"": 2483,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1902,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 38,
			"SteuerEinkommen_P75": 58.4,
			"eink_arm_Sum": 445,
			"ant_eink_arm": 23.4,
			"SozialQuote": 10.2,
			"SozialBeziehende": 346,
			"Mietpreis": "NA"
		},
		{
			"": 2484,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 404,
			"SteuerEinkommen_P25": 36.35,
			"SteuerEinkommen_Median": 60.25,
			"SteuerEinkommen_P75": 85.1,
			"eink_arm_Sum": 97,
			"ant_eink_arm": 24,
			"SozialQuote": 10.2,
			"SozialBeziehende": 346,
			"Mietpreis": "NA"
		},
		{
			"": 2506,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5191,
			"SteuerEinkommen_P25": 15.5,
			"SteuerEinkommen_Median": 32.65,
			"SteuerEinkommen_P75": 52.7,
			"eink_arm_Sum": 1540,
			"ant_eink_arm": 29.7,
			"SozialQuote": 10.4,
			"SozialBeziehende": 934,
			"Mietpreis": "NA"
		},
		{
			"": 2507,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1021,
			"SteuerEinkommen_P25": 35,
			"SteuerEinkommen_Median": 54.8,
			"SteuerEinkommen_P75": 75.2,
			"eink_arm_Sum": 241,
			"ant_eink_arm": 23.6,
			"SozialQuote": 10.4,
			"SozialBeziehende": 934,
			"Mietpreis": "NA"
		},
		{
			"": 2528,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5026,
			"SteuerEinkommen_P25": 16.9,
			"SteuerEinkommen_Median": 30,
			"SteuerEinkommen_P75": 45.75,
			"eink_arm_Sum": 1436,
			"ant_eink_arm": 28.6,
			"SozialQuote": 8,
			"SozialBeziehende": 943,
			"Mietpreis": "NA"
		},
		{
			"": 2529,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1946,
			"SteuerEinkommen_P25": 38.9,
			"SteuerEinkommen_Median": 55,
			"SteuerEinkommen_P75": 70.9,
			"eink_arm_Sum": 375,
			"ant_eink_arm": 19.3,
			"SozialQuote": 8,
			"SozialBeziehende": 943,
			"Mietpreis": "NA"
		},
		{
			"": 2574,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4541,
			"SteuerEinkommen_P25": 18.2,
			"SteuerEinkommen_Median": 36,
			"SteuerEinkommen_P75": 55,
			"eink_arm_Sum": 1175,
			"ant_eink_arm": 25.9,
			"SozialQuote": 7.8,
			"SozialBeziehende": 664,
			"Mietpreis": "NA"
		},
		{
			"": 2575,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1088,
			"SteuerEinkommen_P25": 41,
			"SteuerEinkommen_Median": 57.4,
			"SteuerEinkommen_P75": 77.6,
			"eink_arm_Sum": 197,
			"ant_eink_arm": 18.1,
			"SozialQuote": 7.8,
			"SozialBeziehende": 664,
			"Mietpreis": "NA"
		},
		{
			"": 2597,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 966,
			"SteuerEinkommen_P25": 20.55,
			"SteuerEinkommen_Median": 41.45,
			"SteuerEinkommen_P75": 64,
			"eink_arm_Sum": 228,
			"ant_eink_arm": 23.6,
			"SozialQuote": 7,
			"SozialBeziehende": 135,
			"Mietpreis": "NA"
		},
		{
			"": 2598,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 270,
			"SteuerEinkommen_P25": 44,
			"SteuerEinkommen_Median": 64.65,
			"SteuerEinkommen_P75": 90.7,
			"eink_arm_Sum": 43,
			"ant_eink_arm": 15.9,
			"SozialQuote": 7,
			"SozialBeziehende": 135,
			"Mietpreis": "NA"
		},
		{
			"": 2642,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8385,
			"SteuerEinkommen_P25": 20.1,
			"SteuerEinkommen_Median": 39.2,
			"SteuerEinkommen_P75": 61.4,
			"eink_arm_Sum": 1942,
			"ant_eink_arm": 23.2,
			"SozialQuote": 3.3,
			"SozialBeziehende": 593,
			"Mietpreis": "NA"
		},
		{
			"": 2643,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2862,
			"SteuerEinkommen_P25": 48.9,
			"SteuerEinkommen_Median": 69.25,
			"SteuerEinkommen_P75": 100,
			"eink_arm_Sum": 349,
			"ant_eink_arm": 12.2,
			"SozialQuote": 3.3,
			"SozialBeziehende": 593,
			"Mietpreis": "NA"
		},
		{
			"": 2664,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4045,
			"SteuerEinkommen_P25": 21,
			"SteuerEinkommen_Median": 45.4,
			"SteuerEinkommen_P75": 72.8,
			"eink_arm_Sum": 914,
			"ant_eink_arm": 22.6,
			"SozialQuote": 2.2,
			"SozialBeziehende": 188,
			"Mietpreis": "NA"
		},
		{
			"": 2665,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1404,
			"SteuerEinkommen_P25": 66.2,
			"SteuerEinkommen_Median": 102.9,
			"SteuerEinkommen_P75": 172.25,
			"eink_arm_Sum": 106,
			"ant_eink_arm": 7.5,
			"SozialQuote": 2.2,
			"SozialBeziehende": 188,
			"Mietpreis": "NA"
		},
		{
			"": 2711,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2742,
			"SteuerEinkommen_P25": 16.9,
			"SteuerEinkommen_Median": 49,
			"SteuerEinkommen_P75": 82.9,
			"eink_arm_Sum": 724,
			"ant_eink_arm": 26.4,
			"SozialQuote": 0.9,
			"SozialBeziehende": 57,
			"Mietpreis": "NA"
		},
		{
			"": 2712,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1209,
			"SteuerEinkommen_P25": 78.1,
			"SteuerEinkommen_Median": 128.15,
			"SteuerEinkommen_P75": 234.9,
			"eink_arm_Sum": 78,
			"ant_eink_arm": 6.5,
			"SozialQuote": 0.9,
			"SozialBeziehende": 57,
			"Mietpreis": "NA"
		},
		{
			"": 2734,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4412,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 45.1,
			"SteuerEinkommen_P75": 73,
			"eink_arm_Sum": 1052,
			"ant_eink_arm": 23.8,
			"SozialQuote": 1.9,
			"SozialBeziehende": 171,
			"Mietpreis": "NA"
		},
		{
			"": 2735,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1370,
			"SteuerEinkommen_P25": 66.4,
			"SteuerEinkommen_Median": 104.5,
			"SteuerEinkommen_P75": 176,
			"eink_arm_Sum": 113,
			"ant_eink_arm": 8.2,
			"SozialQuote": 1.9,
			"SozialBeziehende": 171,
			"Mietpreis": "NA"
		},
		{
			"": 2757,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3239,
			"SteuerEinkommen_P25": 20.2,
			"SteuerEinkommen_Median": 41.7,
			"SteuerEinkommen_P75": 66.6,
			"eink_arm_Sum": 747,
			"ant_eink_arm": 23.1,
			"SozialQuote": 2.2,
			"SozialBeziehende": 139,
			"Mietpreis": "NA"
		},
		{
			"": 2758,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 944,
			"SteuerEinkommen_P25": 55.8,
			"SteuerEinkommen_Median": 87,
			"SteuerEinkommen_P75": 148.7,
			"eink_arm_Sum": 86,
			"ant_eink_arm": 9.1,
			"SozialQuote": 2.2,
			"SozialBeziehende": 139,
			"Mietpreis": "NA"
		},
		{
			"": 2779,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3637,
			"SteuerEinkommen_P25": 21.9,
			"SteuerEinkommen_Median": 45.35,
			"SteuerEinkommen_P75": 69.5,
			"eink_arm_Sum": 793,
			"ant_eink_arm": 21.8,
			"SozialQuote": 1.2,
			"SozialBeziehende": 110,
			"Mietpreis": "NA"
		},
		{
			"": 2780,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1914,
			"SteuerEinkommen_P25": 60.1,
			"SteuerEinkommen_Median": 92.25,
			"SteuerEinkommen_P75": 141.9,
			"eink_arm_Sum": 162,
			"ant_eink_arm": 8.5,
			"SozialQuote": 1.2,
			"SozialBeziehende": 110,
			"Mietpreis": "NA"
		},
		{
			"": 2827,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2650,
			"SteuerEinkommen_P25": 24.7,
			"SteuerEinkommen_Median": 47.9,
			"SteuerEinkommen_P75": 73.2,
			"eink_arm_Sum": 494,
			"ant_eink_arm": 18.6,
			"SozialQuote": 2.1,
			"SozialBeziehende": 97,
			"Mietpreis": "NA"
		},
		{
			"": 2828,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 536,
			"SteuerEinkommen_P25": 52.4,
			"SteuerEinkommen_Median": 87.2,
			"SteuerEinkommen_P75": 145.3,
			"eink_arm_Sum": 61,
			"ant_eink_arm": 11.4,
			"SozialQuote": 2.1,
			"SozialBeziehende": 97,
			"Mietpreis": "NA"
		},
		{
			"": 2849,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2714,
			"SteuerEinkommen_P25": 22.35,
			"SteuerEinkommen_Median": 44.2,
			"SteuerEinkommen_P75": 69.3,
			"eink_arm_Sum": 575,
			"ant_eink_arm": 21.2,
			"SozialQuote": 2.4,
			"SozialBeziehende": 120,
			"Mietpreis": "NA"
		},
		{
			"": 2850,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 636,
			"SteuerEinkommen_P25": 55,
			"SteuerEinkommen_Median": 86.2,
			"SteuerEinkommen_P75": 133.3,
			"eink_arm_Sum": 66,
			"ant_eink_arm": 10.4,
			"SozialQuote": 2.4,
			"SozialBeziehende": 120,
			"Mietpreis": "NA"
		},
		{
			"": 2872,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1906,
			"SteuerEinkommen_P25": 21.1,
			"SteuerEinkommen_Median": 43.9,
			"SteuerEinkommen_P75": 66.75,
			"eink_arm_Sum": 438,
			"ant_eink_arm": 23,
			"SozialQuote": 1.3,
			"SozialBeziehende": 55,
			"Mietpreis": "NA"
		},
		{
			"": 2873,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 709,
			"SteuerEinkommen_P25": 62.3,
			"SteuerEinkommen_Median": 86.4,
			"SteuerEinkommen_P75": 138.7,
			"eink_arm_Sum": 45,
			"ant_eink_arm": 6.3,
			"SozialQuote": 1.3,
			"SozialBeziehende": 55,
			"Mietpreis": "NA"
		},
		{
			"": 2919,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6443,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 37.8,
			"SteuerEinkommen_P75": 55,
			"eink_arm_Sum": 1355,
			"ant_eink_arm": 21,
			"SozialQuote": 3.7,
			"SozialBeziehende": 578,
			"Mietpreis": "NA"
		},
		{
			"": 2920,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3137,
			"SteuerEinkommen_P25": 48.2,
			"SteuerEinkommen_Median": 65.6,
			"SteuerEinkommen_P75": 91.6,
			"eink_arm_Sum": 343,
			"ant_eink_arm": 10.9,
			"SozialQuote": 3.7,
			"SozialBeziehende": 578,
			"Mietpreis": "NA"
		},
		{
			"": 2942,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 10468,
			"SteuerEinkommen_P25": 19.7,
			"SteuerEinkommen_Median": 35.9,
			"SteuerEinkommen_P75": 52.8,
			"eink_arm_Sum": 2523,
			"ant_eink_arm": 24.1,
			"SozialQuote": 6.1,
			"SozialBeziehende": 1676,
			"Mietpreis": "NA"
		},
		{
			"": 2943,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5421,
			"SteuerEinkommen_P25": 45.8,
			"SteuerEinkommen_Median": 62.3,
			"SteuerEinkommen_P75": 83.3,
			"eink_arm_Sum": 694,
			"ant_eink_arm": 12.8,
			"SozialQuote": 6.1,
			"SozialBeziehende": 1676,
			"Mietpreis": "NA"
		},
		{
			"": 2988,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7862,
			"SteuerEinkommen_P25": 23.6,
			"SteuerEinkommen_Median": 45.1,
			"SteuerEinkommen_P75": 66.8,
			"eink_arm_Sum": 1538,
			"ant_eink_arm": 19.6,
			"SozialQuote": 2.4,
			"SozialBeziehende": 476,
			"Mietpreis": "NA"
		},
		{
			"": 2989,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3868,
			"SteuerEinkommen_P25": 58.2,
			"SteuerEinkommen_Median": 80.9,
			"SteuerEinkommen_P75": 116.5,
			"eink_arm_Sum": 281,
			"ant_eink_arm": 7.3,
			"SozialQuote": 2.4,
			"SozialBeziehende": 476,
			"Mietpreis": "NA"
		},
		{
			"": 3011,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6869,
			"SteuerEinkommen_P25": 20.3,
			"SteuerEinkommen_Median": 38.8,
			"SteuerEinkommen_P75": 57.9,
			"eink_arm_Sum": 1575,
			"ant_eink_arm": 22.9,
			"SozialQuote": 5.1,
			"SozialBeziehende": 704,
			"Mietpreis": "NA"
		},
		{
			"": 3012,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2007,
			"SteuerEinkommen_P25": 46,
			"SteuerEinkommen_Median": 65.3,
			"SteuerEinkommen_P75": 90,
			"eink_arm_Sum": 272,
			"ant_eink_arm": 13.6,
			"SozialQuote": 5.1,
			"SozialBeziehende": 704,
			"Mietpreis": "NA"
		},
		{
			"": 3058,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5868,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 34.4,
			"SteuerEinkommen_P75": 51.6,
			"eink_arm_Sum": 1511,
			"ant_eink_arm": 25.7,
			"SozialQuote": 4.4,
			"SozialBeziehende": 779,
			"Mietpreis": "NA"
		},
		{
			"": 3059,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3638,
			"SteuerEinkommen_P25": 46.7,
			"SteuerEinkommen_Median": 65,
			"SteuerEinkommen_P75": 86.75,
			"eink_arm_Sum": 423,
			"ant_eink_arm": 11.6,
			"SozialQuote": 4.4,
			"SozialBeziehende": 779,
			"Mietpreis": "NA"
		},
		{
			"": 3082,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6984,
			"SteuerEinkommen_P25": 21.1,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 59.7,
			"eink_arm_Sum": 1488,
			"ant_eink_arm": 21.3,
			"SozialQuote": 4.9,
			"SozialBeziehende": 791,
			"Mietpreis": "NA"
		},
		{
			"": 3083,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2662,
			"SteuerEinkommen_P25": 47.85,
			"SteuerEinkommen_Median": 69.9,
			"SteuerEinkommen_P75": 100.6,
			"eink_arm_Sum": 331,
			"ant_eink_arm": 12.4,
			"SozialQuote": 4.9,
			"SozialBeziehende": 791,
			"Mietpreis": "NA"
		},
		{
			"": 3105,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6052,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 34.3,
			"SteuerEinkommen_P75": 50.9,
			"eink_arm_Sum": 1544,
			"ant_eink_arm": 25.5,
			"SozialQuote": 6.6,
			"SozialBeziehende": 1111,
			"Mietpreis": "NA"
		},
		{
			"": 3106,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3273,
			"SteuerEinkommen_P25": 42.4,
			"SteuerEinkommen_Median": 59.9,
			"SteuerEinkommen_P75": 81.4,
			"eink_arm_Sum": 486,
			"ant_eink_arm": 14.8,
			"SozialQuote": 6.6,
			"SozialBeziehende": 1111,
			"Mietpreis": "NA"
		},
		{
			"": 3151,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1723,
			"SteuerEinkommen_P25": 16.55,
			"SteuerEinkommen_Median": 31.1,
			"SteuerEinkommen_P75": 45.3,
			"eink_arm_Sum": 487,
			"ant_eink_arm": 28.3,
			"SozialQuote": 6.2,
			"SozialBeziehende": 386,
			"Mietpreis": "NA"
		},
		{
			"": 3152,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1268,
			"SteuerEinkommen_P25": 41.7,
			"SteuerEinkommen_Median": 58,
			"SteuerEinkommen_P75": 75.95,
			"eink_arm_Sum": 194,
			"ant_eink_arm": 15.3,
			"SozialQuote": 6.2,
			"SozialBeziehende": 386,
			"Mietpreis": "NA"
		},
		{
			"": 3174,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3696,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 32.8,
			"SteuerEinkommen_P75": 48.6,
			"eink_arm_Sum": 944,
			"ant_eink_arm": 25.5,
			"SozialQuote": 6.8,
			"SozialBeziehende": 662,
			"Mietpreis": "NA"
		},
		{
			"": 3175,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1866,
			"SteuerEinkommen_P25": 41.7,
			"SteuerEinkommen_Median": 59.85,
			"SteuerEinkommen_P75": 77.7,
			"eink_arm_Sum": 283,
			"ant_eink_arm": 15.2,
			"SozialQuote": 6.8,
			"SozialBeziehende": 662,
			"Mietpreis": "NA"
		},
		{
			"": 3196,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3559,
			"SteuerEinkommen_P25": 15.8,
			"SteuerEinkommen_Median": 28.7,
			"SteuerEinkommen_P75": 43.6,
			"eink_arm_Sum": 1081,
			"ant_eink_arm": 30.4,
			"SozialQuote": 5,
			"SozialBeziehende": 543,
			"Mietpreis": "NA"
		},
		{
			"": 3197,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2160,
			"SteuerEinkommen_P25": 43.1,
			"SteuerEinkommen_Median": 58.7,
			"SteuerEinkommen_P75": 76.4,
			"eink_arm_Sum": 291,
			"ant_eink_arm": 13.5,
			"SozialQuote": 5,
			"SozialBeziehende": 543,
			"Mietpreis": "NA"
		},
		{
			"": 3266,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1691,
			"SteuerEinkommen_P25": 19.45,
			"SteuerEinkommen_Median": 44.05,
			"SteuerEinkommen_P75": 72.8,
			"eink_arm_Sum": 414,
			"ant_eink_arm": 24.5,
			"SozialQuote": 4.4,
			"SozialBeziehende": 122,
			"Mietpreis": "NA"
		},
		{
			"": 3267,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 292,
			"SteuerEinkommen_P25": 49.85,
			"SteuerEinkommen_Median": 87.05,
			"SteuerEinkommen_P75": 145.25,
			"eink_arm_Sum": 48,
			"ant_eink_arm": 16.4,
			"SozialQuote": 4.4,
			"SozialBeziehende": 122,
			"Mietpreis": "NA"
		},
		{
			"": 3289,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 320,
			"SteuerEinkommen_P25": 13.1,
			"SteuerEinkommen_Median": 33.2,
			"SteuerEinkommen_P75": 62,
			"eink_arm_Sum": 98,
			"ant_eink_arm": 30.6,
			"SozialQuote": 3.6,
			"SozialBeziehende": 21,
			"Mietpreis": "NA"
		},
		{
			"": 3290,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 72,
			"SteuerEinkommen_P25": 57.05,
			"SteuerEinkommen_Median": 105,
			"SteuerEinkommen_P75": 195.2,
			"eink_arm_Sum": 9,
			"ant_eink_arm": 12.5,
			"SozialQuote": 3.6,
			"SozialBeziehende": 21,
			"Mietpreis": "NA"
		},
		{
			"": 3309,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1207,
			"SteuerEinkommen_P25": 1.4,
			"SteuerEinkommen_Median": 21,
			"SteuerEinkommen_P75": 44.9,
			"eink_arm_Sum": 557,
			"ant_eink_arm": 46.1,
			"SozialQuote": 0.6,
			"SozialBeziehende": 10,
			"Mietpreis": "NA"
		},
		{
			"": 3310,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 126,
			"SteuerEinkommen_P25": 60.6,
			"SteuerEinkommen_Median": 105.15,
			"SteuerEinkommen_P75": 181,
			"eink_arm_Sum": 20,
			"ant_eink_arm": 15.9,
			"SozialQuote": 0.6,
			"SozialBeziehende": 10,
			"Mietpreis": "NA"
		},
		{
			"": 3331,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1296,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 4.7,
			"SteuerEinkommen_P75": 20.35,
			"eink_arm_Sum": 939,
			"ant_eink_arm": 72.5,
			"SozialQuote": 3.2,
			"SozialBeziehende": 61,
			"Mietpreis": "NA"
		},
		{
			"": 3332,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 113,
			"SteuerEinkommen_P25": 40.5,
			"SteuerEinkommen_Median": 78,
			"SteuerEinkommen_P75": 100.3,
			"eink_arm_Sum": 23,
			"ant_eink_arm": 20.4,
			"SozialQuote": 3.2,
			"SozialBeziehende": 61,
			"Mietpreis": "NA"
		},
		{
			"": 3377,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6362,
			"SteuerEinkommen_P25": 19.9,
			"SteuerEinkommen_Median": 39.5,
			"SteuerEinkommen_P75": 60.1,
			"eink_arm_Sum": 1506,
			"ant_eink_arm": 23.7,
			"SozialQuote": 2.8,
			"SozialBeziehende": 425,
			"Mietpreis": "NA"
		},
		{
			"": 3378,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2591,
			"SteuerEinkommen_P25": 53.2,
			"SteuerEinkommen_Median": 73.5,
			"SteuerEinkommen_P75": 106.4,
			"eink_arm_Sum": 256,
			"ant_eink_arm": 9.9,
			"SozialQuote": 2.8,
			"SozialBeziehende": 425,
			"Mietpreis": "NA"
		},
		{
			"": 3401,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1545,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 36.5,
			"SteuerEinkommen_P75": 55,
			"eink_arm_Sum": 362,
			"ant_eink_arm": 23.4,
			"SozialQuote": 3.6,
			"SozialBeziehende": 168,
			"Mietpreis": "NA"
		},
		{
			"": 3402,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 963,
			"SteuerEinkommen_P25": 47.3,
			"SteuerEinkommen_Median": 69.35,
			"SteuerEinkommen_P75": 95.5,
			"eink_arm_Sum": 106,
			"ant_eink_arm": 11,
			"SozialQuote": 3.6,
			"SozialBeziehende": 168,
			"Mietpreis": "NA"
		},
		{
			"": 3424,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3560,
			"SteuerEinkommen_P25": 22,
			"SteuerEinkommen_Median": 46.9,
			"SteuerEinkommen_P75": 74.6,
			"eink_arm_Sum": 770,
			"ant_eink_arm": 21.6,
			"SozialQuote": 2.7,
			"SozialBeziehende": 206,
			"Mietpreis": "NA"
		},
		{
			"": 3425,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1193,
			"SteuerEinkommen_P25": 58.2,
			"SteuerEinkommen_Median": 93.6,
			"SteuerEinkommen_P75": 148.9,
			"eink_arm_Sum": 115,
			"ant_eink_arm": 9.6,
			"SozialQuote": 2.7,
			"SozialBeziehende": 206,
			"Mietpreis": "NA"
		},
		{
			"": 3469,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6444,
			"SteuerEinkommen_P25": 21.6,
			"SteuerEinkommen_Median": 40.5,
			"SteuerEinkommen_P75": 60.3,
			"eink_arm_Sum": 1371,
			"ant_eink_arm": 21.3,
			"SozialQuote": 5.8,
			"SozialBeziehende": 771,
			"Mietpreis": "NA"
		},
		{
			"": 3470,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1935,
			"SteuerEinkommen_P25": 42.6,
			"SteuerEinkommen_Median": 64.7,
			"SteuerEinkommen_P75": 95.1,
			"eink_arm_Sum": 324,
			"ant_eink_arm": 16.7,
			"SozialQuote": 5.8,
			"SozialBeziehende": 771,
			"Mietpreis": "NA"
		},
		{
			"": 3492,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3042,
			"SteuerEinkommen_P25": 12.3,
			"SteuerEinkommen_Median": 29.7,
			"SteuerEinkommen_P75": 47.2,
			"eink_arm_Sum": 1002,
			"ant_eink_arm": 32.9,
			"SozialQuote": 4.3,
			"SozialBeziehende": 422,
			"Mietpreis": "NA"
		},
		{
			"": 3493,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1890,
			"SteuerEinkommen_P25": 49.3,
			"SteuerEinkommen_Median": 65,
			"SteuerEinkommen_P75": 85.4,
			"eink_arm_Sum": 179,
			"ant_eink_arm": 9.5,
			"SozialQuote": 4.3,
			"SozialBeziehende": 422,
			"Mietpreis": "NA"
		},
		{
			"": 3515,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9008,
			"SteuerEinkommen_P25": 18.9,
			"SteuerEinkommen_Median": 35.5,
			"SteuerEinkommen_P75": 53.8,
			"eink_arm_Sum": 2250,
			"ant_eink_arm": 25,
			"SozialQuote": 7.1,
			"SozialBeziehende": 1344,
			"Mietpreis": "NA"
		},
		{
			"": 3516,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2638,
			"SteuerEinkommen_P25": 39.1,
			"SteuerEinkommen_Median": 58.1,
			"SteuerEinkommen_P75": 77.6,
			"eink_arm_Sum": 479,
			"ant_eink_arm": 18.2,
			"SozialQuote": 7.1,
			"SozialBeziehende": 1344,
			"Mietpreis": "NA"
		},
		{
			"": 3560,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1881,
			"SteuerEinkommen_P25": 18.4,
			"SteuerEinkommen_Median": 38.3,
			"SteuerEinkommen_P75": 58.4,
			"eink_arm_Sum": 478,
			"ant_eink_arm": 25.4,
			"SozialQuote": 8,
			"SozialBeziehende": 274,
			"Mietpreis": "NA"
		},
		{
			"": 3561,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 388,
			"SteuerEinkommen_P25": 36.9,
			"SteuerEinkommen_Median": 60,
			"SteuerEinkommen_P75": 82.7,
			"eink_arm_Sum": 89,
			"ant_eink_arm": 22.9,
			"SozialQuote": 8,
			"SozialBeziehende": 274,
			"Mietpreis": "NA"
		},
		{
			"": 3583,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5195,
			"SteuerEinkommen_P25": 15.3,
			"SteuerEinkommen_Median": 32.6,
			"SteuerEinkommen_P75": 52.8,
			"eink_arm_Sum": 1565,
			"ant_eink_arm": 30.1,
			"SozialQuote": 11.5,
			"SozialBeziehende": 1047,
			"Mietpreis": "NA"
		},
		{
			"": 3584,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1040,
			"SteuerEinkommen_P25": 35.3,
			"SteuerEinkommen_Median": 54.25,
			"SteuerEinkommen_P75": 75.5,
			"eink_arm_Sum": 242,
			"ant_eink_arm": 23.3,
			"SozialQuote": 11.5,
			"SozialBeziehende": 1047,
			"Mietpreis": "NA"
		},
		{
			"": 3606,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5037,
			"SteuerEinkommen_P25": 15.9,
			"SteuerEinkommen_Median": 29.7,
			"SteuerEinkommen_P75": 45.4,
			"eink_arm_Sum": 1533,
			"ant_eink_arm": 30.4,
			"SozialQuote": 7.8,
			"SozialBeziehende": 919,
			"Mietpreis": "NA"
		},
		{
			"": 3607,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1956,
			"SteuerEinkommen_P25": 38.35,
			"SteuerEinkommen_Median": 55.2,
			"SteuerEinkommen_P75": 72.15,
			"eink_arm_Sum": 383,
			"ant_eink_arm": 19.6,
			"SozialQuote": 7.8,
			"SozialBeziehende": 919,
			"Mietpreis": "NA"
		},
		{
			"": 3652,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4557,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 35.9,
			"SteuerEinkommen_P75": 55.4,
			"eink_arm_Sum": 1177,
			"ant_eink_arm": 25.8,
			"SozialQuote": 7.6,
			"SozialBeziehende": 658,
			"Mietpreis": "NA"
		},
		{
			"": 3653,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1089,
			"SteuerEinkommen_P25": 38.2,
			"SteuerEinkommen_Median": 57,
			"SteuerEinkommen_P75": 77.6,
			"eink_arm_Sum": 213,
			"ant_eink_arm": 19.6,
			"SozialQuote": 7.6,
			"SozialBeziehende": 658,
			"Mietpreis": "NA"
		},
		{
			"": 3675,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1217,
			"SteuerEinkommen_P25": 25,
			"SteuerEinkommen_Median": 45.2,
			"SteuerEinkommen_P75": 64.7,
			"eink_arm_Sum": 228,
			"ant_eink_arm": 18.7,
			"SozialQuote": 5.9,
			"SozialBeziehende": 133,
			"Mietpreis": "NA"
		},
		{
			"": 3676,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 275,
			"SteuerEinkommen_P25": 47.2,
			"SteuerEinkommen_Median": 68.8,
			"SteuerEinkommen_P75": 100.8,
			"eink_arm_Sum": 38,
			"ant_eink_arm": 13.8,
			"SozialQuote": 5.9,
			"SozialBeziehende": 133,
			"Mietpreis": "NA"
		},
		{
			"": 3719,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8440,
			"SteuerEinkommen_P25": 21,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 62.1,
			"eink_arm_Sum": 1872,
			"ant_eink_arm": 22.2,
			"SozialQuote": 3.8,
			"SozialBeziehende": 701,
			"Mietpreis": "NA"
		},
		{
			"": 3720,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2803,
			"SteuerEinkommen_P25": 50,
			"SteuerEinkommen_Median": 70.2,
			"SteuerEinkommen_P75": 98.7,
			"eink_arm_Sum": 322,
			"ant_eink_arm": 11.5,
			"SozialQuote": 3.8,
			"SozialBeziehende": 701,
			"Mietpreis": "NA"
		},
		{
			"": 3741,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4029,
			"SteuerEinkommen_P25": 20.65,
			"SteuerEinkommen_Median": 45.7,
			"SteuerEinkommen_P75": 74.1,
			"eink_arm_Sum": 921,
			"ant_eink_arm": 22.9,
			"SozialQuote": 1.9,
			"SozialBeziehende": 162,
			"Mietpreis": "NA"
		},
		{
			"": 3742,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1374,
			"SteuerEinkommen_P25": 66.8,
			"SteuerEinkommen_Median": 104.1,
			"SteuerEinkommen_P75": 162.7,
			"eink_arm_Sum": 124,
			"ant_eink_arm": 9,
			"SozialQuote": 1.9,
			"SozialBeziehende": 162,
			"Mietpreis": "NA"
		},
		{
			"": 3788,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2740,
			"SteuerEinkommen_P25": 17.2,
			"SteuerEinkommen_Median": 48.55,
			"SteuerEinkommen_P75": 82,
			"eink_arm_Sum": 717,
			"ant_eink_arm": 26.2,
			"SozialQuote": 0.9,
			"SozialBeziehende": 61,
			"Mietpreis": "NA"
		},
		{
			"": 3789,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1161,
			"SteuerEinkommen_P25": 78.2,
			"SteuerEinkommen_Median": 127.2,
			"SteuerEinkommen_P75": 220.1,
			"eink_arm_Sum": 72,
			"ant_eink_arm": 6.2,
			"SozialQuote": 0.9,
			"SozialBeziehende": 61,
			"Mietpreis": "NA"
		},
		{
			"": 3811,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4471,
			"SteuerEinkommen_P25": 20.4,
			"SteuerEinkommen_Median": 45.7,
			"SteuerEinkommen_P75": 75.5,
			"eink_arm_Sum": 1045,
			"ant_eink_arm": 23.4,
			"SozialQuote": 1.6,
			"SozialBeziehende": 143,
			"Mietpreis": "NA"
		},
		{
			"": 3812,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1353,
			"SteuerEinkommen_P25": 66.6,
			"SteuerEinkommen_Median": 107.05,
			"SteuerEinkommen_P75": 180.2,
			"eink_arm_Sum": 112,
			"ant_eink_arm": 8.3,
			"SozialQuote": 1.6,
			"SozialBeziehende": 143,
			"Mietpreis": "NA"
		},
		{
			"": 3834,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3204,
			"SteuerEinkommen_P25": 20.4,
			"SteuerEinkommen_Median": 42.1,
			"SteuerEinkommen_P75": 67.5,
			"eink_arm_Sum": 746,
			"ant_eink_arm": 23.3,
			"SozialQuote": 2.1,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 3835,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 946,
			"SteuerEinkommen_P25": 57.1,
			"SteuerEinkommen_Median": 87.5,
			"SteuerEinkommen_P75": 146.8,
			"eink_arm_Sum": 89,
			"ant_eink_arm": 9.4,
			"SozialQuote": 2.1,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 3856,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3685,
			"SteuerEinkommen_P25": 21.3,
			"SteuerEinkommen_Median": 45.1,
			"SteuerEinkommen_P75": 69,
			"eink_arm_Sum": 802,
			"ant_eink_arm": 21.8,
			"SozialQuote": 1.3,
			"SozialBeziehende": 118,
			"Mietpreis": "NA"
		},
		{
			"": 3857,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1881,
			"SteuerEinkommen_P25": 58.6,
			"SteuerEinkommen_Median": 91.05,
			"SteuerEinkommen_P75": 138.5,
			"eink_arm_Sum": 164,
			"ant_eink_arm": 8.7,
			"SozialQuote": 1.3,
			"SozialBeziehende": 118,
			"Mietpreis": "NA"
		},
		{
			"": 3903,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2657,
			"SteuerEinkommen_P25": 24.4,
			"SteuerEinkommen_Median": 48.3,
			"SteuerEinkommen_P75": 74.6,
			"eink_arm_Sum": 502,
			"ant_eink_arm": 18.9,
			"SozialQuote": 2.7,
			"SozialBeziehende": 126,
			"Mietpreis": "NA"
		},
		{
			"": 3904,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 516,
			"SteuerEinkommen_P25": 52.1,
			"SteuerEinkommen_Median": 84.7,
			"SteuerEinkommen_P75": 141.8,
			"eink_arm_Sum": 64,
			"ant_eink_arm": 12.4,
			"SozialQuote": 2.7,
			"SozialBeziehende": 126,
			"Mietpreis": "NA"
		},
		{
			"": 3925,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2718,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 43.55,
			"SteuerEinkommen_P75": 69.55,
			"eink_arm_Sum": 581,
			"ant_eink_arm": 21.4,
			"SozialQuote": 2.2,
			"SozialBeziehende": 112,
			"Mietpreis": "NA"
		},
		{
			"": 3926,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 623,
			"SteuerEinkommen_P25": 56.9,
			"SteuerEinkommen_Median": 86.3,
			"SteuerEinkommen_P75": 130.3,
			"eink_arm_Sum": 63,
			"ant_eink_arm": 10.1,
			"SozialQuote": 2.2,
			"SozialBeziehende": 112,
			"Mietpreis": "NA"
		},
		{
			"": 3948,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1940,
			"SteuerEinkommen_P25": 19.35,
			"SteuerEinkommen_Median": 43.3,
			"SteuerEinkommen_P75": 66.2,
			"eink_arm_Sum": 475,
			"ant_eink_arm": 24.5,
			"SozialQuote": 1.1,
			"SozialBeziehende": 46,
			"Mietpreis": "NA"
		},
		{
			"": 3949,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 696,
			"SteuerEinkommen_P25": 61.1,
			"SteuerEinkommen_Median": 90.8,
			"SteuerEinkommen_P75": 138.8,
			"eink_arm_Sum": 44,
			"ant_eink_arm": 6.3,
			"SozialQuote": 1.1,
			"SozialBeziehende": 46,
			"Mietpreis": "NA"
		},
		{
			"": 3993,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6515,
			"SteuerEinkommen_P25": 20.9,
			"SteuerEinkommen_Median": 37.1,
			"SteuerEinkommen_P75": 54.6,
			"eink_arm_Sum": 1390,
			"ant_eink_arm": 21.3,
			"SozialQuote": 4.1,
			"SozialBeziehende": 649,
			"Mietpreis": "NA"
		},
		{
			"": 3994,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3119,
			"SteuerEinkommen_P25": 48,
			"SteuerEinkommen_Median": 65.1,
			"SteuerEinkommen_P75": 91.2,
			"eink_arm_Sum": 344,
			"ant_eink_arm": 11,
			"SozialQuote": 4.1,
			"SozialBeziehende": 649,
			"Mietpreis": "NA"
		},
		{
			"": 4015,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 10471,
			"SteuerEinkommen_P25": 19.33,
			"SteuerEinkommen_Median": 36.1,
			"SteuerEinkommen_P75": 52.9,
			"eink_arm_Sum": 2557,
			"ant_eink_arm": 24.4,
			"SozialQuote": 6.3,
			"SozialBeziehende": 1724,
			"Mietpreis": "NA"
		},
		{
			"": 4016,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5337,
			"SteuerEinkommen_P25": 46.2,
			"SteuerEinkommen_Median": 62.5,
			"SteuerEinkommen_P75": 82.9,
			"eink_arm_Sum": 673,
			"ant_eink_arm": 12.6,
			"SozialQuote": 6.3,
			"SozialBeziehende": 1724,
			"Mietpreis": "NA"
		},
		{
			"": 4062,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7990,
			"SteuerEinkommen_P25": 23.7,
			"SteuerEinkommen_Median": 45.3,
			"SteuerEinkommen_P75": 66.7,
			"eink_arm_Sum": 1597,
			"ant_eink_arm": 20,
			"SozialQuote": 2.8,
			"SozialBeziehende": 548,
			"Mietpreis": "NA"
		},
		{
			"": 4063,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3824,
			"SteuerEinkommen_P25": 57.7,
			"SteuerEinkommen_Median": 80.1,
			"SteuerEinkommen_P75": 116.3,
			"eink_arm_Sum": 305,
			"ant_eink_arm": 8,
			"SozialQuote": 2.8,
			"SozialBeziehende": 548,
			"Mietpreis": "NA"
		},
		{
			"": 4086,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7000,
			"SteuerEinkommen_P25": 19.7,
			"SteuerEinkommen_Median": 38.8,
			"SteuerEinkommen_P75": 58.5,
			"eink_arm_Sum": 1676,
			"ant_eink_arm": 23.9,
			"SozialQuote": 5.3,
			"SozialBeziehende": 732,
			"Mietpreis": "NA"
		},
		{
			"": 4087,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1963,
			"SteuerEinkommen_P25": 44.8,
			"SteuerEinkommen_Median": 64.1,
			"SteuerEinkommen_P75": 89.1,
			"eink_arm_Sum": 278,
			"ant_eink_arm": 14.2,
			"SozialQuote": 5.3,
			"SozialBeziehende": 732,
			"Mietpreis": "NA"
		},
		{
			"": 4133,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5878,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 35,
			"SteuerEinkommen_P75": 51.8,
			"eink_arm_Sum": 1518,
			"ant_eink_arm": 25.8,
			"SozialQuote": 4.6,
			"SozialBeziehende": 811,
			"Mietpreis": "NA"
		},
		{
			"": 4134,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3585,
			"SteuerEinkommen_P25": 46.8,
			"SteuerEinkommen_Median": 65.2,
			"SteuerEinkommen_P75": 87.1,
			"eink_arm_Sum": 419,
			"ant_eink_arm": 11.7,
			"SozialQuote": 4.6,
			"SozialBeziehende": 811,
			"Mietpreis": "NA"
		},
		{
			"": 4157,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7181,
			"SteuerEinkommen_P25": 20.4,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 59.7,
			"eink_arm_Sum": 1630,
			"ant_eink_arm": 22.7,
			"SozialQuote": 4.7,
			"SozialBeziehende": 768,
			"Mietpreis": "NA"
		},
		{
			"": 4158,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2683,
			"SteuerEinkommen_P25": 47.5,
			"SteuerEinkommen_Median": 69.8,
			"SteuerEinkommen_P75": 99.7,
			"eink_arm_Sum": 332,
			"ant_eink_arm": 12.4,
			"SozialQuote": 4.7,
			"SozialBeziehende": 768,
			"Mietpreis": "NA"
		},
		{
			"": 4180,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6325,
			"SteuerEinkommen_P25": 18,
			"SteuerEinkommen_Median": 34.7,
			"SteuerEinkommen_P75": 51.1,
			"eink_arm_Sum": 1662,
			"ant_eink_arm": 26.3,
			"SozialQuote": 6.5,
			"SozialBeziehende": 1145,
			"Mietpreis": "NA"
		},
		{
			"": 4181,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3336,
			"SteuerEinkommen_P25": 43,
			"SteuerEinkommen_Median": 59.8,
			"SteuerEinkommen_P75": 81.4,
			"eink_arm_Sum": 486,
			"ant_eink_arm": 14.6,
			"SozialQuote": 6.5,
			"SozialBeziehende": 1145,
			"Mietpreis": "NA"
		},
		{
			"": 4226,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1793,
			"SteuerEinkommen_P25": 15.9,
			"SteuerEinkommen_Median": 30.5,
			"SteuerEinkommen_P75": 45.2,
			"eink_arm_Sum": 514,
			"ant_eink_arm": 28.7,
			"SozialQuote": 6.8,
			"SozialBeziehende": 444,
			"Mietpreis": "NA"
		},
		{
			"": 4227,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1310,
			"SteuerEinkommen_P25": 42.4,
			"SteuerEinkommen_Median": 58.1,
			"SteuerEinkommen_P75": 75.5,
			"eink_arm_Sum": 189,
			"ant_eink_arm": 14.4,
			"SozialQuote": 6.8,
			"SozialBeziehende": 444,
			"Mietpreis": "NA"
		},
		{
			"": 4248,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3673,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 33.05,
			"SteuerEinkommen_P75": 48.8,
			"eink_arm_Sum": 951,
			"ant_eink_arm": 25.9,
			"SozialQuote": 6.8,
			"SozialBeziehende": 658,
			"Mietpreis": "NA"
		},
		{
			"": 4249,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1836,
			"SteuerEinkommen_P25": 40.3,
			"SteuerEinkommen_Median": 58.5,
			"SteuerEinkommen_P75": 77.9,
			"eink_arm_Sum": 295,
			"ant_eink_arm": 16.1,
			"SozialQuote": 6.8,
			"SozialBeziehende": 658,
			"Mietpreis": "NA"
		},
		{
			"": 4271,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3585,
			"SteuerEinkommen_P25": 15,
			"SteuerEinkommen_Median": 29,
			"SteuerEinkommen_P75": 43.8,
			"eink_arm_Sum": 1116,
			"ant_eink_arm": 31.1,
			"SozialQuote": 5.5,
			"SozialBeziehende": 608,
			"Mietpreis": "NA"
		},
		{
			"": 4272,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2192,
			"SteuerEinkommen_P25": 43,
			"SteuerEinkommen_Median": 58.5,
			"SteuerEinkommen_P75": 75.9,
			"eink_arm_Sum": 298,
			"ant_eink_arm": 13.6,
			"SozialQuote": 5.5,
			"SozialBeziehende": 608,
			"Mietpreis": "NA"
		},
		{
			"": 4340,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1685,
			"SteuerEinkommen_P25": 19.6,
			"SteuerEinkommen_Median": 45,
			"SteuerEinkommen_P75": 73.8,
			"eink_arm_Sum": 412,
			"ant_eink_arm": 24.5,
			"SozialQuote": 5.4,
			"SozialBeziehende": 151,
			"Mietpreis": "NA"
		},
		{
			"": 4341,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 293,
			"SteuerEinkommen_P25": 51.7,
			"SteuerEinkommen_Median": 88.4,
			"SteuerEinkommen_P75": 142.8,
			"eink_arm_Sum": 38,
			"ant_eink_arm": 13,
			"SozialQuote": 5.4,
			"SozialBeziehende": 151,
			"Mietpreis": "NA"
		},
		{
			"": 4363,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 306,
			"SteuerEinkommen_P25": 13.9,
			"SteuerEinkommen_Median": 32.3,
			"SteuerEinkommen_P75": 62.2,
			"eink_arm_Sum": 99,
			"ant_eink_arm": 32.4,
			"SozialQuote": 1.7,
			"SozialBeziehende": 10,
			"Mietpreis": "NA"
		},
		{
			"": 4364,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 74,
			"SteuerEinkommen_P25": 56.4,
			"SteuerEinkommen_Median": 98.1,
			"SteuerEinkommen_P75": 205.6,
			"eink_arm_Sum": 8,
			"ant_eink_arm": 10.8,
			"SozialQuote": 1.7,
			"SozialBeziehende": 10,
			"Mietpreis": "NA"
		},
		{
			"": 4383,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1187,
			"SteuerEinkommen_P25": 1,
			"SteuerEinkommen_Median": 21.5,
			"SteuerEinkommen_P75": 46.7,
			"eink_arm_Sum": 527,
			"ant_eink_arm": 44.4,
			"SozialQuote": 0.6,
			"SozialBeziehende": 10,
			"Mietpreis": "NA"
		},
		{
			"": 4384,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 125,
			"SteuerEinkommen_P25": 49.2,
			"SteuerEinkommen_Median": 106.2,
			"SteuerEinkommen_P75": 171.2,
			"eink_arm_Sum": 21,
			"ant_eink_arm": 16.8,
			"SozialQuote": 0.6,
			"SozialBeziehende": 10,
			"Mietpreis": "NA"
		},
		{
			"": 4405,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 972,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 5.8,
			"SteuerEinkommen_P75": 23.7,
			"eink_arm_Sum": 678,
			"ant_eink_arm": 69.8,
			"SozialQuote": 4.4,
			"SozialBeziehende": 64,
			"Mietpreis": "NA"
		},
		{
			"": 4406,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 105,
			"SteuerEinkommen_P25": 48.1,
			"SteuerEinkommen_Median": 78.9,
			"SteuerEinkommen_P75": 113.3,
			"eink_arm_Sum": 19,
			"ant_eink_arm": 18.1,
			"SozialQuote": 4.4,
			"SozialBeziehende": 64,
			"Mietpreis": "NA"
		},
		{
			"": 4450,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6313,
			"SteuerEinkommen_P25": 20.1,
			"SteuerEinkommen_Median": 39.3,
			"SteuerEinkommen_P75": 59.8,
			"eink_arm_Sum": 1465,
			"ant_eink_arm": 23.2,
			"SozialQuote": 3.2,
			"SozialBeziehende": 468,
			"Mietpreis": "NA"
		},
		{
			"": 4451,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2514,
			"SteuerEinkommen_P25": 52.5,
			"SteuerEinkommen_Median": 73.8,
			"SteuerEinkommen_P75": 106.1,
			"eink_arm_Sum": 244,
			"ant_eink_arm": 9.7,
			"SozialQuote": 3.2,
			"SozialBeziehende": 468,
			"Mietpreis": "NA"
		},
		{
			"": 4474,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1679,
			"SteuerEinkommen_P25": 18.2,
			"SteuerEinkommen_Median": 34.8,
			"SteuerEinkommen_P75": 53.8,
			"eink_arm_Sum": 438,
			"ant_eink_arm": 26.1,
			"SozialQuote": 4.1,
			"SozialBeziehende": 194,
			"Mietpreis": "NA"
		},
		{
			"": 4475,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 964,
			"SteuerEinkommen_P25": 48.8,
			"SteuerEinkommen_Median": 68.6,
			"SteuerEinkommen_P75": 95.7,
			"eink_arm_Sum": 96,
			"ant_eink_arm": 10,
			"SozialQuote": 4.1,
			"SozialBeziehende": 194,
			"Mietpreis": "NA"
		},
		{
			"": 4496,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3590,
			"SteuerEinkommen_P25": 22.7,
			"SteuerEinkommen_Median": 47.29,
			"SteuerEinkommen_P75": 73.3,
			"eink_arm_Sum": 748,
			"ant_eink_arm": 20.8,
			"SozialQuote": 2.8,
			"SozialBeziehende": 212,
			"Mietpreis": "NA"
		},
		{
			"": 4497,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1181,
			"SteuerEinkommen_P25": 57.5,
			"SteuerEinkommen_Median": 90.25,
			"SteuerEinkommen_P75": 149.9,
			"eink_arm_Sum": 105,
			"ant_eink_arm": 8.9,
			"SozialQuote": 2.8,
			"SozialBeziehende": 212,
			"Mietpreis": "NA"
		},
		{
			"": 4541,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6466,
			"SteuerEinkommen_P25": 21.6,
			"SteuerEinkommen_Median": 40.2,
			"SteuerEinkommen_P75": 60.4,
			"eink_arm_Sum": 1369,
			"ant_eink_arm": 21.2,
			"SozialQuote": 6.4,
			"SozialBeziehende": 843,
			"Mietpreis": "NA"
		},
		{
			"": 4542,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1872,
			"SteuerEinkommen_P25": 42.1,
			"SteuerEinkommen_Median": 64.9,
			"SteuerEinkommen_P75": 94.8,
			"eink_arm_Sum": 302,
			"ant_eink_arm": 16.1,
			"SozialQuote": 6.4,
			"SozialBeziehende": 843,
			"Mietpreis": "NA"
		},
		{
			"": 4564,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3067,
			"SteuerEinkommen_P25": 12.5,
			"SteuerEinkommen_Median": 29.8,
			"SteuerEinkommen_P75": 46.4,
			"eink_arm_Sum": 1008,
			"ant_eink_arm": 32.9,
			"SozialQuote": 5.1,
			"SozialBeziehende": 515,
			"Mietpreis": "NA"
		},
		{
			"": 4565,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1924,
			"SteuerEinkommen_P25": 47.9,
			"SteuerEinkommen_Median": 63.9,
			"SteuerEinkommen_P75": 83.8,
			"eink_arm_Sum": 220,
			"ant_eink_arm": 11.4,
			"SozialQuote": 5.1,
			"SozialBeziehende": 515,
			"Mietpreis": "NA"
		},
		{
			"": 4587,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9013,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 35.5,
			"SteuerEinkommen_P75": 53.7,
			"eink_arm_Sum": 2281,
			"ant_eink_arm": 25.3,
			"SozialQuote": 8,
			"SozialBeziehende": 1506,
			"Mietpreis": "NA"
		},
		{
			"": 4588,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2612,
			"SteuerEinkommen_P25": 38.8,
			"SteuerEinkommen_Median": 57.5,
			"SteuerEinkommen_P75": 76.4,
			"eink_arm_Sum": 501,
			"ant_eink_arm": 19.2,
			"SozialQuote": 8,
			"SozialBeziehende": 1506,
			"Mietpreis": "NA"
		},
		{
			"": 4633,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1876,
			"SteuerEinkommen_P25": 18.8,
			"SteuerEinkommen_Median": 37.8,
			"SteuerEinkommen_P75": 58.5,
			"eink_arm_Sum": 471,
			"ant_eink_arm": 25.1,
			"SozialQuote": 9.3,
			"SozialBeziehende": 311,
			"Mietpreis": "NA"
		},
		{
			"": 4634,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 350,
			"SteuerEinkommen_P25": 36.3,
			"SteuerEinkommen_Median": 60.15,
			"SteuerEinkommen_P75": 85.8,
			"eink_arm_Sum": 80,
			"ant_eink_arm": 22.9,
			"SozialQuote": 9.3,
			"SozialBeziehende": 311,
			"Mietpreis": "NA"
		},
		{
			"": 4656,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5151,
			"SteuerEinkommen_P25": 15.8,
			"SteuerEinkommen_Median": 33.8,
			"SteuerEinkommen_P75": 53.1,
			"eink_arm_Sum": 1511,
			"ant_eink_arm": 29.3,
			"SozialQuote": 12.9,
			"SozialBeziehende": 1163,
			"Mietpreis": "NA"
		},
		{
			"": 4657,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1012,
			"SteuerEinkommen_P25": 34.4,
			"SteuerEinkommen_Median": 54.6,
			"SteuerEinkommen_P75": 77.3,
			"eink_arm_Sum": 246,
			"ant_eink_arm": 24.3,
			"SozialQuote": 12.9,
			"SozialBeziehende": 1163,
			"Mietpreis": "NA"
		},
		{
			"": 4679,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5087,
			"SteuerEinkommen_P25": 16,
			"SteuerEinkommen_Median": 30,
			"SteuerEinkommen_P75": 45.3,
			"eink_arm_Sum": 1533,
			"ant_eink_arm": 30.1,
			"SozialQuote": 9.3,
			"SozialBeziehende": 1094,
			"Mietpreis": "NA"
		},
		{
			"": 4680,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1887,
			"SteuerEinkommen_P25": 37.1,
			"SteuerEinkommen_Median": 54.2,
			"SteuerEinkommen_P75": 71.5,
			"eink_arm_Sum": 361,
			"ant_eink_arm": 19.1,
			"SozialQuote": 9.3,
			"SozialBeziehende": 1094,
			"Mietpreis": "NA"
		},
		{
			"": 4725,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4484,
			"SteuerEinkommen_P25": 18,
			"SteuerEinkommen_Median": 36.9,
			"SteuerEinkommen_P75": 55.7,
			"eink_arm_Sum": 1175,
			"ant_eink_arm": 26.2,
			"SozialQuote": 8.3,
			"SozialBeziehende": 712,
			"Mietpreis": "NA"
		},
		{
			"": 4726,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1065,
			"SteuerEinkommen_P25": 38.8,
			"SteuerEinkommen_Median": 58.1,
			"SteuerEinkommen_P75": 76.5,
			"eink_arm_Sum": 215,
			"ant_eink_arm": 20.2,
			"SozialQuote": 8.3,
			"SozialBeziehende": 712,
			"Mietpreis": "NA"
		},
		{
			"": 4748,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1224,
			"SteuerEinkommen_P25": 25.45,
			"SteuerEinkommen_Median": 47.1,
			"SteuerEinkommen_P75": 67.8,
			"eink_arm_Sum": 229,
			"ant_eink_arm": 18.7,
			"SozialQuote": 6.1,
			"SozialBeziehende": 138,
			"Mietpreis": "NA"
		},
		{
			"": 4749,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 288,
			"SteuerEinkommen_P25": 47.5,
			"SteuerEinkommen_Median": 71.85,
			"SteuerEinkommen_P75": 101.85,
			"eink_arm_Sum": 40,
			"ant_eink_arm": 13.9,
			"SozialQuote": 6.1,
			"SozialBeziehende": 138,
			"Mietpreis": "NA"
		},
		{
			"": 4794,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8461,
			"SteuerEinkommen_P25": 20.9,
			"SteuerEinkommen_Median": 40.4,
			"SteuerEinkommen_P75": 61.9,
			"eink_arm_Sum": 1920,
			"ant_eink_arm": 22.7,
			"SozialQuote": 3.4,
			"SozialBeziehende": 617,
			"Mietpreis": "NA"
		},
		{
			"": 4795,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2761,
			"SteuerEinkommen_P25": 49.3,
			"SteuerEinkommen_Median": 70.2,
			"SteuerEinkommen_P75": 99.6,
			"eink_arm_Sum": 333,
			"ant_eink_arm": 12.1,
			"SozialQuote": 3.4,
			"SozialBeziehende": 617,
			"Mietpreis": "NA"
		},
		{
			"": 4817,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4036,
			"SteuerEinkommen_P25": 20.3,
			"SteuerEinkommen_Median": 45.7,
			"SteuerEinkommen_P75": 72,
			"eink_arm_Sum": 941,
			"ant_eink_arm": 23.3,
			"SozialQuote": 2.1,
			"SozialBeziehende": 182,
			"Mietpreis": "NA"
		},
		{
			"": 4818,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1348,
			"SteuerEinkommen_P25": 66.8,
			"SteuerEinkommen_Median": 106.65,
			"SteuerEinkommen_P75": 172.8,
			"eink_arm_Sum": 107,
			"ant_eink_arm": 7.9,
			"SozialQuote": 2.1,
			"SozialBeziehende": 182,
			"Mietpreis": "NA"
		},
		{
			"": 4863,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2748,
			"SteuerEinkommen_P25": 17.1,
			"SteuerEinkommen_Median": 48.5,
			"SteuerEinkommen_P75": 81.8,
			"eink_arm_Sum": 728,
			"ant_eink_arm": 26.5,
			"SozialQuote": 1.2,
			"SozialBeziehende": 77,
			"Mietpreis": "NA"
		},
		{
			"": 4864,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1162,
			"SteuerEinkommen_P25": 76.4,
			"SteuerEinkommen_Median": 128.3,
			"SteuerEinkommen_P75": 218.7,
			"eink_arm_Sum": 63,
			"ant_eink_arm": 5.4,
			"SozialQuote": 1.2,
			"SozialBeziehende": 77,
			"Mietpreis": "NA"
		},
		{
			"": 4886,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4447,
			"SteuerEinkommen_P25": 19.7,
			"SteuerEinkommen_Median": 46,
			"SteuerEinkommen_P75": 75.5,
			"eink_arm_Sum": 1080,
			"ant_eink_arm": 24.3,
			"SozialQuote": 1.7,
			"SozialBeziehende": 157,
			"Mietpreis": "NA"
		},
		{
			"": 4887,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1380,
			"SteuerEinkommen_P25": 66.9,
			"SteuerEinkommen_Median": 109.6,
			"SteuerEinkommen_P75": 182.8,
			"eink_arm_Sum": 118,
			"ant_eink_arm": 8.6,
			"SozialQuote": 1.7,
			"SozialBeziehende": 157,
			"Mietpreis": "NA"
		},
		{
			"": 4910,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3240,
			"SteuerEinkommen_P25": 19.5,
			"SteuerEinkommen_Median": 42.45,
			"SteuerEinkommen_P75": 68.1,
			"eink_arm_Sum": 785,
			"ant_eink_arm": 24.2,
			"SozialQuote": 2.1,
			"SozialBeziehende": 134,
			"Mietpreis": "NA"
		},
		{
			"": 4911,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 968,
			"SteuerEinkommen_P25": 59.7,
			"SteuerEinkommen_Median": 89,
			"SteuerEinkommen_P75": 144.9,
			"eink_arm_Sum": 94,
			"ant_eink_arm": 9.7,
			"SozialQuote": 2.1,
			"SozialBeziehende": 134,
			"Mietpreis": "NA"
		},
		{
			"": 4932,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3687,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 44.1,
			"SteuerEinkommen_P75": 68.05,
			"eink_arm_Sum": 860,
			"ant_eink_arm": 23.3,
			"SozialQuote": 1.3,
			"SozialBeziehende": 122,
			"Mietpreis": "NA"
		},
		{
			"": 4933,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1861,
			"SteuerEinkommen_P25": 58.35,
			"SteuerEinkommen_Median": 90.1,
			"SteuerEinkommen_P75": 137.85,
			"eink_arm_Sum": 163,
			"ant_eink_arm": 8.8,
			"SozialQuote": 1.3,
			"SozialBeziehende": 122,
			"Mietpreis": "NA"
		},
		{
			"": 4979,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2626,
			"SteuerEinkommen_P25": 23.2,
			"SteuerEinkommen_Median": 47.6,
			"SteuerEinkommen_P75": 72.8,
			"eink_arm_Sum": 520,
			"ant_eink_arm": 19.8,
			"SozialQuote": 2.8,
			"SozialBeziehende": 126,
			"Mietpreis": "NA"
		},
		{
			"": 4980,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 504,
			"SteuerEinkommen_P25": 54.3,
			"SteuerEinkommen_Median": 90.6,
			"SteuerEinkommen_P75": 144.8,
			"eink_arm_Sum": 57,
			"ant_eink_arm": 11.3,
			"SozialQuote": 2.8,
			"SozialBeziehende": 126,
			"Mietpreis": "NA"
		},
		{
			"": 5001,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2727,
			"SteuerEinkommen_P25": 21.8,
			"SteuerEinkommen_Median": 44.7,
			"SteuerEinkommen_P75": 69.8,
			"eink_arm_Sum": 593,
			"ant_eink_arm": 21.7,
			"SozialQuote": 2.3,
			"SozialBeziehende": 116,
			"Mietpreis": "NA"
		},
		{
			"": 5002,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 616,
			"SteuerEinkommen_P25": 54.1,
			"SteuerEinkommen_Median": 87.2,
			"SteuerEinkommen_P75": 136.6,
			"eink_arm_Sum": 62,
			"ant_eink_arm": 10.1,
			"SozialQuote": 2.3,
			"SozialBeziehende": 116,
			"Mietpreis": "NA"
		},
		{
			"": 5024,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1953,
			"SteuerEinkommen_P25": 19.6,
			"SteuerEinkommen_Median": 44.7,
			"SteuerEinkommen_P75": 68.1,
			"eink_arm_Sum": 475,
			"ant_eink_arm": 24.3,
			"SozialQuote": 1.4,
			"SozialBeziehende": 61,
			"Mietpreis": "NA"
		},
		{
			"": 5025,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 678,
			"SteuerEinkommen_P25": 62.1,
			"SteuerEinkommen_Median": 88.9,
			"SteuerEinkommen_P75": 133.4,
			"eink_arm_Sum": 51,
			"ant_eink_arm": 7.5,
			"SozialQuote": 1.4,
			"SozialBeziehende": 61,
			"Mietpreis": "NA"
		},
		{
			"": 5070,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6685,
			"SteuerEinkommen_P25": 20.7,
			"SteuerEinkommen_Median": 36.8,
			"SteuerEinkommen_P75": 54.5,
			"eink_arm_Sum": 1506,
			"ant_eink_arm": 22.5,
			"SozialQuote": 4.2,
			"SozialBeziehende": 690,
			"Mietpreis": "NA"
		},
		{
			"": 5071,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3112,
			"SteuerEinkommen_P25": 48,
			"SteuerEinkommen_Median": 65,
			"SteuerEinkommen_P75": 90,
			"eink_arm_Sum": 346,
			"ant_eink_arm": 11.1,
			"SozialQuote": 4.2,
			"SozialBeziehende": 690,
			"Mietpreis": "NA"
		},
		{
			"": 5092,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 10428,
			"SteuerEinkommen_P25": 19.8,
			"SteuerEinkommen_Median": 36.5,
			"SteuerEinkommen_P75": 53.2,
			"eink_arm_Sum": 2496,
			"ant_eink_arm": 23.9,
			"SozialQuote": 6.8,
			"SozialBeziehende": 1833,
			"Mietpreis": "NA"
		},
		{
			"": 5093,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5169,
			"SteuerEinkommen_P25": 45.4,
			"SteuerEinkommen_Median": 61.4,
			"SteuerEinkommen_P75": 82.6,
			"eink_arm_Sum": 645,
			"ant_eink_arm": 12.5,
			"SozialQuote": 6.8,
			"SozialBeziehende": 1833,
			"Mietpreis": "NA"
		},
		{
			"": 5139,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8153,
			"SteuerEinkommen_P25": 23.1,
			"SteuerEinkommen_Median": 45.1,
			"SteuerEinkommen_P75": 66.2,
			"eink_arm_Sum": 1619,
			"ant_eink_arm": 19.9,
			"SozialQuote": 2.9,
			"SozialBeziehende": 576,
			"Mietpreis": "NA"
		},
		{
			"": 5140,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3775,
			"SteuerEinkommen_P25": 57.3,
			"SteuerEinkommen_Median": 79.4,
			"SteuerEinkommen_P75": 115.5,
			"eink_arm_Sum": 313,
			"ant_eink_arm": 8.3,
			"SozialQuote": 2.9,
			"SozialBeziehende": 576,
			"Mietpreis": "NA"
		},
		{
			"": 5162,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7223,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 38.4,
			"SteuerEinkommen_P75": 58.3,
			"eink_arm_Sum": 1830,
			"ant_eink_arm": 25.3,
			"SozialQuote": 6.1,
			"SozialBeziehende": 877,
			"Mietpreis": "NA"
		},
		{
			"": 5163,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1912,
			"SteuerEinkommen_P25": 46.1,
			"SteuerEinkommen_Median": 64.6,
			"SteuerEinkommen_P75": 90.7,
			"eink_arm_Sum": 274,
			"ant_eink_arm": 14.3,
			"SozialQuote": 6.1,
			"SozialBeziehende": 877,
			"Mietpreis": "NA"
		},
		{
			"": 5209,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5946,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 34.4,
			"SteuerEinkommen_P75": 51.2,
			"eink_arm_Sum": 1565,
			"ant_eink_arm": 26.3,
			"SozialQuote": 5.8,
			"SozialBeziehende": 1030,
			"Mietpreis": "NA"
		},
		{
			"": 5210,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3592,
			"SteuerEinkommen_P25": 46,
			"SteuerEinkommen_Median": 64.8,
			"SteuerEinkommen_P75": 88,
			"eink_arm_Sum": 433,
			"ant_eink_arm": 12.1,
			"SozialQuote": 5.8,
			"SozialBeziehende": 1030,
			"Mietpreis": "NA"
		},
		{
			"": 5233,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7330,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 39.9,
			"SteuerEinkommen_P75": 59.4,
			"eink_arm_Sum": 1719,
			"ant_eink_arm": 23.5,
			"SozialQuote": 5.6,
			"SozialBeziehende": 940,
			"Mietpreis": "NA"
		},
		{
			"": 5234,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2736,
			"SteuerEinkommen_P25": 47.8,
			"SteuerEinkommen_Median": 69.1,
			"SteuerEinkommen_P75": 99.3,
			"eink_arm_Sum": 344,
			"ant_eink_arm": 12.6,
			"SozialQuote": 5.6,
			"SozialBeziehende": 940,
			"Mietpreis": "NA"
		},
		{
			"": 5256,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6530,
			"SteuerEinkommen_P25": 18,
			"SteuerEinkommen_Median": 34.8,
			"SteuerEinkommen_P75": 51.5,
			"eink_arm_Sum": 1728,
			"ant_eink_arm": 26.5,
			"SozialQuote": 7.8,
			"SozialBeziehende": 1415,
			"Mietpreis": "NA"
		},
		{
			"": 5257,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3386,
			"SteuerEinkommen_P25": 42.6,
			"SteuerEinkommen_Median": 60.6,
			"SteuerEinkommen_P75": 81,
			"eink_arm_Sum": 519,
			"ant_eink_arm": 15.3,
			"SozialQuote": 7.8,
			"SozialBeziehende": 1415,
			"Mietpreis": "NA"
		},
		{
			"": 5302,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1774,
			"SteuerEinkommen_P25": 15,
			"SteuerEinkommen_Median": 30.5,
			"SteuerEinkommen_P75": 44.5,
			"eink_arm_Sum": 529,
			"ant_eink_arm": 29.8,
			"SozialQuote": 7.5,
			"SozialBeziehende": 478,
			"Mietpreis": "NA"
		},
		{
			"": 5303,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1302,
			"SteuerEinkommen_P25": 41.5,
			"SteuerEinkommen_Median": 57.45,
			"SteuerEinkommen_P75": 75.6,
			"eink_arm_Sum": 196,
			"ant_eink_arm": 15.1,
			"SozialQuote": 7.5,
			"SozialBeziehende": 478,
			"Mietpreis": "NA"
		},
		{
			"": 5324,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3664,
			"SteuerEinkommen_P25": 18.4,
			"SteuerEinkommen_Median": 32.5,
			"SteuerEinkommen_P75": 48.3,
			"eink_arm_Sum": 955,
			"ant_eink_arm": 26.1,
			"SozialQuote": 8,
			"SozialBeziehende": 768,
			"Mietpreis": "NA"
		},
		{
			"": 5325,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1791,
			"SteuerEinkommen_P25": 41.2,
			"SteuerEinkommen_Median": 58.5,
			"SteuerEinkommen_P75": 77.6,
			"eink_arm_Sum": 288,
			"ant_eink_arm": 16.1,
			"SozialQuote": 8,
			"SozialBeziehende": 768,
			"Mietpreis": "NA"
		},
		{
			"": 5347,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3578,
			"SteuerEinkommen_P25": 15.1,
			"SteuerEinkommen_Median": 29.6,
			"SteuerEinkommen_P75": 43.8,
			"eink_arm_Sum": 1088,
			"ant_eink_arm": 30.4,
			"SozialQuote": 6.8,
			"SozialBeziehende": 740,
			"Mietpreis": "NA"
		},
		{
			"": 5348,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2154,
			"SteuerEinkommen_P25": 42.5,
			"SteuerEinkommen_Median": 58.6,
			"SteuerEinkommen_P75": 74.7,
			"eink_arm_Sum": 295,
			"ant_eink_arm": 13.7,
			"SozialQuote": 6.8,
			"SozialBeziehende": 740,
			"Mietpreis": "NA"
		},
		{
			"": 5417,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1678,
			"SteuerEinkommen_P25": 17.3,
			"SteuerEinkommen_Median": 42.1,
			"SteuerEinkommen_P75": 72.5,
			"eink_arm_Sum": 456,
			"ant_eink_arm": 27.2,
			"SozialQuote": 5.1,
			"SozialBeziehende": 140,
			"Mietpreis": "NA"
		},
		{
			"": 5418,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 288,
			"SteuerEinkommen_P25": 59.7,
			"SteuerEinkommen_Median": 97.3,
			"SteuerEinkommen_P75": 149.3,
			"eink_arm_Sum": 28,
			"ant_eink_arm": 9.7,
			"SozialQuote": 5.1,
			"SozialBeziehende": 140,
			"Mietpreis": "NA"
		},
		{
			"": 5441,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 294,
			"SteuerEinkommen_P25": 12.1,
			"SteuerEinkommen_Median": 32.85,
			"SteuerEinkommen_P75": 63.8,
			"eink_arm_Sum": 91,
			"ant_eink_arm": 31,
			"SozialQuote": 2.1,
			"SozialBeziehende": 12,
			"Mietpreis": "NA"
		},
		{
			"": 5442,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 76,
			"SteuerEinkommen_P25": 54.9,
			"SteuerEinkommen_Median": 98.6,
			"SteuerEinkommen_P75": 190.2,
			"eink_arm_Sum": 11,
			"ant_eink_arm": 14.5,
			"SozialQuote": 2.1,
			"SozialBeziehende": 12,
			"Mietpreis": "NA"
		},
		{
			"": 5462,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1215,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 20,
			"SteuerEinkommen_P75": 46.95,
			"eink_arm_Sum": 579,
			"ant_eink_arm": 47.7,
			"SozialQuote": 1.1,
			"SozialBeziehende": 18,
			"Mietpreis": "NA"
		},
		{
			"": 5463,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 130,
			"SteuerEinkommen_P25": 48.6,
			"SteuerEinkommen_Median": 98.7,
			"SteuerEinkommen_P75": 164.4,
			"eink_arm_Sum": 23,
			"ant_eink_arm": 17.7,
			"SozialQuote": 1.1,
			"SozialBeziehende": 18,
			"Mietpreis": "NA"
		},
		{
			"": 5484,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 644,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 12.25,
			"SteuerEinkommen_P75": 39.1,
			"eink_arm_Sum": 383,
			"ant_eink_arm": 59.5,
			"SozialQuote": 6.5,
			"SozialBeziehende": 72,
			"Mietpreis": "NA"
		},
		{
			"": 5485,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 96,
			"SteuerEinkommen_P25": 51.5,
			"SteuerEinkommen_Median": 80.05,
			"SteuerEinkommen_P75": 123.2,
			"eink_arm_Sum": 15,
			"ant_eink_arm": 15.6,
			"SozialQuote": 6.5,
			"SozialBeziehende": 72,
			"Mietpreis": "NA"
		},
		{
			"": 5529,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6436,
			"SteuerEinkommen_P25": 19.3,
			"SteuerEinkommen_Median": 38.7,
			"SteuerEinkommen_P75": 59.7,
			"eink_arm_Sum": 1581,
			"ant_eink_arm": 24.6,
			"SozialQuote": 3.8,
			"SozialBeziehende": 569,
			"Mietpreis": "NA"
		},
		{
			"": 5530,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2471,
			"SteuerEinkommen_P25": 52.4,
			"SteuerEinkommen_Median": 74.25,
			"SteuerEinkommen_P75": 108.5,
			"eink_arm_Sum": 257,
			"ant_eink_arm": 10.4,
			"SozialQuote": 3.8,
			"SozialBeziehende": 569,
			"Mietpreis": "NA"
		},
		{
			"": 5553,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1679,
			"SteuerEinkommen_P25": 18.1,
			"SteuerEinkommen_Median": 34.1,
			"SteuerEinkommen_P75": 52.7,
			"eink_arm_Sum": 435,
			"ant_eink_arm": 25.9,
			"SozialQuote": 4.9,
			"SozialBeziehende": 228,
			"Mietpreis": "NA"
		},
		{
			"": 5554,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 948,
			"SteuerEinkommen_P25": 45.75,
			"SteuerEinkommen_Median": 68.25,
			"SteuerEinkommen_P75": 94.05,
			"eink_arm_Sum": 105,
			"ant_eink_arm": 11.1,
			"SozialQuote": 4.9,
			"SozialBeziehende": 228,
			"Mietpreis": "NA"
		},
		{
			"": 5575,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3605,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 47.4,
			"SteuerEinkommen_P75": 75,
			"eink_arm_Sum": 798,
			"ant_eink_arm": 22.1,
			"SozialQuote": 2.8,
			"SozialBeziehende": 219,
			"Mietpreis": "NA"
		},
		{
			"": 5576,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1184,
			"SteuerEinkommen_P25": 58.2,
			"SteuerEinkommen_Median": 92.7,
			"SteuerEinkommen_P75": 151.2,
			"eink_arm_Sum": 125,
			"ant_eink_arm": 10.6,
			"SozialQuote": 2.8,
			"SozialBeziehende": 219,
			"Mietpreis": "NA"
		},
		{
			"": 5621,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6437,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 40.6,
			"SteuerEinkommen_P75": 61,
			"eink_arm_Sum": 1392,
			"ant_eink_arm": 21.6,
			"SozialQuote": 7.3,
			"SozialBeziehende": 966,
			"Mietpreis": "NA"
		},
		{
			"": 5622,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1856,
			"SteuerEinkommen_P25": 42.1,
			"SteuerEinkommen_Median": 65.6,
			"SteuerEinkommen_P75": 96.4,
			"eink_arm_Sum": 312,
			"ant_eink_arm": 16.8,
			"SozialQuote": 7.3,
			"SozialBeziehende": 966,
			"Mietpreis": "NA"
		},
		{
			"": 5644,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3055,
			"SteuerEinkommen_P25": 10.5,
			"SteuerEinkommen_Median": 28.5,
			"SteuerEinkommen_P75": 47.1,
			"eink_arm_Sum": 1041,
			"ant_eink_arm": 34.1,
			"SozialQuote": 5.8,
			"SozialBeziehende": 584,
			"Mietpreis": "NA"
		},
		{
			"": 5645,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1922,
			"SteuerEinkommen_P25": 46.9,
			"SteuerEinkommen_Median": 63.5,
			"SteuerEinkommen_P75": 85.6,
			"eink_arm_Sum": 230,
			"ant_eink_arm": 12,
			"SozialQuote": 5.8,
			"SozialBeziehende": 584,
			"Mietpreis": "NA"
		},
		{
			"": 5667,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9060,
			"SteuerEinkommen_P25": 18.6,
			"SteuerEinkommen_Median": 35.6,
			"SteuerEinkommen_P75": 53.8,
			"eink_arm_Sum": 2292,
			"ant_eink_arm": 25.3,
			"SozialQuote": 9.1,
			"SozialBeziehende": 1716,
			"Mietpreis": "NA"
		},
		{
			"": 5668,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2594,
			"SteuerEinkommen_P25": 37,
			"SteuerEinkommen_Median": 56.6,
			"SteuerEinkommen_P75": 77.1,
			"eink_arm_Sum": 543,
			"ant_eink_arm": 20.9,
			"SozialQuote": 9.1,
			"SozialBeziehende": 1716,
			"Mietpreis": "NA"
		},
		{
			"": 5714,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1894,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 38.8,
			"SteuerEinkommen_P75": 59.7,
			"eink_arm_Sum": 491,
			"ant_eink_arm": 25.9,
			"SozialQuote": 8.6,
			"SozialBeziehende": 288,
			"Mietpreis": "NA"
		},
		{
			"": 5715,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 365,
			"SteuerEinkommen_P25": 34.8,
			"SteuerEinkommen_Median": 55.35,
			"SteuerEinkommen_P75": 89.6,
			"eink_arm_Sum": 84,
			"ant_eink_arm": 23,
			"SozialQuote": 8.6,
			"SozialBeziehende": 288,
			"Mietpreis": "NA"
		},
		{
			"": 5737,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5191,
			"SteuerEinkommen_P25": 15.15,
			"SteuerEinkommen_Median": 33,
			"SteuerEinkommen_P75": 54.6,
			"eink_arm_Sum": 1559,
			"ant_eink_arm": 30,
			"SozialQuote": 13.4,
			"SozialBeziehende": 1205,
			"Mietpreis": "NA"
		},
		{
			"": 5738,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 967,
			"SteuerEinkommen_P25": 31.15,
			"SteuerEinkommen_Median": 51.9,
			"SteuerEinkommen_P75": 76.5,
			"eink_arm_Sum": 265,
			"ant_eink_arm": 27.4,
			"SozialQuote": 13.4,
			"SozialBeziehende": 1205,
			"Mietpreis": "NA"
		},
		{
			"": 5760,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5097,
			"SteuerEinkommen_P25": 15.4,
			"SteuerEinkommen_Median": 29.85,
			"SteuerEinkommen_P75": 45,
			"eink_arm_Sum": 1578,
			"ant_eink_arm": 31,
			"SozialQuote": 9.6,
			"SozialBeziehende": 1134,
			"Mietpreis": "NA"
		},
		{
			"": 5761,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1848,
			"SteuerEinkommen_P25": 36.2,
			"SteuerEinkommen_Median": 53,
			"SteuerEinkommen_P75": 70,
			"eink_arm_Sum": 402,
			"ant_eink_arm": 21.8,
			"SozialQuote": 9.6,
			"SozialBeziehende": 1134,
			"Mietpreis": "NA"
		},
		{
			"": 5807,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4693,
			"SteuerEinkommen_P25": 14.9,
			"SteuerEinkommen_Median": 35.3,
			"SteuerEinkommen_P75": 55.3,
			"eink_arm_Sum": 1418,
			"ant_eink_arm": 30.2,
			"SozialQuote": 8.5,
			"SozialBeziehende": 753,
			"Mietpreis": "NA"
		},
		{
			"": 5808,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1044,
			"SteuerEinkommen_P25": 39.2,
			"SteuerEinkommen_Median": 56.3,
			"SteuerEinkommen_P75": 76.6,
			"eink_arm_Sum": 196,
			"ant_eink_arm": 18.8,
			"SozialQuote": 8.5,
			"SozialBeziehende": 753,
			"Mietpreis": "NA"
		},
		{
			"": 5830,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1292,
			"SteuerEinkommen_P25": 24.35,
			"SteuerEinkommen_Median": 47.4,
			"SteuerEinkommen_P75": 69.5,
			"eink_arm_Sum": 264,
			"ant_eink_arm": 20.4,
			"SozialQuote": 5.7,
			"SozialBeziehende": 138,
			"Mietpreis": "NA"
		},
		{
			"": 5831,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 309,
			"SteuerEinkommen_P25": 47.9,
			"SteuerEinkommen_Median": 73.1,
			"SteuerEinkommen_P75": 109.9,
			"eink_arm_Sum": 43,
			"ant_eink_arm": 13.9,
			"SozialQuote": 5.7,
			"SozialBeziehende": 138,
			"Mietpreis": "NA"
		},
		{
			"": 5875,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8438,
			"SteuerEinkommen_P25": 20.7,
			"SteuerEinkommen_Median": 40.6,
			"SteuerEinkommen_P75": 63,
			"eink_arm_Sum": 1897,
			"ant_eink_arm": 22.5,
			"SozialQuote": 4.2,
			"SozialBeziehende": 771,
			"Mietpreis": "NA"
		},
		{
			"": 5876,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2737,
			"SteuerEinkommen_P25": 49.5,
			"SteuerEinkommen_Median": 70,
			"SteuerEinkommen_P75": 101.5,
			"eink_arm_Sum": 326,
			"ant_eink_arm": 11.9,
			"SozialQuote": 4.2,
			"SozialBeziehende": 771,
			"Mietpreis": "NA"
		},
		{
			"": 5898,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3919,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 46,
			"SteuerEinkommen_P75": 73.55,
			"eink_arm_Sum": 925,
			"ant_eink_arm": 23.6,
			"SozialQuote": 2.1,
			"SozialBeziehende": 182,
			"Mietpreis": "NA"
		},
		{
			"": 5899,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1321,
			"SteuerEinkommen_P25": 64.35,
			"SteuerEinkommen_Median": 106.2,
			"SteuerEinkommen_P75": 173.2,
			"eink_arm_Sum": 115,
			"ant_eink_arm": 8.7,
			"SozialQuote": 2.1,
			"SozialBeziehende": 182,
			"Mietpreis": "NA"
		},
		{
			"": 5944,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2775,
			"SteuerEinkommen_P25": 17.4,
			"SteuerEinkommen_Median": 49.05,
			"SteuerEinkommen_P75": 83.2,
			"eink_arm_Sum": 733,
			"ant_eink_arm": 26.4,
			"SozialQuote": 1.4,
			"SozialBeziehende": 97,
			"Mietpreis": "NA"
		},
		{
			"": 5945,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1191,
			"SteuerEinkommen_P25": 77.5,
			"SteuerEinkommen_Median": 131.4,
			"SteuerEinkommen_P75": 229.8,
			"eink_arm_Sum": 78,
			"ant_eink_arm": 6.5,
			"SozialQuote": 1.4,
			"SozialBeziehende": 97,
			"Mietpreis": "NA"
		},
		{
			"": 5967,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4391,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 46.3,
			"SteuerEinkommen_P75": 75.6,
			"eink_arm_Sum": 1068,
			"ant_eink_arm": 24.3,
			"SozialQuote": 1.8,
			"SozialBeziehende": 164,
			"Mietpreis": "NA"
		},
		{
			"": 5968,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1368,
			"SteuerEinkommen_P25": 66.6,
			"SteuerEinkommen_Median": 110.7,
			"SteuerEinkommen_P75": 187.4,
			"eink_arm_Sum": 127,
			"ant_eink_arm": 9.3,
			"SozialQuote": 1.8,
			"SozialBeziehende": 164,
			"Mietpreis": "NA"
		},
		{
			"": 5990,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3161,
			"SteuerEinkommen_P25": 20.2,
			"SteuerEinkommen_Median": 42.9,
			"SteuerEinkommen_P75": 68.4,
			"eink_arm_Sum": 737,
			"ant_eink_arm": 23.3,
			"SozialQuote": 2,
			"SozialBeziehende": 130,
			"Mietpreis": "NA"
		},
		{
			"": 5991,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 983,
			"SteuerEinkommen_P25": 59.5,
			"SteuerEinkommen_Median": 90,
			"SteuerEinkommen_P75": 153.9,
			"eink_arm_Sum": 97,
			"ant_eink_arm": 9.9,
			"SozialQuote": 2,
			"SozialBeziehende": 130,
			"Mietpreis": "NA"
		},
		{
			"": 6012,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3779,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 42.8,
			"SteuerEinkommen_P75": 68.2,
			"eink_arm_Sum": 897,
			"ant_eink_arm": 23.7,
			"SozialQuote": 1.3,
			"SozialBeziehende": 126,
			"Mietpreis": "NA"
		},
		{
			"": 6013,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1861,
			"SteuerEinkommen_P25": 58.4,
			"SteuerEinkommen_Median": 90.35,
			"SteuerEinkommen_P75": 137.2,
			"eink_arm_Sum": 157,
			"ant_eink_arm": 8.4,
			"SozialQuote": 1.3,
			"SozialBeziehende": 126,
			"Mietpreis": "NA"
		},
		{
			"": 6059,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2616,
			"SteuerEinkommen_P25": 23.1,
			"SteuerEinkommen_Median": 47.9,
			"SteuerEinkommen_P75": 74.2,
			"eink_arm_Sum": 508,
			"ant_eink_arm": 19.4,
			"SozialQuote": 3,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 6060,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 502,
			"SteuerEinkommen_P25": 56.4,
			"SteuerEinkommen_Median": 89,
			"SteuerEinkommen_P75": 142.1,
			"eink_arm_Sum": 56,
			"ant_eink_arm": 11.2,
			"SozialQuote": 3,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 6081,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2735,
			"SteuerEinkommen_P25": 20.2,
			"SteuerEinkommen_Median": 43.75,
			"SteuerEinkommen_P75": 70.4,
			"eink_arm_Sum": 651,
			"ant_eink_arm": 23.8,
			"SozialQuote": 2.3,
			"SozialBeziehende": 118,
			"Mietpreis": "NA"
		},
		{
			"": 6082,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 635,
			"SteuerEinkommen_P25": 55.6,
			"SteuerEinkommen_Median": 87.4,
			"SteuerEinkommen_P75": 140.6,
			"eink_arm_Sum": 67,
			"ant_eink_arm": 10.6,
			"SozialQuote": 2.3,
			"SozialBeziehende": 118,
			"Mietpreis": "NA"
		},
		{
			"": 6104,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1995,
			"SteuerEinkommen_P25": 18.35,
			"SteuerEinkommen_Median": 44,
			"SteuerEinkommen_P75": 66.8,
			"eink_arm_Sum": 505,
			"ant_eink_arm": 25.3,
			"SozialQuote": 1.8,
			"SozialBeziehende": 80,
			"Mietpreis": "NA"
		},
		{
			"": 6105,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 680,
			"SteuerEinkommen_P25": 60.1,
			"SteuerEinkommen_Median": 88,
			"SteuerEinkommen_P75": 134.4,
			"eink_arm_Sum": 50,
			"ant_eink_arm": 7.4,
			"SozialQuote": 1.8,
			"SozialBeziehende": 80,
			"Mietpreis": "NA"
		},
		{
			"": 6149,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6834,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 36.5,
			"SteuerEinkommen_P75": 54,
			"eink_arm_Sum": 1601,
			"ant_eink_arm": 23.4,
			"SozialQuote": 5,
			"SozialBeziehende": 812,
			"Mietpreis": "NA"
		},
		{
			"": 6150,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3060,
			"SteuerEinkommen_P25": 47.3,
			"SteuerEinkommen_Median": 65.1,
			"SteuerEinkommen_P75": 90.7,
			"eink_arm_Sum": 388,
			"ant_eink_arm": 12.7,
			"SozialQuote": 5,
			"SozialBeziehende": 812,
			"Mietpreis": "NA"
		},
		{
			"": 6171,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 10535,
			"SteuerEinkommen_P25": 19,
			"SteuerEinkommen_Median": 36,
			"SteuerEinkommen_P75": 53.2,
			"eink_arm_Sum": 2623,
			"ant_eink_arm": 24.9,
			"SozialQuote": 7.4,
			"SozialBeziehende": 2012,
			"Mietpreis": "NA"
		},
		{
			"": 6172,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5125,
			"SteuerEinkommen_P25": 44.4,
			"SteuerEinkommen_Median": 61.25,
			"SteuerEinkommen_P75": 83,
			"eink_arm_Sum": 699,
			"ant_eink_arm": 13.6,
			"SozialQuote": 7.4,
			"SozialBeziehende": 2012,
			"Mietpreis": "NA"
		},
		{
			"": 6218,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8148,
			"SteuerEinkommen_P25": 22.4,
			"SteuerEinkommen_Median": 44.4,
			"SteuerEinkommen_P75": 65.4,
			"eink_arm_Sum": 1685,
			"ant_eink_arm": 20.7,
			"SozialQuote": 3.4,
			"SozialBeziehende": 680,
			"Mietpreis": "NA"
		},
		{
			"": 6219,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3746,
			"SteuerEinkommen_P25": 56.9,
			"SteuerEinkommen_Median": 80.05,
			"SteuerEinkommen_P75": 117.3,
			"eink_arm_Sum": 298,
			"ant_eink_arm": 8,
			"SozialQuote": 3.4,
			"SozialBeziehende": 680,
			"Mietpreis": "NA"
		},
		{
			"": 6242,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7298,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 38.6,
			"SteuerEinkommen_P75": 58.1,
			"eink_arm_Sum": 1859,
			"ant_eink_arm": 25.5,
			"SozialQuote": 7,
			"SozialBeziehende": 998,
			"Mietpreis": "NA"
		},
		{
			"": 6243,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1885,
			"SteuerEinkommen_P25": 45,
			"SteuerEinkommen_Median": 64.6,
			"SteuerEinkommen_P75": 89.9,
			"eink_arm_Sum": 286,
			"ant_eink_arm": 15.2,
			"SozialQuote": 7,
			"SozialBeziehende": 998,
			"Mietpreis": "NA"
		},
		{
			"": 6289,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6049,
			"SteuerEinkommen_P25": 17.6,
			"SteuerEinkommen_Median": 34.2,
			"SteuerEinkommen_P75": 51.3,
			"eink_arm_Sum": 1618,
			"ant_eink_arm": 26.7,
			"SozialQuote": 6.6,
			"SozialBeziehende": 1171,
			"Mietpreis": "NA"
		},
		{
			"": 6290,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3552,
			"SteuerEinkommen_P25": 45.6,
			"SteuerEinkommen_Median": 64.7,
			"SteuerEinkommen_P75": 87.6,
			"eink_arm_Sum": 465,
			"ant_eink_arm": 13.1,
			"SozialQuote": 6.6,
			"SozialBeziehende": 1171,
			"Mietpreis": "NA"
		},
		{
			"": 6313,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7536,
			"SteuerEinkommen_P25": 18.6,
			"SteuerEinkommen_Median": 38.7,
			"SteuerEinkommen_P75": 59.2,
			"eink_arm_Sum": 1905,
			"ant_eink_arm": 25.3,
			"SozialQuote": 6.4,
			"SozialBeziehende": 1098,
			"Mietpreis": "NA"
		},
		{
			"": 6314,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2728,
			"SteuerEinkommen_P25": 46.7,
			"SteuerEinkommen_Median": 70,
			"SteuerEinkommen_P75": 99.5,
			"eink_arm_Sum": 372,
			"ant_eink_arm": 13.6,
			"SozialQuote": 6.4,
			"SozialBeziehende": 1098,
			"Mietpreis": "NA"
		},
		{
			"": 6336,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6513,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 34.2,
			"SteuerEinkommen_P75": 51.3,
			"eink_arm_Sum": 1779,
			"ant_eink_arm": 27.3,
			"SozialQuote": 9.1,
			"SozialBeziehende": 1660,
			"Mietpreis": "NA"
		},
		{
			"": 6337,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3386,
			"SteuerEinkommen_P25": 41.9,
			"SteuerEinkommen_Median": 60.2,
			"SteuerEinkommen_P75": 81.4,
			"eink_arm_Sum": 546,
			"ant_eink_arm": 16.1,
			"SozialQuote": 9.1,
			"SozialBeziehende": 1660,
			"Mietpreis": "NA"
		},
		{
			"": 6382,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1776,
			"SteuerEinkommen_P25": 13.3,
			"SteuerEinkommen_Median": 29.7,
			"SteuerEinkommen_P75": 44.3,
			"eink_arm_Sum": 572,
			"ant_eink_arm": 32.2,
			"SozialQuote": 9.2,
			"SozialBeziehende": 595,
			"Mietpreis": "NA"
		},
		{
			"": 6383,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1292,
			"SteuerEinkommen_P25": 39.85,
			"SteuerEinkommen_Median": 56.95,
			"SteuerEinkommen_P75": 74.75,
			"eink_arm_Sum": 217,
			"ant_eink_arm": 16.8,
			"SozialQuote": 9.2,
			"SozialBeziehende": 595,
			"Mietpreis": "NA"
		},
		{
			"": 6404,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3618,
			"SteuerEinkommen_P25": 18.2,
			"SteuerEinkommen_Median": 31.9,
			"SteuerEinkommen_P75": 47.7,
			"eink_arm_Sum": 940,
			"ant_eink_arm": 26,
			"SozialQuote": 9.2,
			"SozialBeziehende": 883,
			"Mietpreis": "NA"
		},
		{
			"": 6405,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1752,
			"SteuerEinkommen_P25": 40.05,
			"SteuerEinkommen_Median": 57.2,
			"SteuerEinkommen_P75": 77.3,
			"eink_arm_Sum": 301,
			"ant_eink_arm": 17.2,
			"SozialQuote": 9.2,
			"SozialBeziehende": 883,
			"Mietpreis": "NA"
		},
		{
			"": 6427,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3507,
			"SteuerEinkommen_P25": 14.9,
			"SteuerEinkommen_Median": 29.2,
			"SteuerEinkommen_P75": 42.6,
			"eink_arm_Sum": 1082,
			"ant_eink_arm": 30.9,
			"SozialQuote": 8.1,
			"SozialBeziehende": 877,
			"Mietpreis": "NA"
		},
		{
			"": 6428,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2113,
			"SteuerEinkommen_P25": 41.4,
			"SteuerEinkommen_Median": 58.1,
			"SteuerEinkommen_P75": 75.1,
			"eink_arm_Sum": 313,
			"ant_eink_arm": 14.8,
			"SozialQuote": 8.1,
			"SozialBeziehende": 877,
			"Mietpreis": "NA"
		},
		{
			"": 6497,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1631,
			"SteuerEinkommen_P25": 18.2,
			"SteuerEinkommen_Median": 44.5,
			"SteuerEinkommen_P75": 74.75,
			"eink_arm_Sum": 424,
			"ant_eink_arm": 26,
			"SozialQuote": 5.1,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 6498,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 295,
			"SteuerEinkommen_P25": 62.7,
			"SteuerEinkommen_Median": 100.8,
			"SteuerEinkommen_P75": 158.3,
			"eink_arm_Sum": 24,
			"ant_eink_arm": 8.1,
			"SozialQuote": 5.1,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 6521,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 292,
			"SteuerEinkommen_P25": 12.1,
			"SteuerEinkommen_Median": 33.05,
			"SteuerEinkommen_P75": 64.25,
			"eink_arm_Sum": 101,
			"ant_eink_arm": 34.6,
			"SozialQuote": 2.7,
			"SozialBeziehende": 15,
			"Mietpreis": "NA"
		},
		{
			"": 6522,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 70,
			"SteuerEinkommen_P25": 50.9,
			"SteuerEinkommen_Median": 101.9,
			"SteuerEinkommen_P75": 191.2,
			"eink_arm_Sum": 8,
			"ant_eink_arm": 11.4,
			"SozialQuote": 2.7,
			"SozialBeziehende": 15,
			"Mietpreis": "NA"
		},
		{
			"": 6542,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1230,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 21.5,
			"SteuerEinkommen_P75": 50,
			"eink_arm_Sum": 566,
			"ant_eink_arm": 46,
			"SozialQuote": 1.2,
			"SozialBeziehende": 19,
			"Mietpreis": "NA"
		},
		{
			"": 6543,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 132,
			"SteuerEinkommen_P25": 59.2,
			"SteuerEinkommen_Median": 102,
			"SteuerEinkommen_P75": 181.7,
			"eink_arm_Sum": 19,
			"ant_eink_arm": 14.4,
			"SozialQuote": 1.2,
			"SozialBeziehende": 19,
			"Mietpreis": "NA"
		},
		{
			"": 6563,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 585,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 14.3,
			"SteuerEinkommen_P75": 51.5,
			"eink_arm_Sum": 326,
			"ant_eink_arm": 55.7,
			"SozialQuote": 5.7,
			"SozialBeziehende": 58,
			"Mietpreis": "NA"
		},
		{
			"": 6564,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 92,
			"SteuerEinkommen_P25": 50.45,
			"SteuerEinkommen_Median": 82.3,
			"SteuerEinkommen_P75": 119.1,
			"eink_arm_Sum": 12,
			"ant_eink_arm": 13,
			"SozialQuote": 5.7,
			"SozialBeziehende": 58,
			"Mietpreis": "NA"
		},
		{
			"": 6608,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6525,
			"SteuerEinkommen_P25": 18.6,
			"SteuerEinkommen_Median": 38.75,
			"SteuerEinkommen_P75": 60.45,
			"eink_arm_Sum": 1658,
			"ant_eink_arm": 25.4,
			"SozialQuote": 3.9,
			"SozialBeziehende": 573,
			"Mietpreis": "NA"
		},
		{
			"": 6609,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2463,
			"SteuerEinkommen_P25": 52.1,
			"SteuerEinkommen_Median": 74.4,
			"SteuerEinkommen_P75": 110,
			"eink_arm_Sum": 273,
			"ant_eink_arm": 11.1,
			"SozialQuote": 3.9,
			"SozialBeziehende": 573,
			"Mietpreis": "NA"
		},
		{
			"": 6632,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1708,
			"SteuerEinkommen_P25": 18.6,
			"SteuerEinkommen_Median": 35,
			"SteuerEinkommen_P75": 54.3,
			"eink_arm_Sum": 435,
			"ant_eink_arm": 25.5,
			"SozialQuote": 5.2,
			"SozialBeziehende": 249,
			"Mietpreis": "NA"
		},
		{
			"": 6633,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 944,
			"SteuerEinkommen_P25": 49.1,
			"SteuerEinkommen_Median": 70.3,
			"SteuerEinkommen_P75": 98.2,
			"eink_arm_Sum": 122,
			"ant_eink_arm": 12.9,
			"SozialQuote": 5.2,
			"SozialBeziehende": 249,
			"Mietpreis": "NA"
		},
		{
			"": 6654,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3605,
			"SteuerEinkommen_P25": 22.9,
			"SteuerEinkommen_Median": 48.6,
			"SteuerEinkommen_P75": 77.55,
			"eink_arm_Sum": 753,
			"ant_eink_arm": 20.9,
			"SozialQuote": 3,
			"SozialBeziehende": 238,
			"Mietpreis": "NA"
		},
		{
			"": 6655,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1200,
			"SteuerEinkommen_P25": 59.8,
			"SteuerEinkommen_Median": 97.9,
			"SteuerEinkommen_P75": 161.9,
			"eink_arm_Sum": 113,
			"ant_eink_arm": 9.4,
			"SozialQuote": 3,
			"SozialBeziehende": 238,
			"Mietpreis": "NA"
		},
		{
			"": 6699,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6606,
			"SteuerEinkommen_P25": 22.5,
			"SteuerEinkommen_Median": 42.4,
			"SteuerEinkommen_P75": 63.7,
			"eink_arm_Sum": 1336,
			"ant_eink_arm": 20.2,
			"SozialQuote": 7.2,
			"SozialBeziehende": 992,
			"Mietpreis": "NA"
		},
		{
			"": 6700,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1876,
			"SteuerEinkommen_P25": 42.2,
			"SteuerEinkommen_Median": 66.2,
			"SteuerEinkommen_P75": 100,
			"eink_arm_Sum": 318,
			"ant_eink_arm": 17,
			"SozialQuote": 7.2,
			"SozialBeziehende": 992,
			"Mietpreis": "NA"
		},
		{
			"": 6722,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3069,
			"SteuerEinkommen_P25": 9.4,
			"SteuerEinkommen_Median": 28.2,
			"SteuerEinkommen_P75": 47.1,
			"eink_arm_Sum": 1102,
			"ant_eink_arm": 35.9,
			"SozialQuote": 5.9,
			"SozialBeziehende": 593,
			"Mietpreis": "NA"
		},
		{
			"": 6723,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1902,
			"SteuerEinkommen_P25": 47.4,
			"SteuerEinkommen_Median": 63.8,
			"SteuerEinkommen_P75": 85.2,
			"eink_arm_Sum": 227,
			"ant_eink_arm": 11.9,
			"SozialQuote": 5.9,
			"SozialBeziehende": 593,
			"Mietpreis": "NA"
		},
		{
			"": 6745,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9120,
			"SteuerEinkommen_P25": 18.05,
			"SteuerEinkommen_Median": 35.8,
			"SteuerEinkommen_P75": 54.5,
			"eink_arm_Sum": 2391,
			"ant_eink_arm": 26.2,
			"SozialQuote": 9.6,
			"SozialBeziehende": 1808,
			"Mietpreis": "NA"
		},
		{
			"": 6746,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2543,
			"SteuerEinkommen_P25": 36.1,
			"SteuerEinkommen_Median": 55.7,
			"SteuerEinkommen_P75": 77.5,
			"eink_arm_Sum": 562,
			"ant_eink_arm": 22.1,
			"SozialQuote": 9.6,
			"SozialBeziehende": 1808,
			"Mietpreis": "NA"
		},
		{
			"": 6791,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1967,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 39.8,
			"SteuerEinkommen_P75": 61,
			"eink_arm_Sum": 487,
			"ant_eink_arm": 24.8,
			"SozialQuote": 6.5,
			"SozialBeziehende": 224,
			"Mietpreis": "NA"
		},
		{
			"": 6792,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 362,
			"SteuerEinkommen_P25": 32.3,
			"SteuerEinkommen_Median": 58.5,
			"SteuerEinkommen_P75": 91.2,
			"eink_arm_Sum": 99,
			"ant_eink_arm": 27.3,
			"SozialQuote": 6.5,
			"SozialBeziehende": 224,
			"Mietpreis": "NA"
		},
		{
			"": 6814,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5306,
			"SteuerEinkommen_P25": 15,
			"SteuerEinkommen_Median": 34.2,
			"SteuerEinkommen_P75": 55.8,
			"eink_arm_Sum": 1655,
			"ant_eink_arm": 31.2,
			"SozialQuote": 13.7,
			"SozialBeziehende": 1248,
			"Mietpreis": "NA"
		},
		{
			"": 6815,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 950,
			"SteuerEinkommen_P25": 31.5,
			"SteuerEinkommen_Median": 52.1,
			"SteuerEinkommen_P75": 74.7,
			"eink_arm_Sum": 264,
			"ant_eink_arm": 27.8,
			"SozialQuote": 13.7,
			"SozialBeziehende": 1248,
			"Mietpreis": "NA"
		},
		{
			"": 6836,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5171,
			"SteuerEinkommen_P25": 14.8,
			"SteuerEinkommen_Median": 29.2,
			"SteuerEinkommen_P75": 45.8,
			"eink_arm_Sum": 1669,
			"ant_eink_arm": 32.3,
			"SozialQuote": 10.3,
			"SozialBeziehende": 1196,
			"Mietpreis": "NA"
		},
		{
			"": 6837,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1790,
			"SteuerEinkommen_P25": 34.85,
			"SteuerEinkommen_Median": 52.1,
			"SteuerEinkommen_P75": 70.1,
			"eink_arm_Sum": 424,
			"ant_eink_arm": 23.7,
			"SozialQuote": 10.3,
			"SozialBeziehende": 1196,
			"Mietpreis": "NA"
		},
		{
			"": 6881,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4700,
			"SteuerEinkommen_P25": 16.1,
			"SteuerEinkommen_Median": 35.7,
			"SteuerEinkommen_P75": 57.2,
			"eink_arm_Sum": 1359,
			"ant_eink_arm": 28.9,
			"SozialQuote": 8.2,
			"SozialBeziehende": 724,
			"Mietpreis": "NA"
		},
		{
			"": 6882,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1056,
			"SteuerEinkommen_P25": 38.2,
			"SteuerEinkommen_Median": 56.3,
			"SteuerEinkommen_P75": 77.5,
			"eink_arm_Sum": 218,
			"ant_eink_arm": 20.6,
			"SozialQuote": 8.2,
			"SozialBeziehende": 724,
			"Mietpreis": "NA"
		},
		{
			"": 6904,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1343,
			"SteuerEinkommen_P25": 24.6,
			"SteuerEinkommen_Median": 46.9,
			"SteuerEinkommen_P75": 71.7,
			"eink_arm_Sum": 268,
			"ant_eink_arm": 20,
			"SozialQuote": 7,
			"SozialBeziehende": 174,
			"Mietpreis": "NA"
		},
		{
			"": 6905,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 313,
			"SteuerEinkommen_P25": 44.5,
			"SteuerEinkommen_Median": 72.9,
			"SteuerEinkommen_P75": 117.7,
			"eink_arm_Sum": 43,
			"ant_eink_arm": 13.7,
			"SozialQuote": 7,
			"SozialBeziehende": 174,
			"Mietpreis": "NA"
		},
		{
			"": 6948,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8391,
			"SteuerEinkommen_P25": 21.5,
			"SteuerEinkommen_Median": 41.5,
			"SteuerEinkommen_P75": 64.2,
			"eink_arm_Sum": 1820,
			"ant_eink_arm": 21.7,
			"SozialQuote": 4.1,
			"SozialBeziehende": 748,
			"Mietpreis": "NA"
		},
		{
			"": 6949,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2733,
			"SteuerEinkommen_P25": 50.2,
			"SteuerEinkommen_Median": 71.1,
			"SteuerEinkommen_P75": 105.1,
			"eink_arm_Sum": 305,
			"ant_eink_arm": 11.2,
			"SozialQuote": 4.1,
			"SozialBeziehende": 748,
			"Mietpreis": "NA"
		},
		{
			"": 6971,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3901,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 47.1,
			"SteuerEinkommen_P75": 77.1,
			"eink_arm_Sum": 884,
			"ant_eink_arm": 22.7,
			"SozialQuote": 1.9,
			"SozialBeziehende": 157,
			"Mietpreis": "NA"
		},
		{
			"": 6972,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1310,
			"SteuerEinkommen_P25": 68.2,
			"SteuerEinkommen_Median": 109.6,
			"SteuerEinkommen_P75": 174.85,
			"eink_arm_Sum": 115,
			"ant_eink_arm": 8.8,
			"SozialQuote": 1.9,
			"SozialBeziehende": 157,
			"Mietpreis": "NA"
		},
		{
			"": 7017,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2769,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 50.3,
			"SteuerEinkommen_P75": 87.6,
			"eink_arm_Sum": 737,
			"ant_eink_arm": 26.6,
			"SozialQuote": 1.4,
			"SozialBeziehende": 93,
			"Mietpreis": "NA"
		},
		{
			"": 7018,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1192,
			"SteuerEinkommen_P25": 80.5,
			"SteuerEinkommen_Median": 139.35,
			"SteuerEinkommen_P75": 244.8,
			"eink_arm_Sum": 77,
			"ant_eink_arm": 6.5,
			"SozialQuote": 1.4,
			"SozialBeziehende": 93,
			"Mietpreis": "NA"
		},
		{
			"": 7040,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4425,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 47.5,
			"SteuerEinkommen_P75": 77.3,
			"eink_arm_Sum": 1045,
			"ant_eink_arm": 23.6,
			"SozialQuote": 1.5,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 7041,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1403,
			"SteuerEinkommen_P25": 69.3,
			"SteuerEinkommen_Median": 116.4,
			"SteuerEinkommen_P75": 197.7,
			"eink_arm_Sum": 116,
			"ant_eink_arm": 8.3,
			"SozialQuote": 1.5,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 7063,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3198,
			"SteuerEinkommen_P25": 21,
			"SteuerEinkommen_Median": 43.9,
			"SteuerEinkommen_P75": 68.7,
			"eink_arm_Sum": 726,
			"ant_eink_arm": 22.7,
			"SozialQuote": 2.5,
			"SozialBeziehende": 161,
			"Mietpreis": "NA"
		},
		{
			"": 7064,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 976,
			"SteuerEinkommen_P25": 59.8,
			"SteuerEinkommen_Median": 92.85,
			"SteuerEinkommen_P75": 158.4,
			"eink_arm_Sum": 92,
			"ant_eink_arm": 9.4,
			"SozialQuote": 2.5,
			"SozialBeziehende": 161,
			"Mietpreis": "NA"
		},
		{
			"": 7085,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3830,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 43.4,
			"SteuerEinkommen_P75": 67.1,
			"eink_arm_Sum": 951,
			"ant_eink_arm": 24.8,
			"SozialQuote": 1.6,
			"SozialBeziehende": 158,
			"Mietpreis": "NA"
		},
		{
			"": 7086,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1879,
			"SteuerEinkommen_P25": 59.1,
			"SteuerEinkommen_Median": 92.3,
			"SteuerEinkommen_P75": 141.6,
			"eink_arm_Sum": 175,
			"ant_eink_arm": 9.3,
			"SozialQuote": 1.6,
			"SozialBeziehende": 158,
			"Mietpreis": "NA"
		},
		{
			"": 7132,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2568,
			"SteuerEinkommen_P25": 24.5,
			"SteuerEinkommen_Median": 49.8,
			"SteuerEinkommen_P75": 78.1,
			"eink_arm_Sum": 495,
			"ant_eink_arm": 19.3,
			"SozialQuote": 3.1,
			"SozialBeziehende": 139,
			"Mietpreis": "NA"
		},
		{
			"": 7133,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 511,
			"SteuerEinkommen_P25": 55.2,
			"SteuerEinkommen_Median": 92.1,
			"SteuerEinkommen_P75": 139,
			"eink_arm_Sum": 47,
			"ant_eink_arm": 9.2,
			"SozialQuote": 3.1,
			"SozialBeziehende": 139,
			"Mietpreis": "NA"
		},
		{
			"": 7154,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2796,
			"SteuerEinkommen_P25": 20.95,
			"SteuerEinkommen_Median": 45.5,
			"SteuerEinkommen_P75": 72.4,
			"eink_arm_Sum": 645,
			"ant_eink_arm": 23.1,
			"SozialQuote": 2.4,
			"SozialBeziehende": 123,
			"Mietpreis": "NA"
		},
		{
			"": 7155,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 611,
			"SteuerEinkommen_P25": 56.9,
			"SteuerEinkommen_Median": 93.9,
			"SteuerEinkommen_P75": 143.1,
			"eink_arm_Sum": 61,
			"ant_eink_arm": 10,
			"SozialQuote": 2.4,
			"SozialBeziehende": 123,
			"Mietpreis": "NA"
		},
		{
			"": 7177,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1984,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 44,
			"SteuerEinkommen_P75": 66.7,
			"eink_arm_Sum": 515,
			"ant_eink_arm": 26,
			"SozialQuote": 1.9,
			"SozialBeziehende": 86,
			"Mietpreis": "NA"
		},
		{
			"": 7178,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 686,
			"SteuerEinkommen_P25": 62.5,
			"SteuerEinkommen_Median": 91.1,
			"SteuerEinkommen_P75": 142.2,
			"eink_arm_Sum": 47,
			"ant_eink_arm": 6.9,
			"SozialQuote": 1.9,
			"SozialBeziehende": 86,
			"Mietpreis": "NA"
		},
		{
			"": 7222,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7025,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 36,
			"SteuerEinkommen_P75": 55,
			"eink_arm_Sum": 1728,
			"ant_eink_arm": 24.6,
			"SozialQuote": 5.7,
			"SozialBeziehende": 939,
			"Mietpreis": "NA"
		},
		{
			"": 7223,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3063,
			"SteuerEinkommen_P25": 47,
			"SteuerEinkommen_Median": 66.4,
			"SteuerEinkommen_P75": 91.8,
			"eink_arm_Sum": 408,
			"ant_eink_arm": 13.3,
			"SozialQuote": 5.7,
			"SozialBeziehende": 939,
			"Mietpreis": "NA"
		},
		{
			"": 7244,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 10622,
			"SteuerEinkommen_P25": 18.25,
			"SteuerEinkommen_Median": 35.9,
			"SteuerEinkommen_P75": 53.4,
			"eink_arm_Sum": 2755,
			"ant_eink_arm": 25.9,
			"SozialQuote": 8,
			"SozialBeziehende": 2164,
			"Mietpreis": "NA"
		},
		{
			"": 7245,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5090,
			"SteuerEinkommen_P25": 44.1,
			"SteuerEinkommen_Median": 61.1,
			"SteuerEinkommen_P75": 82.8,
			"eink_arm_Sum": 768,
			"ant_eink_arm": 15.1,
			"SozialQuote": 8,
			"SozialBeziehende": 2164,
			"Mietpreis": "NA"
		},
		{
			"": 7291,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8254,
			"SteuerEinkommen_P25": 22.7,
			"SteuerEinkommen_Median": 44.85,
			"SteuerEinkommen_P75": 67.35,
			"eink_arm_Sum": 1664,
			"ant_eink_arm": 20.2,
			"SozialQuote": 3.6,
			"SozialBeziehende": 720,
			"Mietpreis": "NA"
		},
		{
			"": 7292,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3711,
			"SteuerEinkommen_P25": 57.9,
			"SteuerEinkommen_Median": 82.1,
			"SteuerEinkommen_P75": 121.1,
			"eink_arm_Sum": 300,
			"ant_eink_arm": 8.1,
			"SozialQuote": 3.6,
			"SozialBeziehende": 720,
			"Mietpreis": "NA"
		},
		{
			"": 7315,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7422,
			"SteuerEinkommen_P25": 18.1,
			"SteuerEinkommen_Median": 38.6,
			"SteuerEinkommen_P75": 58.8,
			"eink_arm_Sum": 1927,
			"ant_eink_arm": 26,
			"SozialQuote": 6.8,
			"SozialBeziehende": 970,
			"Mietpreis": "NA"
		},
		{
			"": 7316,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1847,
			"SteuerEinkommen_P25": 45.05,
			"SteuerEinkommen_Median": 65.2,
			"SteuerEinkommen_P75": 93.7,
			"eink_arm_Sum": 281,
			"ant_eink_arm": 15.2,
			"SozialQuote": 6.8,
			"SozialBeziehende": 970,
			"Mietpreis": "NA"
		},
		{
			"": 7362,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6080,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 34.8,
			"SteuerEinkommen_P75": 52.2,
			"eink_arm_Sum": 1623,
			"ant_eink_arm": 26.7,
			"SozialQuote": 7.1,
			"SozialBeziehende": 1266,
			"Mietpreis": "NA"
		},
		{
			"": 7363,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3482,
			"SteuerEinkommen_P25": 45.4,
			"SteuerEinkommen_Median": 64.3,
			"SteuerEinkommen_P75": 87.3,
			"eink_arm_Sum": 465,
			"ant_eink_arm": 13.4,
			"SozialQuote": 7.1,
			"SozialBeziehende": 1266,
			"Mietpreis": "NA"
		},
		{
			"": 7385,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7729,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 38.5,
			"SteuerEinkommen_P75": 60.1,
			"eink_arm_Sum": 1979,
			"ant_eink_arm": 25.6,
			"SozialQuote": 6.8,
			"SozialBeziehende": 1186,
			"Mietpreis": "NA"
		},
		{
			"": 7386,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2722,
			"SteuerEinkommen_P25": 47.2,
			"SteuerEinkommen_Median": 69.8,
			"SteuerEinkommen_P75": 103,
			"eink_arm_Sum": 369,
			"ant_eink_arm": 13.6,
			"SozialQuote": 6.8,
			"SozialBeziehende": 1186,
			"Mietpreis": "NA"
		},
		{
			"": 7408,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6748,
			"SteuerEinkommen_P25": 16.9,
			"SteuerEinkommen_Median": 34.4,
			"SteuerEinkommen_P75": 52.1,
			"eink_arm_Sum": 1851,
			"ant_eink_arm": 27.4,
			"SozialQuote": 9.8,
			"SozialBeziehende": 1813,
			"Mietpreis": "NA"
		},
		{
			"": 7409,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3371,
			"SteuerEinkommen_P25": 41.4,
			"SteuerEinkommen_Median": 60.7,
			"SteuerEinkommen_P75": 82.6,
			"eink_arm_Sum": 562,
			"ant_eink_arm": 16.7,
			"SozialQuote": 9.8,
			"SozialBeziehende": 1813,
			"Mietpreis": "NA"
		},
		{
			"": 7454,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1771,
			"SteuerEinkommen_P25": 13.7,
			"SteuerEinkommen_Median": 29.3,
			"SteuerEinkommen_P75": 45,
			"eink_arm_Sum": 595,
			"ant_eink_arm": 33.6,
			"SozialQuote": 12,
			"SozialBeziehende": 782,
			"Mietpreis": "NA"
		},
		{
			"": 7455,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1262,
			"SteuerEinkommen_P25": 39,
			"SteuerEinkommen_Median": 56,
			"SteuerEinkommen_P75": 75,
			"eink_arm_Sum": 231,
			"ant_eink_arm": 18.3,
			"SozialQuote": 12,
			"SozialBeziehende": 782,
			"Mietpreis": "NA"
		},
		{
			"": 7476,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3569,
			"SteuerEinkommen_P25": 16.6,
			"SteuerEinkommen_Median": 31.3,
			"SteuerEinkommen_P75": 48,
			"eink_arm_Sum": 1012,
			"ant_eink_arm": 28.4,
			"SozialQuote": 10.4,
			"SozialBeziehende": 1003,
			"Mietpreis": "NA"
		},
		{
			"": 7477,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1755,
			"SteuerEinkommen_P25": 38.6,
			"SteuerEinkommen_Median": 56.4,
			"SteuerEinkommen_P75": 76.2,
			"eink_arm_Sum": 333,
			"ant_eink_arm": 19,
			"SozialQuote": 10.4,
			"SozialBeziehende": 1003,
			"Mietpreis": "NA"
		},
		{
			"": 7499,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3547,
			"SteuerEinkommen_P25": 13.9,
			"SteuerEinkommen_Median": 28.5,
			"SteuerEinkommen_P75": 43,
			"eink_arm_Sum": 1154,
			"ant_eink_arm": 32.5,
			"SozialQuote": 9.8,
			"SozialBeziehende": 1057,
			"Mietpreis": "NA"
		},
		{
			"": 7500,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2065,
			"SteuerEinkommen_P25": 40,
			"SteuerEinkommen_Median": 57.3,
			"SteuerEinkommen_P75": 74.1,
			"eink_arm_Sum": 360,
			"ant_eink_arm": 17.4,
			"SozialQuote": 9.8,
			"SozialBeziehende": 1057,
			"Mietpreis": "NA"
		},
		{
			"": 7568,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1589,
			"SteuerEinkommen_P25": 19.5,
			"SteuerEinkommen_Median": 46.2,
			"SteuerEinkommen_P75": 75.7,
			"eink_arm_Sum": 403,
			"ant_eink_arm": 25.4,
			"SozialQuote": 3.8,
			"SozialBeziehende": 102,
			"Mietpreis": "NA"
		},
		{
			"": 7569,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 302,
			"SteuerEinkommen_P25": 61.9,
			"SteuerEinkommen_Median": 107.1,
			"SteuerEinkommen_P75": 166.1,
			"eink_arm_Sum": 22,
			"ant_eink_arm": 7.3,
			"SozialQuote": 3.8,
			"SozialBeziehende": 102,
			"Mietpreis": "NA"
		},
		{
			"": 7590,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 292,
			"SteuerEinkommen_P25": 12.2,
			"SteuerEinkommen_Median": 33.5,
			"SteuerEinkommen_P75": 71.5,
			"eink_arm_Sum": 94,
			"ant_eink_arm": 32.2,
			"SozialQuote": 1.8,
			"SozialBeziehende": 10,
			"Mietpreis": "NA"
		},
		{
			"": 7591,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 74,
			"SteuerEinkommen_P25": 50.4,
			"SteuerEinkommen_Median": 99.9,
			"SteuerEinkommen_P75": 203.5,
			"eink_arm_Sum": 10,
			"ant_eink_arm": 13.5,
			"SozialQuote": 1.8,
			"SozialBeziehende": 10,
			"Mietpreis": "NA"
		},
		{
			"": 7611,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1194,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 21.9,
			"SteuerEinkommen_P75": 52.6,
			"eink_arm_Sum": 557,
			"ant_eink_arm": 46.6,
			"SozialQuote": 9.9,
			"SozialBeziehende": 161,
			"Mietpreis": "NA"
		},
		{
			"": 7612,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 135,
			"SteuerEinkommen_P25": 52.4,
			"SteuerEinkommen_Median": 96.35,
			"SteuerEinkommen_P75": 172.9,
			"eink_arm_Sum": 25,
			"ant_eink_arm": 18.5,
			"SozialQuote": 9.9,
			"SozialBeziehende": 161,
			"Mietpreis": "NA"
		},
		{
			"": 7633,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 576,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 11.45,
			"SteuerEinkommen_P75": 46,
			"eink_arm_Sum": 346,
			"ant_eink_arm": 60.1,
			"SozialQuote": 13.7,
			"SozialBeziehende": 142,
			"Mietpreis": "NA"
		},
		{
			"": 7634,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 103,
			"SteuerEinkommen_P25": 57.3,
			"SteuerEinkommen_Median": 85.7,
			"SteuerEinkommen_P75": 131.1,
			"eink_arm_Sum": 12,
			"ant_eink_arm": 11.7,
			"SozialQuote": 13.7,
			"SozialBeziehende": 142,
			"Mietpreis": "NA"
		},
		{
			"": 7678,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6517,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 39.5,
			"SteuerEinkommen_P75": 61.6,
			"eink_arm_Sum": 1649,
			"ant_eink_arm": 25.3,
			"SozialQuote": 3.9,
			"SozialBeziehende": 579,
			"Mietpreis": "NA"
		},
		{
			"": 7679,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2436,
			"SteuerEinkommen_P25": 52,
			"SteuerEinkommen_Median": 74.3,
			"SteuerEinkommen_P75": 112.2,
			"eink_arm_Sum": 271,
			"ant_eink_arm": 11.1,
			"SozialQuote": 3.9,
			"SozialBeziehende": 579,
			"Mietpreis": "NA"
		},
		{
			"": 7702,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1730,
			"SteuerEinkommen_P25": 19.6,
			"SteuerEinkommen_Median": 35.6,
			"SteuerEinkommen_P75": 55.2,
			"eink_arm_Sum": 432,
			"ant_eink_arm": 25,
			"SozialQuote": 4.5,
			"SozialBeziehende": 217,
			"Mietpreis": "NA"
		},
		{
			"": 7703,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 964,
			"SteuerEinkommen_P25": 46.5,
			"SteuerEinkommen_Median": 69.2,
			"SteuerEinkommen_P75": 97.1,
			"eink_arm_Sum": 117,
			"ant_eink_arm": 12.1,
			"SozialQuote": 4.5,
			"SozialBeziehende": 217,
			"Mietpreis": "NA"
		},
		{
			"": 7724,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3570,
			"SteuerEinkommen_P25": 23.6,
			"SteuerEinkommen_Median": 50,
			"SteuerEinkommen_P75": 79.8,
			"eink_arm_Sum": 754,
			"ant_eink_arm": 21.1,
			"SozialQuote": 3,
			"SozialBeziehende": 231,
			"Mietpreis": "NA"
		},
		{
			"": 7725,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1192,
			"SteuerEinkommen_P25": 58.3,
			"SteuerEinkommen_Median": 97.3,
			"SteuerEinkommen_P75": 162.7,
			"eink_arm_Sum": 119,
			"ant_eink_arm": 10,
			"SozialQuote": 3,
			"SozialBeziehende": 231,
			"Mietpreis": "NA"
		},
		{
			"": 7770,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6684,
			"SteuerEinkommen_P25": 22.6,
			"SteuerEinkommen_Median": 43.9,
			"SteuerEinkommen_P75": 65.8,
			"eink_arm_Sum": 1380,
			"ant_eink_arm": 20.6,
			"SozialQuote": 6.9,
			"SozialBeziehende": 961,
			"Mietpreis": "NA"
		},
		{
			"": 7771,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1917,
			"SteuerEinkommen_P25": 39.2,
			"SteuerEinkommen_Median": 65.4,
			"SteuerEinkommen_P75": 103.1,
			"eink_arm_Sum": 379,
			"ant_eink_arm": 19.8,
			"SozialQuote": 6.9,
			"SozialBeziehende": 961,
			"Mietpreis": "NA"
		},
		{
			"": 7792,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3105,
			"SteuerEinkommen_P25": 9.7,
			"SteuerEinkommen_Median": 28.9,
			"SteuerEinkommen_P75": 48.3,
			"eink_arm_Sum": 1092,
			"ant_eink_arm": 35.2,
			"SozialQuote": 6.1,
			"SozialBeziehende": 604,
			"Mietpreis": "NA"
		},
		{
			"": 7793,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1895,
			"SteuerEinkommen_P25": 44.65,
			"SteuerEinkommen_Median": 62.1,
			"SteuerEinkommen_P75": 84.85,
			"eink_arm_Sum": 267,
			"ant_eink_arm": 14.1,
			"SozialQuote": 6.1,
			"SozialBeziehende": 604,
			"Mietpreis": "NA"
		},
		{
			"": 7815,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9148,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 36.9,
			"SteuerEinkommen_P75": 55.8,
			"eink_arm_Sum": 2381,
			"ant_eink_arm": 26,
			"SozialQuote": 8.8,
			"SozialBeziehende": 1634,
			"Mietpreis": "NA"
		},
		{
			"": 7816,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2464,
			"SteuerEinkommen_P25": 35.65,
			"SteuerEinkommen_Median": 54.5,
			"SteuerEinkommen_P75": 77.55,
			"eink_arm_Sum": 554,
			"ant_eink_arm": 22.5,
			"SozialQuote": 8.8,
			"SozialBeziehende": 1634,
			"Mietpreis": "NA"
		},
		{
			"": 7861,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1941,
			"SteuerEinkommen_P25": 19.8,
			"SteuerEinkommen_Median": 40.8,
			"SteuerEinkommen_P75": 62.9,
			"eink_arm_Sum": 486,
			"ant_eink_arm": 25,
			"SozialQuote": 6.1,
			"SozialBeziehende": 210,
			"Mietpreis": "NA"
		},
		{
			"": 7862,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 371,
			"SteuerEinkommen_P25": 29.5,
			"SteuerEinkommen_Median": 56.7,
			"SteuerEinkommen_P75": 91.8,
			"eink_arm_Sum": 106,
			"ant_eink_arm": 28.6,
			"SozialQuote": 6.1,
			"SozialBeziehende": 210,
			"Mietpreis": "NA"
		},
		{
			"": 7884,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5453,
			"SteuerEinkommen_P25": 15.1,
			"SteuerEinkommen_Median": 35,
			"SteuerEinkommen_P75": 56.8,
			"eink_arm_Sum": 1698,
			"ant_eink_arm": 31.1,
			"SozialQuote": 13.9,
			"SozialBeziehende": 1257,
			"Mietpreis": "NA"
		},
		{
			"": 7885,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 919,
			"SteuerEinkommen_P25": 30,
			"SteuerEinkommen_Median": 49.2,
			"SteuerEinkommen_P75": 73.4,
			"eink_arm_Sum": 279,
			"ant_eink_arm": 30.4,
			"SozialQuote": 13.9,
			"SozialBeziehende": 1257,
			"Mietpreis": "NA"
		},
		{
			"": 7906,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5149,
			"SteuerEinkommen_P25": 15.2,
			"SteuerEinkommen_Median": 29.8,
			"SteuerEinkommen_P75": 46.5,
			"eink_arm_Sum": 1649,
			"ant_eink_arm": 32,
			"SozialQuote": 10.3,
			"SozialBeziehende": 1174,
			"Mietpreis": "NA"
		},
		{
			"": 7907,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1731,
			"SteuerEinkommen_P25": 33.4,
			"SteuerEinkommen_Median": 50.2,
			"SteuerEinkommen_P75": 68.5,
			"eink_arm_Sum": 437,
			"ant_eink_arm": 25.2,
			"SozialQuote": 10.3,
			"SozialBeziehende": 1174,
			"Mietpreis": "NA"
		},
		{
			"": 7951,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4767,
			"SteuerEinkommen_P25": 16.7,
			"SteuerEinkommen_Median": 36.6,
			"SteuerEinkommen_P75": 58.5,
			"eink_arm_Sum": 1383,
			"ant_eink_arm": 29,
			"SozialQuote": 8.7,
			"SozialBeziehende": 771,
			"Mietpreis": "NA"
		},
		{
			"": 7952,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1065,
			"SteuerEinkommen_P25": 37,
			"SteuerEinkommen_Median": 56.2,
			"SteuerEinkommen_P75": 75.8,
			"eink_arm_Sum": 228,
			"ant_eink_arm": 21.4,
			"SozialQuote": 8.7,
			"SozialBeziehende": 771,
			"Mietpreis": "NA"
		},
		{
			"": 7973,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1485,
			"SteuerEinkommen_P25": 27.6,
			"SteuerEinkommen_Median": 50.65,
			"SteuerEinkommen_P75": 75.2,
			"eink_arm_Sum": 283,
			"ant_eink_arm": 19.1,
			"SozialQuote": 5.5,
			"SozialBeziehende": 148,
			"Mietpreis": "NA"
		},
		{
			"": 7974,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 321,
			"SteuerEinkommen_P25": 48.1,
			"SteuerEinkommen_Median": 75.5,
			"SteuerEinkommen_P75": 121.4,
			"eink_arm_Sum": 37,
			"ant_eink_arm": 11.5,
			"SozialQuote": 5.5,
			"SozialBeziehende": 148,
			"Mietpreis": "NA"
		},
		{
			"": 8018,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8435,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 41.4,
			"SteuerEinkommen_P75": 65.1,
			"eink_arm_Sum": 1918,
			"ant_eink_arm": 22.7,
			"SozialQuote": 4.2,
			"SozialBeziehende": 766,
			"Mietpreis": "NA"
		},
		{
			"": 8019,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2674,
			"SteuerEinkommen_P25": 49.9,
			"SteuerEinkommen_Median": 71.25,
			"SteuerEinkommen_P75": 106.3,
			"eink_arm_Sum": 316,
			"ant_eink_arm": 11.8,
			"SozialQuote": 4.2,
			"SozialBeziehende": 766,
			"Mietpreis": "NA"
		},
		{
			"": 8040,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3946,
			"SteuerEinkommen_P25": 22.3,
			"SteuerEinkommen_Median": 48.9,
			"SteuerEinkommen_P75": 78.45,
			"eink_arm_Sum": 845,
			"ant_eink_arm": 21.4,
			"SozialQuote": 1.9,
			"SozialBeziehende": 164,
			"Mietpreis": "NA"
		},
		{
			"": 8041,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1323,
			"SteuerEinkommen_P25": 70.1,
			"SteuerEinkommen_Median": 110.3,
			"SteuerEinkommen_P75": 181,
			"eink_arm_Sum": 96,
			"ant_eink_arm": 7.3,
			"SozialQuote": 1.9,
			"SozialBeziehende": 164,
			"Mietpreis": "NA"
		},
		{
			"": 8087,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2769,
			"SteuerEinkommen_P25": 18,
			"SteuerEinkommen_Median": 52.95,
			"SteuerEinkommen_P75": 93.1,
			"eink_arm_Sum": 721,
			"ant_eink_arm": 26,
			"SozialQuote": 1.3,
			"SozialBeziehende": 89,
			"Mietpreis": "NA"
		},
		{
			"": 8088,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1196,
			"SteuerEinkommen_P25": 81.9,
			"SteuerEinkommen_Median": 141.5,
			"SteuerEinkommen_P75": 250.7,
			"eink_arm_Sum": 79,
			"ant_eink_arm": 6.6,
			"SozialQuote": 1.3,
			"SozialBeziehende": 89,
			"Mietpreis": "NA"
		},
		{
			"": 8110,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4509,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 48.05,
			"SteuerEinkommen_P75": 80,
			"eink_arm_Sum": 1077,
			"ant_eink_arm": 23.9,
			"SozialQuote": 1.5,
			"SozialBeziehende": 144,
			"Mietpreis": "NA"
		},
		{
			"": 8111,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1419,
			"SteuerEinkommen_P25": 71.3,
			"SteuerEinkommen_Median": 120.5,
			"SteuerEinkommen_P75": 205.5,
			"eink_arm_Sum": 115,
			"ant_eink_arm": 8.1,
			"SozialQuote": 1.5,
			"SozialBeziehende": 144,
			"Mietpreis": "NA"
		},
		{
			"": 8133,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3253,
			"SteuerEinkommen_P25": 20.75,
			"SteuerEinkommen_Median": 43.5,
			"SteuerEinkommen_P75": 69.25,
			"eink_arm_Sum": 771,
			"ant_eink_arm": 23.7,
			"SozialQuote": 2.3,
			"SozialBeziehende": 149,
			"Mietpreis": "NA"
		},
		{
			"": 8134,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 958,
			"SteuerEinkommen_P25": 60.1,
			"SteuerEinkommen_Median": 95.75,
			"SteuerEinkommen_P75": 169.8,
			"eink_arm_Sum": 89,
			"ant_eink_arm": 9.3,
			"SozialQuote": 2.3,
			"SozialBeziehende": 149,
			"Mietpreis": "NA"
		},
		{
			"": 8155,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3865,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 44.4,
			"SteuerEinkommen_P75": 69.95,
			"eink_arm_Sum": 954,
			"ant_eink_arm": 24.7,
			"SozialQuote": 1.4,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 8156,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1871,
			"SteuerEinkommen_P25": 59.8,
			"SteuerEinkommen_Median": 91.5,
			"SteuerEinkommen_P75": 142.2,
			"eink_arm_Sum": 161,
			"ant_eink_arm": 8.6,
			"SozialQuote": 1.4,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 8201,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2501,
			"SteuerEinkommen_P25": 25.4,
			"SteuerEinkommen_Median": 52,
			"SteuerEinkommen_P75": 81.3,
			"eink_arm_Sum": 494,
			"ant_eink_arm": 19.8,
			"SozialQuote": 2.1,
			"SozialBeziehende": 92,
			"Mietpreis": "NA"
		},
		{
			"": 8202,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 492,
			"SteuerEinkommen_P25": 60.5,
			"SteuerEinkommen_Median": 100,
			"SteuerEinkommen_P75": 158.9,
			"eink_arm_Sum": 43,
			"ant_eink_arm": 8.7,
			"SozialQuote": 2.1,
			"SozialBeziehende": 92,
			"Mietpreis": "NA"
		},
		{
			"": 8224,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2738,
			"SteuerEinkommen_P25": 22,
			"SteuerEinkommen_Median": 47.55,
			"SteuerEinkommen_P75": 75.55,
			"eink_arm_Sum": 606,
			"ant_eink_arm": 22.1,
			"SozialQuote": 2.4,
			"SozialBeziehende": 119,
			"Mietpreis": "NA"
		},
		{
			"": 8225,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 607,
			"SteuerEinkommen_P25": 58.1,
			"SteuerEinkommen_Median": 94.1,
			"SteuerEinkommen_P75": 146.2,
			"eink_arm_Sum": 64,
			"ant_eink_arm": 10.5,
			"SozialQuote": 2.4,
			"SozialBeziehende": 119,
			"Mietpreis": "NA"
		},
		{
			"": 8246,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1956,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 44.6,
			"SteuerEinkommen_P75": 68.6,
			"eink_arm_Sum": 526,
			"ant_eink_arm": 26.9,
			"SozialQuote": 1.6,
			"SozialBeziehende": 70,
			"Mietpreis": "NA"
		},
		{
			"": 8247,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 693,
			"SteuerEinkommen_P25": 59.3,
			"SteuerEinkommen_Median": 88.2,
			"SteuerEinkommen_P75": 152.1,
			"eink_arm_Sum": 60,
			"ant_eink_arm": 8.7,
			"SozialQuote": 1.6,
			"SozialBeziehende": 70,
			"Mietpreis": "NA"
		},
		{
			"": 8291,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7120,
			"SteuerEinkommen_P25": 19.8,
			"SteuerEinkommen_Median": 37,
			"SteuerEinkommen_P75": 56,
			"eink_arm_Sum": 1761,
			"ant_eink_arm": 24.7,
			"SozialQuote": 5.6,
			"SozialBeziehende": 926,
			"Mietpreis": "NA"
		},
		{
			"": 8292,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3062,
			"SteuerEinkommen_P25": 45.7,
			"SteuerEinkommen_Median": 65.3,
			"SteuerEinkommen_P75": 92,
			"eink_arm_Sum": 438,
			"ant_eink_arm": 14.3,
			"SozialQuote": 5.6,
			"SozialBeziehende": 926,
			"Mietpreis": "NA"
		},
		{
			"": 8313,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 10871,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 36.6,
			"SteuerEinkommen_P75": 54.3,
			"eink_arm_Sum": 2823,
			"ant_eink_arm": 26,
			"SozialQuote": 7.9,
			"SozialBeziehende": 2179,
			"Mietpreis": "NA"
		},
		{
			"": 8314,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5065,
			"SteuerEinkommen_P25": 41.5,
			"SteuerEinkommen_Median": 59.9,
			"SteuerEinkommen_P75": 82.2,
			"eink_arm_Sum": 839,
			"ant_eink_arm": 16.6,
			"SozialQuote": 7.9,
			"SozialBeziehende": 2179,
			"Mietpreis": "NA"
		},
		{
			"": 8359,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8354,
			"SteuerEinkommen_P25": 23.5,
			"SteuerEinkommen_Median": 45.8,
			"SteuerEinkommen_P75": 68.4,
			"eink_arm_Sum": 1699,
			"ant_eink_arm": 20.3,
			"SozialQuote": 3.5,
			"SozialBeziehende": 712,
			"Mietpreis": "NA"
		},
		{
			"": 8360,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3746,
			"SteuerEinkommen_P25": 56.8,
			"SteuerEinkommen_Median": 81.35,
			"SteuerEinkommen_P75": 121.25,
			"eink_arm_Sum": 338,
			"ant_eink_arm": 9,
			"SozialQuote": 3.5,
			"SozialBeziehende": 712,
			"Mietpreis": "NA"
		},
		{
			"": 8382,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7422,
			"SteuerEinkommen_P25": 19.1,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 60.55,
			"eink_arm_Sum": 1894,
			"ant_eink_arm": 25.5,
			"SozialQuote": 6.4,
			"SozialBeziehende": 904,
			"Mietpreis": "NA"
		},
		{
			"": 8383,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1774,
			"SteuerEinkommen_P25": 43.6,
			"SteuerEinkommen_Median": 65.2,
			"SteuerEinkommen_P75": 92.6,
			"eink_arm_Sum": 298,
			"ant_eink_arm": 16.8,
			"SozialQuote": 6.4,
			"SozialBeziehende": 904,
			"Mietpreis": "NA"
		},
		{
			"": 8427,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6139,
			"SteuerEinkommen_P25": 17.8,
			"SteuerEinkommen_Median": 35,
			"SteuerEinkommen_P75": 52.6,
			"eink_arm_Sum": 1694,
			"ant_eink_arm": 27.6,
			"SozialQuote": 7.3,
			"SozialBeziehende": 1292,
			"Mietpreis": "NA"
		},
		{
			"": 8428,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3455,
			"SteuerEinkommen_P25": 43.3,
			"SteuerEinkommen_Median": 62.9,
			"SteuerEinkommen_P75": 86.2,
			"eink_arm_Sum": 522,
			"ant_eink_arm": 15.1,
			"SozialQuote": 7.3,
			"SozialBeziehende": 1292,
			"Mietpreis": "NA"
		},
		{
			"": 8449,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7983,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 40.1,
			"SteuerEinkommen_P75": 62.3,
			"eink_arm_Sum": 2080,
			"ant_eink_arm": 26.1,
			"SozialQuote": 6.9,
			"SozialBeziehende": 1250,
			"Mietpreis": "NA"
		},
		{
			"": 8450,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2775,
			"SteuerEinkommen_P25": 45.7,
			"SteuerEinkommen_Median": 69.9,
			"SteuerEinkommen_P75": 102.4,
			"eink_arm_Sum": 418,
			"ant_eink_arm": 15.1,
			"SozialQuote": 6.9,
			"SozialBeziehende": 1250,
			"Mietpreis": "NA"
		},
		{
			"": 8472,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7080,
			"SteuerEinkommen_P25": 17.2,
			"SteuerEinkommen_Median": 34.6,
			"SteuerEinkommen_P75": 53.6,
			"eink_arm_Sum": 1974,
			"ant_eink_arm": 27.9,
			"SozialQuote": 9.7,
			"SozialBeziehende": 1840,
			"Mietpreis": "NA"
		},
		{
			"": 8473,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3478,
			"SteuerEinkommen_P25": 39.15,
			"SteuerEinkommen_Median": 59.5,
			"SteuerEinkommen_P75": 83.2,
			"eink_arm_Sum": 660,
			"ant_eink_arm": 19,
			"SozialQuote": 9.7,
			"SozialBeziehende": 1840,
			"Mietpreis": "NA"
		},
		{
			"": 8518,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1819,
			"SteuerEinkommen_P25": 15,
			"SteuerEinkommen_Median": 30.95,
			"SteuerEinkommen_P75": 45.65,
			"eink_arm_Sum": 573,
			"ant_eink_arm": 31.5,
			"SozialQuote": 12,
			"SozialBeziehende": 777,
			"Mietpreis": "NA"
		},
		{
			"": 8519,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1273,
			"SteuerEinkommen_P25": 37,
			"SteuerEinkommen_Median": 54.9,
			"SteuerEinkommen_P75": 74.9,
			"eink_arm_Sum": 270,
			"ant_eink_arm": 21.2,
			"SozialQuote": 12,
			"SozialBeziehende": 777,
			"Mietpreis": "NA"
		},
		{
			"": 8540,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3677,
			"SteuerEinkommen_P25": 16.5,
			"SteuerEinkommen_Median": 30.8,
			"SteuerEinkommen_P75": 47.6,
			"eink_arm_Sum": 1080,
			"ant_eink_arm": 29.4,
			"SozialQuote": 11.6,
			"SozialBeziehende": 1140,
			"Mietpreis": "NA"
		},
		{
			"": 8541,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1770,
			"SteuerEinkommen_P25": 36.5,
			"SteuerEinkommen_Median": 54.6,
			"SteuerEinkommen_P75": 76,
			"eink_arm_Sum": 387,
			"ant_eink_arm": 21.9,
			"SozialQuote": 11.6,
			"SozialBeziehende": 1140,
			"Mietpreis": "NA"
		},
		{
			"": 8562,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3484,
			"SteuerEinkommen_P25": 14.5,
			"SteuerEinkommen_Median": 29.3,
			"SteuerEinkommen_P75": 43.6,
			"eink_arm_Sum": 1117,
			"ant_eink_arm": 32.1,
			"SozialQuote": 9.9,
			"SozialBeziehende": 1046,
			"Mietpreis": "NA"
		},
		{
			"": 8563,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2056,
			"SteuerEinkommen_P25": 37.5,
			"SteuerEinkommen_Median": 55.75,
			"SteuerEinkommen_P75": 73.4,
			"eink_arm_Sum": 411,
			"ant_eink_arm": 20,
			"SozialQuote": 9.9,
			"SozialBeziehende": 1046,
			"Mietpreis": "NA"
		},
		{
			"": 8631,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1587,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 47.15,
			"SteuerEinkommen_P75": 80.95,
			"eink_arm_Sum": 409,
			"ant_eink_arm": 25.8,
			"SozialQuote": 3.5,
			"SozialBeziehende": 95,
			"Mietpreis": "NA"
		},
		{
			"": 8632,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 297,
			"SteuerEinkommen_P25": 65.4,
			"SteuerEinkommen_Median": 111.15,
			"SteuerEinkommen_P75": 171.6,
			"eink_arm_Sum": 33,
			"ant_eink_arm": 11.1,
			"SozialQuote": 3.5,
			"SozialBeziehende": 95,
			"Mietpreis": "NA"
		},
		{
			"": 8652,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 280,
			"SteuerEinkommen_P25": 16.5,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 72.5,
			"eink_arm_Sum": 81,
			"ant_eink_arm": 28.9,
			"SozialQuote": 1.4,
			"SozialBeziehende": 8,
			"Mietpreis": "NA"
		},
		{
			"": 8653,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 71,
			"SteuerEinkommen_P25": 56.3,
			"SteuerEinkommen_Median": 107.3,
			"SteuerEinkommen_P75": 247.25,
			"eink_arm_Sum": 10,
			"ant_eink_arm": 14.1,
			"SozialQuote": 1.4,
			"SozialBeziehende": 8,
			"Mietpreis": "NA"
		},
		{
			"": 8672,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1182,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 22.7,
			"SteuerEinkommen_P75": 53.2,
			"eink_arm_Sum": 551,
			"ant_eink_arm": 46.6,
			"SozialQuote": 10.7,
			"SozialBeziehende": 172,
			"Mietpreis": "NA"
		},
		{
			"": 8673,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 132,
			"SteuerEinkommen_P25": 60.7,
			"SteuerEinkommen_Median": 110.9,
			"SteuerEinkommen_P75": 181.5,
			"eink_arm_Sum": 18,
			"ant_eink_arm": 13.6,
			"SozialQuote": 10.7,
			"SozialBeziehende": 172,
			"Mietpreis": "NA"
		},
		{
			"": 8694,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 603,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 13.8,
			"SteuerEinkommen_P75": 55.5,
			"eink_arm_Sum": 346,
			"ant_eink_arm": 57.4,
			"SozialQuote": 13.4,
			"SozialBeziehende": 143,
			"Mietpreis": "NA"
		},
		{
			"": 8695,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 96,
			"SteuerEinkommen_P25": 49.6,
			"SteuerEinkommen_Median": 86.55,
			"SteuerEinkommen_P75": 134.1,
			"eink_arm_Sum": 14,
			"ant_eink_arm": 14.6,
			"SozialQuote": 13.4,
			"SozialBeziehende": 143,
			"Mietpreis": "NA"
		},
		{
			"": 8738,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6633,
			"SteuerEinkommen_P25": 19.9,
			"SteuerEinkommen_Median": 40.8,
			"SteuerEinkommen_P75": 63.3,
			"eink_arm_Sum": 1715,
			"ant_eink_arm": 25.9,
			"SozialQuote": 3.3,
			"SozialBeziehende": 501,
			"Mietpreis": "NA"
		},
		{
			"": 8739,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2421,
			"SteuerEinkommen_P25": 53.9,
			"SteuerEinkommen_Median": 78.25,
			"SteuerEinkommen_P75": 119.7,
			"eink_arm_Sum": 265,
			"ant_eink_arm": 10.9,
			"SozialQuote": 3.3,
			"SozialBeziehende": 501,
			"Mietpreis": "NA"
		},
		{
			"": 8760,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1758,
			"SteuerEinkommen_P25": 20.4,
			"SteuerEinkommen_Median": 37.45,
			"SteuerEinkommen_P75": 56,
			"eink_arm_Sum": 430,
			"ant_eink_arm": 24.5,
			"SozialQuote": 4.6,
			"SozialBeziehende": 233,
			"Mietpreis": "NA"
		},
		{
			"": 8761,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 990,
			"SteuerEinkommen_P25": 49.6,
			"SteuerEinkommen_Median": 71.6,
			"SteuerEinkommen_P75": 100.7,
			"eink_arm_Sum": 120,
			"ant_eink_arm": 12.1,
			"SozialQuote": 4.6,
			"SozialBeziehende": 233,
			"Mietpreis": "NA"
		},
		{
			"": 8782,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3604,
			"SteuerEinkommen_P25": 25.4,
			"SteuerEinkommen_Median": 52.65,
			"SteuerEinkommen_P75": 87.1,
			"eink_arm_Sum": 718,
			"ant_eink_arm": 19.9,
			"SozialQuote": 2.6,
			"SozialBeziehende": 210,
			"Mietpreis": "NA"
		},
		{
			"": 8783,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1207,
			"SteuerEinkommen_P25": 62.2,
			"SteuerEinkommen_Median": 101.75,
			"SteuerEinkommen_P75": 171.9,
			"eink_arm_Sum": 125,
			"ant_eink_arm": 10.4,
			"SozialQuote": 2.6,
			"SozialBeziehende": 210,
			"Mietpreis": "NA"
		},
		{
			"": 8828,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6888,
			"SteuerEinkommen_P25": 24.1,
			"SteuerEinkommen_Median": 45.1,
			"SteuerEinkommen_P75": 68.3,
			"eink_arm_Sum": 1425,
			"ant_eink_arm": 20.7,
			"SozialQuote": 6,
			"SozialBeziehende": 861,
			"Mietpreis": "NA"
		},
		{
			"": 8829,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1915,
			"SteuerEinkommen_P25": 41.4,
			"SteuerEinkommen_Median": 69.45,
			"SteuerEinkommen_P75": 110.6,
			"eink_arm_Sum": 371,
			"ant_eink_arm": 19.4,
			"SozialQuote": 6,
			"SozialBeziehende": 861,
			"Mietpreis": "NA"
		},
		{
			"": 8850,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3166,
			"SteuerEinkommen_P25": 10.4,
			"SteuerEinkommen_Median": 30,
			"SteuerEinkommen_P75": 50.05,
			"eink_arm_Sum": 1141,
			"ant_eink_arm": 36,
			"SozialQuote": 5.6,
			"SozialBeziehende": 559,
			"Mietpreis": "NA"
		},
		{
			"": 8851,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1869,
			"SteuerEinkommen_P25": 47.1,
			"SteuerEinkommen_Median": 64.8,
			"SteuerEinkommen_P75": 89.3,
			"eink_arm_Sum": 256,
			"ant_eink_arm": 13.7,
			"SozialQuote": 5.6,
			"SozialBeziehende": 559,
			"Mietpreis": "NA"
		},
		{
			"": 8873,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9331,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 38.9,
			"SteuerEinkommen_P75": 58.1,
			"eink_arm_Sum": 2391,
			"ant_eink_arm": 25.6,
			"SozialQuote": 7.9,
			"SozialBeziehende": 1496,
			"Mietpreis": "NA"
		},
		{
			"": 8874,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2404,
			"SteuerEinkommen_P25": 35.6,
			"SteuerEinkommen_Median": 56.3,
			"SteuerEinkommen_P75": 78.5,
			"eink_arm_Sum": 590,
			"ant_eink_arm": 24.5,
			"SozialQuote": 7.9,
			"SozialBeziehende": 1496,
			"Mietpreis": "NA"
		},
		{
			"": 8918,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2016,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 42.3,
			"SteuerEinkommen_P75": 67.5,
			"eink_arm_Sum": 500,
			"ant_eink_arm": 24.8,
			"SozialQuote": 4.8,
			"SozialBeziehende": 172,
			"Mietpreis": "NA"
		},
		{
			"": 8919,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 357,
			"SteuerEinkommen_P25": 34.9,
			"SteuerEinkommen_Median": 61.4,
			"SteuerEinkommen_P75": 98.9,
			"eink_arm_Sum": 93,
			"ant_eink_arm": 26.1,
			"SozialQuote": 4.8,
			"SozialBeziehende": 172,
			"Mietpreis": "NA"
		},
		{
			"": 8940,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5535,
			"SteuerEinkommen_P25": 15.8,
			"SteuerEinkommen_Median": 35.55,
			"SteuerEinkommen_P75": 59.6,
			"eink_arm_Sum": 1777,
			"ant_eink_arm": 32.1,
			"SozialQuote": 12.2,
			"SozialBeziehende": 1133,
			"Mietpreis": "NA"
		},
		{
			"": 8941,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 862,
			"SteuerEinkommen_P25": 31.2,
			"SteuerEinkommen_Median": 50.5,
			"SteuerEinkommen_P75": 78.2,
			"eink_arm_Sum": 261,
			"ant_eink_arm": 30.3,
			"SozialQuote": 12.2,
			"SozialBeziehende": 1133,
			"Mietpreis": "NA"
		},
		{
			"": 8962,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5286,
			"SteuerEinkommen_P25": 16.3,
			"SteuerEinkommen_Median": 31.1,
			"SteuerEinkommen_P75": 48,
			"eink_arm_Sum": 1717,
			"ant_eink_arm": 32.5,
			"SozialQuote": 9.9,
			"SozialBeziehende": 1168,
			"Mietpreis": "NA"
		},
		{
			"": 8963,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1706,
			"SteuerEinkommen_P25": 33.9,
			"SteuerEinkommen_Median": 52.15,
			"SteuerEinkommen_P75": 70.2,
			"eink_arm_Sum": 448,
			"ant_eink_arm": 26.3,
			"SozialQuote": 9.9,
			"SozialBeziehende": 1168,
			"Mietpreis": "NA"
		},
		{
			"": 9007,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4838,
			"SteuerEinkommen_P25": 16.6,
			"SteuerEinkommen_Median": 37.85,
			"SteuerEinkommen_P75": 60.8,
			"eink_arm_Sum": 1431,
			"ant_eink_arm": 29.6,
			"SozialQuote": 8.7,
			"SozialBeziehende": 787,
			"Mietpreis": "NA"
		},
		{
			"": 9008,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1041,
			"SteuerEinkommen_P25": 37.1,
			"SteuerEinkommen_Median": 57.9,
			"SteuerEinkommen_P75": 80.1,
			"eink_arm_Sum": 233,
			"ant_eink_arm": 22.4,
			"SozialQuote": 8.7,
			"SozialBeziehende": 787,
			"Mietpreis": "NA"
		},
		{
			"": 9030,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1549,
			"SteuerEinkommen_P25": 29.9,
			"SteuerEinkommen_Median": 54,
			"SteuerEinkommen_P75": 79.95,
			"eink_arm_Sum": 281,
			"ant_eink_arm": 18.1,
			"SozialQuote": 4.6,
			"SozialBeziehende": 126,
			"Mietpreis": "NA"
		},
		{
			"": 9031,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 318,
			"SteuerEinkommen_P25": 48.2,
			"SteuerEinkommen_Median": 74.2,
			"SteuerEinkommen_P75": 134.75,
			"eink_arm_Sum": 43,
			"ant_eink_arm": 13.5,
			"SozialQuote": 4.6,
			"SozialBeziehende": 126,
			"Mietpreis": "NA"
		},
		{
			"": 9075,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8475,
			"SteuerEinkommen_P25": 22.2,
			"SteuerEinkommen_Median": 44,
			"SteuerEinkommen_P75": 67.8,
			"eink_arm_Sum": 1917,
			"ant_eink_arm": 22.6,
			"SozialQuote": 4,
			"SozialBeziehende": 756,
			"Mietpreis": "NA"
		},
		{
			"": 9076,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2692,
			"SteuerEinkommen_P25": 50.8,
			"SteuerEinkommen_Median": 74,
			"SteuerEinkommen_P75": 111.4,
			"eink_arm_Sum": 326,
			"ant_eink_arm": 12.1,
			"SozialQuote": 4,
			"SozialBeziehende": 756,
			"Mietpreis": "NA"
		},
		{
			"": 9097,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4004,
			"SteuerEinkommen_P25": 23.5,
			"SteuerEinkommen_Median": 50.6,
			"SteuerEinkommen_P75": 82.2,
			"eink_arm_Sum": 877,
			"ant_eink_arm": 21.9,
			"SozialQuote": 1.4,
			"SozialBeziehende": 124,
			"Mietpreis": "NA"
		},
		{
			"": 9098,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1348,
			"SteuerEinkommen_P25": 72,
			"SteuerEinkommen_Median": 114.5,
			"SteuerEinkommen_P75": 188.2,
			"eink_arm_Sum": 104,
			"ant_eink_arm": 7.7,
			"SozialQuote": 1.4,
			"SozialBeziehende": 124,
			"Mietpreis": "NA"
		},
		{
			"": 9143,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2756,
			"SteuerEinkommen_P25": 19.8,
			"SteuerEinkommen_Median": 56.25,
			"SteuerEinkommen_P75": 96.8,
			"eink_arm_Sum": 709,
			"ant_eink_arm": 25.7,
			"SozialQuote": 1,
			"SozialBeziehende": 67,
			"Mietpreis": "NA"
		},
		{
			"": 9144,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1216,
			"SteuerEinkommen_P25": 84.8,
			"SteuerEinkommen_Median": 148.1,
			"SteuerEinkommen_P75": 257,
			"eink_arm_Sum": 71,
			"ant_eink_arm": 5.8,
			"SozialQuote": 1,
			"SozialBeziehende": 67,
			"Mietpreis": "NA"
		},
		{
			"": 9166,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4438,
			"SteuerEinkommen_P25": 21.8,
			"SteuerEinkommen_Median": 50.3,
			"SteuerEinkommen_P75": 86.4,
			"eink_arm_Sum": 1058,
			"ant_eink_arm": 23.8,
			"SozialQuote": 1.3,
			"SozialBeziehende": 127,
			"Mietpreis": "NA"
		},
		{
			"": 9167,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1430,
			"SteuerEinkommen_P25": 75.55,
			"SteuerEinkommen_Median": 128.1,
			"SteuerEinkommen_P75": 217.55,
			"eink_arm_Sum": 105,
			"ant_eink_arm": 7.3,
			"SozialQuote": 1.3,
			"SozialBeziehende": 127,
			"Mietpreis": "NA"
		},
		{
			"": 9189,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3276,
			"SteuerEinkommen_P25": 21.4,
			"SteuerEinkommen_Median": 45.3,
			"SteuerEinkommen_P75": 72.1,
			"eink_arm_Sum": 795,
			"ant_eink_arm": 24.3,
			"SozialQuote": 2.2,
			"SozialBeziehende": 144,
			"Mietpreis": "NA"
		},
		{
			"": 9190,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 951,
			"SteuerEinkommen_P25": 60.9,
			"SteuerEinkommen_Median": 100,
			"SteuerEinkommen_P75": 170.5,
			"eink_arm_Sum": 92,
			"ant_eink_arm": 9.7,
			"SozialQuote": 2.2,
			"SozialBeziehende": 144,
			"Mietpreis": "NA"
		},
		{
			"": 9211,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3908,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 46.1,
			"SteuerEinkommen_P75": 73,
			"eink_arm_Sum": 957,
			"ant_eink_arm": 24.5,
			"SozialQuote": 1.3,
			"SozialBeziehende": 130,
			"Mietpreis": "NA"
		},
		{
			"": 9212,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1891,
			"SteuerEinkommen_P25": 63.95,
			"SteuerEinkommen_Median": 96.3,
			"SteuerEinkommen_P75": 147.4,
			"eink_arm_Sum": 159,
			"ant_eink_arm": 8.4,
			"SozialQuote": 1.3,
			"SozialBeziehende": 130,
			"Mietpreis": "NA"
		},
		{
			"": 9257,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2592,
			"SteuerEinkommen_P25": 28,
			"SteuerEinkommen_Median": 55.7,
			"SteuerEinkommen_P75": 88.4,
			"eink_arm_Sum": 492,
			"ant_eink_arm": 19,
			"SozialQuote": 2.1,
			"SozialBeziehende": 94,
			"Mietpreis": "NA"
		},
		{
			"": 9258,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 467,
			"SteuerEinkommen_P25": 60.8,
			"SteuerEinkommen_Median": 100.9,
			"SteuerEinkommen_P75": 168.5,
			"eink_arm_Sum": 49,
			"ant_eink_arm": 10.5,
			"SozialQuote": 2.1,
			"SozialBeziehende": 94,
			"Mietpreis": "NA"
		},
		{
			"": 9280,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2759,
			"SteuerEinkommen_P25": 23.6,
			"SteuerEinkommen_Median": 50.1,
			"SteuerEinkommen_P75": 83,
			"eink_arm_Sum": 602,
			"ant_eink_arm": 21.8,
			"SozialQuote": 2.3,
			"SozialBeziehende": 118,
			"Mietpreis": "NA"
		},
		{
			"": 9281,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 616,
			"SteuerEinkommen_P25": 61.8,
			"SteuerEinkommen_Median": 97.9,
			"SteuerEinkommen_P75": 155.4,
			"eink_arm_Sum": 57,
			"ant_eink_arm": 9.3,
			"SozialQuote": 2.3,
			"SozialBeziehende": 118,
			"Mietpreis": "NA"
		},
		{
			"": 9303,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1996,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 45.45,
			"SteuerEinkommen_P75": 71.4,
			"eink_arm_Sum": 556,
			"ant_eink_arm": 27.9,
			"SozialQuote": 1.3,
			"SozialBeziehende": 60,
			"Mietpreis": "NA"
		},
		{
			"": 9304,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 693,
			"SteuerEinkommen_P25": 64.2,
			"SteuerEinkommen_Median": 94.4,
			"SteuerEinkommen_P75": 163.4,
			"eink_arm_Sum": 54,
			"ant_eink_arm": 7.8,
			"SozialQuote": 1.3,
			"SozialBeziehende": 60,
			"Mietpreis": "NA"
		},
		{
			"": 9348,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7396,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 38.9,
			"SteuerEinkommen_P75": 58.9,
			"eink_arm_Sum": 1820,
			"ant_eink_arm": 24.6,
			"SozialQuote": 4.9,
			"SozialBeziehende": 826,
			"Mietpreis": "NA"
		},
		{
			"": 9349,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3013,
			"SteuerEinkommen_P25": 47.3,
			"SteuerEinkommen_Median": 68.8,
			"SteuerEinkommen_P75": 96.4,
			"eink_arm_Sum": 417,
			"ant_eink_arm": 13.8,
			"SozialQuote": 4.9,
			"SozialBeziehende": 826,
			"Mietpreis": "NA"
		},
		{
			"": 9372,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11117,
			"SteuerEinkommen_P25": 19.8,
			"SteuerEinkommen_Median": 37.8,
			"SteuerEinkommen_P75": 56,
			"eink_arm_Sum": 2910,
			"ant_eink_arm": 26.2,
			"SozialQuote": 7.2,
			"SozialBeziehende": 2022,
			"Mietpreis": "NA"
		},
		{
			"": 9373,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5004,
			"SteuerEinkommen_P25": 43.3,
			"SteuerEinkommen_Median": 62.1,
			"SteuerEinkommen_P75": 84.9,
			"eink_arm_Sum": 843,
			"ant_eink_arm": 16.8,
			"SozialQuote": 7.2,
			"SozialBeziehende": 2022,
			"Mietpreis": "NA"
		},
		{
			"": 9418,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8497,
			"SteuerEinkommen_P25": 23.7,
			"SteuerEinkommen_Median": 46.85,
			"SteuerEinkommen_P75": 70.4,
			"eink_arm_Sum": 1774,
			"ant_eink_arm": 20.9,
			"SozialQuote": 3.1,
			"SozialBeziehende": 639,
			"Mietpreis": "NA"
		},
		{
			"": 9419,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3684,
			"SteuerEinkommen_P25": 59.5,
			"SteuerEinkommen_Median": 84.7,
			"SteuerEinkommen_P75": 128.5,
			"eink_arm_Sum": 329,
			"ant_eink_arm": 8.9,
			"SozialQuote": 3.1,
			"SozialBeziehende": 639,
			"Mietpreis": "NA"
		},
		{
			"": 9441,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7617,
			"SteuerEinkommen_P25": 20.2,
			"SteuerEinkommen_Median": 41.2,
			"SteuerEinkommen_P75": 62.9,
			"eink_arm_Sum": 1896,
			"ant_eink_arm": 24.9,
			"SozialQuote": 5.3,
			"SozialBeziehende": 757,
			"Mietpreis": "NA"
		},
		{
			"": 9442,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1714,
			"SteuerEinkommen_P25": 45.8,
			"SteuerEinkommen_Median": 67.4,
			"SteuerEinkommen_P75": 98.5,
			"eink_arm_Sum": 286,
			"ant_eink_arm": 16.7,
			"SozialQuote": 5.3,
			"SozialBeziehende": 757,
			"Mietpreis": "NA"
		},
		{
			"": 9485,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6680,
			"SteuerEinkommen_P25": 19.3,
			"SteuerEinkommen_Median": 36.2,
			"SteuerEinkommen_P75": 54.1,
			"eink_arm_Sum": 1820,
			"ant_eink_arm": 27.2,
			"SozialQuote": 7,
			"SozialBeziehende": 1397,
			"Mietpreis": "NA"
		},
		{
			"": 9486,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3665,
			"SteuerEinkommen_P25": 45.3,
			"SteuerEinkommen_Median": 65.1,
			"SteuerEinkommen_P75": 88.8,
			"eink_arm_Sum": 569,
			"ant_eink_arm": 15.5,
			"SozialQuote": 7,
			"SozialBeziehende": 1397,
			"Mietpreis": "NA"
		},
		{
			"": 9507,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8216,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 42,
			"SteuerEinkommen_P75": 65.2,
			"eink_arm_Sum": 2129,
			"ant_eink_arm": 25.9,
			"SozialQuote": 6.5,
			"SozialBeziehende": 1207,
			"Mietpreis": "NA"
		},
		{
			"": 9508,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2730,
			"SteuerEinkommen_P25": 47.15,
			"SteuerEinkommen_Median": 73.2,
			"SteuerEinkommen_P75": 110,
			"eink_arm_Sum": 402,
			"ant_eink_arm": 14.7,
			"SozialQuote": 6.5,
			"SozialBeziehende": 1207,
			"Mietpreis": "NA"
		},
		{
			"": 9529,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7260,
			"SteuerEinkommen_P25": 17.8,
			"SteuerEinkommen_Median": 36,
			"SteuerEinkommen_P75": 55.4,
			"eink_arm_Sum": 2078,
			"ant_eink_arm": 28.6,
			"SozialQuote": 9.2,
			"SozialBeziehende": 1813,
			"Mietpreis": "NA"
		},
		{
			"": 9530,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3468,
			"SteuerEinkommen_P25": 40.8,
			"SteuerEinkommen_Median": 61.8,
			"SteuerEinkommen_P75": 85.4,
			"eink_arm_Sum": 661,
			"ant_eink_arm": 19.1,
			"SozialQuote": 9.2,
			"SozialBeziehende": 1813,
			"Mietpreis": "NA"
		},
		{
			"": 9574,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1879,
			"SteuerEinkommen_P25": 15.2,
			"SteuerEinkommen_Median": 31.95,
			"SteuerEinkommen_P75": 48,
			"eink_arm_Sum": 624,
			"ant_eink_arm": 33.2,
			"SozialQuote": 10.5,
			"SozialBeziehende": 692,
			"Mietpreis": "NA"
		},
		{
			"": 9575,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1263,
			"SteuerEinkommen_P25": 38,
			"SteuerEinkommen_Median": 57.4,
			"SteuerEinkommen_P75": 76.4,
			"eink_arm_Sum": 274,
			"ant_eink_arm": 21.7,
			"SozialQuote": 10.5,
			"SozialBeziehende": 692,
			"Mietpreis": "NA"
		},
		{
			"": 9597,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3827,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 31.5,
			"SteuerEinkommen_P75": 48,
			"eink_arm_Sum": 1173,
			"ant_eink_arm": 30.7,
			"SozialQuote": 11.5,
			"SozialBeziehende": 1147,
			"Mietpreis": "NA"
		},
		{
			"": 9598,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1732,
			"SteuerEinkommen_P25": 37,
			"SteuerEinkommen_Median": 55.7,
			"SteuerEinkommen_P75": 77,
			"eink_arm_Sum": 397,
			"ant_eink_arm": 22.9,
			"SozialQuote": 11.5,
			"SozialBeziehende": 1147,
			"Mietpreis": "NA"
		},
		{
			"": 9619,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3481,
			"SteuerEinkommen_P25": 15,
			"SteuerEinkommen_Median": 30.25,
			"SteuerEinkommen_P75": 44.7,
			"eink_arm_Sum": 1137,
			"ant_eink_arm": 32.7,
			"SozialQuote": 9,
			"SozialBeziehende": 967,
			"Mietpreis": "NA"
		},
		{
			"": 9620,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2011,
			"SteuerEinkommen_P25": 39.4,
			"SteuerEinkommen_Median": 57.7,
			"SteuerEinkommen_P75": 75.6,
			"eink_arm_Sum": 403,
			"ant_eink_arm": 20,
			"SozialQuote": 9,
			"SozialBeziehende": 967,
			"Mietpreis": "NA"
		},
		{
			"": 9688,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1572,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 49.3,
			"SteuerEinkommen_P75": 86,
			"eink_arm_Sum": 402,
			"ant_eink_arm": 25.6,
			"SozialQuote": 2.1,
			"SozialBeziehende": 58,
			"Mietpreis": "NA"
		},
		{
			"": 9689,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 303,
			"SteuerEinkommen_P25": 69.5,
			"SteuerEinkommen_Median": 118.65,
			"SteuerEinkommen_P75": 182.65,
			"eink_arm_Sum": 32,
			"ant_eink_arm": 10.6,
			"SozialQuote": 2.1,
			"SozialBeziehende": 58,
			"Mietpreis": "NA"
		},
		{
			"": 9709,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 287,
			"SteuerEinkommen_P25": 16.9,
			"SteuerEinkommen_Median": 39,
			"SteuerEinkommen_P75": 73.8,
			"eink_arm_Sum": 83,
			"ant_eink_arm": 28.9,
			"SozialQuote": 2.1,
			"SozialBeziehende": 12,
			"Mietpreis": "NA"
		},
		{
			"": 9710,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 75,
			"SteuerEinkommen_P25": 59.9,
			"SteuerEinkommen_Median": 118.25,
			"SteuerEinkommen_P75": 259.8,
			"eink_arm_Sum": 6,
			"ant_eink_arm": 8,
			"SozialQuote": 2.1,
			"SozialBeziehende": 12,
			"Mietpreis": "NA"
		},
		{
			"": 9730,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1180,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 22,
			"SteuerEinkommen_P75": 56.6,
			"eink_arm_Sum": 574,
			"ant_eink_arm": 48.6,
			"SozialQuote": 8.9,
			"SozialBeziehende": 144,
			"Mietpreis": "NA"
		},
		{
			"": 9731,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 135,
			"SteuerEinkommen_P25": 60.3,
			"SteuerEinkommen_Median": 120.1,
			"SteuerEinkommen_P75": 184.6,
			"eink_arm_Sum": 20,
			"ant_eink_arm": 14.8,
			"SozialQuote": 8.9,
			"SozialBeziehende": 144,
			"Mietpreis": "NA"
		},
		{
			"": 9751,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 600,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 14.3,
			"SteuerEinkommen_P75": 57.75,
			"eink_arm_Sum": 350,
			"ant_eink_arm": 58.3,
			"SozialQuote": 13.3,
			"SozialBeziehende": 138,
			"Mietpreis": "NA"
		},
		{
			"": 9752,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 85,
			"SteuerEinkommen_P25": 55.4,
			"SteuerEinkommen_Median": 87,
			"SteuerEinkommen_P75": 131.9,
			"eink_arm_Sum": 9,
			"ant_eink_arm": 10.6,
			"SozialQuote": 13.3,
			"SozialBeziehende": 138,
			"Mietpreis": "NA"
		},
		{
			"": 9794,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6731,
			"SteuerEinkommen_P25": 20.9,
			"SteuerEinkommen_Median": 42.15,
			"SteuerEinkommen_P75": 66.3,
			"eink_arm_Sum": 1688,
			"ant_eink_arm": 25.1,
			"SozialQuote": 2.8,
			"SozialBeziehende": 431,
			"Mietpreis": "NA"
		},
		{
			"": 9795,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2401,
			"SteuerEinkommen_P25": 56,
			"SteuerEinkommen_Median": 81,
			"SteuerEinkommen_P75": 125.8,
			"eink_arm_Sum": 278,
			"ant_eink_arm": 11.6,
			"SozialQuote": 2.8,
			"SozialBeziehende": 431,
			"Mietpreis": "NA"
		},
		{
			"": 9817,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1699,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 38.4,
			"SteuerEinkommen_P75": 58.4,
			"eink_arm_Sum": 431,
			"ant_eink_arm": 25.4,
			"SozialQuote": 4.8,
			"SozialBeziehende": 244,
			"Mietpreis": "NA"
		},
		{
			"": 9818,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1019,
			"SteuerEinkommen_P25": 49.45,
			"SteuerEinkommen_Median": 74.25,
			"SteuerEinkommen_P75": 104.9,
			"eink_arm_Sum": 131,
			"ant_eink_arm": 12.9,
			"SozialQuote": 4.8,
			"SozialBeziehende": 244,
			"Mietpreis": "NA"
		},
		{
			"": 9839,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3647,
			"SteuerEinkommen_P25": 26.4,
			"SteuerEinkommen_Median": 55.1,
			"SteuerEinkommen_P75": 90.3,
			"eink_arm_Sum": 750,
			"ant_eink_arm": 20.6,
			"SozialQuote": 2.7,
			"SozialBeziehende": 223,
			"Mietpreis": "NA"
		},
		{
			"": 9840,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1232,
			"SteuerEinkommen_P25": 66.45,
			"SteuerEinkommen_Median": 113.35,
			"SteuerEinkommen_P75": 190.6,
			"eink_arm_Sum": 119,
			"ant_eink_arm": 9.7,
			"SozialQuote": 2.7,
			"SozialBeziehende": 223,
			"Mietpreis": "NA"
		},
		{
			"": 9884,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7037,
			"SteuerEinkommen_P25": 24.5,
			"SteuerEinkommen_Median": 47.7,
			"SteuerEinkommen_P75": 71.6,
			"eink_arm_Sum": 1471,
			"ant_eink_arm": 20.9,
			"SozialQuote": 4.8,
			"SozialBeziehende": 713,
			"Mietpreis": "NA"
		},
		{
			"": 9885,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1939,
			"SteuerEinkommen_P25": 43.2,
			"SteuerEinkommen_Median": 73.8,
			"SteuerEinkommen_P75": 116.3,
			"eink_arm_Sum": 357,
			"ant_eink_arm": 18.4,
			"SozialQuote": 4.8,
			"SozialBeziehende": 713,
			"Mietpreis": "NA"
		},
		{
			"": 9906,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3182,
			"SteuerEinkommen_P25": 10.8,
			"SteuerEinkommen_Median": 30.4,
			"SteuerEinkommen_P75": 51,
			"eink_arm_Sum": 1165,
			"ant_eink_arm": 36.6,
			"SozialQuote": 5.5,
			"SozialBeziehende": 556,
			"Mietpreis": "NA"
		},
		{
			"": 9907,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1866,
			"SteuerEinkommen_P25": 47.6,
			"SteuerEinkommen_Median": 65.9,
			"SteuerEinkommen_P75": 92.9,
			"eink_arm_Sum": 248,
			"ant_eink_arm": 13.3,
			"SozialQuote": 5.5,
			"SozialBeziehende": 556,
			"Mietpreis": "NA"
		},
		{
			"": 9929,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9453,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 39.8,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 2483,
			"ant_eink_arm": 26.3,
			"SozialQuote": 7.2,
			"SozialBeziehende": 1391,
			"Mietpreis": "NA"
		},
		{
			"": 9930,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2401,
			"SteuerEinkommen_P25": 37.3,
			"SteuerEinkommen_Median": 58.85,
			"SteuerEinkommen_P75": 81.3,
			"eink_arm_Sum": 570,
			"ant_eink_arm": 23.7,
			"SozialQuote": 7.2,
			"SozialBeziehende": 1391,
			"Mietpreis": "NA"
		},
		{
			"": 9974,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2083,
			"SteuerEinkommen_P25": 21.5,
			"SteuerEinkommen_Median": 44.1,
			"SteuerEinkommen_P75": 70.8,
			"eink_arm_Sum": 512,
			"ant_eink_arm": 24.6,
			"SozialQuote": 4.5,
			"SozialBeziehende": 167,
			"Mietpreis": "NA"
		},
		{
			"": 9975,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 347,
			"SteuerEinkommen_P25": 33.5,
			"SteuerEinkommen_Median": 61.4,
			"SteuerEinkommen_P75": 99.1,
			"eink_arm_Sum": 96,
			"ant_eink_arm": 27.7,
			"SozialQuote": 4.5,
			"SozialBeziehende": 167,
			"Mietpreis": "NA"
		},
		{
			"": 9995,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5647,
			"SteuerEinkommen_P25": 17.7,
			"SteuerEinkommen_Median": 38.45,
			"SteuerEinkommen_P75": 62.6,
			"eink_arm_Sum": 1699,
			"ant_eink_arm": 30.1,
			"SozialQuote": 11,
			"SozialBeziehende": 1062,
			"Mietpreis": "NA"
		},
		{
			"": 9996,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 899,
			"SteuerEinkommen_P25": 32.6,
			"SteuerEinkommen_Median": 52.55,
			"SteuerEinkommen_P75": 83.6,
			"eink_arm_Sum": 276,
			"ant_eink_arm": 30.7,
			"SozialQuote": 11,
			"SozialBeziehende": 1062,
			"Mietpreis": "NA"
		},
		{
			"": 10017,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5362,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 32.7,
			"SteuerEinkommen_P75": 50,
			"eink_arm_Sum": 1723,
			"ant_eink_arm": 32.1,
			"SozialQuote": 8.3,
			"SozialBeziehende": 996,
			"Mietpreis": "NA"
		},
		{
			"": 10018,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1710,
			"SteuerEinkommen_P25": 36,
			"SteuerEinkommen_Median": 52.7,
			"SteuerEinkommen_P75": 71.85,
			"eink_arm_Sum": 435,
			"ant_eink_arm": 25.4,
			"SozialQuote": 8.3,
			"SozialBeziehende": 996,
			"Mietpreis": "NA"
		},
		{
			"": 10061,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4886,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 39.75,
			"SteuerEinkommen_P75": 62.6,
			"eink_arm_Sum": 1408,
			"ant_eink_arm": 28.8,
			"SozialQuote": 8.1,
			"SozialBeziehende": 748,
			"Mietpreis": "NA"
		},
		{
			"": 10062,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1052,
			"SteuerEinkommen_P25": 38.3,
			"SteuerEinkommen_Median": 59.05,
			"SteuerEinkommen_P75": 84.6,
			"eink_arm_Sum": 237,
			"ant_eink_arm": 22.5,
			"SozialQuote": 8.1,
			"SozialBeziehende": 748,
			"Mietpreis": "NA"
		},
		{
			"": 10083,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1546,
			"SteuerEinkommen_P25": 32,
			"SteuerEinkommen_Median": 55.95,
			"SteuerEinkommen_P75": 83.4,
			"eink_arm_Sum": 266,
			"ant_eink_arm": 17.2,
			"SozialQuote": 3.7,
			"SozialBeziehende": 103,
			"Mietpreis": "NA"
		},
		{
			"": 10084,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 321,
			"SteuerEinkommen_P25": 51.2,
			"SteuerEinkommen_Median": 80.05,
			"SteuerEinkommen_P75": 130.5,
			"eink_arm_Sum": 36,
			"ant_eink_arm": 11.2,
			"SozialQuote": 3.7,
			"SozialBeziehende": 103,
			"Mietpreis": "NA"
		},
		{
			"": 10127,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8636,
			"SteuerEinkommen_P25": 22.6,
			"SteuerEinkommen_Median": 46,
			"SteuerEinkommen_P75": 70.1,
			"eink_arm_Sum": 2002,
			"ant_eink_arm": 23.2,
			"SozialQuote": 3.5,
			"SozialBeziehende": 683,
			"Mietpreis": "NA"
		},
		{
			"": 10128,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2765,
			"SteuerEinkommen_P25": 52,
			"SteuerEinkommen_Median": 77.25,
			"SteuerEinkommen_P75": 117.6,
			"eink_arm_Sum": 347,
			"ant_eink_arm": 12.5,
			"SozialQuote": 3.5,
			"SozialBeziehende": 683,
			"Mietpreis": "NA"
		},
		{
			"": 10150,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4006,
			"SteuerEinkommen_P25": 24,
			"SteuerEinkommen_Median": 52.2,
			"SteuerEinkommen_P75": 85.9,
			"eink_arm_Sum": 885,
			"ant_eink_arm": 22.1,
			"SozialQuote": 1.1,
			"SozialBeziehende": 98,
			"Mietpreis": "NA"
		},
		{
			"": 10151,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1377,
			"SteuerEinkommen_P25": 76.05,
			"SteuerEinkommen_Median": 121.4,
			"SteuerEinkommen_P75": 199.9,
			"eink_arm_Sum": 98,
			"ant_eink_arm": 7.1,
			"SozialQuote": 1.1,
			"SozialBeziehende": 98,
			"Mietpreis": "NA"
		},
		{
			"": 10196,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2789,
			"SteuerEinkommen_P25": 21.8,
			"SteuerEinkommen_Median": 59.6,
			"SteuerEinkommen_P75": 101.2,
			"eink_arm_Sum": 682,
			"ant_eink_arm": 24.5,
			"SozialQuote": 0.9,
			"SozialBeziehende": 67,
			"Mietpreis": "NA"
		},
		{
			"": 10197,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1247,
			"SteuerEinkommen_P25": 89.3,
			"SteuerEinkommen_Median": 153.6,
			"SteuerEinkommen_P75": 275.5,
			"eink_arm_Sum": 71,
			"ant_eink_arm": 5.7,
			"SozialQuote": 0.9,
			"SozialBeziehende": 67,
			"Mietpreis": "NA"
		},
		{
			"": 10219,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4419,
			"SteuerEinkommen_P25": 22,
			"SteuerEinkommen_Median": 52.3,
			"SteuerEinkommen_P75": 90,
			"eink_arm_Sum": 1074,
			"ant_eink_arm": 24.3,
			"SozialQuote": 1.2,
			"SozialBeziehende": 117,
			"Mietpreis": "NA"
		},
		{
			"": 10220,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1459,
			"SteuerEinkommen_P25": 77.45,
			"SteuerEinkommen_Median": 131.65,
			"SteuerEinkommen_P75": 231.3,
			"eink_arm_Sum": 113,
			"ant_eink_arm": 7.7,
			"SozialQuote": 1.2,
			"SozialBeziehende": 117,
			"Mietpreis": "NA"
		},
		{
			"": 10242,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3324,
			"SteuerEinkommen_P25": 22.3,
			"SteuerEinkommen_Median": 47,
			"SteuerEinkommen_P75": 75.8,
			"eink_arm_Sum": 780,
			"ant_eink_arm": 23.5,
			"SozialQuote": 1.8,
			"SozialBeziehende": 122,
			"Mietpreis": "NA"
		},
		{
			"": 10243,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 955,
			"SteuerEinkommen_P25": 64.4,
			"SteuerEinkommen_Median": 104.2,
			"SteuerEinkommen_P75": 175.2,
			"eink_arm_Sum": 87,
			"ant_eink_arm": 9.1,
			"SozialQuote": 1.8,
			"SozialBeziehende": 122,
			"Mietpreis": "NA"
		},
		{
			"": 10264,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3894,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 45.6,
			"SteuerEinkommen_P75": 74.7,
			"eink_arm_Sum": 982,
			"ant_eink_arm": 25.2,
			"SozialQuote": 1.1,
			"SozialBeziehende": 107,
			"Mietpreis": "NA"
		},
		{
			"": 10265,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1899,
			"SteuerEinkommen_P25": 67.1,
			"SteuerEinkommen_Median": 101.85,
			"SteuerEinkommen_P75": 158.6,
			"eink_arm_Sum": 151,
			"ant_eink_arm": 8,
			"SozialQuote": 1.1,
			"SozialBeziehende": 107,
			"Mietpreis": "NA"
		},
		{
			"": 10309,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2550,
			"SteuerEinkommen_P25": 29.8,
			"SteuerEinkommen_Median": 57.8,
			"SteuerEinkommen_P75": 94.3,
			"eink_arm_Sum": 446,
			"ant_eink_arm": 17.5,
			"SozialQuote": 1.9,
			"SozialBeziehende": 85,
			"Mietpreis": "NA"
		},
		{
			"": 10310,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 487,
			"SteuerEinkommen_P25": 62.2,
			"SteuerEinkommen_Median": 109.5,
			"SteuerEinkommen_P75": 175.8,
			"eink_arm_Sum": 49,
			"ant_eink_arm": 10.1,
			"SozialQuote": 1.9,
			"SozialBeziehende": 85,
			"Mietpreis": "NA"
		},
		{
			"": 10332,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2747,
			"SteuerEinkommen_P25": 24.6,
			"SteuerEinkommen_Median": 51.9,
			"SteuerEinkommen_P75": 85.4,
			"eink_arm_Sum": 613,
			"ant_eink_arm": 22.3,
			"SozialQuote": 1.8,
			"SozialBeziehende": 91,
			"Mietpreis": "NA"
		},
		{
			"": 10333,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 615,
			"SteuerEinkommen_P25": 64.8,
			"SteuerEinkommen_Median": 101.9,
			"SteuerEinkommen_P75": 171.1,
			"eink_arm_Sum": 47,
			"ant_eink_arm": 7.6,
			"SozialQuote": 1.8,
			"SozialBeziehende": 91,
			"Mietpreis": "NA"
		},
		{
			"": 10354,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1998,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 46.85,
			"SteuerEinkommen_P75": 74.55,
			"eink_arm_Sum": 554,
			"ant_eink_arm": 27.7,
			"SozialQuote": 1.2,
			"SozialBeziehende": 54,
			"Mietpreis": "NA"
		},
		{
			"": 10355,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 704,
			"SteuerEinkommen_P25": 67.7,
			"SteuerEinkommen_Median": 100.7,
			"SteuerEinkommen_P75": 169.9,
			"eink_arm_Sum": 45,
			"ant_eink_arm": 6.4,
			"SozialQuote": 1.2,
			"SozialBeziehende": 54,
			"Mietpreis": "NA"
		},
		{
			"": 10398,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7632,
			"SteuerEinkommen_P25": 21.5,
			"SteuerEinkommen_Median": 40.2,
			"SteuerEinkommen_P75": 61.2,
			"eink_arm_Sum": 1857,
			"ant_eink_arm": 24.3,
			"SozialQuote": 4.3,
			"SozialBeziehende": 739,
			"Mietpreis": "NA"
		},
		{
			"": 10399,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3000,
			"SteuerEinkommen_P25": 50,
			"SteuerEinkommen_Median": 70.9,
			"SteuerEinkommen_P75": 102.1,
			"eink_arm_Sum": 392,
			"ant_eink_arm": 13.1,
			"SozialQuote": 4.3,
			"SozialBeziehende": 739,
			"Mietpreis": "NA"
		},
		{
			"": 10420,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11256,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 39.6,
			"SteuerEinkommen_P75": 58.5,
			"eink_arm_Sum": 2939,
			"ant_eink_arm": 26.1,
			"SozialQuote": 6.7,
			"SozialBeziehende": 1913,
			"Mietpreis": "NA"
		},
		{
			"": 10421,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5011,
			"SteuerEinkommen_P25": 44.3,
			"SteuerEinkommen_Median": 63.8,
			"SteuerEinkommen_P75": 87.65,
			"eink_arm_Sum": 860,
			"ant_eink_arm": 17.2,
			"SozialQuote": 6.7,
			"SozialBeziehende": 1913,
			"Mietpreis": "NA"
		},
		{
			"": 10465,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8410,
			"SteuerEinkommen_P25": 24.9,
			"SteuerEinkommen_Median": 48.3,
			"SteuerEinkommen_P75": 73.2,
			"eink_arm_Sum": 1736,
			"ant_eink_arm": 20.6,
			"SozialQuote": 2.5,
			"SozialBeziehende": 514,
			"Mietpreis": "NA"
		},
		{
			"": 10466,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3717,
			"SteuerEinkommen_P25": 60.5,
			"SteuerEinkommen_Median": 88.4,
			"SteuerEinkommen_P75": 131.8,
			"eink_arm_Sum": 325,
			"ant_eink_arm": 8.7,
			"SozialQuote": 2.5,
			"SozialBeziehende": 514,
			"Mietpreis": "NA"
		},
		{
			"": 10487,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7672,
			"SteuerEinkommen_P25": 20.7,
			"SteuerEinkommen_Median": 42.9,
			"SteuerEinkommen_P75": 65.3,
			"eink_arm_Sum": 1935,
			"ant_eink_arm": 25.2,
			"SozialQuote": 5,
			"SozialBeziehende": 736,
			"Mietpreis": "NA"
		},
		{
			"": 10488,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1741,
			"SteuerEinkommen_P25": 47.1,
			"SteuerEinkommen_Median": 69,
			"SteuerEinkommen_P75": 102.1,
			"eink_arm_Sum": 284,
			"ant_eink_arm": 16.3,
			"SozialQuote": 5,
			"SozialBeziehende": 736,
			"Mietpreis": "NA"
		},
		{
			"": 10532,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7127,
			"SteuerEinkommen_P25": 19.9,
			"SteuerEinkommen_Median": 38.1,
			"SteuerEinkommen_P75": 57.3,
			"eink_arm_Sum": 1912,
			"ant_eink_arm": 26.8,
			"SozialQuote": 6.2,
			"SozialBeziehende": 1311,
			"Mietpreis": "NA"
		},
		{
			"": 10533,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3869,
			"SteuerEinkommen_P25": 46.5,
			"SteuerEinkommen_Median": 67.2,
			"SteuerEinkommen_P75": 92.7,
			"eink_arm_Sum": 563,
			"ant_eink_arm": 14.6,
			"SozialQuote": 6.2,
			"SozialBeziehende": 1311,
			"Mietpreis": "NA"
		},
		{
			"": 10554,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8294,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 43.2,
			"SteuerEinkommen_P75": 67.4,
			"eink_arm_Sum": 2178,
			"ant_eink_arm": 26.3,
			"SozialQuote": 6.1,
			"SozialBeziehende": 1143,
			"Mietpreis": "NA"
		},
		{
			"": 10555,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2743,
			"SteuerEinkommen_P25": 49.1,
			"SteuerEinkommen_Median": 75.95,
			"SteuerEinkommen_P75": 113.6,
			"eink_arm_Sum": 417,
			"ant_eink_arm": 15.2,
			"SozialQuote": 6.1,
			"SozialBeziehende": 1143,
			"Mietpreis": "NA"
		},
		{
			"": 10576,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7305,
			"SteuerEinkommen_P25": 18.9,
			"SteuerEinkommen_Median": 37.7,
			"SteuerEinkommen_P75": 58,
			"eink_arm_Sum": 2076,
			"ant_eink_arm": 28.4,
			"SozialQuote": 8.2,
			"SozialBeziehende": 1624,
			"Mietpreis": "NA"
		},
		{
			"": 10577,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3438,
			"SteuerEinkommen_P25": 41.8,
			"SteuerEinkommen_Median": 63.1,
			"SteuerEinkommen_P75": 87.7,
			"eink_arm_Sum": 668,
			"ant_eink_arm": 19.4,
			"SozialQuote": 8.2,
			"SozialBeziehende": 1624,
			"Mietpreis": "NA"
		},
		{
			"": 10622,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1882,
			"SteuerEinkommen_P25": 15,
			"SteuerEinkommen_Median": 32.2,
			"SteuerEinkommen_P75": 49.3,
			"eink_arm_Sum": 637,
			"ant_eink_arm": 33.8,
			"SozialQuote": 10.4,
			"SozialBeziehende": 697,
			"Mietpreis": "NA"
		},
		{
			"": 10623,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1253,
			"SteuerEinkommen_P25": 40.3,
			"SteuerEinkommen_Median": 59.2,
			"SteuerEinkommen_P75": 79.7,
			"eink_arm_Sum": 251,
			"ant_eink_arm": 20,
			"SozialQuote": 10.4,
			"SozialBeziehende": 697,
			"Mietpreis": "NA"
		},
		{
			"": 10645,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3833,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 32.7,
			"SteuerEinkommen_P75": 49.9,
			"eink_arm_Sum": 1183,
			"ant_eink_arm": 30.9,
			"SozialQuote": 10.3,
			"SozialBeziehende": 1034,
			"Mietpreis": "NA"
		},
		{
			"": 10646,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1742,
			"SteuerEinkommen_P25": 38.3,
			"SteuerEinkommen_Median": 56.6,
			"SteuerEinkommen_P75": 79,
			"eink_arm_Sum": 395,
			"ant_eink_arm": 22.7,
			"SozialQuote": 10.3,
			"SozialBeziehende": 1034,
			"Mietpreis": "NA"
		},
		{
			"": 10667,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3574,
			"SteuerEinkommen_P25": 14.9,
			"SteuerEinkommen_Median": 30.5,
			"SteuerEinkommen_P75": 45.9,
			"eink_arm_Sum": 1219,
			"ant_eink_arm": 34.1,
			"SozialQuote": 8.3,
			"SozialBeziehende": 905,
			"Mietpreis": "NA"
		},
		{
			"": 10668,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2039,
			"SteuerEinkommen_P25": 39.8,
			"SteuerEinkommen_Median": 58.6,
			"SteuerEinkommen_P75": 78.1,
			"eink_arm_Sum": 415,
			"ant_eink_arm": 20.4,
			"SozialQuote": 8.3,
			"SozialBeziehende": 905,
			"Mietpreis": "NA"
		},
		{
			"": 10736,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1540,
			"SteuerEinkommen_P25": 21.4,
			"SteuerEinkommen_Median": 49.3,
			"SteuerEinkommen_P75": 85.2,
			"eink_arm_Sum": 383,
			"ant_eink_arm": 24.9,
			"SozialQuote": 2.1,
			"SozialBeziehende": 58,
			"Mietpreis": "NA"
		},
		{
			"": 10737,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 318,
			"SteuerEinkommen_P25": 70.9,
			"SteuerEinkommen_Median": 115.05,
			"SteuerEinkommen_P75": 179.9,
			"eink_arm_Sum": 29,
			"ant_eink_arm": 9.1,
			"SozialQuote": 2.1,
			"SozialBeziehende": 58,
			"Mietpreis": "NA"
		},
		{
			"": 10757,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 272,
			"SteuerEinkommen_P25": 17.6,
			"SteuerEinkommen_Median": 39.4,
			"SteuerEinkommen_P75": 70,
			"eink_arm_Sum": 82,
			"ant_eink_arm": 30.1,
			"SozialQuote": 1.2,
			"SozialBeziehende": 7,
			"Mietpreis": "NA"
		},
		{
			"": 10758,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 69,
			"SteuerEinkommen_P25": 63.3,
			"SteuerEinkommen_Median": 127.4,
			"SteuerEinkommen_P75": 239.3,
			"eink_arm_Sum": 9,
			"ant_eink_arm": 13,
			"SozialQuote": 1.2,
			"SozialBeziehende": 7,
			"Mietpreis": "NA"
		},
		{
			"": 10779,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1165,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 22.95,
			"SteuerEinkommen_P75": 58,
			"eink_arm_Sum": 546,
			"ant_eink_arm": 46.9,
			"SozialQuote": 8,
			"SozialBeziehende": 128,
			"Mietpreis": "NA"
		},
		{
			"": 10780,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 135,
			"SteuerEinkommen_P25": 57.2,
			"SteuerEinkommen_Median": 116.45,
			"SteuerEinkommen_P75": 194.75,
			"eink_arm_Sum": 24,
			"ant_eink_arm": 17.8,
			"SozialQuote": 8,
			"SozialBeziehende": 128,
			"Mietpreis": "NA"
		},
		{
			"": 10799,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 566,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 13.4,
			"SteuerEinkommen_P75": 63,
			"eink_arm_Sum": 326,
			"ant_eink_arm": 57.6,
			"SozialQuote": 12.1,
			"SozialBeziehende": 124,
			"Mietpreis": "NA"
		},
		{
			"": 10800,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 93,
			"SteuerEinkommen_P25": 51,
			"SteuerEinkommen_Median": 116.8,
			"SteuerEinkommen_P75": 169,
			"eink_arm_Sum": 13,
			"ant_eink_arm": 14,
			"SozialQuote": 12.1,
			"SozialBeziehende": 124,
			"Mietpreis": "NA"
		},
		{
			"": 10841,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6765,
			"SteuerEinkommen_P25": 20.3,
			"SteuerEinkommen_Median": 42.7,
			"SteuerEinkommen_P75": 67.2,
			"eink_arm_Sum": 1749,
			"ant_eink_arm": 25.9,
			"SozialQuote": 2.6,
			"SozialBeziehende": 403,
			"Mietpreis": "NA"
		},
		{
			"": 10842,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2433,
			"SteuerEinkommen_P25": 56.6,
			"SteuerEinkommen_Median": 84.2,
			"SteuerEinkommen_P75": 128.2,
			"eink_arm_Sum": 296,
			"ant_eink_arm": 12.2,
			"SozialQuote": 2.6,
			"SozialBeziehende": 403,
			"Mietpreis": "NA"
		},
		{
			"": 10863,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1706,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 37.7,
			"SteuerEinkommen_P75": 57.7,
			"eink_arm_Sum": 460,
			"ant_eink_arm": 27,
			"SozialQuote": 4.2,
			"SozialBeziehende": 222,
			"Mietpreis": "NA"
		},
		{
			"": 10864,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1028,
			"SteuerEinkommen_P25": 51.25,
			"SteuerEinkommen_Median": 77.45,
			"SteuerEinkommen_P75": 107.2,
			"eink_arm_Sum": 129,
			"ant_eink_arm": 12.5,
			"SozialQuote": 4.2,
			"SozialBeziehende": 222,
			"Mietpreis": "NA"
		},
		{
			"": 10885,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3636,
			"SteuerEinkommen_P25": 25.55,
			"SteuerEinkommen_Median": 55.2,
			"SteuerEinkommen_P75": 90,
			"eink_arm_Sum": 769,
			"ant_eink_arm": 21.1,
			"SozialQuote": 2.4,
			"SozialBeziehende": 201,
			"Mietpreis": "NA"
		},
		{
			"": 10886,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1245,
			"SteuerEinkommen_P25": 68,
			"SteuerEinkommen_Median": 113.4,
			"SteuerEinkommen_P75": 185.2,
			"eink_arm_Sum": 124,
			"ant_eink_arm": 10,
			"SozialQuote": 2.4,
			"SozialBeziehende": 201,
			"Mietpreis": "NA"
		},
		{
			"": 10930,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7023,
			"SteuerEinkommen_P25": 25.4,
			"SteuerEinkommen_Median": 48.8,
			"SteuerEinkommen_P75": 72.95,
			"eink_arm_Sum": 1455,
			"ant_eink_arm": 20.7,
			"SozialQuote": 4.2,
			"SozialBeziehende": 614,
			"Mietpreis": "NA"
		},
		{
			"": 10931,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1924,
			"SteuerEinkommen_P25": 47.3,
			"SteuerEinkommen_Median": 76.7,
			"SteuerEinkommen_P75": 123.7,
			"eink_arm_Sum": 336,
			"ant_eink_arm": 17.5,
			"SozialQuote": 4.2,
			"SozialBeziehende": 614,
			"Mietpreis": "NA"
		},
		{
			"": 10952,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3361,
			"SteuerEinkommen_P25": 11,
			"SteuerEinkommen_Median": 31.4,
			"SteuerEinkommen_P75": 52.7,
			"eink_arm_Sum": 1183,
			"ant_eink_arm": 35.2,
			"SozialQuote": 4.5,
			"SozialBeziehende": 474,
			"Mietpreis": "NA"
		},
		{
			"": 10953,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1920,
			"SteuerEinkommen_P25": 47.5,
			"SteuerEinkommen_Median": 68.4,
			"SteuerEinkommen_P75": 94.6,
			"eink_arm_Sum": 287,
			"ant_eink_arm": 14.9,
			"SozialQuote": 4.5,
			"SozialBeziehende": 474,
			"Mietpreis": "NA"
		},
		{
			"": 10975,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9685,
			"SteuerEinkommen_P25": 20.4,
			"SteuerEinkommen_Median": 40.3,
			"SteuerEinkommen_P75": 61.45,
			"eink_arm_Sum": 2515,
			"ant_eink_arm": 26,
			"SozialQuote": 6.9,
			"SozialBeziehende": 1335,
			"Mietpreis": "NA"
		},
		{
			"": 10976,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2329,
			"SteuerEinkommen_P25": 38,
			"SteuerEinkommen_Median": 59.4,
			"SteuerEinkommen_P75": 82.1,
			"eink_arm_Sum": 567,
			"ant_eink_arm": 24.3,
			"SozialQuote": 6.9,
			"SozialBeziehende": 1335,
			"Mietpreis": "NA"
		},
		{
			"": 11019,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2039,
			"SteuerEinkommen_P25": 22.7,
			"SteuerEinkommen_Median": 44.8,
			"SteuerEinkommen_P75": 72.5,
			"eink_arm_Sum": 484,
			"ant_eink_arm": 23.7,
			"SozialQuote": 3.5,
			"SozialBeziehende": 135,
			"Mietpreis": "NA"
		},
		{
			"": 11020,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 366,
			"SteuerEinkommen_P25": 37.75,
			"SteuerEinkommen_Median": 63.2,
			"SteuerEinkommen_P75": 106.4,
			"eink_arm_Sum": 91,
			"ant_eink_arm": 24.9,
			"SozialQuote": 3.5,
			"SozialBeziehende": 135,
			"Mietpreis": "NA"
		},
		{
			"": 11040,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5666,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 38.8,
			"SteuerEinkommen_P75": 63.4,
			"eink_arm_Sum": 1739,
			"ant_eink_arm": 30.7,
			"SozialQuote": 10.6,
			"SozialBeziehende": 1016,
			"Mietpreis": "NA"
		},
		{
			"": 11041,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 893,
			"SteuerEinkommen_P25": 33.7,
			"SteuerEinkommen_Median": 54.8,
			"SteuerEinkommen_P75": 85.9,
			"eink_arm_Sum": 267,
			"ant_eink_arm": 29.9,
			"SozialQuote": 10.6,
			"SozialBeziehende": 1016,
			"Mietpreis": "NA"
		},
		{
			"": 11062,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5449,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 32.6,
			"SteuerEinkommen_P75": 50.6,
			"eink_arm_Sum": 1769,
			"ant_eink_arm": 32.5,
			"SozialQuote": 8,
			"SozialBeziehende": 964,
			"Mietpreis": "NA"
		},
		{
			"": 11063,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1697,
			"SteuerEinkommen_P25": 36.6,
			"SteuerEinkommen_Median": 54,
			"SteuerEinkommen_P75": 73.4,
			"eink_arm_Sum": 436,
			"ant_eink_arm": 25.7,
			"SozialQuote": 8,
			"SozialBeziehende": 964,
			"Mietpreis": "NA"
		},
		{
			"": 11107,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4906,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 39.3,
			"SteuerEinkommen_P75": 63.6,
			"eink_arm_Sum": 1478,
			"ant_eink_arm": 30.1,
			"SozialQuote": 8,
			"SozialBeziehende": 741,
			"Mietpreis": "NA"
		},
		{
			"": 11108,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1038,
			"SteuerEinkommen_P25": 39.1,
			"SteuerEinkommen_Median": 60.05,
			"SteuerEinkommen_P75": 85.75,
			"eink_arm_Sum": 244,
			"ant_eink_arm": 23.5,
			"SozialQuote": 8,
			"SozialBeziehende": 741,
			"Mietpreis": "NA"
		},
		{
			"": 11130,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1560,
			"SteuerEinkommen_P25": 29.6,
			"SteuerEinkommen_Median": 55.5,
			"SteuerEinkommen_P75": 84.7,
			"eink_arm_Sum": 288,
			"ant_eink_arm": 18.5,
			"SozialQuote": 3.8,
			"SozialBeziehende": 111,
			"Mietpreis": "NA"
		},
		{
			"": 11131,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 333,
			"SteuerEinkommen_P25": 55.8,
			"SteuerEinkommen_Median": 89.6,
			"SteuerEinkommen_P75": 136.4,
			"eink_arm_Sum": 36,
			"ant_eink_arm": 10.8,
			"SozialQuote": 3.8,
			"SozialBeziehende": 111,
			"Mietpreis": "NA"
		},
		{
			"": 11174,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8759,
			"SteuerEinkommen_P25": 22.6,
			"SteuerEinkommen_Median": 46.15,
			"SteuerEinkommen_P75": 71.1,
			"eink_arm_Sum": 2063,
			"ant_eink_arm": 23.6,
			"SozialQuote": 3.2,
			"SozialBeziehende": 643,
			"Mietpreis": "NA"
		},
		{
			"": 11175,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2802,
			"SteuerEinkommen_P25": 53.9,
			"SteuerEinkommen_Median": 80.25,
			"SteuerEinkommen_P75": 121.3,
			"eink_arm_Sum": 345,
			"ant_eink_arm": 12.3,
			"SozialQuote": 3.2,
			"SozialBeziehende": 643,
			"Mietpreis": "NA"
		},
		{
			"": 11196,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4038,
			"SteuerEinkommen_P25": 24.4,
			"SteuerEinkommen_Median": 52.1,
			"SteuerEinkommen_P75": 85.85,
			"eink_arm_Sum": 903,
			"ant_eink_arm": 22.4,
			"SozialQuote": 0.9,
			"SozialBeziehende": 85,
			"Mietpreis": "NA"
		},
		{
			"": 11197,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1378,
			"SteuerEinkommen_P25": 79.9,
			"SteuerEinkommen_Median": 127.5,
			"SteuerEinkommen_P75": 199.4,
			"eink_arm_Sum": 96,
			"ant_eink_arm": 7,
			"SozialQuote": 0.9,
			"SozialBeziehende": 85,
			"Mietpreis": "NA"
		},
		{
			"": 11241,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2764,
			"SteuerEinkommen_P25": 19.8,
			"SteuerEinkommen_Median": 56.9,
			"SteuerEinkommen_P75": 99.4,
			"eink_arm_Sum": 729,
			"ant_eink_arm": 26.4,
			"SozialQuote": 0.7,
			"SozialBeziehende": 53,
			"Mietpreis": "NA"
		},
		{
			"": 11242,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1261,
			"SteuerEinkommen_P25": 95,
			"SteuerEinkommen_Median": 154.55,
			"SteuerEinkommen_P75": 255.4,
			"eink_arm_Sum": 71,
			"ant_eink_arm": 5.6,
			"SozialQuote": 0.7,
			"SozialBeziehende": 53,
			"Mietpreis": "NA"
		},
		{
			"": 11264,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4422,
			"SteuerEinkommen_P25": 21.4,
			"SteuerEinkommen_Median": 51.1,
			"SteuerEinkommen_P75": 89.5,
			"eink_arm_Sum": 1106,
			"ant_eink_arm": 25,
			"SozialQuote": 1,
			"SozialBeziehende": 100,
			"Mietpreis": "NA"
		},
		{
			"": 11265,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1470,
			"SteuerEinkommen_P25": 77,
			"SteuerEinkommen_Median": 132.6,
			"SteuerEinkommen_P75": 234.8,
			"eink_arm_Sum": 132,
			"ant_eink_arm": 9,
			"SozialQuote": 1,
			"SozialBeziehende": 100,
			"Mietpreis": "NA"
		},
		{
			"": 11286,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3247,
			"SteuerEinkommen_P25": 21.9,
			"SteuerEinkommen_Median": 46.6,
			"SteuerEinkommen_P75": 75.6,
			"eink_arm_Sum": 799,
			"ant_eink_arm": 24.6,
			"SozialQuote": 1.9,
			"SozialBeziehende": 127,
			"Mietpreis": "NA"
		},
		{
			"": 11287,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 956,
			"SteuerEinkommen_P25": 67.6,
			"SteuerEinkommen_Median": 109.55,
			"SteuerEinkommen_P75": 182.4,
			"eink_arm_Sum": 93,
			"ant_eink_arm": 9.7,
			"SozialQuote": 1.9,
			"SozialBeziehende": 127,
			"Mietpreis": "NA"
		},
		{
			"": 11308,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3952,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 47.2,
			"SteuerEinkommen_P75": 75.3,
			"eink_arm_Sum": 984,
			"ant_eink_arm": 24.9,
			"SozialQuote": 1.2,
			"SozialBeziehende": 118,
			"Mietpreis": "NA"
		},
		{
			"": 11309,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1897,
			"SteuerEinkommen_P25": 68.75,
			"SteuerEinkommen_Median": 103.95,
			"SteuerEinkommen_P75": 158.4,
			"eink_arm_Sum": 154,
			"ant_eink_arm": 8.1,
			"SozialQuote": 1.2,
			"SozialBeziehende": 118,
			"Mietpreis": "NA"
		},
		{
			"": 11352,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2503,
			"SteuerEinkommen_P25": 29.5,
			"SteuerEinkommen_Median": 58.25,
			"SteuerEinkommen_P75": 94.1,
			"eink_arm_Sum": 458,
			"ant_eink_arm": 18.3,
			"SozialQuote": 1.5,
			"SozialBeziehende": 66,
			"Mietpreis": "NA"
		},
		{
			"": 11353,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 492,
			"SteuerEinkommen_P25": 64.3,
			"SteuerEinkommen_Median": 112.2,
			"SteuerEinkommen_P75": 180,
			"eink_arm_Sum": 43,
			"ant_eink_arm": 8.7,
			"SozialQuote": 1.5,
			"SozialBeziehende": 66,
			"Mietpreis": "NA"
		},
		{
			"": 11374,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2746,
			"SteuerEinkommen_P25": 24.15,
			"SteuerEinkommen_Median": 54.4,
			"SteuerEinkommen_P75": 87.95,
			"eink_arm_Sum": 609,
			"ant_eink_arm": 22.2,
			"SozialQuote": 1.8,
			"SozialBeziehende": 92,
			"Mietpreis": "NA"
		},
		{
			"": 11375,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 618,
			"SteuerEinkommen_P25": 68.5,
			"SteuerEinkommen_Median": 112,
			"SteuerEinkommen_P75": 169,
			"eink_arm_Sum": 43,
			"ant_eink_arm": 7,
			"SozialQuote": 1.8,
			"SozialBeziehende": 92,
			"Mietpreis": "NA"
		},
		{
			"": 11396,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1984,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 47.3,
			"SteuerEinkommen_P75": 75.4,
			"eink_arm_Sum": 536,
			"ant_eink_arm": 27,
			"SozialQuote": 1.3,
			"SozialBeziehende": 61,
			"Mietpreis": "NA"
		},
		{
			"": 11397,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 696,
			"SteuerEinkommen_P25": 67.1,
			"SteuerEinkommen_Median": 101.2,
			"SteuerEinkommen_P75": 165,
			"eink_arm_Sum": 51,
			"ant_eink_arm": 7.3,
			"SozialQuote": 1.3,
			"SozialBeziehende": 61,
			"Mietpreis": "NA"
		},
		{
			"": 11441,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7790,
			"SteuerEinkommen_P25": 21.9,
			"SteuerEinkommen_Median": 41.4,
			"SteuerEinkommen_P75": 62.1,
			"eink_arm_Sum": 1868,
			"ant_eink_arm": 24,
			"SozialQuote": 4.1,
			"SozialBeziehende": 718,
			"Mietpreis": "NA"
		},
		{
			"": 11442,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2963,
			"SteuerEinkommen_P25": 50.9,
			"SteuerEinkommen_Median": 73.7,
			"SteuerEinkommen_P75": 104.1,
			"eink_arm_Sum": 388,
			"ant_eink_arm": 13.1,
			"SozialQuote": 4.1,
			"SozialBeziehende": 718,
			"Mietpreis": "NA"
		},
		{
			"": 11464,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11342,
			"SteuerEinkommen_P25": 20.1,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 58.9,
			"eink_arm_Sum": 2991,
			"ant_eink_arm": 26.4,
			"SozialQuote": 6.5,
			"SozialBeziehende": 1853,
			"Mietpreis": "NA"
		},
		{
			"": 11465,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4962,
			"SteuerEinkommen_P25": 44.7,
			"SteuerEinkommen_Median": 64.8,
			"SteuerEinkommen_P75": 89,
			"eink_arm_Sum": 848,
			"ant_eink_arm": 17.1,
			"SozialQuote": 6.5,
			"SozialBeziehende": 1853,
			"Mietpreis": "NA"
		},
		{
			"": 11509,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8556,
			"SteuerEinkommen_P25": 24.7,
			"SteuerEinkommen_Median": 48.6,
			"SteuerEinkommen_P75": 73.6,
			"eink_arm_Sum": 1825,
			"ant_eink_arm": 21.3,
			"SozialQuote": 2.4,
			"SozialBeziehende": 504,
			"Mietpreis": "NA"
		},
		{
			"": 11510,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3653,
			"SteuerEinkommen_P25": 62.6,
			"SteuerEinkommen_Median": 90.7,
			"SteuerEinkommen_P75": 135.5,
			"eink_arm_Sum": 319,
			"ant_eink_arm": 8.7,
			"SozialQuote": 2.4,
			"SozialBeziehende": 504,
			"Mietpreis": "NA"
		},
		{
			"": 11532,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7677,
			"SteuerEinkommen_P25": 21.4,
			"SteuerEinkommen_Median": 43.3,
			"SteuerEinkommen_P75": 65.6,
			"eink_arm_Sum": 1895,
			"ant_eink_arm": 24.7,
			"SozialQuote": 4.8,
			"SozialBeziehende": 705,
			"Mietpreis": "NA"
		},
		{
			"": 11533,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1735,
			"SteuerEinkommen_P25": 49.3,
			"SteuerEinkommen_Median": 72.2,
			"SteuerEinkommen_P75": 109.1,
			"eink_arm_Sum": 276,
			"ant_eink_arm": 15.9,
			"SozialQuote": 4.8,
			"SozialBeziehende": 705,
			"Mietpreis": "NA"
		},
		{
			"": 11577,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7283,
			"SteuerEinkommen_P25": 19.7,
			"SteuerEinkommen_Median": 38.8,
			"SteuerEinkommen_P75": 57.7,
			"eink_arm_Sum": 1970,
			"ant_eink_arm": 27,
			"SozialQuote": 5.6,
			"SozialBeziehende": 1194,
			"Mietpreis": "NA"
		},
		{
			"": 11578,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3968,
			"SteuerEinkommen_P25": 48.3,
			"SteuerEinkommen_Median": 68.9,
			"SteuerEinkommen_P75": 94.4,
			"eink_arm_Sum": 558,
			"ant_eink_arm": 14.1,
			"SozialQuote": 5.6,
			"SozialBeziehende": 1194,
			"Mietpreis": "NA"
		},
		{
			"": 11599,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8220,
			"SteuerEinkommen_P25": 19.8,
			"SteuerEinkommen_Median": 43.6,
			"SteuerEinkommen_P75": 67.9,
			"eink_arm_Sum": 2223,
			"ant_eink_arm": 27,
			"SozialQuote": 5.9,
			"SozialBeziehende": 1123,
			"Mietpreis": "NA"
		},
		{
			"": 11600,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2668,
			"SteuerEinkommen_P25": 49.4,
			"SteuerEinkommen_Median": 78.3,
			"SteuerEinkommen_P75": 117,
			"eink_arm_Sum": 408,
			"ant_eink_arm": 15.3,
			"SozialQuote": 5.9,
			"SozialBeziehende": 1123,
			"Mietpreis": "NA"
		},
		{
			"": 11621,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7402,
			"SteuerEinkommen_P25": 18.2,
			"SteuerEinkommen_Median": 37.4,
			"SteuerEinkommen_P75": 58.8,
			"eink_arm_Sum": 2161,
			"ant_eink_arm": 29.2,
			"SozialQuote": 7.6,
			"SozialBeziehende": 1523,
			"Mietpreis": "NA"
		},
		{
			"": 11622,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3412,
			"SteuerEinkommen_P25": 42.7,
			"SteuerEinkommen_Median": 65,
			"SteuerEinkommen_P75": 90.5,
			"eink_arm_Sum": 676,
			"ant_eink_arm": 19.8,
			"SozialQuote": 7.6,
			"SozialBeziehende": 1523,
			"Mietpreis": "NA"
		},
		{
			"": 11667,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1976,
			"SteuerEinkommen_P25": 14.9,
			"SteuerEinkommen_Median": 32.8,
			"SteuerEinkommen_P75": 50.1,
			"eink_arm_Sum": 672,
			"ant_eink_arm": 34,
			"SozialQuote": 9,
			"SozialBeziehende": 622,
			"Mietpreis": "NA"
		},
		{
			"": 11668,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1282,
			"SteuerEinkommen_P25": 40,
			"SteuerEinkommen_Median": 59.95,
			"SteuerEinkommen_P75": 81.65,
			"eink_arm_Sum": 278,
			"ant_eink_arm": 21.7,
			"SozialQuote": 9,
			"SozialBeziehende": 622,
			"Mietpreis": "NA"
		},
		{
			"": 11689,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3830,
			"SteuerEinkommen_P25": 17.1,
			"SteuerEinkommen_Median": 32.95,
			"SteuerEinkommen_P75": 50.8,
			"eink_arm_Sum": 1201,
			"ant_eink_arm": 31.4,
			"SozialQuote": 9.8,
			"SozialBeziehende": 992,
			"Mietpreis": "NA"
		},
		{
			"": 11690,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1682,
			"SteuerEinkommen_P25": 38.8,
			"SteuerEinkommen_Median": 58.2,
			"SteuerEinkommen_P75": 80.2,
			"eink_arm_Sum": 392,
			"ant_eink_arm": 23.3,
			"SozialQuote": 9.8,
			"SozialBeziehende": 992,
			"Mietpreis": "NA"
		},
		{
			"": 11710,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3642,
			"SteuerEinkommen_P25": 14.7,
			"SteuerEinkommen_Median": 30.7,
			"SteuerEinkommen_P75": 45.95,
			"eink_arm_Sum": 1253,
			"ant_eink_arm": 34.4,
			"SozialQuote": 7.7,
			"SozialBeziehende": 860,
			"Mietpreis": "NA"
		},
		{
			"": 11711,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2040,
			"SteuerEinkommen_P25": 39.9,
			"SteuerEinkommen_Median": 59.3,
			"SteuerEinkommen_P75": 78.9,
			"eink_arm_Sum": 433,
			"ant_eink_arm": 21.2,
			"SozialQuote": 7.7,
			"SozialBeziehende": 860,
			"Mietpreis": "NA"
		},
		{
			"": 11778,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1566,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 49.05,
			"SteuerEinkommen_P75": 85.35,
			"eink_arm_Sum": 394,
			"ant_eink_arm": 25.2,
			"SozialQuote": 1.9,
			"SozialBeziehende": 53,
			"Mietpreis": "NA"
		},
		{
			"": 11779,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 314,
			"SteuerEinkommen_P25": 73.1,
			"SteuerEinkommen_Median": 122.35,
			"SteuerEinkommen_P75": 182.4,
			"eink_arm_Sum": 31,
			"ant_eink_arm": 9.9,
			"SozialQuote": 1.9,
			"SozialBeziehende": 53,
			"Mietpreis": "NA"
		},
		{
			"": 11800,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 281,
			"SteuerEinkommen_P25": 14.5,
			"SteuerEinkommen_Median": 38.8,
			"SteuerEinkommen_P75": 64.7,
			"eink_arm_Sum": 90,
			"ant_eink_arm": 32,
			"SozialQuote": 2.1,
			"SozialBeziehende": 12,
			"Mietpreis": "NA"
		},
		{
			"": 11801,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 65,
			"SteuerEinkommen_P25": 62.5,
			"SteuerEinkommen_Median": 139.2,
			"SteuerEinkommen_P75": 249.2,
			"eink_arm_Sum": 8,
			"ant_eink_arm": 12.3,
			"SozialQuote": 2.1,
			"SozialBeziehende": 12,
			"Mietpreis": "NA"
		},
		{
			"": 11821,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1137,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 22.15,
			"SteuerEinkommen_P75": 55.65,
			"eink_arm_Sum": 549,
			"ant_eink_arm": 48.3,
			"SozialQuote": 7.8,
			"SozialBeziehende": 124,
			"Mietpreis": "NA"
		},
		{
			"": 11822,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 136,
			"SteuerEinkommen_P25": 58.25,
			"SteuerEinkommen_Median": 105.9,
			"SteuerEinkommen_P75": 175.5,
			"eink_arm_Sum": 25,
			"ant_eink_arm": 18.4,
			"SozialQuote": 7.8,
			"SozialBeziehende": 124,
			"Mietpreis": "NA"
		},
		{
			"": 11841,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 533,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 11.5,
			"SteuerEinkommen_P75": 53.9,
			"eink_arm_Sum": 326,
			"ant_eink_arm": 61.2,
			"SozialQuote": 13.9,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 11842,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 96,
			"SteuerEinkommen_P25": 63.1,
			"SteuerEinkommen_Median": 111.8,
			"SteuerEinkommen_P75": 175.45,
			"eink_arm_Sum": 9,
			"ant_eink_arm": 9.4,
			"SozialQuote": 13.9,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 11884,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6830,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 42.9,
			"SteuerEinkommen_P75": 67.4,
			"eink_arm_Sum": 1793,
			"ant_eink_arm": 26.3,
			"SozialQuote": 2.6,
			"SozialBeziehende": 405,
			"Mietpreis": "NA"
		},
		{
			"": 11885,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2403,
			"SteuerEinkommen_P25": 57.9,
			"SteuerEinkommen_Median": 85.1,
			"SteuerEinkommen_P75": 131.7,
			"eink_arm_Sum": 277,
			"ant_eink_arm": 11.5,
			"SozialQuote": 2.6,
			"SozialBeziehende": 405,
			"Mietpreis": "NA"
		},
		{
			"": 11907,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1732,
			"SteuerEinkommen_P25": 20.1,
			"SteuerEinkommen_Median": 37.1,
			"SteuerEinkommen_P75": 57.6,
			"eink_arm_Sum": 459,
			"ant_eink_arm": 26.5,
			"SozialQuote": 4.3,
			"SozialBeziehende": 224,
			"Mietpreis": "NA"
		},
		{
			"": 11908,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1028,
			"SteuerEinkommen_P25": 52.3,
			"SteuerEinkommen_Median": 79.6,
			"SteuerEinkommen_P75": 108.75,
			"eink_arm_Sum": 127,
			"ant_eink_arm": 12.4,
			"SozialQuote": 4.3,
			"SozialBeziehende": 224,
			"Mietpreis": "NA"
		},
		{
			"": 11929,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3650,
			"SteuerEinkommen_P25": 26.15,
			"SteuerEinkommen_Median": 55.6,
			"SteuerEinkommen_P75": 92.5,
			"eink_arm_Sum": 774,
			"ant_eink_arm": 21.2,
			"SozialQuote": 2.4,
			"SozialBeziehende": 197,
			"Mietpreis": "NA"
		},
		{
			"": 11930,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1204,
			"SteuerEinkommen_P25": 66.8,
			"SteuerEinkommen_Median": 116.6,
			"SteuerEinkommen_P75": 194.7,
			"eink_arm_Sum": 110,
			"ant_eink_arm": 9.1,
			"SozialQuote": 2.4,
			"SozialBeziehende": 197,
			"Mietpreis": "NA"
		},
		{
			"": 11974,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7209,
			"SteuerEinkommen_P25": 25.4,
			"SteuerEinkommen_Median": 49.5,
			"SteuerEinkommen_P75": 75,
			"eink_arm_Sum": 1507,
			"ant_eink_arm": 20.9,
			"SozialQuote": 3.6,
			"SozialBeziehende": 542,
			"Mietpreis": "NA"
		},
		{
			"": 11975,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1978,
			"SteuerEinkommen_P25": 47.75,
			"SteuerEinkommen_Median": 80.05,
			"SteuerEinkommen_P75": 127.9,
			"eink_arm_Sum": 341,
			"ant_eink_arm": 17.2,
			"SozialQuote": 3.6,
			"SozialBeziehende": 542,
			"Mietpreis": "NA"
		},
		{
			"": 11996,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3417,
			"SteuerEinkommen_P25": 11.5,
			"SteuerEinkommen_Median": 31.65,
			"SteuerEinkommen_P75": 53.6,
			"eink_arm_Sum": 1227,
			"ant_eink_arm": 35.9,
			"SozialQuote": 4.5,
			"SozialBeziehende": 463,
			"Mietpreis": "NA"
		},
		{
			"": 11997,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1888,
			"SteuerEinkommen_P25": 48.3,
			"SteuerEinkommen_Median": 68.7,
			"SteuerEinkommen_P75": 95.6,
			"eink_arm_Sum": 296,
			"ant_eink_arm": 15.7,
			"SozialQuote": 4.5,
			"SozialBeziehende": 463,
			"Mietpreis": "NA"
		},
		{
			"": 12019,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9607,
			"SteuerEinkommen_P25": 20.3,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 61.2,
			"eink_arm_Sum": 2510,
			"ant_eink_arm": 26.1,
			"SozialQuote": 6.1,
			"SozialBeziehende": 1163,
			"Mietpreis": "NA"
		},
		{
			"": 12020,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2263,
			"SteuerEinkommen_P25": 38.2,
			"SteuerEinkommen_Median": 59.2,
			"SteuerEinkommen_P75": 85,
			"eink_arm_Sum": 557,
			"ant_eink_arm": 24.6,
			"SozialQuote": 6.1,
			"SozialBeziehende": 1163,
			"Mietpreis": "NA"
		},
		{
			"": 12063,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2087,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 44.9,
			"SteuerEinkommen_P75": 71.7,
			"eink_arm_Sum": 515,
			"ant_eink_arm": 24.7,
			"SozialQuote": 3.7,
			"SozialBeziehende": 147,
			"Mietpreis": "NA"
		},
		{
			"": 12064,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 393,
			"SteuerEinkommen_P25": 37.2,
			"SteuerEinkommen_Median": 67.6,
			"SteuerEinkommen_P75": 113.8,
			"eink_arm_Sum": 100,
			"ant_eink_arm": 25.4,
			"SozialQuote": 3.7,
			"SozialBeziehende": 147,
			"Mietpreis": "NA"
		},
		{
			"": 12084,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5633,
			"SteuerEinkommen_P25": 17.5,
			"SteuerEinkommen_Median": 39.6,
			"SteuerEinkommen_P75": 63.4,
			"eink_arm_Sum": 1712,
			"ant_eink_arm": 30.4,
			"SozialQuote": 10.2,
			"SozialBeziehende": 978,
			"Mietpreis": "NA"
		},
		{
			"": 12085,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 860,
			"SteuerEinkommen_P25": 34.5,
			"SteuerEinkommen_Median": 55.1,
			"SteuerEinkommen_P75": 86.8,
			"eink_arm_Sum": 256,
			"ant_eink_arm": 29.8,
			"SozialQuote": 10.2,
			"SozialBeziehende": 978,
			"Mietpreis": "NA"
		},
		{
			"": 12106,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5655,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 33.1,
			"SteuerEinkommen_P75": 51.8,
			"eink_arm_Sum": 1833,
			"ant_eink_arm": 32.4,
			"SozialQuote": 7.3,
			"SozialBeziehende": 884,
			"Mietpreis": "NA"
		},
		{
			"": 12107,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1638,
			"SteuerEinkommen_P25": 36,
			"SteuerEinkommen_Median": 54.6,
			"SteuerEinkommen_P75": 74.2,
			"eink_arm_Sum": 448,
			"ant_eink_arm": 27.4,
			"SozialQuote": 7.3,
			"SozialBeziehende": 884,
			"Mietpreis": "NA"
		},
		{
			"": 12150,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4897,
			"SteuerEinkommen_P25": 16.8,
			"SteuerEinkommen_Median": 39.8,
			"SteuerEinkommen_P75": 64.7,
			"eink_arm_Sum": 1487,
			"ant_eink_arm": 30.4,
			"SozialQuote": 8.1,
			"SozialBeziehende": 751,
			"Mietpreis": "NA"
		},
		{
			"": 12151,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1031,
			"SteuerEinkommen_P25": 40.8,
			"SteuerEinkommen_Median": 61.8,
			"SteuerEinkommen_P75": 87.35,
			"eink_arm_Sum": 229,
			"ant_eink_arm": 22.2,
			"SozialQuote": 8.1,
			"SozialBeziehende": 751,
			"Mietpreis": "NA"
		},
		{
			"": 12172,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1558,
			"SteuerEinkommen_P25": 29.5,
			"SteuerEinkommen_Median": 55.15,
			"SteuerEinkommen_P75": 84,
			"eink_arm_Sum": 293,
			"ant_eink_arm": 18.8,
			"SozialQuote": 3.5,
			"SozialBeziehende": 103,
			"Mietpreis": "NA"
		},
		{
			"": 12173,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 349,
			"SteuerEinkommen_P25": 54.7,
			"SteuerEinkommen_Median": 89.1,
			"SteuerEinkommen_P75": 140.4,
			"eink_arm_Sum": 47,
			"ant_eink_arm": 13.5,
			"SozialQuote": 3.5,
			"SozialBeziehende": 103,
			"Mietpreis": "NA"
		},
		{
			"": 12216,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8821,
			"SteuerEinkommen_P25": 23.4,
			"SteuerEinkommen_Median": 46.1,
			"SteuerEinkommen_P75": 72.6,
			"eink_arm_Sum": 2002,
			"ant_eink_arm": 22.7,
			"SozialQuote": 3,
			"SozialBeziehende": 602,
			"Mietpreis": "NA"
		},
		{
			"": 12217,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2793,
			"SteuerEinkommen_P25": 54.4,
			"SteuerEinkommen_Median": 80.8,
			"SteuerEinkommen_P75": 124.2,
			"eink_arm_Sum": 341,
			"ant_eink_arm": 12.2,
			"SozialQuote": 3,
			"SozialBeziehende": 602,
			"Mietpreis": "NA"
		},
		{
			"": 12238,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4073,
			"SteuerEinkommen_P25": 23.9,
			"SteuerEinkommen_Median": 52,
			"SteuerEinkommen_P75": 86.3,
			"eink_arm_Sum": 911,
			"ant_eink_arm": 22.4,
			"SozialQuote": 0.8,
			"SozialBeziehende": 77,
			"Mietpreis": "NA"
		},
		{
			"": 12239,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1394,
			"SteuerEinkommen_P25": 81.8,
			"SteuerEinkommen_Median": 128,
			"SteuerEinkommen_P75": 203.8,
			"eink_arm_Sum": 104,
			"ant_eink_arm": 7.5,
			"SozialQuote": 0.8,
			"SozialBeziehende": 77,
			"Mietpreis": "NA"
		},
		{
			"": 12283,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2733,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 55.2,
			"SteuerEinkommen_P75": 99,
			"eink_arm_Sum": 737,
			"ant_eink_arm": 27,
			"SozialQuote": 0.8,
			"SozialBeziehende": 59,
			"Mietpreis": "NA"
		},
		{
			"": 12284,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1283,
			"SteuerEinkommen_P25": 98.35,
			"SteuerEinkommen_Median": 154.8,
			"SteuerEinkommen_P75": 261.75,
			"eink_arm_Sum": 68,
			"ant_eink_arm": 5.3,
			"SozialQuote": 0.8,
			"SozialBeziehende": 59,
			"Mietpreis": "NA"
		},
		{
			"": 12305,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4384,
			"SteuerEinkommen_P25": 22.3,
			"SteuerEinkommen_Median": 52.7,
			"SteuerEinkommen_P75": 90.6,
			"eink_arm_Sum": 1073,
			"ant_eink_arm": 24.5,
			"SozialQuote": 1,
			"SozialBeziehende": 102,
			"Mietpreis": "NA"
		},
		{
			"": 12306,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1468,
			"SteuerEinkommen_P25": 80.2,
			"SteuerEinkommen_Median": 140.6,
			"SteuerEinkommen_P75": 236.7,
			"eink_arm_Sum": 117,
			"ant_eink_arm": 8,
			"SozialQuote": 1,
			"SozialBeziehende": 102,
			"Mietpreis": "NA"
		},
		{
			"": 12327,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3179,
			"SteuerEinkommen_P25": 21.95,
			"SteuerEinkommen_Median": 47.2,
			"SteuerEinkommen_P75": 76.15,
			"eink_arm_Sum": 772,
			"ant_eink_arm": 24.3,
			"SozialQuote": 1.7,
			"SozialBeziehende": 116,
			"Mietpreis": "NA"
		},
		{
			"": 12328,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 959,
			"SteuerEinkommen_P25": 67.8,
			"SteuerEinkommen_Median": 110.1,
			"SteuerEinkommen_P75": 190.5,
			"eink_arm_Sum": 89,
			"ant_eink_arm": 9.3,
			"SozialQuote": 1.7,
			"SozialBeziehende": 116,
			"Mietpreis": "NA"
		},
		{
			"": 12350,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3980,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 46.1,
			"SteuerEinkommen_P75": 74.5,
			"eink_arm_Sum": 1014,
			"ant_eink_arm": 25.5,
			"SozialQuote": 1.3,
			"SozialBeziehende": 132,
			"Mietpreis": "NA"
		},
		{
			"": 12351,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1861,
			"SteuerEinkommen_P25": 68.8,
			"SteuerEinkommen_Median": 103.05,
			"SteuerEinkommen_P75": 164.4,
			"eink_arm_Sum": 150,
			"ant_eink_arm": 8.1,
			"SozialQuote": 1.3,
			"SozialBeziehende": 132,
			"Mietpreis": "NA"
		},
		{
			"": 12394,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2477,
			"SteuerEinkommen_P25": 30.8,
			"SteuerEinkommen_Median": 60.6,
			"SteuerEinkommen_P75": 99.8,
			"eink_arm_Sum": 425,
			"ant_eink_arm": 17.2,
			"SozialQuote": 1.1,
			"SozialBeziehende": 49,
			"Mietpreis": "NA"
		},
		{
			"": 12395,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 498,
			"SteuerEinkommen_P25": 71.2,
			"SteuerEinkommen_Median": 113.7,
			"SteuerEinkommen_P75": 190.3,
			"eink_arm_Sum": 50,
			"ant_eink_arm": 10,
			"SozialQuote": 1.1,
			"SozialBeziehende": 49,
			"Mietpreis": "NA"
		},
		{
			"": 12416,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2733,
			"SteuerEinkommen_P25": 24.8,
			"SteuerEinkommen_Median": 54.2,
			"SteuerEinkommen_P75": 89.8,
			"eink_arm_Sum": 601,
			"ant_eink_arm": 22,
			"SozialQuote": 1.7,
			"SozialBeziehende": 90,
			"Mietpreis": "NA"
		},
		{
			"": 12417,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 659,
			"SteuerEinkommen_P25": 68.2,
			"SteuerEinkommen_Median": 113,
			"SteuerEinkommen_P75": 183.3,
			"eink_arm_Sum": 58,
			"ant_eink_arm": 8.8,
			"SozialQuote": 1.7,
			"SozialBeziehende": 90,
			"Mietpreis": "NA"
		},
		{
			"": 12438,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2032,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 46.4,
			"SteuerEinkommen_P75": 75.5,
			"eink_arm_Sum": 559,
			"ant_eink_arm": 27.5,
			"SozialQuote": 1.2,
			"SozialBeziehende": 54,
			"Mietpreis": "NA"
		},
		{
			"": 12439,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 686,
			"SteuerEinkommen_P25": 67.4,
			"SteuerEinkommen_Median": 104.2,
			"SteuerEinkommen_P75": 173.7,
			"eink_arm_Sum": 50,
			"ant_eink_arm": 7.3,
			"SozialQuote": 1.2,
			"SozialBeziehende": 54,
			"Mietpreis": "NA"
		},
		{
			"": 12481,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7843,
			"SteuerEinkommen_P25": 21.8,
			"SteuerEinkommen_Median": 42.1,
			"SteuerEinkommen_P75": 62.5,
			"eink_arm_Sum": 1916,
			"ant_eink_arm": 24.4,
			"SozialQuote": 3.9,
			"SozialBeziehende": 678,
			"Mietpreis": "NA"
		},
		{
			"": 12482,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2938,
			"SteuerEinkommen_P25": 50.8,
			"SteuerEinkommen_Median": 74,
			"SteuerEinkommen_P75": 105,
			"eink_arm_Sum": 397,
			"ant_eink_arm": 13.5,
			"SozialQuote": 3.9,
			"SozialBeziehende": 678,
			"Mietpreis": "NA"
		},
		{
			"": 12503,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11619,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 39.9,
			"SteuerEinkommen_P75": 59,
			"eink_arm_Sum": 3115,
			"ant_eink_arm": 26.8,
			"SozialQuote": 6.2,
			"SozialBeziehende": 1823,
			"Mietpreis": "NA"
		},
		{
			"": 12504,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5001,
			"SteuerEinkommen_P25": 44.7,
			"SteuerEinkommen_Median": 65.1,
			"SteuerEinkommen_P75": 89.6,
			"eink_arm_Sum": 898,
			"ant_eink_arm": 18,
			"SozialQuote": 6.2,
			"SozialBeziehende": 1823,
			"Mietpreis": "NA"
		},
		{
			"": 12547,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8429,
			"SteuerEinkommen_P25": 24.9,
			"SteuerEinkommen_Median": 48.8,
			"SteuerEinkommen_P75": 74,
			"eink_arm_Sum": 1787,
			"ant_eink_arm": 21.2,
			"SozialQuote": 2.2,
			"SozialBeziehende": 463,
			"Mietpreis": "NA"
		},
		{
			"": 12548,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3620,
			"SteuerEinkommen_P25": 62.9,
			"SteuerEinkommen_Median": 91.8,
			"SteuerEinkommen_P75": 136.4,
			"eink_arm_Sum": 319,
			"ant_eink_arm": 8.8,
			"SozialQuote": 2.2,
			"SozialBeziehende": 463,
			"Mietpreis": "NA"
		},
		{
			"": 12569,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7702,
			"SteuerEinkommen_P25": 21.5,
			"SteuerEinkommen_Median": 43.5,
			"SteuerEinkommen_P75": 65.7,
			"eink_arm_Sum": 1906,
			"ant_eink_arm": 24.7,
			"SozialQuote": 4.7,
			"SozialBeziehende": 711,
			"Mietpreis": "NA"
		},
		{
			"": 12570,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1763,
			"SteuerEinkommen_P25": 49,
			"SteuerEinkommen_Median": 72.5,
			"SteuerEinkommen_P75": 108,
			"eink_arm_Sum": 290,
			"ant_eink_arm": 16.4,
			"SozialQuote": 4.7,
			"SozialBeziehende": 711,
			"Mietpreis": "NA"
		},
		{
			"": 12614,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7517,
			"SteuerEinkommen_P25": 19,
			"SteuerEinkommen_Median": 38.4,
			"SteuerEinkommen_P75": 58.2,
			"eink_arm_Sum": 2107,
			"ant_eink_arm": 28,
			"SozialQuote": 5.3,
			"SozialBeziehende": 1162,
			"Mietpreis": "NA"
		},
		{
			"": 12615,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4028,
			"SteuerEinkommen_P25": 48.7,
			"SteuerEinkommen_Median": 70.4,
			"SteuerEinkommen_P75": 96.4,
			"eink_arm_Sum": 616,
			"ant_eink_arm": 15.3,
			"SozialQuote": 5.3,
			"SozialBeziehende": 1162,
			"Mietpreis": "NA"
		},
		{
			"": 12636,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8233,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 44.4,
			"SteuerEinkommen_P75": 68.6,
			"eink_arm_Sum": 2194,
			"ant_eink_arm": 26.6,
			"SozialQuote": 5.6,
			"SozialBeziehende": 1072,
			"Mietpreis": "NA"
		},
		{
			"": 12637,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2660,
			"SteuerEinkommen_P25": 51.1,
			"SteuerEinkommen_Median": 80.8,
			"SteuerEinkommen_P75": 121.3,
			"eink_arm_Sum": 412,
			"ant_eink_arm": 15.5,
			"SozialQuote": 5.6,
			"SozialBeziehende": 1072,
			"Mietpreis": "NA"
		},
		{
			"": 12659,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7524,
			"SteuerEinkommen_P25": 18.4,
			"SteuerEinkommen_Median": 38.6,
			"SteuerEinkommen_P75": 59.5,
			"eink_arm_Sum": 2189,
			"ant_eink_arm": 29.1,
			"SozialQuote": 7.5,
			"SozialBeziehende": 1532,
			"Mietpreis": "NA"
		},
		{
			"": 12660,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3441,
			"SteuerEinkommen_P25": 43.7,
			"SteuerEinkommen_Median": 65.7,
			"SteuerEinkommen_P75": 92.7,
			"eink_arm_Sum": 663,
			"ant_eink_arm": 19.3,
			"SozialQuote": 7.5,
			"SozialBeziehende": 1532,
			"Mietpreis": "NA"
		},
		{
			"": 12705,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2029,
			"SteuerEinkommen_P25": 15,
			"SteuerEinkommen_Median": 31.85,
			"SteuerEinkommen_P75": 51.1,
			"eink_arm_Sum": 694,
			"ant_eink_arm": 34.2,
			"SozialQuote": 8.4,
			"SozialBeziehende": 588,
			"Mietpreis": "NA"
		},
		{
			"": 12706,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1291,
			"SteuerEinkommen_P25": 41.45,
			"SteuerEinkommen_Median": 62.15,
			"SteuerEinkommen_P75": 83.75,
			"eink_arm_Sum": 274,
			"ant_eink_arm": 21.2,
			"SozialQuote": 8.4,
			"SozialBeziehende": 588,
			"Mietpreis": "NA"
		},
		{
			"": 12727,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3864,
			"SteuerEinkommen_P25": 17.3,
			"SteuerEinkommen_Median": 33.4,
			"SteuerEinkommen_P75": 51.4,
			"eink_arm_Sum": 1189,
			"ant_eink_arm": 30.8,
			"SozialQuote": 9.2,
			"SozialBeziehende": 943,
			"Mietpreis": "NA"
		},
		{
			"": 12728,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1692,
			"SteuerEinkommen_P25": 38.55,
			"SteuerEinkommen_Median": 57.9,
			"SteuerEinkommen_P75": 80.15,
			"eink_arm_Sum": 402,
			"ant_eink_arm": 23.8,
			"SozialQuote": 9.2,
			"SozialBeziehende": 943,
			"Mietpreis": "NA"
		},
		{
			"": 12749,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3642,
			"SteuerEinkommen_P25": 13.5,
			"SteuerEinkommen_Median": 30,
			"SteuerEinkommen_P75": 45.6,
			"eink_arm_Sum": 1303,
			"ant_eink_arm": 35.8,
			"SozialQuote": 8,
			"SozialBeziehende": 872,
			"Mietpreis": "NA"
		},
		{
			"": 12750,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1995,
			"SteuerEinkommen_P25": 39.8,
			"SteuerEinkommen_Median": 59.35,
			"SteuerEinkommen_P75": 78.8,
			"eink_arm_Sum": 461,
			"ant_eink_arm": 23.1,
			"SozialQuote": 8,
			"SozialBeziehende": 872,
			"Mietpreis": "NA"
		},
		{
			"": 12817,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1571,
			"SteuerEinkommen_P25": 21.45,
			"SteuerEinkommen_Median": 49.95,
			"SteuerEinkommen_P75": 87.15,
			"eink_arm_Sum": 396,
			"ant_eink_arm": 25.2,
			"SozialQuote": 2,
			"SozialBeziehende": 56,
			"Mietpreis": "NA"
		},
		{
			"": 12818,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 326,
			"SteuerEinkommen_P25": 70,
			"SteuerEinkommen_Median": 121.6,
			"SteuerEinkommen_P75": 198.1,
			"eink_arm_Sum": 32,
			"ant_eink_arm": 9.8,
			"SozialQuote": 2,
			"SozialBeziehende": 56,
			"Mietpreis": "NA"
		},
		{
			"": 12839,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 290,
			"SteuerEinkommen_P25": 12.9,
			"SteuerEinkommen_Median": 42.2,
			"SteuerEinkommen_P75": 71.9,
			"eink_arm_Sum": 96,
			"ant_eink_arm": 33.1,
			"SozialQuote": 1.4,
			"SozialBeziehende": 8,
			"Mietpreis": "NA"
		},
		{
			"": 12840,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 68,
			"SteuerEinkommen_P25": 61.3,
			"SteuerEinkommen_Median": 129.5,
			"SteuerEinkommen_P75": 229.1,
			"eink_arm_Sum": 10,
			"ant_eink_arm": 14.7,
			"SozialQuote": 1.4,
			"SozialBeziehende": 8,
			"Mietpreis": "NA"
		},
		{
			"": 12860,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1128,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 22,
			"SteuerEinkommen_P75": 53.65,
			"eink_arm_Sum": 552,
			"ant_eink_arm": 48.9,
			"SozialQuote": 7.2,
			"SozialBeziehende": 113,
			"Mietpreis": "NA"
		},
		{
			"": 12861,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 133,
			"SteuerEinkommen_P25": 52.8,
			"SteuerEinkommen_Median": 103.7,
			"SteuerEinkommen_P75": 179.1,
			"eink_arm_Sum": 24,
			"ant_eink_arm": 18,
			"SozialQuote": 7.2,
			"SozialBeziehende": 113,
			"Mietpreis": "NA"
		},
		{
			"": 12882,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 531,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 12.2,
			"SteuerEinkommen_P75": 53,
			"eink_arm_Sum": 320,
			"ant_eink_arm": 60.3,
			"SozialQuote": 15,
			"SozialBeziehende": 143,
			"Mietpreis": "NA"
		},
		{
			"": 12883,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 89,
			"SteuerEinkommen_P25": 54.8,
			"SteuerEinkommen_Median": 100.7,
			"SteuerEinkommen_P75": 142.7,
			"eink_arm_Sum": 13,
			"ant_eink_arm": 14.6,
			"SozialQuote": 15,
			"SozialBeziehende": 143,
			"Mietpreis": "NA"
		},
		{
			"": 12926,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6883,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 42.5,
			"SteuerEinkommen_P75": 66.8,
			"eink_arm_Sum": 1813,
			"ant_eink_arm": 26.3,
			"SozialQuote": 2.7,
			"SozialBeziehende": 420,
			"Mietpreis": "NA"
		},
		{
			"": 12927,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2399,
			"SteuerEinkommen_P25": 56.05,
			"SteuerEinkommen_Median": 85.1,
			"SteuerEinkommen_P75": 132.95,
			"eink_arm_Sum": 309,
			"ant_eink_arm": 12.9,
			"SozialQuote": 2.7,
			"SozialBeziehende": 420,
			"Mietpreis": "NA"
		},
		{
			"": 12948,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1721,
			"SteuerEinkommen_P25": 19.8,
			"SteuerEinkommen_Median": 37.2,
			"SteuerEinkommen_P75": 58.8,
			"eink_arm_Sum": 474,
			"ant_eink_arm": 27.5,
			"SozialQuote": 4.5,
			"SozialBeziehende": 239,
			"Mietpreis": "NA"
		},
		{
			"": 12949,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1001,
			"SteuerEinkommen_P25": 53.7,
			"SteuerEinkommen_Median": 77.7,
			"SteuerEinkommen_P75": 109.5,
			"eink_arm_Sum": 131,
			"ant_eink_arm": 13.1,
			"SozialQuote": 4.5,
			"SozialBeziehende": 239,
			"Mietpreis": "NA"
		},
		{
			"": 12970,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3581,
			"SteuerEinkommen_P25": 25.8,
			"SteuerEinkommen_Median": 55.8,
			"SteuerEinkommen_P75": 93,
			"eink_arm_Sum": 762,
			"ant_eink_arm": 21.3,
			"SozialQuote": 2.3,
			"SozialBeziehende": 188,
			"Mietpreis": "NA"
		},
		{
			"": 12971,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1217,
			"SteuerEinkommen_P25": 71.7,
			"SteuerEinkommen_Median": 118.3,
			"SteuerEinkommen_P75": 199.2,
			"eink_arm_Sum": 121,
			"ant_eink_arm": 9.9,
			"SozialQuote": 2.3,
			"SozialBeziehende": 188,
			"Mietpreis": "NA"
		},
		{
			"": 13014,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7246,
			"SteuerEinkommen_P25": 25.5,
			"SteuerEinkommen_Median": 49.8,
			"SteuerEinkommen_P75": 76.6,
			"eink_arm_Sum": 1527,
			"ant_eink_arm": 21.1,
			"SozialQuote": 3.5,
			"SozialBeziehende": 539,
			"Mietpreis": "NA"
		},
		{
			"": 13015,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1982,
			"SteuerEinkommen_P25": 48.8,
			"SteuerEinkommen_Median": 82.2,
			"SteuerEinkommen_P75": 136.6,
			"eink_arm_Sum": 361,
			"ant_eink_arm": 18.2,
			"SozialQuote": 3.5,
			"SozialBeziehende": 539,
			"Mietpreis": "NA"
		},
		{
			"": 13036,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3403,
			"SteuerEinkommen_P25": 10.95,
			"SteuerEinkommen_Median": 33.25,
			"SteuerEinkommen_P75": 54.5,
			"eink_arm_Sum": 1221,
			"ant_eink_arm": 35.9,
			"SozialQuote": 4.5,
			"SozialBeziehende": 470,
			"Mietpreis": "NA"
		},
		{
			"": 13037,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1873,
			"SteuerEinkommen_P25": 48.8,
			"SteuerEinkommen_Median": 69.6,
			"SteuerEinkommen_P75": 98.5,
			"eink_arm_Sum": 305,
			"ant_eink_arm": 16.3,
			"SozialQuote": 4.5,
			"SozialBeziehende": 470,
			"Mietpreis": "NA"
		},
		{
			"": 13058,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9739,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 41.3,
			"SteuerEinkommen_P75": 62.8,
			"eink_arm_Sum": 2469,
			"ant_eink_arm": 25.4,
			"SozialQuote": 5.3,
			"SozialBeziehende": 1028,
			"Mietpreis": "NA"
		},
		{
			"": 13059,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2228,
			"SteuerEinkommen_P25": 37.5,
			"SteuerEinkommen_Median": 60.25,
			"SteuerEinkommen_P75": 87.5,
			"eink_arm_Sum": 584,
			"ant_eink_arm": 26.2,
			"SozialQuote": 5.3,
			"SozialBeziehende": 1028,
			"Mietpreis": "NA"
		},
		{
			"": 13103,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2100,
			"SteuerEinkommen_P25": 23.1,
			"SteuerEinkommen_Median": 44.7,
			"SteuerEinkommen_P75": 75.6,
			"eink_arm_Sum": 489,
			"ant_eink_arm": 23.3,
			"SozialQuote": 3.4,
			"SozialBeziehende": 136,
			"Mietpreis": "NA"
		},
		{
			"": 13104,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 406,
			"SteuerEinkommen_P25": 39.9,
			"SteuerEinkommen_Median": 69.55,
			"SteuerEinkommen_P75": 116.25,
			"eink_arm_Sum": 99,
			"ant_eink_arm": 24.4,
			"SozialQuote": 3.4,
			"SozialBeziehende": 136,
			"Mietpreis": "NA"
		},
		{
			"": 13125,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5684,
			"SteuerEinkommen_P25": 17.4,
			"SteuerEinkommen_Median": 39.45,
			"SteuerEinkommen_P75": 63.9,
			"eink_arm_Sum": 1761,
			"ant_eink_arm": 31,
			"SozialQuote": 9.7,
			"SozialBeziehende": 945,
			"Mietpreis": "NA"
		},
		{
			"": 13126,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 836,
			"SteuerEinkommen_P25": 35.4,
			"SteuerEinkommen_Median": 57.1,
			"SteuerEinkommen_P75": 93.2,
			"eink_arm_Sum": 236,
			"ant_eink_arm": 28.2,
			"SozialQuote": 9.7,
			"SozialBeziehende": 945,
			"Mietpreis": "NA"
		},
		{
			"": 13147,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5633,
			"SteuerEinkommen_P25": 17,
			"SteuerEinkommen_Median": 33.75,
			"SteuerEinkommen_P75": 52.8,
			"eink_arm_Sum": 1839,
			"ant_eink_arm": 32.6,
			"SozialQuote": 7,
			"SozialBeziehende": 838,
			"Mietpreis": "NA"
		},
		{
			"": 13148,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1621,
			"SteuerEinkommen_P25": 36.9,
			"SteuerEinkommen_Median": 54.45,
			"SteuerEinkommen_P75": 75,
			"eink_arm_Sum": 437,
			"ant_eink_arm": 27,
			"SozialQuote": 7,
			"SozialBeziehende": 838,
			"Mietpreis": "NA"
		},
		{
			"": 13192,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4924,
			"SteuerEinkommen_P25": 16.15,
			"SteuerEinkommen_Median": 38.8,
			"SteuerEinkommen_P75": 65,
			"eink_arm_Sum": 1550,
			"ant_eink_arm": 31.5,
			"SozialQuote": 8,
			"SozialBeziehende": 747,
			"Mietpreis": "NA"
		},
		{
			"": 13193,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1011,
			"SteuerEinkommen_P25": 42.1,
			"SteuerEinkommen_Median": 63.45,
			"SteuerEinkommen_P75": 90.7,
			"eink_arm_Sum": 219,
			"ant_eink_arm": 21.7,
			"SozialQuote": 8,
			"SozialBeziehende": 747,
			"Mietpreis": "NA"
		},
		{
			"": 13214,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1556,
			"SteuerEinkommen_P25": 28.9,
			"SteuerEinkommen_Median": 55.6,
			"SteuerEinkommen_P75": 85.2,
			"eink_arm_Sum": 290,
			"ant_eink_arm": 18.6,
			"SozialQuote": 3,
			"SozialBeziehende": 90,
			"Mietpreis": "NA"
		},
		{
			"": 13215,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 345,
			"SteuerEinkommen_P25": 58.6,
			"SteuerEinkommen_Median": 88.6,
			"SteuerEinkommen_P75": 142.1,
			"eink_arm_Sum": 41,
			"ant_eink_arm": 11.9,
			"SozialQuote": 3,
			"SozialBeziehende": 90,
			"Mietpreis": "NA"
		},
		{
			"": 13259,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8827,
			"SteuerEinkommen_P25": 23.9,
			"SteuerEinkommen_Median": 46.4,
			"SteuerEinkommen_P75": 73,
			"eink_arm_Sum": 2010,
			"ant_eink_arm": 22.8,
			"SozialQuote": 2.8,
			"SozialBeziehende": 557,
			"Mietpreis": "NA"
		},
		{
			"": 13260,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2764,
			"SteuerEinkommen_P25": 55.4,
			"SteuerEinkommen_Median": 83.2,
			"SteuerEinkommen_P75": 129.5,
			"eink_arm_Sum": 329,
			"ant_eink_arm": 11.9,
			"SozialQuote": 2.8,
			"SozialBeziehende": 557,
			"Mietpreis": "NA"
		},
		{
			"": 13281,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4059,
			"SteuerEinkommen_P25": 23.8,
			"SteuerEinkommen_Median": 52.4,
			"SteuerEinkommen_P75": 87.5,
			"eink_arm_Sum": 916,
			"ant_eink_arm": 22.6,
			"SozialQuote": 1,
			"SozialBeziehende": 94,
			"Mietpreis": "NA"
		},
		{
			"": 13282,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1400,
			"SteuerEinkommen_P25": 81.5,
			"SteuerEinkommen_Median": 129.7,
			"SteuerEinkommen_P75": 209.6,
			"eink_arm_Sum": 98,
			"ant_eink_arm": 7,
			"SozialQuote": 1,
			"SozialBeziehende": 94,
			"Mietpreis": "NA"
		},
		{
			"": 13327,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2776,
			"SteuerEinkommen_P25": 18.9,
			"SteuerEinkommen_Median": 57,
			"SteuerEinkommen_P75": 100.8,
			"eink_arm_Sum": 745,
			"ant_eink_arm": 26.8,
			"SozialQuote": 0.9,
			"SozialBeziehende": 69,
			"Mietpreis": "NA"
		},
		{
			"": 13328,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1303,
			"SteuerEinkommen_P25": 95.7,
			"SteuerEinkommen_Median": 157.5,
			"SteuerEinkommen_P75": 271.5,
			"eink_arm_Sum": 66,
			"ant_eink_arm": 5.1,
			"SozialQuote": 0.9,
			"SozialBeziehende": 69,
			"Mietpreis": "NA"
		},
		{
			"": 13349,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4302,
			"SteuerEinkommen_P25": 22.3,
			"SteuerEinkommen_Median": 54.1,
			"SteuerEinkommen_P75": 94.1,
			"eink_arm_Sum": 1053,
			"ant_eink_arm": 24.5,
			"SozialQuote": 1.1,
			"SozialBeziehende": 108,
			"Mietpreis": "NA"
		},
		{
			"": 13350,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1485,
			"SteuerEinkommen_P25": 85.5,
			"SteuerEinkommen_Median": 139.1,
			"SteuerEinkommen_P75": 235.5,
			"eink_arm_Sum": 105,
			"ant_eink_arm": 7.1,
			"SozialQuote": 1.1,
			"SozialBeziehende": 108,
			"Mietpreis": "NA"
		},
		{
			"": 13371,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3201,
			"SteuerEinkommen_P25": 22,
			"SteuerEinkommen_Median": 48.1,
			"SteuerEinkommen_P75": 80,
			"eink_arm_Sum": 795,
			"ant_eink_arm": 24.8,
			"SozialQuote": 1.6,
			"SozialBeziehende": 107,
			"Mietpreis": "NA"
		},
		{
			"": 13372,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 953,
			"SteuerEinkommen_P25": 68,
			"SteuerEinkommen_Median": 117.5,
			"SteuerEinkommen_P75": 196.5,
			"eink_arm_Sum": 82,
			"ant_eink_arm": 8.6,
			"SozialQuote": 1.6,
			"SozialBeziehende": 107,
			"Mietpreis": "NA"
		},
		{
			"": 13394,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3919,
			"SteuerEinkommen_P25": 21.1,
			"SteuerEinkommen_Median": 46.4,
			"SteuerEinkommen_P75": 74,
			"eink_arm_Sum": 994,
			"ant_eink_arm": 25.4,
			"SozialQuote": 1.2,
			"SozialBeziehende": 123,
			"Mietpreis": "NA"
		},
		{
			"": 13395,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1850,
			"SteuerEinkommen_P25": 70.2,
			"SteuerEinkommen_Median": 105.2,
			"SteuerEinkommen_P75": 162.9,
			"eink_arm_Sum": 153,
			"ant_eink_arm": 8.3,
			"SozialQuote": 1.2,
			"SozialBeziehende": 123,
			"Mietpreis": "NA"
		},
		{
			"": 13438,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2520,
			"SteuerEinkommen_P25": 31.9,
			"SteuerEinkommen_Median": 61.1,
			"SteuerEinkommen_P75": 101.3,
			"eink_arm_Sum": 438,
			"ant_eink_arm": 17.4,
			"SozialQuote": 1.4,
			"SozialBeziehende": 64,
			"Mietpreis": "NA"
		},
		{
			"": 13439,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 508,
			"SteuerEinkommen_P25": 68.6,
			"SteuerEinkommen_Median": 119,
			"SteuerEinkommen_P75": 200,
			"eink_arm_Sum": 49,
			"ant_eink_arm": 9.6,
			"SozialQuote": 1.4,
			"SozialBeziehende": 64,
			"Mietpreis": "NA"
		},
		{
			"": 13460,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2708,
			"SteuerEinkommen_P25": 26.2,
			"SteuerEinkommen_Median": 55.5,
			"SteuerEinkommen_P75": 92.5,
			"eink_arm_Sum": 584,
			"ant_eink_arm": 21.6,
			"SozialQuote": 2.2,
			"SozialBeziehende": 118,
			"Mietpreis": "NA"
		},
		{
			"": 13461,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 664,
			"SteuerEinkommen_P25": 70.2,
			"SteuerEinkommen_Median": 113.1,
			"SteuerEinkommen_P75": 186.8,
			"eink_arm_Sum": 62,
			"ant_eink_arm": 9.3,
			"SozialQuote": 2.2,
			"SozialBeziehende": 118,
			"Mietpreis": "NA"
		},
		{
			"": 13482,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2025,
			"SteuerEinkommen_P25": 18,
			"SteuerEinkommen_Median": 46.9,
			"SteuerEinkommen_P75": 74.6,
			"eink_arm_Sum": 561,
			"ant_eink_arm": 27.7,
			"SozialQuote": 1.1,
			"SozialBeziehende": 49,
			"Mietpreis": "NA"
		},
		{
			"": 13483,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 656,
			"SteuerEinkommen_P25": 67.5,
			"SteuerEinkommen_Median": 106.5,
			"SteuerEinkommen_P75": 174,
			"eink_arm_Sum": 58,
			"ant_eink_arm": 8.8,
			"SozialQuote": 1.1,
			"SozialBeziehende": 49,
			"Mietpreis": "NA"
		},
		{
			"": 13527,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7917,
			"SteuerEinkommen_P25": 21,
			"SteuerEinkommen_Median": 41.7,
			"SteuerEinkommen_P75": 62.9,
			"eink_arm_Sum": 2005,
			"ant_eink_arm": 25.3,
			"SozialQuote": 3.8,
			"SozialBeziehende": 680,
			"Mietpreis": "NA"
		},
		{
			"": 13528,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3012,
			"SteuerEinkommen_P25": 51.55,
			"SteuerEinkommen_Median": 76,
			"SteuerEinkommen_P75": 106.9,
			"eink_arm_Sum": 410,
			"ant_eink_arm": 13.6,
			"SozialQuote": 3.8,
			"SozialBeziehende": 680,
			"Mietpreis": "NA"
		},
		{
			"": 13550,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11803,
			"SteuerEinkommen_P25": 20.7,
			"SteuerEinkommen_Median": 40.6,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 3054,
			"ant_eink_arm": 25.9,
			"SozialQuote": 6,
			"SozialBeziehende": 1800,
			"Mietpreis": "NA"
		},
		{
			"": 13551,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5032,
			"SteuerEinkommen_P25": 44.8,
			"SteuerEinkommen_Median": 65.3,
			"SteuerEinkommen_P75": 90.3,
			"eink_arm_Sum": 927,
			"ant_eink_arm": 18.4,
			"SozialQuote": 6,
			"SozialBeziehende": 1800,
			"Mietpreis": "NA"
		},
		{
			"": 13594,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8441,
			"SteuerEinkommen_P25": 24.5,
			"SteuerEinkommen_Median": 49,
			"SteuerEinkommen_P75": 73.9,
			"eink_arm_Sum": 1834,
			"ant_eink_arm": 21.7,
			"SozialQuote": 2,
			"SozialBeziehende": 419,
			"Mietpreis": "NA"
		},
		{
			"": 13595,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3588,
			"SteuerEinkommen_P25": 63.5,
			"SteuerEinkommen_Median": 93.7,
			"SteuerEinkommen_P75": 140.7,
			"eink_arm_Sum": 333,
			"ant_eink_arm": 9.3,
			"SozialQuote": 2,
			"SozialBeziehende": 419,
			"Mietpreis": "NA"
		},
		{
			"": 13616,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7681,
			"SteuerEinkommen_P25": 21.6,
			"SteuerEinkommen_Median": 44.4,
			"SteuerEinkommen_P75": 67,
			"eink_arm_Sum": 1909,
			"ant_eink_arm": 24.9,
			"SozialQuote": 4.5,
			"SozialBeziehende": 678,
			"Mietpreis": "NA"
		},
		{
			"": 13617,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1755,
			"SteuerEinkommen_P25": 49.7,
			"SteuerEinkommen_Median": 73.8,
			"SteuerEinkommen_P75": 111.7,
			"eink_arm_Sum": 276,
			"ant_eink_arm": 15.7,
			"SozialQuote": 4.5,
			"SozialBeziehende": 678,
			"Mietpreis": "NA"
		},
		{
			"": 13661,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7904,
			"SteuerEinkommen_P25": 18.8,
			"SteuerEinkommen_Median": 38.9,
			"SteuerEinkommen_P75": 59.1,
			"eink_arm_Sum": 2256,
			"ant_eink_arm": 28.5,
			"SozialQuote": 5.2,
			"SozialBeziehende": 1212,
			"Mietpreis": "NA"
		},
		{
			"": 13662,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4202,
			"SteuerEinkommen_P25": 49.1,
			"SteuerEinkommen_Median": 70.6,
			"SteuerEinkommen_P75": 97.8,
			"eink_arm_Sum": 641,
			"ant_eink_arm": 15.3,
			"SozialQuote": 5.2,
			"SozialBeziehende": 1212,
			"Mietpreis": "NA"
		},
		{
			"": 13683,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8349,
			"SteuerEinkommen_P25": 20.3,
			"SteuerEinkommen_Median": 44.55,
			"SteuerEinkommen_P75": 69.3,
			"eink_arm_Sum": 2195,
			"ant_eink_arm": 26.3,
			"SozialQuote": 5.4,
			"SozialBeziehende": 1050,
			"Mietpreis": "NA"
		},
		{
			"": 13684,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2669,
			"SteuerEinkommen_P25": 51.7,
			"SteuerEinkommen_Median": 81.7,
			"SteuerEinkommen_P75": 125.6,
			"eink_arm_Sum": 421,
			"ant_eink_arm": 15.8,
			"SozialQuote": 5.4,
			"SozialBeziehende": 1050,
			"Mietpreis": "NA"
		},
		{
			"": 13705,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7554,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 38.3,
			"SteuerEinkommen_P75": 59.5,
			"eink_arm_Sum": 2191,
			"ant_eink_arm": 29,
			"SozialQuote": 7.1,
			"SozialBeziehende": 1474,
			"Mietpreis": "NA"
		},
		{
			"": 13706,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3515,
			"SteuerEinkommen_P25": 43.4,
			"SteuerEinkommen_Median": 66.8,
			"SteuerEinkommen_P75": 94.8,
			"eink_arm_Sum": 716,
			"ant_eink_arm": 20.4,
			"SozialQuote": 7.1,
			"SozialBeziehende": 1474,
			"Mietpreis": "NA"
		},
		{
			"": 13751,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2007,
			"SteuerEinkommen_P25": 14.45,
			"SteuerEinkommen_Median": 32.3,
			"SteuerEinkommen_P75": 50.5,
			"eink_arm_Sum": 709,
			"ant_eink_arm": 35.3,
			"SozialQuote": 8.9,
			"SozialBeziehende": 613,
			"Mietpreis": "NA"
		},
		{
			"": 13752,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1294,
			"SteuerEinkommen_P25": 41.9,
			"SteuerEinkommen_Median": 62.8,
			"SteuerEinkommen_P75": 85.4,
			"eink_arm_Sum": 282,
			"ant_eink_arm": 21.8,
			"SozialQuote": 8.9,
			"SozialBeziehende": 613,
			"Mietpreis": "NA"
		},
		{
			"": 13773,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3880,
			"SteuerEinkommen_P25": 17.1,
			"SteuerEinkommen_Median": 32.9,
			"SteuerEinkommen_P75": 50.9,
			"eink_arm_Sum": 1237,
			"ant_eink_arm": 31.9,
			"SozialQuote": 8.8,
			"SozialBeziehende": 896,
			"Mietpreis": "NA"
		},
		{
			"": 13774,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1643,
			"SteuerEinkommen_P25": 39,
			"SteuerEinkommen_Median": 58.9,
			"SteuerEinkommen_P75": 80.4,
			"eink_arm_Sum": 394,
			"ant_eink_arm": 24,
			"SozialQuote": 8.8,
			"SozialBeziehende": 896,
			"Mietpreis": "NA"
		},
		{
			"": 13795,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3685,
			"SteuerEinkommen_P25": 13.8,
			"SteuerEinkommen_Median": 29.7,
			"SteuerEinkommen_P75": 46,
			"eink_arm_Sum": 1347,
			"ant_eink_arm": 36.6,
			"SozialQuote": 8.4,
			"SozialBeziehende": 930,
			"Mietpreis": "NA"
		},
		{
			"": 13796,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1947,
			"SteuerEinkommen_P25": 39.6,
			"SteuerEinkommen_Median": 58.2,
			"SteuerEinkommen_P75": 79.8,
			"eink_arm_Sum": 464,
			"ant_eink_arm": 23.8,
			"SozialQuote": 8.4,
			"SozialBeziehende": 930,
			"Mietpreis": "NA"
		},
		{
			"": 13864,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1590,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 49.2,
			"SteuerEinkommen_P75": 85.8,
			"eink_arm_Sum": 405,
			"ant_eink_arm": 25.5,
			"SozialQuote": 2.5,
			"SozialBeziehende": 73,
			"Mietpreis": "NA"
		},
		{
			"": 13865,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 331,
			"SteuerEinkommen_P25": 68.1,
			"SteuerEinkommen_Median": 120.7,
			"SteuerEinkommen_P75": 193.1,
			"eink_arm_Sum": 43,
			"ant_eink_arm": 13,
			"SozialQuote": 2.5,
			"SozialBeziehende": 73,
			"Mietpreis": "NA"
		},
		{
			"": 13887,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 296,
			"SteuerEinkommen_P25": 12.9,
			"SteuerEinkommen_Median": 41.7,
			"SteuerEinkommen_P75": 72.4,
			"eink_arm_Sum": 94,
			"ant_eink_arm": 31.8,
			"SozialQuote": 1.8,
			"SozialBeziehende": 10,
			"Mietpreis": "NA"
		},
		{
			"": 13888,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 63,
			"SteuerEinkommen_P25": 63.5,
			"SteuerEinkommen_Median": 131.2,
			"SteuerEinkommen_P75": 251,
			"eink_arm_Sum": 9,
			"ant_eink_arm": 14.3,
			"SozialQuote": 1.8,
			"SozialBeziehende": 10,
			"Mietpreis": "NA"
		},
		{
			"": 13908,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1115,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 20.6,
			"SteuerEinkommen_P75": 53.3,
			"eink_arm_Sum": 567,
			"ant_eink_arm": 50.9,
			"SozialQuote": 7,
			"SozialBeziehende": 110,
			"Mietpreis": "NA"
		},
		{
			"": 13909,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 132,
			"SteuerEinkommen_P25": 56.5,
			"SteuerEinkommen_Median": 110.75,
			"SteuerEinkommen_P75": 176.55,
			"eink_arm_Sum": 25,
			"ant_eink_arm": 18.9,
			"SozialQuote": 7,
			"SozialBeziehende": 110,
			"Mietpreis": "NA"
		},
		{
			"": 13929,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 528,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 11.65,
			"SteuerEinkommen_P75": 54.8,
			"eink_arm_Sum": 317,
			"ant_eink_arm": 60,
			"SozialQuote": 13.4,
			"SozialBeziehende": 127,
			"Mietpreis": "NA"
		},
		{
			"": 13930,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 88,
			"SteuerEinkommen_P25": 51.8,
			"SteuerEinkommen_Median": 94.8,
			"SteuerEinkommen_P75": 149,
			"eink_arm_Sum": 16,
			"ant_eink_arm": 18.2,
			"SozialQuote": 13.4,
			"SozialBeziehende": 127,
			"Mietpreis": "NA"
		},
		{
			"": 13973,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6917,
			"SteuerEinkommen_P25": 19.45,
			"SteuerEinkommen_Median": 42.4,
			"SteuerEinkommen_P75": 67.6,
			"eink_arm_Sum": 1903,
			"ant_eink_arm": 27.5,
			"SozialQuote": 2.7,
			"SozialBeziehende": 425,
			"Mietpreis": "NA"
		},
		{
			"": 13974,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2354,
			"SteuerEinkommen_P25": 56.9,
			"SteuerEinkommen_Median": 84.15,
			"SteuerEinkommen_P75": 135.8,
			"eink_arm_Sum": 289,
			"ant_eink_arm": 12.3,
			"SozialQuote": 2.7,
			"SozialBeziehende": 425,
			"Mietpreis": "NA"
		},
		{
			"": 13995,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1730,
			"SteuerEinkommen_P25": 18.75,
			"SteuerEinkommen_Median": 37.85,
			"SteuerEinkommen_P75": 58.05,
			"eink_arm_Sum": 498,
			"ant_eink_arm": 28.8,
			"SozialQuote": 4.8,
			"SozialBeziehende": 254,
			"Mietpreis": "NA"
		},
		{
			"": 13996,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1005,
			"SteuerEinkommen_P25": 51,
			"SteuerEinkommen_Median": 74.5,
			"SteuerEinkommen_P75": 105.6,
			"eink_arm_Sum": 147,
			"ant_eink_arm": 14.6,
			"SozialQuote": 4.8,
			"SozialBeziehende": 254,
			"Mietpreis": "NA"
		},
		{
			"": 14018,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3641,
			"SteuerEinkommen_P25": 25.2,
			"SteuerEinkommen_Median": 56.4,
			"SteuerEinkommen_P75": 92.9,
			"eink_arm_Sum": 784,
			"ant_eink_arm": 21.5,
			"SozialQuote": 2.1,
			"SozialBeziehende": 177,
			"Mietpreis": "NA"
		},
		{
			"": 14019,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1204,
			"SteuerEinkommen_P25": 69.7,
			"SteuerEinkommen_Median": 117.6,
			"SteuerEinkommen_P75": 201.85,
			"eink_arm_Sum": 125,
			"ant_eink_arm": 10.4,
			"SozialQuote": 2.1,
			"SozialBeziehende": 177,
			"Mietpreis": "NA"
		},
		{
			"": 14062,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7345,
			"SteuerEinkommen_P25": 25.4,
			"SteuerEinkommen_Median": 50,
			"SteuerEinkommen_P75": 75.9,
			"eink_arm_Sum": 1551,
			"ant_eink_arm": 21.1,
			"SozialQuote": 3.3,
			"SozialBeziehende": 509,
			"Mietpreis": "NA"
		},
		{
			"": 14063,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1946,
			"SteuerEinkommen_P25": 49.9,
			"SteuerEinkommen_Median": 83.7,
			"SteuerEinkommen_P75": 137.5,
			"eink_arm_Sum": 328,
			"ant_eink_arm": 16.9,
			"SozialQuote": 3.3,
			"SozialBeziehende": 509,
			"Mietpreis": "NA"
		},
		{
			"": 14084,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3445,
			"SteuerEinkommen_P25": 11,
			"SteuerEinkommen_Median": 33,
			"SteuerEinkommen_P75": 53.6,
			"eink_arm_Sum": 1259,
			"ant_eink_arm": 36.5,
			"SozialQuote": 4.4,
			"SozialBeziehende": 466,
			"Mietpreis": "NA"
		},
		{
			"": 14085,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1908,
			"SteuerEinkommen_P25": 47.9,
			"SteuerEinkommen_Median": 69.5,
			"SteuerEinkommen_P75": 96.3,
			"eink_arm_Sum": 335,
			"ant_eink_arm": 17.6,
			"SozialQuote": 4.4,
			"SozialBeziehende": 466,
			"Mietpreis": "NA"
		},
		{
			"": 14106,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9970,
			"SteuerEinkommen_P25": 20.7,
			"SteuerEinkommen_Median": 41.5,
			"SteuerEinkommen_P75": 63.8,
			"eink_arm_Sum": 2580,
			"ant_eink_arm": 25.9,
			"SozialQuote": 5,
			"SozialBeziehende": 990,
			"Mietpreis": "NA"
		},
		{
			"": 14107,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2266,
			"SteuerEinkommen_P25": 36.65,
			"SteuerEinkommen_Median": 60.15,
			"SteuerEinkommen_P75": 89.05,
			"eink_arm_Sum": 606,
			"ant_eink_arm": 26.7,
			"SozialQuote": 5,
			"SozialBeziehende": 990,
			"Mietpreis": "NA"
		},
		{
			"": 14151,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2051,
			"SteuerEinkommen_P25": 22.5,
			"SteuerEinkommen_Median": 47.65,
			"SteuerEinkommen_P75": 76.8,
			"eink_arm_Sum": 497,
			"ant_eink_arm": 24.2,
			"SozialQuote": 3.5,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 14152,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 417,
			"SteuerEinkommen_P25": 36.3,
			"SteuerEinkommen_Median": 73.4,
			"SteuerEinkommen_P75": 125.3,
			"eink_arm_Sum": 110,
			"ant_eink_arm": 26.4,
			"SozialQuote": 3.5,
			"SozialBeziehende": 137,
			"Mietpreis": "NA"
		},
		{
			"": 14173,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5736,
			"SteuerEinkommen_P25": 17.8,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 65.3,
			"eink_arm_Sum": 1721,
			"ant_eink_arm": 30,
			"SozialQuote": 9.3,
			"SozialBeziehende": 911,
			"Mietpreis": "NA"
		},
		{
			"": 14174,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 815,
			"SteuerEinkommen_P25": 34.5,
			"SteuerEinkommen_Median": 57.4,
			"SteuerEinkommen_P75": 94.8,
			"eink_arm_Sum": 240,
			"ant_eink_arm": 29.4,
			"SozialQuote": 9.3,
			"SozialBeziehende": 911,
			"Mietpreis": "NA"
		},
		{
			"": 14195,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5870,
			"SteuerEinkommen_P25": 17.2,
			"SteuerEinkommen_Median": 34.5,
			"SteuerEinkommen_P75": 54.3,
			"eink_arm_Sum": 1910,
			"ant_eink_arm": 32.5,
			"SozialQuote": 6.8,
			"SozialBeziehende": 838,
			"Mietpreis": "NA"
		},
		{
			"": 14196,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1610,
			"SteuerEinkommen_P25": 34.9,
			"SteuerEinkommen_Median": 52.9,
			"SteuerEinkommen_P75": 73.8,
			"eink_arm_Sum": 474,
			"ant_eink_arm": 29.4,
			"SozialQuote": 6.8,
			"SozialBeziehende": 838,
			"Mietpreis": "NA"
		},
		{
			"": 14240,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4940,
			"SteuerEinkommen_P25": 16.7,
			"SteuerEinkommen_Median": 39.25,
			"SteuerEinkommen_P75": 65.35,
			"eink_arm_Sum": 1526,
			"ant_eink_arm": 30.9,
			"SozialQuote": 7.4,
			"SozialBeziehende": 691,
			"Mietpreis": "NA"
		},
		{
			"": 14241,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1004,
			"SteuerEinkommen_P25": 41.7,
			"SteuerEinkommen_Median": 64,
			"SteuerEinkommen_P75": 94.6,
			"eink_arm_Sum": 219,
			"ant_eink_arm": 21.8,
			"SozialQuote": 7.4,
			"SozialBeziehende": 691,
			"Mietpreis": "NA"
		},
		{
			"": 14262,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1635,
			"SteuerEinkommen_P25": 29.5,
			"SteuerEinkommen_Median": 56.55,
			"SteuerEinkommen_P75": 85.9,
			"eink_arm_Sum": 310,
			"ant_eink_arm": 19,
			"SozialQuote": 3.2,
			"SozialBeziehende": 103,
			"Mietpreis": "NA"
		},
		{
			"": 14263,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 373,
			"SteuerEinkommen_P25": 57.9,
			"SteuerEinkommen_Median": 96.4,
			"SteuerEinkommen_P75": 149.4,
			"eink_arm_Sum": 42,
			"ant_eink_arm": 11.3,
			"SozialQuote": 3.2,
			"SozialBeziehende": 103,
			"Mietpreis": "NA"
		},
		{
			"": 14307,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8832,
			"SteuerEinkommen_P25": 23.1,
			"SteuerEinkommen_Median": 46.4,
			"SteuerEinkommen_P75": 73.3,
			"eink_arm_Sum": 2070,
			"ant_eink_arm": 23.4,
			"SozialQuote": 2.8,
			"SozialBeziehende": 571,
			"Mietpreis": "NA"
		},
		{
			"": 14308,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2782,
			"SteuerEinkommen_P25": 54.2,
			"SteuerEinkommen_Median": 83,
			"SteuerEinkommen_P75": 128.7,
			"eink_arm_Sum": 355,
			"ant_eink_arm": 12.8,
			"SozialQuote": 2.8,
			"SozialBeziehende": 571,
			"Mietpreis": "NA"
		},
		{
			"": 14329,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4049,
			"SteuerEinkommen_P25": 23.2,
			"SteuerEinkommen_Median": 52.2,
			"SteuerEinkommen_P75": 86,
			"eink_arm_Sum": 947,
			"ant_eink_arm": 23.4,
			"SozialQuote": 1,
			"SozialBeziehende": 97,
			"Mietpreis": "NA"
		},
		{
			"": 14330,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1400,
			"SteuerEinkommen_P25": 83.95,
			"SteuerEinkommen_Median": 129.3,
			"SteuerEinkommen_P75": 208.4,
			"eink_arm_Sum": 92,
			"ant_eink_arm": 6.6,
			"SozialQuote": 1,
			"SozialBeziehende": 97,
			"Mietpreis": "NA"
		},
		{
			"": 14375,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2740,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 57,
			"SteuerEinkommen_P75": 100.4,
			"eink_arm_Sum": 733,
			"ant_eink_arm": 26.8,
			"SozialQuote": 0.7,
			"SozialBeziehende": 53,
			"Mietpreis": "NA"
		},
		{
			"": 14376,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1281,
			"SteuerEinkommen_P25": 98.8,
			"SteuerEinkommen_Median": 166.7,
			"SteuerEinkommen_P75": 286.6,
			"eink_arm_Sum": 75,
			"ant_eink_arm": 5.9,
			"SozialQuote": 0.7,
			"SozialBeziehende": 53,
			"Mietpreis": "NA"
		},
		{
			"": 14397,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4327,
			"SteuerEinkommen_P25": 22,
			"SteuerEinkommen_Median": 54.45,
			"SteuerEinkommen_P75": 92.5,
			"eink_arm_Sum": 1076,
			"ant_eink_arm": 24.9,
			"SozialQuote": 1.1,
			"SozialBeziehende": 112,
			"Mietpreis": "NA"
		},
		{
			"": 14398,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1484,
			"SteuerEinkommen_P25": 84.1,
			"SteuerEinkommen_Median": 140.8,
			"SteuerEinkommen_P75": 237.2,
			"eink_arm_Sum": 113,
			"ant_eink_arm": 7.6,
			"SozialQuote": 1.1,
			"SozialBeziehende": 112,
			"Mietpreis": "NA"
		},
		{
			"": 14419,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3151,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 48.3,
			"SteuerEinkommen_P75": 80.3,
			"eink_arm_Sum": 787,
			"ant_eink_arm": 25,
			"SozialQuote": 1.4,
			"SozialBeziehende": 98,
			"Mietpreis": "NA"
		},
		{
			"": 14420,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 987,
			"SteuerEinkommen_P25": 70.85,
			"SteuerEinkommen_Median": 113.55,
			"SteuerEinkommen_P75": 200.1,
			"eink_arm_Sum": 96,
			"ant_eink_arm": 9.7,
			"SozialQuote": 1.4,
			"SozialBeziehende": 98,
			"Mietpreis": "NA"
		},
		{
			"": 14442,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3903,
			"SteuerEinkommen_P25": 21.6,
			"SteuerEinkommen_Median": 46.4,
			"SteuerEinkommen_P75": 73,
			"eink_arm_Sum": 974,
			"ant_eink_arm": 25,
			"SozialQuote": 1.3,
			"SozialBeziehende": 135,
			"Mietpreis": "NA"
		},
		{
			"": 14443,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1846,
			"SteuerEinkommen_P25": 71.4,
			"SteuerEinkommen_Median": 105,
			"SteuerEinkommen_P75": 161.8,
			"eink_arm_Sum": 153,
			"ant_eink_arm": 8.3,
			"SozialQuote": 1.3,
			"SozialBeziehende": 135,
			"Mietpreis": "NA"
		},
		{
			"": 14487,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2517,
			"SteuerEinkommen_P25": 30.9,
			"SteuerEinkommen_Median": 62.5,
			"SteuerEinkommen_P75": 100.75,
			"eink_arm_Sum": 440,
			"ant_eink_arm": 17.5,
			"SozialQuote": 1.2,
			"SozialBeziehende": 54,
			"Mietpreis": "NA"
		},
		{
			"": 14488,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 508,
			"SteuerEinkommen_P25": 73.9,
			"SteuerEinkommen_Median": 123.2,
			"SteuerEinkommen_P75": 209,
			"eink_arm_Sum": 42,
			"ant_eink_arm": 8.3,
			"SozialQuote": 1.2,
			"SozialBeziehende": 54,
			"Mietpreis": "NA"
		},
		{
			"": 14509,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2715,
			"SteuerEinkommen_P25": 26.1,
			"SteuerEinkommen_Median": 56.3,
			"SteuerEinkommen_P75": 94.25,
			"eink_arm_Sum": 597,
			"ant_eink_arm": 22,
			"SozialQuote": 2,
			"SozialBeziehende": 106,
			"Mietpreis": "NA"
		},
		{
			"": 14510,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 675,
			"SteuerEinkommen_P25": 72.3,
			"SteuerEinkommen_Median": 117.6,
			"SteuerEinkommen_P75": 191.95,
			"eink_arm_Sum": 57,
			"ant_eink_arm": 8.4,
			"SozialQuote": 2,
			"SozialBeziehende": 106,
			"Mietpreis": "NA"
		},
		{
			"": 14531,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1977,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 46.95,
			"SteuerEinkommen_P75": 74.85,
			"eink_arm_Sum": 550,
			"ant_eink_arm": 27.8,
			"SozialQuote": 1.1,
			"SozialBeziehende": 52,
			"Mietpreis": "NA"
		},
		{
			"": 14532,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 655,
			"SteuerEinkommen_P25": 67,
			"SteuerEinkommen_Median": 105.4,
			"SteuerEinkommen_P75": 173,
			"eink_arm_Sum": 59,
			"ant_eink_arm": 9,
			"SozialQuote": 1.1,
			"SozialBeziehende": 52,
			"Mietpreis": "NA"
		},
		{
			"": 14576,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8108,
			"SteuerEinkommen_P25": 20.9,
			"SteuerEinkommen_Median": 41.3,
			"SteuerEinkommen_P75": 62.9,
			"eink_arm_Sum": 2077,
			"ant_eink_arm": 25.6,
			"SozialQuote": 3.8,
			"SozialBeziehende": 711,
			"Mietpreis": "NA"
		},
		{
			"": 14577,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3058,
			"SteuerEinkommen_P25": 51.2,
			"SteuerEinkommen_Median": 76,
			"SteuerEinkommen_P75": 106.1,
			"eink_arm_Sum": 427,
			"ant_eink_arm": 14,
			"SozialQuote": 3.8,
			"SozialBeziehende": 711,
			"Mietpreis": "NA"
		},
		{
			"": 14599,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11936,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 40.7,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 3132,
			"ant_eink_arm": 26.2,
			"SozialQuote": 5.8,
			"SozialBeziehende": 1743,
			"Mietpreis": "NA"
		},
		{
			"": 14600,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4992,
			"SteuerEinkommen_P25": 43.2,
			"SteuerEinkommen_Median": 64.8,
			"SteuerEinkommen_P75": 91,
			"eink_arm_Sum": 986,
			"ant_eink_arm": 19.8,
			"SozialQuote": 5.8,
			"SozialBeziehende": 1743,
			"Mietpreis": "NA"
		},
		{
			"": 14643,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8561,
			"SteuerEinkommen_P25": 24.25,
			"SteuerEinkommen_Median": 48.8,
			"SteuerEinkommen_P75": 73.4,
			"eink_arm_Sum": 1882,
			"ant_eink_arm": 22,
			"SozialQuote": 2.2,
			"SozialBeziehende": 453,
			"Mietpreis": "NA"
		},
		{
			"": 14644,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3559,
			"SteuerEinkommen_P25": 62.8,
			"SteuerEinkommen_Median": 93.35,
			"SteuerEinkommen_P75": 140.2,
			"eink_arm_Sum": 347,
			"ant_eink_arm": 9.7,
			"SozialQuote": 2.2,
			"SozialBeziehende": 453,
			"Mietpreis": "NA"
		},
		{
			"": 14665,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7765,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 45.2,
			"SteuerEinkommen_P75": 68.8,
			"eink_arm_Sum": 1958,
			"ant_eink_arm": 25.2,
			"SozialQuote": 4.2,
			"SozialBeziehende": 629,
			"Mietpreis": "NA"
		},
		{
			"": 14666,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1704,
			"SteuerEinkommen_P25": 50,
			"SteuerEinkommen_Median": 74.1,
			"SteuerEinkommen_P75": 114.8,
			"eink_arm_Sum": 280,
			"ant_eink_arm": 16.4,
			"SozialQuote": 4.2,
			"SozialBeziehende": 629,
			"Mietpreis": "NA"
		},
		{
			"": 14710,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8111,
			"SteuerEinkommen_P25": 18.9,
			"SteuerEinkommen_Median": 39,
			"SteuerEinkommen_P75": 59.8,
			"eink_arm_Sum": 2304,
			"ant_eink_arm": 28.4,
			"SozialQuote": 5,
			"SozialBeziehende": 1196,
			"Mietpreis": "NA"
		},
		{
			"": 14711,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4211,
			"SteuerEinkommen_P25": 48.5,
			"SteuerEinkommen_Median": 70.7,
			"SteuerEinkommen_P75": 98.2,
			"eink_arm_Sum": 674,
			"ant_eink_arm": 16,
			"SozialQuote": 5,
			"SozialBeziehende": 1196,
			"Mietpreis": "NA"
		},
		{
			"": 14732,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8443,
			"SteuerEinkommen_P25": 20.8,
			"SteuerEinkommen_Median": 44.6,
			"SteuerEinkommen_P75": 70,
			"eink_arm_Sum": 2160,
			"ant_eink_arm": 25.6,
			"SozialQuote": 5.3,
			"SozialBeziehende": 1028,
			"Mietpreis": "NA"
		},
		{
			"": 14733,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2701,
			"SteuerEinkommen_P25": 51,
			"SteuerEinkommen_Median": 82,
			"SteuerEinkommen_P75": 125.5,
			"eink_arm_Sum": 427,
			"ant_eink_arm": 15.8,
			"SozialQuote": 5.3,
			"SozialBeziehende": 1028,
			"Mietpreis": "NA"
		},
		{
			"": 14755,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7850,
			"SteuerEinkommen_P25": 18.1,
			"SteuerEinkommen_Median": 39.2,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 2320,
			"ant_eink_arm": 29.6,
			"SozialQuote": 6.4,
			"SozialBeziehende": 1397,
			"Mietpreis": "NA"
		},
		{
			"": 14756,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3585,
			"SteuerEinkommen_P25": 43.7,
			"SteuerEinkommen_Median": 66.8,
			"SteuerEinkommen_P75": 95.8,
			"eink_arm_Sum": 715,
			"ant_eink_arm": 19.9,
			"SozialQuote": 6.4,
			"SozialBeziehende": 1397,
			"Mietpreis": "NA"
		},
		{
			"": 14801,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2062,
			"SteuerEinkommen_P25": 14.4,
			"SteuerEinkommen_Median": 31.35,
			"SteuerEinkommen_P75": 50.9,
			"eink_arm_Sum": 740,
			"ant_eink_arm": 35.9,
			"SozialQuote": 8.6,
			"SozialBeziehende": 591,
			"Mietpreis": "NA"
		},
		{
			"": 14802,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1251,
			"SteuerEinkommen_P25": 39.8,
			"SteuerEinkommen_Median": 61.5,
			"SteuerEinkommen_P75": 84.7,
			"eink_arm_Sum": 292,
			"ant_eink_arm": 23.3,
			"SozialQuote": 8.6,
			"SozialBeziehende": 591,
			"Mietpreis": "NA"
		},
		{
			"": 14823,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3943,
			"SteuerEinkommen_P25": 16.2,
			"SteuerEinkommen_Median": 33,
			"SteuerEinkommen_P75": 50.4,
			"eink_arm_Sum": 1297,
			"ant_eink_arm": 32.9,
			"SozialQuote": 8.8,
			"SozialBeziehende": 902,
			"Mietpreis": "NA"
		},
		{
			"": 14824,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1630,
			"SteuerEinkommen_P25": 38,
			"SteuerEinkommen_Median": 57.9,
			"SteuerEinkommen_P75": 79.65,
			"eink_arm_Sum": 416,
			"ant_eink_arm": 25.5,
			"SozialQuote": 8.8,
			"SozialBeziehende": 902,
			"Mietpreis": "NA"
		},
		{
			"": 14845,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3661,
			"SteuerEinkommen_P25": 12.55,
			"SteuerEinkommen_Median": 29.2,
			"SteuerEinkommen_P75": 46.6,
			"eink_arm_Sum": 1385,
			"ant_eink_arm": 37.8,
			"SozialQuote": 8.5,
			"SozialBeziehende": 926,
			"Mietpreis": "NA"
		},
		{
			"": 14846,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1907,
			"SteuerEinkommen_P25": 38.2,
			"SteuerEinkommen_Median": 57.9,
			"SteuerEinkommen_P75": 78.8,
			"eink_arm_Sum": 480,
			"ant_eink_arm": 25.2,
			"SozialQuote": 8.5,
			"SozialBeziehende": 926,
			"Mietpreis": "NA"
		},
		{
			"": 14914,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1610,
			"SteuerEinkommen_P25": 22,
			"SteuerEinkommen_Median": 49.95,
			"SteuerEinkommen_P75": 83.4,
			"eink_arm_Sum": 402,
			"ant_eink_arm": 25,
			"SozialQuote": 2.1,
			"SozialBeziehende": 60,
			"Mietpreis": "NA"
		},
		{
			"": 14915,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 320,
			"SteuerEinkommen_P25": 73.8,
			"SteuerEinkommen_Median": 120.65,
			"SteuerEinkommen_P75": 196.5,
			"eink_arm_Sum": 35,
			"ant_eink_arm": 10.9,
			"SozialQuote": 2.1,
			"SozialBeziehende": 60,
			"Mietpreis": "NA"
		},
		{
			"": 14937,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 276,
			"SteuerEinkommen_P25": 13.7,
			"SteuerEinkommen_Median": 36.1,
			"SteuerEinkommen_P75": 73.4,
			"eink_arm_Sum": 94,
			"ant_eink_arm": 34.1,
			"SozialQuote": 1.1,
			"SozialBeziehende": 6,
			"Mietpreis": "NA"
		},
		{
			"": 14938,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 71,
			"SteuerEinkommen_P25": 50.9,
			"SteuerEinkommen_Median": 145.2,
			"SteuerEinkommen_P75": 252.2,
			"eink_arm_Sum": 15,
			"ant_eink_arm": 21.1,
			"SozialQuote": 1.1,
			"SozialBeziehende": 6,
			"Mietpreis": "NA"
		},
		{
			"": 14957,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1111,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 19.5,
			"SteuerEinkommen_P75": 53.1,
			"eink_arm_Sum": 582,
			"ant_eink_arm": 52.4,
			"SozialQuote": 7.4,
			"SozialBeziehende": 115,
			"Mietpreis": "NA"
		},
		{
			"": 14958,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 129,
			"SteuerEinkommen_P25": 57,
			"SteuerEinkommen_Median": 108,
			"SteuerEinkommen_P75": 175.5,
			"eink_arm_Sum": 25,
			"ant_eink_arm": 19.4,
			"SozialQuote": 7.4,
			"SozialBeziehende": 115,
			"Mietpreis": "NA"
		},
		{
			"": 14979,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 542,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 14.1,
			"SteuerEinkommen_P75": 54.5,
			"eink_arm_Sum": 325,
			"ant_eink_arm": 60,
			"SozialQuote": 12.6,
			"SozialBeziehende": 120,
			"Mietpreis": "NA"
		},
		{
			"": 14980,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 92,
			"SteuerEinkommen_P25": 50.35,
			"SteuerEinkommen_Median": 90.3,
			"SteuerEinkommen_P75": 156.1,
			"eink_arm_Sum": 15,
			"ant_eink_arm": 16.3,
			"SozialQuote": 12.6,
			"SozialBeziehende": 120,
			"Mietpreis": "NA"
		},
		{
			"": 15024,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6894,
			"SteuerEinkommen_P25": 19.9,
			"SteuerEinkommen_Median": 43,
			"SteuerEinkommen_P75": 67.8,
			"eink_arm_Sum": 1868,
			"ant_eink_arm": 27.1,
			"SozialQuote": 2.8,
			"SozialBeziehende": 437,
			"Mietpreis": "NA"
		},
		{
			"": 15025,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2312,
			"SteuerEinkommen_P25": 54.9,
			"SteuerEinkommen_Median": 84,
			"SteuerEinkommen_P75": 136.4,
			"eink_arm_Sum": 323,
			"ant_eink_arm": 14,
			"SozialQuote": 2.8,
			"SozialBeziehende": 437,
			"Mietpreis": "NA"
		},
		{
			"": 15046,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1789,
			"SteuerEinkommen_P25": 18.95,
			"SteuerEinkommen_Median": 38.55,
			"SteuerEinkommen_P75": 59.45,
			"eink_arm_Sum": 518,
			"ant_eink_arm": 29,
			"SozialQuote": 5.4,
			"SozialBeziehende": 305,
			"Mietpreis": "NA"
		},
		{
			"": 15047,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1031,
			"SteuerEinkommen_P25": 47.6,
			"SteuerEinkommen_Median": 72.5,
			"SteuerEinkommen_P75": 105,
			"eink_arm_Sum": 169,
			"ant_eink_arm": 16.4,
			"SozialQuote": 5.4,
			"SozialBeziehende": 305,
			"Mietpreis": "NA"
		},
		{
			"": 15069,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3624,
			"SteuerEinkommen_P25": 26.9,
			"SteuerEinkommen_Median": 57,
			"SteuerEinkommen_P75": 94.3,
			"eink_arm_Sum": 755,
			"ant_eink_arm": 20.8,
			"SozialQuote": 2.1,
			"SozialBeziehende": 180,
			"Mietpreis": "NA"
		},
		{
			"": 15070,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1222,
			"SteuerEinkommen_P25": 68.1,
			"SteuerEinkommen_Median": 120.65,
			"SteuerEinkommen_P75": 202.65,
			"eink_arm_Sum": 131,
			"ant_eink_arm": 10.7,
			"SozialQuote": 2.1,
			"SozialBeziehende": 180,
			"Mietpreis": "NA"
		},
		{
			"": 15114,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7615,
			"SteuerEinkommen_P25": 26.5,
			"SteuerEinkommen_Median": 51,
			"SteuerEinkommen_P75": 77.5,
			"eink_arm_Sum": 1575,
			"ant_eink_arm": 20.7,
			"SozialQuote": 3.5,
			"SozialBeziehende": 547,
			"Mietpreis": "NA"
		},
		{
			"": 15115,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1992,
			"SteuerEinkommen_P25": 49.8,
			"SteuerEinkommen_Median": 86,
			"SteuerEinkommen_P75": 138.2,
			"eink_arm_Sum": 330,
			"ant_eink_arm": 16.6,
			"SozialQuote": 3.5,
			"SozialBeziehende": 547,
			"Mietpreis": "NA"
		},
		{
			"": 15136,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3358,
			"SteuerEinkommen_P25": 11.8,
			"SteuerEinkommen_Median": 32.5,
			"SteuerEinkommen_P75": 53,
			"eink_arm_Sum": 1220,
			"ant_eink_arm": 36.3,
			"SozialQuote": 4.5,
			"SozialBeziehende": 475,
			"Mietpreis": "NA"
		},
		{
			"": 15137,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1882,
			"SteuerEinkommen_P25": 46.2,
			"SteuerEinkommen_Median": 67.4,
			"SteuerEinkommen_P75": 96.2,
			"eink_arm_Sum": 331,
			"ant_eink_arm": 17.6,
			"SozialQuote": 4.5,
			"SozialBeziehende": 475,
			"Mietpreis": "NA"
		},
		{
			"": 15159,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 10243,
			"SteuerEinkommen_P25": 21,
			"SteuerEinkommen_Median": 42.5,
			"SteuerEinkommen_P75": 64.6,
			"eink_arm_Sum": 2639,
			"ant_eink_arm": 25.8,
			"SozialQuote": 4.8,
			"SozialBeziehende": 954,
			"Mietpreis": "NA"
		},
		{
			"": 15160,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2254,
			"SteuerEinkommen_P25": 36,
			"SteuerEinkommen_Median": 60,
			"SteuerEinkommen_P75": 90.8,
			"eink_arm_Sum": 617,
			"ant_eink_arm": 27.4,
			"SozialQuote": 4.8,
			"SozialBeziehende": 954,
			"Mietpreis": "NA"
		},
		{
			"": 15205,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2063,
			"SteuerEinkommen_P25": 21.4,
			"SteuerEinkommen_Median": 47.45,
			"SteuerEinkommen_P75": 76.9,
			"eink_arm_Sum": 525,
			"ant_eink_arm": 25.4,
			"SozialQuote": 3.7,
			"SozialBeziehende": 146,
			"Mietpreis": "NA"
		},
		{
			"": 15206,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 404,
			"SteuerEinkommen_P25": 31.5,
			"SteuerEinkommen_Median": 63.55,
			"SteuerEinkommen_P75": 122.4,
			"eink_arm_Sum": 120,
			"ant_eink_arm": 29.7,
			"SozialQuote": 3.7,
			"SozialBeziehende": 146,
			"Mietpreis": "NA"
		},
		{
			"": 15226,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5914,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 40.5,
			"SteuerEinkommen_P75": 66.3,
			"eink_arm_Sum": 1768,
			"ant_eink_arm": 29.9,
			"SozialQuote": 9.2,
			"SozialBeziehende": 913,
			"Mietpreis": "NA"
		},
		{
			"": 15227,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 793,
			"SteuerEinkommen_P25": 34.7,
			"SteuerEinkommen_Median": 58,
			"SteuerEinkommen_P75": 95,
			"eink_arm_Sum": 228,
			"ant_eink_arm": 28.8,
			"SozialQuote": 9.2,
			"SozialBeziehende": 913,
			"Mietpreis": "NA"
		},
		{
			"": 15248,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5934,
			"SteuerEinkommen_P25": 17.3,
			"SteuerEinkommen_Median": 34.6,
			"SteuerEinkommen_P75": 55,
			"eink_arm_Sum": 1925,
			"ant_eink_arm": 32.4,
			"SozialQuote": 6.7,
			"SozialBeziehende": 836,
			"Mietpreis": "NA"
		},
		{
			"": 15249,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1625,
			"SteuerEinkommen_P25": 33.9,
			"SteuerEinkommen_Median": 51.2,
			"SteuerEinkommen_P75": 72.8,
			"eink_arm_Sum": 517,
			"ant_eink_arm": 31.8,
			"SozialQuote": 6.7,
			"SozialBeziehende": 836,
			"Mietpreis": "NA"
		},
		{
			"": 15293,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4848,
			"SteuerEinkommen_P25": 16.75,
			"SteuerEinkommen_Median": 38.95,
			"SteuerEinkommen_P75": 65.4,
			"eink_arm_Sum": 1508,
			"ant_eink_arm": 31.1,
			"SozialQuote": 7.1,
			"SozialBeziehende": 658,
			"Mietpreis": "NA"
		},
		{
			"": 15294,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 976,
			"SteuerEinkommen_P25": 42,
			"SteuerEinkommen_Median": 64.9,
			"SteuerEinkommen_P75": 93.3,
			"eink_arm_Sum": 212,
			"ant_eink_arm": 21.7,
			"SozialQuote": 7.1,
			"SozialBeziehende": 658,
			"Mietpreis": "NA"
		},
		{
			"": 15315,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1988,
			"SteuerEinkommen_P25": 34.1,
			"SteuerEinkommen_Median": 60.1,
			"SteuerEinkommen_P75": 92.1,
			"eink_arm_Sum": 353,
			"ant_eink_arm": 17.8,
			"SozialQuote": 3,
			"SozialBeziehende": 114,
			"Mietpreis": "NA"
		},
		{
			"": 15316,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 408,
			"SteuerEinkommen_P25": 66.1,
			"SteuerEinkommen_Median": 108.4,
			"SteuerEinkommen_P75": 165.9,
			"eink_arm_Sum": 42,
			"ant_eink_arm": 10.3,
			"SozialQuote": 3,
			"SozialBeziehende": 114,
			"Mietpreis": "NA"
		},
		{
			"": 15359,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8934,
			"SteuerEinkommen_P25": 22.7,
			"SteuerEinkommen_Median": 46.3,
			"SteuerEinkommen_P75": 72.5,
			"eink_arm_Sum": 2156,
			"ant_eink_arm": 24.1,
			"SozialQuote": 2.6,
			"SozialBeziehende": 541,
			"Mietpreis": "NA"
		},
		{
			"": 15360,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2748,
			"SteuerEinkommen_P25": 54.7,
			"SteuerEinkommen_Median": 83.45,
			"SteuerEinkommen_P75": 129.95,
			"eink_arm_Sum": 388,
			"ant_eink_arm": 14.1,
			"SozialQuote": 2.6,
			"SozialBeziehende": 541,
			"Mietpreis": "NA"
		},
		{
			"": 15382,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4107,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 51,
			"SteuerEinkommen_P75": 86.7,
			"eink_arm_Sum": 1027,
			"ant_eink_arm": 25,
			"SozialQuote": 0.8,
			"SozialBeziehende": 82,
			"Mietpreis": "NA"
		},
		{
			"": 15383,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1389,
			"SteuerEinkommen_P25": 82.3,
			"SteuerEinkommen_Median": 129,
			"SteuerEinkommen_P75": 209.5,
			"eink_arm_Sum": 102,
			"ant_eink_arm": 7.3,
			"SozialQuote": 0.8,
			"SozialBeziehende": 82,
			"Mietpreis": "NA"
		},
		{
			"": 15428,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2723,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 55.65,
			"SteuerEinkommen_P75": 100,
			"eink_arm_Sum": 754,
			"ant_eink_arm": 27.7,
			"SozialQuote": 0.7,
			"SozialBeziehende": 51,
			"Mietpreis": "NA"
		},
		{
			"": 15429,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1298,
			"SteuerEinkommen_P25": 99.65,
			"SteuerEinkommen_Median": 162.65,
			"SteuerEinkommen_P75": 269.6,
			"eink_arm_Sum": 94,
			"ant_eink_arm": 7.2,
			"SozialQuote": 0.7,
			"SozialBeziehende": 51,
			"Mietpreis": "NA"
		},
		{
			"": 15451,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4400,
			"SteuerEinkommen_P25": 21.9,
			"SteuerEinkommen_Median": 54.7,
			"SteuerEinkommen_P75": 90,
			"eink_arm_Sum": 1094,
			"ant_eink_arm": 24.9,
			"SozialQuote": 1.1,
			"SozialBeziehende": 108,
			"Mietpreis": "NA"
		},
		{
			"": 15452,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1488,
			"SteuerEinkommen_P25": 83.5,
			"SteuerEinkommen_Median": 135.1,
			"SteuerEinkommen_P75": 238.4,
			"eink_arm_Sum": 115,
			"ant_eink_arm": 7.7,
			"SozialQuote": 1.1,
			"SozialBeziehende": 108,
			"Mietpreis": "NA"
		},
		{
			"": 15473,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3193,
			"SteuerEinkommen_P25": 22.5,
			"SteuerEinkommen_Median": 49.4,
			"SteuerEinkommen_P75": 80.5,
			"eink_arm_Sum": 770,
			"ant_eink_arm": 24.1,
			"SozialQuote": 1.4,
			"SozialBeziehende": 100,
			"Mietpreis": "NA"
		},
		{
			"": 15474,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1007,
			"SteuerEinkommen_P25": 68.5,
			"SteuerEinkommen_Median": 113.3,
			"SteuerEinkommen_P75": 197.8,
			"eink_arm_Sum": 99,
			"ant_eink_arm": 9.8,
			"SozialQuote": 1.4,
			"SozialBeziehende": 100,
			"Mietpreis": "NA"
		},
		{
			"": 15496,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3874,
			"SteuerEinkommen_P25": 20.65,
			"SteuerEinkommen_Median": 45,
			"SteuerEinkommen_P75": 72.55,
			"eink_arm_Sum": 999,
			"ant_eink_arm": 25.8,
			"SozialQuote": 1.5,
			"SozialBeziehende": 150,
			"Mietpreis": "NA"
		},
		{
			"": 15497,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1837,
			"SteuerEinkommen_P25": 68.6,
			"SteuerEinkommen_Median": 102.85,
			"SteuerEinkommen_P75": 157.8,
			"eink_arm_Sum": 158,
			"ant_eink_arm": 8.6,
			"SozialQuote": 1.5,
			"SozialBeziehende": 150,
			"Mietpreis": "NA"
		},
		{
			"": 15541,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2541,
			"SteuerEinkommen_P25": 30.3,
			"SteuerEinkommen_Median": 61.45,
			"SteuerEinkommen_P75": 101.1,
			"eink_arm_Sum": 472,
			"ant_eink_arm": 18.6,
			"SozialQuote": 1.4,
			"SozialBeziehende": 68,
			"Mietpreis": "NA"
		},
		{
			"": 15542,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 517,
			"SteuerEinkommen_P25": 74.7,
			"SteuerEinkommen_Median": 121.55,
			"SteuerEinkommen_P75": 212.25,
			"eink_arm_Sum": 40,
			"ant_eink_arm": 7.7,
			"SozialQuote": 1.4,
			"SozialBeziehende": 68,
			"Mietpreis": "NA"
		},
		{
			"": 15563,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2765,
			"SteuerEinkommen_P25": 24.1,
			"SteuerEinkommen_Median": 55.5,
			"SteuerEinkommen_P75": 94.15,
			"eink_arm_Sum": 640,
			"ant_eink_arm": 23.1,
			"SozialQuote": 1.9,
			"SozialBeziehende": 108,
			"Mietpreis": "NA"
		},
		{
			"": 15564,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 693,
			"SteuerEinkommen_P25": 72.95,
			"SteuerEinkommen_Median": 116.8,
			"SteuerEinkommen_P75": 196.05,
			"eink_arm_Sum": 70,
			"ant_eink_arm": 10.1,
			"SozialQuote": 1.9,
			"SozialBeziehende": 108,
			"Mietpreis": "NA"
		},
		{
			"": 15585,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2051,
			"SteuerEinkommen_P25": 17.4,
			"SteuerEinkommen_Median": 45.7,
			"SteuerEinkommen_P75": 73.9,
			"eink_arm_Sum": 603,
			"ant_eink_arm": 29.4,
			"SozialQuote": 1.3,
			"SozialBeziehende": 63,
			"Mietpreis": "NA"
		},
		{
			"": 15586,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 659,
			"SteuerEinkommen_P25": 66.3,
			"SteuerEinkommen_Median": 104.4,
			"SteuerEinkommen_P75": 176.2,
			"eink_arm_Sum": 67,
			"ant_eink_arm": 10.2,
			"SozialQuote": 1.3,
			"SozialBeziehende": 63,
			"Mietpreis": "NA"
		},
		{
			"": 15630,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8149,
			"SteuerEinkommen_P25": 21.5,
			"SteuerEinkommen_Median": 41.8,
			"SteuerEinkommen_P75": 63.1,
			"eink_arm_Sum": 2046,
			"ant_eink_arm": 25.1,
			"SozialQuote": 3.8,
			"SozialBeziehende": 712,
			"Mietpreis": "NA"
		},
		{
			"": 15631,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3108,
			"SteuerEinkommen_P25": 50.5,
			"SteuerEinkommen_Median": 75.05,
			"SteuerEinkommen_P75": 106.7,
			"eink_arm_Sum": 463,
			"ant_eink_arm": 14.9,
			"SozialQuote": 3.8,
			"SozialBeziehende": 712,
			"Mietpreis": "NA"
		},
		{
			"": 15653,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12060,
			"SteuerEinkommen_P25": 20.2,
			"SteuerEinkommen_Median": 40.5,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 3198,
			"ant_eink_arm": 26.5,
			"SozialQuote": 5.6,
			"SozialBeziehende": 1679,
			"Mietpreis": "NA"
		},
		{
			"": 15654,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4869,
			"SteuerEinkommen_P25": 43,
			"SteuerEinkommen_Median": 64.6,
			"SteuerEinkommen_P75": 91.6,
			"eink_arm_Sum": 1008,
			"ant_eink_arm": 20.7,
			"SozialQuote": 5.6,
			"SozialBeziehende": 1679,
			"Mietpreis": "NA"
		},
		{
			"": 15697,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8563,
			"SteuerEinkommen_P25": 24,
			"SteuerEinkommen_Median": 48.6,
			"SteuerEinkommen_P75": 73,
			"eink_arm_Sum": 1913,
			"ant_eink_arm": 22.3,
			"SozialQuote": 2.2,
			"SozialBeziehende": 472,
			"Mietpreis": "NA"
		},
		{
			"": 15698,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3545,
			"SteuerEinkommen_P25": 61.9,
			"SteuerEinkommen_Median": 92.6,
			"SteuerEinkommen_P75": 139.75,
			"eink_arm_Sum": 370,
			"ant_eink_arm": 10.4,
			"SozialQuote": 2.2,
			"SozialBeziehende": 472,
			"Mietpreis": "NA"
		},
		{
			"": 15719,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7786,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 45,
			"SteuerEinkommen_P75": 67.7,
			"eink_arm_Sum": 1942,
			"ant_eink_arm": 24.9,
			"SozialQuote": 4.2,
			"SozialBeziehende": 638,
			"Mietpreis": "NA"
		},
		{
			"": 15720,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1696,
			"SteuerEinkommen_P25": 47.2,
			"SteuerEinkommen_Median": 73.2,
			"SteuerEinkommen_P75": 112.1,
			"eink_arm_Sum": 312,
			"ant_eink_arm": 18.4,
			"SozialQuote": 4.2,
			"SozialBeziehende": 638,
			"Mietpreis": "NA"
		},
		{
			"": 15764,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8152,
			"SteuerEinkommen_P25": 18.6,
			"SteuerEinkommen_Median": 38.8,
			"SteuerEinkommen_P75": 59.3,
			"eink_arm_Sum": 2359,
			"ant_eink_arm": 28.9,
			"SozialQuote": 5.1,
			"SozialBeziehende": 1208,
			"Mietpreis": "NA"
		},
		{
			"": 15765,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4274,
			"SteuerEinkommen_P25": 47.1,
			"SteuerEinkommen_Median": 70.4,
			"SteuerEinkommen_P75": 97.5,
			"eink_arm_Sum": 743,
			"ant_eink_arm": 17.4,
			"SozialQuote": 5.1,
			"SozialBeziehende": 1208,
			"Mietpreis": "NA"
		},
		{
			"": 15786,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8507,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 44.7,
			"SteuerEinkommen_P75": 70,
			"eink_arm_Sum": 2261,
			"ant_eink_arm": 26.6,
			"SozialQuote": 5.2,
			"SozialBeziehende": 1024,
			"Mietpreis": "NA"
		},
		{
			"": 15787,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2717,
			"SteuerEinkommen_P25": 50.1,
			"SteuerEinkommen_Median": 81.4,
			"SteuerEinkommen_P75": 124.5,
			"eink_arm_Sum": 438,
			"ant_eink_arm": 16.1,
			"SozialQuote": 5.2,
			"SozialBeziehende": 1024,
			"Mietpreis": "NA"
		},
		{
			"": 15808,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8150,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 39.3,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 2363,
			"ant_eink_arm": 29,
			"SozialQuote": 5.9,
			"SozialBeziehende": 1327,
			"Mietpreis": "NA"
		},
		{
			"": 15809,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3630,
			"SteuerEinkommen_P25": 42.1,
			"SteuerEinkommen_Median": 66,
			"SteuerEinkommen_P75": 94.9,
			"eink_arm_Sum": 766,
			"ant_eink_arm": 21.1,
			"SozialQuote": 5.9,
			"SozialBeziehende": 1327,
			"Mietpreis": "NA"
		},
		{
			"": 15854,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2096,
			"SteuerEinkommen_P25": 14.4,
			"SteuerEinkommen_Median": 32.1,
			"SteuerEinkommen_P75": 50.7,
			"eink_arm_Sum": 756,
			"ant_eink_arm": 36.1,
			"SozialQuote": 8.5,
			"SozialBeziehende": 591,
			"Mietpreis": "NA"
		},
		{
			"": 15855,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1250,
			"SteuerEinkommen_P25": 38.2,
			"SteuerEinkommen_Median": 59.85,
			"SteuerEinkommen_P75": 84.5,
			"eink_arm_Sum": 311,
			"ant_eink_arm": 24.9,
			"SozialQuote": 8.5,
			"SozialBeziehende": 591,
			"Mietpreis": "NA"
		},
		{
			"": 15876,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4015,
			"SteuerEinkommen_P25": 17.6,
			"SteuerEinkommen_Median": 33.2,
			"SteuerEinkommen_P75": 51.7,
			"eink_arm_Sum": 1292,
			"ant_eink_arm": 32.2,
			"SozialQuote": 8.8,
			"SozialBeziehende": 919,
			"Mietpreis": "NA"
		},
		{
			"": 15877,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1635,
			"SteuerEinkommen_P25": 36.7,
			"SteuerEinkommen_Median": 57.6,
			"SteuerEinkommen_P75": 79.8,
			"eink_arm_Sum": 433,
			"ant_eink_arm": 26.5,
			"SozialQuote": 8.8,
			"SozialBeziehende": 919,
			"Mietpreis": "NA"
		},
		{
			"": 15897,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3613,
			"SteuerEinkommen_P25": 11.6,
			"SteuerEinkommen_Median": 29.1,
			"SteuerEinkommen_P75": 46.9,
			"eink_arm_Sum": 1410,
			"ant_eink_arm": 39,
			"SozialQuote": 8.5,
			"SozialBeziehende": 908,
			"Mietpreis": "NA"
		},
		{
			"": 15898,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1829,
			"SteuerEinkommen_P25": 36.65,
			"SteuerEinkommen_Median": 55.8,
			"SteuerEinkommen_P75": 76.965,
			"eink_arm_Sum": 483,
			"ant_eink_arm": 26.4,
			"SozialQuote": 8.5,
			"SozialBeziehende": 908,
			"Mietpreis": "NA"
		},
		{
			"": 15967,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1562,
			"SteuerEinkommen_P25": 20.35,
			"SteuerEinkommen_Median": 46.35,
			"SteuerEinkommen_P75": 75.6,
			"eink_arm_Sum": 408,
			"ant_eink_arm": 26.1,
			"SozialQuote": 2.1,
			"SozialBeziehende": 63,
			"Mietpreis": "NA"
		},
		{
			"": 15968,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 323,
			"SteuerEinkommen_P25": 71.3,
			"SteuerEinkommen_Median": 115.8,
			"SteuerEinkommen_P75": 194.5,
			"eink_arm_Sum": 28,
			"ant_eink_arm": 8.7,
			"SozialQuote": 2.1,
			"SozialBeziehende": 63,
			"Mietpreis": "NA"
		},
		{
			"": 15989,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 264,
			"SteuerEinkommen_P25": 13.6,
			"SteuerEinkommen_Median": 35,
			"SteuerEinkommen_P75": 71.7,
			"eink_arm_Sum": 94,
			"ant_eink_arm": 35.6,
			"SozialQuote": 2,
			"SozialBeziehende": 11,
			"Mietpreis": "NA"
		},
		{
			"": 15990,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 61,
			"SteuerEinkommen_P25": 60,
			"SteuerEinkommen_Median": 143.5,
			"SteuerEinkommen_P75": 224.1,
			"eink_arm_Sum": 9,
			"ant_eink_arm": 14.8,
			"SozialQuote": 2,
			"SozialBeziehende": 11,
			"Mietpreis": "NA"
		},
		{
			"": 16008,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1104,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 20.2,
			"SteuerEinkommen_P75": 53.3,
			"eink_arm_Sum": 561,
			"ant_eink_arm": 50.8,
			"SozialQuote": 7.5,
			"SozialBeziehende": 119,
			"Mietpreis": "NA"
		},
		{
			"": 16009,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 123,
			"SteuerEinkommen_P25": 57.4,
			"SteuerEinkommen_Median": 98.8,
			"SteuerEinkommen_P75": 160.6,
			"eink_arm_Sum": 22,
			"ant_eink_arm": 17.9,
			"SozialQuote": 7.5,
			"SozialBeziehende": 119,
			"Mietpreis": "NA"
		},
		{
			"": 16029,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 526,
			"SteuerEinkommen_P25": 0,
			"SteuerEinkommen_Median": 9.4,
			"SteuerEinkommen_P75": 45.4,
			"eink_arm_Sum": 326,
			"ant_eink_arm": 62,
			"SozialQuote": 12.6,
			"SozialBeziehende": 119,
			"Mietpreis": "NA"
		},
		{
			"": 16030,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 87,
			"SteuerEinkommen_P25": 47.7,
			"SteuerEinkommen_Median": 84.3,
			"SteuerEinkommen_P75": 150,
			"eink_arm_Sum": 19,
			"ant_eink_arm": 21.8,
			"SozialQuote": 12.6,
			"SozialBeziehende": 119,
			"Mietpreis": "NA"
		},
		{
			"": 16074,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6643,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 41.4,
			"SteuerEinkommen_P75": 65.2,
			"eink_arm_Sum": 1835,
			"ant_eink_arm": 27.6,
			"SozialQuote": 2.7,
			"SozialBeziehende": 418,
			"Mietpreis": "NA"
		},
		{
			"": 16075,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2330,
			"SteuerEinkommen_P25": 57.2,
			"SteuerEinkommen_Median": 85.45,
			"SteuerEinkommen_P75": 135,
			"eink_arm_Sum": 286,
			"ant_eink_arm": 12.3,
			"SozialQuote": 2.7,
			"SozialBeziehende": 418,
			"Mietpreis": "NA"
		},
		{
			"": 16097,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1853,
			"SteuerEinkommen_P25": 17.7,
			"SteuerEinkommen_Median": 37.7,
			"SteuerEinkommen_P75": 59,
			"eink_arm_Sum": 562,
			"ant_eink_arm": 30.3,
			"SozialQuote": 5.6,
			"SozialBeziehende": 327,
			"Mietpreis": "NA"
		},
		{
			"": 16098,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1032,
			"SteuerEinkommen_P25": 48.8,
			"SteuerEinkommen_Median": 74.2,
			"SteuerEinkommen_P75": 106.7,
			"eink_arm_Sum": 171,
			"ant_eink_arm": 16.6,
			"SozialQuote": 5.6,
			"SozialBeziehende": 327,
			"Mietpreis": "NA"
		},
		{
			"": 16119,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3461,
			"SteuerEinkommen_P25": 24.9,
			"SteuerEinkommen_Median": 53.9,
			"SteuerEinkommen_P75": 86.9,
			"eink_arm_Sum": 755,
			"ant_eink_arm": 21.8,
			"SozialQuote": 2.1,
			"SozialBeziehende": 181,
			"Mietpreis": "NA"
		},
		{
			"": 16120,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1206,
			"SteuerEinkommen_P25": 70,
			"SteuerEinkommen_Median": 116.2,
			"SteuerEinkommen_P75": 190.8,
			"eink_arm_Sum": 126,
			"ant_eink_arm": 10.4,
			"SozialQuote": 2.1,
			"SozialBeziehende": 181,
			"Mietpreis": "NA"
		},
		{
			"": 16164,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7132,
			"SteuerEinkommen_P25": 25.7,
			"SteuerEinkommen_Median": 49.9,
			"SteuerEinkommen_P75": 74.1,
			"eink_arm_Sum": 1477,
			"ant_eink_arm": 20.7,
			"SozialQuote": 3.3,
			"SozialBeziehende": 523,
			"Mietpreis": "NA"
		},
		{
			"": 16165,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2044,
			"SteuerEinkommen_P25": 50.5,
			"SteuerEinkommen_Median": 85,
			"SteuerEinkommen_P75": 134.3,
			"eink_arm_Sum": 343,
			"ant_eink_arm": 16.8,
			"SozialQuote": 3.3,
			"SozialBeziehende": 523,
			"Mietpreis": "NA"
		},
		{
			"": 16186,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3267,
			"SteuerEinkommen_P25": 11.5,
			"SteuerEinkommen_Median": 31.9,
			"SteuerEinkommen_P75": 51.2,
			"eink_arm_Sum": 1183,
			"ant_eink_arm": 36.2,
			"SozialQuote": 4.4,
			"SozialBeziehende": 466,
			"Mietpreis": "NA"
		},
		{
			"": 16187,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1895,
			"SteuerEinkommen_P25": 45.5,
			"SteuerEinkommen_Median": 68,
			"SteuerEinkommen_P75": 97.5,
			"eink_arm_Sum": 343,
			"ant_eink_arm": 18.1,
			"SozialQuote": 4.4,
			"SozialBeziehende": 466,
			"Mietpreis": "NA"
		},
		{
			"": 16209,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9976,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 41.8,
			"SteuerEinkommen_P75": 63.6,
			"eink_arm_Sum": 2554,
			"ant_eink_arm": 25.6,
			"SozialQuote": 4.9,
			"SozialBeziehende": 982,
			"Mietpreis": "NA"
		},
		{
			"": 16210,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2331,
			"SteuerEinkommen_P25": 38.6,
			"SteuerEinkommen_Median": 61.55,
			"SteuerEinkommen_P75": 91.6,
			"eink_arm_Sum": 576,
			"ant_eink_arm": 24.7,
			"SozialQuote": 4.9,
			"SozialBeziehende": 982,
			"Mietpreis": "NA"
		},
		{
			"": 16254,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2012,
			"SteuerEinkommen_P25": 20.1,
			"SteuerEinkommen_Median": 45.3,
			"SteuerEinkommen_P75": 71.4,
			"eink_arm_Sum": 525,
			"ant_eink_arm": 26.1,
			"SozialQuote": 3.5,
			"SozialBeziehende": 146,
			"Mietpreis": "NA"
		},
		{
			"": 16255,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 434,
			"SteuerEinkommen_P25": 34.5,
			"SteuerEinkommen_Median": 67.5,
			"SteuerEinkommen_P75": 115.7,
			"eink_arm_Sum": 127,
			"ant_eink_arm": 29.3,
			"SozialQuote": 3.5,
			"SozialBeziehende": 146,
			"Mietpreis": "NA"
		},
		{
			"": 16276,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5855,
			"SteuerEinkommen_P25": 17.8,
			"SteuerEinkommen_Median": 40.2,
			"SteuerEinkommen_P75": 65,
			"eink_arm_Sum": 1728,
			"ant_eink_arm": 29.5,
			"SozialQuote": 8.6,
			"SozialBeziehende": 876,
			"Mietpreis": "NA"
		},
		{
			"": 16277,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 864,
			"SteuerEinkommen_P25": 37.4,
			"SteuerEinkommen_Median": 60,
			"SteuerEinkommen_P75": 99.9,
			"eink_arm_Sum": 223,
			"ant_eink_arm": 25.8,
			"SozialQuote": 8.6,
			"SozialBeziehende": 876,
			"Mietpreis": "NA"
		},
		{
			"": 16299,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5777,
			"SteuerEinkommen_P25": 16.8,
			"SteuerEinkommen_Median": 34,
			"SteuerEinkommen_P75": 53.9,
			"eink_arm_Sum": 1905,
			"ant_eink_arm": 33,
			"SozialQuote": 6.9,
			"SozialBeziehende": 855,
			"Mietpreis": "NA"
		},
		{
			"": 16300,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1629,
			"SteuerEinkommen_P25": 34,
			"SteuerEinkommen_Median": 51.3,
			"SteuerEinkommen_P75": 73.9,
			"eink_arm_Sum": 495,
			"ant_eink_arm": 30.4,
			"SozialQuote": 6.9,
			"SozialBeziehende": 855,
			"Mietpreis": "NA"
		},
		{
			"": 16344,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4704,
			"SteuerEinkommen_P25": 16.3,
			"SteuerEinkommen_Median": 39.4,
			"SteuerEinkommen_P75": 63.9,
			"eink_arm_Sum": 1459,
			"ant_eink_arm": 31,
			"SozialQuote": 6.7,
			"SozialBeziehende": 617,
			"Mietpreis": "NA"
		},
		{
			"": 16345,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1021,
			"SteuerEinkommen_P25": 42.7,
			"SteuerEinkommen_Median": 64.85,
			"SteuerEinkommen_P75": 99.95,
			"eink_arm_Sum": 209,
			"ant_eink_arm": 20.5,
			"SozialQuote": 6.7,
			"SozialBeziehende": 617,
			"Mietpreis": "NA"
		},
		{
			"": 16366,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2146,
			"SteuerEinkommen_P25": 35,
			"SteuerEinkommen_Median": 59.9,
			"SteuerEinkommen_P75": 88,
			"eink_arm_Sum": 345,
			"ant_eink_arm": 16.1,
			"SozialQuote": 2.5,
			"SozialBeziehende": 109,
			"Mietpreis": "NA"
		},
		{
			"": 16367,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 478,
			"SteuerEinkommen_P25": 73.3,
			"SteuerEinkommen_Median": 111.4,
			"SteuerEinkommen_P75": 168.6,
			"eink_arm_Sum": 42,
			"ant_eink_arm": 8.8,
			"SozialQuote": 2.5,
			"SozialBeziehende": 109,
			"Mietpreis": "NA"
		},
		{
			"": 16412,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8766,
			"SteuerEinkommen_P25": 21.6,
			"SteuerEinkommen_Median": 45.1,
			"SteuerEinkommen_P75": 69.8,
			"eink_arm_Sum": 2165,
			"ant_eink_arm": 24.7,
			"SozialQuote": 2.6,
			"SozialBeziehende": 537,
			"Mietpreis": "NA"
		},
		{
			"": 16413,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2812,
			"SteuerEinkommen_P25": 54.7,
			"SteuerEinkommen_Median": 82.4,
			"SteuerEinkommen_P75": 130.7,
			"eink_arm_Sum": 390,
			"ant_eink_arm": 13.9,
			"SozialQuote": 2.6,
			"SozialBeziehende": 537,
			"Mietpreis": "NA"
		},
		{
			"": 16435,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3940,
			"SteuerEinkommen_P25": 20.9,
			"SteuerEinkommen_Median": 49.4,
			"SteuerEinkommen_P75": 81.2,
			"eink_arm_Sum": 1006,
			"ant_eink_arm": 25.5,
			"SozialQuote": 1,
			"SozialBeziehende": 97,
			"Mietpreis": "NA"
		},
		{
			"": 16436,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1416,
			"SteuerEinkommen_P25": 81.4,
			"SteuerEinkommen_Median": 130,
			"SteuerEinkommen_P75": 203.55,
			"eink_arm_Sum": 112,
			"ant_eink_arm": 7.9,
			"SozialQuote": 1,
			"SozialBeziehende": 97,
			"Mietpreis": "NA"
		},
		{
			"": 16481,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2662,
			"SteuerEinkommen_P25": 17.1,
			"SteuerEinkommen_Median": 52.3,
			"SteuerEinkommen_P75": 91.6,
			"eink_arm_Sum": 756,
			"ant_eink_arm": 28.4,
			"SozialQuote": 0.7,
			"SozialBeziehende": 55,
			"Mietpreis": "NA"
		},
		{
			"": 16482,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1239,
			"SteuerEinkommen_P25": 98.9,
			"SteuerEinkommen_Median": 160,
			"SteuerEinkommen_P75": 261.5,
			"eink_arm_Sum": 86,
			"ant_eink_arm": 6.9,
			"SozialQuote": 0.7,
			"SozialBeziehende": 55,
			"Mietpreis": "NA"
		},
		{
			"": 16504,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4225,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 53.4,
			"SteuerEinkommen_P75": 86.1,
			"eink_arm_Sum": 1041,
			"ant_eink_arm": 24.6,
			"SozialQuote": 1,
			"SozialBeziehende": 107,
			"Mietpreis": "NA"
		},
		{
			"": 16505,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1461,
			"SteuerEinkommen_P25": 80,
			"SteuerEinkommen_Median": 130.7,
			"SteuerEinkommen_P75": 220.9,
			"eink_arm_Sum": 111,
			"ant_eink_arm": 7.6,
			"SozialQuote": 1,
			"SozialBeziehende": 107,
			"Mietpreis": "NA"
		},
		{
			"": 16527,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3002,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 49.25,
			"SteuerEinkommen_P75": 78.2,
			"eink_arm_Sum": 769,
			"ant_eink_arm": 25.6,
			"SozialQuote": 1.4,
			"SozialBeziehende": 100,
			"Mietpreis": "NA"
		},
		{
			"": 16528,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1011,
			"SteuerEinkommen_P25": 70.5,
			"SteuerEinkommen_Median": 113.2,
			"SteuerEinkommen_P75": 190.7,
			"eink_arm_Sum": 93,
			"ant_eink_arm": 9.2,
			"SozialQuote": 1.4,
			"SozialBeziehende": 100,
			"Mietpreis": "NA"
		},
		{
			"": 16550,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3822,
			"SteuerEinkommen_P25": 21.1,
			"SteuerEinkommen_Median": 45.1,
			"SteuerEinkommen_P75": 70.6,
			"eink_arm_Sum": 959,
			"ant_eink_arm": 25.1,
			"SozialQuote": 1.6,
			"SozialBeziehende": 163,
			"Mietpreis": "NA"
		},
		{
			"": 16551,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1846,
			"SteuerEinkommen_P25": 69.5,
			"SteuerEinkommen_Median": 103.1,
			"SteuerEinkommen_P75": 155.95,
			"eink_arm_Sum": 144,
			"ant_eink_arm": 7.8,
			"SozialQuote": 1.6,
			"SozialBeziehende": 163,
			"Mietpreis": "NA"
		},
		{
			"": 16594,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2277,
			"SteuerEinkommen_P25": 27.6,
			"SteuerEinkommen_Median": 56.35,
			"SteuerEinkommen_P75": 90.45,
			"eink_arm_Sum": 448,
			"ant_eink_arm": 19.7,
			"SozialQuote": 1.2,
			"SozialBeziehende": 58,
			"Mietpreis": "NA"
		},
		{
			"": 16595,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 487,
			"SteuerEinkommen_P25": 70.2,
			"SteuerEinkommen_Median": 117.55,
			"SteuerEinkommen_P75": 200.4,
			"eink_arm_Sum": 44,
			"ant_eink_arm": 9,
			"SozialQuote": 1.2,
			"SozialBeziehende": 58,
			"Mietpreis": "NA"
		},
		{
			"": 16615,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2622,
			"SteuerEinkommen_P25": 22.9,
			"SteuerEinkommen_Median": 51.9,
			"SteuerEinkommen_P75": 82.9,
			"eink_arm_Sum": 623,
			"ant_eink_arm": 23.8,
			"SozialQuote": 2,
			"SozialBeziehende": 117,
			"Mietpreis": "NA"
		},
		{
			"": 16616,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 682,
			"SteuerEinkommen_P25": 70.1,
			"SteuerEinkommen_Median": 111.4,
			"SteuerEinkommen_P75": 178.6,
			"eink_arm_Sum": 57,
			"ant_eink_arm": 8.4,
			"SozialQuote": 2,
			"SozialBeziehende": 117,
			"Mietpreis": "NA"
		},
		{
			"": 16637,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 1933,
			"SteuerEinkommen_P25": 16.7,
			"SteuerEinkommen_Median": 44.6,
			"SteuerEinkommen_P75": 71.7,
			"eink_arm_Sum": 568,
			"ant_eink_arm": 29.4,
			"SozialQuote": 1.4,
			"SozialBeziehende": 67,
			"Mietpreis": "NA"
		},
		{
			"": 16638,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 669,
			"SteuerEinkommen_P25": 66,
			"SteuerEinkommen_Median": 103.2,
			"SteuerEinkommen_P75": 173.9,
			"eink_arm_Sum": 66,
			"ant_eink_arm": 9.9,
			"SozialQuote": 1.4,
			"SozialBeziehende": 67,
			"Mietpreis": "NA"
		},
		{
			"": 16682,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7889,
			"SteuerEinkommen_P25": 21.6,
			"SteuerEinkommen_Median": 41.6,
			"SteuerEinkommen_P75": 62.3,
			"eink_arm_Sum": 1932,
			"ant_eink_arm": 24.5,
			"SozialQuote": 3.6,
			"SozialBeziehende": 672,
			"Mietpreis": "NA"
		},
		{
			"": 16683,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3155,
			"SteuerEinkommen_P25": 50.7,
			"SteuerEinkommen_Median": 75.5,
			"SteuerEinkommen_P75": 106.7,
			"eink_arm_Sum": 487,
			"ant_eink_arm": 15.4,
			"SozialQuote": 3.6,
			"SozialBeziehende": 672,
			"Mietpreis": "NA"
		},
		{
			"": 16705,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11861,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 40.8,
			"SteuerEinkommen_P75": 59.9,
			"eink_arm_Sum": 3155,
			"ant_eink_arm": 26.6,
			"SozialQuote": 5.3,
			"SozialBeziehende": 1598,
			"Mietpreis": "NA"
		},
		{
			"": 16706,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4949,
			"SteuerEinkommen_P25": 42.7,
			"SteuerEinkommen_Median": 64.6,
			"SteuerEinkommen_P75": 91.4,
			"eink_arm_Sum": 1003,
			"ant_eink_arm": 20.3,
			"SozialQuote": 5.3,
			"SozialBeziehende": 1598,
			"Mietpreis": "NA"
		},
		{
			"": 16751,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8382,
			"SteuerEinkommen_P25": 24,
			"SteuerEinkommen_Median": 48.6,
			"SteuerEinkommen_P75": 71.9,
			"eink_arm_Sum": 1863,
			"ant_eink_arm": 22.2,
			"SozialQuote": 2.2,
			"SozialBeziehende": 461,
			"Mietpreis": "NA"
		},
		{
			"": 16752,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3613,
			"SteuerEinkommen_P25": 62.4,
			"SteuerEinkommen_Median": 93.4,
			"SteuerEinkommen_P75": 139.9,
			"eink_arm_Sum": 366,
			"ant_eink_arm": 10.1,
			"SozialQuote": 2.2,
			"SozialBeziehende": 461,
			"Mietpreis": "NA"
		},
		{
			"": 16775,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7572,
			"SteuerEinkommen_P25": 20.8,
			"SteuerEinkommen_Median": 44.1,
			"SteuerEinkommen_P75": 66.9,
			"eink_arm_Sum": 1919,
			"ant_eink_arm": 25.3,
			"SozialQuote": 4.3,
			"SozialBeziehende": 640,
			"Mietpreis": "NA"
		},
		{
			"": 16776,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1756,
			"SteuerEinkommen_P25": 48.55,
			"SteuerEinkommen_Median": 75.2,
			"SteuerEinkommen_P75": 116.35,
			"eink_arm_Sum": 281,
			"ant_eink_arm": 16,
			"SozialQuote": 4.3,
			"SozialBeziehende": 640,
			"Mietpreis": "NA"
		},
		{
			"": 16821,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7883,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 37.9,
			"SteuerEinkommen_P75": 57.8,
			"eink_arm_Sum": 2309,
			"ant_eink_arm": 29.3,
			"SozialQuote": 5.1,
			"SozialBeziehende": 1256,
			"Mietpreis": "NA"
		},
		{
			"": 16822,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4372,
			"SteuerEinkommen_P25": 47.2,
			"SteuerEinkommen_Median": 70,
			"SteuerEinkommen_P75": 97.9,
			"eink_arm_Sum": 759,
			"ant_eink_arm": 17.4,
			"SozialQuote": 5.1,
			"SozialBeziehende": 1256,
			"Mietpreis": "NA"
		},
		{
			"": 16843,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8157,
			"SteuerEinkommen_P25": 19.6,
			"SteuerEinkommen_Median": 43.3,
			"SteuerEinkommen_P75": 66.75,
			"eink_arm_Sum": 2227,
			"ant_eink_arm": 27.3,
			"SozialQuote": 5.5,
			"SozialBeziehende": 1094,
			"Mietpreis": "NA"
		},
		{
			"": 16844,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2717,
			"SteuerEinkommen_P25": 50.6,
			"SteuerEinkommen_Median": 81.6,
			"SteuerEinkommen_P75": 126.4,
			"eink_arm_Sum": 442,
			"ant_eink_arm": 16.3,
			"SozialQuote": 5.5,
			"SozialBeziehende": 1094,
			"Mietpreis": "NA"
		},
		{
			"": 16865,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8067,
			"SteuerEinkommen_P25": 17.8,
			"SteuerEinkommen_Median": 38.7,
			"SteuerEinkommen_P75": 58.7,
			"eink_arm_Sum": 2436,
			"ant_eink_arm": 30.2,
			"SozialQuote": 6,
			"SozialBeziehende": 1365,
			"Mietpreis": "NA"
		},
		{
			"": 16866,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3663,
			"SteuerEinkommen_P25": 41.2,
			"SteuerEinkommen_Median": 64.8,
			"SteuerEinkommen_P75": 94.9,
			"eink_arm_Sum": 795,
			"ant_eink_arm": 21.7,
			"SozialQuote": 6,
			"SozialBeziehende": 1365,
			"Mietpreis": "NA"
		},
		{
			"": 16911,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 2135,
			"SteuerEinkommen_P25": 14.8,
			"SteuerEinkommen_Median": 32.3,
			"SteuerEinkommen_P75": 50.1,
			"eink_arm_Sum": 759,
			"ant_eink_arm": 35.6,
			"SozialQuote": 8.7,
			"SozialBeziehende": 628,
			"Mietpreis": "NA"
		},
		{
			"": 16912,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1301,
			"SteuerEinkommen_P25": 37.4,
			"SteuerEinkommen_Median": 60.1,
			"SteuerEinkommen_P75": 83.4,
			"eink_arm_Sum": 336,
			"ant_eink_arm": 25.8,
			"SozialQuote": 8.7,
			"SozialBeziehende": 628,
			"Mietpreis": "NA"
		},
		{
			"": 16933,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3983,
			"SteuerEinkommen_P25": 17.5,
			"SteuerEinkommen_Median": 33.6,
			"SteuerEinkommen_P75": 51.4,
			"eink_arm_Sum": 1266,
			"ant_eink_arm": 31.8,
			"SozialQuote": 8.5,
			"SozialBeziehende": 895,
			"Mietpreis": "NA"
		},
		{
			"": 16934,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1655,
			"SteuerEinkommen_P25": 35.4,
			"SteuerEinkommen_Median": 57,
			"SteuerEinkommen_P75": 80.3,
			"eink_arm_Sum": 456,
			"ant_eink_arm": 27.6,
			"SozialQuote": 8.5,
			"SozialBeziehende": 895,
			"Mietpreis": "NA"
		},
		{
			"": 16955,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3712,
			"SteuerEinkommen_P25": 11.7,
			"SteuerEinkommen_Median": 29.8,
			"SteuerEinkommen_P75": 48.2,
			"eink_arm_Sum": 1414,
			"ant_eink_arm": 38.1,
			"SozialQuote": 7.7,
			"SozialBeziehende": 856,
			"Mietpreis": "NA"
		},
		{
			"": 16956,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1900,
			"SteuerEinkommen_P25": 37.2,
			"SteuerEinkommen_Median": 56.4,
			"SteuerEinkommen_P75": 78.25,
			"eink_arm_Sum": 489,
			"ant_eink_arm": 25.7,
			"SozialQuote": 7.7,
			"SozialBeziehende": 856,
			"Mietpreis": "NA"
		},
		{
			"": 1089,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1090,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1091,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1092,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1093,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1094,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1095,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1096,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1097,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1098,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1099,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1100,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1101,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1102,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1103,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1104,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1105,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1106,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1107,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1108,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1109,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1110,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1111,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1112,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1113,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1114,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1115,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1116,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 11171,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 11181,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1119,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1120,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1121,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1122,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1123,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1124,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1125,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1126,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1127,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1128,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1129,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1130,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1131,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1132,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1133,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1134,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1135,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1136,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1137,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1138,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1139,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 11401,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 11411,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1142,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1143,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1144,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1145,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1146,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1147,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1148,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1149,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1150,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1151,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1152,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1153,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1154,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1155,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1156,
			"SteuerJahr": 2015,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": "NA"
		},
		{
			"": 1157,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2980
		},
		{
			"": 1158,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2980
		},
		{
			"": 1159,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2980
		},
		{
			"": 1160,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2980
		},
		{
			"": 11611,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2980
		},
		{
			"": 11623,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2980
		},
		{
			"": 1163,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2980
		},
		{
			"": 1164,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2980
		},
		{
			"": 1165,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2390
		},
		{
			"": 1166,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2390
		},
		{
			"": 1167,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2390
		},
		{
			"": 1168,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2390
		},
		{
			"": 1169,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2390
		},
		{
			"": 1170,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2390
		},
		{
			"": 1171,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2620
		},
		{
			"": 1172,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2620
		},
		{
			"": 1173,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2620
		},
		{
			"": 1174,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2620
		},
		{
			"": 1175,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2620
		},
		{
			"": 1176,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2620
		},
		{
			"": 1177,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2750
		},
		{
			"": 1178,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2750
		},
		{
			"": 1179,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2750
		},
		{
			"": 1180,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2750
		},
		{
			"": 1181,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2750
		},
		{
			"": 1182,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2750
		},
		{
			"": 11831,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2740
		},
		{
			"": 11843,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2740
		},
		{
			"": 1185,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2740
		},
		{
			"": 1186,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher Wyss",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2740
		},
		{
			"": 1187,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2790
		},
		{
			"": 1188,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2790
		},
		{
			"": 1189,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2790
		},
		{
			"": 1190,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2790
		},
		{
			"": 1191,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2510
		},
		{
			"": 1192,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2510
		},
		{
			"": 1193,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2510
		},
		{
			"": 1194,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2510
		},
		{
			"": 1195,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2510
		},
		{
			"": 1196,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2510
		},
		{
			"": 1197,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2510
		},
		{
			"": 1198,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2510
		},
		{
			"": 1199,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2860
		},
		{
			"": 1200,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2860
		},
		{
			"": 1201,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2860
		},
		{
			"": 1202,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2860
		},
		{
			"": 1203,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2860
		},
		{
			"": 1204,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2860
		},
		{
			"": 1205,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2200
		},
		{
			"": 1206,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2200
		},
		{
			"": 1207,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2200
		},
		{
			"": 1208,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2200
		},
		{
			"": 1209,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2180
		},
		{
			"": 1210,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2180
		},
		{
			"": 1211,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2180
		},
		{
			"": 1212,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2180
		},
		{
			"": 1213,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2130
		},
		{
			"": 1214,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2130
		},
		{
			"": 1215,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2130
		},
		{
			"": 1216,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2130
		},
		{
			"": 1217,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2130
		},
		{
			"": 1218,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2130
		},
		{
			"": 1219,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2050
		},
		{
			"": 1220,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2050
		},
		{
			"": 1221,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2050
		},
		{
			"": 1222,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2050
		},
		{
			"": 1223,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2050
		},
		{
			"": 1224,
			"SteuerJahr": 2016,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SteuerTariflang": "NA",
			"AnzBestZiv_sum": "NA",
			"SteuerEinkommen_P25": "NA",
			"SteuerEinkommen_Median": "NA",
			"SteuerEinkommen_P75": "NA",
			"eink_arm_Sum": "NA",
			"ant_eink_arm": "NA",
			"SozialQuote": "NA",
			"SozialBeziehende": "NA",
			"Mietpreis": 2050
		}
	];

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(268),
	    isObjectLike = __webpack_require__(270);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || objectToString.call(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 56 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 57 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = compareObjects;
	function compareObjects(objA, objB) {
	  var keys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	
	  if (objA === objB) {
	    return false;
	  }
	
	  var aKeys = Object.keys(objA);
	  var bKeys = Object.keys(objB);
	
	  if (aKeys.length !== bKeys.length) {
	    return true;
	  }
	
	  var keysMap = {};
	  var i = void 0,
	      len = void 0;
	
	  for (i = 0, len = keys.length; i < len; i++) {
	    keysMap[keys[i]] = true;
	  }
	
	  for (i = 0, len = aKeys.length; i < len; i++) {
	    var key = aKeys[i];
	    var aValue = objA[key];
	    var bValue = objB[key];
	
	    if (aValue === bValue) {
	      continue;
	    }
	
	    if (!keysMap[key] || aValue === null || bValue === null || (typeof aValue === 'undefined' ? 'undefined' : _typeof(aValue)) !== 'object' || (typeof bValue === 'undefined' ? 'undefined' : _typeof(bValue)) !== 'object') {
	      return true;
	    }
	
	    var aValueKeys = Object.keys(aValue);
	    var bValueKeys = Object.keys(bValue);
	
	    if (aValueKeys.length !== bValueKeys.length) {
	      return true;
	    }
	
	    for (var n = 0, length = aValueKeys.length; n < length; n++) {
	      var aValueKey = aValueKeys[n];
	
	      if (aValue[aValueKey] !== bValue[aValueKey]) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	}

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	!function(root, factory) {
	     true ? module.exports = factory(__webpack_require__(1), __webpack_require__(285)) : "function" == typeof define && define.amd ? define([ "react", "react-modal" ], factory) : "object" == typeof exports ? exports.ReactImageLightbox = factory(require("react"), require("react-modal")) : root.ReactImageLightbox = factory(root.react, root["react-modal"]);
	}(this, function(__WEBPACK_EXTERNAL_MODULE_8__, __WEBPACK_EXTERNAL_MODULE_9__) {
	    /******/
	    return function(modules) {
	        /******/
	        /******/
	        // The require function
	        /******/
	        function __webpack_require__(moduleId) {
	            /******/
	            /******/
	            // Check if module is in cache
	            /******/
	            if (installedModules[moduleId]) /******/
	            return installedModules[moduleId].exports;
	            /******/
	            /******/
	            // Create a new module (and put it into the cache)
	            /******/
	            var module = installedModules[moduleId] = {
	                /******/
	                exports: {},
	                /******/
	                id: moduleId,
	                /******/
	                loaded: !1
	            };
	            /******/
	            /******/
	            // Return the exports of the module
	            /******/
	            /******/
	            /******/
	            // Execute the module function
	            /******/
	            /******/
	            /******/
	            // Flag the module as loaded
	            /******/
	            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
	            module.loaded = !0, module.exports;
	        }
	        // webpackBootstrap
	        /******/
	        // The module cache
	        /******/
	        var installedModules = {};
	        /******/
	        /******/
	        // Load entry module and return exports
	        /******/
	        /******/
	        /******/
	        /******/
	        // expose the modules object (__webpack_modules__)
	        /******/
	        /******/
	        /******/
	        // expose the module cache
	        /******/
	        /******/
	        /******/
	        // __webpack_public_path__
	        /******/
	        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
	        __webpack_require__.p = "", __webpack_require__(0);
	    }([ /* 0 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        "use strict";
	        module.exports = __webpack_require__(2).default;
	    }, /* 1 */
	    /***/
	    function(module, exports) {
	        "use strict";
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        });
	        // Min image zoom level
	        exports.MIN_ZOOM_LEVEL = 0, exports.MAX_ZOOM_LEVEL = 300, exports.ZOOM_RATIO = 1.007, 
	        exports.ZOOM_BUTTON_INCREMENT_SIZE = 100, exports.WHEEL_MOVE_X_THRESHOLD = 200, 
	        exports.WHEEL_MOVE_Y_THRESHOLD = 1, exports.KEYS = {
	            ESC: 27,
	            LEFT_ARROW: 37,
	            RIGHT_ARROW: 39
	        }, exports.ACTION_NONE = 0, exports.ACTION_MOVE = 1, exports.ACTION_SWIPE = 2, exports.ACTION_PINCH = 3, 
	        exports.ACTION_ROTATE = 4, exports.SOURCE_ANY = 0, exports.SOURCE_MOUSE = 1, exports.SOURCE_TOUCH = 2, 
	        exports.SOURCE_POINTER = 3, exports.MIN_SWIPE_DISTANCE = 200;
	    }, /* 2 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        "use strict";
	        function _interopRequireDefault(obj) {
	            return obj && obj.__esModule ? obj : {
	                default: obj
	            };
	        }
	        function _defineProperty(obj, key, value) {
	            return key in obj ? Object.defineProperty(obj, key, {
	                value: value,
	                enumerable: !0,
	                configurable: !0,
	                writable: !0
	            }) : obj[key] = value, obj;
	        }
	        function _classCallCheck(instance, Constructor) {
	            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
	        }
	        function _possibleConstructorReturn(self, call) {
	            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	            return !call || "object" != typeof call && "function" != typeof call ? self : call;
	        }
	        function _inherits(subClass, superClass) {
	            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	            subClass.prototype = Object.create(superClass && superClass.prototype, {
	                constructor: {
	                    value: subClass,
	                    enumerable: !1,
	                    writable: !0,
	                    configurable: !0
	                }
	            }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
	        }
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        });
	        var _slicedToArray = function() {
	            function sliceIterator(arr, i) {
	                var _arr = [], _n = !0, _d = !1, _e = void 0;
	                try {
	                    for (var _s, _i = arr[Symbol.iterator](); !(_n = (_s = _i.next()).done) && (_arr.push(_s.value), 
	                    !i || _arr.length !== i); _n = !0) ;
	                } catch (err) {
	                    _d = !0, _e = err;
	                } finally {
	                    try {
	                        !_n && _i.return && _i.return();
	                    } finally {
	                        if (_d) throw _e;
	                    }
	                }
	                return _arr;
	            }
	            return function(arr, i) {
	                if (Array.isArray(arr)) return arr;
	                if (Symbol.iterator in Object(arr)) return sliceIterator(arr, i);
	                throw new TypeError("Invalid attempt to destructure non-iterable instance");
	            };
	        }(), _createClass = function() {
	            function defineProperties(target, props) {
	                for (var i = 0; i < props.length; i++) {
	                    var descriptor = props[i];
	                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
	                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
	                }
	            }
	            return function(Constructor, protoProps, staticProps) {
	                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
	                Constructor;
	            };
	        }(), _extends = Object.assign || function(target) {
	            for (var i = 1; i < arguments.length; i++) {
	                var source = arguments[i];
	                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
	            }
	            return target;
	        }, _react = __webpack_require__(8), _react2 = _interopRequireDefault(_react), _reactModal = __webpack_require__(9), _reactModal2 = _interopRequireDefault(_reactModal), _util = __webpack_require__(3), _constant = __webpack_require__(1), _style = __webpack_require__(7), _style2 = _interopRequireDefault(_style), styles = _style2.default, _ieVersion = (0, 
	        _util.getIEVersion)();
	        _ieVersion < 10 && (styles = _extends({}, styles, {
	            toolbarSide: styles.toolbarSide + " " + styles.toolbarSideNoFlex,
	            toolbarLeftSide: styles.toolbarLeftSide + " " + styles.toolbarLeftSideNoFlex,
	            toolbarRightSide: styles.toolbarRightSide + " " + styles.toolbarRightSideNoFlex
	        }));
	        var ReactImageLightbox = function(_Component) {
	            function ReactImageLightbox(props) {
	                _classCallCheck(this, ReactImageLightbox);
	                var _this = _possibleConstructorReturn(this, (ReactImageLightbox.__proto__ || Object.getPrototypeOf(ReactImageLightbox)).call(this, props));
	                return _this.state = {
	                    //-----------------------------
	                    // Animation
	                    //-----------------------------
	                    // Lightbox is closing
	                    // When Lightbox is mounted, if animation is enabled it will open with the reverse of the closing animation
	                    isClosing: !props.animationDisabled,
	                    // Component parts should animate (e.g., when images are moving, or image is being zoomed)
	                    shouldAnimate: !1,
	                    //-----------------------------
	                    // Zoom settings
	                    //-----------------------------
	                    // Zoom level of image
	                    zoomLevel: _constant.MIN_ZOOM_LEVEL,
	                    //-----------------------------
	                    // Image position settings
	                    //-----------------------------
	                    // Horizontal offset from center
	                    offsetX: 0,
	                    // Vertical offset from center
	                    offsetY: 0
	                }, _this.closeIfClickInner = _this.closeIfClickInner.bind(_this), _this.handleImageDoubleClick = _this.handleImageDoubleClick.bind(_this), 
	                _this.handleImageMouseWheel = _this.handleImageMouseWheel.bind(_this), _this.handleKeyInput = _this.handleKeyInput.bind(_this), 
	                _this.handleMouseUp = _this.handleMouseUp.bind(_this), _this.handleMouseDown = _this.handleMouseDown.bind(_this), 
	                _this.handleMouseMove = _this.handleMouseMove.bind(_this), _this.handleOuterMousewheel = _this.handleOuterMousewheel.bind(_this), 
	                _this.handleTouchStart = _this.handleTouchStart.bind(_this), _this.handleTouchMove = _this.handleTouchMove.bind(_this), 
	                _this.handleTouchEnd = _this.handleTouchEnd.bind(_this), _this.handlePointerEvent = _this.handlePointerEvent.bind(_this), 
	                _this.handleCaptionMousewheel = _this.handleCaptionMousewheel.bind(_this), _this.handleWindowResize = _this.handleWindowResize.bind(_this), 
	                _this.handleZoomInButtonClick = _this.handleZoomInButtonClick.bind(_this), _this.handleZoomOutButtonClick = _this.handleZoomOutButtonClick.bind(_this), 
	                _this.requestClose = _this.requestClose.bind(_this), _this.requestMoveNext = _this.requestMoveNext.bind(_this), 
	                _this.requestMovePrev = _this.requestMovePrev.bind(_this), _this;
	            }
	            return _inherits(ReactImageLightbox, _Component), _createClass(ReactImageLightbox, [ {
	                key: "componentWillMount",
	                value: function() {
	                    // Timeouts - always clear it before umount
	                    this.timeouts = [], // Current action
	                    this.currentAction = _constant.ACTION_NONE, // Events source
	                    this.eventsSource = _constant.SOURCE_ANY, // Empty pointers list
	                    this.pointerList = [], // Prevent inner close
	                    this.preventInnerClose = !1, this.preventInnerCloseTimeout = null, // Whether event listeners for keyboard and mouse input have been attached or not
	                    this.listenersAttached = !1, // Used to disable animation when changing props.mainSrc|nextSrc|prevSrc
	                    this.keyPressed = !1, // Used to store load state / dimensions of images
	                    this.imageCache = {}, // Time the last keydown event was called (used in keyboard action rate limiting)
	                    this.lastKeyDownTime = 0, // Used for debouncing window resize event
	                    this.resizeTimeout = null, // Used to determine when actions are triggered by the scroll wheel
	                    this.wheelActionTimeout = null, this.resetScrollTimeout = null, this.scrollX = 0, 
	                    this.scrollY = 0, // Used in panning zoomed images
	                    this.moveStartX = 0, this.moveStartY = 0, this.moveStartOffsetX = 0, this.moveStartOffsetY = 0, 
	                    // Used to swipe
	                    this.swipeStartX = 0, this.swipeStartY = 0, this.swipeEndX = 0, this.swipeEndY = 0, 
	                    // Used to pinch
	                    this.pinchTouchList = null, this.pinchDistance = 0, // Used to differentiate between images with identical src
	                    this.keyCounter = 0, // Used to detect a move when all src's remain unchanged (four or more of the same image in a row)
	                    this.moveRequested = !1, this.props.animationDisabled || // Make opening animation play
	                    this.setState({
	                        isClosing: !1
	                    });
	                }
	            }, {
	                key: "componentDidMount",
	                value: function() {
	                    this.mounted = !0, this.attachListeners(), this.loadAllImages();
	                }
	            }, {
	                key: "shouldComponentUpdate",
	                value: function() {
	                    // Wait for move...
	                    return !this.moveRequested;
	                }
	            }, {
	                key: "componentWillReceiveProps",
	                value: function(nextProps) {
	                    var _this2 = this, sourcesChanged = !1, prevSrcDict = {}, nextSrcDict = {};
	                    this.getSrcTypes().forEach(function(srcType) {
	                        _this2.props[srcType.name] !== nextProps[srcType.name] && (sourcesChanged = !0, 
	                        prevSrcDict[_this2.props[srcType.name]] = !0, nextSrcDict[nextProps[srcType.name]] = !0);
	                    }), (sourcesChanged || this.moveRequested) && (// Reset the loaded state for images not rendered next
	                    Object.keys(prevSrcDict).forEach(function(prevSrc) {
	                        !(prevSrc in nextSrcDict) && prevSrc in _this2.imageCache && (_this2.imageCache[prevSrc].loaded = !1);
	                    }), this.moveRequested = !1, // Load any new images
	                    this.loadAllImages(nextProps));
	                }
	            }, {
	                key: "componentWillUnmount",
	                value: function() {
	                    this.mounted = !1, this.detachListeners(), this.timeouts.forEach(function(tid) {
	                        return clearTimeout(tid);
	                    });
	                }
	            }, {
	                key: "setTimeout",
	                value: function(_setTimeout) {
	                    function setTimeout(_x, _x2) {
	                        return _setTimeout.apply(this, arguments);
	                    }
	                    return setTimeout.toString = function() {
	                        return _setTimeout.toString();
	                    }, setTimeout;
	                }(function(func, time) {
	                    var _this3 = this, id = setTimeout(function() {
	                        _this3.timeouts = _this3.timeouts.filter(function(tid) {
	                            return tid !== id;
	                        }), func();
	                    }, time);
	                    return this.timeouts.push(id), id;
	                })
	            }, {
	                key: "clearTimeout",
	                value: function(_clearTimeout) {
	                    function clearTimeout(_x3) {
	                        return _clearTimeout.apply(this, arguments);
	                    }
	                    return clearTimeout.toString = function() {
	                        return _clearTimeout.toString();
	                    }, clearTimeout;
	                }(function(id) {
	                    this.timeouts = this.timeouts.filter(function(tid) {
	                        return tid !== id;
	                    }), clearTimeout(id);
	                })
	            }, {
	                key: "attachListeners",
	                value: function() {
	                    this.listenersAttached || "undefined" == typeof window || (window.addEventListener("resize", this.handleWindowResize), 
	                    window.addEventListener("mouseup", this.handleMouseUp), window.addEventListener("touchend", this.handleTouchEnd), 
	                    window.addEventListener("touchcancel", this.handleTouchEnd), window.addEventListener("pointerdown", this.handlePointerEvent), 
	                    window.addEventListener("pointermove", this.handlePointerEvent), window.addEventListener("pointerup", this.handlePointerEvent), 
	                    window.addEventListener("pointercancel", this.handlePointerEvent), // Have to add an extra mouseup handler to catch mouseup events outside of the window
	                    //  if the page containing the lightbox is displayed in an iframe
	                    (0, _util.isInSameOriginIframe)() && (window.top.addEventListener("mouseup", this.handleMouseUp), 
	                    window.top.addEventListener("touchend", this.handleTouchEnd), window.top.addEventListener("touchcancel", this.handleTouchEnd), 
	                    window.top.addEventListener("pointerdown", this.handlePointerEvent), window.top.addEventListener("pointermove", this.handlePointerEvent), 
	                    window.top.addEventListener("pointerup", this.handlePointerEvent), window.top.addEventListener("pointercancel", this.handlePointerEvent)), 
	                    this.listenersAttached = !0);
	                }
	            }, {
	                key: "changeZoom",
	                value: function(zoomLevel, clientX, clientY) {
	                    // Ignore if zoom disabled
	                    if (this.props.enableZoom) {
	                        // Constrain zoom level to the set bounds
	                        var nextZoomLevel = Math.max(_constant.MIN_ZOOM_LEVEL, Math.min(_constant.MAX_ZOOM_LEVEL, zoomLevel));
	                        // Ignore requests that don't change the zoom level
	                        if (nextZoomLevel !== this.state.zoomLevel) {
	                            if (nextZoomLevel === _constant.MIN_ZOOM_LEVEL) // Snap back to center if zoomed all the way out
	                            return this.setState({
	                                zoomLevel: nextZoomLevel,
	                                offsetX: 0,
	                                offsetY: 0
	                            });
	                            var imageBaseSize = this.getBestImageForType("mainSrc");
	                            if (null !== imageBaseSize) {
	                                var currentZoomMultiplier = this.getZoomMultiplier(), nextZoomMultiplier = this.getZoomMultiplier(nextZoomLevel), boxRect = this.getLightboxRect(), pointerX = "undefined" != typeof clientX ? clientX - boxRect.left : boxRect.width / 2, pointerY = "undefined" != typeof clientY ? clientY - boxRect.top : boxRect.height / 2, currentImageOffsetX = (boxRect.width - imageBaseSize.width * currentZoomMultiplier) / 2, currentImageOffsetY = (boxRect.height - imageBaseSize.height * currentZoomMultiplier) / 2, currentImageRealOffsetX = currentImageOffsetX - this.state.offsetX, currentImageRealOffsetY = currentImageOffsetY - this.state.offsetY, currentPointerXRelativeToImage = (pointerX - currentImageRealOffsetX) / currentZoomMultiplier, currentPointerYRelativeToImage = (pointerY - currentImageRealOffsetY) / currentZoomMultiplier, nextImageRealOffsetX = pointerX - currentPointerXRelativeToImage * nextZoomMultiplier, nextImageRealOffsetY = pointerY - currentPointerYRelativeToImage * nextZoomMultiplier, nextImageOffsetX = (boxRect.width - imageBaseSize.width * nextZoomMultiplier) / 2, nextImageOffsetY = (boxRect.height - imageBaseSize.height * nextZoomMultiplier) / 2, nextOffsetX = nextImageOffsetX - nextImageRealOffsetX, nextOffsetY = nextImageOffsetY - nextImageRealOffsetY;
	                                // When zooming out, limit the offset so things don't get left askew
	                                if (this.currentAction !== _constant.ACTION_PINCH) {
	                                    var maxOffsets = this.getMaxOffsets();
	                                    this.state.zoomLevel > nextZoomLevel && (nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, nextOffsetX)), 
	                                    nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, nextOffsetY)));
	                                }
	                                this.setState({
	                                    zoomLevel: nextZoomLevel,
	                                    offsetX: nextOffsetX,
	                                    offsetY: nextOffsetY
	                                });
	                            }
	                        }
	                    }
	                }
	            }, {
	                key: "closeIfClickInner",
	                value: function(event) {
	                    !this.preventInnerClose && event.target.className.search(/\bril-inner\b/) > -1 && this.requestClose(event);
	                }
	            }, {
	                key: "setPreventInnerClose",
	                value: function() {
	                    var _this4 = this;
	                    this.preventInnerCloseTimeout && this.clearTimeout(this.preventInnerCloseTimeout), 
	                    this.preventInnerClose = !0, this.preventInnerCloseTimeout = this.setTimeout(function() {
	                        _this4.preventInnerClose = !1, _this4.preventInnerCloseTimeout = null;
	                    }, 100);
	                }
	            }, {
	                key: "detachListeners",
	                value: function() {
	                    this.listenersAttached && (window.removeEventListener("resize", this.handleWindowResize), 
	                    window.removeEventListener("mouseup", this.handleMouseUp), window.removeEventListener("touchend", this.handleTouchEnd), 
	                    window.removeEventListener("touchcancel", this.handleTouchEnd), window.removeEventListener("pointerdown", this.handlePointerEvent), 
	                    window.removeEventListener("pointermove", this.handlePointerEvent), window.removeEventListener("pointerup", this.handlePointerEvent), 
	                    window.removeEventListener("pointercancel", this.handlePointerEvent), (0, _util.isInSameOriginIframe)() && (window.top.removeEventListener("mouseup", this.handleMouseUp), 
	                    window.top.removeEventListener("touchend", this.handleTouchEnd), window.top.removeEventListener("touchcancel", this.handleTouchEnd), 
	                    window.top.removeEventListener("pointerdown", this.handlePointerEvent), window.top.removeEventListener("pointermove", this.handlePointerEvent), 
	                    window.top.removeEventListener("pointerup", this.handlePointerEvent), window.top.removeEventListener("pointercancel", this.handlePointerEvent)), 
	                    this.listenersAttached = !1);
	                }
	            }, {
	                key: "getBestImageForType",
	                value: function(srcType) {
	                    var imageSrc = this.props[srcType], fitSizes = {};
	                    if (this.isImageLoaded(imageSrc)) // Use full-size image if available
	                    fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height); else {
	                        if (!this.isImageLoaded(this.props[srcType + "Thumbnail"])) return null;
	                        // Fall back to using thumbnail if the image has not been loaded
	                        imageSrc = this.props[srcType + "Thumbnail"], fitSizes = this.getFitSizes(this.imageCache[imageSrc].width, this.imageCache[imageSrc].height, !0);
	                    }
	                    return {
	                        src: imageSrc,
	                        height: fitSizes.height,
	                        width: fitSizes.width
	                    };
	                }
	            }, {
	                key: "getFitSizes",
	                value: function(width, height, stretch) {
	                    var boxSize = this.getLightboxRect(), maxHeight = boxSize.height - 2 * this.props.imagePadding, maxWidth = boxSize.width - 2 * this.props.imagePadding;
	                    stretch || (maxHeight = Math.min(maxHeight, height), maxWidth = Math.min(maxWidth, width));
	                    var maxRatio = maxWidth / maxHeight, srcRatio = width / height;
	                    return maxRatio > srcRatio ? {
	                        width: width * maxHeight / height,
	                        height: maxHeight
	                    } : {
	                        width: maxWidth,
	                        height: height * maxWidth / width
	                    };
	                }
	            }, {
	                key: "getMaxOffsets",
	                value: function() {
	                    var zoomLevel = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state.zoomLevel, currentImageInfo = this.getBestImageForType("mainSrc");
	                    if (null === currentImageInfo) return {
	                        maxX: 0,
	                        minX: 0,
	                        maxY: 0,
	                        minY: 0
	                    };
	                    var boxSize = this.getLightboxRect(), zoomMultiplier = this.getZoomMultiplier(zoomLevel), maxX = 0;
	                    // if there is still blank space in the X dimension, don't limit except to the opposite edge
	                    maxX = zoomMultiplier * currentImageInfo.width - boxSize.width < 0 ? (boxSize.width - zoomMultiplier * currentImageInfo.width) / 2 : (zoomMultiplier * currentImageInfo.width - boxSize.width) / 2;
	                    var maxY = 0;
	                    // if there is still blank space in the Y dimension, don't limit except to the opposite edge
	                    return maxY = zoomMultiplier * currentImageInfo.height - boxSize.height < 0 ? (boxSize.height - zoomMultiplier * currentImageInfo.height) / 2 : (zoomMultiplier * currentImageInfo.height - boxSize.height) / 2, 
	                    {
	                        maxX: maxX,
	                        maxY: maxY,
	                        minX: -1 * maxX,
	                        minY: -1 * maxY
	                    };
	                }
	            }, {
	                key: "getSrcTypes",
	                value: function() {
	                    return [ {
	                        name: "mainSrc",
	                        keyEnding: "i" + this.keyCounter
	                    }, {
	                        name: "mainSrcThumbnail",
	                        keyEnding: "t" + this.keyCounter
	                    }, {
	                        name: "nextSrc",
	                        keyEnding: "i" + (this.keyCounter + 1)
	                    }, {
	                        name: "nextSrcThumbnail",
	                        keyEnding: "t" + (this.keyCounter + 1)
	                    }, {
	                        name: "prevSrc",
	                        keyEnding: "i" + (this.keyCounter - 1)
	                    }, {
	                        name: "prevSrcThumbnail",
	                        keyEnding: "t" + (this.keyCounter - 1)
	                    } ];
	                }
	            }, {
	                key: "getZoomMultiplier",
	                value: function() {
	                    var zoomLevel = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.state.zoomLevel;
	                    return Math.pow(_constant.ZOOM_RATIO, zoomLevel);
	                }
	            }, {
	                key: "getLightboxRect",
	                value: function() {
	                    return this.outerEl ? this.outerEl.getBoundingClientRect() : {
	                        width: (0, _util.getWindowWidth)(),
	                        height: (0, _util.getWindowHeight)(),
	                        top: 0,
	                        right: 0,
	                        bottom: 0,
	                        left: 0
	                    };
	                }
	            }, {
	                key: "handleKeyInput",
	                value: function(event) {
	                    // Ignore key input during animations
	                    if (event.stopPropagation(), !this.isAnimating()) {
	                        // Allow slightly faster navigation through the images when user presses keys repeatedly
	                        if ("keyup" === event.type) return void (this.lastKeyDownTime -= this.props.keyRepeatKeyupBonus);
	                        var keyCode = event.which || event.keyCode, currentTime = new Date();
	                        if (!(currentTime.getTime() - this.lastKeyDownTime < this.props.keyRepeatLimit && keyCode !== _constant.KEYS.ESC)) switch (this.lastKeyDownTime = currentTime.getTime(), 
	                        keyCode) {
	                          // ESC key closes the lightbox
	                            case _constant.KEYS.ESC:
	                            event.preventDefault(), this.requestClose(event);
	                            break;
	
	                          // Left arrow key moves to previous image
	                            case _constant.KEYS.LEFT_ARROW:
	                            if (!this.props.prevSrc) return;
	                            event.preventDefault(), this.keyPressed = !0, this.requestMovePrev(event);
	                            break;
	
	                          // Right arrow key moves to next image
	                            case _constant.KEYS.RIGHT_ARROW:
	                            if (!this.props.nextSrc) return;
	                            event.preventDefault(), this.keyPressed = !0, this.requestMoveNext(event);
	                        }
	                    }
	                }
	            }, {
	                key: "handleOuterMousewheel",
	                value: function(event) {
	                    var _this5 = this;
	                    // Prevent scrolling of the background
	                    event.preventDefault(), event.stopPropagation();
	                    var xThreshold = _constant.WHEEL_MOVE_X_THRESHOLD, actionDelay = 0, imageMoveDelay = 500;
	                    // Prevent rapid-fire zoom behavior
	                    if (this.clearTimeout(this.resetScrollTimeout), this.resetScrollTimeout = this.setTimeout(function() {
	                        _this5.scrollX = 0, _this5.scrollY = 0;
	                    }, 300), null === this.wheelActionTimeout && !this.isAnimating()) {
	                        if (Math.abs(event.deltaY) < Math.abs(event.deltaX)) {
	                            // handle horizontal scrolls with image moves
	                            this.scrollY = 0, this.scrollX += event.deltaX;
	                            var bigLeapX = xThreshold / 2;
	                            // If the scroll amount has accumulated sufficiently, or a large leap was taken
	                            this.scrollX >= xThreshold || event.deltaX >= bigLeapX ? (// Scroll right moves to next
	                            this.requestMoveNext(event), actionDelay = imageMoveDelay, this.scrollX = 0) : (this.scrollX <= -1 * xThreshold || event.deltaX <= -1 * bigLeapX) && (// Scroll left moves to previous
	                            this.requestMovePrev(event), actionDelay = imageMoveDelay, this.scrollX = 0);
	                        }
	                        // Allow successive actions after the set delay
	                        0 !== actionDelay && (this.wheelActionTimeout = this.setTimeout(function() {
	                            _this5.wheelActionTimeout = null;
	                        }, actionDelay));
	                    }
	                }
	            }, {
	                key: "handleImageMouseWheel",
	                value: function(event) {
	                    event.preventDefault();
	                    var yThreshold = _constant.WHEEL_MOVE_Y_THRESHOLD;
	                    if (Math.abs(event.deltaY) >= Math.abs(event.deltaX)) {
	                        // If the vertical scroll amount was large enough, perform a zoom
	                        if (event.stopPropagation(), Math.abs(event.deltaY) < yThreshold) return;
	                        this.scrollX = 0, this.scrollY += event.deltaY, this.changeZoom(this.state.zoomLevel - event.deltaY, event.clientX, event.clientY);
	                    }
	                }
	            }, {
	                key: "handleImageDoubleClick",
	                value: function(event) {
	                    this.state.zoomLevel > _constant.MIN_ZOOM_LEVEL ? // A double click when zoomed in zooms all the way out
	                    this.changeZoom(_constant.MIN_ZOOM_LEVEL, event.clientX, event.clientY) : // A double click when zoomed all the way out zooms in
	                    this.changeZoom(this.state.zoomLevel + _constant.ZOOM_BUTTON_INCREMENT_SIZE, event.clientX, event.clientY);
	                }
	            }, {
	                key: "shouldHandleEvent",
	                value: function(source) {
	                    if (this.eventsSource === source) return !0;
	                    if (this.eventsSource === _constant.SOURCE_ANY) return this.eventsSource = source, 
	                    !0;
	                    switch (source) {
	                      case _constant.SOURCE_MOUSE:
	                        return !1;
	
	                      case _constant.SOURCE_TOUCH:
	                        return this.eventsSource = _constant.SOURCE_TOUCH, this.filterPointersBySource(), 
	                        !0;
	
	                      case _constant.SOURCE_POINTER:
	                        return this.eventsSource === _constant.SOURCE_MOUSE && (this.eventsSource = _constant.SOURCE_POINTER, 
	                        this.filterPointersBySource(), !0);
	
	                      default:
	                        return !1;
	                    }
	                }
	            }, {
	                key: "addPointer",
	                value: function(pointer) {
	                    this.pointerList.push(pointer);
	                }
	            }, {
	                key: "removePointer",
	                value: function(pointer) {
	                    this.pointerList = this.pointerList.filter(function(_ref) {
	                        var id = _ref.id;
	                        return id !== pointer.id;
	                    });
	                }
	            }, {
	                key: "filterPointersBySource",
	                value: function() {
	                    var _this6 = this;
	                    this.pointerList = this.pointerList.filter(function(_ref2) {
	                        var source = _ref2.source;
	                        return source === _this6.eventsSource;
	                    });
	                }
	            }, {
	                key: "handleMouseDown",
	                value: function(event) {
	                    this.shouldHandleEvent(_constant.SOURCE_MOUSE) && ReactImageLightbox.isTargetMatchImage(event.target) && (this.addPointer(ReactImageLightbox.parseMouseEvent(event)), 
	                    this.multiPointerStart(event));
	                }
	            }, {
	                key: "handleMouseMove",
	                value: function(event) {
	                    this.shouldHandleEvent(_constant.SOURCE_MOUSE) && this.multiPointerMove(event, [ ReactImageLightbox.parseMouseEvent(event) ]);
	                }
	            }, {
	                key: "handleMouseUp",
	                value: function(event) {
	                    this.shouldHandleEvent(_constant.SOURCE_MOUSE) && (this.removePointer(ReactImageLightbox.parseMouseEvent(event)), 
	                    this.multiPointerEnd(event));
	                }
	            }, {
	                key: "handlePointerEvent",
	                value: function(event) {
	                    if (this.shouldHandleEvent(_constant.SOURCE_POINTER)) switch (event.type) {
	                      case "pointerdown":
	                        ReactImageLightbox.isTargetMatchImage(event.target) && (this.addPointer(ReactImageLightbox.parsePointerEvent(event)), 
	                        this.multiPointerStart(event));
	                        break;
	
	                      case "pointermove":
	                        this.multiPointerMove(event, [ ReactImageLightbox.parsePointerEvent(event) ]);
	                        break;
	
	                      case "pointerup":
	                      case "pointercancel":
	                        this.removePointer(ReactImageLightbox.parsePointerEvent(event)), this.multiPointerEnd(event);
	                    }
	                }
	            }, {
	                key: "handleTouchStart",
	                value: function(event) {
	                    var _this7 = this;
	                    this.shouldHandleEvent(_constant.SOURCE_TOUCH) && ReactImageLightbox.isTargetMatchImage(event.target) && ([].forEach.call(event.changedTouches, function(eventTouch) {
	                        return _this7.addPointer(ReactImageLightbox.parseTouchPointer(eventTouch));
	                    }), this.multiPointerStart(event));
	                }
	            }, {
	                key: "handleTouchMove",
	                value: function(event) {
	                    this.shouldHandleEvent(_constant.SOURCE_TOUCH) && this.multiPointerMove(event, [].map.call(event.changedTouches, function(eventTouch) {
	                        return ReactImageLightbox.parseTouchPointer(eventTouch);
	                    }));
	                }
	            }, {
	                key: "handleTouchEnd",
	                value: function(event) {
	                    var _this8 = this;
	                    this.shouldHandleEvent(_constant.SOURCE_TOUCH) && ([].map.call(event.changedTouches, function(touch) {
	                        return _this8.removePointer(ReactImageLightbox.parseTouchPointer(touch));
	                    }), this.multiPointerEnd(event));
	                }
	            }, {
	                key: "decideMoveOrSwipe",
	                value: function(pointer) {
	                    this.state.zoomLevel <= _constant.MIN_ZOOM_LEVEL ? this.handleSwipeStart(pointer) : this.handleMoveStart(pointer);
	                }
	            }, {
	                key: "multiPointerStart",
	                value: function(event) {
	                    switch (this.handleEnd(null), this.pointerList.length) {
	                      case 1:
	                        event.preventDefault(), this.decideMoveOrSwipe(this.pointerList[0]);
	                        break;
	
	                      case 2:
	                        event.preventDefault(), this.handlePinchStart(this.pointerList);
	                    }
	                }
	            }, {
	                key: "multiPointerMove",
	                value: function(event, pointerList) {
	                    switch (this.currentAction) {
	                      case _constant.ACTION_MOVE:
	                        event.preventDefault(), this.handleMove(pointerList[0]);
	                        break;
	
	                      case _constant.ACTION_SWIPE:
	                        event.preventDefault(), this.handleSwipe(pointerList[0]);
	                        break;
	
	                      case _constant.ACTION_PINCH:
	                        event.preventDefault(), this.handlePinch(pointerList);
	                    }
	                }
	            }, {
	                key: "multiPointerEnd",
	                value: function(event) {
	                    switch (this.currentAction !== _constant.ACTION_NONE && (this.setPreventInnerClose(), 
	                    this.handleEnd(event)), this.pointerList.length) {
	                      case 0:
	                        this.eventsSource = _constant.SOURCE_ANY;
	                        break;
	
	                      case 1:
	                        event.preventDefault(), this.decideMoveOrSwipe(this.pointerList[0]);
	                        break;
	
	                      case 2:
	                        event.preventDefault(), this.handlePinchStart(this.pointerList);
	                    }
	                }
	            }, {
	                key: "handleEnd",
	                value: function(event) {
	                    switch (this.currentAction) {
	                      case _constant.ACTION_MOVE:
	                        this.handleMoveEnd(event);
	                        break;
	
	                      case _constant.ACTION_SWIPE:
	                        this.handleSwipeEnd(event);
	                        break;
	
	                      case _constant.ACTION_PINCH:
	                        this.handlePinchEnd(event);
	                    }
	                }
	            }, {
	                key: "handleMoveStart",
	                value: function(_ref3) {
	                    var clientX = _ref3.x, clientY = _ref3.y;
	                    this.props.enableZoom && (this.currentAction = _constant.ACTION_MOVE, this.moveStartX = clientX, 
	                    this.moveStartY = clientY, this.moveStartOffsetX = this.state.offsetX, this.moveStartOffsetY = this.state.offsetY);
	                }
	            }, {
	                key: "handleMove",
	                value: function(_ref4) {
	                    var clientX = _ref4.x, clientY = _ref4.y, newOffsetX = this.moveStartX - clientX + this.moveStartOffsetX, newOffsetY = this.moveStartY - clientY + this.moveStartOffsetY;
	                    this.state.offsetX === newOffsetX && this.state.offsetY === newOffsetY || this.setState({
	                        offsetX: newOffsetX,
	                        offsetY: newOffsetY
	                    });
	                }
	            }, {
	                key: "handleMoveEnd",
	                value: function() {
	                    var _this9 = this;
	                    this.currentAction = _constant.ACTION_NONE, this.moveStartX = 0, this.moveStartY = 0, 
	                    this.moveStartOffsetX = 0, this.moveStartOffsetY = 0;
	                    // Snap image back into frame if outside max offset range
	                    var maxOffsets = this.getMaxOffsets(), nextOffsetX = Math.max(maxOffsets.minX, Math.min(maxOffsets.maxX, this.state.offsetX)), nextOffsetY = Math.max(maxOffsets.minY, Math.min(maxOffsets.maxY, this.state.offsetY));
	                    nextOffsetX === this.state.offsetX && nextOffsetY === this.state.offsetY || (this.setState({
	                        offsetX: nextOffsetX,
	                        offsetY: nextOffsetY,
	                        shouldAnimate: !0
	                    }), this.setTimeout(function() {
	                        _this9.setState({
	                            shouldAnimate: !1
	                        });
	                    }, this.props.animationDuration));
	                }
	            }, {
	                key: "handleSwipeStart",
	                value: function(_ref5) {
	                    var clientX = _ref5.x, clientY = _ref5.y;
	                    this.currentAction = _constant.ACTION_SWIPE, this.swipeStartX = clientX, this.swipeStartY = clientY, 
	                    this.swipeEndX = clientX, this.swipeEndY = clientY;
	                }
	            }, {
	                key: "handleSwipe",
	                value: function(_ref6) {
	                    var clientX = _ref6.x, clientY = _ref6.y;
	                    this.swipeEndX = clientX, this.swipeEndY = clientY;
	                }
	            }, {
	                key: "handleSwipeEnd",
	                value: function(event) {
	                    var xDiff = this.swipeEndX - this.swipeStartX, xDiffAbs = Math.abs(xDiff), yDiffAbs = Math.abs(this.swipeEndY - this.swipeStartY);
	                    if (this.currentAction = _constant.ACTION_NONE, this.swipeStartX = 0, this.swipeStartY = 0, 
	                    this.swipeEndX = 0, this.swipeEndY = 0, !(!event || this.isAnimating() || xDiffAbs < 1.5 * yDiffAbs)) {
	                        if (xDiffAbs < _constant.MIN_SWIPE_DISTANCE) {
	                            var boxRect = this.getLightboxRect();
	                            if (xDiffAbs < boxRect.width / 4) return;
	                        }
	                        xDiff > 0 && this.props.prevSrc ? (event.preventDefault(), this.requestMovePrev()) : xDiff < 0 && this.props.nextSrc && (event.preventDefault(), 
	                        this.requestMoveNext());
	                    }
	                }
	            }, {
	                key: "calculatePinchDistance",
	                value: function() {
	                    var _ref7 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.pinchTouchList, _ref8 = _slicedToArray(_ref7, 2), a = _ref8[0], b = _ref8[1];
	                    return Math.sqrt(Math.pow(a.x - b.x, 2) + Math.pow(a.y - b.y, 2));
	                }
	            }, {
	                key: "calculatePinchCenter",
	                value: function() {
	                    var _ref9 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.pinchTouchList, _ref10 = _slicedToArray(_ref9, 2), a = _ref10[0], b = _ref10[1];
	                    return {
	                        x: a.x - (a.x - b.x) / 2,
	                        y: a.y - (a.y - b.y) / 2
	                    };
	                }
	            }, {
	                key: "handlePinchStart",
	                value: function(pointerList) {
	                    this.props.enableZoom && (this.currentAction = _constant.ACTION_PINCH, this.pinchTouchList = pointerList.map(function(_ref11) {
	                        var id = _ref11.id, x = _ref11.x, y = _ref11.y;
	                        return {
	                            id: id,
	                            x: x,
	                            y: y
	                        };
	                    }), this.pinchDistance = this.calculatePinchDistance());
	                }
	            }, {
	                key: "handlePinch",
	                value: function(pointerList) {
	                    this.pinchTouchList = this.pinchTouchList.map(function(oldPointer) {
	                        for (var i = 0; i < pointerList.length; i++) if (pointerList[i].id === oldPointer.id) return pointerList[i];
	                        return oldPointer;
	                    });
	                    var newDistance = this.calculatePinchDistance(), zoomLevel = this.state.zoomLevel + newDistance - this.pinchDistance;
	                    this.pinchDistance = newDistance;
	                    var _calculatePinchCenter = this.calculatePinchCenter(this.pinchTouchList), clientX = _calculatePinchCenter.x, clientY = _calculatePinchCenter.y;
	                    this.changeZoom(zoomLevel, clientX, clientY);
	                }
	            }, {
	                key: "handlePinchEnd",
	                value: function() {
	                    this.currentAction = _constant.ACTION_NONE, this.pinchTouchList = null, this.pinchDistance = 0;
	                }
	            }, {
	                key: "handleWindowResize",
	                value: function() {
	                    this.clearTimeout(this.resizeTimeout), this.resizeTimeout = this.setTimeout(this.forceUpdate.bind(this), 100);
	                }
	            }, {
	                key: "handleZoomInButtonClick",
	                value: function() {
	                    this.changeZoom(this.state.zoomLevel + _constant.ZOOM_BUTTON_INCREMENT_SIZE);
	                }
	            }, {
	                key: "handleZoomOutButtonClick",
	                value: function() {
	                    this.changeZoom(this.state.zoomLevel - _constant.ZOOM_BUTTON_INCREMENT_SIZE);
	                }
	            }, {
	                key: "handleCaptionMousewheel",
	                value: function(event) {
	                    if (event.stopPropagation(), this.caption) {
	                        var height = this.caption.getBoundingClientRect().height, scrollHeight = this.caption.scrollHeight, scrollTop = this.caption.scrollTop;
	                        (event.deltaY > 0 && height + scrollTop >= scrollHeight || event.deltaY < 0 && scrollTop <= 0) && event.preventDefault();
	                    }
	                }
	            }, {
	                key: "isAnimating",
	                value: function() {
	                    return this.state.shouldAnimate || this.state.isClosing;
	                }
	            }, {
	                key: "isImageLoaded",
	                value: function(imageSrc) {
	                    return imageSrc && imageSrc in this.imageCache && this.imageCache[imageSrc].loaded;
	                }
	            }, {
	                key: "loadImage",
	                value: function(srcType, imageSrc, done) {
	                    var _this10 = this;
	                    // Return the image info if it is already cached
	                    if (this.isImageLoaded(imageSrc)) return void this.setTimeout(function() {
	                        done();
	                    }, 1);
	                    var that = this, inMemoryImage = new Image();
	                    inMemoryImage.onerror = function(errorEvent) {
	                        _this10.props.onImageLoadError(imageSrc, srcType, errorEvent), done(errorEvent);
	                    }, inMemoryImage.onload = function() {
	                        that.imageCache[imageSrc] = {
	                            loaded: !0,
	                            width: this.width,
	                            height: this.height
	                        }, done();
	                    }, inMemoryImage.src = imageSrc;
	                }
	            }, {
	                key: "loadAllImages",
	                value: function() {
	                    var _this11 = this, props = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.props, generateLoadDoneCallback = function(srcType, imageSrc) {
	                        return function(err) {
	                            // Give up showing image on error
	                            err || // Don't rerender if the src is not the same as when the load started
	                            // or if the component has unmounted
	                            _this11.props[srcType] === imageSrc && _this11.mounted && // Force rerender with the new image
	                            _this11.forceUpdate();
	                        };
	                    };
	                    // Load the images
	                    this.getSrcTypes().forEach(function(srcType) {
	                        var type = srcType.name;
	                        // Load unloaded images
	                        props[type] && !_this11.isImageLoaded(props[type]) && _this11.loadImage(type, props[type], generateLoadDoneCallback(type, props[type]));
	                    });
	                }
	            }, {
	                key: "requestClose",
	                value: function(event) {
	                    var _this12 = this, closeLightbox = function() {
	                        return _this12.props.onCloseRequest(event);
	                    };
	                    // With animation
	                    // Start closing animation
	                    // Perform the actual closing at the end of the animation
	                    return this.props.animationDisabled || "keydown" === event.type && !this.props.animationOnKeyInput ? closeLightbox() : (this.setState({
	                        isClosing: !0
	                    }), void this.setTimeout(closeLightbox, this.props.animationDuration));
	                }
	            }, {
	                key: "requestMove",
	                value: function(direction, event) {
	                    var _this13 = this, nextState = {
	                        zoomLevel: _constant.MIN_ZOOM_LEVEL,
	                        offsetX: 0,
	                        offsetY: 0
	                    };
	                    // Enable animated states
	                    this.props.animationDisabled || this.keyPressed && !this.props.animationOnKeyInput || (nextState.shouldAnimate = !0, 
	                    this.setTimeout(function() {
	                        return _this13.setState({
	                            shouldAnimate: !1
	                        });
	                    }, this.props.animationDuration)), this.keyPressed = !1, this.moveRequested = !0, 
	                    "prev" === direction ? (this.keyCounter--, this.setState(nextState), this.props.onMovePrevRequest(event)) : (this.keyCounter++, 
	                    this.setState(nextState), this.props.onMoveNextRequest(event));
	                }
	            }, {
	                key: "requestMoveNext",
	                value: function(event) {
	                    this.requestMove("next", event);
	                }
	            }, {
	                key: "requestMovePrev",
	                value: function(event) {
	                    this.requestMove("prev", event);
	                }
	            }, {
	                key: "render",
	                value: function() {
	                    var _this14 = this, _props = this.props, animationDisabled = _props.animationDisabled, animationDuration = _props.animationDuration, clickOutsideToClose = _props.clickOutsideToClose, discourageDownloads = _props.discourageDownloads, enableZoom = _props.enableZoom, imageTitle = _props.imageTitle, nextSrc = _props.nextSrc, prevSrc = _props.prevSrc, toolbarButtons = _props.toolbarButtons, reactModalStyle = _props.reactModalStyle, _state = this.state, zoomLevel = _state.zoomLevel, offsetX = _state.offsetX, offsetY = _state.offsetY, isClosing = _state.isClosing, boxSize = this.getLightboxRect(), transitionStyle = {};
	                    // Transition settings for sliding animations
	                    !animationDisabled && this.isAnimating() && (transitionStyle = _extends({}, transitionStyle, {
	                        transition: "transform " + animationDuration + "ms"
	                    }));
	                    // Key endings to differentiate between images with the same src
	                    var keyEndings = {};
	                    this.getSrcTypes().forEach(function(_ref12) {
	                        var name = _ref12.name, keyEnding = _ref12.keyEnding;
	                        keyEndings[name] = keyEnding;
	                    });
	                    // Images to be displayed
	                    var images = [], addImage = function(srcType, imageClass) {
	                        var baseStyle = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
	                        // Ignore types that have no source defined for their full size image
	                        if (_this14.props[srcType]) {
	                            var imageStyle = _extends({}, baseStyle, transitionStyle);
	                            zoomLevel > _constant.MIN_ZOOM_LEVEL && (imageStyle.cursor = "move");
	                            var bestImageInfo = _this14.getBestImageForType(srcType);
	                            if (null === bestImageInfo) {
	                                var loadingIcon = void 0;
	                                // Fall back to loading icon if the thumbnail has not been loaded
	                                return loadingIcon = _ieVersion < 10 ? _react2.default.createElement("div", {
	                                    className: styles.loadingContainer__icon
	                                }, (0, _util.translate)("Loading...")) : _react2.default.createElement("div", {
	                                    className: "ril-loading-circle " + styles.loadingCircle + " " + styles.loadingContainer__icon
	                                }, _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                }), _react2.default.createElement("div", {
	                                    className: "ril-loading-circle-point " + styles.loadingCirclePoint
	                                })), void images.push(_react2.default.createElement("div", {
	                                    className: imageClass + " " + styles.image + " not-loaded ril-not-loaded",
	                                    style: imageStyle,
	                                    key: _this14.props[srcType] + keyEndings[srcType]
	                                }, _react2.default.createElement("div", {
	                                    className: styles.loadingContainer
	                                }, loadingIcon)));
	                            }
	                            imageStyle.width = bestImageInfo.width, imageStyle.height = bestImageInfo.height;
	                            var imageSrc = bestImageInfo.src;
	                            discourageDownloads ? (imageStyle.backgroundImage = "url('" + imageSrc + "')", images.push(_react2.default.createElement("div", {
	                                className: imageClass + " " + styles.image + " " + styles.imageDiscourager,
	                                onDoubleClick: _this14.handleImageDoubleClick,
	                                onWheel: _this14.handleImageMouseWheel,
	                                style: imageStyle,
	                                key: imageSrc + keyEndings[srcType]
	                            }, _react2.default.createElement("div", {
	                                className: "download-blocker ril-download-blocker " + styles.downloadBlocker
	                            })))) : images.push(_react2.default.createElement("img", {
	                                className: imageClass + " " + styles.image,
	                                onDoubleClick: _this14.handleImageDoubleClick,
	                                onWheel: _this14.handleImageMouseWheel,
	                                onDragStart: function(e) {
	                                    return e.preventDefault();
	                                },
	                                style: imageStyle,
	                                src: imageSrc,
	                                key: imageSrc + keyEndings[srcType],
	                                alt: "string" == typeof imageTitle ? imageTitle : (0, _util.translate)("Image"),
	                                draggable: !1
	                            }));
	                        }
	                    }, zoomMultiplier = this.getZoomMultiplier();
	                    // Next Image (displayed on the right)
	                    addImage("nextSrc", "image-next ril-image-next " + styles.imageNext, ReactImageLightbox.getTransform({
	                        x: boxSize.width
	                    })), // Main Image
	                    addImage("mainSrc", "image-current ril-image-current", ReactImageLightbox.getTransform({
	                        x: -1 * offsetX,
	                        y: -1 * offsetY,
	                        zoom: zoomMultiplier
	                    })), // Previous Image (displayed on the left)
	                    addImage("prevSrc", "image-prev ril-image-prev " + styles.imagePrev, ReactImageLightbox.getTransform({
	                        x: -1 * boxSize.width
	                    }));
	                    var noop = function() {}, zoomInButtonClasses = [ styles.toolbarItemChild, styles.builtinButton, styles.zoomInButton ], zoomOutButtonClasses = [ styles.toolbarItemChild, styles.builtinButton, styles.zoomOutButton ], zoomInButtonHandler = this.handleZoomInButtonClick, zoomOutButtonHandler = this.handleZoomOutButtonClick;
	                    // Disable zooming in when zoomed all the way in
	                    zoomLevel === _constant.MAX_ZOOM_LEVEL && (zoomInButtonClasses.push(styles.builtinButtonDisabled), 
	                    zoomInButtonHandler = noop), // Disable zooming out when zoomed all the way out
	                    zoomLevel === _constant.MIN_ZOOM_LEVEL && (zoomOutButtonClasses.push(styles.builtinButtonDisabled), 
	                    zoomOutButtonHandler = noop), // Ignore clicks during animation
	                    this.isAnimating() && (zoomInButtonHandler = noop, zoomOutButtonHandler = noop);
	                    var modalStyle = {
	                        overlay: _extends({
	                            zIndex: 1e3,
	                            backgroundColor: "transparent"
	                        }, reactModalStyle.overlay),
	                        content: _extends({
	                            backgroundColor: "transparent",
	                            overflow: "hidden",
	                            // Needed, otherwise keyboard shortcuts scroll the page
	                            border: "none",
	                            borderRadius: 0,
	                            padding: 0,
	                            top: 0,
	                            left: 0,
	                            right: 0,
	                            bottom: 0
	                        }, reactModalStyle.content)
	                    };
	                    // DEPRECATION NOTICE
	                    // All unprefixed classes (listed below) will be removed in v4.0.0.
	                    // Use their `ril-` prefixed alternatives instead.
	                    //
	                    // DEPRECATED: close, closing, download-blocker, image-current,
	                    //             image-next, image-prev, inner, next-button, not-loaded,
	                    //             outer, prev-button, toolbar, toolbar-left, toolbar-right,
	                    //             zoom-in, zoom-out
	                    return _react2.default.createElement(_reactModal2.default, {
	                        isOpen: !0,
	                        onRequestClose: clickOutsideToClose ? this.requestClose : noop,
	                        onAfterOpen: function() {
	                            return _this14.outerEl && _this14.outerEl.focus();
	                        },
	                        style: modalStyle,
	                        contentLabel: (0, _util.translate)("Lightbox")
	                    }, _react2.default.createElement("div", {
	                        // eslint-disable-line jsx-a11y/no-static-element-interactions
	                        // Floating modal with closing animations
	                        className: "outer ril-outer " + styles.outer + " " + styles.outerAnimating + (isClosing ? " closing ril-closing " + styles.outerClosing : ""),
	                        style: {
	                            transition: "opacity " + animationDuration + "ms",
	                            animationDuration: animationDuration + "ms",
	                            animationDirection: isClosing ? "normal" : "reverse"
	                        },
	                        ref: function(el) {
	                            _this14.outerEl = el;
	                        },
	                        onWheel: this.handleOuterMousewheel,
	                        onMouseMove: this.handleMouseMove,
	                        onMouseDown: this.handleMouseDown,
	                        onTouchStart: this.handleTouchStart,
	                        onTouchMove: this.handleTouchMove,
	                        tabIndex: "-1",
	                        onKeyDown: this.handleKeyInput,
	                        onKeyUp: this.handleKeyInput
	                    }, _react2.default.createElement("div", {
	                        // eslint-disable-line jsx-a11y/no-static-element-interactions
	                        // Image holder
	                        className: "inner ril-inner " + styles.inner,
	                        onClick: clickOutsideToClose ? this.closeIfClickInner : noop
	                    }, images), prevSrc && _react2.default.createElement("button", {
	                        // Move to previous image button
	                        type: "button",
	                        className: "prev-button ril-prev-button " + styles.navButtons + " " + styles.navButtonPrev,
	                        key: "prev",
	                        onClick: this.isAnimating() ? noop : this.requestMovePrev
	                    }), nextSrc && _react2.default.createElement("button", {
	                        // Move to next image button
	                        type: "button",
	                        className: "next-button ril-next-button " + styles.navButtons + " " + styles.navButtonNext,
	                        key: "next",
	                        onClick: this.isAnimating() ? noop : this.requestMoveNext
	                    }), _react2.default.createElement("div", {
	                        // Lightbox toolbar
	                        className: "toolbar ril-toolbar " + styles.toolbar
	                    }, _react2.default.createElement("ul", {
	                        className: "toolbar-left ril-toolbar-left " + styles.toolbarSide + " " + styles.toolbarLeftSide
	                    }, _react2.default.createElement("li", {
	                        className: "ril-toolbar__item " + styles.toolbarItem
	                    }, _react2.default.createElement("span", {
	                        className: "ril-toolbar__item__child " + styles.toolbarItemChild
	                    }, imageTitle))), _react2.default.createElement("ul", {
	                        className: [ "toolbar-right", "ril-toolbar-right", styles.toolbarSide, styles.toolbarRightSide ].join(" ")
	                    }, toolbarButtons ? toolbarButtons.map(function(button, i) {
	                        return _react2.default.createElement("li", {
	                            key: i,
	                            className: "ril-toolbar__item " + styles.toolbarItem
	                        }, button);
	                    }) : "", enableZoom && _react2.default.createElement("li", {
	                        className: "ril-toolbar__item " + styles.toolbarItem
	                    }, _react2.default.createElement("button", {
	                        // Lightbox zoom in button
	                        type: "button",
	                        key: "zoom-in",
	                        className: "zoom-in ril-zoom-in " + zoomInButtonClasses.join(" "),
	                        onClick: zoomInButtonHandler
	                    })), enableZoom && _react2.default.createElement("li", {
	                        className: "ril-toolbar__item " + styles.toolbarItem
	                    }, _react2.default.createElement("button", {
	                        // Lightbox zoom out button
	                        type: "button",
	                        key: "zoom-out",
	                        className: "zoom-out ril-zoom-out " + zoomOutButtonClasses.join(" "),
	                        onClick: zoomOutButtonHandler
	                    })), _react2.default.createElement("li", {
	                        className: "ril-toolbar__item " + styles.toolbarItem
	                    }, _react2.default.createElement("button", {
	                        // Lightbox close button
	                        type: "button",
	                        key: "close",
	                        className: "close ril-close ril-toolbar__item__child" + (" " + styles.toolbarItemChild + " " + styles.builtinButton + " " + styles.closeButton),
	                        onClick: this.isAnimating() ? noop : this.requestClose
	                    })))), this.props.imageCaption && _react2.default.createElement("div", {
	                        // Image caption
	                        onWheel: this.handleCaptionMousewheel,
	                        onMouseDown: function(event) {
	                            return event.stopPropagation();
	                        },
	                        className: "ril-caption " + styles.caption,
	                        ref: function(el) {
	                            _this14.caption = el;
	                        }
	                    }, _react2.default.createElement("div", {
	                        className: "ril-caption-content " + styles.captionContent
	                    }, this.props.imageCaption))));
	                }
	            } ], [ {
	                key: "isTargetMatchImage",
	                value: function(target) {
	                    return target && /ril-image-current/.test(target.className);
	                }
	            }, {
	                key: "parseMouseEvent",
	                value: function(mouseEvent) {
	                    return {
	                        id: "mouse",
	                        source: _constant.SOURCE_MOUSE,
	                        x: parseInt(mouseEvent.clientX, 10),
	                        y: parseInt(mouseEvent.clientY, 10)
	                    };
	                }
	            }, {
	                key: "parseTouchPointer",
	                value: function(touchPointer) {
	                    return {
	                        id: touchPointer.identifier,
	                        source: _constant.SOURCE_TOUCH,
	                        x: parseInt(touchPointer.clientX, 10),
	                        y: parseInt(touchPointer.clientY, 10)
	                    };
	                }
	            }, {
	                key: "parsePointerEvent",
	                value: function(pointerEvent) {
	                    return {
	                        id: pointerEvent.pointerId,
	                        source: _constant.SOURCE_POINTER,
	                        x: parseInt(pointerEvent.clientX, 10),
	                        y: parseInt(pointerEvent.clientY, 10)
	                    };
	                }
	            }, {
	                key: "getTransform",
	                value: function(_ref13) {
	                    var _ref13$x = _ref13.x, x = void 0 === _ref13$x ? null : _ref13$x, _ref13$y = _ref13.y, y = void 0 === _ref13$y ? null : _ref13$y, _ref13$zoom = _ref13.zoom, zoom = void 0 === _ref13$zoom ? null : _ref13$zoom, isOldIE = _ieVersion < 10, transforms = [];
	                    return null === x && null === y || transforms.push(isOldIE ? "translate(" + (x || 0) + "px," + (y || 0) + "px)" : "translate3d(" + (x || 0) + "px," + (y || 0) + "px,0)"), 
	                    null !== zoom && transforms.push(isOldIE ? "scale(" + zoom + ")" : "scale3d(" + zoom + "," + zoom + ",1)"), 
	                    _defineProperty({}, isOldIE ? "msTransform" : "transform", 0 === transforms.length ? "none" : transforms.join(" "));
	                }
	            } ]), ReactImageLightbox;
	        }(_react.Component);
	        ReactImageLightbox.propTypes = {
	            //-----------------------------
	            // Image sources
	            //-----------------------------
	            // Main display image url
	            mainSrc: _react.PropTypes.string.isRequired,
	            // eslint-disable-line react/no-unused-prop-types
	            // Previous display image url (displayed to the left)
	            // If left undefined, movePrev actions will not be performed, and the button not displayed
	            prevSrc: _react.PropTypes.string,
	            // Next display image url (displayed to the right)
	            // If left undefined, moveNext actions will not be performed, and the button not displayed
	            nextSrc: _react.PropTypes.string,
	            //-----------------------------
	            // Image thumbnail sources
	            //-----------------------------
	            // Thumbnail image url corresponding to props.mainSrc
	            mainSrcThumbnail: _react.PropTypes.string,
	            // eslint-disable-line react/no-unused-prop-types
	            // Thumbnail image url corresponding to props.prevSrc
	            prevSrcThumbnail: _react.PropTypes.string,
	            // eslint-disable-line react/no-unused-prop-types
	            // Thumbnail image url corresponding to props.nextSrc
	            nextSrcThumbnail: _react.PropTypes.string,
	            // eslint-disable-line react/no-unused-prop-types
	            //-----------------------------
	            // Event Handlers
	            //-----------------------------
	            // Close window event
	            // Should change the parent state such that the lightbox is not rendered
	            onCloseRequest: _react.PropTypes.func.isRequired,
	            // Move to previous image event
	            // Should change the parent state such that props.prevSrc becomes props.mainSrc,
	            //  props.mainSrc becomes props.nextSrc, etc.
	            onMovePrevRequest: _react.PropTypes.func,
	            // Move to next image event
	            // Should change the parent state such that props.nextSrc becomes props.mainSrc,
	            //  props.mainSrc becomes props.prevSrc, etc.
	            onMoveNextRequest: _react.PropTypes.func,
	            // Called when an image fails to load
	            // (imageSrc: string, srcType: string, errorEvent: object): void
	            onImageLoadError: _react.PropTypes.func,
	            //-----------------------------
	            // Download discouragement settings
	            //-----------------------------
	            // Enable download discouragement (prevents [right-click -> Save Image As...])
	            discourageDownloads: _react.PropTypes.bool,
	            //-----------------------------
	            // Animation settings
	            //-----------------------------
	            // Disable all animation
	            animationDisabled: _react.PropTypes.bool,
	            // Disable animation on actions performed with keyboard shortcuts
	            animationOnKeyInput: _react.PropTypes.bool,
	            // Animation duration (ms)
	            animationDuration: _react.PropTypes.number,
	            //-----------------------------
	            // Keyboard shortcut settings
	            //-----------------------------
	            // Required interval of time (ms) between key actions
	            // (prevents excessively fast navigation of images)
	            keyRepeatLimit: _react.PropTypes.number,
	            // Amount of time (ms) restored after each keyup
	            // (makes rapid key presses slightly faster than holding down the key to navigate images)
	            keyRepeatKeyupBonus: _react.PropTypes.number,
	            //-----------------------------
	            // Image info
	            //-----------------------------
	            // Image title
	            imageTitle: _react.PropTypes.node,
	            // Image caption
	            imageCaption: _react.PropTypes.node,
	            //-----------------------------
	            // Lightbox style
	            //-----------------------------
	            // Set z-index style, etc., for the parent react-modal (format: https://github.com/reactjs/react-modal#styles )
	            reactModalStyle: _react.PropTypes.object,
	            // Padding (px) between the edge of the window and the lightbox
	            imagePadding: _react.PropTypes.number,
	            //-----------------------------
	            // Other
	            //-----------------------------
	            // Array of custom toolbar buttons
	            toolbarButtons: _react.PropTypes.arrayOf(_react.PropTypes.node),
	            // When true, clicks outside of the image close the lightbox
	            clickOutsideToClose: _react.PropTypes.bool,
	            // Set to false to disable zoom functionality and hide zoom buttons
	            enableZoom: _react.PropTypes.bool
	        }, ReactImageLightbox.defaultProps = {
	            onMovePrevRequest: function() {},
	            onMoveNextRequest: function() {},
	            onImageLoadError: function() {},
	            discourageDownloads: !1,
	            animationDisabled: !1,
	            animationOnKeyInput: !1,
	            animationDuration: 300,
	            keyRepeatLimit: 180,
	            keyRepeatKeyupBonus: 40,
	            reactModalStyle: {},
	            imagePadding: 10,
	            clickOutsideToClose: !0,
	            enableZoom: !0
	        }, exports.default = ReactImageLightbox;
	    }, /* 3 */
	    /***/
	    function(module, exports) {
	        "use strict";
	        /**
		 * Get the version of Internet Explorer in use, or undefined
		 *
		 * @return {?number} ieVersion - IE version as an integer, or undefined if not IE
		 */
	        function getIEVersion() {
	            if ("undefined" != typeof window) {
	                var match = window.navigator.userAgent.match(/(?:MSIE |Trident\/.*; rv:)(\d+)/);
	                return match ? parseInt(match[1], 10) : void 0;
	            }
	        }
	        /**
		 * Placeholder for future translate functionality
		 */
	        function translate(str) {
	            var replaceStrings = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
	            if (!str) return "";
	            var translated = str;
	            return replaceStrings && Object.keys(replaceStrings).forEach(function(placeholder) {
	                translated = translated.replace(placeholder, replaceStrings[placeholder]);
	            }), translated;
	        }
	        function getWindowWidth() {
	            return "undefined" == typeof window ? 0 : window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
	        }
	        function getWindowHeight() {
	            return "undefined" == typeof window ? 0 : window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	        }
	        // Returns true if this window is rendered as an iframe inside another window
	        // with the same origin.
	        function isInSameOriginIframe() {
	            try {
	                return window.self !== window.top && window.top.document;
	            } catch (e) {
	                return !1;
	            }
	        }
	        Object.defineProperty(exports, "__esModule", {
	            value: !0
	        }), exports.getIEVersion = getIEVersion, exports.translate = translate, exports.getWindowWidth = getWindowWidth, 
	        exports.getWindowHeight = getWindowHeight, exports.isInSameOriginIframe = isInSameOriginIframe;
	    }, /* 4 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        exports = module.exports = __webpack_require__(5)(), // imports
	        // module
	        exports.push([ module.id, '@-webkit-keyframes closeWindow___2Hlon{0%{opacity:1}to{opacity:0}}@keyframes closeWindow___2Hlon{0%{opacity:1}to{opacity:0}}.outer___2lDXy{background-color:rgba(0,0,0,.85);top:0;left:0;right:0;bottom:0;z-index:1000;width:100%;height:100%;-ms-content-zooming:none;-ms-user-select:none;-ms-touch-select:none;-ms-touch-action:none;touch-action:none}.outerClosing___1EQGK{opacity:0}.image___2FLq2,.inner___1rfRQ{position:absolute;top:0;left:0;right:0;bottom:0}.image___2FLq2{margin:auto;max-width:100%;max-height:100%;-ms-content-zooming:none;-ms-user-select:none;-ms-touch-select:none;-ms-touch-action:none;touch-action:none}.imageNext___1uRqJ,.imagePrev___F6xVQ{@extends .image}.imageDiscourager___3-CUB{background-repeat:no-repeat;background-position:50%;background-size:contain}.navButtons___3kNVF{border:none;position:absolute;top:0;bottom:0;width:20px;height:34px;padding:40px 30px;margin:auto;cursor:pointer;opacity:.7}.navButtons___3kNVF:hover{opacity:1}.navButtons___3kNVF:active{opacity:.7}.navButtonPrev___2vBS8{left:0;background:rgba(0,0,0,.2) url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDE5LDMgLTIsLTIgLTE2LDE2IDE2LDE2IDEsLTEgLTE1LC0xNSAxNSwtMTUgeiIgZmlsbD0iI0ZGRiIvPjwvc3ZnPg==") no-repeat 50%}.navButtonNext___30R2i{right:0;background:rgba(0,0,0,.2) url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjM0Ij48cGF0aCBkPSJtIDEsMyAyLC0yIDE2LDE2IC0xNiwxNiAtMSwtMSAxNSwtMTUgLTE1LC0xNSB6IiBmaWxsPSIjRkZGIi8+PC9zdmc+") no-repeat 50%}.downloadBlocker___3rU9-{position:absolute;top:0;left:0;right:0;bottom:0;background-image:url("data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");background-size:cover}.caption___3vDh_,.toolbar___1xYly{background-color:rgba(0,0,0,.5);position:absolute;left:0;right:0;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.caption___3vDh_{bottom:0;max-height:150px;overflow:auto}.captionContent___30kw2{padding:10px 20px;color:#fff}.toolbar___1xYly{top:0;height:50px}.toolbarSide___3FYWk{height:50px;margin:0}.toolbarSideNoFlex___KxqgW{height:auto;line-height:50px;max-width:48%;position:absolute;top:0;bottom:0}.toolbarLeftSide___8beAg{padding-left:20px;padding-right:0;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto;overflow:hidden;text-overflow:ellipsis}.toolbarLeftSideNoFlex___3O3cZ{left:0;overflow:visible}.toolbarRightSide___1Sdfc{padding-left:0;padding-right:20px;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.toolbarRightSideNoFlex___oa0FT{right:0}.toolbarItem___3WbMb{display:inline-block;line-height:50px;padding:0;color:#fff;font-size:120%;max-width:100%;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.toolbarItemChild___2U_MP{vertical-align:middle}.builtinButton___1zqo6{width:40px;height:35px;cursor:pointer;border:none;opacity:.7}.builtinButton___1zqo6:hover{opacity:1}.builtinButton___1zqo6:active{outline:none}.builtinButtonDisabled___3uvqe{cursor:default;opacity:.5}.builtinButtonDisabled___3uvqe:hover{opacity:.5}.closeButton___3BdAF{background:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgd2lkdGg9IjIwIiBoZWlnaHQ9IjIwIj48cGF0aCBkPSJtIDEsMyAxLjI1LC0xLjI1IDcuNSw3LjUgNy41LC03LjUgMS4yNSwxLjI1IC03LjUsNy41IDcuNSw3LjUgLTEuMjUsMS4yNSAtNy41LC03LjUgLTcuNSw3LjUgLTEuMjUsLTEuMjUgNy41LC03LjUgLTcuNSwtNy41IHoiIGZpbGw9IiNGRkYiLz48L3N2Zz4=") no-repeat 50%}.zoomInButton___3xtuX{background:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PHBhdGggZD0iTTEyIDV2NiIvPjwvZz48Y2lyY2xlIGN4PSIxMiIgY3k9IjgiIHI9IjciIGZpbGw9Im5vbmUiIHN0cm9rZT0iI2ZmZiIgc3Ryb2tlLXdpZHRoPSIyIi8+PC9zdmc+") no-repeat 50%}.zoomOutButton___38PZx{background:url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCI+PGcgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PHBhdGggZD0iTTEgMTlsNi02Ii8+PHBhdGggZD0iTTkgOGg2Ii8+PC9nPjxjaXJjbGUgY3g9IjEyIiBjeT0iOCIgcj0iNyIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjZmZmIiBzdHJva2Utd2lkdGg9IjIiLz48L3N2Zz4=") no-repeat 50%}.outerAnimating___2-fZi{-webkit-animation-name:closeWindow___2Hlon;animation-name:closeWindow___2Hlon}@-webkit-keyframes pointFade___2RA5J{0%,19.999%,to{opacity:0}20%{opacity:1}}@keyframes pointFade___2RA5J{0%,19.999%,to{opacity:0}20%{opacity:1}}.loadingCircle___3JNJg{width:60px;height:60px;position:relative}.loadingCirclePoint___3md-S{width:100%;height:100%;position:absolute;left:0;top:0}.loadingCirclePoint___3md-S:before{content:"";display:block;margin:0 auto;width:15%;height:15%;background-color:#fff;border-radius:30%;-webkit-animation:pointFade___2RA5J 1.2s infinite ease-in-out both;animation:pointFade___2RA5J 1.2s infinite ease-in-out both}.loadingCirclePoint___3md-S:first-of-type{-webkit-transform:rotate(0deg);-ms-transform:rotate(0deg);transform:rotate(0deg)}.loadingCirclePoint___3md-S:first-of-type:before,.loadingCirclePoint___3md-S:nth-of-type(7):before{-webkit-animation-delay:-1.2s;animation-delay:-1.2s}.loadingCirclePoint___3md-S:nth-of-type(2){-webkit-transform:rotate(30deg);-ms-transform:rotate(30deg);transform:rotate(30deg)}.loadingCirclePoint___3md-S:nth-of-type(8){-webkit-transform:rotate(210deg);-ms-transform:rotate(210deg);transform:rotate(210deg)}.loadingCirclePoint___3md-S:nth-of-type(2):before,.loadingCirclePoint___3md-S:nth-of-type(8):before{-webkit-animation-delay:-1s;animation-delay:-1s}.loadingCirclePoint___3md-S:nth-of-type(3){-webkit-transform:rotate(60deg);-ms-transform:rotate(60deg);transform:rotate(60deg)}.loadingCirclePoint___3md-S:nth-of-type(9){-webkit-transform:rotate(240deg);-ms-transform:rotate(240deg);transform:rotate(240deg)}.loadingCirclePoint___3md-S:nth-of-type(3):before,.loadingCirclePoint___3md-S:nth-of-type(9):before{-webkit-animation-delay:-.8s;animation-delay:-.8s}.loadingCirclePoint___3md-S:nth-of-type(4){-webkit-transform:rotate(90deg);-ms-transform:rotate(90deg);transform:rotate(90deg)}.loadingCirclePoint___3md-S:nth-of-type(10){-webkit-transform:rotate(270deg);-ms-transform:rotate(270deg);transform:rotate(270deg)}.loadingCirclePoint___3md-S:nth-of-type(4):before,.loadingCirclePoint___3md-S:nth-of-type(10):before{-webkit-animation-delay:-.6s;animation-delay:-.6s}.loadingCirclePoint___3md-S:nth-of-type(5){-webkit-transform:rotate(120deg);-ms-transform:rotate(120deg);transform:rotate(120deg)}.loadingCirclePoint___3md-S:nth-of-type(11){-webkit-transform:rotate(300deg);-ms-transform:rotate(300deg);transform:rotate(300deg)}.loadingCirclePoint___3md-S:nth-of-type(5):before,.loadingCirclePoint___3md-S:nth-of-type(11):before{-webkit-animation-delay:-.4s;animation-delay:-.4s}.loadingCirclePoint___3md-S:nth-of-type(6){-webkit-transform:rotate(150deg);-ms-transform:rotate(150deg);transform:rotate(150deg)}.loadingCirclePoint___3md-S:nth-of-type(12){-webkit-transform:rotate(330deg);-ms-transform:rotate(330deg);transform:rotate(330deg)}.loadingCirclePoint___3md-S:nth-of-type(6):before,.loadingCirclePoint___3md-S:nth-of-type(12):before{-webkit-animation-delay:-.2s;animation-delay:-.2s}.loadingCirclePoint___3md-S:nth-of-type(7){-webkit-transform:rotate(180deg);-ms-transform:rotate(180deg);transform:rotate(180deg)}.loadingCirclePoint___3md-S:nth-of-type(13){-webkit-transform:rotate(1turn);-ms-transform:rotate(1turn);transform:rotate(1turn)}.loadingCirclePoint___3md-S:nth-of-type(7):before,.loadingCirclePoint___3md-S:nth-of-type(13):before{-webkit-animation-delay:0ms;animation-delay:0ms}.loadingContainer___2vaJ-{position:absolute;top:0;right:0;bottom:0;left:0}.loadingContainer__icon___1wQQz{color:#fff;position:absolute;top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);-ms-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%)}', "" ]), 
	        // exports
	        exports.locals = {
	            outer: "outer___2lDXy",
	            outerClosing: "outerClosing___1EQGK",
	            inner: "inner___1rfRQ",
	            image: "image___2FLq2",
	            imagePrev: "imagePrev___F6xVQ",
	            imageNext: "imageNext___1uRqJ",
	            imageDiscourager: "imageDiscourager___3-CUB",
	            navButtons: "navButtons___3kNVF",
	            navButtonPrev: "navButtonPrev___2vBS8",
	            navButtonNext: "navButtonNext___30R2i",
	            downloadBlocker: "downloadBlocker___3rU9-",
	            caption: "caption___3vDh_",
	            toolbar: "toolbar___1xYly",
	            captionContent: "captionContent___30kw2",
	            toolbarSide: "toolbarSide___3FYWk",
	            toolbarSideNoFlex: "toolbarSideNoFlex___KxqgW",
	            toolbarLeftSide: "toolbarLeftSide___8beAg",
	            toolbarLeftSideNoFlex: "toolbarLeftSideNoFlex___3O3cZ",
	            toolbarRightSide: "toolbarRightSide___1Sdfc",
	            toolbarRightSideNoFlex: "toolbarRightSideNoFlex___oa0FT",
	            toolbarItem: "toolbarItem___3WbMb",
	            toolbarItemChild: "toolbarItemChild___2U_MP",
	            builtinButton: "builtinButton___1zqo6",
	            builtinButtonDisabled: "builtinButtonDisabled___3uvqe",
	            closeButton: "closeButton___3BdAF",
	            zoomInButton: "zoomInButton___3xtuX",
	            zoomOutButton: "zoomOutButton___38PZx",
	            outerAnimating: "outerAnimating___2-fZi",
	            closeWindow: "closeWindow___2Hlon",
	            loadingCircle: "loadingCircle___3JNJg",
	            loadingCirclePoint: "loadingCirclePoint___3md-S",
	            pointFade: "pointFade___2RA5J",
	            loadingContainer: "loadingContainer___2vaJ-",
	            loadingContainer__icon: "loadingContainer__icon___1wQQz"
	        };
	    }, /* 5 */
	    /***/
	    function(module, exports) {
	        /*
			MIT License http://www.opensource.org/licenses/mit-license.php
			Author Tobias Koppers @sokra
		*/
	        // css base code, injected by the css-loader
	        module.exports = function() {
	            var list = [];
	            // return the list of modules as css string
	            // import a list of modules into the list
	            return list.toString = function() {
	                for (var result = [], i = 0; i < this.length; i++) {
	                    var item = this[i];
	                    item[2] ? result.push("@media " + item[2] + "{" + item[1] + "}") : result.push(item[1]);
	                }
	                return result.join("");
	            }, list.i = function(modules, mediaQuery) {
	                "string" == typeof modules && (modules = [ [ null, modules, "" ] ]);
	                for (var alreadyImportedModules = {}, i = 0; i < this.length; i++) {
	                    var id = this[i][0];
	                    "number" == typeof id && (alreadyImportedModules[id] = !0);
	                }
	                for (i = 0; i < modules.length; i++) {
	                    var item = modules[i];
	                    // skip already imported module
	                    // this implementation is not 100% perfect for weird media query combinations
	                    //  when a module is imported multiple times with different media queries.
	                    //  I hope this will never occur (Hey this way we have smaller bundles)
	                    "number" == typeof item[0] && alreadyImportedModules[item[0]] || (mediaQuery && !item[2] ? item[2] = mediaQuery : mediaQuery && (item[2] = "(" + item[2] + ") and (" + mediaQuery + ")"), 
	                    list.push(item));
	                }
	            }, list;
	        };
	    }, /* 6 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        function addStylesToDom(styles, options) {
	            for (var i = 0; i < styles.length; i++) {
	                var item = styles[i], domStyle = stylesInDom[item.id];
	                if (domStyle) {
	                    domStyle.refs++;
	                    for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j](item.parts[j]);
	                    for (;j < item.parts.length; j++) domStyle.parts.push(addStyle(item.parts[j], options));
	                } else {
	                    for (var parts = [], j = 0; j < item.parts.length; j++) parts.push(addStyle(item.parts[j], options));
	                    stylesInDom[item.id] = {
	                        id: item.id,
	                        refs: 1,
	                        parts: parts
	                    };
	                }
	            }
	        }
	        function listToStyles(list) {
	            for (var styles = [], newStyles = {}, i = 0; i < list.length; i++) {
	                var item = list[i], id = item[0], css = item[1], media = item[2], sourceMap = item[3], part = {
	                    css: css,
	                    media: media,
	                    sourceMap: sourceMap
	                };
	                newStyles[id] ? newStyles[id].parts.push(part) : styles.push(newStyles[id] = {
	                    id: id,
	                    parts: [ part ]
	                });
	            }
	            return styles;
	        }
	        function insertStyleElement(options, styleElement) {
	            var head = getHeadElement(), lastStyleElementInsertedAtTop = styleElementsInsertedAtTop[styleElementsInsertedAtTop.length - 1];
	            if ("top" === options.insertAt) lastStyleElementInsertedAtTop ? lastStyleElementInsertedAtTop.nextSibling ? head.insertBefore(styleElement, lastStyleElementInsertedAtTop.nextSibling) : head.appendChild(styleElement) : head.insertBefore(styleElement, head.firstChild), 
	            styleElementsInsertedAtTop.push(styleElement); else {
	                if ("bottom" !== options.insertAt) throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	                head.appendChild(styleElement);
	            }
	        }
	        function removeStyleElement(styleElement) {
	            styleElement.parentNode.removeChild(styleElement);
	            var idx = styleElementsInsertedAtTop.indexOf(styleElement);
	            idx >= 0 && styleElementsInsertedAtTop.splice(idx, 1);
	        }
	        function createStyleElement(options) {
	            var styleElement = document.createElement("style");
	            return styleElement.type = "text/css", insertStyleElement(options, styleElement), 
	            styleElement;
	        }
	        function createLinkElement(options) {
	            var linkElement = document.createElement("link");
	            return linkElement.rel = "stylesheet", insertStyleElement(options, linkElement), 
	            linkElement;
	        }
	        function addStyle(obj, options) {
	            var styleElement, update, remove;
	            if (options.singleton) {
	                var styleIndex = singletonCounter++;
	                styleElement = singletonElement || (singletonElement = createStyleElement(options)), 
	                update = applyToSingletonTag.bind(null, styleElement, styleIndex, !1), remove = applyToSingletonTag.bind(null, styleElement, styleIndex, !0);
	            } else obj.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (styleElement = createLinkElement(options), 
	            update = updateLink.bind(null, styleElement), remove = function() {
	                removeStyleElement(styleElement), styleElement.href && URL.revokeObjectURL(styleElement.href);
	            }) : (styleElement = createStyleElement(options), update = applyToTag.bind(null, styleElement), 
	            remove = function() {
	                removeStyleElement(styleElement);
	            });
	            return update(obj), function(newObj) {
	                if (newObj) {
	                    if (newObj.css === obj.css && newObj.media === obj.media && newObj.sourceMap === obj.sourceMap) return;
	                    update(obj = newObj);
	                } else remove();
	            };
	        }
	        function applyToSingletonTag(styleElement, index, remove, obj) {
	            var css = remove ? "" : obj.css;
	            if (styleElement.styleSheet) styleElement.styleSheet.cssText = replaceText(index, css); else {
	                var cssNode = document.createTextNode(css), childNodes = styleElement.childNodes;
	                childNodes[index] && styleElement.removeChild(childNodes[index]), childNodes.length ? styleElement.insertBefore(cssNode, childNodes[index]) : styleElement.appendChild(cssNode);
	            }
	        }
	        function applyToTag(styleElement, obj) {
	            var css = obj.css, media = obj.media;
	            if (media && styleElement.setAttribute("media", media), styleElement.styleSheet) styleElement.styleSheet.cssText = css; else {
	                for (;styleElement.firstChild; ) styleElement.removeChild(styleElement.firstChild);
	                styleElement.appendChild(document.createTextNode(css));
	            }
	        }
	        function updateLink(linkElement, obj) {
	            var css = obj.css, sourceMap = obj.sourceMap;
	            sourceMap && (// http://stackoverflow.com/a/26603875
	            css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */");
	            var blob = new Blob([ css ], {
	                type: "text/css"
	            }), oldSrc = linkElement.href;
	            linkElement.href = URL.createObjectURL(blob), oldSrc && URL.revokeObjectURL(oldSrc);
	        }
	        /*
			MIT License http://www.opensource.org/licenses/mit-license.php
			Author Tobias Koppers @sokra
		*/
	        var stylesInDom = {}, memoize = function(fn) {
	            var memo;
	            return function() {
	                return "undefined" == typeof memo && (memo = fn.apply(this, arguments)), memo;
	            };
	        }, isOldIE = memoize(function() {
	            return /msie [6-9]\b/.test(window.navigator.userAgent.toLowerCase());
	        }), getHeadElement = memoize(function() {
	            return document.head || document.getElementsByTagName("head")[0];
	        }), singletonElement = null, singletonCounter = 0, styleElementsInsertedAtTop = [];
	        module.exports = function(list, options) {
	            options = options || {}, // Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	            // tags it will allow on a page
	            "undefined" == typeof options.singleton && (options.singleton = isOldIE()), // By default, add <style> tags to the bottom of <head>.
	            "undefined" == typeof options.insertAt && (options.insertAt = "bottom");
	            var styles = listToStyles(list);
	            return addStylesToDom(styles, options), function(newList) {
	                for (var mayRemove = [], i = 0; i < styles.length; i++) {
	                    var item = styles[i], domStyle = stylesInDom[item.id];
	                    domStyle.refs--, mayRemove.push(domStyle);
	                }
	                if (newList) {
	                    var newStyles = listToStyles(newList);
	                    addStylesToDom(newStyles, options);
	                }
	                for (var i = 0; i < mayRemove.length; i++) {
	                    var domStyle = mayRemove[i];
	                    if (0 === domStyle.refs) {
	                        for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();
	                        delete stylesInDom[domStyle.id];
	                    }
	                }
	            };
	        };
	        var replaceText = function() {
	            var textStore = [];
	            return function(index, replacement) {
	                return textStore[index] = replacement, textStore.filter(Boolean).join("\n");
	            };
	        }();
	    }, /* 7 */
	    /***/
	    function(module, exports, __webpack_require__) {
	        // style-loader: Adds some css to the DOM by adding a <style> tag
	        // load the styles
	        var content = __webpack_require__(4);
	        "string" == typeof content && (content = [ [ module.id, content, "" ] ]);
	        // add the styles to the DOM
	        __webpack_require__(6)(content, {});
	        content.locals && (module.exports = content.locals);
	    }, /* 8 */
	    /***/
	    function(module, exports) {
	        module.exports = __WEBPACK_EXTERNAL_MODULE_8__;
	    }, /* 9 */
	    /***/
	    function(module, exports) {
	        module.exports = __WEBPACK_EXTERNAL_MODULE_9__;
	    } ]);
	});
	//# sourceMappingURL=react-image-lightbox.js.map

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(24);
	var Danger = __webpack_require__(298);
	var ReactMultiChildUpdateTypes = __webpack_require__(118);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(11);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(74);
	var setInnerHTML = __webpack_require__(46);
	var setTextContent = __webpack_require__(131);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 60 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventConstants = __webpack_require__(16);
	var ReactErrorUtils = __webpack_require__(68);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 63 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactPropTypes = __webpack_require__(120);
	var ReactPropTypeLocations = __webpack_require__(71);
	var ReactPropTypesSecret = __webpack_require__(72);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop, null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactNoopUpdateQueue = __webpack_require__(69);
	
	var canDefineProperty = __webpack_require__(124);
	var emptyObject = __webpack_require__(31);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentTreeHook
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(20);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty)
	  // Strip regex characters so we can use it for regex
	  .replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  // Remove hasOwnProperty from the template to make it generic
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var itemMap;
	var rootIDSet;
	
	var itemByKey;
	var rootByKey;
	
	if (canUseCollections) {
	  itemMap = new Map();
	  rootIDSet = new Set();
	} else {
	  itemByKey = {};
	  rootByKey = {};
	}
	
	var unmountedIDs = [];
	
	// Use non-numeric keys to prevent V8 performance issues:
	// https://github.com/facebook/react/pull/7232
	function getKeyFromID(id) {
	  return '.' + id;
	}
	function getIDFromKey(key) {
	  return parseInt(key.substr(1), 10);
	}
	
	function get(id) {
	  if (canUseCollections) {
	    return itemMap.get(id);
	  } else {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  }
	}
	
	function remove(id) {
	  if (canUseCollections) {
	    itemMap['delete'](id);
	  } else {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  }
	}
	
	function create(id, element, parentID) {
	  var item = {
	    element: element,
	    parentID: parentID,
	    text: null,
	    childIDs: [],
	    isMounted: false,
	    updateCount: 0
	  };
	
	  if (canUseCollections) {
	    itemMap.set(id, item);
	  } else {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  }
	}
	
	function addRoot(id) {
	  if (canUseCollections) {
	    rootIDSet.add(id);
	  } else {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  }
	}
	
	function removeRoot(id) {
	  if (canUseCollections) {
	    rootIDSet['delete'](id);
	  } else {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  }
	}
	
	function getRegisteredIDs() {
	  if (canUseCollections) {
	    return Array.from(itemMap.keys());
	  } else {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  }
	}
	
	function getRootIDs() {
	  if (canUseCollections) {
	    return Array.from(rootIDSet.keys());
	  } else {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  }
	}
	
	function purgeDeep(id) {
	  var item = get(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    remove(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + name + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = get(id);
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = get(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent ID is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    create(id, element, parentID);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = get(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = get(id);
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = get(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = get(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = get(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var type = topElement.type;
	      var name = typeof type === 'function' ? type.displayName || type.name : type;
	      var owner = topElement._owner;
	      info += describeComponentFrame(name || 'Unknown', topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = get(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = get(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = get(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = get(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = get(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRegisteredIDs: getRegisteredIDs,
	
	  getRootIDs: getRootIDs
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(6);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(40);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 72 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypesSecret
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactInstanceMap = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactUpdates = __webpack_require__(15);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 74 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 75 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 76 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 79 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactElement = __webpack_require__(14);
	
	var getIteratorFn = __webpack_require__(127);
	var invariant = __webpack_require__(2);
	var KeyEscapeUtils = __webpack_require__(63);
	var warning = __webpack_require__(6);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyFunction = __webpack_require__(10);
	var warning = __webpack_require__(6);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = ' Make sure you don\'t have any extra whitespace between tags on ' + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(207);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./divider.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./divider.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(209);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./header.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./header.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(376);
	
	var Tooltip = function (_React$Component) {
	  _inherits(Tooltip, _React$Component);
	
	  function Tooltip(props) {
	    _classCallCheck(this, Tooltip);
	
	    var _this = _possibleConstructorReturn(this, (Tooltip.__proto__ || Object.getPrototypeOf(Tooltip)).call(this, props));
	
	    _this.state = {
	      width: _this.props.chartWidth,
	      showTooltip: false
	    };
	
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: 'render',
	    value: function render() {
	
	      var transform = '';
	      var transformText = 'translate(' + this.props.tooltipWidth / 2 + ',' + (this.props.tooltipHeight / 2 - 8) + ')';
	      var transformArrow = '';
	
	      var x = this.props.tooltipPosX;
	      var y = this.props.tooltipPosY;
	
	      // Large Tooltips
	
	      // TOOLTIP TOP OF CIRCLE
	      if (y > this.props.tooltipHeight) {
	        // console.log(y);
	        transform = 'translate(' + (x - this.props.tooltipWidth / 2) + ',' + (y - this.props.tooltipHeight - 15) + ')';
	        transformArrow = 'translate(' + (this.props.tooltipWidth / 2 - 20) + ',' + (this.props.tooltipHeight - 3) + ')';
	        // LEFT BOUNDARY
	        if (x < this.props.tooltipWidth) {
	          transform = 'translate(' + (x - 20) + ',' + (y - this.props.tooltipHeight - 20) + ')';
	          transformArrow = 'translate(' + 0 + ',' + (this.props.tooltipHeight - 3) + ')';
	        }
	        if (x > this.props.chartWidth - this.props.tooltipWidth) {
	          transform = 'translate(' + (x - this.props.tooltipWidth + 20) + ',' + (y - this.props.tooltipHeight - 15) + ')';
	          transformArrow = 'translate(' + (this.props.tooltipWidth - 40) + ',' + (this.props.tooltipHeight - 3) + ')';
	        }
	        // RIGHT BOUNDARY
	
	        // TOOLTIP BOTTOM OF CIRCLE
	      } else if (y < this.props.tooltipHeight) {
	        transform = 'translate(' + (x - this.props.tooltipWidth / 2) + ',' + (Math.round(y) + 15) + ')';
	        transformArrow = 'translate(' + (this.props.tooltipWidth / 2 - 20) + ',' + 2 + ') rotate(180,20,0)';
	        // LEFT BOUNDARY
	        if (x < this.props.tooltipWidth) {
	          transform = 'translate(' + (x - 20) + ',' + (Math.round(y) + 20) + ')';
	          transformArrow = 'translate(' + 0 + ',' + 2 + ') rotate(180,20,0)';
	        }
	        // RIGHT BOUNDARY
	        if (x > this.props.chartWidth - this.props.tooltipWidth) {
	          transform = 'translate(' + (x - this.props.tooltipWidth + 20) + ',' + (Math.round(y) + 15) + ')';
	          transformArrow = 'translate(' + (this.props.tooltipWidth - 40) + ',' + 2 + ') rotate(180,20,0)';
	        }
	      }
	
	      return _react2.default.createElement(
	        'g',
	        { transform: transform, className: 'tooltip-wrapper ' + this.props.tooltipClassName },
	        _react2.default.createElement('rect', { className: 'shadow', width: this.props.tooltipWidth, height: this.props.tooltipHeight, rx: '1', ry: '1', fill: this.props.tooltipBackground, opacity: '1' }),
	        _react2.default.createElement('polygon', { className: 'shadow', points: '10,0  30,0  20,10', transform: transformArrow,
	          fill: this.props.tooltipBackground, opacity: '1' }),
	        _react2.default.createElement(
	          'text',
	          { transform: transformText },
	          _react2.default.createElement(
	            'tspan',
	            { x: '0', textAnchor: 'middle', dy: this.props.tooltipYOffset ? this.props.tooltipYOffset : '-3.5', fontSize: this.props.tooltipFontSize + 'px', fill: this.props.tooltipColor },
	            this.props.tooltipPrefix,
	            this.props.tooltipTitle,
	            this.props.tooltipSuffix
	          ),
	          _react2.default.createElement(
	            'tspan',
	            { x: '0', textAnchor: 'middle', dy: this.props.tooltipFontSize + 3, fontSize: this.props.tooltipFontSize + 'px', fontFamily: 'Benton Sans Cond', fontWeight: 'medium', fill: this.props.tooltipColor },
	            this.props.tooltipCountPrefix && this.props.tooltipCountPrefix,
	            this.props.tooltipCountAbsolute,
	            this.props.tooltipCountSuffix
	          ),
	          _react2.default.createElement(
	            'tspan',
	            { x: '0', textAnchor: 'middle', dy: this.props.tooltipFontSize * 1.33, fontSize: this.props.tooltipFontSize + 'px', fontFamily: 'Benton Sans Cond', fontWeight: 'medium', fill: this.props.tooltipColor },
	            this.props.tooltipCountAbsolutePrefix,
	            ' ',
	            this.props.tooltipCountPercentage,
	            this.props.tooltipCountAbsoluteSuffix
	          )
	        )
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react2.default.Component);
	
	Tooltip.propTypes = {
	  tooltipPosX: _react2.default.PropTypes.number,
	  tooltipPosY: _react2.default.PropTypes.number,
	  tooltipWidth: _react2.default.PropTypes.number,
	  tooltipHeight: _react2.default.PropTypes.number,
	  chartWidth: _react2.default.PropTypes.number,
	  chartHeight: _react2.default.PropTypes.number,
	  tooltipClassName: _react2.default.PropTypes.string,
	  tooltipBackground: _react2.default.PropTypes.string,
	  tooltipCount: _react2.default.PropTypes.string,
	  tooltipAbsoluteCount: _react2.default.PropTypes.string,
	  tooltipTitle: _react2.default.PropTypes.string,
	  tooltipColor: _react2.default.PropTypes.string,
	  tooltipData: _react2.default.PropTypes.array,
	  tooltipSize: _react2.default.PropTypes.string,
	  tooltipFontSize: _react2.default.PropTypes.number,
	  tooltipPrefix: _react2.default.PropTypes.string,
	  tooltipSuffix: _react2.default.PropTypes.string,
	  tooltipCountSuffix: _react2.default.PropTypes.string,
	  tooltipCountPrefix: _react2.default.PropTypes.string,
	  tooltipCountAbsolute: _react2.default.PropTypes.string,
	  tooltipCountPercentage: _react2.default.PropTypes.string,
	  tooltipCountAbsolutePrefix: _react2.default.PropTypes.string,
	  tooltipCountAbsoluteSuffix: _react2.default.PropTypes.string,
	  tooltipYOffset: _react2.default.PropTypes.number
	};
	
	exports.default = Tooltip;

/***/ },
/* 85 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function(it){
	  if(it == undefined)throw TypeError("Can't call method on  " + it);
	  return it;
	};

/***/ },
/* 86 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function(it, key){
	  return hasOwnProperty.call(it, key);
	};

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var dP         = __webpack_require__(174)
	  , createDesc = __webpack_require__(179);
	module.exports = __webpack_require__(48) ? function(object, key, value){
	  return dP.f(object, key, createDesc(1, value));
	} : function(object, key, value){
	  object[key] = value;
	  return object;
	};

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(167);
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};

/***/ },
/* 89 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil  = Math.ceil
	  , floor = Math.floor;
	module.exports = function(it){
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(88)
	  , defined = __webpack_require__(85);
	module.exports = function(it){
	  return IObject(defined(it));
	};

/***/ },
/* 91 */
/***/ function(module, exports) {

	var id = 0
	  , px = Math.random();
	module.exports = function(key){
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-request/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(27), __webpack_require__(223), __webpack_require__(224)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-collection', 'd3-dispatch', 'd3-dsv'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3));
	}(this, function (exports,d3Collection,d3Dispatch,d3Dsv) { 'use strict';
	
	  function request(url, callback) {
	    var request,
	        event = d3Dispatch.dispatch("beforesend", "progress", "load", "error"),
	        mimeType,
	        headers = d3Collection.map(),
	        xhr = new XMLHttpRequest,
	        user = null,
	        password = null,
	        response,
	        responseType,
	        timeout = 0;
	
	    // If IE does not support CORS, use XDomainRequest.
	    if (typeof XDomainRequest !== "undefined"
	        && !("withCredentials" in xhr)
	        && /^(http(s)?:)?\/\//.test(url)) xhr = new XDomainRequest;
	
	    "onload" in xhr
	        ? xhr.onload = xhr.onerror = xhr.ontimeout = respond
	        : xhr.onreadystatechange = function(o) { xhr.readyState > 3 && respond(o); };
	
	    function respond(o) {
	      var status = xhr.status, result;
	      if (!status && hasResponse(xhr)
	          || status >= 200 && status < 300
	          || status === 304) {
	        if (response) {
	          try {
	            result = response.call(request, xhr);
	          } catch (e) {
	            event.call("error", request, e);
	            return;
	          }
	        } else {
	          result = xhr;
	        }
	        event.call("load", request, result);
	      } else {
	        event.call("error", request, o);
	      }
	    }
	
	    xhr.onprogress = function(e) {
	      event.call("progress", request, e);
	    };
	
	    request = {
	      header: function(name, value) {
	        name = (name + "").toLowerCase();
	        if (arguments.length < 2) return headers.get(name);
	        if (value == null) headers.remove(name);
	        else headers.set(name, value + "");
	        return request;
	      },
	
	      // If mimeType is non-null and no Accept header is set, a default is used.
	      mimeType: function(value) {
	        if (!arguments.length) return mimeType;
	        mimeType = value == null ? null : value + "";
	        return request;
	      },
	
	      // Specifies what type the response value should take;
	      // for instance, arraybuffer, blob, document, or text.
	      responseType: function(value) {
	        if (!arguments.length) return responseType;
	        responseType = value;
	        return request;
	      },
	
	      timeout: function(value) {
	        if (!arguments.length) return timeout;
	        timeout = +value;
	        return request;
	      },
	
	      user: function(value) {
	        return arguments.length < 1 ? user : (user = value == null ? null : value + "", request);
	      },
	
	      password: function(value) {
	        return arguments.length < 1 ? password : (password = value == null ? null : value + "", request);
	      },
	
	      // Specify how to convert the response content to a specific type;
	      // changes the callback value on "load" events.
	      response: function(value) {
	        response = value;
	        return request;
	      },
	
	      // Alias for send("GET", …).
	      get: function(data, callback) {
	        return request.send("GET", data, callback);
	      },
	
	      // Alias for send("POST", …).
	      post: function(data, callback) {
	        return request.send("POST", data, callback);
	      },
	
	      // If callback is non-null, it will be used for error and load events.
	      send: function(method, data, callback) {
	        xhr.open(method, url, true, user, password);
	        if (mimeType != null && !headers.has("accept")) headers.set("accept", mimeType + ",*/*");
	        if (xhr.setRequestHeader) headers.each(function(value, name) { xhr.setRequestHeader(name, value); });
	        if (mimeType != null && xhr.overrideMimeType) xhr.overrideMimeType(mimeType);
	        if (responseType != null) xhr.responseType = responseType;
	        if (timeout > 0) xhr.timeout = timeout;
	        if (callback == null && typeof data === "function") callback = data, data = null;
	        if (callback != null && callback.length === 1) callback = fixCallback(callback);
	        if (callback != null) request.on("error", callback).on("load", function(xhr) { callback(null, xhr); });
	        event.call("beforesend", request, xhr);
	        xhr.send(data == null ? null : data);
	        return request;
	      },
	
	      abort: function() {
	        xhr.abort();
	        return request;
	      },
	
	      on: function() {
	        var value = event.on.apply(event, arguments);
	        return value === event ? request : value;
	      }
	    };
	
	    if (callback != null) {
	      if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	      return request.get(callback);
	    }
	
	    return request;
	  }
	
	  function fixCallback(callback) {
	    return function(error, xhr) {
	      callback(error == null ? xhr : null);
	    };
	  }
	
	  function hasResponse(xhr) {
	    var type = xhr.responseType;
	    return type && type !== "text"
	        ? xhr.response // null on error
	        : xhr.responseText; // "" on error
	  }
	
	  function type(defaultMimeType, response) {
	    return function(url, callback) {
	      var r = request(url).mimeType(defaultMimeType).response(response);
	      if (callback != null) {
	        if (typeof callback !== "function") throw new Error("invalid callback: " + callback);
	        return r.get(callback);
	      }
	      return r;
	    };
	  }
	
	  var html = type("text/html", function(xhr) {
	    return document.createRange().createContextualFragment(xhr.responseText);
	  });
	
	  var json = type("application/json", function(xhr) {
	    return JSON.parse(xhr.responseText);
	  });
	
	  var text = type("text/plain", function(xhr) {
	    return xhr.responseText;
	  });
	
	  var xml = type("application/xml", function(xhr) {
	    var xml = xhr.responseXML;
	    if (!xml) throw new Error("parse error");
	    return xml;
	  });
	
	  function dsv(defaultMimeType, parse) {
	    return function(url, row, callback) {
	      if (arguments.length < 3) callback = row, row = null;
	      var r = request(url).mimeType(defaultMimeType);
	      r.row = function(_) { return arguments.length ? r.response(responseOf(parse, row = _)) : row; };
	      r.row(row);
	      return callback ? r.get(callback) : r;
	    };
	  }
	
	  function responseOf(parse, row) {
	    return function(request) {
	      return parse(request.responseText, row);
	    };
	  }
	
	  var csv = dsv("text/csv", d3Dsv.csvParse);
	
	  var tsv = dsv("text/tab-separated-values", d3Dsv.tsvParse);
	
	  exports.request = request;
	  exports.html = html;
	  exports.json = json;
	  exports.text = text;
	  exports.xml = xml;
	  exports.csv = csv;
	  exports.tsv = tsv;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ Version 1.0.4. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var t0 = new Date;
	var t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = new Date(+date)), date;
	  }
	
	  interval.floor = interval;
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [];
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(new Date(+start)); while (offseti(start, step), floori(start), start < stop)
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) while (--step >= 0) while (offseti(date, 1), !test(date)) {} // eslint-disable-line no-empty
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationSecond) * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(Math.floor(date / durationMinute) * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  var offset = date.getTimezoneOffset() * durationMinute % durationHour;
	  if (offset < 0) offset += durationHour;
	  date.setTime(Math.floor((+date - offset) / durationHour) * durationHour + offset);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	
	var utcYears = utcYear.range;
	
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 94 */
/***/ function(module, exports) {

	"use strict";
	
	var detector = module.exports = {};
	
	detector.isIE = function(version) {
	    function isAnyIeVersion() {
	        var agent = navigator.userAgent.toLowerCase();
	        return agent.indexOf("msie") !== -1 || agent.indexOf("trident") !== -1 || agent.indexOf(" edge/") !== -1;
	    }
	
	    if(!isAnyIeVersion()) {
	        return false;
	    }
	
	    if(!version) {
	        return true;
	    }
	
	    //Shamelessly stolen from https://gist.github.com/padolsey/527683
	    var ieVersion = (function(){
	        var undef,
	            v = 3,
	            div = document.createElement("div"),
	            all = div.getElementsByTagName("i");
	
	        do {
	            div.innerHTML = "<!--[if gt IE " + (++v) + "]><i></i><![endif]-->";
	        }
	        while (all[0]);
	
	        return v > 4 ? v : undef;
	    }());
	
	    return version === ieVersion;
	};
	
	detector.isLegacyOpera = function() {
	    return !!window.opera;
	};


/***/ },
/* 95 */
/***/ function(module, exports) {

	"use strict";
	
	var utils = module.exports = {};
	
	/**
	 * Loops through the collection and calls the callback for each element. if the callback returns truthy, the loop is broken and returns the same value.
	 * @public
	 * @param {*} collection The collection to loop through. Needs to have a length property set and have indices set from 0 to length - 1.
	 * @param {function} callback The callback to be called for each element. The element will be given as a parameter to the callback. If this callback returns truthy, the loop is broken and the same value is returned.
	 * @returns {*} The value that a callback has returned (if truthy). Otherwise nothing.
	 */
	utils.forEach = function(collection, callback) {
	    for(var i = 0; i < collection.length; i++) {
	        var result = callback(collection[i]);
	        if(result) {
	            return result;
	        }
	    }
	};


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(10);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 97 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 98 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(263),
	    isArguments = __webpack_require__(265),
	    isArray = __webpack_require__(266);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 101 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var INPUT_FOCUSED = 'INPUT_FOCUSED';
	var INPUT_BLURRED = 'INPUT_BLURRED';
	var INPUT_CHANGED = 'INPUT_CHANGED';
	var UPDATE_FOCUSED_SUGGESTION = 'UPDATE_FOCUSED_SUGGESTION';
	var RESET_FOCUSED_SUGGESTION = 'RESET_FOCUSED_SUGGESTION';
	var REVEAL_SUGGESTIONS = 'REVEAL_SUGGESTIONS';
	var CLOSE_SUGGESTIONS = 'CLOSE_SUGGESTIONS';
	
	var inputFocused = function inputFocused(shouldRenderSuggestions) {
	  return {
	    type: INPUT_FOCUSED,
	    shouldRenderSuggestions: shouldRenderSuggestions
	  };
	};
	
	var inputBlurred = function inputBlurred(shouldRenderSuggestions) {
	  return {
	    type: INPUT_BLURRED,
	    shouldRenderSuggestions: shouldRenderSuggestions
	  };
	};
	
	var inputChanged = function inputChanged(shouldRenderSuggestions) {
	  return {
	    type: INPUT_CHANGED,
	    shouldRenderSuggestions: shouldRenderSuggestions
	  };
	};
	
	var updateFocusedSuggestion = function updateFocusedSuggestion(sectionIndex, suggestionIndex, value) {
	  return {
	    type: UPDATE_FOCUSED_SUGGESTION,
	    sectionIndex: sectionIndex,
	    suggestionIndex: suggestionIndex,
	    value: value
	  };
	};
	
	var resetFocusedSuggestion = function resetFocusedSuggestion() {
	  var shouldResetValueBeforeUpDown = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	  return {
	    type: RESET_FOCUSED_SUGGESTION,
	    shouldResetValueBeforeUpDown: shouldResetValueBeforeUpDown
	  };
	};
	
	var revealSuggestions = function revealSuggestions() {
	  return {
	    type: REVEAL_SUGGESTIONS
	  };
	};
	
	var closeSuggestions = function closeSuggestions() {
	  return {
	    type: CLOSE_SUGGESTIONS
	  };
	};
	
	var actionCreators = exports.actionCreators = {
	  inputFocused: inputFocused,
	  inputBlurred: inputBlurred,
	  inputChanged: inputChanged,
	  updateFocusedSuggestion: updateFocusedSuggestion,
	  resetFocusedSuggestion: resetFocusedSuggestion,
	  revealSuggestions: revealSuggestions,
	  closeSuggestions: closeSuggestions
	};
	
	var reducer = function reducer(state, action) {
	  switch (action.type) {
	    case INPUT_FOCUSED:
	      return _extends({}, state, {
	        isFocused: true,
	        isCollapsed: !action.shouldRenderSuggestions
	      });
	
	    case INPUT_BLURRED:
	      return _extends({}, state, {
	        isFocused: false,
	        focusedSectionIndex: null,
	        focusedSuggestionIndex: null,
	        valueBeforeUpDown: null,
	        isCollapsed: !action.shouldRenderSuggestions
	      });
	
	    case INPUT_CHANGED:
	      return _extends({}, state, {
	        focusedSectionIndex: null,
	        focusedSuggestionIndex: null,
	        valueBeforeUpDown: null,
	        isCollapsed: !action.shouldRenderSuggestions
	      });
	
	    case UPDATE_FOCUSED_SUGGESTION:
	      {
	        var sectionIndex = action.sectionIndex;
	        var suggestionIndex = action.suggestionIndex;
	        var value = action.value;
	        var valueBeforeUpDown = state.valueBeforeUpDown;
	
	
	        if (suggestionIndex === null) {
	          valueBeforeUpDown = null;
	        } else if (valueBeforeUpDown === null && typeof value !== 'undefined') {
	          valueBeforeUpDown = value;
	        }
	
	        return _extends({}, state, {
	          focusedSectionIndex: sectionIndex,
	          focusedSuggestionIndex: suggestionIndex,
	          valueBeforeUpDown: valueBeforeUpDown
	        });
	      }
	
	    case RESET_FOCUSED_SUGGESTION:
	      {
	        return _extends({}, state, {
	          focusedSectionIndex: null,
	          focusedSuggestionIndex: null,
	          valueBeforeUpDown: action.shouldResetValueBeforeUpDown ? null : state.valueBeforeUpDown
	        });
	      }
	
	    case REVEAL_SUGGESTIONS:
	      return _extends({}, state, {
	        isCollapsed: false
	      });
	
	    case CLOSE_SUGGESTIONS:
	      return _extends({}, state, {
	        focusedSectionIndex: null,
	        focusedSuggestionIndex: null,
	        valueBeforeUpDown: null,
	        isCollapsed: true
	      });
	
	    default:
	      return state;
	  }
	};
	
	exports.default = reducer;

/***/ },
/* 102 */
/***/ function(module, exports) {

	/*!
	 * Adapted from jQuery UI core
	 *
	 * http://jqueryui.com
	 *
	 * Copyright 2014 jQuery Foundation and other contributors
	 * Released under the MIT license.
	 * http://jquery.org/license
	 *
	 * http://api.jqueryui.com/category/ui-core/
	 */
	
	function focusable(element, isTabIndexNotNaN) {
	  var nodeName = element.nodeName.toLowerCase();
	  return (/input|select|textarea|button|object/.test(nodeName) ?
	    !element.disabled :
	    "a" === nodeName ?
	      element.href || isTabIndexNotNaN :
	      isTabIndexNotNaN) && visible(element);
	}
	
	function hidden(el) {
	  return (el.offsetWidth <= 0 && el.offsetHeight <= 0) ||
	    el.style.display === 'none';
	}
	
	function visible(element) {
	  while (element) {
	    if (element === document.body) break;
	    if (hidden(element)) return false;
	    element = element.parentNode;
	  }
	  return true;
	}
	
	function tabbable(element) {
	  var tabIndex = element.getAttribute('tabindex');
	  if (tabIndex === null) tabIndex = undefined;
	  var isTabIndexNaN = isNaN(tabIndex);
	  return (isTabIndexNaN || tabIndex >= 0) && focusable(element, !isTabIndexNaN);
	}
	
	function findTabbableDescendants(element) {
	  return [].slice.call(element.querySelectorAll('*'), 0).filter(function(el) {
	    return tabbable(el);
	  });
	}
	
	module.exports = findTabbableDescendants;
	


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseAssign = __webpack_require__(259),
	    createAssigner = __webpack_require__(262),
	    keys = __webpack_require__(100);
	
	/**
	 * A specialized version of `_.assign` for customizing assigned values without
	 * support for argument juggling, multiple sources, and `this` binding `customizer`
	 * functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 */
	function assignWith(object, source, customizer) {
	  var index = -1,
	      props = keys(source),
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key],
	        result = customizer(value, source[key], key, object, source);
	
	    if ((result === result ? (result !== value) : (value === value)) ||
	        (value === undefined && !(key in object))) {
	      object[key] = result;
	    }
	  }
	  return object;
	}
	
	/**
	 * Assigns own enumerable properties of source object(s) to the destination
	 * object. Subsequent sources overwrite property assignments of previous sources.
	 * If `customizer` is provided it is invoked to produce the assigned values.
	 * The `customizer` is bound to `thisArg` and invoked with five arguments:
	 * (objectValue, sourceValue, key, object, source).
	 *
	 * **Note:** This method mutates `object` and is based on
	 * [`Object.assign`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-object.assign).
	 *
	 * @static
	 * @memberOf _
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {*} [thisArg] The `this` binding of `customizer`.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * _.assign({ 'user': 'barney' }, { 'age': 40 }, { 'user': 'fred' });
	 * // => { 'user': 'fred', 'age': 40 }
	 *
	 * // using a customizer callback
	 * var defaults = _.partialRight(_.assign, function(value, other) {
	 *   return _.isUndefined(value) ? other : value;
	 * });
	 *
	 * defaults({ 'user': 'barney' }, { 'age': 36 }, { 'user': 'fred' });
	 * // => { 'user': 'barney', 'age': 36 }
	 */
	var assign = createAssigner(function(object, source, customizer) {
	  return customizer
	    ? assignWith(object, source, customizer)
	    : baseAssign(object, source);
	});
	
	module.exports = assign;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 105 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(19);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(25);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(11);
	
	var quoteAttributeValueForBrowser = __webpack_require__(356);
	var warning = __webpack_require__(6);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(19);
	var ReactElement = __webpack_require__(14);
	
	var emptyFunction = __webpack_require__(10);
	var traverseAllChildren = __webpack_require__(80);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var ReactComponent = __webpack_require__(65);
	var ReactElement = __webpack_require__(14);
	var ReactPropTypeLocations = __webpack_require__(71);
	var ReactPropTypeLocationNames = __webpack_require__(70);
	var ReactNoopUpdateQueue = __webpack_require__(69);
	
	var emptyObject = __webpack_require__(31);
	var invariant = __webpack_require__(2);
	var keyMirror = __webpack_require__(40);
	var keyOf = __webpack_require__(18);
	var warning = __webpack_require__(6);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    if (false) {
	      var typeofSpec = typeof spec;
	      var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
	    }
	
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 111 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var DisabledInputUtils = __webpack_require__(42);
	var LinkedValueUtils = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(15);
	
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 113 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 114 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactHostComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var invariant = __webpack_require__(2);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(317);
	
	var containsNode = __webpack_require__(241);
	var focusNode = __webpack_require__(97);
	var getActiveElement = __webpack_require__(98);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(24);
	var DOMProperty = __webpack_require__(25);
	var ReactBrowserEventEmitter = __webpack_require__(43);
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMContainerInfo = __webpack_require__(310);
	var ReactDOMFeatureFlags = __webpack_require__(313);
	var ReactElement = __webpack_require__(14);
	var ReactFeatureFlags = __webpack_require__(114);
	var ReactInstanceMap = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactMarkupChecksum = __webpack_require__(326);
	var ReactReconciler = __webpack_require__(26);
	var ReactUpdateQueue = __webpack_require__(73);
	var ReactUpdates = __webpack_require__(15);
	
	var emptyObject = __webpack_require__(31);
	var instantiateReactComponent = __webpack_require__(129);
	var invariant = __webpack_require__(2);
	var setInnerHTML = __webpack_require__(46);
	var shouldUpdateReactComponent = __webpack_require__(79);
	var warning = __webpack_require__(6);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(40);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactElement = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	var ReactPropTypeLocationNames = __webpack_require__(70);
	var ReactPropTypesSecret = __webpack_require__(72);
	
	var emptyFunction = __webpack_require__(10);
	var getIteratorFn = __webpack_require__(127);
	var warning = __webpack_require__(6);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	/**
	 * We use an Error-like object for backward compatibility as people may call
	 * PropTypes directly and inspect their output. However we don't use real
	 * Errors anymore. We don't inspect their stack anyway, and creating them
	 * is prohibitively expensive if they are created too often, such as what
	 * happens in oneOfType() for any type before the one that matched.
	 */
	function PropTypeError(message) {
	  this.message = message;
	  this.stack = '';
	}
	// Make `instanceof Error` still work for returned errors.
	PropTypeError.prototype = Error.prototype;
	
	function createChainableTypeChecker(validate) {
	  if (false) {
	    var manualPropTypeCallCache = {};
	  }
	  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (false) {
	      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
	        var cacheKey = componentName + ':' + propName;
	        if (!manualPropTypeCallCache[cacheKey]) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in the next major version. You may be ' + 'seeing this warning due to a third-party PropTypes library. ' + 'See https://fb.me/react-warning-dont-call-proptypes for details.', propFullName, componentName) : void 0;
	          manualPropTypeCallCache[cacheKey] = true;
	        }
	      }
	    }
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new PropTypeError('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName, secret) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    if (!ReactElement.isValidElement(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	    return emptyFunction.thatReturnsNull;
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 121 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.3.2';

/***/ },
/* 122 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 125 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getHostComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(119);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 127 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var ReactCompositeComponent = __webpack_require__(306);
	var ReactEmptyComponent = __webpack_require__(113);
	var ReactHostComponent = __webpack_require__(115);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? nextDebugID++ : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 130 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	var escapeTextContentForBrowser = __webpack_require__(45);
	var setInnerHTML = __webpack_require__(46);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 132 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  var rest = funcs.slice(0, -1);
	  return function () {
	    return rest.reduceRight(function (composed, f) {
	      return f(composed);
	    }, last.apply(undefined, arguments));
	  };
	}

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(55);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(387);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [preloadedState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(133);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(360);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(359);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(358);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(132);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(135);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 135 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(205);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./container.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./container.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(208);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./grid.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./grid.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(212);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./image.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./image.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(216);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./message.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./message.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(217);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./reset.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./reset.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(219);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./site.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./site.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @file Simple Tracking Pixel code. Add the URL you want to call, and the
	 * component is being drawn, nicely and invisibly.
	 *
	 * @author Kaspar Manz <kaspar.manz@tages-anzeiger.ch>
	 */
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TrackingPixel = function TrackingPixel(props) {
	  return _react2.default.createElement('img', {
	    src: props.url,
	    style: { position: 'absolute', visibility: 'hidden' },
	    width: '1',
	    height: '1'
	  });
	};
	
	TrackingPixel.propTypes = {
	  /**
	   * Source URL of the tracking pixel image to load.
	   */
	  url: _react2.default.PropTypes.string.isRequired
	};
	
	exports.default = TrackingPixel;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(12);
	
	__webpack_require__(383);
	
	__webpack_require__(82);
	
	__webpack_require__(136);
	
	__webpack_require__(139);
	
	__webpack_require__(137);
	
	__webpack_require__(83);
	
	__webpack_require__(384);
	
	__webpack_require__(138);
	
	__webpack_require__(379);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(364);
	
	// React
	
	
	// Semantic UI
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    var _this = _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).call(this));
	
	    _this.state = {
	      showOverlay: true
	    };
	
	    return _this;
	  }
	
	  _createClass(Footer, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'footer-wrapper', key: 'footer' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'ui secondary inverted very fitted vertical segment',
	            style: {
	              maxWidth: 'none',
	              background: 'rgba(0,0,0,0.9)'
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ui two column stackable inverted middle aligned centered vertically divided grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'column' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'ui very basic inverted table' },
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'top aligned' },
	                        _react2.default.createElement(
	                          'td',
	                          { scope: 'row' },
	                          'Text'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'ui list' },
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'item',
	                                style: { paddingTop: '2px' }
	                              },
	                              'Patrice Siegrist ',
	                              _react2.default.createElement(
	                                'a',
	                                { className: 'white-blue-link', href: 'https://twitter.com/pasiegrist', target: '_blank' },
	                                _react2.default.createElement('i', { className: 'twitter icon' })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'top aligned' },
	                        _react2.default.createElement(
	                          'td',
	                          { scope: 'row' },
	                          'Programmierung'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'ui list' },
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'item',
	                                style: { paddingTop: '2px' }
	                              },
	                              'Marc Fehr ',
	                              _react2.default.createElement(
	                                'a',
	                                { className: 'white-blue-link', href: 'https://twitter.com/mrcfhr', target: '_blank' },
	                                _react2.default.createElement('i', { className: 'twitter icon' })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'top aligned' },
	                        _react2.default.createElement(
	                          'td',
	                          { scope: 'row' },
	                          'Fotografien'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'ui list' },
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'item',
	                                style: { paddingTop: '2px' }
	                              },
	                              'Sabina Bobst '
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'top aligned' },
	                        _react2.default.createElement(
	                          'td',
	                          { scope: 'row' },
	                          'Video'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'ui list' },
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'item',
	                                style: { paddingTop: '2px' }
	                              },
	                              'Patrice Siegrist ',
	                              _react2.default.createElement(
	                                'a',
	                                { className: 'white-blue-link', href: 'https://twitter.com/pasiegrist', target: '_blank' },
	                                _react2.default.createElement('i', { className: 'twitter icon' })
	                              )
	                            )
	                          )
	                        )
	                      ),
	                      _react2.default.createElement(
	                        'tr',
	                        { className: 'top aligned' },
	                        _react2.default.createElement(
	                          'td',
	                          { scope: 'row' },
	                          'Datengrundlage'
	                        ),
	                        _react2.default.createElement(
	                          'td',
	                          null,
	                          _react2.default.createElement(
	                            'div',
	                            { className: 'ui list' },
	                            _react2.default.createElement(
	                              'div',
	                              {
	                                className: 'item white-blue-link',
	                                style: { paddingTop: '2px' }
	                              },
	                              _react2.default.createElement(
	                                'a',
	                                { style: { color: 'white' }, href: 'https://www.stadt-zuerich.ch/prd/de/index/statistik.html', target: '_blank' },
	                                'Statistik Stadt Z\xFCrich ',
	                                _react2.default.createElement('i', { className: 'external icon white-blue-link' })
	                              ),
	                              _react2.default.createElement('br', null),
	                              _react2.default.createElement(
	                                'a',
	                                { style: { color: 'white' }, href: 'https://www.wuestpartner.com/', target: '_blank' },
	                                'W\xFCest Partner ',
	                                _react2.default.createElement('i', { className: 'external icon white-blue-link' })
	                              ),
	                              _react2.default.createElement(
	                                'a',
	                                {
	                                  style: { color: 'white' }, href: 'https://data.stadt-zuerich.ch/', target: '_blank' },
	                                _react2.default.createElement('br', null),
	                                'Open Data Z\xFCrich ',
	                                _react2.default.createElement('i', { className: 'external icon white-blue-link' })
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              ),
	              this.state.showOverlay && _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'column' },
	                  _react2.default.createElement(
	                    'h3',
	                    {
	                      style: {
	                        fontFamily: 'Benton Sans Cond',
	                        fontWeight: 'bold'
	                      }
	                    },
	                    _react2.default.createElement('i', { className: 'bar chart icon' }),
	                    ' Weitere Infos zu den Daten'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Sofern nicht anders ausgewiesen, wurden die Daten f\xFCr diesen Artikel von Statistik Stadt Z\xFCrich verwendet. Mittel- und Durchschnittswerte beziehen sich auf den Median. Die Steuerdaten gibt Statistik Stadt Z\xFCrich nur bis 2014 heraus. Das sind somit die aktuellsten Daten. Selbst f\xFCr 2014 gibt es noch eine gewisse Unsch\xE4rfe. Das definitive steuerbare Einkommen liegt erst f\xFCr 86,7 Prozent der Steuerpflichtigen vor. Die Interpretation der Steuerdaten im Stadtkreis 1 ist schwierig. Dort enthalten sind auch Personen ohne eigene Wohnmeldeadresse, aber mit Wohnsitz in der Stadt Z\xFCrich (zum Beispiel Gef\xE4ngnisinsassen oder Personen in Heimen und Anstalten ausserhalb der Stadt Z\xFCrich).'
	                  ),
	                  _react2.default.createElement(
	                    'p',
	                    null,
	                    'Das statistische Quartier ',
	                    _react2.default.createElement(
	                      'strong',
	                      null,
	                      'Alt-Wiedikon'
	                    ),
	                    ' wurde aus programmiertechnischen Gr\xFCnden von uns in Wiedikon umbenannt.'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'row', style: { borderTop: 'none' } },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'column', style: { border: 'none' } },
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'ui icon message' },
	                    _react2.default.createElement('i', { className: 'comments icon' }),
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'content', style: { textAlign: 'left', lineHeight: '25px' } },
	                      _react2.default.createElement(
	                        'div',
	                        { className: 'header' },
	                        ' Haben Sie Anmerkungen oder einen Fehler entdeckt?'
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        null,
	                        'Wir freuen uns \xFCber Ihre ',
	                        _react2.default.createElement(
	                          'a',
	                          { className: 'orange-link', href: 'mailto:interaktiv@tages-anzeiger.ch' },
	                          'Nachricht'
	                        ),
	                        '.'
	                      )
	                    )
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: 'ui tertiary inverted vertical center aligned very fitted basic segment' },
	                    _react2.default.createElement('img', { src: '//interaktiv.tagesanzeiger.ch/static/icons/logo-ta-icon-inverted.svg', alt: '', className: 'ui mini middle aligned right spaced image' }),
	                    _react2.default.createElement(
	                      'small',
	                      null,
	                      '\xA9 2016 Tages-Anzeiger'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'ui vertical segment ta footer shadowed',
	            style: {
	              margin: '0 auto',
	              marginBottom: '15px',
	              paddingTop: '43px'
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui container' },
	            _react2.default.createElement(
	              'div',
	              { className: 'ui one column doubling stackable divided grid' },
	              _react2.default.createElement(
	                'div',
	                { className: 'center aligned column' },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'ui vertical labeled icon buttons' },
	                  _react2.default.createElement(
	                    'a',
	                    { href: 'https://www.facebook.com/sharer/sharer.php?u=' + this.props.shareUrl, target: '_blank', className: 'white-link ui facebook button fb-share' },
	                    _react2.default.createElement('i', { className: 'facebook icon', target: '_blank' }),
	                    'Auf Facebook teilen'
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { target: '_blank', href: 'https://twitter.com/intent/tweet?text=' + this.props.twitterShareText, className: 'white-link ui twitter button twitter-share' },
	                    _react2.default.createElement('i', { className: 'twitter icon', target: '_blank' }),
	                    'Auf Twitter teilen'
	                  ),
	                  '                '
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Footer;
	}(_react.Component);
	
	exports.default = Footer;
	
	
	Footer.propTypes = _defineProperty({
	  handler: _react2.default.PropTypes.func,
	  shareUrl: _react2.default.PropTypes.string,
	  twitterShareText: _react2.default.PropTypes.string
	}, 'handler', _react2.default.PropTypes.func);

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAutosuggest = __webpack_require__(273);
	
	var _reactAutosuggest2 = _interopRequireDefault(_reactAutosuggest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(13);
	__webpack_require__(12);
	__webpack_require__(380);
	__webpack_require__(139);
	__webpack_require__(378);
	
	__webpack_require__(365);
	__webpack_require__(385);
	
	var cityQuarters = __webpack_require__(254);
	var quarterList = __webpack_require__(255);
	
	// Teach Autosuggest how to calculate suggestions for any given input value.
	var getSuggestions = function getSuggestions(value) {
	  var inputValue = value.trim().toLowerCase();
	  var inputLength = inputValue.length;
	
	  return inputLength === 0 ? [] : cityQuarters.filter(function (lang) {
	    return lang.name.toLowerCase().slice(0, inputLength) === inputValue;
	  });
	};
	
	// When suggestion is clicked, Autosuggest needs to populate the input element
	// based on the clicked suggestion. Teach Autosuggest how to calculate the
	// input value for every given suggestion.
	var getSuggestionValue = function getSuggestionValue(suggestion) {
	  return suggestion.name + ' (' + suggestion.circle + ')';
	};
	
	// Use your imagination to render suggestions.
	var renderSuggestion = function renderSuggestion(suggestion) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    suggestion.name + ' (' + suggestion.circle + ')'
	  );
	};
	
	var Identificator = function (_React$Component) {
	  _inherits(Identificator, _React$Component);
	
	  function Identificator(props) {
	    _classCallCheck(this, Identificator);
	
	    var _this = _possibleConstructorReturn(this, (Identificator.__proto__ || Object.getPrototypeOf(Identificator)).call(this, props));
	
	    _this.onChange = function (event, _ref) {
	      var newValue = _ref.newValue;
	
	      _this.setState({
	        value: newValue
	      });
	    };
	
	    _this.toggleList = function (e) {
	      _this.setState({
	        showQuarterList: !_this.state.showQuarterList
	      });
	    };
	
	    _this.onSuggestionSelected = function (event, _ref2) {
	      var suggestion = _ref2.suggestion;
	
	
	      _this.setState({
	        selectedQuarter: suggestion,
	        readerMadeHisChoice: true
	      });
	
	      // console.log(suggestion)
	
	      _this.props.clickHandler(suggestion, true, true);
	    };
	
	    _this.onSuggestionsFetchRequested = function (_ref3) {
	      var value = _ref3.value;
	
	      _this.setState({
	        suggestions: getSuggestions(value)
	      });
	    };
	
	    _this.onSuggestionsClearRequested = function () {
	      _this.setState({
	        suggestions: []
	      });
	      // this.props.clickHandler(this.state.value,true,true)
	    };
	
	    _this.resetSelection = function () {
	      _this.setState({
	        selectedQuarter: '',
	        value: '',
	        showQuarterList: false
	      });
	      // suggestion => suggestion.name + ' (' + suggestion.circle + ')';
	      _this.props.clickHandler('', true, false);
	    };
	
	    _this.toggleList = _this.toggleList.bind(_this);
	    _this.selectedOnList = _this.selectedOnList.bind(_this);
	
	    _this.state = {
	      quarterList: quarterList,
	      showMessageIfNotCitizen: false,
	      isLoading: false,
	      suggestions: [],
	      value: '',
	      selectedQuarter: '',
	      showQuarterList: false
	    };
	    return _this;
	  }
	
	  _createClass(Identificator, [{
	    key: 'selectedOnList',
	    value: function selectedOnList(quarter, circle) {
	
	      var suggestion = {
	        circle: 'Kreis ' + circle,
	        name: quarter
	      };
	
	      // console.log(suggestion);
	
	      this.setState({
	        selectedQuarter: suggestion,
	        showQuarterList: true
	      });
	
	      window.scrollTo(0, window.innerHeight);
	
	      // console.log(window.innerHeight+'px')
	
	      this.props.clickHandler(suggestion, true, true);
	    }
	
	    // Autosuggest will call this function every time you need to update suggestions.
	    // You already implemented this logic above, so just use it.
	
	
	    // Autosuggest will call this function every time you need to clear suggestions.
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          value = _state.value,
	          suggestions = _state.suggestions;
	
	      // Autosuggest will pass through all these props to the input element.
	
	      var inputProps = {
	        placeholder: 'Suchen Sie Ihr Stadtquartier..',
	        value: value,
	        onChange: this.onChange,
	        type: 'search'
	      };
	
	      var appendTableRow = function appendTableRow(v, i) {
	        // console.log(v)
	
	        var quarter = v.quarterId;
	        var circle = v.circle;
	
	        return _react2.default.createElement(
	          'tr',
	          {
	            className: 'hover-table',
	            onClick: function onClick() {
	              return _this2.selectedOnList(quarter, circle);
	            },
	            'data-id': v.quarterId
	          },
	          _react2.default.createElement(
	            'td',
	            null,
	            'Kreis ',
	            v.circle
	          ),
	          _react2.default.createElement(
	            'td',
	            null,
	            v.quarterName
	          )
	        );
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'identificator wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ui vertical very fitted segment text-center' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui message identificator' },
	            _react2.default.createElement(
	              'p',
	              { className: 'identificator question title' },
	              'Wohnen Sie in der Stadt Z\xFCrich?'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'ui green basic large button ' + (this.props.readerIsCityCitizen ? 'active' : ''),
	                onClick: function onClick() {
	                  return _this2.props.clickHandler('', true, _this2.state.selectedQuarter ? true : false);
	                }
	              },
	              'Ja'
	            ),
	            _react2.default.createElement(
	              'button',
	              {
	                className: 'ui red basic large button ' + (!this.props.readerIsCityCitizen && this.props.readerMadeHisChoice ? 'active' : ''),
	                onClick: function onClick() {
	                  return _this2.props.clickHandler('', false, true);
	                }
	              },
	              'Nein'
	            ),
	            !this.props.readerIsCityCitizen && this.props.readerMadeHisChoice && _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'i',
	                { className: 'icon info circle' },
	                ' '
	              ),
	              ' Sie sehen eine allgemeine Version des Textes. Einzig einige Daten auf Quartierniveau werden im Text nicht eingeblendet.'
	            ),
	            this.props.readerIsCityCitizen && _react2.default.createElement(
	              'div',
	              null,
	              this.props.readerMadeHisChoice == false && _react2.default.createElement(
	                'p',
	                {
	                  className: 'search-label',
	                  style: {
	                    fontSize: '0.9em',
	                    color: 'grey'
	                  }
	                },
	                _react2.default.createElement(
	                  'span',
	                  { style: {
	                      fontSize: '1.2em',
	                      color: 'black'
	                    } },
	                  'In welchem ',
	                  _react2.default.createElement(
	                    'strong',
	                    null,
	                    'Stadtquartier'
	                  ),
	                  ' wohnen Sie?'
	                ),
	                _react2.default.createElement('br', null),
	                'Keine PLZ eingeben. ',
	                _react2.default.createElement(
	                  'a',
	                  {
	                    href: 'https://de.wikipedia.org/wiki/Stadtteile_der_Stadt_Z%C3%BCrich#Statistische_Quartiere_und_Zonen',
	                    target: '_blank' },
	                  'Hier gehts zur Definition der Statistischen Quartiere der Stadt Z\xFCrich'
	                )
	              ),
	              this.props.readerMadeHisChoice == true && _react2.default.createElement('br', null),
	              _react2.default.createElement(
	                'div',
	                { className: 'ui large icon input' },
	                this.state.selectedQuarter == '' && _react2.default.createElement(_reactAutosuggest2.default, {
	                  suggestions: suggestions,
	                  onSuggestionsFetchRequested: this.onSuggestionsFetchRequested,
	                  onSuggestionsClearRequested: this.onSuggestionsClearRequested,
	                  getSuggestionValue: getSuggestionValue,
	                  renderSuggestion: renderSuggestion,
	                  inputProps: inputProps,
	                  onSuggestionSelected: this.onSuggestionSelected,
	                  focusFirstSuggestion: true
	                })
	              ),
	              this.state.selectedQuarter == '' && _react2.default.createElement(
	                'div',
	                {
	                  className: 'ui styled accordion'
	                },
	                _react2.default.createElement(
	                  'div',
	                  {
	                    onClick: this.toggleList,
	                    className: 'title',
	                    style: {
	                      fontFamily: 'Benton Sans Cond',
	                      marginTop: '10px'
	                    }
	                  },
	                  _react2.default.createElement('i', { className: 'caret icon ' + (this.state.showQuarterList ? 'down' : 'right') }),
	                  'Liste aller Stadtquartiere'
	                ),
	                this.state.showQuarterList == true && _react2.default.createElement(
	                  'div',
	                  { className: 'quarterlist-content' },
	                  _react2.default.createElement(
	                    'table',
	                    { className: 'ui fixed single line celled selectable very compact table' },
	                    _react2.default.createElement(
	                      'thead',
	                      null,
	                      _react2.default.createElement(
	                        'tr',
	                        null,
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Kreis'
	                        ),
	                        _react2.default.createElement(
	                          'th',
	                          null,
	                          'Statistisches Quartier'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(
	                      'tbody',
	                      null,
	                      this.state.quarterList.map(appendTableRow)
	                    )
	                  )
	                )
	              ),
	              this.state.selectedQuarter && _react2.default.createElement(
	                'div',
	                { className: 'selection reset box' },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'bentonLight',
	                      style: { fontSize: '0.9em' }
	                    },
	                    'Sie wohnen im Quartier '
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    {
	                      className: 'bentonFat'
	                    },
	                    this.state.selectedQuarter.name
	                  ),
	                  _react2.default.createElement('i', {
	                    className: 'icon remove red',
	                    onClick: this.resetSelection
	                  })
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Identificator;
	}(_react2.default.Component);
	
	Identificator.defaultProps = {};
	
	Identificator.propTypes = {
	  readerIsCityCitizen: _react2.default.PropTypes.bool,
	  clickHandler: _react2.default.PropTypes.func,
	  readerMadeHisChoice: _react2.default.PropTypes.bool,
	  onSuggestionSelected: _react2.default.PropTypes.func,
	  changeChosenQuarter: _react2.default.PropTypes.func
	};
	
	exports.default = Identificator;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(84);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _d3TimeFormat = __webpack_require__(30);
	
	var _d3Scale = __webpack_require__(28);
	
	var _d3Shape = __webpack_require__(39);
	
	var _d3Array = __webpack_require__(22);
	
	var _d3Selection = __webpack_require__(29);
	
	var _d3Axis = __webpack_require__(38);
	
	var _d3Format = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(13);
	__webpack_require__(12);
	__webpack_require__(21);
	__webpack_require__(366);
	// import ReactDOM from 'react-dom';
	// import d3 from 'd3';
	
	// import {interpolate} from 'd3-interpolate';
	// import {keys, nest} from 'd3-collection';
	
	var localeDefinition = __webpack_require__(53);
	
	/************************************************************************/
	
	var Linechart = function (_React$Component) {
	  _inherits(Linechart, _React$Component);
	
	  function Linechart(props) {
	    _classCallCheck(this, Linechart);
	
	    var _this = _possibleConstructorReturn(this, (Linechart.__proto__ || Object.getPrototypeOf(Linechart)).call(this, props));
	
	    _this.state = {
	      width: _this.props.width,
	      showTooltip: false,
	      tooltipAbsoluteCount: '',
	      percentage: 0
	    };
	
	    _this.mouseEntersDot = _this.mouseEntersDot.bind(_this);
	    _this.mouseLeavesDot = _this.mouseLeavesDot.bind(_this);
	    _this.touchStart = _this.touchStart.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(Linechart, [{
	    key: 'touchStart',
	    value: function touchStart(e) {
	
	      var count = e.target.getAttribute('data-count');
	      var absolute = e.target.getAttribute('data-absolute');
	      var year = e.target.getAttribute('data-year');
	      var title = e.target.getAttribute('data-title');
	      var percentage = e.target.getAttribute('data-percentage');
	
	      // show tooltip here
	      this.setState({
	        showTooltip: true,
	        tooltipX: e.target.getAttribute('cx'),
	        tooltipY: e.target.getAttribute('cy'),
	        tooltipTitle: year,
	        tooltipCount: count,
	        tooltipAbsoluteCount: absolute,
	        percentage: percentage
	      });
	    }
	  }, {
	    key: 'mouseEntersDot',
	    value: function mouseEntersDot(e) {
	
	      // DESKTOP AND TOUCH DEVICE SWITCH
	      if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
	        return;
	      } else {
	
	        var count = e.target.getAttribute('data-count');
	        var absolute = e.target.getAttribute('data-absolute');
	        var year = e.target.getAttribute('data-year');
	        var title = e.target.getAttribute('data-title');
	        var percentage = e.target.getAttribute('data-percentage');
	
	        // show tooltip here
	        this.setState({
	          showTooltip: true,
	          tooltipX: e.target.getAttribute('cx'),
	          tooltipY: e.target.getAttribute('cy'),
	          tooltipTitle: year,
	          tooltipCount: count,
	          tooltipAbsoluteCount: absolute,
	          percentage: percentage
	        });
	      }
	    }
	  }, {
	    key: 'mouseLeavesDot',
	    value: function mouseLeavesDot() {
	      // hide tooltip here
	      this.setState({
	        showTooltip: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var data = this.props.dataSource;
	
	      // to keep 'this' alive in the data.map function below
	      var _self = this;
	
	      var margin = { top: 15, right: 20, bottom: 20, left: 35 },
	          w = this.props.width - (margin.left + margin.right),
	          h = this.props.height - (margin.top + margin.bottom),
	          r = this.props.circleRadius;
	
	      if (this.props.width != 160) {
	        w = this.props.width + 10 - (margin.left + margin.right);
	        r = this.props.circleRadius * 1.5;
	      }
	
	      var parseDate = (0, _d3TimeFormat.timeParse)('%m-%d-%Y');
	      var parseYear = (0, _d3TimeFormat.timeFormat)('%Y');
	
	      var locale = (0, _d3Format.formatDefaultLocale)(localeDefinition);
	      var percentageFormat = locale.format('');
	
	      data.forEach(function (d) {
	        d.date = parseDate(d.day);
	        d.year = parseYear(d.date);
	      });
	
	      // AXIS SETUP
	      var x = (0, _d3Scale.scaleTime)().domain((0, _d3Array.extent)(data, function (d) {
	        return d.date;
	      })).rangeRound([0, w]);
	
	      var y = (0, _d3Scale.scaleLinear)().domain([this.props.minY, this.props.maxY]).range([h, 0]);
	
	      var formatPercent = (0, _d3Format.format)(',.0%');
	
	      var axisBottom = (0, _d3Axis.axisBottom)(x).ticks(this.props.ticksY).tickSize(4).tickFormat((0, _d3TimeFormat.timeFormat)(this.props.tickFormatX));
	
	      var axisLeft = (0, _d3Axis.axisLeft)(y).ticks(this.props.ticksX).tickSize(4).tickFormat(function (d) {
	        return parseInt(d, 10) + "%";
	      });
	      ;
	
	      // DRAW LINE IN CSV
	
	      var drawLine = (0, _d3Shape.line)().x(function (d) {
	        return x(d.date);
	      }).y(function (d) {
	        return y(d.count);
	      }).curve(_d3Shape.curveCatmullRom.alpha(0.5));
	
	      var transform = 'translate(' + margin.left + ',' + margin.top + ')';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment padded linechart ' + this.props.chartClassName
	        },
	        _react2.default.createElement('div', {
	          className: 'ui inverted simple dimmer'
	        }),
	        this.props.chartTitle != '' && _react2.default.createElement(
	          'p',
	          {
	            className: 'diagram title small'
	          },
	          this.props.chartTitle
	        ),
	        _react2.default.createElement(
	          'svg',
	          {
	            id: 'svg-' + this.props.chartId,
	            width: this.props.width + 10,
	            height: this.props.height
	          },
	          _react2.default.createElement(
	            'g',
	            {
	              transform: transform
	            },
	            _react2.default.createElement(
	              'g',
	              { className: 'axes',
	                transform: 'translate(0,0)' },
	              _react2.default.createElement('g', { className: 'axis-bottom',
	                ref: function ref(el) {
	                  return axisBottom((0, _d3Selection.select)(el));
	                },
	                transform: 'translate(0,' + h + ')' }),
	              _react2.default.createElement('g', { className: 'axis-left',
	                ref: function ref(el) {
	                  return axisLeft((0, _d3Selection.select)(el));
	                },
	                transform: 'translate(0,0)'
	              })
	            ),
	            _react2.default.createElement('path', {
	              className: 'line shadow',
	              d: drawLine(data), strokeLinecap: 'round'
	            }),
	            'const _self = this; // TODO Possibly error with direct attributes like strokeWidth when compiling in DIST // TODO Append transparent rect over circle for mouseover event trigger',
	            data.map(function (d, i) {
	              return _react2.default.createElement('circle', {
	                className: 'dot',
	                r: r,
	                cx: x(d.date),
	                cy: y(d.count),
	                fill: _self.props.circleFill,
	                stroke: _self.props.circleStrokeFill,
	                strokeWidth: _self.props.circleStroke,
	                key: i,
	                onMouseEnter: _self.mouseEntersDot,
	                onMouseLeave: _self.mouseLeavesDot,
	                onTouchStart: _self.touchStart,
	                'data-count': d.count,
	                'data-absolute': d.absolute,
	                'data-year': d.year,
	                'data-title': d.title,
	                'data-percentage': d.percentage
	              });
	            }),
	            this.state.showTooltip == true && _react2.default.createElement(_Tooltip2.default, {
	              tooltipPosX: parseFloat(this.state.tooltipX),
	              tooltipPosY: parseFloat(this.state.tooltipY),
	              tooltipWidth: this.props.tooltipWidth,
	              tooltipHeight: this.props.tooltipHeight,
	              chartWidth: this.props.width,
	              chartHeight: this.props.height,
	              tooltipClassName: 'tooltip',
	              tooltipBackground: '#000000',
	              tooltipColor: '#ffffff',
	              tooltipTitle: this.state.tooltipTitle,
	              tooltipCount: this.state.tooltipCount,
	              tooltipSize: this.props.linechartClass,
	              tooltipFontSize: this.props.tooltipFontSize,
	              tooltipPrefix: this.props.chartClassName == 'small' ? 'Jahr ' : 'Jahr ',
	              tooltipSuffix: this.props.chartClassName == 'small' ? ' ' : ':',
	              tooltipCountSuffix: this.props.chartClassName == 'small' ? '' : ' Prozent',
	              tooltipCountPrefix: this.props.chartClassName == 'small' ? 'Total: ' : '',
	              tooltipCountAbsolutePrefix: this.props.chartClassName == 'small' ? 'Anteil: ' : '',
	              tooltipCountAbsoluteSuffix: this.props.chartClassName == 'small' ? '%' : '',
	              tooltipCountAbsolute: this.state.tooltipAbsoluteCount,
	              tooltipCountPercentage: this.state.percentage
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Linechart;
	}(_react2.default.Component);
	
	Linechart.propTypes = {
	  chartTitle: _react2.default.PropTypes.string,
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number,
	  chartId: _react2.default.PropTypes.string,
	  chartClassName: _react2.default.PropTypes.string,
	  linechartClass: _react2.default.PropTypes.string,
	  readerMadeHisChoice: _react2.default.PropTypes.bool,
	  circleFill: _react2.default.PropTypes.string,
	  maxY: _react2.default.PropTypes.number,
	  minY: _react2.default.PropTypes.number,
	  circleRadius: _react2.default.PropTypes.number,
	  circleStroke: _react2.default.PropTypes.number,
	  circleStrokeFill: _react2.default.PropTypes.string,
	  ticksX: _react2.default.PropTypes.number,
	  ticksY: _react2.default.PropTypes.number,
	  tickFormatX: _react2.default.PropTypes.string,
	  tickFormatY: _react2.default.PropTypes.string,
	  x: _react2.default.PropTypes.func,
	  y: _react2.default.PropTypes.func,
	  tooltipWidth: _react2.default.PropTypes.number,
	  tooltipHeight: _react2.default.PropTypes.number,
	  tooltipFontSize: _react2.default.PropTypes.number,
	  dataSource: _react2.default.PropTypes.array,
	  chartMargin: _react2.default.PropTypes.array
	};
	
	exports.default = Linechart;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Tooltip = __webpack_require__(84);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _d3TimeFormat = __webpack_require__(30);
	
	var _d3Scale = __webpack_require__(28);
	
	var _d3Shape = __webpack_require__(39);
	
	var _d3Array = __webpack_require__(22);
	
	var _d3Selection = __webpack_require__(29);
	
	var _d3Axis = __webpack_require__(38);
	
	var _d3Format = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(13);
	__webpack_require__(12);
	__webpack_require__(21);
	__webpack_require__(367);
	// import ReactDOM from 'react-dom';
	// import d3 from 'd3';
	
	// import {interpolate} from 'd3-interpolate';
	// import {keys, nest} from 'd3-collection';
	
	var localeDefinition = __webpack_require__(53);
	
	/************************************************************************/
	
	var LinechartMultiple = function (_React$Component) {
	  _inherits(LinechartMultiple, _React$Component);
	
	  function LinechartMultiple(props) {
	    _classCallCheck(this, LinechartMultiple);
	
	    var _this = _possibleConstructorReturn(this, (LinechartMultiple.__proto__ || Object.getPrototypeOf(LinechartMultiple)).call(this, props));
	
	    _this.mouseEntersDot = _this.mouseEntersDot.bind(_this);
	    _this.mouseLeavesDot = _this.mouseLeavesDot.bind(_this);
	    _this.touchStart = _this.touchStart.bind(_this);
	
	    _this.state = {
	      width: _this.props.width,
	      height: _this.props.height,
	      showTooltip: false
	    };
	
	    return _this;
	  }
	
	  _createClass(LinechartMultiple, [{
	    key: 'touchStart',
	    value: function touchStart(e) {
	
	      // console.log(e.target.getAttribute('cx'));
	
	      var count = e.target.getAttribute('data-count');
	      var year = e.target.getAttribute('data-year');
	      var title = e.target.getAttribute('data-title');
	
	      // show tooltip here
	      this.setState({
	        showTooltip: true,
	        tooltipX: e.target.getAttribute('cx'),
	        tooltipY: e.target.getAttribute('cy'),
	        tooltipTitle: year,
	        tooltipCount: count
	      });
	    }
	  }, {
	    key: 'mouseEntersDot',
	    value: function mouseEntersDot(e) {
	
	      // DESKTOP AND TOUCH DEVICE SWITCH
	      if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
	        return;
	      } else {
	
	        var count = e.target.getAttribute('data-count');
	        var year = e.target.getAttribute('data-year');
	        var title = e.target.getAttribute('data-title');
	
	        // show tooltip here
	        this.setState({
	          showTooltip: true,
	          tooltipX: e.target.getAttribute('cx'),
	          tooltipY: e.target.getAttribute('cy'),
	          tooltipTitle: year,
	          tooltipCount: count
	        });
	      }
	    }
	  }, {
	    key: 'mouseLeavesDot',
	    value: function mouseLeavesDot() {
	      // hide tooltip here
	      this.setState({
	        showTooltip: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      var dataSet = {
	        p25: [],
	        p50: [],
	        p75: []
	      };
	
	      for (var i = 0; i < this.props.dataSource.length; i++) {
	        dataSet.p25.push({ year: this.props.dataSource[i].year, count: this.props.dataSource[i].p25 });
	        dataSet.p50.push({ year: this.props.dataSource[i].year, count: this.props.dataSource[i].p50 });
	        dataSet.p75.push({ year: this.props.dataSource[i].year, count: this.props.dataSource[i].p75 });
	      }
	
	      var data = dataSet;
	
	      // to keep 'this' alive in the data.map function below
	      var _self = this;
	
	      var margin = { top: 15, right: 20, bottom: 20, left: 35 };
	      var w = this.props.width - margin.left - 2 * margin.right;
	      var h = this.props.width > 479 ? this.props.height - (margin.top + margin.bottom) : this.props.height / 2 - (margin.top + margin.bottom),
	          r = this.props.circleRadius;
	
	      if (this.state.width < 500) {
	        r = this.props.circleRadius * 1.2;
	      }
	
	      var locale = (0, _d3Format.formatDefaultLocale)(localeDefinition);
	
	      data.p25.forEach(function (d) {
	        d.yearTick = d.year.toString();
	      });
	      data.p50.forEach(function (d) {
	        d.yearTick = d.year.toString();
	      });
	      data.p75.forEach(function (d) {
	        d.yearTick = d.year.toString();
	      });
	
	      // console.log(data);
	
	      // AXIS SETUP
	      var x = (0, _d3Scale.scaleTime)().domain((0, _d3Array.extent)([1999, 2014])).rangeRound([0, w]);
	
	      var y = (0, _d3Scale.scaleLinear)().domain([this.props.minY, this.props.maxY]).range([h, 0]);
	
	      var axisBottom = (0, _d3Axis.axisBottom)(x).ticks(this.props.ticksX).tickSize(4).tickFormat((0, _d3Format.format)(".0f"));
	      ;
	
	      var axisLeft = (0, _d3Axis.axisLeft)(y).ticks(this.props.ticksY).tickSize(4).tickFormat(function (d) {
	        return parseInt(d, 10) + "%";
	      });
	      ;
	
	      // DRAW LINE IN CSV
	
	      var drawLine = (0, _d3Shape.line)().x(function (d) {
	        return x(d.year);
	      }).y(function (d) {
	        return y(d.count);
	      }).curve(_d3Shape.curveCatmullRom.alpha(0.5));
	
	      var transform = 'translate(' + margin.left + ',' + margin.top + ')';
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment padded linechart ' + this.props.chartClassName
	        },
	        _react2.default.createElement('div', {
	          className: 'ui inverted simple dimmer'
	        }),
	        _react2.default.createElement(
	          'svg',
	          {
	            id: 'svg-' + this.props.chartId,
	            height: this.props.width > 479 ? this.props.height : this.props.height / 2,
	            width: this.props.width - 20
	          },
	          _react2.default.createElement(
	            'g',
	            {
	              transform: transform
	            },
	            _react2.default.createElement(
	              'g',
	              { className: 'axes',
	                transform: 'translate(0,0)' },
	              _react2.default.createElement('g', { className: 'axis-bottom',
	                ref: function ref(el) {
	                  return axisBottom((0, _d3Selection.select)(el));
	                },
	                transform: 'translate(0,' + h + ')' }),
	              _react2.default.createElement('g', { className: 'axis-left',
	                ref: function ref(el) {
	                  return axisLeft((0, _d3Selection.select)(el));
	                },
	                transform: 'translate(0,0)'
	              })
	            ),
	            _react2.default.createElement('path', {
	              className: 'line shadow p25',
	              d: drawLine(data.p25), strokeLinecap: 'round'
	            }),
	            _react2.default.createElement('path', {
	              className: 'line shadow p50',
	              d: drawLine(data.p50), strokeLinecap: 'round'
	            }),
	            _react2.default.createElement('path', {
	              className: 'line shadow p75',
	              d: drawLine(data.p75), strokeLinecap: 'round'
	            }),
	            'const _self = this; // TODO Possibly error with direct attributes like strokeWidth when compiling in DIST // TODO Append transparent rect over circle for mouseover event trigger',
	            data.p25.map(function (d, i) {
	              return _react2.default.createElement('circle', {
	                className: 'dot',
	                r: r,
	                cx: x(d.year),
	                cy: y(d.count),
	                fill: '#E23C4E',
	                stroke: _self.props.circleStrokeFill,
	                strokeWidth: _self.props.circleStroke,
	                key: i,
	                onMouseEnter: _self.mouseEntersDot,
	                onMouseLeave: _self.mouseLeavesDot,
	                onTouchStart: _self.touchStart,
	                'data-count': Math.round(d.count * 10) / 10,
	                'data-year': d.year,
	                'data-title': d.count
	              });
	            }),
	            data.p50.map(function (d, i) {
	              return _react2.default.createElement('circle', {
	                className: 'dot',
	                r: r,
	                cx: x(d.year),
	                cy: y(d.count),
	                fill: '#1D5F82',
	                stroke: _self.props.circleStrokeFill,
	                strokeWidth: _self.props.circleStroke,
	                key: i,
	                onMouseEnter: _self.mouseEntersDot,
	                onMouseLeave: _self.mouseLeavesDot,
	                onTouchStart: _self.touchStart,
	                'data-count': Math.round(d.count * 10) / 10,
	                'data-year': d.year,
	                'data-title': d.count
	              });
	            }),
	            data.p75.map(function (d, i) {
	              return _react2.default.createElement('circle', {
	                className: 'dot',
	                r: r,
	                cx: x(d.year),
	                cy: y(d.count),
	                fill: 'black',
	                stroke: _self.props.circleStrokeFill,
	                strokeWidth: _self.props.circleStroke,
	                key: i,
	                onMouseEnter: _self.mouseEntersDot,
	                onMouseLeave: _self.mouseLeavesDot,
	                onTouchStart: _self.touchStart,
	                'data-count': Math.round(d.count * 10) / 10,
	                'data-year': d.year,
	                'data-title': d.count
	              });
	            }),
	            this.state.showTooltip == true && _react2.default.createElement(_Tooltip2.default, {
	              tooltipPosX: parseFloat(this.state.tooltipX),
	              tooltipPosY: parseFloat(this.state.tooltipY),
	              tooltipWidth: this.props.tooltipWidth,
	              tooltipHeight: this.props.tooltipHeight,
	              chartWidth: this.props.width - margin.left - margin.right,
	              chartHeight: this.props.height,
	              tooltipClassName: 'tooltip',
	              tooltipBackground: '#000000',
	              tooltipColor: '#ffffff',
	              tooltipTitle: this.state.tooltipTitle,
	              tooltipCount: this.state.tooltipCount,
	              tooltipSize: this.props.linechartClass,
	              tooltipFontSize: this.props.tooltipFontSize,
	              tooltipPrefix: this.props.chartClassName == 'small' ? 'Jahr ' : 'Jahr ',
	              tooltipSuffix: this.props.chartClassName == 'small' ? ' ' : ':',
	              tooltipCountSuffix: this.props.chartClassName == 'small' ? '' : ' Prozent',
	              tooltipCountPrefix: this.props.chartClassName == 'small' ? 'Total: ' : '',
	              tooltipCountAbsolutePrefix: this.props.chartClassName == 'small' ? 'Anteil: ' : '',
	              tooltipCountAbsoluteSuffix: this.props.chartClassName == 'small' ? '%' : '',
	              tooltipCountAbsolute: this.state.tooltipCount,
	              tooltipCountPercentage: this.state.percentage,
	              tooltipYOffset: 5
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return LinechartMultiple;
	}(_react2.default.Component);
	
	LinechartMultiple.propTypes = {
	  chartTitle: _react2.default.PropTypes.string,
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number,
	  chartId: _react2.default.PropTypes.string,
	  chartClassName: _react2.default.PropTypes.string,
	  linechartClass: _react2.default.PropTypes.string,
	  readerMadeHisChoice: _react2.default.PropTypes.bool,
	  circleFillp25: _react2.default.PropTypes.string,
	  circleFillp50: _react2.default.PropTypes.string,
	  circleFillp75: _react2.default.PropTypes.string,
	  maxY: _react2.default.PropTypes.number,
	  minY: _react2.default.PropTypes.number,
	  circleStrokeFillp25: _react2.default.PropTypes.string,
	  circleStrokeFillp50: _react2.default.PropTypes.string,
	  circleStrokeFillp75: _react2.default.PropTypes.string,
	  circleRadius: _react2.default.PropTypes.number,
	  circleStroke: _react2.default.PropTypes.number,
	  circleStrokeFill: _react2.default.PropTypes.string,
	  ticksX: _react2.default.PropTypes.number,
	  ticksY: _react2.default.PropTypes.number,
	  tickFormatX: _react2.default.PropTypes.string,
	  tickFormatY: _react2.default.PropTypes.string,
	  x: _react2.default.PropTypes.func,
	  y: _react2.default.PropTypes.func,
	  tooltipWidth: _react2.default.PropTypes.number,
	  tooltipHeight: _react2.default.PropTypes.number,
	  tooltipFontSize: _react2.default.PropTypes.number,
	  dataSource: _react2.default.PropTypes.array,
	  chartMargin: _react2.default.PropTypes.array
	};
	
	exports.default = LinechartMultiple;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MastheadComponent = __webpack_require__(148);
	
	var _MastheadComponent2 = _interopRequireDefault(_MastheadComponent);
	
	var _taReactTracking = __webpack_require__(393);
	
	var _taReactTracking2 = _interopRequireDefault(_taReactTracking);
	
	var _Storyhead = __webpack_require__(158);
	
	var _Storyhead2 = _interopRequireDefault(_Storyhead);
	
	var _Identificator = __webpack_require__(144);
	
	var _Identificator2 = _interopRequireDefault(_Identificator);
	
	var _Section = __webpack_require__(151);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Section3 = __webpack_require__(152);
	
	var _Section4 = _interopRequireDefault(_Section3);
	
	var _Section5 = __webpack_require__(153);
	
	var _Section6 = _interopRequireDefault(_Section5);
	
	var _section = __webpack_require__(154);
	
	var _section2 = _interopRequireDefault(_section);
	
	var _section3 = __webpack_require__(155);
	
	var _section4 = _interopRequireDefault(_section3);
	
	var _section5 = __webpack_require__(156);
	
	var _section6 = _interopRequireDefault(_section5);
	
	var _MultipleLineChart = __webpack_require__(150);
	
	var _MultipleLineChart2 = _interopRequireDefault(_MultipleLineChart);
	
	var _SmallMultiples = __webpack_require__(157);
	
	var _SmallMultiples2 = _interopRequireDefault(_SmallMultiples);
	
	var _SVGMap = __webpack_require__(159);
	
	var _SVGMap2 = _interopRequireDefault(_SVGMap);
	
	var _Video = __webpack_require__(160);
	
	var _Video2 = _interopRequireDefault(_Video);
	
	var _Footer = __webpack_require__(143);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _reactContainerDimensions = __webpack_require__(279);
	
	var _reactContainerDimensions2 = _interopRequireDefault(_reactContainerDimensions);
	
	var _zhQuarterMap = __webpack_require__(252);
	
	var _zhQuarterMap2 = _interopRequireDefault(_zhQuarterMap);
	
	var _zhQuarterMapSoziahilfe = __webpack_require__(258);
	
	var _zhQuarterMapSoziahilfe2 = _interopRequireDefault(_zhQuarterMapSoziahilfe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(140);
	__webpack_require__(141);
	__webpack_require__(386);
	
	// import FeedbackMessage from '../feedbackMessage/FeedbackMessage.component';
	// import CopyRightNotice from '../copyrightNotice/CopyrightNotice.component';
	
	// import Linechart from '../lineChart/Linechart.component';
	
	// import SVGCircleMap from '../svgCircleMap/SVGMap.component';
	
	// import zhCircleMap from '../svgCircleMap/data/zhCircleMap.svg';
	
	// import zhCircleMapData from 'json!../svgQuarterMap/data/zhCircleMap.json';
	
	var AppComponent = function (_React$Component) {
	  _inherits(AppComponent, _React$Component);
	
	  function AppComponent(props) {
	    _classCallCheck(this, AppComponent);
	
	    var _this = _possibleConstructorReturn(this, (AppComponent.__proto__ || Object.getPrototypeOf(AppComponent)).call(this, props));
	
	    _this.random = Math.random() * 100000;
	
	
	    _this.state = {
	      showQuarterList: false,
	      readerIsCityCitizen: false,
	      readerMadeHisChoice: false,
	      chosenQuarter: '',
	      showOverlay: false,
	      dataSource: [{ day: '02-11-1999', title: 'Kreis 1', count: 500 }, { day: '02-12-2000', title: 'Kreis 2', count: 250 }, { day: '02-13-2001', title: 'Kreis 3', count: 50 }, { day: '02-14-2002', title: 'Kreis 4', count: 500 }, { day: '02-15-2003', title: 'Kreis 5', count: 0 }, { day: '02-16-2004', title: 'Kreis 6', count: 380 }, { day: '02-17-2005', title: 'Kreis 7', count: 100 }, { day: '02-18-2006', title: 'Kreis 8', count: 300 }, { day: '02-16-2007', title: 'Kreis 6', count: 380 }, { day: '02-17-2008', title: 'Kreis 7', count: 100 }, { day: '02-18-2009', title: 'Kreis 8', count: 300 }]
	    };
	
	    _this.changeCitizenship = _this.changeCitizenship.bind(_this);
	    _this.changeChosenQuarter = _this.changeChosenQuarter.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(AppComponent, [{
	    key: 'changeChosenQuarter',
	    value: function changeChosenQuarter(newChoice) {
	      this.setState({
	        chosenQuarter: newChoice
	      });
	    }
	  }, {
	    key: 'changeCitizenship',
	    value: function changeCitizenship(quarter, choice, choiceIsMade) {
	      this.setState({
	        chosenQuarter: quarter,
	        readerIsCityCitizen: choice,
	        readerMadeHisChoice: choiceIsMade,
	        showQuarterList: false
	      });
	      if (quarter) {
	        this.setState({
	          chosenQuarterName: quarter.name,
	          chosenCircleName: quarter.circle,
	          readerMadeHisChoice: true,
	          readerIsCityCitizen: true
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'index'
	        },
	        _react2.default.createElement(
	          'div',
	          { style: {
	              position: 'absolute'
	            }
	          },
	          _react2.default.createElement('img', {
	            style: {
	              display: 'none'
	            },
	            src: 'http://www.tagesanzeiger.ch/zuerich/Oliver-45--ploetzlich-arm-im-reichen-Zuerich/story/19748408/pixel.gif?nocache=' + this.random,
	            width: '1',
	            height: '1'
	          })
	        ),
	        _react2.default.createElement(_MastheadComponent2.default, {
	          inverted: 'true',
	          mediaName: 'tagesanzeiger',
	          shareUrl: 'http://interaktiv.tagesanzeiger.ch/2016/armut-in-zuerich/',
	          twitterShareText: 'In Z\xFCrich leben Zehntausende Menschen in Armut. Oliver ist einer von ihnen. Eine Abstiegsgeschichte.' }),
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              height: '100vh'
	            }
	          },
	          _react2.default.createElement(
	            _reactContainerDimensions2.default,
	            null,
	            _react2.default.createElement(_Storyhead2.default, null)
	          )
	        ),
	        _react2.default.createElement(
	          _reactContainerDimensions2.default,
	          null,
	          _react2.default.createElement(_Identificator2.default, {
	            readerIsCityCitizen: this.state.readerIsCityCitizen,
	            readerMadeHisChoice: this.state.readerMadeHisChoice,
	            clickHandler: this.changeCitizenship,
	            changeChosenQuarter: this.changeChosenQuarter,
	            showQuarterList: this.state.showQuarterList
	          })
	        ),
	        _react2.default.createElement(_Section2.default, {
	          readerIsCityCitizen: this.state.readerIsCityCitizen,
	          readerMadeHisChoice: this.state.readerMadeHisChoice,
	          quarter: this.state.chosenQuarterName,
	          circle: this.state.chosenCircleName
	        }),
	        _react2.default.createElement(_SVGMap2.default, {
	          dataSource: this.state.dataSource,
	          mapId: 'zh-quarter-map',
	          mapTitle: 'Sozialhilfequote nach Stadtquartieren',
	          mapLead: 'Die verwendeten Daten beziehen sich auf das Jahr 2014.',
	          height: 640,
	          width: 640,
	          mapSource: _zhQuarterMap2.default,
	          mapData: _zhQuarterMapSoziahilfe2.default,
	          mapDataYear: 2014,
	          readerIsCityCitizen: this.state.readerIsCityCitizen,
	          readerMadeHisChoice: this.state.readerMadeHisChoice,
	          sortProp: 'QuartSort'
	        }),
	        _react2.default.createElement(_Section4.default, {
	          readerIsCityCitizen: this.state.readerIsCityCitizen,
	          readerMadeHisChoice: this.state.readerMadeHisChoice,
	          quarter: this.state.chosenQuarterName,
	          circle: this.state.chosenCircleName
	        }),
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'ui  dimmable ' + (this.state.readerMadeHisChoice ? '' : 'dimmed') + ' segment  linechart'
	          },
	          _react2.default.createElement('div', {
	            className: 'ui inverted simple dimmer',
	            style: {
	              display: this.state.readerMadeHisChoice ? 'none' : 'block'
	            }
	          }),
	          _react2.default.createElement(
	            _reactContainerDimensions2.default,
	            null,
	            _react2.default.createElement(_MultipleLineChart2.default, {
	              readerIsCityCitizen: this.state.readerIsCityCitizen,
	              readerMadeHisChoice: this.state.readerMadeHisChoice
	            })
	          ),
	          _react2.default.createElement(_Section6.default, {
	            readerIsCityCitizen: this.state.readerIsCityCitizen,
	            readerMadeHisChoice: this.state.readerMadeHisChoice
	          }),
	          _react2.default.createElement('iframe', {
	            src: 'http://interaktiv.tagesanzeiger.ch/guessgame/front/quiz/show-single/139/537',
	            width: '100%',
	            height: '250',
	            scrolling: 'no',
	            style: { border: '0px', marginTop: '15px', overflow: 'hidden', width: '100%', minHeight: '380px' }
	          }),
	          _react2.default.createElement(_section2.default, {
	            readerIsCityCitizen: this.state.readerIsCityCitizen,
	            readerMadeHisChoice: this.state.readerMadeHisChoice
	          }),
	          _react2.default.createElement(
	            _reactContainerDimensions2.default,
	            null,
	            _react2.default.createElement(_Video2.default, null)
	          ),
	          _react2.default.createElement(_section4.default, {
	            readerIsCityCitizen: this.state.readerIsCityCitizen,
	            readerMadeHisChoice: this.state.readerMadeHisChoice,
	            quarter: this.state.chosenQuarterName,
	            circle: this.state.chosenCircleName
	          }),
	          _react2.default.createElement(
	            _reactContainerDimensions2.default,
	            null,
	            _react2.default.createElement(_SmallMultiples2.default, {
	              readerIsCityCitizen: this.state.readerIsCityCitizen,
	              readerMadeHisChoice: this.state.readerMadeHisChoice
	            })
	          ),
	          _react2.default.createElement(_section6.default, {
	            readerIsCityCitizen: this.state.readerIsCityCitizen,
	            readerMadeHisChoice: this.state.readerMadeHisChoice
	          })
	        ),
	        _react2.default.createElement(_Footer2.default, {
	          handler: this.switchOverlay,
	          shareUrl: 'http://interaktiv.tagesanzeiger.ch/2016/armut-in-zuerich/',
	          twitterShareText: 'In Z\xFCrich leben Zehntausende Menschen in Armut. Oliver ist einer von ihnen. Eine Abstiegsgeschichte: https://goo.gl/dtIgjV @tagesanzeiger '
	        }),
	        _react2.default.createElement(_taReactTracking2.default, {
	          articleId: '19748408',
	          projectId: 'armut-in-zuerich'
	        })
	      );
	    }
	  }]);
	
	  return AppComponent;
	}(_react2.default.Component);
	
	AppComponent.defaultProps = {};
	
	exports.default = AppComponent;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Request = __webpack_require__(92);
	
	var d3request = _interopRequireWildcard(_d3Request);
	
	var _facebookShareIcon = __webpack_require__(149);
	
	var _facebookShareIcon2 = _interopRequireDefault(_facebookShareIcon);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//region import React
	
	//endregion
	
	//region import additional libraries
	
	//endregion
	
	//region import components
	
	
	//endregion
	
	//region import CSS
	// Semantic UI
	__webpack_require__(140);
	__webpack_require__(141);
	__webpack_require__(137);
	__webpack_require__(136);
	__webpack_require__(13);
	__webpack_require__(381);
	__webpack_require__(382);
	__webpack_require__(138);
	
	// Specific CSS
	__webpack_require__(363);
	//endregion
	
	
	var MastheadComponent = function (_React$Component) {
	  _inherits(MastheadComponent, _React$Component);
	
	  function MastheadComponent(state) {
	    _classCallCheck(this, MastheadComponent);
	
	    var _this = _possibleConstructorReturn(this, (MastheadComponent.__proto__ || Object.getPrototypeOf(MastheadComponent)).call(this, state));
	
	    _this.state = _extends({}, state, {
	      facebookShares: 0
	    });
	    return _this;
	  }
	
	  /**
	   * Called once the component has been mounted, checks the Facebook graph
	   * for shares and displays them in the header.
	   */
	
	
	  _createClass(MastheadComponent, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.shareUrl) {
	        // Get Facebook Share Count
	        d3request.json('https://graph.facebook.com/?id=' + this.props.shareUrl).get(function (error, result) {
	          if (error) {
	            _this2.setState({
	              facebookShares: 0
	            });
	          }
	          _this2.setState({
	            facebookShares: result.share.share_count || 0
	          });
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      // Prepare constants for the inverted version
	      var invertedClass = this.props.inverted ? 'inverted' : '';
	      var invertedImgSrcName = this.props.inverted ? '-inverted' : '';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ta-masthead masthead-component ' + invertedClass },
	        _react2.default.createElement(
	          'div',
	          { className: 'ui container ' },
	          _react2.default.createElement(
	            'div',
	            { className: 'ui two column middle aligned grid' },
	            _react2.default.createElement(
	              'div',
	              { className: 'column ta-logo' },
	              _react2.default.createElement(
	                'a',
	                { href: 'http://' + this.props.mediaName + '.ch' },
	                _react2.default.createElement('img', {
	                  src: '//interaktiv.tagesanzeiger.ch/static/logos/' + this.props.mediaName + invertedImgSrcName + '.svg',
	                  alt: this.props.mediaName + ' Logo',
	                  className: 'ui middle aligned logo image' })
	              )
	            ),
	            function () {
	              // Conditionals have to be constructed using immediately called
	              // functions within JSX
	              if (_this3.props.shareUrl) {
	                return _react2.default.createElement(
	                  'div',
	                  { className: 'right aligned column' },
	                  _react2.default.createElement(
	                    'div',
	                    {
	                      className: 'ui horizontal link list share ' + invertedClass },
	                    _react2.default.createElement(_facebookShareIcon2.default, { shareUrl: _this3.props.shareUrl,
	                      facebookShares: _this3.state.facebookShares }),
	                    _react2.default.createElement(
	                      'a',
	                      { href: encodeURI('https://twitter.com/intent/tweet?url=' + _this3.props.shareUrl + '&via=' + _this3.props.mediaName + (_this3.props.twitterShareText ? '&text=' + _this3.props.twitterShareText : '')),
	                        className: 'twitter-share item',
	                        target: '_blank'
	                      },
	                      _react2.default.createElement('i', { className: 'twitter middle aligned icon' })
	                    )
	                  )
	                );
	              }
	            }()
	          )
	        )
	      );
	    }
	
	    /**
	     * Extracts the hostname of the location, and provides the default
	     * mediaName if none is supplied.
	     *
	     * @returns {{hostname: string, mainDomain: string, mediaName: string}}
	     */
	
	  }], [{
	    key: 'extractMediaName',
	    value: function extractMediaName() {
	      var hostname = window.location.hostname;
	      var mainDomain = hostname.substring(hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1); // extract domain name from host
	      // (crops subdomains like
	      // interaktiv.)
	      var mediaName = mainDomain.split('.')[0];
	      return {
	        hostname: hostname,
	        mainDomain: mainDomain,
	        mediaName: mediaName
	      };
	    }
	  }]);
	
	  return MastheadComponent;
	}(_react2.default.Component);
	
	MastheadComponent.propTypes = {
	  mediaName: _react2.default.PropTypes.string,
	  shareUrl: _react2.default.PropTypes.string,
	  twitterShareText: _react2.default.PropTypes.string,
	  inverted: _react2.default.PropTypes.string
	};
	
	MastheadComponent.defaultProps = {
	  mediaName: MastheadComponent.extractMediaName().mediaName,
	  inverted: false,
	  shareUrl: function () {
	    return window.location;
	  }()
	};
	
	exports.default = MastheadComponent;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//endregion
	
	//region CSS imports
	__webpack_require__(13);
	//endregion
	
	//region React imports
	function FacebookShareIcon(props) {
	  return _react2.default.createElement(
	    'a',
	    {
	      target: '_blank',
	      href: 'https://www.facebook.com/dialog/share?href=' + encodeURIComponent(props.shareUrl) + '&display=popup&app_id=' + props.facebookAppId + '&quote=' + encodeURIComponent(props.shareText) + '&hashtag=' + (props.hashtag ? encodeURIComponent('#' + props.hashtag) : ''),
	      className: 'fb-share item' },
	    props.facebookShares > 0 ? _react2.default.createElement(
	      'div',
	      { className: 'count ui mini right pointing label',
	        style: { marginRight: '0.5em' } },
	      props.facebookShares
	    ) : null,
	    _react2.default.createElement('i', { className: 'facebook square middle aligned icon' })
	  );
	}
	
	FacebookShareIcon.propTypes = {
	  shareUrl: _react2.default.PropTypes.string,
	  facebookShares: _react2.default.PropTypes.number,
	  facebookAppId: _react2.default.PropTypes.string,
	  shareText: _react2.default.PropTypes.string,
	  hashtag: _react2.default.PropTypes.string
	};
	
	FacebookShareIcon.defaultProps = {
	  shareUrl: function () {
	    return window.location;
	  }(),
	  facebookShares: 0,
	  facebookAppId: '147124108642216',
	  shareText: '',
	  hashtag: ''
	};
	
	exports.default = FacebookShareIcon;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _LinechartMultiple = __webpack_require__(146);
	
	var _LinechartMultiple2 = _interopRequireDefault(_LinechartMultiple);
	
	var _d3TimeFormat = __webpack_require__(30);
	
	var _d3Scale = __webpack_require__(28);
	
	var _d3Shape = __webpack_require__(39);
	
	var _d3Array = __webpack_require__(22);
	
	var _d3Selection = __webpack_require__(29);
	
	var _d3Axis = __webpack_require__(38);
	
	var _d3Format = __webpack_require__(23);
	
	var _d3Interpolate = __webpack_require__(51);
	
	var _d3Collection = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import d3 from 'd3';
	
	__webpack_require__(12);
	
	var dataSource = __webpack_require__(256);
	
	/************************************************************************/
	
	var MultipleLineChart = function (_React$Component) {
	  _inherits(MultipleLineChart, _React$Component);
	
	  function MultipleLineChart(props) {
	    _classCallCheck(this, MultipleLineChart);
	
	    var _this = _possibleConstructorReturn(this, (MultipleLineChart.__proto__ || Object.getPrototypeOf(MultipleLineChart)).call(this, props));
	
	    _this.basicDataByYear = [];
	    _this.marriedDataByYear = [];
	
	
	    _this.changeData = _this.changeData.bind(_this);
	
	    var dataByCategory = (0, _d3Collection.nest)().key(function (d) {
	      return d.SteuerTariflang;
	    }).key(function (d) {
	      return d.SteurJahr;
	    }).entries(dataSource);
	
	    for (var i = 0; i < dataByCategory[0]['values'][0]['values'].length; i++) {
	      _this.basicDataByYear.push({
	        year: dataByCategory[0]['values'][0]['values'][i]['SteuerJahr'],
	        p25: dataByCategory[0]['values'][0]['values'][i]['p25'],
	        p50: dataByCategory[0]['values'][0]['values'][i]['p50'],
	        p75: dataByCategory[0]['values'][0]['values'][i]['p75']
	      });
	    }
	
	    for (var _i = 0; _i < dataByCategory[1]['values'][0]['values'].length; _i++) {
	      _this.marriedDataByYear.push({
	        year: dataByCategory[1]['values'][0]['values'][_i]['SteuerJahr'],
	        p25: dataByCategory[1]['values'][0]['values'][_i]['p25'],
	        p50: dataByCategory[1]['values'][0]['values'][_i]['p50'],
	        p75: dataByCategory[1]['values'][0]['values'][_i]['p75']
	      });
	    }
	
	    /* Set data states */
	    _this.state = {
	      actualDataSource: _this.basicDataByYear,
	      activeButton: 'basic'
	    };
	
	    return _this;
	  }
	
	  _createClass(MultipleLineChart, [{
	    key: 'changeData',
	    value: function changeData(e) {
	      var newDataSource = e.currentTarget.getAttribute('data-selector');
	      // console.log(newDataSource);
	      if (newDataSource == 'basic') {
	        this.setState({
	          actualDataSource: this.basicDataByYear,
	          activeButton: 'basic'
	        });
	      } else {
	        this.setState({
	          actualDataSource: this.marriedDataByYear,
	          activeButton: 'married'
	        });
	      }
	      // console.log(this.state.actualDataSource)
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment padded linechart'
	        },
	        _react2.default.createElement('div', {
	          className: 'ui inverted simple dimmer',
	          style: {
	            display: this.state.readerMadeHisChoice ? 'none' : 'block'
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { maxWidth: '640px', margin: '0 auto', marginTop: '30px', marginBottom: '40px' } },
	          _react2.default.createElement(
	            'h3',
	            {
	              style: {
	                marginBottom: '10px',
	                fontFamily: 'Benton Sans Cond',
	                fontWeight: 'bold'
	              }
	            },
	            'Entwicklung des steuerbaren Einkommens'
	          ),
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                marginBottom: '20px'
	              }
	            },
	            'Indexierte Werte, aufgeteilt in das\xA0',
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'round-number',
	                style: {
	                  fontSize: '17px',
	                  background: '#E23C4E',
	                  borderRadius: '50%',
	                  color: 'white',
	                  padding: '4px',
	                  paddingLeft: '6px'
	                }
	              },
	              '25.'
	            ),
	            ', das ',
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'round-number',
	                style: {
	                  fontSize: '17px',
	                  background: '#1D5F82',
	                  borderRadius: '50%',
	                  color: 'white',
	                  padding: '4px',
	                  paddingLeft: '6px'
	                }
	              },
	              '50.'
	            ),
	            ' und das ',
	            _react2.default.createElement(
	              'span',
	              {
	                className: 'round-number',
	                style: {
	                  fontSize: '17px',
	                  background: '#000',
	                  borderRadius: '50%',
	                  color: 'white',
	                  padding: '4px',
	                  paddingLeft: '6px'
	                }
	              },
	              '75.'
	            ),
	            '\xA0Perzentil f\xFCr die Stadt Z\xFCrich.'
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'button-wrapper',
	              style: { textAlign: 'center' }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'ui small buttons' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'ui button ' + (this.state.activeButton == 'basic' ? 'active' : ''),
	                  'data-selector': 'basic',
	                  onClick: this.changeData
	                },
	                'Ledige'
	              ),
	              _react2.default.createElement('div', {
	                className: ''
	              }),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'ui button ' + (this.state.activeButton == 'married' ? 'active' : ''),
	                  'data-selector': 'married',
	                  onClick: this.changeData
	                },
	                'Verheiratete'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'linechart-wrapper large',
	              style: {
	                maxWidth: '640px'
	              }
	            },
	            _react2.default.createElement(_LinechartMultiple2.default, {
	              chartClassName: 'large',
	              chartTitle: '',
	              width: this.props.width,
	              height: this.props.width > 450 ? 480 : 420,
	              chartId: 'multiple-lines-chart',
	              readerIsCityCitizen: this.props.readerIsCityCitizen,
	              readerMadeHisChoice: this.props.readerMadeHisChoice,
	              circleRadius: 4,
	              circleFillp25: '#E23C4E',
	              circleFillp50: '#000000',
	              circleFillp75: '#1D5F82',
	              circleStroke: 1,
	              circleStrokeFill: '#ffffff',
	              circleStrokeFillp25: '#E23C4E',
	              circleStrokeFillp50: '#000000',
	              circleStrokeFillp75: '#1D5F82',
	              ticksX: 10,
	              ticksY: 10,
	              minY: 100,
	              maxY: 135,
	              tickFormatX: '%Y',
	              linechartClass: 'large',
	              tooltipHeight: 50,
	              tooltipWidth: 90,
	              tooltipFontSize: 14,
	              dataSource: this.state.actualDataSource
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return MultipleLineChart;
	}(_react2.default.Component);
	
	MultipleLineChart.propTypes = {
	
	  readerMadeHisChoice: _react2.default.PropTypes.bool,
	  readerIsCityCitizen: _react2.default.PropTypes.bool,
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number
	
	};
	
	exports.default = MultipleLineChart;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(13);
	__webpack_require__(12);
	__webpack_require__(21);
	__webpack_require__(368);
	
	var dataSource = __webpack_require__(54);
	
	var Section1 = function (_React$Component) {
	  _inherits(Section1, _React$Component);
	
	  function Section1(props) {
	    _classCallCheck(this, Section1);
	
	    var _this = _possibleConstructorReturn(this, (Section1.__proto__ || Object.getPrototypeOf(Section1)).call(this, props));
	
	    _this.state = {
	      sozialBeziehende: 0,
	      sozialQuote: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(Section1, [{
	    key: 'niceComma',
	    value: function niceComma(value) {
	      var str = value.toString();
	      var newValue = str.replace(".", ",");
	      return newValue;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (this.props.quarter != '') {
	
	        // Calculate data when new props arrive
	
	        for (var i = 0; i < dataSource.length; i++) {
	
	          if (dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Grundtarif') {
	
	            // console.log(dataSource[i])
	
	            this.setState({
	              sozialBeziehende: dataSource[i].SozialBeziehende,
	              sozialQuote: dataSource[i].SozialQuote
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section one wrapper' },
	        _react2.default.createElement(
	          'div',
	          {
	            className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment mobile-padding',
	            style: { padding: '0px 0px' }
	          },
	          _react2.default.createElement('div', { className: 'ui inverted simple dimmer' }),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Lernt Oliver eine Frau kennen, spricht er sofort Klartext: \xABIch sage immer drei Dinge. Erstens: Ich bin arm. Zweitens: Ich bin krank. Drittens: \u2026\xBB Oliver stockt. Sein Blick ist glasig, seine Konzentration schwindet. Das Gespr\xE4ch ersch\xF6pft ihn. ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Oliver leidet unter Narkolepsie'
	            ),
	            ', umgangssprachlich Schlafkrankheit genannt. Um seine Geschichte zu erz\xE4hlen, hat er eine Extradosis Medikamente eingeworfen. \xABRitalin\xBB, sagt er, und macht mit seinem rechten Unterarm eine Pumpbewegung, um den Effekt zu unterstreichen, den die Droge eigentlich haben sollte.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Oliver ist 45 Jahre alt, B\xFCrstenschnitt, rundes Gesicht, breiter Nacken. Er tr\xE4gt ein blaues T-Shirt und Jeans, wirkt unauff\xE4llig, einzig die leicht ger\xF6teten Augen fallen auf. Er sitzt in der K\xFCche seiner Genossenschaftswohnung in der Stadt Z\xFCrich. An der Wand h\xE4ngen Fotos, Zeichnungen und Postkarten von seinem Sohn. Oliver will anonym bleiben. Sein 9-j\xE4hriger Sohn soll auf dem Pausenplatz nicht wegen seiner Geschichte geh\xE4nselt werden.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Olivers Geschichte handelt von ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'einem jahrelangen Kampf gegen die Armut'
	            ),
	            ', der lange Zeit verloren schien. Pl\xF6tzlich h\xE4tten 326 Franken im Monat ausreichen m\xFCssen. Das Konto war leer, f\xFCnf Betreibungen waren h\xE4ngig. Es reichte nicht. Der Reisvorrat war aufgebraucht und am n\xE4chsten Tag h\xE4tte sein Sohn zum Mittagessen kommen sollen. Das war vor etwas mehr als einem Jahr. \xABDa wusste ich, ich muss aufs Sozialamt\xBB, sagt Oliver. \xABWissen Sie, wie sich das anf\xFChlt?\xBB'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Armut ist in Z\xFCrich weitgehend unsichtbar'
	            ),
	            ', weil sie bloss die wenigsten zu einem Leben auf der Strasse zwingt. Nur w\xE4hrend der Adventszeit, wenn die Hilfswerke um die Aufmerksamkeit potenzieller Spenderinnen und Spender buhlen, r\xFCckt sie etwas ins Bewusstsein der reichen Z\xFCrcherinnen und Z\xFCrcher \u2013 dann, wenn zwischen Weihnachtseink\xE4ufen und Gl\xFChwein f\xFCr 6.50 Franken der Zweifr\xE4nkler im Heilsarmee-Topf scheppert.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            '19\'748 Menschen haben in Z\xFCrich 2014 Sozialhilfe bezogen, wie ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.stadt-zuerich.ch/epaper/PRD/SSZ/Jahrbuch/JB_2016_output/web/html5/index.html?&locale=DEU', target: '_blank' },
	              'Zahlen von Statistik Stadt Z\xFCrich'
	            ),
	            ' zeigen. Das entspricht 5,1 Prozent.',
	            this.props.quarter != undefined && this.props.readerIsCityCitizen == true && _react2.default.createElement(
	              'span',
	              { className: 'personalised text' },
	              'Im Quartier ',
	              this.niceComma(this.props.quarter),
	              ' waren es ',
	              this.state.sozialBeziehende,
	              ' Menschen (',
	              this.niceComma(this.state.sozialQuote),
	              ' Prozent).'
	            ),
	            '\xA0',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.bfs.admin.ch/bfs/de/home/statistiken/soziale-sicherheit/erhebungen/shs.html', target: '_blank' },
	              'Schweizweit'
	            ),
	            ' und im ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://www.statistik.zh.ch/internet/justiz_inneres/statistik/de/daten/daten_bevoelkerung_soziales/soziales.html', target: '_blank' },
	              'Kanton Z\xFCrich'
	            ),
	            ' liegt die Sozialhilfequote bei 3,2 Prozent. Im Stadtkreis 12 ist die Sozialhilfequote mit 8,3 Prozent am h\xF6chsten. 2379 Menschen sind betroffen. Den tiefsten Wert weist der Stadtkreis 7 auf, 425 Menschen oder 1,2 Prozent. Zu den ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://www.caritas-zuerich.ch/was-wir-sagen/zahlen-und-fakten-zur-armut-bei-uns', target: '_blank' },
	              'Risikogruppen'
	            ),
	            ' geh\xF6ren: Alleinerziehende, Unterhaltspflichtige, Familien mit drei und mehr Kindern, Alleinlebende, Migranten und Menschen mit geringer Bildung.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Anspruch auf Sozialhilfe h\xE4tten noch viel mehr. ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://blog.bfh.ch/knotenmaschen/wer-wagt-es-nach-hilfe-zu-fragen/', target: '_blank' },
	              'Eine Studie'
	            ),
	            ' hat gezeigt, dass in St\xE4dten etwa jeder Siebte, der Anspruch auf Sozialhilfe h\xE4tte, keine beantragt \u2013 ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://www.tagesanzeiger.ch/schweiz/standard/Aus-Scham-auf-Sozialhilfe-verzichten/story/11945810', target: '_blank' },
	              'aus Scham'
	            ),
	            ', aus Stolz oder bei Ausl\xE4ndern auch aus Angst vor Konsequenzen f\xFCr den Aufenthaltsstatus. Auf dem Land ist diese Zahl noch deutlich h\xF6her.                          '
	          )
	        )
	      );
	    }
	  }]);
	
	  return Section1;
	}(_react2.default.Component);
	
	Section1.defaultProps = {};
	
	Section1.propTypes = {
	  readerIsCityCitizen: _react2.default.PropTypes.bool,
	  readerMadeHisChoice: _react2.default.PropTypes.bool,
	  quarter: _react2.default.PropTypes.string,
	  circle: _react2.default.PropTypes.string
	};
	
	exports.default = Section1;

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImageLightbox = __webpack_require__(58);
	
	var _reactImageLightbox2 = _interopRequireDefault(_reactImageLightbox);
	
	var _ = __webpack_require__(395);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(13);
	__webpack_require__(12);
	__webpack_require__(21);
	__webpack_require__(369);
	
	var dataSource = __webpack_require__(54);
	
	var Section2 = function (_React$Component) {
	  _inherits(Section2, _React$Component);
	
	  function Section2(props) {
	    _classCallCheck(this, Section2);
	
	    var _this = _possibleConstructorReturn(this, (Section2.__proto__ || Object.getPrototypeOf(Section2)).call(this, props));
	
	    _this.state = {
	      isOpen: false,
	      mietPreis: 0,
	      steuerEinkommen: 0,
	      steuernMarriedP75: 0,
	      steuernUnmarriedP75: 0,
	      steuernMarriedP25: 0,
	      steuernUnmarriedP25: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(Section2, [{
	    key: 'niceNumber',
	    value: function niceNumber(value, sep) {
	      if (sep == null) {
	        sep = '\'';
	      }
	
	      value = Math.round(value);
	
	      value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
	
	      return value;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (this.props.quarter != '') {
	
	        // Calculate data when new props arrive
	
	        for (var i = 0; i < dataSource.length; i++) {
	
	          // console.log(dataSource[i])
	
	          if (dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2016 && dataSource[i].SteuerTariflang == 'NA') {
	            this.setState({
	              mietPreis: dataSource[i].Mietpreis
	            });
	          }
	
	          if (dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Verheiratet') {
	            // console.log(dataSource[i])
	            this.setState({
	              steuerEinkommen: this.niceNumber(dataSource[i].SteuerEinkommen_Median * 1000)
	            });
	          }
	
	          if (dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Verheiratet') {
	            // console.log(dataSource[i])
	            this.setState({
	              steuernMarriedP75: this.niceNumber(dataSource[i].SteuerEinkommen_P75 * 1000),
	              steuernMarriedP25: this.niceNumber(dataSource[i].SteuerEinkommen_P25 * 1000)
	            });
	          }
	
	          if (dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Grundtarif') {
	            // console.log(dataSource[i])
	            this.setState({
	              steuernUnmarriedP75: this.niceNumber(dataSource[i].SteuerEinkommen_P75 * 1000),
	              steuernUnmarriedP25: this.niceNumber(dataSource[i].SteuerEinkommen_P25 * 1000)
	            });
	          }
	
	          // console.log(this.state.steuerEinkommen)
	
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section two wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment padded' },
	          _react2.default.createElement('div', { className: 'ui inverted simple dimmer' }),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Ist Z\xFCrich eine gute Stadt, um arm zu sein?'
	            ),
	            ' \xABJa und nein\xBB, sagt Oliver. Beide Antworten h\xE4tten mit dem Reichtum der Stadt zu tun: \xABWeil die Menschen so viel besitzen, tr\xF6pfelt auch etwas davon zu mir herunter.\xBB So hat er schon \xF6fters alte Hosen von Freunden geschenkt bekommen, weil er kein Geld hatte, um seine zerrissenen zu ersetzen.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Auf der anderen Seite hat das Leben in der Stadt seinen Preis. Die Krankenkassenpr\xE4mien sind h\xF6her als in anderen Orten im Kanton, die Betreuungskosten f\xFCr Kinder sind teuer und die Mieten sind in den letzten zehn Jahren deutlich angestiegen. Die Immobilienberatungsfirma W\xFCest Partner sch\xE4tzt, dass die Angebotsmieten seit 2006 um rund 36,5 Prozent gestiegen sind \u2013 f\xFCr eine durchschnittliche 4-Zimmer-Wohnung mit 110 Quadratmetern.',
	            this.props.quarter != undefined && this.props.readerIsCityCitizen == true && _react2.default.createElement(
	              'span',
	              { className: 'personalised text' },
	              'Im Stadtkreis, in dem Sie wohnen, betr\xE4gt die mittlere Miete einer solchen Wohnung ',
	              this.state.mietPreis,
	              ' Franken.'
	            ),
	            '\xA0Mit den steigenden Mieten verbinden ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://staedteinitiative.ch/cmsfiles/staedteinitiative_sozialpolitik_bericht_2015.pdf', target: '_blank' },
	              'Experten auch den R\xFCckgang'
	            ),
	            ' der Sozialhilfequote in Z\xFCrich. Weil g\xFCnstiger Wohnraum rarer wurde, sind viele Sozialhilfebeziehende oder armutsgef\xE4hrdete Menschen in Agglomerationsgemeinden oder aufs Land gezogen.'
	          ),
	          this.state.isOpen && _react2.default.createElement(_reactImageLightbox2.default, {
	            mainSrc: _2.default,
	            imageCaption: 'Abgewetzt: Weil sich Oliver keine neuen Kleider leisten kann, hat er von Bekannten alte geschenkt bekommen.',
	            onCloseRequest: function onCloseRequest() {
	              return _this2.setState({ isOpen: false });
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'section text image wrapper' },
	            _react2.default.createElement('img', {
	              src: _2.default, width: '100%',
	              onClick: function onClick() {
	                return _this2.setState({ isOpen: true });
	              }
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'bild legend' },
	              'Abgewetzt: Weil sich Oliver keine neuen Kleider leisten kann, hat er von Bekannten alte geschenkt bekommen.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Oliver konnte in seiner Wohnung bleiben. Aber: Essen, Kaffee, Kino, Konzerte, Kultur \u2013 alles kostet mehr als an anderen Orten. ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Das Sozialleben leidet unter der Armut.'
	            ),
	            ' Mit sinkendem Kontostand sind auch die Freunde weniger geworden. Die Freunde gehen lieber aus, als Oliver in seiner Wohnung zu besuchen. Er versteht das, weil er auch lieber ausgehen w\xFCrde, aber das Geld dazu fehlt.                            '
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Die Steuerdaten der Stadt Z\xFCrich zeigen, wie gut die Z\xFCrcherinnen und Z\xFCrcher (',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.stadt-zuerich.ch/fd/de/index/steuern/quellensteuer/auslaendische_arbeitnehmer.html', target: '_blank' },
	              'ohne Quellenbesteuerte'
	            ),
	            ') verdienen. Sie zeigen aber ebenfalls, ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'dass nicht alle Einkommen in den letzten rund 15 Jahren gleich stark gestiegen sind.'
	            ),
	            ' Das mittlere steuerbare Einkommen hat in der Stadt um etwas mehr als 20 Prozent zugenommen \u2013 bei Ledigen und Verheirateten. Die H\xE4lfte versteuert mehr, die H\xE4lfte weniger. Bei den Ledigen ist es zwischen 1999 und 2014 von 34\'500 Franken auf 42\'200, bei den Ehepaaren von 63\'100 auf 76\'500 Franken gestiegen. Diese Zahlen m\xF6gen tief erscheinen, weil sie ausblenden, dass das steuerbare Einkommen deutlich unter dem Bruttoeinkommen liegt. Ein Beispiel vom ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.vermoegenszentrum.ch/ratgeber/wissensbeitrage/privatkunden/steuern-sparen/berechnung-des-steuerbaren-einkommens.html', target: '_blank' },
	              'Verm\xF6genszentrum'
	            ),
	            ': Ein Ehepaar mit zwei Kindern lebt in einer Mietwohnung im Kanton Z\xFCrich. Es verdient brutto 100\'000 Franken im Jahr. Nach allen Abz\xFCgen liegt das steuerbare Einkommen \xFCber 40 Prozent unter dem Bruttoeinkommen, bei rund 57\'700 Franken, also unter dem mittleren Z\xFCrcher Wert.',
	            this.props.quarter != undefined && this.props.readerIsCityCitizen == true && _react2.default.createElement(
	              'span',
	              {
	                className: 'personalised text' },
	              'Zum Vergleich: Im Quartier ',
	              this.props.quarter,
	              ' betr\xE4gt das mittlere Einkommen der Ehepaare ',
	              this.state.steuerEinkommen,
	              ' Franken.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Noch st\xE4rker angestiegen ist das steuerbare Einkommen der Reichen. Wenn Verheiratete im Jahr 1999 89\'500 Franken oder mehr versteuerten, geh\xF6rten sie zu den reichsten 25 Prozent der Z\xFCrcherinnen und Z\xFCrcher. Bei den Ledigen lag die Grenze bei 53\'300 Franken. 2014 geh\xF6rte zu den reichsten 25 Prozent, wer als Ehepaar mindestens 119\'000 Franken und als Einzelperson mindestens 66\'000 Franken versteuerte: Das entspricht einer Zunahme von knapp 33 respektive rund 23 Prozent.',
	            this.props.quarter != undefined && this.props.readerIsCityCitizen == true && _react2.default.createElement(
	              'span',
	              {
	                className: 'personalised text' },
	              'In der Nachbarschaft, in der Sie wohnen, versteuerten die reichsten 25 Prozent der Ehepaare mindestens ',
	              this.state.steuernMarriedP75,
	              ' Franken und der Ledigen ',
	              this.state.steuernUnmarriedP75,
	              ' Franken.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Und bei den \xE4rmsten 25 Prozent?'
	            ),
	            ' Auch dort stieg das steuerbare Einkommen an, aber deutlich weniger: Der Grenzwert stieg von maximal 17\'600 Franken auf 19\'600 (rund 11 Prozent mehr) bei den Unverheirateten und von maximal 44\'200 auf 48\'800 (rund 10 Prozent) bei den Ehepaaren.',
	            this.props.quarter != undefined && this.props.readerIsCityCitizen == true && _react2.default.createElement(
	              'span',
	              {
	                className: 'personalised text' },
	              'Im Quartier, in dem Sie leben, versteuerten die \xE4rmsten 25 Prozent der Ledigen maximal ',
	              this.state.steuernUnmarriedP25,
	              ' Franken und der Verheirateten ',
	              this.state.steuernMarriedP25,
	              ' Franken.'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Section2;
	}(_react2.default.Component);
	
	Section2.defaultProps = {};
	
	Section2.propTypes = {
	  readerIsCityCitizen: _react2.default.PropTypes.bool,
	  readerMadeHisChoice: _react2.default.PropTypes.bool,
	  quarter: _react2.default.PropTypes.string,
	  circle: _react2.default.PropTypes.string
	};
	
	exports.default = Section2;

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImageLightbox = __webpack_require__(58);
	
	var _reactImageLightbox2 = _interopRequireDefault(_reactImageLightbox);
	
	var _ = __webpack_require__(396);
	
	var _2 = _interopRequireDefault(_);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(13);
	__webpack_require__(12);
	__webpack_require__(21);
	__webpack_require__(370);
	
	var Section3 = function (_React$Component) {
	    _inherits(Section3, _React$Component);
	
	    function Section3(props) {
	        _classCallCheck(this, Section3);
	
	        var _this = _possibleConstructorReturn(this, (Section3.__proto__ || Object.getPrototypeOf(Section3)).call(this, props));
	
	        _this.state = {
	            isOpen: false
	        };
	
	        return _this;
	    }
	
	    _createClass(Section3, [{
	        key: 'render',
	        value: function render() {
	            var _this2 = this;
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'section three wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment padded' },
	                    _react2.default.createElement('div', { className: 'ui inverted simple dimmer' }),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'section-text' },
	                        'Seit er 14 war, begleitet Oliver seine Krankheit. Ein typisches Symptom der Narkolepsie sind sogenannte ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'https://de.wikipedia.org/wiki/Kataplexie', target: '_blank' },
	                            'Kataplexien'
	                        ),
	                        ', L\xE4hmungserscheinungen. Sie treten beispielsweise beim Jassen auf, wenn Oliver ein gutes Blatt hat. Denn: \xABEmotionen l\xF6sen Anf\xE4lle aus.\xBB Oliver versuchte, sich mit der Narkolepsie zu arrangieren: ',
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Medikamente, Yoga, Meditation, Schlafpausen.'
	                        ),
	                        ' Das hat alles lange funktioniert. Im Gymnasium wurde ihm extra ein Notfallbett im Putzraum zur Verf\xFCgung gestellt. W\xE4hrend des Studiums schlief er jeweils im Kopierraum. Und weil die Arbeit als Angestellter f\xFCr den Narkoleptiker schwierig war, machte er sich im Jahr 2000 selbstst\xE4ndig.                            '
	                    ),
	                    this.state.isOpen && _react2.default.createElement(_reactImageLightbox2.default, {
	                        mainSrc: _2.default,
	                        imageCaption: 'Kosten viel Geld: Die Narkolepsie zwingt Oliver dazu, t\xE4glich Medikamente zu schlucken.',
	                        onCloseRequest: function onCloseRequest() {
	                            return _this2.setState({ isOpen: false });
	                        }
	                    }),
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'section text image wrapper' },
	                        _react2.default.createElement('img', {
	                            src: _2.default, width: '100%',
	                            onClick: function onClick() {
	                                return _this2.setState({ isOpen: true });
	                            }
	                        }),
	                        _react2.default.createElement(
	                            'p',
	                            { className: 'bild legend' },
	                            'Kosten viel Geld: Die Narkolepsie zwingt Oliver dazu, t\xE4glich Medikamente zu schlucken.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'section-text' },
	                        'Der 45-J\xE4hrige kramt aus einer durchsichtigen Plastikkiste Flyer, Plakate, Flugbl\xE4tter und Zeitungen von Z\xFCrcher Kulturinstitutionen  hervor. Er atmet schnell, pr\xE4sentiert sichtlich stolz seine Werke von fr\xFCher: \xABMan kann die Plakate direkt nebeneinander aufh\xE4ngen. Sehen Sie, die Muster gehen fliessend ineinander \xFCber.\xBB Drei Jahre hat er Grafik und Design studiert, 1995 abgeschlossen. 14 Jahre lang hat er als Selbstst\xE4ndiger von zu Hause aus einen Umsatz von 50\'000 bis 60\'000 Franken erwirtschaftet. Seine damalige Partnerin, die Mutter des gemeinsamen Sohnes, arbeitete als Lehrerin und verdiente rund 6000 Franken im Monat. ',
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\xABIch war nie reich, aber es hat gereicht.\xBB'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'section-text' },
	                        'Wenn er heute Bekannten sage, er habe kein Geld, k\xF6nnten zahlreiche das nicht einordnen, sagt Oliver. F\xFCr viele Z\xFCrcher sei man schon arm, wenn man sich nicht das neuste iPhone leisten kann. Sie k\xF6nnen es sich nicht vorstellen, wie es ist, im ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'http://www.caritas-zuerich.ch/caritaszh/hilfe-finden/guenstiger-leben/guenstige-lebensmittel-im-caritas-markt', target: '_blank' },
	                            'Caritas-Markt'
	                        ),
	                        ' einkaufen zu gehen, sich dar\xFCber Gedanken machen zu m\xFCssen, welches Brot man kauft, um einige Rappen zu sparen. Sie kennen den Preis nicht einmal. \xABIch wusste genau, welches Brot 2,80 Franken und welches 3,40 Franken kostet.\xBB'
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Section3;
	}(_react2.default.Component);
	
	Section3.defaultProps = {};
	
	Section3.propTypes = {
	    readerIsCityCitizen: _react2.default.PropTypes.bool,
	    readerMadeHisChoice: _react2.default.PropTypes.bool
	};
	
	exports.default = Section3;

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(13);
	__webpack_require__(12);
	__webpack_require__(21);
	__webpack_require__(371);
	
	var Section4 = function (_React$Component) {
	    _inherits(Section4, _React$Component);
	
	    function Section4(props) {
	        _classCallCheck(this, Section4);
	
	        return _possibleConstructorReturn(this, (Section4.__proto__ || Object.getPrototypeOf(Section4)).call(this, props));
	    }
	
	    _createClass(Section4, [{
	        key: 'render',
	        value: function render() {
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'section four wrapper' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment padded' },
	                    _react2.default.createElement('div', { className: 'ui inverted simple dimmer' }),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'section-text' },
	                        'Olivers finanzieller Abstieg beginnt 2009 mit einer Netzhautabl\xF6sung im linken Auge. Es folgen ',
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'neun Operationen, neun Vollnarkosen,'
	                        ),
	                        ' neunmal zwei bis drei Wochen Bettruhe. Die Symptome der Narkolepsie, mit der er sich arrangiert hatte, verschlimmerten sich. Es reichte nicht mehr aus, dass er sich t\xE4glich vier- bis f\xFCnfmal f\xFCr 20 Minuten hinlegt. Er muss nun jeweils 60 bis 90 Minuten schlafen. Sein Gesch\xE4ft leidet. Er kann nicht termingerecht liefern. Selbst Stammkunden springen ab.                            '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'section-text' },
	                        '2012 trennen sich er und seine Partnerin. \xABDas Leben mit einem Narkoleptiker ist anstrengend\xBB, sagt Oliver dazu. Jetzt bezahlt er die Miete alleine. Er bekommt eine Teil-IV-Rente. 40 Prozent m\xFCsste er zus\xE4tzlich noch arbeiten. Doch seine Krankheit vereinnahmt ihn mittlerweile zu stark. ',
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Das Gesch\xE4ft ist komplett eingebrochen.'
	                        ),
	                        ' Seine Mutter unterst\xFCtzt ihn ungefragt mit ein paar 100 Franken pro Monat. Doch sie bekommt Alzheimer, braucht Pflege. Mit seinem Vater hatte er sich schon lange \xFCberworfen.                            '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'section-text' },
	                        'Rund 1800 Franken IV- und 156 Franken Pensionskassen-Rente stehen zirka 1630 Franken Fixkosten gegen\xFCber: Miete, Strom, Wasser, Haftpflicht, Krankenkasse plus Franchise und Selbstbehalt, die Oliver wegen Arztbesuchen und Medikamenten jedes Jahr voll beanspruchen muss. ',
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '326 Franken bleiben ihm pro Monat zum Leben.'
	                        ),
	                        ' Rechnungen bleiben unbezahlt. Oliver beantragt eine volle IV-Rente. Es heisst, sie komme bald. Er wartet. F\xFCnfmal wird er betrieben \u2013 vom Staat und der Krankenkasse. Dann, im September 2015, wird Oliver zum Sozialhilfeempf\xE4nger. Die volle IV-Rente, die ihn wieder von der Sozialhilfe befreit, wird ihm schliesslich erst viel sp\xE4ter zugesprochen.                            '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'section-text' },
	                        'Die Armut sieht man Oliver und seiner Wohnung nicht an. B\xFCro, Schlafzimmer, Wohnzimmer, K\xFCche \u2013\xA0alles wirkt etwas unordentlich, aber es fehlt nichts. Einen Fernseher hat er nicht, daf\xFCr einen grossen Drucker: \xABEin Geschenk!\xBB, rechtfertigt er sich gleich. Wie so vieles hier in der Wohnung.                            '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'section-text' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'Armut stellt man sich anders vor:'
	                        ),
	                        ' Elend, Obdachlosigkeit, Hunger. Deshalb betrete man ein \xABMinenfeld\xBB, wenn man sich mit Armut in der Schweiz besch\xE4ftige, wie der ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'http://www.beobachter.ch/justiz-behoerde/buerger-verwaltung/artikel/armut-in-der-schweiz_wenns-wieder-nur-brot-gibt/', target: '_blank' },
	                            '\xABBeobachter\xBB'
	                        ),
	                        ' schreibt. Sozialhilfeempf\xE4nger gelten oftmals als verw\xF6hnte, faule Schmarotzer. In der Schweiz k\xF6nne jeder arbeiten, wenn er nur wolle. Wer sich einen Fernseher oder ein Handy leisten kann, ist nicht arm. Andrea G\xE4rtner sieht das anders. Die Sozialarbeiterin arbeitet in der mobilen Sozialberatung der Caritas Z\xFCrich. Sie ber\xE4t t\xE4glich Familien im Stadtkreis 12, dem Kreis mit der h\xF6chsten Sozialhilfequote. Was G\xE4rtner \xFCber g\xE4ngige Vorurteile sagt, sehen Sie im Video:                            '
	                    )
	                )
	            );
	        }
	    }]);
	
	    return Section4;
	}(_react2.default.Component);
	
	Section4.defaultProps = {};
	
	Section4.propTypes = {
	    readerIsCityCitizen: _react2.default.PropTypes.bool,
	    readerMadeHisChoice: _react2.default.PropTypes.bool
	};
	
	exports.default = Section4;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(13);
	__webpack_require__(12);
	__webpack_require__(21);
	__webpack_require__(372);
	
	var dataSource = __webpack_require__(54);
	
	var Section5 = function (_React$Component) {
	  _inherits(Section5, _React$Component);
	
	  function Section5(props) {
	    _classCallCheck(this, Section5);
	
	    var _this = _possibleConstructorReturn(this, (Section5.__proto__ || Object.getPrototypeOf(Section5)).call(this, props));
	
	    _this.state = {
	      mietPreis: 0,
	      steuerEinkommen: 0,
	      steuernMarriedP75: 0,
	      steuernUnmarriedP75: 0,
	      steuernMarriedP25: 0,
	      steuernUnmarriedP25: 0
	    };
	
	    return _this;
	  }
	
	  _createClass(Section5, [{
	    key: 'niceComma',
	    value: function niceComma(value) {
	      var str = value.toString();
	      var newValue = str.replace(".", ",");
	      return newValue;
	    }
	  }, {
	    key: 'niceNumber',
	    value: function niceNumber(value, sep) {
	      if (sep == null) {
	        sep = '\'';
	      }
	
	      value = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, sep);
	
	      return value;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (this.props.quarter != '') {
	
	        // Calculate data when new props arrive
	
	        for (var i = 0; i < dataSource.length; i++) {
	
	          if (dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Verheiratet') {
	            // console.log(dataSource[i])
	            this.setState({
	              einkArmSumMarried: dataSource[i].eink_arm_Sum,
	              antArmSumMarried: dataSource[i].ant_eink_arm
	            });
	          }
	
	          if (dataSource[i].QuarSort == props.quarter && dataSource[i].SteuerJahr == 2014 && dataSource[i].SteuerTariflang == 'Grundtarif') {
	            this.setState({
	              einkArmSumUnmarried: dataSource[i].eink_arm_Sum,
	              antArmSumUnmarried: dataSource[i].ant_eink_arm
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section four wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment padded' },
	          _react2.default.createElement('div', { className: 'ui inverted simple dimmer' }),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Zirka ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://www.lokalinfo.ch/news/?tx_ttnews%5Btt_news%5D=9540&cHash=1ad71582a19244b6ff08eb1335cb39cb', target: '_blank' },
	              '400 Menschen haben im vergangenen Winter'
	            ),
	            ' im Pfuusbus von Pfarrer Sieber in der Stadt Z\xFCrich geschlafen \u2013 im ganzen Kanton sch\xE4tzt man die Zahl der Obdachlosen auf ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://www.woerter-blog.ch/wp-content/uploads/2016/11/ta_20161116_0_0_19.pdf', target: '_blank' },
	              'rund 600'
	            ),
	            '. Sie entsprechen dem Armutsklischee, aber Tausende von Armut Betroffene, so wie Oliver, tun dies nicht. ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Was also heisst eigentlich \xABarm sein\xBB?'
	            ),
	            '                            '
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Die Frage zu beantworten, ist schwierig. Es gibt verschiedene Ans\xE4tze.',
	            _react2.default.createElement(
	              'strong',
	              null,
	              '\xA0Die absolute Definition:'
	            ),
	            ' Die Armutsgrenze entspricht dem sozialen Existenzminimum gem\xE4ss ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://skos.ch/uploads/media/2016_SKOS-Richtlinien-komplett-d.pdf', target: '_blank' },
	              'Richtlinien der Skos'
	            ),
	            ', Schweizerische Konferenz f\xFCr Sozialhilfe. F\xFCr eine Einzelperson wie Oliver heisst das: monatlich 986 Franken f\xFCr den Grundbedarf, plus Miete, plus Krankenkasse. F\xFCr eine Familie mit zwei Kindern betr\xE4gt der Grundbedarf 2110 Franken.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Die relative Definition:'
	            ),
	            ' Laut dem ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.stadt-zuerich.ch/content/dam/stzh/portal/Deutsch/Stadtrat%20&%20Stadtpraesident/Publikationen%20und%20Broschueren/Stadtratsbeschluesse/2013/Okt/StZH_StRB_2013_0917.pdf', target: '_blank' },
	              'Z\xFCrcher Stadtrat'
	            ),
	            ' gilt als armutsgef\xE4hrdet, wer weniger als 60 Prozent des mittleren Einkommens verdient. Die Armutsgrenze liegt bei der H\xE4lfte des verf\xFCgbaren mittleren Einkommens. In der Stadt Z\xFCrich waren das 2014 gem\xE4ss Steuerdaten 43\'332 Ledige (27,2 Prozent) und 9536 Ehepaare (19,9 Prozent).',
	            this.props.quarter != undefined && this.props.readerIsCityCitizen == true && _react2.default.createElement(
	              'span',
	              {
	                className: 'personalised text' },
	              'In dem Quartier, in dem Sie wohnen, waren es ',
	              this.state.einkArmSumUnmarried,
	              ' Unverheiratete (',
	              this.niceComma(this.state.antArmSumUnmarried),
	              ' Prozent) und ',
	              this.state.einkArmSumMarried,
	              ' Ehepaare (',
	              this.niceComma(this.state.antArmSumMarried),
	              ' Prozent).'
	            ),
	            '\xA0Insgesamt hat der Anteil seit 1999 um einige Prozentpunkte zugenommen \u2013 um 2,6 bei den Ledigen und 4,1 bei den Verheirateten. Am st\xE4rksten ist die relative Armut im Stadtkreis 12 angestiegen.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Section5;
	}(_react2.default.Component);
	
	Section5.defaultProps = {};
	
	Section5.propTypes = {
	  readerIsCityCitizen: _react2.default.PropTypes.bool,
	  readerMadeHisChoice: _react2.default.PropTypes.bool,
	  quarter: _react2.default.PropTypes.string,
	  circle: _react2.default.PropTypes.string
	};
	
	exports.default = Section5;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactImageLightbox = __webpack_require__(58);
	
	var _reactImageLightbox2 = _interopRequireDefault(_reactImageLightbox);
	
	var _ = __webpack_require__(397);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(398);
	
	var _4 = _interopRequireDefault(_3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(13);
	__webpack_require__(12);
	__webpack_require__(21);
	__webpack_require__(373);
	
	var Section6 = function (_React$Component) {
	  _inherits(Section6, _React$Component);
	
	  function Section6(props) {
	    _classCallCheck(this, Section6);
	
	    var _this = _possibleConstructorReturn(this, (Section6.__proto__ || Object.getPrototypeOf(Section6)).call(this, props));
	
	    _this.state = {
	      isOpen1: false,
	      isOpen2: false
	    };
	
	    return _this;
	  }
	
	  _createClass(Section6, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'section four wrapper' },
	        _react2.default.createElement(
	          'div',
	          { className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment padded' },
	          _react2.default.createElement('div', { className: 'ui inverted simple dimmer' }),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Die Berechnung der relativen Armut, basierend auf Steuerdaten, weist jedoch einige Schw\xE4chen auf und wird deshalb immer wieder kritisiert. ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Sie \xFCbersch\xE4tzt die Zahl der betroffenen Haushalte'
	            ),
	            ' und Personen, weil sie Konkubinate nicht erfasst. Zudem sind darin Studenten und Menschen mit einbezogen, die sich bewusst f\xFCr einen Lebensstil mit wenig Einkommen entschieden haben. Armut ist aber nur dann ein Problem, wenn Menschen keine andere Wahl haben. Gleichzeitig untersch\xE4tzt die relative Messung die Zahl der Betroffenen, weil quellenbesteuerte Ausl\xE4nder ohne Niederlassungsbewilligung nicht ber\xFCcksichtigt werden. In der Regel werden jene mit einem Einkommen unter 120\'000 Franken quellenbesteuert.                        '
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Daher h\xE4lt es die Armutsforschung f\xFCr ungen\xFCgend, einzig das Portemonnaie als Richtwert zu nehmen. Man ist sich einig, dass Armut ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://www.statistik.zh.ch/internet/justiz_inneres/statistik/de/aktuell/mitteilungen/2010/armutsrechner.html', target: '_blank' },
	              'vielschichtiger ist und auch immaterielle Faktoren beinhaltet.'
	            ),
	            ' Faktoren wie die Wohnsituation, Freizeit, Gesundheit, soziale Kontakte, Bildung und Zufriedenheit.'
	          ),
	          this.state.isOpen1 && _react2.default.createElement(_reactImageLightbox2.default, {
	            mainSrc: _2.default,
	            imageCaption: 'Trotz Zen: Der finanzielle Abstieg war f\xFCr Oliver eine \xABharte Pr\xFCfung\xBB.',
	            onCloseRequest: function onCloseRequest() {
	              return _this2.setState({ isOpen1: false });
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'section text image wrapper' },
	            _react2.default.createElement('img', {
	              src: _2.default, width: '100%',
	              onClick: function onClick() {
	                return _this2.setState({ isOpen1: true });
	              }
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'bild legend' },
	              'Trotz Zen: Der finanzielle Abstieg war f\xFCr Oliver eine \xABharte Pr\xFCfung\xBB.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            '\xABYoga und Zen-Meditation haben mir im Umgang mit meiner Krankheit extrem geholfen\xBB, sagt Oliver, \xABauch als ich vor gut einem Jahr ganz unten ankam.\xBB Er habe verinnerlicht, mit wenig auszukommen und daraus das Beste zu sch\xF6pfen. Es w\xE4re aber gelogen, dass er es einfach so weggesteckt h\xE4tte. Es sei eine \xABharte Pr\xFCfung\xBB seiner Lebensphilosophie gewesen. ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Er sch\xE4mte sich.'
	            ),
	            '                         '
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Immer wieder spricht Oliver davon, dass er sich gut vorstellen k\xF6nne, dass ein solcher Abstieg Depressionen oder Suizidgedanken ausl\xF6se: \xABIch hatte die nicht\xBB, beteuert er. Doch wer kein Geld habe in dieser Stadt und f\xFCr andere Menschen sorgen sollte, der komme an seine Grenzen. \xABDas Schlimmste ist, wenn Menschen unter deiner Armut leiden, die noch weniger daf\xFCr k\xF6nnen als du selbst \u2013 wie zum Beispiel mein Sohn.\xBB Und das tun viele: Rund ein Drittel der Sozialhilfebez\xFCger ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://skos.ch/uploads/media/FAQ_2013_01.pdf', target: '_blank' },
	              'sind Kinder'
	            ),
	            '.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Oliver wurde d\xFCnnh\xE4utiger. Zum Beispiel als seine Ex, mit der er eigentlich ein gutes Verh\xE4ltnis pflegt, mit ihrem Sohn nach Italien verreiste. Sie habe ihm das erst kurzfristig vor den Ferien mitgeteilt, sagt er. Sie entgegnete, sie habe es ihm schon vor l\xE4ngerer Zeit erz\xE4hlt. Egal wer recht hat, in jenem Moment machte es ihn w\xFCtend. ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Pl\xF6tzlich habe er \xABstrukturelle Gewalt\xBB gesp\xFCrt:'
	            ),
	            ' \xABDie Bank erh\xF6ht einfach so die Schreibgeb\xFChren um ein paar Franken, obwohl sie durch die Digitalisierung weniger Aufwand hat.\xBB Oder als die EC-Karte \xFCber Wochen hinweg nicht funktionierte: Die Bank suchte den Schuldigen beim Herausgeber der Karte, der Kartenherausgeber beim Apparat. \xABMir wurde wochenlang der legitime Zugriff auf mein Geld verwehrt\xBB, sagt Oliver. Da sei er in der Schalterhalle etwas laut geworden. \xABDer Sicherheitsdienst hat mich rausbegleitet.\xBB Auf einmal verstehe man, weshalb Menschen auf einem Amt ausrasten.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Nach langer Wartezeit hat Oliver eine volle IV-Rente zugesprochen bekommen. Er geh\xF6rt somit zu ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.stadt-zuerich.ch/sd/de/index/beratung/sozialhilfe/faq.html', target: '_blank' },
	              'den 60 Prozent'
	            ),
	            ', die jeweils nach rund einem Jahr die Sozialhilfe wieder verlassen k\xF6nnen. Er \xF6ffnet auf seinem Notebook eine Tabelle: \xABBudget: Stand 23.10.2016\xBB \xABSeit einigen Wochen bin ich nun raus aus der Sozialhilfe\xBB, sagt er. Oliver l\xE4chelt wie ein Kind, das ersch\xF6pft von einem langen Tag noch ein Bettm\xFCmpfeli erh\xE4lt. Die Ausgaben in der Tabelle sind in drei Kategorien unterteilt: in den Grundbedarf 2622 Franken (Miete, Essen, Krankenkasse), in jene Ausgaben, die \xABallen zugutekommen\xBB 505.75 Franken (Yoga, Ausgaben f\xFCr den Sohn, Internet) und in Luxus 477.20 Franken (Beitrag f\xFCr die Schweizerische Narkolepsie Gesellschaft, Kultur, Geschenke).'
	          ),
	          this.state.isOpen2 && _react2.default.createElement(_reactImageLightbox2.default, {
	            mainSrc: _4.default,
	            imageCaption: 'Oliver ist zuversichtlich: \xABIch schaffe das.\xBB',
	            onCloseRequest: function onCloseRequest() {
	              return _this2.setState({ isOpen2: false });
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { className: 'section text image wrapper' },
	            _react2.default.createElement('img', {
	              src: _4.default, width: '100%',
	              onClick: function onClick() {
	                return _this2.setState({ isOpen2: true });
	              }
	            }),
	            _react2.default.createElement(
	              'p',
	              { className: 'bild legend' },
	              'Oliver ist zuversichtlich: \xABIch schaffe das.\xBB'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Oliver wird nun monatlich rund 3600 Franken bekommen. IV-Rente, Erg\xE4nzungsleistungen, Kinder- und Pensionskassen-Rente. Unvorhergesehene Ausgaben k\xF6nnen Oliver aber immer noch aus der Bahn werfen. Er lebt rein rechnerisch weiterhin an der Armutsgrenze. \xABIch schaffe das. Damit komme ich durch\xBB, sagt er. Wenn er eine Frau kennen lerne, sage er aber weiterhin: ',
	            _react2.default.createElement(
	              'strong',
	              null,
	              '\xABIch bin arm. Ich bin krank und \u2026\xBB'
	            ),
	            ', es f\xE4llt ihm wieder ein, \xAB\u2026 ich will keine weiteren Kinder mehr.\xBB Nun bricht Oliver das Gespr\xE4ch ab. Er muss sich hinlegen \u2013 die Narkolepsie.'
	          ),
	          _react2.default.createElement(
	            'p',
	            { className: 'section-text' },
	            'Einige Tage sp\xE4ter schreibt Oliver ein Mail. Es sei ihm wichtig, etwas Abschliessendes zu sagen: \xABIch sehe mich als einer von vielen, die so oft nicht gesehen werden, nicht einmal von jenen, die ihnen am n\xE4chsten stehen.\xBB Das sei ein Grund mehr, weshalb er seine Geschichte nur anonymisiert wiedergeben m\xF6chte. Als Stellvertreter. Als einer von Tausenden.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Section6;
	}(_react2.default.Component);
	
	Section6.defaultProps = {};
	
	Section6.propTypes = {
	  readerIsCityCitizen: _react2.default.PropTypes.bool,
	  readerMadeHisChoice: _react2.default.PropTypes.bool
	};
	
	exports.default = Section6;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Linechart = __webpack_require__(145);
	
	var _Linechart2 = _interopRequireDefault(_Linechart);
	
	var _d3TimeFormat = __webpack_require__(30);
	
	var _d3Scale = __webpack_require__(28);
	
	var _d3Shape = __webpack_require__(39);
	
	var _d3Array = __webpack_require__(22);
	
	var _d3Selection = __webpack_require__(29);
	
	var _d3Axis = __webpack_require__(38);
	
	var _d3Format = __webpack_require__(23);
	
	var _d3Interpolate = __webpack_require__(51);
	
	var _d3Collection = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import d3 from 'd3';
	
	var dataSource = __webpack_require__(257);
	
	/************************************************************************/
	
	var SmallMultiples = function (_React$Component) {
	  _inherits(SmallMultiples, _React$Component);
	
	  function SmallMultiples(props) {
	    _classCallCheck(this, SmallMultiples);
	
	    var _this = _possibleConstructorReturn(this, (SmallMultiples.__proto__ || Object.getPrototypeOf(SmallMultiples)).call(this, props));
	
	    _this.basic = [];
	    _this.married = [];
	
	
	    _this.changeData = _this.changeData.bind(_this);
	
	    var dataByCircle = (0, _d3Collection.nest)().key(function (d) {
	      return d.KreisSort;
	    }).key(function (d) {
	      return d.SteuerTariflang;
	    }).entries(dataSource);
	
	    for (var i = 0; i < dataByCircle.length; i++) {
	      _this.basic.push([]);
	      for (var ii = 0; ii < dataByCircle[i]['values'][0]['values'].length; ii++) {
	        _this.basic[i].push({
	          title: dataByCircle[i]['values'][0]['values'][ii]['KreisSort'],
	          count: Math.round(parseFloat(dataByCircle[i]['values'][0]['values'][ii]['armindex'])),
	          absolute: Math.round(parseFloat(dataByCircle[i]['values'][0]['values'][ii]['eink_arm_Sum'])),
	          percentage: Math.round(parseFloat(dataByCircle[i]['values'][0]['values'][ii]['ant_eink_arm'])),
	          day: '01-01-' + dataByCircle[i]['values'][0]['values'][ii]['SteuerJahr']
	        });
	      }
	    }
	
	    for (var m = 0; m < dataByCircle.length; m++) {
	      _this.married.push([]);
	      for (var mm = 0; mm < dataByCircle[m]['values'][1]['values'].length; mm++) {
	        _this.married[m].push({
	          title: dataByCircle[m]['values'][1]['values'][mm]['KreisSort'],
	          count: Math.round(parseFloat(dataByCircle[m]['values'][1]['values'][mm]['armindex'])),
	          absolute: Math.round(parseFloat(dataByCircle[m]['values'][1]['values'][mm]['eink_arm_Sum'])),
	          percentage: Math.round(parseFloat(dataByCircle[m]['values'][1]['values'][mm]['ant_eink_arm'])),
	          day: '01-01-' + dataByCircle[m]['values'][1]['values'][mm]['SteuerJahr']
	        });
	      }
	    }
	
	    /* Set data states */
	
	    _this.state = {
	      actualDataSource: _this.basic,
	      actualMin: 80,
	      actualMax: 130,
	      activeButton: 'basic'
	    };
	    return _this;
	  }
	
	  _createClass(SmallMultiples, [{
	    key: 'changeData',
	    value: function changeData(e) {
	      var newDataSource = e.currentTarget.getAttribute('data-selector');
	      console.log(newDataSource);
	      console.log(newDataSource);
	      if (newDataSource == 'basic') {
	        this.setState({
	          actualDataSource: this.basic,
	          activeButton: 'basic',
	          actualMin: 70,
	          actualMax: 180
	        });
	      } else {
	        this.setState({
	          actualDataSource: this.married,
	          activeButton: 'married',
	          actualMin: 70,
	          actualMax: 180
	        });
	      }
	      console.log(this.state.actualDataSource);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var linechartData = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	
	      var appendSmallLineCharts = function appendSmallLineCharts(v, i) {
	        // console.log(v)
	        return _react2.default.createElement(_Linechart2.default, {
	          key: 'linechart-' + i,
	          chartTitle: 'Kreis ' + (i + 1),
	          width: _this2.props.width > 500 ? 160 : _this2.props.width - 60,
	          height: 130,
	          chartClassName: 'small',
	          chartId: 'linechart-' + i,
	          readerIsCityCitizen: _this2.props.readerIsCityCitizen,
	          readerMadeHisChoice: _this2.props.readerMadeHisChoice,
	          circleRadius: 3,
	          circleFill: '#E23C4E',
	          circleStroke: 0,
	          circleStrokeFill: '#ffffff',
	          tickFormatX: '%y',
	          tickFormatY: ',.0f',
	          ticksX: 5,
	          ticksY: 5,
	          minY: _this2.state.actualMin,
	          maxY: _this2.state.actualMax,
	          tooltipWidth: 70,
	          tooltipHeight: 55,
	          tooltipFontSize: 12,
	          linechartClass: 'small',
	          dataSource: _this2.state.actualDataSource[i]
	        });
	      };
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment padded linechart'
	        },
	        _react2.default.createElement('div', {
	          className: 'ui inverted simple dimmer',
	          style: {
	            display: this.state.readerMadeHisChoice ? 'none' : 'block'
	          }
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { maxWidth: '640px', margin: '0 auto', marginTop: '30px' } },
	          _react2.default.createElement(
	            'h3',
	            {
	              style: {
	                marginBottom: '0px',
	                fontFamily: 'Benton Sans Cond',
	                fontWeight: 'bold'
	              }
	            },
	            'Entwicklung der relativen Armut nach Stadtkreisen'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Die Linien zeigen die Ver\xE4nderung der relativen Armut seit 1999. Fahren Sie mit dem Cursor \xFCber die roten Punkte, um zu sehen, wie viele Menschen weniger als 50% des mittleren Einkommens versteuern.'
	          ),
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'button-wrapper',
	              style: { textAlign: 'center' }
	            },
	            _react2.default.createElement(
	              'div',
	              { className: 'ui small buttons' },
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'ui button ' + (this.state.activeButton == 'basic' ? 'active' : ''),
	                  'data-selector': 'basic',
	                  onClick: this.changeData
	                },
	                'Ledige'
	              ),
	              _react2.default.createElement('div', {
	                className: ''
	              }),
	              _react2.default.createElement(
	                'button',
	                {
	                  className: 'ui button ' + (this.state.activeButton == 'married' ? 'active' : ''),
	                  'data-selector': 'married',
	                  onClick: this.changeData
	                },
	                'Verheiratete'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'linechart-wrapper small' },
	            this.state.actualDataSource.map(appendSmallLineCharts)
	          ),
	          _react2.default.createElement(
	            'p',
	            {
	              className: 'graphic legend'
	            },
	            'Das City-Quartier im Stadtkreis 1 ist ein Spezialfall, weil dort auch Obdachlose und Personen zugerechnet werden, die ausserhalb der Stadt in einem Gef\xE4ngnis oder Heim sind.'
	          )
	        )
	      );
	    }
	  }]);
	
	  return SmallMultiples;
	}(_react2.default.Component);
	
	SmallMultiples.propTypes = {
	
	  readerMadeHisChoice: _react2.default.PropTypes.bool,
	  readerIsCityCitizen: _react2.default.PropTypes.bool,
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number
	};
	
	exports.default = SmallMultiples;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _scrollDown = __webpack_require__(251);
	
	var _scrollDown2 = _interopRequireDefault(_scrollDown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(83);
	__webpack_require__(82);
	__webpack_require__(374);
	
	var Storyhead = function (_React$Component) {
	  _inherits(Storyhead, _React$Component);
	
	  function Storyhead(props) {
	    _classCallCheck(this, Storyhead);
	
	    var _this = _possibleConstructorReturn(this, (Storyhead.__proto__ || Object.getPrototypeOf(Storyhead)).call(this, props));
	
	    _this.state = {
	      height: _this.props.height
	    };
	    return _this;
	  }
	
	  _createClass(Storyhead, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'storyhead wrapper'
	        },
	        _react2.default.createElement(
	          'section',
	          {
	            className: 'storyhead background image',
	            style: {
	              height: this.state.height
	            }
	          },
	          _react2.default.createElement(
	            'div',
	            {
	              className: 'intro-text'
	            },
	            _react2.default.createElement(
	              'h2',
	              { className: 'ui header' },
	              'Pl\xF6tzlich arm in der reichen Stadt'
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'lead'
	              },
	              _react2.default.createElement(
	                'h4',
	                {
	                  className: 'ui horizontal inverted divider'
	                },
	                'Patrice Siegrist'
	              ),
	              'In Z\xFCrich sind Zehntausende Menschen von Armut betroffen. Sie werden kaum wahrgenommen. Oliver ist einer von ihnen \u2013 eine Geschichte eines Abstiegs.'
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: 'scroll-down-wrapper'
	              },
	              _react2.default.createElement('img', {
	                src: _scrollDown2.default,
	                width: '100px',
	                className: 'scroll-animation'
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Storyhead;
	}(_react2.default.Component);
	
	Storyhead.defaultProps = {};
	
	Storyhead.propTypes = {
	  height: _react2.default.PropTypes.number
	};
	
	exports.default = Storyhead;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Scale = __webpack_require__(28);
	
	var _d3Array = __webpack_require__(22);
	
	var _d3Selection = __webpack_require__(29);
	
	var _d3Format = __webpack_require__(23);
	
	var _d3Collection = __webpack_require__(27);
	
	var _reactSvg = __webpack_require__(291);
	
	var _reactSvg2 = _interopRequireDefault(_reactSvg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// require('ta-semantic-ui/semantic/dist/components/icon.css');
	
	__webpack_require__(375);
	// import Tooltip from '../tooltip/Tooltip';
	// import ZhCircleMap from '../zhCircleMap/zhCircleMap';
	
	// import {timeParse,timeFormat} from 'd3-time-format';
	
	// import {line, curveCatmullRom} from 'd3-shape';
	
	// import {axisBottom as d3axisBottom, axisLeft as d3axisLeft} from 'd3-axis';
	
	// import {interpolate} from 'd3-interpolate';
	
	
	var localeDefinition = __webpack_require__(53);
	
	/************************************************************************/
	
	var SVGMap = function (_React$Component) {
	  _inherits(SVGMap, _React$Component);
	
	  function SVGMap(props) {
	    _classCallCheck(this, SVGMap);
	
	    var _this = _possibleConstructorReturn(this, (SVGMap.__proto__ || Object.getPrototypeOf(SVGMap)).call(this, props));
	
	    _this.colorScale = (0, _d3Scale.scaleLinear)();
	
	
	    var dataByYear = (0, _d3Collection.nest)().key(function (d) {
	      return d.Jahr;
	    }).key(function (d) {
	      return d.QuarSort;
	    }).entries(_this.props.mapData);
	
	    var actualData = [];
	
	    for (var i = 0; i < dataByYear.length; i++) {
	      if (dataByYear[i].key == _this.props.mapDataYear.toString()) {
	        actualData.push(dataByYear[i]);
	      }
	    }
	
	    var minMaxAmount = [];
	
	    for (var x = 0; x < actualData[0]['values'].length; x++) {
	      minMaxAmount.push(actualData[0]['values'][x]['values'][0]['SozialhilfeQuote']);
	    }
	
	    var dataExtent = (0, _d3Array.extent)(minMaxAmount);
	    // console.log(dataExtent);
	
	    _this.colorScale = (0, _d3Scale.scaleLinear)().domain(dataExtent).range(['#fbcecd', '#e23c4e']);
	
	    _this.state = {
	      width: _this.props.width,
	      height: _this.props.height,
	      showTooltip: false,
	      actualMapData: actualData,
	      dataMatched: false
	    };
	
	    _this.mouseEntersMapPart = _this.mouseEntersMapPart.bind(_this);
	    _this.mouseLeavesMapPart = _this.mouseLeavesMapPart.bind(_this);
	
	    return _this;
	  }
	
	  _createClass(SVGMap, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      var svgElements = document.getElementsByTagName('path');
	    }
	  }, {
	    key: 'mouseEntersMapPart',
	    value: function mouseEntersMapPart(e) {
	      var title = e.getAttribute('id');
	
	      // console.log(title);
	
	      this.setState({
	        dataMatched: false
	      });
	
	      // DESKTOP AND TOUCH DEVICE SWITCH
	      if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
	        this.setState({
	          tooltipY: 115,
	          tooltipFontSize: '0.8em'
	        });
	      } else {
	        this.setState({
	          tooltipY: 85,
	          tooltipFontSize: '1em'
	        });
	      }
	
	      // loop data to get count here
	      for (var i = 0; i < this.state.actualMapData[0]['values'].length; i++) {
	
	        if (this.state.actualMapData[0]['values'][i]['key'] == title) {
	          // console.log(this.state.actualMapData[0]['values'][i]['key'])
	          this.setState({
	            tooltipCount: this.state.actualMapData[0]['values'][i]['values'][0]['SozialhilfeQuote'],
	            tooltipCountAbsolute: this.state.actualMapData[0]['values'][i]['values'][0]['SozialhilfeBeziehende'],
	            dataMatched: true
	          });
	        }
	      }
	
	      // show tooltip here
	      this.setState({
	        showTooltip: true,
	        tooltipX: e.getAttribute('cx'),
	        tooltipTitle: title
	      });
	
	      console.log(this.state.tooltipY);
	    }
	  }, {
	    key: 'mouseLeavesMapPart',
	    value: function mouseLeavesMapPart() {
	      // hide tooltip here
	      this.setState({
	        showTooltip: false,
	        dataMatched: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.props.dataSource;
	      var locale = (0, _d3Format.formatDefaultLocale)(localeDefinition);
	
	      // to keep 'this' alive in the data.map function below
	      var _self = this;
	
	      var margin = { top: 15, right: 20, bottom: 20, left: 35 },
	          w = this.state.width - (margin.left + margin.right),
	          h = this.props.height - (margin.top + margin.bottom);
	
	      var percentageFormat = locale.format('');
	
	      data.forEach(function (d) {
	        /* */
	      });
	
	      var transform = 'translate(' + margin.left + ',' + margin.top + ')';
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'ui  dimmable ' + (this.props.readerMadeHisChoice ? '' : 'dimmed') + ' segment padded' },
	        _react2.default.createElement('div', { className: 'ui inverted simple dimmer' }),
	        this.props.mapTitle && _react2.default.createElement(
	          'h3',
	          {
	            style: {
	              marginBottom: '0px',
	              fontFamily: 'Benton Sans Cond',
	              fontWeight: 'bold'
	            } },
	          this.props.mapTitle
	        ),
	        this.props.mapLead && _react2.default.createElement(
	          'p',
	          null,
	          this.props.mapLead
	        ),
	        _react2.default.createElement(_reactSvg2.default, {
	          path: this.props.mapSource,
	          className: this.props.mapClassName,
	          callback: function callback(svg) {
	
	            var svgElements = svg.getElementsByTagName('path');
	
	            for (var c = 0; c < svgElements.length; c++) {
	              if (svgElements[c].getAttribute('id') != 'see') {
	
	                // TODO loop data through and match with id
	
	                var title = svgElements[c].getAttribute('id');
	
	                // loop data to get count here
	                for (var _i = 0; _i < _this2.state.actualMapData[0]['values'].length; _i++) {
	                  if (_this2.state.actualMapData[0]['values'][_i]['key'] == title) {
	                    var colorizeCount = _this2.state.actualMapData[0]['values'][_i]['values'][0]['SozialhilfeQuote'];
	                    (0, _d3Selection.select)(svgElements[c]).style('fill', _this2.colorScale(colorizeCount));
	                  }
	                }
	
	                {/*d3select(svgElements[c]).style('opacity', 1);*/}
	              }
	            }
	
	            // DESKTOP AND TOUCH DEVICE SWITCH
	            if ('ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0) {
	
	              // Touch
	              for (var t = 0; t < svgElements.length; t++) {
	                svgElements[t].addEventListener('touchstart', function (e) {
	                  var element = e.currentTarget;
	                  _self.mouseEntersMapPart(element);
	                });
	              }
	            } else {
	
	              // No Touch
	              for (var j = 0; j < svgElements.length; j++) {
	                svgElements[j].addEventListener('mouseleave', function (e) {
	                  e.preventDefault();
	                  _self.setState({
	                    showTooltip: false,
	                    tooltipCount: ''
	                  });
	                });
	              }
	
	              for (var i = 0; i < svgElements.length; i++) {
	                svgElements[i].addEventListener('mouseenter', function (e) {
	                  var element = e.currentTarget;
	                  _self.mouseEntersMapPart(element);
	                });
	              }
	            }
	          }
	
	        }),
	        this.state.showTooltip == true && this.state.dataMatched == true && _react2.default.createElement(
	          'p',
	          {
	            style: {
	              position: 'absolute',
	              top: this.state.tooltipY,
	              textAlign: 'center',
	              display: 'block',
	              width: '100%',
	              left: '0px',
	              fontSize: this.state.tooltipFontSize
	            }
	          },
	          this.state.tooltipTitle,
	          ':\xA0',
	          _react2.default.createElement(
	            'strong',
	            {
	              style: { borderBottom: '2px solid black' }
	            },
	            this.state.tooltipCount,
	            ' Prozent'
	          ),
	          ' (',
	          this.state.tooltipCountAbsolute,
	          ' Personen)'
	        ),
	        _react2.default.createElement(
	          'p',
	          {
	            className: 'graphic legend'
	          },
	          'Das City-Quartier im Stadtkreis 1 ist ein Spezialfall, weil dort auch Obdachlose und Personen zugerechnet werden, die ausserhalb der Stadt in einem Gef\xE4ngnis oder Heim sind.'
	        ),
	        _react2.default.createElement('br', null)
	      );
	    }
	  }]);
	
	  return SVGMap;
	}(_react2.default.Component);
	
	SVGMap.propTypes = {
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number,
	  dataSource: _react2.default.PropTypes.array,
	  mapSource: _react2.default.PropTypes.string,
	  mapTitle: _react2.default.PropTypes.string,
	  mapLead: _react2.default.PropTypes.string,
	  mapClassName: _react2.default.PropTypes.string,
	  mapId: _react2.default.PropTypes.string,
	  readerMadeHisChoice: _react2.default.PropTypes.bool,
	  tooltipWidth: _react2.default.PropTypes.number,
	  tooltipHeight: _react2.default.PropTypes.number,
	  tooltipFontSize: _react2.default.PropTypes.number,
	  mapData: _react2.default.PropTypes.array,
	  mapDataYear: _react2.default.PropTypes.number
	};
	
	exports.default = SVGMap;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	__webpack_require__(83);
	__webpack_require__(82);
	__webpack_require__(377);
	
	var Video = function (_React$Component) {
	  _inherits(Video, _React$Component);
	
	  function Video() {
	    _classCallCheck(this, Video);
	
	    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
	  }
	
	  _createClass(Video, [{
	    key: 'render',
	    value: function render() {
	
	      var videoHeight = this.props.width / 16 * 9;
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: 'video wrapper'
	        },
	        _react2.default.createElement('iframe', { width: '100%', frameBorder: '0', allowFullScreen: 'true', height: videoHeight, src: 'https://www.youtube.com/embed/UUBudztre2o' }),
	        _react2.default.createElement(
	          'p',
	          {
	            className: 'graphic legend video padding',
	            style: {
	              marginBottom: '0px'
	            }
	          },
	          'Andrea G\xE4rtner, Sozialarbeiterin der Caritas Z\xFCrich, spricht \xFCber Vorurteile gegen\xFCber der Sozialhilfe.'
	        )
	      );
	    }
	  }]);
	
	  return Video;
	}(_react2.default.Component);
	
	Video.defaultProps = {};
	
	Video.propTypes = {
	  source: _react2.default.PropTypes.string,
	  width: _react2.default.PropTypes.number,
	  height: _react2.default.PropTypes.number
	};
	
	exports.default = Video;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var utils = __webpack_require__(162);
	
	module.exports = function batchProcessorMaker(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var asyncProcess    = utils.getOption(options, "async", true);
	    var autoProcess     = utils.getOption(options, "auto", true);
	
	    if(autoProcess && !asyncProcess) {
	        reporter && reporter.warn("Invalid options combination. auto=true and async=false is invalid. Setting async=true.");
	        asyncProcess = true;
	    }
	
	    var batch = Batch();
	    var asyncFrameHandler;
	    var isProcessing = false;
	
	    function addFunction(level, fn) {
	        if(!isProcessing && autoProcess && asyncProcess && batch.size() === 0) {
	            // Since this is async, it is guaranteed to be executed after that the fn is added to the batch.
	            // This needs to be done before, since we're checking the size of the batch to be 0.
	            processBatchAsync();
	        }
	
	        batch.add(level, fn);
	    }
	
	    function processBatch() {
	        // Save the current batch, and create a new batch so that incoming functions are not added into the currently processing batch.
	        // Continue processing until the top-level batch is empty (functions may be added to the new batch while processing, and so on).
	        isProcessing = true;
	        while (batch.size()) {
	            var processingBatch = batch;
	            batch = Batch();
	            processingBatch.process();
	        }
	        isProcessing = false;
	    }
	
	    function forceProcessBatch(localAsyncProcess) {
	        if (isProcessing) {
	            return;
	        }
	
	        if(localAsyncProcess === undefined) {
	            localAsyncProcess = asyncProcess;
	        }
	
	        if(asyncFrameHandler) {
	            cancelFrame(asyncFrameHandler);
	            asyncFrameHandler = null;
	        }
	
	        if(localAsyncProcess) {
	            processBatchAsync();
	        } else {
	            processBatch();
	        }
	    }
	
	    function processBatchAsync() {
	        asyncFrameHandler = requestFrame(processBatch);
	    }
	
	    function clearBatch() {
	        batch           = {};
	        batchSize       = 0;
	        topLevel        = 0;
	        bottomLevel     = 0;
	    }
	
	    function cancelFrame(listener) {
	        // var cancel = window.cancelAnimationFrame || window.mozCancelAnimationFrame || window.webkitCancelAnimationFrame || window.clearTimeout;
	        var cancel = clearTimeout;
	        return cancel(listener);
	    }
	
	    function requestFrame(callback) {
	        // var raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || function(fn) { return window.setTimeout(fn, 20); };
	        var raf = function(fn) { return setTimeout(fn, 0); };
	        return raf(callback);
	    }
	
	    return {
	        add: addFunction,
	        force: forceProcessBatch
	    };
	};
	
	function Batch() {
	    var batch       = {};
	    var size        = 0;
	    var topLevel    = 0;
	    var bottomLevel = 0;
	
	    function add(level, fn) {
	        if(!fn) {
	            fn = level;
	            level = 0;
	        }
	
	        if(level > topLevel) {
	            topLevel = level;
	        } else if(level < bottomLevel) {
	            bottomLevel = level;
	        }
	
	        if(!batch[level]) {
	            batch[level] = [];
	        }
	
	        batch[level].push(fn);
	        size++;
	    }
	
	    function process() {
	        for(var level = bottomLevel; level <= topLevel; level++) {
	            var fns = batch[level];
	
	            for(var i = 0; i < fns.length; i++) {
	                var fn = fns[i];
	                fn();
	            }
	        }
	    }
	
	    function getSize() {
	        return size;
	    }
	
	    return {
	        add: add,
	        process: process,
	        size: getSize
	    };
	}


/***/ },
/* 162 */
/***/ function(module, exports) {

	"use strict";
	
	var utils = module.exports = {};
	
	utils.getOption = getOption;
	
	function getOption(options, name, defaultValue) {
	    var value = options[name];
	
	    if((value === undefined || value === null) && defaultValue !== undefined) {
	        return defaultValue;
	    }
	
	    return value;
	}


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(187);
	module.exports = __webpack_require__(47).Object.assign;

/***/ },
/* 164 */
/***/ function(module, exports) {

	module.exports = function(it){
	  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
	  return it;
	};

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(50);
	module.exports = function(it){
	  if(!isObject(it))throw TypeError(it + ' is not an object!');
	  return it;
	};

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(90)
	  , toLength  = __webpack_require__(184)
	  , toIndex   = __webpack_require__(183);
	module.exports = function(IS_INCLUDES){
	  return function($this, el, fromIndex){
	    var O      = toIObject($this)
	      , length = toLength(O.length)
	      , index  = toIndex(fromIndex, length)
	      , value;
	    // Array#includes uses SameValueZero equality algorithm
	    if(IS_INCLUDES && el != el)while(length > index){
	      value = O[index++];
	      if(value != value)return true;
	    // Array#toIndex ignores holes, Array#includes - not
	    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
	      if(O[index] === el)return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

/***/ },
/* 167 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function(it){
	  return toString.call(it).slice(8, -1);
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(164);
	module.exports = function(fn, that, length){
	  aFunction(fn);
	  if(that === undefined)return fn;
	  switch(length){
	    case 1: return function(a){
	      return fn.call(that, a);
	    };
	    case 2: return function(a, b){
	      return fn.call(that, a, b);
	    };
	    case 3: return function(a, b, c){
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function(/* ...args */){
	    return fn.apply(that, arguments);
	  };
	};

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(50)
	  , document = __webpack_require__(37).document
	  // in old IE typeof document.createElement is 'object'
	  , is = isObject(document) && isObject(document.createElement);
	module.exports = function(it){
	  return is ? document.createElement(it) : {};
	};

/***/ },
/* 170 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(37)
	  , core      = __webpack_require__(47)
	  , hide      = __webpack_require__(87)
	  , redefine  = __webpack_require__(180)
	  , ctx       = __webpack_require__(168)
	  , PROTOTYPE = 'prototype';
	
	var $export = function(type, name, source){
	  var IS_FORCED = type & $export.F
	    , IS_GLOBAL = type & $export.G
	    , IS_STATIC = type & $export.S
	    , IS_PROTO  = type & $export.P
	    , IS_BIND   = type & $export.B
	    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE]
	    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
	    , expProto  = exports[PROTOTYPE] || (exports[PROTOTYPE] = {})
	    , key, own, out, exp;
	  if(IS_GLOBAL)source = name;
	  for(key in source){
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if(target)redefine(target, key, out, type & $export.U);
	    // export
	    if(exports[key] != out)hide(exports, key, exp);
	    if(IS_PROTO && expProto[key] != out)expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library` 
	module.exports = $export;

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(48) && !__webpack_require__(49)(function(){
	  return Object.defineProperty(__webpack_require__(169)('div'), 'a', {get: function(){ return 7; }}).a != 7;
	});

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys  = __webpack_require__(177)
	  , gOPS     = __webpack_require__(175)
	  , pIE      = __webpack_require__(178)
	  , toObject = __webpack_require__(185)
	  , IObject  = __webpack_require__(88)
	  , $assign  = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(49)(function(){
	  var A = {}
	    , B = {}
	    , S = Symbol()
	    , K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function(k){ B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
	  var T     = toObject(target)
	    , aLen  = arguments.length
	    , index = 1
	    , getSymbols = gOPS.f
	    , isEnum     = pIE.f;
	  while(aLen > index){
	    var S      = IObject(arguments[index++])
	      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
	      , length = keys.length
	      , j      = 0
	      , key;
	    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
	  } return T;
	} : $assign;

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var anObject       = __webpack_require__(165)
	  , IE8_DOM_DEFINE = __webpack_require__(172)
	  , toPrimitive    = __webpack_require__(186)
	  , dP             = Object.defineProperty;
	
	exports.f = __webpack_require__(48) ? Object.defineProperty : function defineProperty(O, P, Attributes){
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if(IE8_DOM_DEFINE)try {
	    return dP(O, P, Attributes);
	  } catch(e){ /* empty */ }
	  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
	  if('value' in Attributes)O[P] = Attributes.value;
	  return O;
	};

/***/ },
/* 175 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var has          = __webpack_require__(86)
	  , toIObject    = __webpack_require__(90)
	  , arrayIndexOf = __webpack_require__(166)(false)
	  , IE_PROTO     = __webpack_require__(181)('IE_PROTO');
	
	module.exports = function(object, names){
	  var O      = toIObject(object)
	    , i      = 0
	    , result = []
	    , key;
	  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while(names.length > i)if(has(O, key = names[i++])){
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys       = __webpack_require__(176)
	  , enumBugKeys = __webpack_require__(170);
	
	module.exports = Object.keys || function keys(O){
	  return $keys(O, enumBugKeys);
	};

/***/ },
/* 178 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;

/***/ },
/* 179 */
/***/ function(module, exports) {

	module.exports = function(bitmap, value){
	  return {
	    enumerable  : !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable    : !(bitmap & 4),
	    value       : value
	  };
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	var global    = __webpack_require__(37)
	  , hide      = __webpack_require__(87)
	  , has       = __webpack_require__(86)
	  , SRC       = __webpack_require__(91)('src')
	  , TO_STRING = 'toString'
	  , $toString = Function[TO_STRING]
	  , TPL       = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(47).inspectSource = function(it){
	  return $toString.call(it);
	};
	
	(module.exports = function(O, key, val, safe){
	  var isFunction = typeof val == 'function';
	  if(isFunction)has(val, 'name') || hide(val, 'name', key);
	  if(O[key] === val)return;
	  if(isFunction)has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if(O === global){
	    O[key] = val;
	  } else {
	    if(!safe){
	      delete O[key];
	      hide(O, key, val);
	    } else {
	      if(O[key])O[key] = val;
	      else hide(O, key, val);
	    }
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString(){
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(182)('keys')
	  , uid    = __webpack_require__(91);
	module.exports = function(key){
	  return shared[key] || (shared[key] = uid(key));
	};

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(37)
	  , SHARED = '__core-js_shared__'
	  , store  = global[SHARED] || (global[SHARED] = {});
	module.exports = function(key){
	  return store[key] || (store[key] = {});
	};

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(89)
	  , max       = Math.max
	  , min       = Math.min;
	module.exports = function(index, length){
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(89)
	  , min       = Math.min;
	module.exports = function(it){
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(85);
	module.exports = function(it){
	  return Object(defined(it));
	};

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(50);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function(it, S){
	  if(!isObject(it))return it;
	  var fn, val;
	  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
	  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
	  throw TypeError("Can't convert object to primitive value");
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(171);
	
	$export($export.S + $export.F, 'Object', {assign: __webpack_require__(173)});

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".masthead-component.masthead-component.masthead-component{position:fixed;border-bottom:1px solid rgba(0,0,0,.2);top:0;left:0;width:100%;z-index:100;padding:0;background:rgba(0,0,0,.6)}.masthead-component.masthead-component.masthead-component.inverted{border-bottom:1px solid hsla(0,0%,100%,.2);color:#f5f5f5}.masthead-component.masthead-component.masthead-component .logo{margin:1.414ex 0;max-height:3ex;width:auto}.masthead-component.masthead-component+*>*>:first-child:before{content:'';display:block;height:80px}", ""]);
	
	// exports


/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}.white-blue-link{color:#fff}.white-blue-link:hover{color:#4099ff}.footer-wrapper{margin-top:20px}", ""]);
	
	// exports


/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}.identificator.wrapper{width:100%;max-width:640px;margin:0 auto;margin-top:50px;margin-bottom:50px}p.search-label{margin-top:15px!important}.ui.large.icon.input{width:100%}.ui.compact.message.identificator{min-width:320px!important}p.identificator.question.title{font-family:Benton Sans Cond;font-weight:800}div.selection.reset.box{margin-top:-30px}div.react-autosuggest__container{border-radius:2px;text-align:center}.ui.icon.input input{padding-right:2px!important;padding-top:11px}", ""]);
	
	// exports


/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}div.section.small.line.chart{max-width:900px;margin:30px auto;height:auto}.small.line.chart.wrapper{width:25%;float:left}.line.shadow{fill:none;stroke:#000;stroke-width:1px}svg#linechartLarge{width:100%;max-width:640px;display:block;float:left;margin:0 auto}div.small.linechart{width:25%;display:block;float:left}div.linechart-wrapper-small{width:100%;display:block;min-height:380px}div.linechart-wrapper.small{min-height:530px}svg{overflow:visible}svg.small{float:left;width:25%;max-width:160px}svg.large{float:left;width:100%;float:none}svg>*{shape-rendering:geometricPrecision}line.axis{stroke-width:.5px}p.diagram.title.small{margin:0;margin-bottom:0;padding-top:15px;font-family:benton sans cond;font-weight:800;font-size:.9em}div.small .tick>text{font-size:10px}circle:hover{cursor:pointer}@media screen and (max-width:500px){div.ui.dimmable.segment.padded.linechart.small{width:100%}}@media screen and (max-width:640px){div.linechart-wrapper.small{height:2028px}}", ""]);
	
	// exports


/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}div.section.small.line.chart{max-width:900px;margin:30px auto;height:auto}.small.line.chart.wrapper{width:25%;float:left}.line.shadow{fill:none;stroke-width:1px}.line.shadow.p25{stroke:#e23c4e}.line.shadow.p75{stroke:#000}.line.shadow.p50{stroke:#1d5f82}svg#linechartLarge{width:100%;max-width:640px;display:block;float:left;margin:0 auto}div.small.linechart{width:25%;display:block;float:left}div.large.linechart{width:100%;max-width:640px;float:none;margin:0 auto}div.linechart-wrapper{width:100%;display:block;min-height:240px}div.linechart-wrapper.small{min-height:530px}#svg-linechart-large{width:100%;max-width:640px;margin:0 auto;height:520px}@media screen and (max-width:500px){#svg-linechart-large{height:250px}}.ui.dimmable.segment.padded.linechart.large{height:475px}@media screen and (max-width:500px){.ui.dimmable.segment.padded.linechart.large{height:150px}}svg{overflow:visible}svg.small{float:left;width:25%;max-width:160px}svg.large{float:left;width:100%;max-width:640px;float:none}svg>*{shape-rendering:geometricPrecision}line.axis{stroke-width:.5px}p.diagram.title.small{margin:0;margin-bottom:0;padding-top:15px;font-family:benton sans cond;font-weight:800;font-size:.9em}div.small .tick>text{font-size:10px}circle:hover{cursor:pointer}", ""]);
	
	// exports


/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}.wrapper.section.one{margin-top:-30px;margin-bottom:10px}div.ui.dimmable.segment.padded{padding:0;margin:0 auto;max-width:640px}span.personalised.text{border-bottom:2px solid #e23c4e;padding:0 3px}@media screen and (max-width:639px){.ui.dimmable.segment.mobile-padding>*{padding:0 10px}}", ""]);
	
	// exports


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}.wrapper.section.two{margin-top:0}@media screen and (max-width:650px){div.ui.dimmable.segment.padded{padding:0 10px}}span.personalised.text{border-bottom:2px solid #e23c4e;padding:0 3px}", ""]);
	
	// exports


/***/ },
/* 195 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}.wrapper.section.trhee{margin-top:50px}div.ui.dimmable.segment.padded{padding:0;margin:0 auto;max-width:640px}.segment{max-width:640px}@media screen and (max-width:650px){div.ui.dimmable.segment.padded{padding:0 10px}}", ""]);
	
	// exports


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}.wrapper.section.four{margin-top:50px;margin-bottom:50px}@media screen and (max-width:650px){div.ui.dimmable.segment.padded{padding:0 10px}}", ""]);
	
	// exports


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}.wrapper.section.four{margin-top:50px;margin-bottom:50px}@media screen and (max-width:650px){div.ui.dimmable.segment.padded{padding:0 10px}}span.personalised.text{border-bottom:2px solid #e23c4e;padding:0 3px}", ""]);
	
	// exports


/***/ },
/* 198 */
196,
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}.storyhead.wrapper{height:100vh;width:100vw}.storyhead.wrapper .intro-text{width:100%;max-width:640px;margin:0 auto;position:relative;top:calc(40% - 80px)}@media screen and (max-width:650px){.storyhead.wrapper .intro-text{top:calc(30% - 80px)}}.storyhead.wrapper .intro-text h2{text-align:center;font-family:Benton Sans Cond;font-weight:800;background:rgba(0,0,0,.5);color:#fff;padding:10px;font-size:2.3em}@media screen and (max-width:500px){.storyhead.wrapper .intro-text h2{font-size:2em;padding:0 5px}}.storyhead.wrapper .intro-text div.lead,.storyhead.wrapper .intro-text p.lead{font-size:20pxe;text-align:center;font-family:Benton Sans Cond;font-weight:400;background:rgba(0,0,0,.5);color:#fff;padding:10px}@media screen and (max-width:500px){.storyhead.wrapper .intro-text div.lead,.storyhead.wrapper .intro-text p.lead{font-size:16px;padding:0 5px}}.storyhead.wrapper .intro-text h4.divider{text-transform:none;font-family:Benton Sans Cond;font-weight:200;background:rgba(0,0,0,.5);color:#fff;padding:10px;margin-top:0!important}.storyhead.background.image{background:#000;background:url(" + __webpack_require__(399) + ");background-position:50%;background-size:cover;background-repeat:no-repeat;width:100%!important}.scroll-down-wrapper{text-align:center}.scroll-animation{-webkit-animation:scroll 2s infinite ease;-moz-animation:scroll 2s infinite ease;-o-animation:scroll 2s infinite ease}@-webkit-keyframes scroll{0%{-webkit-transform:translateY(0);opacity:0}to{-webkit-transform:translateY(10px);opacity:1}}", ""]);
	
	// exports


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}.wrapper.svg-map{margin-top:50px;margin-bottom:20px}.section.svg.map.zh-circle{max-width:640px;margin:0 auto}svg{float:none}svg path:hover{cursor:pointer}g.tooltip-wrapper.map{position:absolute;left:0}h3{font-size:1.5em}", ""]);
	
	// exports


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}", ""]);
	
	// exports


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "h4.divider{background:none!important;margin-top:0}.text-center{text-align:center}.padded{width:100%;max-width:640px;margin:0 auto}.bentonFat{font-weight:800}.bentonFat,.bentonLight{font-family:Benton Sans Cond}.bentonLight{font-weight:200}p.section-text{font-family:Georgia!important}.ui.dimmable.segment.linechart{padding:0}.ui.dimmable.segment{margin:0 auto}@media screen and (min-width:640px){.ui.dimmable.segment .ui.dimmable.segment{padding:0!important}}div.text.image.wrapper{margin-top:30px;margin-bottom:30px}div.ril-caption>div{margin:0 auto!important;font-family:Benton Sans Cond}div.section.text.image.wrapper>img:hover{cursor:pointer}p.graphic.legend{font-size:.9em;color:gray}div.overlay.fullscreen{position:fixed;background:#5a686d;width:100vw;height:100vh;padding:10px;color:#fff;z-index:9999}.bild.legend{color:gray}.hover-table:hover{cursor:pointer}.hover-table:hover td{color:#007abf}@media screen and (max-width:640px){.graphic.legend.video.padding{padding:0 10px}}", ""]);
	
	// exports


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Accordion\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.accordion,.ui.accordion .accordion{max-width:100%}.ui.accordion .accordion{margin:1em 0 0;padding:0}.ui.accordion .accordion .title,.ui.accordion .title{cursor:pointer}.ui.accordion .title:not(.ui){padding:.5em 0;font-family:Publico Headline,Georgia,serif;font-size:1em;color:rgba(0,0,0,.87)}.ui.accordion .accordion .title~.content,.ui.accordion .title~.content{display:none}.ui.accordion:not(.styled) .accordion .title~.content:not(.ui),.ui.accordion:not(.styled) .title~.content:not(.ui){margin:'';padding:.5em 0 1em}.ui.accordion:not(.styled) .title~.content:not(.ui):last-child{padding-bottom:0}.ui.accordion .accordion .title .dropdown.icon,.ui.accordion .title .dropdown.icon{display:inline-block;float:none;opacity:1;width:1.25em;height:1em;margin:0 .25rem 0 0;padding:0;font-size:1em;-webkit-transition:opacity .1s ease,-webkit-transform .1s ease;transition:opacity .1s ease,-webkit-transform .1s ease;transition:transform .1s ease,opacity .1s ease;transition:transform .1s ease,opacity .1s ease,-webkit-transform .1s ease;vertical-align:baseline;-webkit-transform:none;transform:none}.ui.accordion.menu .item .title{display:block;padding:0}.ui.accordion.menu .item .title>.dropdown.icon{float:right;margin:.207em 0 0 1em;-webkit-transform:rotate(180deg);transform:rotate(180deg)}.ui.accordion .ui.header .dropdown.icon{font-size:1em;margin:0 .25rem 0 0}.ui.accordion .accordion .active.title .dropdown.icon,.ui.accordion .active.title .dropdown.icon,.ui.accordion.menu .item .active.title>.dropdown.icon{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.ui.styled.accordion{width:600px}.ui.styled.accordion,.ui.styled.accordion .accordion{border-radius:.11764706rem;background:#fff;box-shadow:none,0 0 0 1px rgba(34,36,38,.15)}.ui.styled.accordion .accordion .title,.ui.styled.accordion .title{margin:0;padding:.75em 1em;color:rgba(0,0,0,.4);font-weight:700;border-top:1px solid rgba(34,36,38,.15);-webkit-transition:background .1s ease,color .1s ease;transition:background .1s ease,color .1s ease}.ui.styled.accordion .accordion .title:first-child,.ui.styled.accordion>.title:first-child{border-top:none}.ui.styled.accordion .accordion .content,.ui.styled.accordion .content{margin:0;padding:.5em 1em 1.5em}.ui.styled.accordion .accordion .content{padding:0;padding:.5em 1em 1.5em}.ui.styled.accordion .accordion .active.title,.ui.styled.accordion .accordion .title:hover,.ui.styled.accordion .active.title,.ui.styled.accordion .title:hover{background:transparent;color:rgba(0,0,0,.87)}.ui.styled.accordion .accordion .active.title,.ui.styled.accordion .active.title{background:transparent;color:rgba(0,0,0,.95)}.ui.accordion .accordion .active.content,.ui.accordion .active.content{display:block}.ui.fluid.accordion,.ui.fluid.accordion .accordion{width:100%}.ui.inverted.accordion .title:not(.ui){color:hsla(0,0%,100%,.9)}@font-face{font-family:Accordion;src:url(data:application/x-font-ttf;charset=utf-8;base64,AAEAAAALAIAAAwAwT1MvMggjB5AAAAC8AAAAYGNtYXAPfOIKAAABHAAAAExnYXNwAAAAEAAAAWgAAAAIZ2x5Zryj6HgAAAFwAAAAyGhlYWT/0IhHAAACOAAAADZoaGVhApkB5wAAAnAAAAAkaG10eAJuABIAAAKUAAAAGGxvY2EAjABWAAACrAAAAA5tYXhwAAgAFgAAArwAAAAgbmFtZfC1n04AAALcAAABPHBvc3QAAwAAAAAEGAAAACAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAAAAAAAAAIAADc5AQAAAAABAAAAAAAAAAAAAgAANzkBAAAAAAEAAAAAAAAAAAACAAA3OQEAAAAAAQASAEkAtwFuABMAADc0PwE2FzYXFh0BFAcGJwYvASY1EgaABQgHBQYGBQcIBYAG2wcGfwcBAQcECf8IBAcBAQd/BgYAAAAAAQAAAEkApQFuABMAADcRNDc2MzIfARYVFA8BBiMiJyY1AAUGBwgFgAYGgAUIBwYFWwEACAUGBoAFCAcFgAYGBQcAAAABAAAAAQAAqWYls18PPPUACwIAAAAAAM/9o+4AAAAAz/2j7gAAAAAAtwFuAAAACAACAAAAAAAAAAEAAAHg/+AAAAIAAAAAAAC3AAEAAAAAAAAAAAAAAAAAAAAGAAAAAAAAAAAAAAAAAQAAAAC3ABIAtwAAAAAAAAAKABQAHgBCAGQAAAABAAAABgAUAAEAAAAAAAIAAAAAAAAAAAAAAAAAAAAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('truetype'),url(data:application/font-woff;charset=utf-8;base64,d09GRk9UVE8AAASwAAoAAAAABGgAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABDRkYgAAAA9AAAAS0AAAEtFpovuE9TLzIAAAIkAAAAYAAAAGAIIweQY21hcAAAAoQAAABMAAAATA984gpnYXNwAAAC0AAAAAgAAAAIAAAAEGhlYWQAAALYAAAANgAAADb/0IhHaGhlYQAAAxAAAAAkAAAAJAKZAedobXR4AAADNAAAABgAAAAYAm4AEm1heHAAAANMAAAABgAAAAYABlAAbmFtZQAAA1QAAAE8AAABPPC1n05wb3N0AAAEkAAAACAAAAAgAAMAAAEABAQAAQEBB3JhdGluZwABAgABADr4HAL4GwP4GAQeCgAZU/+Lix4KABlT/4uLDAeLa/iU+HQFHQAAAHkPHQAAAH4RHQAAAAkdAAABJBIABwEBBw0PERQZHnJhdGluZ3JhdGluZ3UwdTF1MjB1RjBEOXVGMERBAAACAYkABAAGAQEEBwoNVp38lA78lA78lA77lA773Z33bxWLkI2Qj44I9xT3FAWOj5CNkIuQi4+JjoePiI2Gi4YIi/uUBYuGiYeHiIiHh4mGi4aLho2Ijwj7FPcUBYeOiY+LkAgO+92L5hWL95QFi5CNkI6Oj4+PjZCLkIuQiY6HCPcU+xQFj4iNhouGi4aJh4eICPsU+xQFiIeGiYaLhouHjYePiI6Jj4uQCA74lBT4lBWLDAoAAAAAAwIAAZAABQAAAUwBZgAAAEcBTAFmAAAA9QAZAIQAAAAAAAAAAAAAAAAAAAABEAAAAAAAAAAAAAAAAAAAAABAAADw2gHg/+D/4AHgACAAAAABAAAAAAAAAAAAAAAgAAAAAAACAAAAAwAAABQAAwABAAAAFAAEADgAAAAKAAgAAgACAAEAIPDa//3//wAAAAAAIPDZ//3//wAB/+MPKwADAAEAAAAAAAAAAAAAAAEAAf//AA8AAQAAAAEAADfYOJZfDzz1AAsCAAAAAADP/aPuAAAAAM/9o+4AAAAAALcBbgAAAAgAAgAAAAAAAAABAAAB4P/gAAACAAAAAAAAtwABAAAAAAAAAAAAAAAAAAAABgAAAAAAAAAAAAAAAAEAAAAAtwASALcAAAAAUAAABgAAAAAADgCuAAEAAAAAAAEADAAAAAEAAAAAAAIADgBAAAEAAAAAAAMADAAiAAEAAAAAAAQADABOAAEAAAAAAAUAFgAMAAEAAAAAAAYABgAuAAEAAAAAAAoANABaAAMAAQQJAAEADAAAAAMAAQQJAAIADgBAAAMAAQQJAAMADAAiAAMAAQQJAAQADABOAAMAAQQJAAUAFgAMAAMAAQQJAAYADAA0AAMAAQQJAAoANABaAHIAYQB0AGkAbgBnAFYAZQByAHMAaQBvAG4AIAAxAC4AMAByAGEAdABpAG4AZ3JhdGluZwByAGEAdABpAG4AZwBSAGUAZwB1AGwAYQByAHIAYQB0AGkAbgBnAEYAbwBuAHQAIABnAGUAbgBlAHIAYQB0AGUAZAAgAGIAeQAgAEkAYwBvAE0AbwBvAG4ALgADAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA) format('woff');font-weight:400;font-style:normal}.ui.accordion .accordion .title .dropdown.icon,.ui.accordion .title .dropdown.icon{font-family:Accordion;line-height:1;-webkit-backface-visibility:hidden;backface-visibility:hidden;font-weight:400;font-style:normal;text-align:center}.ui.accordion .accordion .title .dropdown.icon:before,.ui.accordion .title .dropdown.icon:before{content:'\\F0DA'}", ""]);
	
	// exports


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Button\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.button{cursor:pointer;display:inline-block;min-height:1em;outline:none;border:none;vertical-align:baseline;background:#e0e1e2 none;font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;margin:0 .25em 0 0;padding:.64705882em 1.5em;text-transform:none;text-shadow:none;font-weight:500;line-height:1em;font-style:normal;text-align:center;text-decoration:none;border-radius:.11764706rem;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transition:opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease;transition:opacity .1s ease,background-color .1s ease,color .1s ease,box-shadow .1s ease,background .1s ease;will-change:'';-webkit-tap-highlight-color:transparent}.ui.button,.ui.button:hover{color:#007abf;box-shadow:inset 0 0 0 1px transparent,inset 0 0 0 0 rgba(34,36,38,.15)}.ui.button:hover{background-color:#cacbcd;background-image:none}.ui.button:hover .icon{opacity:.85}.ui.button:focus{background-color:#cacbcd;color:#007abf;background-image:''!important;box-shadow:''!important}.ui.button:focus .icon{opacity:.85}.ui.active.button:active,.ui.button:active{background-color:#babbbc;background-image:'';color:rgba(0,0,0,.9);box-shadow:inset 0 0 0 1px transparent,none}.ui.active.button{box-shadow:inset 0 0 0 1px transparent}.ui.active.button,.ui.active.button:hover{color:rgba(0,0,0,.95)}.ui.active.button,.ui.active.button:active,.ui.active.button:hover{background-color:#c0c1c2;background-image:none}.ui.loading.loading.loading.loading.loading.loading.button{position:relative;cursor:default;text-shadow:none!important;color:transparent!important;opacity:1;pointer-events:auto;-webkit-transition:all 0s linear,opacity .1s ease;transition:all 0s linear,opacity .1s ease}.ui.loading.button:before{border-radius:500rem;border:.2em solid rgba(0,0,0,.15)}.ui.loading.button:after,.ui.loading.button:before{position:absolute;content:'';top:50%;left:50%;margin:-.64705882em 0 0 -.64705882em;width:1.29411765em;height:1.29411765em}.ui.loading.button:after{-webkit-animation:button-spin .6s linear;animation:button-spin .6s linear;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;border-radius:500rem;border-color:#fff transparent transparent;border-style:solid;border-width:.2em;box-shadow:0 0 0 1px transparent}.ui.labeled.icon.loading.button .icon{background-color:transparent;box-shadow:none}@-webkit-keyframes button-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes button-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ui.basic.loading.button:not(.inverted):before{border-color:rgba(0,0,0,.1)}.ui.basic.loading.button:not(.inverted):after{border-top-color:#5a686d}.ui.button:disabled,.ui.buttons .disabled.button,.ui.disabled.active.button,.ui.disabled.button,.ui.disabled.button:hover{cursor:default;opacity:.45!important;background-image:none!important;box-shadow:none!important;pointer-events:none!important}.ui.basic.buttons .ui.disabled.button{border-color:rgba(34,36,38,.5)}.ui.animated.button{position:relative;overflow:hidden;padding-right:0!important;vertical-align:middle;z-index:1}.ui.animated.button .content{will-change:transform,opacity}.ui.animated.button .visible.content{position:relative;margin-right:1.5em}.ui.animated.button .hidden.content{position:absolute;width:100%}.ui.animated.button .hidden.content,.ui.animated.button .visible.content{-webkit-transition:right .3s ease 0s;transition:right .3s ease 0s}.ui.animated.button .visible.content{left:auto;right:0}.ui.animated.button .hidden.content{top:50%;left:auto;right:-100%;margin-top:-.5em}.ui.animated.button:focus .visible.content,.ui.animated.button:hover .visible.content{left:auto;right:200%}.ui.animated.button:focus .hidden.content,.ui.animated.button:hover .hidden.content{left:auto;right:0}.ui.vertical.animated.button .hidden.content,.ui.vertical.animated.button .visible.content{-webkit-transition:top .3s ease,-webkit-transform .3s ease;transition:top .3s ease,-webkit-transform .3s ease;transition:top .3s ease,transform .3s ease;transition:top .3s ease,transform .3s ease,-webkit-transform .3s ease}.ui.vertical.animated.button .visible.content{-webkit-transform:translateY(0);transform:translateY(0);right:auto}.ui.vertical.animated.button .hidden.content{top:-50%;left:0;right:auto}.ui.vertical.animated.button:focus .visible.content,.ui.vertical.animated.button:hover .visible.content{-webkit-transform:translateY(200%);transform:translateY(200%);right:auto}.ui.vertical.animated.button:focus .hidden.content,.ui.vertical.animated.button:hover .hidden.content{top:50%;right:auto}.ui.fade.animated.button .hidden.content,.ui.fade.animated.button .visible.content{-webkit-transition:opacity .3s ease,-webkit-transform .3s ease;transition:opacity .3s ease,-webkit-transform .3s ease;transition:opacity .3s ease,transform .3s ease;transition:opacity .3s ease,transform .3s ease,-webkit-transform .3s ease}.ui.fade.animated.button .visible.content{left:auto;right:auto;opacity:1;-webkit-transform:scale(1);transform:scale(1)}.ui.fade.animated.button .hidden.content{opacity:0;left:0;right:auto;-webkit-transform:scale(1.5);transform:scale(1.5)}.ui.fade.animated.button:focus .visible.content,.ui.fade.animated.button:hover .visible.content{left:auto;right:auto;opacity:0;-webkit-transform:scale(.75);transform:scale(.75)}.ui.fade.animated.button:focus .hidden.content,.ui.fade.animated.button:hover .hidden.content{left:0;right:auto;opacity:1;-webkit-transform:scale(1);transform:scale(1)}.ui.inverted.button{box-shadow:inset 0 0 0 0 #fff!important;background:transparent none;color:#fff;text-shadow:none!important}.ui.inverted.buttons .button{margin:0}.ui.inverted.buttons .button:first-child{margin-left:0}.ui.inverted.vertical.buttons .button{margin:0}.ui.inverted.vertical.buttons .button:first-child{margin-top:0}.ui.inverted.button.active,.ui.inverted.button:focus,.ui.inverted.button:hover{background:#fff;box-shadow:inset 0 0 0 0 #fff!important;color:#007abf}.ui.inverted.button.active:focus{background:#dcddde;box-shadow:inset 0 0 0 0 #dcddde!important;color:#007abf}.ui.labeled.button:not(.icon){display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;background:none!important;padding:0!important;border:none!important;box-shadow:none!important}.ui.labeled.button>.button{margin:0}.ui.labeled.button>.label{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:0 0 0 -1px!important;padding:'';font-size:1em;border-color:rgba(34,36,38,.15)}.ui.labeled.button>.tag.label:before{width:1.85em;height:1.85em}.ui.labeled.button:not([class*=\"left labeled\"])>.button{border-top-right-radius:0;border-bottom-right-radius:0}.ui.labeled.button:not([class*=\"left labeled\"])>.label,.ui[class*=\"left labeled\"].button>.button{border-top-left-radius:0;border-bottom-left-radius:0}.ui[class*=\"left labeled\"].button>.label{border-top-right-radius:0;border-bottom-right-radius:0}.ui.facebook.button{background-color:#4b68b8;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.facebook.button:hover{background-color:#3d5bad;color:#fff;text-shadow:none}.ui.facebook.button:active{background-color:#3b5395;color:#fff;text-shadow:none}.ui.twitter.button{background-color:#1dadeb;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.twitter.button:hover{background-color:#09a3e5;color:#fff;text-shadow:none}.ui.twitter.button:active{background-color:#118ec4;color:#fff;text-shadow:none}.ui.google.plus.button{background-color:#dd4b39;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.google.plus.button:hover{background-color:#e0321c;color:#fff;text-shadow:none}.ui.google.plus.button:active{background-color:#c23321;color:#fff;text-shadow:none}.ui.linkedin.button{background-color:#1f88be;color:#fff;text-shadow:none}.ui.linkedin.button:hover{background-color:#147baf;color:#fff;text-shadow:none}.ui.linkedin.button:active{background-color:#186992;color:#fff;text-shadow:none}.ui.youtube.button{background-color:#cc181e;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.youtube.button:hover{background-color:#bd0d13;color:#fff;text-shadow:none}.ui.youtube.button:active{background-color:#9e1317;color:#fff;text-shadow:none}.ui.instagram.button{background-color:#49769c;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.instagram.button:hover{background-color:#3d698e;color:#fff;text-shadow:none}.ui.instagram.button:active{background-color:#395c79;color:#fff;text-shadow:none}.ui.pinterest.button{background-color:#bd081c;color:#fff;text-shadow:none;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.pinterest.button:hover{background-color:#ac0013;color:#fff;text-shadow:none}.ui.pinterest.button:active{background-color:#8c0615;color:#fff;text-shadow:none}.ui.vk.button{background-color:#4d7198;color:#fff;background-image:none;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.vk.button:hover{background-color:#41648a;color:#fff}.ui.vk.button:active{background-color:#3c5876;color:#fff}.ui.button>.icon:not(.button){height:.76470588em;opacity:.8;-webkit-transition:opacity .1s ease;transition:opacity .1s ease;vertical-align:'';color:''}.ui.button:not(.icon)>.icon:not(.button):not(.dropdown),.ui.button>.icon:not(.button){margin:0 .35294118em 0 -.17647059em}.ui.button:not(.icon)>.right.icon:not(.button):not(.dropdown){margin:0 -.17647059em 0 .35294118em}.ui[class*=\"left floated\"].button,.ui[class*=\"left floated\"].buttons{float:left;margin-left:0;margin-right:.25em}.ui[class*=\"right floated\"].button,.ui[class*=\"right floated\"].buttons{float:right;margin-right:0;margin-left:.25em}.ui.compact.button,.ui.compact.buttons .button{padding:.48529412em 1.125em}.ui.compact.icon.button,.ui.compact.icon.buttons .button{padding:.48529412em}.ui.compact.labeled.icon.button,.ui.compact.labeled.icon.buttons .button{padding:.48529412em 3.41911765em}.ui.mini.button,.ui.mini.buttons .button,.ui.mini.buttons .or{font-size:.64705882rem}.ui.tiny.button,.ui.tiny.buttons .button,.ui.tiny.buttons .or{font-size:.76470588rem}.ui.small.button,.ui.small.buttons .button,.ui.small.buttons .or{font-size:.82352941rem}.ui.button,.ui.buttons .button,.ui.buttons .or{font-size:1rem}.ui.large.button,.ui.large.buttons .button,.ui.large.buttons .or{font-size:1.11764706rem}.ui.big.button,.ui.big.buttons .button,.ui.big.buttons .or{font-size:1.29411765rem}.ui.huge.button,.ui.huge.buttons .button,.ui.huge.buttons .or{font-size:1.41176471rem}.ui.massive.button,.ui.massive.buttons .button,.ui.massive.buttons .or{font-size:1.58823529rem}.ui.icon.button,.ui.icon.buttons .button{padding:.64705882em}.ui.icon.button>.icon,.ui.icon.buttons .button>.icon{opacity:.9;margin:0;vertical-align:top}.ui.basic.button,.ui.basic.buttons .button{background:transparent none!important;color:#007abf!important;font-weight:500;border-radius:.11764706rem;text-transform:none;text-shadow:none!important;box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.basic.buttons{box-shadow:none;border:0 solid rgba(34,36,38,.15);border-radius:.11764706rem}.ui.basic.buttons .button{border-radius:0}.ui.basic.button:focus,.ui.basic.button:hover,.ui.basic.buttons .button:focus,.ui.basic.buttons .button:hover{background:rgba(0,0,0,.05)!important;color:#007abf!important;box-shadow:none}.ui.basic.button:active,.ui.basic.buttons .button:active{background:rgba(0,0,0,.1)!important;color:rgba(0,0,0,.9)!important;box-shadow:inset 0 0 0 0 rgba(0,0,0,.15),inset 0 1px 4px 0 rgba(34,36,38,.15)}.ui.basic.active.button,.ui.basic.buttons .active.button{background:rgba(0,0,0,.05)!important;box-shadow:''!important;color:rgba(0,0,0,.95);box-shadow:rgba(34,36,38,.35)}.ui.basic.active.button:hover,.ui.basic.buttons .active.button:hover{background-color:rgba(0,0,0,.05)}.ui.basic.buttons .button:hover{box-shadow:inset none}.ui.basic.buttons .button:active{box-shadow:inset 0 0 0 0 rgba(0,0,0,.15),inset inset 0 1px 4px 0 rgba(34,36,38,.15)}.ui.basic.buttons .active.button{box-shadow:inset rgba(34,36,38,.35)}.ui.basic.inverted.button,.ui.basic.inverted.buttons .button{background-color:transparent!important;color:#f9fafb!important;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important}.ui.basic.inverted.button:focus,.ui.basic.inverted.button:hover,.ui.basic.inverted.buttons .button:focus,.ui.basic.inverted.buttons .button:hover{color:#fff!important;box-shadow:inset 0 0 0 0 #fff!important}.ui.basic.inverted.button:active,.ui.basic.inverted.buttons .button:active{background-color:hsla(0,0%,100%,.08)!important;color:#fff!important;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.9)!important}.ui.basic.inverted.active.button,.ui.basic.inverted.buttons .active.button{background-color:hsla(0,0%,100%,.08);color:#fff;text-shadow:none;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.7)}.ui.basic.buttons .button{border-left:0 solid rgba(34,36,38,.15);box-shadow:none}.ui.basic.vertical.buttons .button{border-left:none;border-left-width:0;border-top:0 solid rgba(34,36,38,.15)}.ui.basic.vertical.buttons .button:first-child{border-top-width:0}.ui.labeled.icon.button,.ui.labeled.icon.buttons .button{position:relative;padding-left:3.79411765em!important;padding-right:1.5em!important}.ui.labeled.icon.button>.icon,.ui.labeled.icon.buttons>.button>.icon{position:absolute;height:100%;line-height:1;border-radius:0;border-top-left-radius:inherit;border-bottom-left-radius:inherit;text-align:center;margin:0;width:2.29411765em;background-color:rgba(0,0,0,.05);color:'';box-shadow:inset -1px 0 0 0 transparent;top:0;left:0}.ui[class*=\"right labeled\"].icon.button{padding-right:3.79411765em!important;padding-left:1.5em!important}.ui[class*=\"right labeled\"].icon.button>.icon{left:auto;right:0;border-radius:0;border-top-right-radius:inherit;border-bottom-right-radius:inherit;box-shadow:inset 1px 0 0 0 transparent}.ui.labeled.icon.button>.icon:after,.ui.labeled.icon.button>.icon:before,.ui.labeled.icon.buttons>.button>.icon:after,.ui.labeled.icon.buttons>.button>.icon:before{display:block;position:absolute;width:100%;top:50%;text-align:center;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.ui.labeled.icon.buttons .button>.icon{border-radius:0}.ui.labeled.icon.buttons .button:first-child>.icon{border-top-left-radius:.11764706rem;border-bottom-left-radius:.11764706rem}.ui.labeled.icon.buttons .button:last-child>.icon{border-top-right-radius:.11764706rem;border-bottom-right-radius:.11764706rem}.ui.vertical.labeled.icon.buttons .button:first-child>.icon{border-radius:0;border-top-left-radius:.11764706rem}.ui.vertical.labeled.icon.buttons .button:last-child>.icon{border-radius:0;border-bottom-left-radius:.11764706rem}.ui.fluid[class*=\"left labeled\"].icon.button,.ui.fluid[class*=\"right labeled\"].icon.button{padding-left:1.5em!important;padding-right:1.5em!important}.ui.button.toggle.active,.ui.buttons .button.toggle.active,.ui.toggle.buttons .active.button{background-color:#4d9221!important;box-shadow:none!important;text-shadow:none;color:#fff!important}.ui.button.toggle.active:hover{background-color:#418217!important;text-shadow:none;color:#fff!important}.ui.circular.button{border-radius:10em}.ui.circular.button>.icon{width:1em;vertical-align:baseline}.ui.buttons .or{position:relative;width:.3em;height:2.29411765em;z-index:3}.ui.buttons .or:before{position:absolute;text-align:center;border-radius:500rem;content:'or';top:50%;left:50%;background-color:#fff;text-shadow:none;margin-top:-.82352941em;margin-left:-.82352941em;width:1.64705882em;height:1.64705882em;line-height:1.64705882em;color:rgba(0,0,0,.4);font-style:normal;font-weight:700;box-shadow:inset 0 0 0 1px transparent}.ui.buttons .or[data-text]:before{content:attr(data-text)}.ui.fluid.buttons .or{width:0!important}.ui.fluid.buttons .or:after{display:none}.ui.attached.button{position:relative;display:block;margin:0;border-radius:0;box-shadow:0 0 0 1px rgba(34,36,38,.15)!important}.ui.attached.top.button{border-radius:.11764706rem .11764706rem 0 0}.ui.attached.bottom.button{border-radius:0 0 .11764706rem .11764706rem}.ui.left.attached.button{display:inline-block;border-left:none;text-align:right;padding-right:.75em;border-radius:.11764706rem 0 0 .11764706rem}.ui.right.attached.button{display:inline-block;text-align:left;padding-left:.75em;border-radius:0 .11764706rem .11764706rem 0}.ui.attached.buttons{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;border-radius:0;width:auto!important;z-index:2;margin-left:-1px;margin-right:-1px}.ui.attached.buttons .button{margin:0}.ui.attached.buttons .button:first-child,.ui.attached.buttons .button:last-child{border-radius:0}.ui[class*=\"top attached\"].buttons{margin-bottom:-1px;border-radius:.11764706rem .11764706rem 0 0}.ui[class*=\"top attached\"].buttons .button:first-child{border-radius:.11764706rem 0 0 0}.ui[class*=\"top attached\"].buttons .button:last-child{border-radius:0 .11764706rem 0 0}.ui[class*=\"bottom attached\"].buttons{margin-top:-1px;border-radius:0 0 .11764706rem .11764706rem}.ui[class*=\"bottom attached\"].buttons .button:first-child{border-radius:0 0 0 .11764706rem}.ui[class*=\"bottom attached\"].buttons .button:last-child{border-radius:0 0 .11764706rem 0}.ui[class*=\"left attached\"].buttons{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-right:0;margin-left:-1px;border-radius:0 .11764706rem .11764706rem 0}.ui[class*=\"left attached\"].buttons .button:first-child{margin-left:-1px;border-radius:0 .11764706rem 0 0}.ui[class*=\"left attached\"].buttons .button:last-child{margin-left:-1px;border-radius:0 0 .11764706rem 0}.ui[class*=\"right attached\"].buttons{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;margin-left:0;margin-right:-1px;border-radius:.11764706rem 0 0 .11764706rem}.ui[class*=\"right attached\"].buttons .button:first-child{margin-left:-1px;border-radius:.11764706rem 0 0 0}.ui[class*=\"right attached\"].buttons .button:last-child{margin-left:-1px;border-radius:0 0 0 .11764706rem}.ui.fluid.button,.ui.fluid.buttons{width:100%}.ui.fluid.button{display:block}.ui.two.buttons{width:100%}.ui.two.buttons>.button{width:50%}.ui.three.buttons{width:100%}.ui.three.buttons>.button{width:33.333%}.ui.four.buttons{width:100%}.ui.four.buttons>.button{width:25%}.ui.five.buttons{width:100%}.ui.five.buttons>.button{width:20%}.ui.six.buttons{width:100%}.ui.six.buttons>.button{width:16.666%}.ui.seven.buttons{width:100%}.ui.seven.buttons>.button{width:14.285%}.ui.eight.buttons{width:100%}.ui.eight.buttons>.button{width:12.5%}.ui.nine.buttons{width:100%}.ui.nine.buttons>.button{width:11.11%}.ui.ten.buttons{width:100%}.ui.ten.buttons>.button{width:10%}.ui.eleven.buttons{width:100%}.ui.eleven.buttons>.button{width:9.09%}.ui.twelve.buttons{width:100%}.ui.twelve.buttons>.button{width:8.3333%}.ui.fluid.vertical.buttons,.ui.fluid.vertical.buttons>.button{display:-webkit-box;display:-ms-flexbox;display:flex;width:auto}.ui.two.vertical.buttons>.button{height:50%}.ui.three.vertical.buttons>.button{height:33.333%}.ui.four.vertical.buttons>.button{height:25%}.ui.five.vertical.buttons>.button{height:20%}.ui.six.vertical.buttons>.button{height:16.666%}.ui.seven.vertical.buttons>.button{height:14.285%}.ui.eight.vertical.buttons>.button{height:12.5%}.ui.nine.vertical.buttons>.button{height:11.11%}.ui.ten.vertical.buttons>.button{height:10%}.ui.eleven.vertical.buttons>.button{height:9.09%}.ui.twelve.vertical.buttons>.button{height:8.3333%}.ui.black.button,.ui.black.buttons .button{background-color:#1b1c1d;color:#fff;text-shadow:none;background-image:none}.ui.black.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.black.button:hover,.ui.black.buttons .button:hover{background-color:#27292a;color:#fff;text-shadow:none}.ui.black.button:focus,.ui.black.buttons .button:focus{background-color:#2f3032;color:#fff;text-shadow:none}.ui.black.button:active,.ui.black.buttons .button:active{background-color:#343637;color:#fff;text-shadow:none}.ui.black.active.button,.ui.black.button .active.button:active,.ui.black.buttons .active.button,.ui.black.buttons .active.button:active{background-color:#0f0f10;color:#fff;text-shadow:none}.ui.basic.black.button:hover,.ui.basic.black.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #27292a!important;color:#27292a!important}.ui.basic.black.button:focus,.ui.basic.black.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #2f3032!important;color:#27292a!important}.ui.basic.black.active.button,.ui.basic.black.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #0f0f10!important;color:#343637!important}.ui.inverted.black.button,.ui.inverted.black.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.black.basic.button,.ui.inverted.black.basic.buttons .button,.ui.inverted.black.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.black.basic.button:hover,.ui.inverted.black.basic.buttons .button:hover,.ui.inverted.black.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #000!important;color:#fff!important}.ui.inverted.black.basic.button:focus,.ui.inverted.black.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #000!important;color:#545454!important}.ui.inverted.black.basic.active.button,.ui.inverted.black.basic.button:active,.ui.inverted.black.basic.buttons .active.button,.ui.inverted.black.basic.buttons .button:active,.ui.inverted.black.buttons .basic.active.button,.ui.inverted.black.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #000!important;color:#fff!important}.ui.grey.button,.ui.grey.buttons .button{background-color:#5a686d;color:#fff;text-shadow:none;background-image:none}.ui.grey.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.grey.button:hover,.ui.grey.buttons .button:hover{background-color:#66757b;color:#fff;text-shadow:none}.ui.grey.button:focus,.ui.grey.buttons .button:focus{background-color:#6c7d83;color:#fff;text-shadow:none}.ui.grey.button:active,.ui.grey.buttons .button:active{background-color:#718389;color:#fff;text-shadow:none}.ui.grey.active.button,.ui.grey.button .active.button:active,.ui.grey.buttons .active.button,.ui.grey.buttons .active.button:active{background-color:#4e5b5f;color:#fff;text-shadow:none}.ui.basic.grey.button:hover,.ui.basic.grey.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #66757b!important;color:#66757b!important}.ui.basic.grey.button:focus,.ui.basic.grey.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #6c7d83!important;color:#66757b!important}.ui.basic.grey.active.button,.ui.basic.grey.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #4e5b5f!important;color:#718389!important}.ui.inverted.grey.button,.ui.inverted.grey.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.grey.basic.button,.ui.inverted.grey.basic.buttons .button,.ui.inverted.grey.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.grey.basic.button:hover,.ui.inverted.grey.basic.buttons .button:hover,.ui.inverted.grey.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #70838a!important;color:#fff!important}.ui.inverted.grey.basic.button:focus,.ui.inverted.grey.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #687c83!important;color:#7f8f95!important}.ui.inverted.grey.basic.active.button,.ui.inverted.grey.basic.buttons .active.button,.ui.inverted.grey.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #6f848b!important;color:#fff!important}.ui.inverted.grey.basic.button:active,.ui.inverted.grey.basic.buttons .button:active,.ui.inverted.grey.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #66757b!important;color:#fff!important}.ui.brown.button,.ui.brown.buttons .button{background-color:#a67a00;color:#fff;text-shadow:none;background-image:none}.ui.brown.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.brown.button:hover,.ui.brown.buttons .button:hover{background-color:#8d6700;color:#fff;text-shadow:none}.ui.brown.button:focus,.ui.brown.buttons .button:focus{background-color:#7d5c00;color:#fff;text-shadow:none}.ui.brown.button:active,.ui.brown.buttons .button:active{background-color:#735500;color:#fff;text-shadow:none}.ui.brown.active.button,.ui.brown.button .active.button:active,.ui.brown.buttons .active.button,.ui.brown.buttons .active.button:active{background-color:#8d6700;color:#fff;text-shadow:none}.ui.basic.brown.button:hover,.ui.basic.brown.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #8d6700!important;color:#8d6700!important}.ui.basic.brown.button:focus,.ui.basic.brown.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #7d5c00!important;color:#8d6700!important}.ui.basic.brown.active.button,.ui.basic.brown.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #8d6700!important;color:#735500!important}.ui.inverted.brown.button,.ui.inverted.brown.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #f3b200!important;color:#f3b200}.ui.inverted.brown.basic.button,.ui.inverted.brown.basic.buttons .button,.ui.inverted.brown.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.brown.basic.button:hover,.ui.inverted.brown.basic.buttons .button:hover,.ui.inverted.brown.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #d99f00!important;color:#f3b200!important}.ui.inverted.brown.basic.button:focus,.ui.inverted.brown.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #ca9400!important;color:#f3b200!important}.ui.inverted.brown.basic.active.button,.ui.inverted.brown.basic.buttons .active.button,.ui.inverted.brown.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #d99f00!important;color:#f3b200!important}.ui.inverted.brown.basic.button:active,.ui.inverted.brown.basic.buttons .button:active,.ui.inverted.brown.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #c08d00!important;color:#f3b200!important}.ui.blue.button,.ui.blue.buttons .button{background-color:#1d5f82;color:#fff;text-shadow:none;background-image:none}.ui.blue.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.blue.button:hover,.ui.blue.buttons .button:hover{background-color:#145171;color:#fff;text-shadow:none}.ui.blue.button:focus,.ui.blue.buttons .button:focus{background-color:#0e4968;color:#fff;text-shadow:none}.ui.blue.button:active,.ui.blue.buttons .button:active{background-color:#144158;color:#fff;text-shadow:none}.ui.blue.active.button,.ui.blue.button .active.button:active,.ui.blue.buttons .active.button,.ui.blue.buttons .active.button:active{background-color:#125274;color:#fff;text-shadow:none}.ui.basic.blue.button:hover,.ui.basic.blue.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #145171!important;color:#145171!important}.ui.basic.blue.button:focus,.ui.basic.blue.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #0e4968!important;color:#145171!important}.ui.basic.blue.active.button,.ui.basic.blue.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #125274!important;color:#144158!important}.ui.inverted.blue.button,.ui.inverted.blue.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #1782bb!important;color:#1782bb}.ui.inverted.blue.basic.button,.ui.inverted.blue.basic.buttons .button,.ui.inverted.blue.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.blue.basic.button:hover,.ui.inverted.blue.basic.buttons .button:hover,.ui.inverted.blue.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #0d75ac!important;color:#1782bb!important}.ui.inverted.blue.basic.button:focus,.ui.inverted.blue.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #056da4!important;color:#1782bb!important}.ui.inverted.blue.basic.active.button,.ui.inverted.blue.basic.buttons .active.button,.ui.inverted.blue.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #0976b0!important;color:#1782bb!important}.ui.inverted.blue.basic.button:active,.ui.inverted.blue.basic.buttons .button:active,.ui.inverted.blue.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #11638e!important;color:#1782bb!important}.ui.green.button,.ui.green.buttons .button{background-color:#54af71;color:#fff;text-shadow:none;background-image:none}.ui.green.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.green.button:hover,.ui.green.buttons .button:hover{background-color:#46a364;color:#fff;text-shadow:none}.ui.green.button:focus,.ui.green.buttons .button:focus{background-color:#3e9d5c;color:#fff;text-shadow:none}.ui.green.button:active,.ui.green.buttons .button:active{background-color:#428e5a;color:#fff;text-shadow:none}.ui.green.active.button,.ui.green.button .active.button:active,.ui.green.buttons .active.button,.ui.green.buttons .active.button:active{background-color:#44a563;color:#fff;text-shadow:none}.ui.basic.green.button:hover,.ui.basic.green.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #46a364!important;color:#46a364!important}.ui.basic.green.button:focus,.ui.basic.green.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #3e9d5c!important;color:#46a364!important}.ui.basic.green.active.button,.ui.basic.green.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #44a563!important;color:#428e5a!important}.ui.inverted.green.button,.ui.inverted.green.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #68ce88!important;color:#68ce88}.ui.inverted.green.basic.button,.ui.inverted.green.basic.buttons .button,.ui.inverted.green.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.green.basic.button:hover,.ui.inverted.green.basic.buttons .button:hover,.ui.inverted.green.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #4fce77!important;color:#68ce88!important}.ui.inverted.green.basic.button:focus,.ui.inverted.green.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #3dd16c!important;color:#68ce88!important}.ui.inverted.green.basic.active.button,.ui.inverted.green.basic.buttons .active.button,.ui.inverted.green.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #4cd176!important;color:#68ce88!important}.ui.inverted.green.basic.button:active,.ui.inverted.green.basic.buttons .button:active,.ui.inverted.green.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #41c26a!important;color:#68ce88!important}.ui.orange.button,.ui.orange.buttons .button{background-color:#f8813d;color:#fff;text-shadow:none;background-image:none}.ui.orange.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.orange.button:hover,.ui.orange.buttons .button:hover{background-color:#ff6f1c;color:#fff;text-shadow:none}.ui.orange.button:focus,.ui.orange.buttons .button:focus{background-color:#ff650d;color:#fff;text-shadow:none}.ui.orange.button:active,.ui.orange.buttons .button:active{background-color:#f6610c;color:#fff;text-shadow:none}.ui.orange.active.button,.ui.orange.button .active.button:active,.ui.orange.buttons .active.button,.ui.orange.buttons .active.button:active{background-color:#ff6f1c;color:#fff;text-shadow:none}.ui.basic.orange.button:hover,.ui.basic.orange.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #ff6f1c!important;color:#ff6f1c!important}.ui.basic.orange.button:focus,.ui.basic.orange.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #ff650d!important;color:#ff6f1c!important}.ui.basic.orange.active.button,.ui.basic.orange.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #ff6f1c!important;color:#f6610c!important}.ui.inverted.orange.button,.ui.inverted.orange.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #ff8945!important;color:#ff8945}.ui.inverted.orange.basic.button,.ui.inverted.orange.basic.buttons .button,.ui.inverted.orange.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.orange.basic.button:hover,.ui.inverted.orange.basic.buttons .button:hover,.ui.inverted.orange.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #ff792c!important;color:#ff8945!important}.ui.inverted.orange.basic.button:focus,.ui.inverted.orange.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #ff6f1d!important;color:#ff8945!important}.ui.inverted.orange.basic.active.button,.ui.inverted.orange.basic.buttons .active.button,.ui.inverted.orange.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #ff792c!important;color:#ff8945!important}.ui.inverted.orange.basic.button:active,.ui.inverted.orange.basic.buttons .button:active,.ui.inverted.orange.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #ff6812!important;color:#ff8945!important}.ui.pink.button,.ui.pink.buttons .button{background-color:#e03997;color:#fff;text-shadow:none;background-image:none}.ui.pink.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.pink.button:hover,.ui.pink.buttons .button:hover{background-color:#e61a8d;color:#fff;text-shadow:none}.ui.pink.button:focus,.ui.pink.buttons .button:focus{background-color:#e10f85;color:#fff;text-shadow:none}.ui.pink.button:active,.ui.pink.buttons .button:active{background-color:#c71f7e;color:#fff;text-shadow:none}.ui.pink.active.button,.ui.pink.button .active.button:active,.ui.pink.buttons .active.button,.ui.pink.buttons .active.button:active{background-color:#ea158d;color:#fff;text-shadow:none}.ui.basic.pink.button:hover,.ui.basic.pink.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #e61a8d!important;color:#e61a8d!important}.ui.basic.pink.button:focus,.ui.basic.pink.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #e10f85!important;color:#e61a8d!important}.ui.basic.pink.active.button,.ui.basic.pink.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #ea158d!important;color:#c71f7e!important}.ui.inverted.pink.button,.ui.inverted.pink.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #f670bb!important;color:#f670bb}.ui.inverted.pink.basic.button,.ui.inverted.pink.basic.buttons .button,.ui.inverted.pink.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.pink.basic.button:hover,.ui.inverted.pink.basic.buttons .button:hover,.ui.inverted.pink.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #fc50b1!important;color:#f670bb!important}.ui.inverted.pink.basic.button:focus,.ui.inverted.pink.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #ff3eab!important;color:#f670bb!important}.ui.inverted.pink.basic.active.button,.ui.inverted.pink.basic.buttons .active.button,.ui.inverted.pink.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #ff4db1!important;color:#f670bb!important}.ui.inverted.pink.basic.button:active,.ui.inverted.pink.basic.buttons .button:active,.ui.inverted.pink.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #f340a5!important;color:#f670bb!important}.ui.violet.button,.ui.violet.buttons .button{background-color:#525394;color:#fff;text-shadow:none;background-image:none}.ui.violet.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.violet.button:hover,.ui.violet.buttons .button:hover{background-color:#464787;color:#fff;text-shadow:none}.ui.violet.button:focus,.ui.violet.buttons .button:focus{background-color:#3e3f7f;color:#fff;text-shadow:none}.ui.violet.button:active,.ui.violet.buttons .button:active{background-color:#404173;color:#fff;text-shadow:none}.ui.violet.active.button,.ui.violet.button .active.button:active,.ui.violet.buttons .active.button,.ui.violet.buttons .active.button:active{background-color:#454688;color:#fff;text-shadow:none}.ui.basic.violet.button:hover,.ui.basic.violet.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #464787!important;color:#464787!important}.ui.basic.violet.button:focus,.ui.basic.violet.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #3e3f7f!important;color:#464787!important}.ui.basic.violet.active.button,.ui.basic.violet.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #454688!important;color:#404173!important}.ui.inverted.violet.button,.ui.inverted.violet.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #6d6ec6!important;color:#6d6ec6}.ui.inverted.violet.basic.button,.ui.inverted.violet.basic.buttons .button,.ui.inverted.violet.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.violet.basic.button:hover,.ui.inverted.violet.basic.buttons .button:hover,.ui.inverted.violet.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #5557c4!important;color:#6d6ec6!important}.ui.inverted.violet.basic.button:focus,.ui.inverted.violet.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #4547c5!important;color:#6d6ec6!important}.ui.inverted.violet.basic.active.button,.ui.inverted.violet.basic.buttons .active.button,.ui.inverted.violet.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #5355c6!important;color:#6d6ec6!important}.ui.inverted.violet.basic.button:active,.ui.inverted.violet.basic.buttons .button:active,.ui.inverted.violet.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #484ab7!important;color:#6d6ec6!important}.ui.purple.button,.ui.purple.buttons .button{background-color:#ad427f;color:#fff;text-shadow:none;background-image:none}.ui.purple.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.purple.button:hover,.ui.purple.buttons .button:hover{background-color:#9f3672;color:#fff;text-shadow:none}.ui.purple.button:focus,.ui.purple.buttons .button:focus{background-color:#982e6b;color:#fff;text-shadow:none}.ui.purple.button:active,.ui.purple.buttons .button:active{background-color:#883464;color:#fff;text-shadow:none}.ui.purple.active.button,.ui.purple.button .active.button:active,.ui.purple.buttons .active.button,.ui.purple.buttons .active.button:active{background-color:#a23472;color:#fff;text-shadow:none}.ui.basic.purple.button:hover,.ui.basic.purple.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #9f3672!important;color:#9f3672!important}.ui.basic.purple.button:focus,.ui.basic.purple.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #982e6b!important;color:#9f3672!important}.ui.basic.purple.active.button,.ui.basic.purple.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #a23472!important;color:#883464!important}.ui.inverted.purple.button,.ui.inverted.purple.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #d864a6!important;color:#d864a6}.ui.inverted.purple.basic.button,.ui.inverted.purple.basic.buttons .button,.ui.inverted.purple.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.purple.basic.button:hover,.ui.inverted.purple.basic.buttons .button:hover,.ui.inverted.purple.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #d9499b!important;color:#d864a6!important}.ui.inverted.purple.basic.button:focus,.ui.inverted.purple.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #de3595!important;color:#d864a6!important}.ui.inverted.purple.basic.active.button,.ui.inverted.purple.basic.buttons .active.button,.ui.inverted.purple.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #dd459c!important;color:#d864a6!important}.ui.inverted.purple.basic.button:active,.ui.inverted.purple.basic.buttons .button:active,.ui.inverted.purple.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #ce3b8f!important;color:#d864a6!important}.ui.red.button,.ui.red.buttons .button{background-color:#e23c4e;color:#fff;text-shadow:none;background-image:none}.ui.red.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.red.button:hover,.ui.red.buttons .button:hover{background-color:#e81d33;color:#fff;text-shadow:none}.ui.red.button:focus,.ui.red.buttons .button:focus{background-color:#e80e25;color:#fff;text-shadow:none}.ui.red.button:active,.ui.red.buttons .button:active{background-color:#cd1e31;color:#fff;text-shadow:none}.ui.red.active.button,.ui.red.button .active.button:active,.ui.red.buttons .active.button,.ui.red.buttons .active.button:active{background-color:#ed182f;color:#fff;text-shadow:none}.ui.basic.red.button:hover,.ui.basic.red.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #e81d33!important;color:#e81d33!important}.ui.basic.red.button:focus,.ui.basic.red.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #e80e25!important;color:#e81d33!important}.ui.basic.red.active.button,.ui.basic.red.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #ed182f!important;color:#cd1e31!important}.ui.inverted.red.button,.ui.inverted.red.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #f77482!important;color:#f77482}.ui.inverted.red.basic.button,.ui.inverted.red.basic.buttons .button,.ui.inverted.red.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.red.basic.button:hover,.ui.inverted.red.basic.buttons .button:hover,.ui.inverted.red.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #fd5466!important;color:#f77482!important}.ui.inverted.red.basic.button:focus,.ui.inverted.red.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #ff4357!important;color:#f77482!important}.ui.inverted.red.basic.active.button,.ui.inverted.red.basic.buttons .active.button,.ui.inverted.red.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #ff5265!important;color:#f77482!important}.ui.inverted.red.basic.button:active,.ui.inverted.red.basic.buttons .button:active,.ui.inverted.red.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #f44356!important;color:#f77482!important}.ui.teal.button,.ui.teal.buttons .button{background-color:#00a1ca;color:#fff;text-shadow:none;background-image:none}.ui.teal.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.teal.button:hover,.ui.teal.buttons .button:hover{background-color:#008db1;color:#fff;text-shadow:none}.ui.teal.button:focus,.ui.teal.buttons .button:focus{background-color:#0080a1;color:#fff;text-shadow:none}.ui.teal.button:active,.ui.teal.buttons .button:active{background-color:#007897;color:#fff;text-shadow:none}.ui.teal.active.button,.ui.teal.button .active.button:active,.ui.teal.buttons .active.button,.ui.teal.buttons .active.button:active{background-color:#008db1;color:#fff;text-shadow:none}.ui.basic.teal.button:hover,.ui.basic.teal.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #008db1!important;color:#008db1!important}.ui.basic.teal.button:focus,.ui.basic.teal.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #0080a1!important;color:#008db1!important}.ui.basic.teal.active.button,.ui.basic.teal.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #008db1!important;color:#007897!important}.ui.inverted.teal.button,.ui.inverted.teal.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #00cafd!important;color:#00cafd}.ui.inverted.teal.basic.button,.ui.inverted.teal.basic.buttons .button,.ui.inverted.teal.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.teal.basic.button:hover,.ui.inverted.teal.basic.buttons .button:hover,.ui.inverted.teal.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #00b5e4!important;color:#00cafd!important}.ui.inverted.teal.basic.button:focus,.ui.inverted.teal.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #00a9d4!important;color:#00cafd!important}.ui.inverted.teal.basic.active.button,.ui.inverted.teal.basic.buttons .active.button,.ui.inverted.teal.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #00b5e4!important;color:#00cafd!important}.ui.inverted.teal.basic.button:active,.ui.inverted.teal.basic.buttons .button:active,.ui.inverted.teal.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #00a1ca!important;color:#00cafd!important}.ui.olive.button,.ui.olive.buttons .button{background-color:#456558;color:#fff;text-shadow:none;background-image:none}.ui.olive.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.olive.button:hover,.ui.olive.buttons .button:hover{background-color:#39574b;color:#fff;text-shadow:none}.ui.olive.button:focus,.ui.olive.buttons .button:focus{background-color:#324f43;color:#fff;text-shadow:none}.ui.olive.button:active,.ui.olive.buttons .button:active{background-color:#30473e;color:#fff;text-shadow:none}.ui.olive.active.button,.ui.olive.button .active.button:active,.ui.olive.buttons .active.button,.ui.olive.buttons .active.button:active{background-color:#39584b;color:#fff;text-shadow:none}.ui.basic.olive.button:hover,.ui.basic.olive.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #39574b!important;color:#39574b!important}.ui.basic.olive.button:focus,.ui.basic.olive.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #324f43!important;color:#39574b!important}.ui.basic.olive.active.button,.ui.basic.olive.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #39584b!important;color:#30473e!important}.ui.inverted.olive.button,.ui.inverted.olive.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #52a583!important;color:#52a583}.ui.inverted.olive.basic.button,.ui.inverted.olive.basic.buttons .button,.ui.inverted.olive.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.olive.basic.button:hover,.ui.inverted.olive.basic.buttons .button:hover,.ui.inverted.olive.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #459876!important;color:#52a583!important}.ui.inverted.olive.basic.button:focus,.ui.inverted.olive.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #3d916f!important;color:#52a583!important}.ui.inverted.olive.basic.active.button,.ui.inverted.olive.basic.buttons .active.button,.ui.inverted.olive.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #497!important;color:#52a583!important}.ui.inverted.olive.basic.button:active,.ui.inverted.olive.basic.buttons .button:active,.ui.inverted.olive.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #418368!important;color:#52a583!important}.ui.yellow.button,.ui.yellow.buttons .button{background-color:#ffca18;color:#fff;text-shadow:none;background-image:none}.ui.yellow.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.yellow.button:hover,.ui.yellow.buttons .button:hover{background-color:#fec300;color:#fff;text-shadow:none}.ui.yellow.button:focus,.ui.yellow.buttons .button:focus{background-color:#eeb800;color:#fff;text-shadow:none}.ui.yellow.button:active,.ui.yellow.buttons .button:active{background-color:#e4b000;color:#fff;text-shadow:none}.ui.yellow.active.button,.ui.yellow.button .active.button:active,.ui.yellow.buttons .active.button,.ui.yellow.buttons .active.button:active{background-color:#fec300;color:#fff;text-shadow:none}.ui.basic.yellow.button:hover,.ui.basic.yellow.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #fec300!important;color:#fec300!important}.ui.basic.yellow.button:focus,.ui.basic.yellow.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #eeb800!important;color:#fec300!important}.ui.basic.yellow.active.button,.ui.basic.yellow.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #fec300!important;color:#e4b000!important}.ui.inverted.yellow.button,.ui.inverted.yellow.buttons .button{background-color:transparent;box-shadow:inset 0 0 0 0 #ffca18!important;color:#ffca18}.ui.inverted.yellow.basic.button,.ui.inverted.yellow.basic.buttons .button,.ui.inverted.yellow.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#fff!important}.ui.inverted.yellow.basic.button:hover,.ui.inverted.yellow.basic.buttons .button:hover,.ui.inverted.yellow.buttons .basic.button:hover{box-shadow:inset 0 0 0 0 #fec300!important;color:#ffca18!important}.ui.inverted.yellow.basic.button:focus,.ui.inverted.yellow.basic.buttons .button:focus{box-shadow:inset 0 0 0 0 #eeb800!important;color:#ffca18!important}.ui.inverted.yellow.basic.active.button,.ui.inverted.yellow.basic.buttons .active.button,.ui.inverted.yellow.buttons .basic.active.button{box-shadow:inset 0 0 0 0 #fec300!important;color:#ffca18!important}.ui.inverted.yellow.basic.button:active,.ui.inverted.yellow.basic.buttons .button:active,.ui.inverted.yellow.buttons .basic.button:active{box-shadow:inset 0 0 0 0 #e4b000!important;color:#ffca18!important}.ui.primary.button,.ui.primary.buttons .button{background-color:#007abf;color:#fff;text-shadow:none;background-image:none}.ui.primary.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.primary.button:hover,.ui.primary.buttons .button:hover{background-color:#006aa6;color:#fff;text-shadow:none}.ui.primary.button:focus,.ui.primary.buttons .button:focus{background-color:#006096;color:#fff;text-shadow:none}.ui.primary.button:active,.ui.primary.buttons .button:active{background-color:#00598c;color:#fff;text-shadow:none}.ui.primary.active.button,.ui.primary.button .active.button:active,.ui.primary.buttons .active.button,.ui.primary.buttons .active.button:active{background-color:#006aa6;color:#fff;text-shadow:none}.ui.basic.primary.button:hover,.ui.basic.primary.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #006aa6!important;color:#006aa6!important}.ui.basic.primary.button:focus,.ui.basic.primary.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #006096!important;color:#006aa6!important}.ui.basic.primary.active.button,.ui.basic.primary.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #006aa6!important;color:#00598c!important}.ui.secondary.button,.ui.secondary.buttons .button{background-color:#5a686d;color:#fff;text-shadow:none;background-image:none}.ui.secondary.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.secondary.button:hover,.ui.secondary.buttons .button:hover{background-color:#64767c;color:#fff;text-shadow:none}.ui.secondary.button:focus,.ui.secondary.buttons .button:focus{background-color:#6a7e86;color:#fff;text-shadow:none}.ui.secondary.button:active,.ui.secondary.buttons .button:active{background-color:#718389;color:#fff;text-shadow:none}.ui.secondary.active.button,.ui.secondary.button .active.button:active,.ui.secondary.buttons .active.button,.ui.secondary.buttons .active.button:active{background-color:#64767d;color:#fff;text-shadow:none}.ui.basic.secondary.button:hover,.ui.basic.secondary.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #64767c!important;color:#64767c!important}.ui.basic.secondary.button:focus,.ui.basic.secondary.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #6a7e86!important;color:#64767c!important}.ui.basic.secondary.active.button,.ui.basic.secondary.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #64767d!important;color:#718389!important}.ui.positive.button,.ui.positive.buttons .button{background-color:#4d9221;color:#fff;text-shadow:none;background-image:none}.ui.positive.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.positive.button:hover,.ui.positive.buttons .button:hover{background-color:#418217;color:#fff;text-shadow:none}.ui.positive.button:focus,.ui.positive.buttons .button:focus{background-color:#3a7911;color:#fff;text-shadow:none}.ui.positive.button:active,.ui.positive.buttons .button:active{background-color:#376818;color:#fff;text-shadow:none}.ui.positive.active.button,.ui.positive.button .active.button:active,.ui.positive.buttons .active.button,.ui.positive.buttons .active.button:active{background-color:#408415;color:#fff;text-shadow:none}.ui.basic.positive.button:hover,.ui.basic.positive.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #418217!important;color:#418217!important}.ui.basic.positive.button:focus,.ui.basic.positive.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #3a7911!important;color:#418217!important}.ui.basic.positive.active.button,.ui.basic.positive.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #408415!important;color:#376818!important}.ui.negative.button,.ui.negative.buttons .button{background-color:#c51b7d;color:#fff;text-shadow:none;background-image:none}.ui.negative.button{box-shadow:inset 0 0 0 0 rgba(34,36,38,.15)}.ui.negative.button:hover,.ui.negative.buttons .button:hover{background-color:#b61070;color:#fff;text-shadow:none}.ui.negative.button:focus,.ui.negative.buttons .button:focus{background-color:#af0868;color:#fff;text-shadow:none}.ui.negative.button:active,.ui.negative.buttons .button:active{background-color:#981561;color:#fff;text-shadow:none}.ui.negative.active.button,.ui.negative.button .active.button:active,.ui.negative.buttons .active.button,.ui.negative.buttons .active.button:active{background-color:#ba0d70;color:#fff;text-shadow:none}.ui.basic.negative.button:hover,.ui.basic.negative.buttons .button:hover{background:transparent!important;box-shadow:inset 0 0 0 0 #b61070!important;color:#b61070!important}.ui.basic.negative.button:focus,.ui.basic.negative.buttons .button:focus{background:transparent!important;box-shadow:inset 0 0 0 0 #af0868!important;color:#b61070!important}.ui.basic.negative.active.button,.ui.basic.negative.buttons .active.button{background:transparent!important;box-shadow:inset 0 0 0 0 #ba0d70!important;color:#981561!important}.ui.buttons{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;font-size:0;vertical-align:baseline;margin:0 .25em 0 0}.ui.buttons:not(.basic):not(.inverted){box-shadow:none}.ui.buttons:after{content:\".\";display:block;height:0;clear:both;visibility:hidden}.ui.buttons .button{-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;border-radius:0;margin:0}.ui.buttons:not(.basic):not(.inverted)>.button,.ui.buttons>.ui.button:not(.basic):not(.inverted){box-shadow:inset 0 0 0 1px transparent,inset 0 0 0 0 rgba(34,36,38,.15)}.ui.buttons .button:first-child{border-left:none;margin-left:0;border-top-left-radius:.11764706rem;border-bottom-left-radius:.11764706rem}.ui.buttons .button:last-child{border-top-right-radius:.11764706rem;border-bottom-right-radius:.11764706rem}.ui.vertical.buttons{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ui.vertical.buttons .button{display:block;float:none;width:100%;margin:0;box-shadow:none;border-radius:0}.ui.vertical.buttons .button:first-child{border-top-left-radius:.11764706rem;border-top-right-radius:.11764706rem}.ui.vertical.buttons .button:last-child{margin-bottom:0;border-bottom-left-radius:.11764706rem;border-bottom-right-radius:.11764706rem}.ui.vertical.buttons .button:only-child{border-radius:.11764706rem}.ui.inverted.button{background:hsla(0,0%,100%,.15);color:#8cd5ff}.ui.inverted.button:hover{background:hsla(0,0%,100%,.2);color:#fff}.ui.inverted.button.active,.ui.inverted.button:focus{background:hsla(0,0%,100%,.25);color:#bfe8ff}.ui.basic.inverted.button,.ui.basic.inverted.buttons .button{background-color:transparent!important;color:#26b1ff!important;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important}.ui.basic.inverted.button:hover,.ui.basic.inverted.buttons .button:hover{color:#8cd5ff!important;background-color:hsla(0,0%,100%,.15)!important}.ui.basic.inverted.button:focus,.ui.basic.inverted.buttons .button:focus{color:#fff!important;background-color:hsla(0,0%,100%,.15)!important}.ui.basic.inverted.button:active,.ui.basic.inverted.buttons .button:active{background-color:hsla(0,0%,100%,.08)!important;color:#fff!important}.ui.basic.inverted.active.button,.ui.basic.inverted.buttons .active.button{background-color:hsla(0,0%,100%,.08);color:#fff;text-shadow:\"negativeTextShadow\";box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.7)}.ui.basic.inverted.active.button:hover,.ui.basic.inverted.buttons .active.button:hover{background-color:hsla(0,0%,100%,.15);box-shadow:inset 0 0 0 0 #fff!important}.ui.red.button,.ui.red.buttons .button{background-color:#e23c4e;color:#fff}.ui.basic.red.button,.ui.basic.red.buttons .button{box-shadow:inset 0 0 0 0 #e23c4e!important;color:#e23c4e!important}.ui.basic.red.button:hover,.ui.basic.red.buttons .button:hover{background:rgba(226,60,78,.2)!important;box-shadow:inset 0 0 0 0 #e81d33!important;color:#e81d33!important}.ui.basic.red.button:focus,.ui.basic.red.buttons .button:focus{background:rgba(226,60,78,.3)!important;box-shadow:inset 0 0 0 0 #e80e25!important;color:#e81d33!important}.ui.basic.red.active.button,.ui.basic.red.buttons .active.button{background:rgba(205,30,49,.2)!important;box-shadow:inset 0 0 0 0 #ed182f!important;color:#cd1e31!important}.ui.basic.red.button:active,.ui.basic.red.buttons .button:active{box-shadow:inset 0 0 0 0 #cd1e31!important;color:#cd1e31!important}.ui.buttons:not(.vertical)>.basic.red.button:not(:first-child){margin-left:0}.ui.inverted.red.button,.ui.inverted.red.buttons .button{background-color:#e23c4e;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.red.button.active,.ui.inverted.red.button:active,.ui.inverted.red.button:focus,.ui.inverted.red.button:hover,.ui.inverted.red.buttons .button.active,.ui.inverted.red.buttons .button:active,.ui.inverted.red.buttons .button:focus,.ui.inverted.red.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.red.button:hover,.ui.inverted.red.buttons .button:hover{background-color:#fd5466}.ui.inverted.red.button:focus,.ui.inverted.red.buttons .button:focus{background-color:#ff4357}.ui.inverted.red.active.button,.ui.inverted.red.buttons .active.button{background-color:#ff5265}.ui.inverted.red.button:active,.ui.inverted.red.buttons .button:active{background-color:#f44356}.ui.inverted.red.basic.button,.ui.inverted.red.basic.buttons .button,.ui.inverted.red.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#f77482!important}.ui.inverted.red.basic.button:hover,.ui.inverted.red.basic.buttons .button:hover,.ui.inverted.red.buttons .basic.button:hover{background-color:rgba(226,60,78,.5)!important;box-shadow:inset 0 0 0 0 #fd5466!important;color:#fff!important}.ui.inverted.red.basic.button:focus,.ui.inverted.red.basic.buttons .button:focus{background-color:rgba(226,60,78,.5)!important;box-shadow:inset 0 0 0 0 #ff4357!important;color:#fff!important}.ui.inverted.red.basic.active.button,.ui.inverted.red.basic.buttons .active.button,.ui.inverted.red.buttons .basic.active.button{background-color:rgba(226,60,78,.2)!important;box-shadow:inset 0 0 0 0 #ff5265!important;color:#f77482!important}.ui.inverted.red.basic.button:active,.ui.inverted.red.basic.buttons .button:active,.ui.inverted.red.buttons .basic.button:active{background-color:rgba(226,60,78,.2)!important;box-shadow:inset 0 0 0 0 #f44356!important;color:#f77482!important}.ui.orange.button,.ui.orange.buttons .button{background-color:#f8813d;color:#fff}.ui.basic.orange.button,.ui.basic.orange.buttons .button{box-shadow:inset 0 0 0 0 #f8813d!important;color:#f8813d!important}.ui.basic.orange.button:hover,.ui.basic.orange.buttons .button:hover{background:rgba(248,129,61,.2)!important;box-shadow:inset 0 0 0 0 #ff6f1c!important;color:#ff6f1c!important}.ui.basic.orange.button:focus,.ui.basic.orange.buttons .button:focus{background:rgba(248,129,61,.3)!important;box-shadow:inset 0 0 0 0 #ff650d!important;color:#ff6f1c!important}.ui.basic.orange.active.button,.ui.basic.orange.buttons .active.button{background:rgba(246,97,12,.2)!important;box-shadow:inset 0 0 0 0 #ff6f1c!important;color:#f6610c!important}.ui.basic.orange.button:active,.ui.basic.orange.buttons .button:active{box-shadow:inset 0 0 0 0 #f6610c!important;color:#f6610c!important}.ui.buttons:not(.vertical)>.basic.orange.button:not(:first-child){margin-left:0}.ui.inverted.orange.button,.ui.inverted.orange.buttons .button{background-color:#f8813d;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.orange.button.active,.ui.inverted.orange.button:active,.ui.inverted.orange.button:focus,.ui.inverted.orange.button:hover,.ui.inverted.orange.buttons .button.active,.ui.inverted.orange.buttons .button:active,.ui.inverted.orange.buttons .button:focus,.ui.inverted.orange.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.orange.button:hover,.ui.inverted.orange.buttons .button:hover{background-color:#ff792c}.ui.inverted.orange.button:focus,.ui.inverted.orange.buttons .button:focus{background-color:#ff6f1d}.ui.inverted.orange.active.button,.ui.inverted.orange.buttons .active.button{background-color:#ff792c}.ui.inverted.orange.button:active,.ui.inverted.orange.buttons .button:active{background-color:#ff6812}.ui.inverted.orange.basic.button,.ui.inverted.orange.basic.buttons .button,.ui.inverted.orange.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#ff8945!important}.ui.inverted.orange.basic.button:hover,.ui.inverted.orange.basic.buttons .button:hover,.ui.inverted.orange.buttons .basic.button:hover{background-color:rgba(248,129,61,.5)!important;box-shadow:inset 0 0 0 0 #ff792c!important;color:#fff!important}.ui.inverted.orange.basic.button:focus,.ui.inverted.orange.basic.buttons .button:focus{background-color:rgba(248,129,61,.5)!important;box-shadow:inset 0 0 0 0 #ff6f1d!important;color:#fff!important}.ui.inverted.orange.basic.active.button,.ui.inverted.orange.basic.buttons .active.button,.ui.inverted.orange.buttons .basic.active.button{background-color:rgba(248,129,61,.2)!important;box-shadow:inset 0 0 0 0 #ff792c!important;color:#ff8945!important}.ui.inverted.orange.basic.button:active,.ui.inverted.orange.basic.buttons .button:active,.ui.inverted.orange.buttons .basic.button:active{background-color:rgba(248,129,61,.2)!important;box-shadow:inset 0 0 0 0 #ff6812!important;color:#ff8945!important}.ui.yellow.button,.ui.yellow.buttons .button{background-color:#ffca18;color:#fff}.ui.basic.yellow.button,.ui.basic.yellow.buttons .button{box-shadow:inset 0 0 0 0 #ffca18!important;color:#ffca18!important}.ui.basic.yellow.button:hover,.ui.basic.yellow.buttons .button:hover{background:rgba(255,202,24,.2)!important;box-shadow:inset 0 0 0 0 #fec300!important;color:#fec300!important}.ui.basic.yellow.button:focus,.ui.basic.yellow.buttons .button:focus{background:rgba(255,202,24,.3)!important;box-shadow:inset 0 0 0 0 #eeb800!important;color:#fec300!important}.ui.basic.yellow.active.button,.ui.basic.yellow.buttons .active.button{background:rgba(228,176,0,.2)!important;box-shadow:inset 0 0 0 0 #fec300!important;color:#e4b000!important}.ui.basic.yellow.button:active,.ui.basic.yellow.buttons .button:active{box-shadow:inset 0 0 0 0 #e4b000!important;color:#e4b000!important}.ui.buttons:not(.vertical)>.basic.yellow.button:not(:first-child){margin-left:0}.ui.inverted.yellow.button,.ui.inverted.yellow.buttons .button{background-color:#ffca18;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.yellow.button.active,.ui.inverted.yellow.button:active,.ui.inverted.yellow.button:focus,.ui.inverted.yellow.button:hover,.ui.inverted.yellow.buttons .button.active,.ui.inverted.yellow.buttons .button:active,.ui.inverted.yellow.buttons .button:focus,.ui.inverted.yellow.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.yellow.button:hover,.ui.inverted.yellow.buttons .button:hover{background-color:#fec300}.ui.inverted.yellow.button:focus,.ui.inverted.yellow.buttons .button:focus{background-color:#eeb800}.ui.inverted.yellow.active.button,.ui.inverted.yellow.buttons .active.button{background-color:#fec300}.ui.inverted.yellow.button:active,.ui.inverted.yellow.buttons .button:active{background-color:#e4b000}.ui.inverted.yellow.basic.button,.ui.inverted.yellow.basic.buttons .button,.ui.inverted.yellow.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#ffca18!important}.ui.inverted.yellow.basic.button:hover,.ui.inverted.yellow.basic.buttons .button:hover,.ui.inverted.yellow.buttons .basic.button:hover{background-color:rgba(255,202,24,.5)!important;box-shadow:inset 0 0 0 0 #fec300!important;color:#fff!important}.ui.inverted.yellow.basic.button:focus,.ui.inverted.yellow.basic.buttons .button:focus{background-color:rgba(255,202,24,.5)!important;box-shadow:inset 0 0 0 0 #eeb800!important;color:#fff!important}.ui.inverted.yellow.basic.active.button,.ui.inverted.yellow.basic.buttons .active.button,.ui.inverted.yellow.buttons .basic.active.button{background-color:rgba(255,202,24,.2)!important;box-shadow:inset 0 0 0 0 #fec300!important;color:#ffca18!important}.ui.inverted.yellow.basic.button:active,.ui.inverted.yellow.basic.buttons .button:active,.ui.inverted.yellow.buttons .basic.button:active{background-color:rgba(255,202,24,.2)!important;box-shadow:inset 0 0 0 0 #e4b000!important;color:#ffca18!important}.ui.olive.button,.ui.olive.buttons .button{background-color:#456558;color:#fff}.ui.basic.olive.button,.ui.basic.olive.buttons .button{box-shadow:inset 0 0 0 0 #456558!important;color:#456558!important}.ui.basic.olive.button:hover,.ui.basic.olive.buttons .button:hover{background:rgba(69,101,88,.2)!important;box-shadow:inset 0 0 0 0 #39574b!important;color:#39574b!important}.ui.basic.olive.button:focus,.ui.basic.olive.buttons .button:focus{background:rgba(69,101,88,.3)!important;box-shadow:inset 0 0 0 0 #324f43!important;color:#39574b!important}.ui.basic.olive.active.button,.ui.basic.olive.buttons .active.button{background:rgba(48,71,62,.2)!important;box-shadow:inset 0 0 0 0 #39584b!important;color:#30473e!important}.ui.basic.olive.button:active,.ui.basic.olive.buttons .button:active{box-shadow:inset 0 0 0 0 #30473e!important;color:#30473e!important}.ui.buttons:not(.vertical)>.basic.olive.button:not(:first-child){margin-left:0}.ui.inverted.olive.button,.ui.inverted.olive.buttons .button{background-color:#456558;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.olive.button.active,.ui.inverted.olive.button:active,.ui.inverted.olive.button:focus,.ui.inverted.olive.button:hover,.ui.inverted.olive.buttons .button.active,.ui.inverted.olive.buttons .button:active,.ui.inverted.olive.buttons .button:focus,.ui.inverted.olive.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.olive.button:hover,.ui.inverted.olive.buttons .button:hover{background-color:#459876}.ui.inverted.olive.button:focus,.ui.inverted.olive.buttons .button:focus{background-color:#3d916f}.ui.inverted.olive.active.button,.ui.inverted.olive.buttons .active.button{background-color:#497}.ui.inverted.olive.button:active,.ui.inverted.olive.buttons .button:active{background-color:#418368}.ui.inverted.olive.basic.button,.ui.inverted.olive.basic.buttons .button,.ui.inverted.olive.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#52a583!important}.ui.inverted.olive.basic.button:hover,.ui.inverted.olive.basic.buttons .button:hover,.ui.inverted.olive.buttons .basic.button:hover{background-color:rgba(69,101,88,.5)!important;box-shadow:inset 0 0 0 0 #459876!important;color:#fff!important}.ui.inverted.olive.basic.button:focus,.ui.inverted.olive.basic.buttons .button:focus{background-color:rgba(69,101,88,.5)!important;box-shadow:inset 0 0 0 0 #3d916f!important;color:#fff!important}.ui.inverted.olive.basic.active.button,.ui.inverted.olive.basic.buttons .active.button,.ui.inverted.olive.buttons .basic.active.button{background-color:rgba(69,101,88,.2)!important;box-shadow:inset 0 0 0 0 #497!important;color:#52a583!important}.ui.inverted.olive.basic.button:active,.ui.inverted.olive.basic.buttons .button:active,.ui.inverted.olive.buttons .basic.button:active{background-color:rgba(69,101,88,.2)!important;box-shadow:inset 0 0 0 0 #418368!important;color:#52a583!important}.ui.green.button,.ui.green.buttons .button{background-color:#54af71;color:#fff}.ui.basic.green.button,.ui.basic.green.buttons .button{box-shadow:inset 0 0 0 0 #54af71!important;color:#54af71!important}.ui.basic.green.button:hover,.ui.basic.green.buttons .button:hover{background:rgba(84,175,113,.2)!important;box-shadow:inset 0 0 0 0 #46a364!important;color:#46a364!important}.ui.basic.green.button:focus,.ui.basic.green.buttons .button:focus{background:rgba(84,175,113,.3)!important;box-shadow:inset 0 0 0 0 #3e9d5c!important;color:#46a364!important}.ui.basic.green.active.button,.ui.basic.green.buttons .active.button{background:rgba(66,142,90,.2)!important;box-shadow:inset 0 0 0 0 #44a563!important;color:#428e5a!important}.ui.basic.green.button:active,.ui.basic.green.buttons .button:active{box-shadow:inset 0 0 0 0 #428e5a!important;color:#428e5a!important}.ui.buttons:not(.vertical)>.basic.green.button:not(:first-child){margin-left:0}.ui.inverted.green.button,.ui.inverted.green.buttons .button{background-color:#54af71;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.green.button.active,.ui.inverted.green.button:active,.ui.inverted.green.button:focus,.ui.inverted.green.button:hover,.ui.inverted.green.buttons .button.active,.ui.inverted.green.buttons .button:active,.ui.inverted.green.buttons .button:focus,.ui.inverted.green.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.green.button:hover,.ui.inverted.green.buttons .button:hover{background-color:#4fce77}.ui.inverted.green.button:focus,.ui.inverted.green.buttons .button:focus{background-color:#3dd16c}.ui.inverted.green.active.button,.ui.inverted.green.buttons .active.button{background-color:#4cd176}.ui.inverted.green.button:active,.ui.inverted.green.buttons .button:active{background-color:#41c26a}.ui.inverted.green.basic.button,.ui.inverted.green.basic.buttons .button,.ui.inverted.green.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#68ce88!important}.ui.inverted.green.basic.button:hover,.ui.inverted.green.basic.buttons .button:hover,.ui.inverted.green.buttons .basic.button:hover{background-color:rgba(84,175,113,.5)!important;box-shadow:inset 0 0 0 0 #4fce77!important;color:#fff!important}.ui.inverted.green.basic.button:focus,.ui.inverted.green.basic.buttons .button:focus{background-color:rgba(84,175,113,.5)!important;box-shadow:inset 0 0 0 0 #3dd16c!important;color:#fff!important}.ui.inverted.green.basic.active.button,.ui.inverted.green.basic.buttons .active.button,.ui.inverted.green.buttons .basic.active.button{background-color:rgba(84,175,113,.2)!important;box-shadow:inset 0 0 0 0 #4cd176!important;color:#68ce88!important}.ui.inverted.green.basic.button:active,.ui.inverted.green.basic.buttons .button:active,.ui.inverted.green.buttons .basic.button:active{background-color:rgba(84,175,113,.2)!important;box-shadow:inset 0 0 0 0 #41c26a!important;color:#68ce88!important}.ui.teal.button,.ui.teal.buttons .button{background-color:#00a1ca;color:#fff}.ui.basic.teal.button,.ui.basic.teal.buttons .button{box-shadow:inset 0 0 0 0 #00a1ca!important;color:#00a1ca!important}.ui.basic.teal.button:hover,.ui.basic.teal.buttons .button:hover{background:rgba(0,161,202,.2)!important;box-shadow:inset 0 0 0 0 #008db1!important;color:#008db1!important}.ui.basic.teal.button:focus,.ui.basic.teal.buttons .button:focus{background:rgba(0,161,202,.3)!important;box-shadow:inset 0 0 0 0 #0080a1!important;color:#008db1!important}.ui.basic.teal.active.button,.ui.basic.teal.buttons .active.button{background:rgba(0,120,151,.2)!important;box-shadow:inset 0 0 0 0 #008db1!important;color:#007897!important}.ui.basic.teal.button:active,.ui.basic.teal.buttons .button:active{box-shadow:inset 0 0 0 0 #007897!important;color:#007897!important}.ui.buttons:not(.vertical)>.basic.teal.button:not(:first-child){margin-left:0}.ui.inverted.teal.button,.ui.inverted.teal.buttons .button{background-color:#00a1ca;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.teal.button.active,.ui.inverted.teal.button:active,.ui.inverted.teal.button:focus,.ui.inverted.teal.button:hover,.ui.inverted.teal.buttons .button.active,.ui.inverted.teal.buttons .button:active,.ui.inverted.teal.buttons .button:focus,.ui.inverted.teal.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.teal.button:hover,.ui.inverted.teal.buttons .button:hover{background-color:#00b5e4}.ui.inverted.teal.button:focus,.ui.inverted.teal.buttons .button:focus{background-color:#00a9d4}.ui.inverted.teal.active.button,.ui.inverted.teal.buttons .active.button{background-color:#00b5e4}.ui.inverted.teal.button:active,.ui.inverted.teal.buttons .button:active{background-color:#00a1ca}.ui.inverted.teal.basic.button,.ui.inverted.teal.basic.buttons .button,.ui.inverted.teal.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#00cafd!important}.ui.inverted.teal.basic.button:hover,.ui.inverted.teal.basic.buttons .button:hover,.ui.inverted.teal.buttons .basic.button:hover{background-color:rgba(0,161,202,.5)!important;box-shadow:inset 0 0 0 0 #00b5e4!important;color:#fff!important}.ui.inverted.teal.basic.button:focus,.ui.inverted.teal.basic.buttons .button:focus{background-color:rgba(0,161,202,.5)!important;box-shadow:inset 0 0 0 0 #00a9d4!important;color:#fff!important}.ui.inverted.teal.basic.active.button,.ui.inverted.teal.basic.buttons .active.button,.ui.inverted.teal.buttons .basic.active.button{background-color:rgba(0,161,202,.2)!important;box-shadow:inset 0 0 0 0 #00b5e4!important;color:#00cafd!important}.ui.inverted.teal.basic.button:active,.ui.inverted.teal.basic.buttons .button:active,.ui.inverted.teal.buttons .basic.button:active{background-color:rgba(0,161,202,.2)!important;box-shadow:inset 0 0 0 0 #00a1ca!important;color:#00cafd!important}.ui.blue.button,.ui.blue.buttons .button{background-color:#1d5f82;color:#fff}.ui.basic.blue.button,.ui.basic.blue.buttons .button{box-shadow:inset 0 0 0 0 #1d5f82!important;color:#1d5f82!important}.ui.basic.blue.button:hover,.ui.basic.blue.buttons .button:hover{background:rgba(29,95,130,.2)!important;box-shadow:inset 0 0 0 0 #145171!important;color:#145171!important}.ui.basic.blue.button:focus,.ui.basic.blue.buttons .button:focus{background:rgba(29,95,130,.3)!important;box-shadow:inset 0 0 0 0 #0e4968!important;color:#145171!important}.ui.basic.blue.active.button,.ui.basic.blue.buttons .active.button{background:rgba(20,65,88,.2)!important;box-shadow:inset 0 0 0 0 #125274!important;color:#144158!important}.ui.basic.blue.button:active,.ui.basic.blue.buttons .button:active{box-shadow:inset 0 0 0 0 #144158!important;color:#144158!important}.ui.buttons:not(.vertical)>.basic.blue.button:not(:first-child){margin-left:0}.ui.inverted.blue.button,.ui.inverted.blue.buttons .button{background-color:#1d5f82;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.blue.button.active,.ui.inverted.blue.button:active,.ui.inverted.blue.button:focus,.ui.inverted.blue.button:hover,.ui.inverted.blue.buttons .button.active,.ui.inverted.blue.buttons .button:active,.ui.inverted.blue.buttons .button:focus,.ui.inverted.blue.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.blue.button:hover,.ui.inverted.blue.buttons .button:hover{background-color:#0d75ac}.ui.inverted.blue.button:focus,.ui.inverted.blue.buttons .button:focus{background-color:#056da4}.ui.inverted.blue.active.button,.ui.inverted.blue.buttons .active.button{background-color:#0976b0}.ui.inverted.blue.button:active,.ui.inverted.blue.buttons .button:active{background-color:#11638e}.ui.inverted.blue.basic.button,.ui.inverted.blue.basic.buttons .button,.ui.inverted.blue.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#1782bb!important}.ui.inverted.blue.basic.button:hover,.ui.inverted.blue.basic.buttons .button:hover,.ui.inverted.blue.buttons .basic.button:hover{background-color:rgba(29,95,130,.5)!important;box-shadow:inset 0 0 0 0 #0d75ac!important;color:#fff!important}.ui.inverted.blue.basic.button:focus,.ui.inverted.blue.basic.buttons .button:focus{background-color:rgba(29,95,130,.5)!important;box-shadow:inset 0 0 0 0 #056da4!important;color:#fff!important}.ui.inverted.blue.basic.active.button,.ui.inverted.blue.basic.buttons .active.button,.ui.inverted.blue.buttons .basic.active.button{background-color:rgba(29,95,130,.2)!important;box-shadow:inset 0 0 0 0 #0976b0!important;color:#1782bb!important}.ui.inverted.blue.basic.button:active,.ui.inverted.blue.basic.buttons .button:active,.ui.inverted.blue.buttons .basic.button:active{background-color:rgba(29,95,130,.2)!important;box-shadow:inset 0 0 0 0 #11638e!important;color:#1782bb!important}.ui.violet.button,.ui.violet.buttons .button{background-color:#525394;color:#fff}.ui.basic.violet.button,.ui.basic.violet.buttons .button{box-shadow:inset 0 0 0 0 #525394!important;color:#525394!important}.ui.basic.violet.button:hover,.ui.basic.violet.buttons .button:hover{background:rgba(82,83,148,.2)!important;box-shadow:inset 0 0 0 0 #464787!important;color:#464787!important}.ui.basic.violet.button:focus,.ui.basic.violet.buttons .button:focus{background:rgba(82,83,148,.3)!important;box-shadow:inset 0 0 0 0 #3e3f7f!important;color:#464787!important}.ui.basic.violet.active.button,.ui.basic.violet.buttons .active.button{background:rgba(64,65,115,.2)!important;box-shadow:inset 0 0 0 0 #454688!important;color:#404173!important}.ui.basic.violet.button:active,.ui.basic.violet.buttons .button:active{box-shadow:inset 0 0 0 0 #404173!important;color:#404173!important}.ui.buttons:not(.vertical)>.basic.violet.button:not(:first-child){margin-left:0}.ui.inverted.violet.button,.ui.inverted.violet.buttons .button{background-color:#525394;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.violet.button.active,.ui.inverted.violet.button:active,.ui.inverted.violet.button:focus,.ui.inverted.violet.button:hover,.ui.inverted.violet.buttons .button.active,.ui.inverted.violet.buttons .button:active,.ui.inverted.violet.buttons .button:focus,.ui.inverted.violet.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.violet.button:hover,.ui.inverted.violet.buttons .button:hover{background-color:#5557c4}.ui.inverted.violet.button:focus,.ui.inverted.violet.buttons .button:focus{background-color:#4547c5}.ui.inverted.violet.active.button,.ui.inverted.violet.buttons .active.button{background-color:#5355c6}.ui.inverted.violet.button:active,.ui.inverted.violet.buttons .button:active{background-color:#484ab7}.ui.inverted.violet.basic.button,.ui.inverted.violet.basic.buttons .button,.ui.inverted.violet.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#6d6ec6!important}.ui.inverted.violet.basic.button:hover,.ui.inverted.violet.basic.buttons .button:hover,.ui.inverted.violet.buttons .basic.button:hover{background-color:rgba(82,83,148,.5)!important;box-shadow:inset 0 0 0 0 #5557c4!important;color:#fff!important}.ui.inverted.violet.basic.button:focus,.ui.inverted.violet.basic.buttons .button:focus{background-color:rgba(82,83,148,.5)!important;box-shadow:inset 0 0 0 0 #4547c5!important;color:#fff!important}.ui.inverted.violet.basic.active.button,.ui.inverted.violet.basic.buttons .active.button,.ui.inverted.violet.buttons .basic.active.button{background-color:rgba(82,83,148,.2)!important;box-shadow:inset 0 0 0 0 #5355c6!important;color:#6d6ec6!important}.ui.inverted.violet.basic.button:active,.ui.inverted.violet.basic.buttons .button:active,.ui.inverted.violet.buttons .basic.button:active{background-color:rgba(82,83,148,.2)!important;box-shadow:inset 0 0 0 0 #484ab7!important;color:#6d6ec6!important}.ui.purple.button,.ui.purple.buttons .button{background-color:#ad427f;color:#fff}.ui.basic.purple.button,.ui.basic.purple.buttons .button{box-shadow:inset 0 0 0 0 #ad427f!important;color:#ad427f!important}.ui.basic.purple.button:hover,.ui.basic.purple.buttons .button:hover{background:rgba(173,66,127,.2)!important;box-shadow:inset 0 0 0 0 #9f3672!important;color:#9f3672!important}.ui.basic.purple.button:focus,.ui.basic.purple.buttons .button:focus{background:rgba(173,66,127,.3)!important;box-shadow:inset 0 0 0 0 #982e6b!important;color:#9f3672!important}.ui.basic.purple.active.button,.ui.basic.purple.buttons .active.button{background:rgba(136,52,100,.2)!important;box-shadow:inset 0 0 0 0 #a23472!important;color:#883464!important}.ui.basic.purple.button:active,.ui.basic.purple.buttons .button:active{box-shadow:inset 0 0 0 0 #883464!important;color:#883464!important}.ui.buttons:not(.vertical)>.basic.purple.button:not(:first-child){margin-left:0}.ui.inverted.purple.button,.ui.inverted.purple.buttons .button{background-color:#ad427f;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.purple.button.active,.ui.inverted.purple.button:active,.ui.inverted.purple.button:focus,.ui.inverted.purple.button:hover,.ui.inverted.purple.buttons .button.active,.ui.inverted.purple.buttons .button:active,.ui.inverted.purple.buttons .button:focus,.ui.inverted.purple.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.purple.button:hover,.ui.inverted.purple.buttons .button:hover{background-color:#d9499b}.ui.inverted.purple.button:focus,.ui.inverted.purple.buttons .button:focus{background-color:#de3595}.ui.inverted.purple.active.button,.ui.inverted.purple.buttons .active.button{background-color:#dd459c}.ui.inverted.purple.button:active,.ui.inverted.purple.buttons .button:active{background-color:#ce3b8f}.ui.inverted.purple.basic.button,.ui.inverted.purple.basic.buttons .button,.ui.inverted.purple.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#d864a6!important}.ui.inverted.purple.basic.button:hover,.ui.inverted.purple.basic.buttons .button:hover,.ui.inverted.purple.buttons .basic.button:hover{background-color:rgba(173,66,127,.5)!important;box-shadow:inset 0 0 0 0 #d9499b!important;color:#fff!important}.ui.inverted.purple.basic.button:focus,.ui.inverted.purple.basic.buttons .button:focus{background-color:rgba(173,66,127,.5)!important;box-shadow:inset 0 0 0 0 #de3595!important;color:#fff!important}.ui.inverted.purple.basic.active.button,.ui.inverted.purple.basic.buttons .active.button,.ui.inverted.purple.buttons .basic.active.button{background-color:rgba(173,66,127,.2)!important;box-shadow:inset 0 0 0 0 #dd459c!important;color:#d864a6!important}.ui.inverted.purple.basic.button:active,.ui.inverted.purple.basic.buttons .button:active,.ui.inverted.purple.buttons .basic.button:active{background-color:rgba(173,66,127,.2)!important;box-shadow:inset 0 0 0 0 #ce3b8f!important;color:#d864a6!important}.ui.pink.button,.ui.pink.buttons .button{background-color:#e03997;color:#fff}.ui.basic.pink.button,.ui.basic.pink.buttons .button{box-shadow:inset 0 0 0 0 #e03997!important;color:#e03997!important}.ui.basic.pink.button:hover,.ui.basic.pink.buttons .button:hover{background:rgba(224,57,151,.2)!important;box-shadow:inset 0 0 0 0 #e61a8d!important;color:#e61a8d!important}.ui.basic.pink.button:focus,.ui.basic.pink.buttons .button:focus{background:rgba(224,57,151,.3)!important;box-shadow:inset 0 0 0 0 #e10f85!important;color:#e61a8d!important}.ui.basic.pink.active.button,.ui.basic.pink.buttons .active.button{background:rgba(199,31,126,.2)!important;box-shadow:inset 0 0 0 0 #ea158d!important;color:#c71f7e!important}.ui.basic.pink.button:active,.ui.basic.pink.buttons .button:active{box-shadow:inset 0 0 0 0 #c71f7e!important;color:#c71f7e!important}.ui.buttons:not(.vertical)>.basic.pink.button:not(:first-child){margin-left:0}.ui.inverted.pink.button,.ui.inverted.pink.buttons .button{background-color:#e03997;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.pink.button.active,.ui.inverted.pink.button:active,.ui.inverted.pink.button:focus,.ui.inverted.pink.button:hover,.ui.inverted.pink.buttons .button.active,.ui.inverted.pink.buttons .button:active,.ui.inverted.pink.buttons .button:focus,.ui.inverted.pink.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.pink.button:hover,.ui.inverted.pink.buttons .button:hover{background-color:#fc50b1}.ui.inverted.pink.button:focus,.ui.inverted.pink.buttons .button:focus{background-color:#ff3eab}.ui.inverted.pink.active.button,.ui.inverted.pink.buttons .active.button{background-color:#ff4db1}.ui.inverted.pink.button:active,.ui.inverted.pink.buttons .button:active{background-color:#f340a5}.ui.inverted.pink.basic.button,.ui.inverted.pink.basic.buttons .button,.ui.inverted.pink.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#f670bb!important}.ui.inverted.pink.basic.button:hover,.ui.inverted.pink.basic.buttons .button:hover,.ui.inverted.pink.buttons .basic.button:hover{background-color:rgba(224,57,151,.5)!important;box-shadow:inset 0 0 0 0 #fc50b1!important;color:#fff!important}.ui.inverted.pink.basic.button:focus,.ui.inverted.pink.basic.buttons .button:focus{background-color:rgba(224,57,151,.5)!important;box-shadow:inset 0 0 0 0 #ff3eab!important;color:#fff!important}.ui.inverted.pink.basic.active.button,.ui.inverted.pink.basic.buttons .active.button,.ui.inverted.pink.buttons .basic.active.button{background-color:rgba(224,57,151,.2)!important;box-shadow:inset 0 0 0 0 #ff4db1!important;color:#f670bb!important}.ui.inverted.pink.basic.button:active,.ui.inverted.pink.basic.buttons .button:active,.ui.inverted.pink.buttons .basic.button:active{background-color:rgba(224,57,151,.2)!important;box-shadow:inset 0 0 0 0 #f340a5!important;color:#f670bb!important}.ui.brown.button,.ui.brown.buttons .button{background-color:#a67a00;color:#fff}.ui.basic.brown.button,.ui.basic.brown.buttons .button{box-shadow:inset 0 0 0 0 #a67a00!important;color:#a67a00!important}.ui.basic.brown.button:hover,.ui.basic.brown.buttons .button:hover{background:rgba(166,122,0,.2)!important;box-shadow:inset 0 0 0 0 #8d6700!important;color:#8d6700!important}.ui.basic.brown.button:focus,.ui.basic.brown.buttons .button:focus{background:rgba(166,122,0,.3)!important;box-shadow:inset 0 0 0 0 #7d5c00!important;color:#8d6700!important}.ui.basic.brown.active.button,.ui.basic.brown.buttons .active.button{background:rgba(115,85,0,.2)!important;box-shadow:inset 0 0 0 0 #8d6700!important;color:#735500!important}.ui.basic.brown.button:active,.ui.basic.brown.buttons .button:active{box-shadow:inset 0 0 0 0 #735500!important;color:#735500!important}.ui.buttons:not(.vertical)>.basic.brown.button:not(:first-child){margin-left:0}.ui.inverted.brown.button,.ui.inverted.brown.buttons .button{background-color:#a67a00;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.brown.button.active,.ui.inverted.brown.button:active,.ui.inverted.brown.button:focus,.ui.inverted.brown.button:hover,.ui.inverted.brown.buttons .button.active,.ui.inverted.brown.buttons .button:active,.ui.inverted.brown.buttons .button:focus,.ui.inverted.brown.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.brown.button:hover,.ui.inverted.brown.buttons .button:hover{background-color:#d99f00}.ui.inverted.brown.button:focus,.ui.inverted.brown.buttons .button:focus{background-color:#ca9400}.ui.inverted.brown.active.button,.ui.inverted.brown.buttons .active.button{background-color:#d99f00}.ui.inverted.brown.button:active,.ui.inverted.brown.buttons .button:active{background-color:#c08d00}.ui.inverted.brown.basic.button,.ui.inverted.brown.basic.buttons .button,.ui.inverted.brown.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#f3b200!important}.ui.inverted.brown.basic.button:hover,.ui.inverted.brown.basic.buttons .button:hover,.ui.inverted.brown.buttons .basic.button:hover{background-color:rgba(166,122,0,.5)!important;box-shadow:inset 0 0 0 0 #d99f00!important;color:#fff!important}.ui.inverted.brown.basic.button:focus,.ui.inverted.brown.basic.buttons .button:focus{background-color:rgba(166,122,0,.5)!important;box-shadow:inset 0 0 0 0 #ca9400!important;color:#fff!important}.ui.inverted.brown.basic.active.button,.ui.inverted.brown.basic.buttons .active.button,.ui.inverted.brown.buttons .basic.active.button{background-color:rgba(166,122,0,.2)!important;box-shadow:inset 0 0 0 0 #d99f00!important;color:#f3b200!important}.ui.inverted.brown.basic.button:active,.ui.inverted.brown.basic.buttons .button:active,.ui.inverted.brown.buttons .basic.button:active{background-color:rgba(166,122,0,.2)!important;box-shadow:inset 0 0 0 0 #c08d00!important;color:#f3b200!important}.ui.grey.button,.ui.grey.buttons .button{background-color:#5a686d;color:#fff}.ui.basic.grey.button,.ui.basic.grey.buttons .button{box-shadow:inset 0 0 0 0 #5a686d!important;color:#5a686d!important}.ui.basic.grey.button:hover,.ui.basic.grey.buttons .button:hover{background:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #66757b!important;color:#66757b!important}.ui.basic.grey.button:focus,.ui.basic.grey.buttons .button:focus{background:rgba(90,104,109,.3)!important;box-shadow:inset 0 0 0 0 #6c7d83!important;color:#66757b!important}.ui.basic.grey.active.button,.ui.basic.grey.buttons .active.button{background:rgba(113,131,137,.2)!important;box-shadow:inset 0 0 0 0 #4e5b5f!important;color:#718389!important}.ui.basic.grey.button:active,.ui.basic.grey.buttons .button:active{box-shadow:inset 0 0 0 0 #718389!important;color:#718389!important}.ui.buttons:not(.vertical)>.basic.grey.button:not(:first-child){margin-left:0}.ui.inverted.grey.button,.ui.inverted.grey.buttons .button{background-color:#5a686d;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.grey.button.active,.ui.inverted.grey.button:active,.ui.inverted.grey.button:focus,.ui.inverted.grey.button:hover,.ui.inverted.grey.buttons .button.active,.ui.inverted.grey.buttons .button:active,.ui.inverted.grey.buttons .button:focus,.ui.inverted.grey.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.grey.button:hover,.ui.inverted.grey.buttons .button:hover{background-color:#70838a}.ui.inverted.grey.button:focus,.ui.inverted.grey.buttons .button:focus{background-color:#687c83}.ui.inverted.grey.active.button,.ui.inverted.grey.buttons .active.button{background-color:#6f848b}.ui.inverted.grey.button:active,.ui.inverted.grey.buttons .button:active{background-color:#66757b}.ui.inverted.grey.basic.button,.ui.inverted.grey.basic.buttons .button,.ui.inverted.grey.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#7f8f95!important}.ui.inverted.grey.basic.button:hover,.ui.inverted.grey.basic.buttons .button:hover,.ui.inverted.grey.buttons .basic.button:hover{background-color:rgba(90,104,109,.5)!important;box-shadow:inset 0 0 0 0 #70838a!important;color:#fff!important}.ui.inverted.grey.basic.button:focus,.ui.inverted.grey.basic.buttons .button:focus{background-color:rgba(90,104,109,.5)!important;box-shadow:inset 0 0 0 0 #687c83!important;color:#fff!important}.ui.inverted.grey.basic.active.button,.ui.inverted.grey.basic.buttons .active.button,.ui.inverted.grey.buttons .basic.active.button{background-color:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #6f848b!important;color:#7f8f95!important}.ui.inverted.grey.basic.button:active,.ui.inverted.grey.basic.buttons .button:active,.ui.inverted.grey.buttons .basic.button:active{background-color:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #66757b!important;color:#7f8f95!important}.ui.black.button,.ui.black.buttons .button{background-color:#1b1c1d;color:#fff}.ui.basic.black.button,.ui.basic.black.buttons .button{box-shadow:inset 0 0 0 0 #1b1c1d!important;color:#1b1c1d!important}.ui.basic.black.button:hover,.ui.basic.black.buttons .button:hover{background:rgba(27,28,29,.2)!important;box-shadow:inset 0 0 0 0 #27292a!important;color:#27292a!important}.ui.basic.black.button:focus,.ui.basic.black.buttons .button:focus{background:rgba(27,28,29,.3)!important;box-shadow:inset 0 0 0 0 #2f3032!important;color:#27292a!important}.ui.basic.black.active.button,.ui.basic.black.buttons .active.button{background:rgba(52,54,55,.2)!important;box-shadow:inset 0 0 0 0 #0f0f10!important;color:#343637!important}.ui.basic.black.button:active,.ui.basic.black.buttons .button:active{box-shadow:inset 0 0 0 0 #343637!important;color:#343637!important}.ui.buttons:not(.vertical)>.basic.black.button:not(:first-child){margin-left:0}.ui.inverted.black.button,.ui.inverted.black.buttons .button{background-color:#1b1c1d;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.black.button.active,.ui.inverted.black.button:active,.ui.inverted.black.button:focus,.ui.inverted.black.button:hover,.ui.inverted.black.buttons .button.active,.ui.inverted.black.buttons .button:active,.ui.inverted.black.buttons .button:focus,.ui.inverted.black.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.black.active.button,.ui.inverted.black.button:active,.ui.inverted.black.button:focus,.ui.inverted.black.button:hover,.ui.inverted.black.buttons .active.button,.ui.inverted.black.buttons .button:active,.ui.inverted.black.buttons .button:focus,.ui.inverted.black.buttons .button:hover{background-color:#000}.ui.inverted.black.basic.button,.ui.inverted.black.basic.buttons .button,.ui.inverted.black.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#545454!important}.ui.inverted.black.basic.button:focus,.ui.inverted.black.basic.button:hover,.ui.inverted.black.basic.buttons .button:focus,.ui.inverted.black.basic.buttons .button:hover,.ui.inverted.black.buttons .basic.button:hover{background-color:rgba(27,28,29,.5)!important;box-shadow:inset 0 0 0 0 #000!important;color:#fff!important}.ui.inverted.black.basic.active.button,.ui.inverted.black.basic.button:active,.ui.inverted.black.basic.buttons .active.button,.ui.inverted.black.basic.buttons .button:active,.ui.inverted.black.buttons .basic.active.button,.ui.inverted.black.buttons .basic.button:active{background-color:rgba(27,28,29,.2)!important;box-shadow:inset 0 0 0 0 #000!important;color:#545454!important}.ui.primary.button,.ui.primary.buttons .button{background-color:#007abf;color:#fff}.ui.basic.primary.button,.ui.basic.primary.buttons .button{box-shadow:inset 0 0 0 0 #007abf!important;color:#007abf!important}.ui.basic.primary.button:hover,.ui.basic.primary.buttons .button:hover{background:rgba(0,122,191,.2)!important;box-shadow:inset 0 0 0 0 #006aa6!important;color:#006aa6!important}.ui.basic.primary.button:focus,.ui.basic.primary.buttons .button:focus{background:rgba(0,122,191,.3)!important;box-shadow:inset 0 0 0 0 #006096!important;color:#006aa6!important}.ui.basic.primary.active.button,.ui.basic.primary.buttons .active.button{background:rgba(0,89,140,.2)!important;box-shadow:inset 0 0 0 0 #006aa6!important;color:#00598c!important}.ui.basic.primary.button:active,.ui.basic.primary.buttons .button:active{box-shadow:inset 0 0 0 0 #00598c!important;color:#00598c!important}.ui.buttons:not(.vertical)>.basic.primary.button:not(:first-child){margin-left:0}.ui.inverted.primary.button,.ui.inverted.primary.buttons .button{background-color:#007abf;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.primary.button.active,.ui.inverted.primary.button:active,.ui.inverted.primary.button:focus,.ui.inverted.primary.button:hover,.ui.inverted.primary.buttons .button.active,.ui.inverted.primary.buttons .button:active,.ui.inverted.primary.buttons .button:focus,.ui.inverted.primary.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.primary.button:hover,.ui.inverted.primary.buttons .button:hover{background-color:#006aa6}.ui.inverted.primary.button:focus,.ui.inverted.primary.buttons .button:focus{background-color:#006096}.ui.inverted.primary.active.button,.ui.inverted.primary.buttons .active.button{background-color:#006aa6}.ui.inverted.primary.button:active,.ui.inverted.primary.buttons .button:active{background-color:#00598c}.ui.inverted.primary.basic.button,.ui.inverted.primary.basic.buttons .button,.ui.inverted.primary.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#26b1ff!important}.ui.inverted.primary.basic.button:hover,.ui.inverted.primary.basic.buttons .button:hover,.ui.inverted.primary.buttons .basic.button:hover{background-color:rgba(0,122,191,.5)!important;box-shadow:inset 0 0 0 0 #006aa6!important;color:#fff!important}.ui.inverted.primary.basic.button:focus,.ui.inverted.primary.basic.buttons .button:focus{background-color:rgba(0,122,191,.5)!important;box-shadow:inset 0 0 0 0 #006096!important;color:#fff!important}.ui.inverted.primary.basic.active.button,.ui.inverted.primary.basic.buttons .active.button,.ui.inverted.primary.buttons .basic.active.button{background-color:rgba(0,122,191,.2)!important;box-shadow:inset 0 0 0 0 #006aa6!important;color:#26b1ff!important}.ui.inverted.primary.basic.button:active,.ui.inverted.primary.basic.buttons .button:active,.ui.inverted.primary.buttons .basic.button:active{background-color:rgba(0,122,191,.2)!important;box-shadow:inset 0 0 0 0 #00598c!important;color:#26b1ff!important}.ui.secondary.button,.ui.secondary.buttons .button{background-color:#5a686d;color:#fff}.ui.basic.secondary.button,.ui.basic.secondary.buttons .button{box-shadow:inset 0 0 0 0 #5a686d!important;color:#5a686d!important}.ui.basic.secondary.button:hover,.ui.basic.secondary.buttons .button:hover{background:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #64767c!important;color:#64767c!important}.ui.basic.secondary.button:focus,.ui.basic.secondary.buttons .button:focus{background:rgba(90,104,109,.3)!important;box-shadow:inset 0 0 0 0 #6a7e86!important;color:#64767c!important}.ui.basic.secondary.active.button,.ui.basic.secondary.buttons .active.button{background:rgba(113,131,137,.2)!important;box-shadow:inset 0 0 0 0 #64767d!important;color:#718389!important}.ui.basic.secondary.button:active,.ui.basic.secondary.buttons .button:active{box-shadow:inset 0 0 0 0 #718389!important;color:#718389!important}.ui.buttons:not(.vertical)>.basic.secondary.button:not(:first-child){margin-left:0}.ui.inverted.secondary.button,.ui.inverted.secondary.buttons .button{background-color:#5a686d;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.secondary.button.active,.ui.inverted.secondary.button:active,.ui.inverted.secondary.button:focus,.ui.inverted.secondary.button:hover,.ui.inverted.secondary.buttons .button.active,.ui.inverted.secondary.buttons .button:active,.ui.inverted.secondary.buttons .button:focus,.ui.inverted.secondary.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.secondary.button:hover,.ui.inverted.secondary.buttons .button:hover{background-color:#64767c}.ui.inverted.secondary.button:focus,.ui.inverted.secondary.buttons .button:focus{background-color:#6a7e86}.ui.inverted.secondary.active.button,.ui.inverted.secondary.buttons .active.button{background-color:#64767d}.ui.inverted.secondary.button:active,.ui.inverted.secondary.buttons .button:active{background-color:#718389}.ui.inverted.secondary.basic.button,.ui.inverted.secondary.basic.buttons .button,.ui.inverted.secondary.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#8d9ba0!important}.ui.inverted.secondary.basic.button:hover,.ui.inverted.secondary.basic.buttons .button:hover,.ui.inverted.secondary.buttons .basic.button:hover{background-color:rgba(90,104,109,.5)!important;box-shadow:inset 0 0 0 0 #64767c!important;color:#fff!important}.ui.inverted.secondary.basic.button:focus,.ui.inverted.secondary.basic.buttons .button:focus{background-color:rgba(90,104,109,.5)!important;box-shadow:inset 0 0 0 0 #6a7e86!important;color:#fff!important}.ui.inverted.secondary.basic.active.button,.ui.inverted.secondary.basic.buttons .active.button,.ui.inverted.secondary.buttons .basic.active.button{background-color:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #64767d!important;color:#8d9ba0!important}.ui.inverted.secondary.basic.button:active,.ui.inverted.secondary.basic.buttons .button:active,.ui.inverted.secondary.buttons .basic.button:active{background-color:rgba(90,104,109,.2)!important;box-shadow:inset 0 0 0 0 #718389!important;color:#8d9ba0!important}.ui.positive.button,.ui.positive.buttons .button{background-color:#4d9221;color:#fff}.ui.basic.positive.button,.ui.basic.positive.buttons .button{box-shadow:inset 0 0 0 0 #4d9221!important;color:#4d9221!important}.ui.basic.positive.button:hover,.ui.basic.positive.buttons .button:hover{background:rgba(77,146,33,.2)!important;box-shadow:inset 0 0 0 0 #418217!important;color:#418217!important}.ui.basic.positive.button:focus,.ui.basic.positive.buttons .button:focus{background:rgba(77,146,33,.3)!important;box-shadow:inset 0 0 0 0 #3a7911!important;color:#418217!important}.ui.basic.positive.active.button,.ui.basic.positive.buttons .active.button{background:rgba(55,104,24,.2)!important;box-shadow:inset 0 0 0 0 #408415!important;color:#376818!important}.ui.basic.positive.button:active,.ui.basic.positive.buttons .button:active{box-shadow:inset 0 0 0 0 #376818!important;color:#376818!important}.ui.buttons:not(.vertical)>.basic.positive.button:not(:first-child){margin-left:0}.ui.inverted.positive.button,.ui.inverted.positive.buttons .button{background-color:#4d9221;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.positive.button.active,.ui.inverted.positive.button:active,.ui.inverted.positive.button:focus,.ui.inverted.positive.button:hover,.ui.inverted.positive.buttons .button.active,.ui.inverted.positive.buttons .button:active,.ui.inverted.positive.buttons .button:focus,.ui.inverted.positive.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.positive.button:hover,.ui.inverted.positive.buttons .button:hover{background-color:#418217}.ui.inverted.positive.button:focus,.ui.inverted.positive.buttons .button:focus{background-color:#3a7911}.ui.inverted.positive.active.button,.ui.inverted.positive.buttons .active.button{background-color:#408415}.ui.inverted.positive.button:active,.ui.inverted.positive.buttons .button:active{background-color:#376818}.ui.inverted.positive.basic.button,.ui.inverted.positive.basic.buttons .button,.ui.inverted.positive.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#4d9221!important}.ui.inverted.positive.basic.button:hover,.ui.inverted.positive.basic.buttons .button:hover,.ui.inverted.positive.buttons .basic.button:hover{background-color:rgba(77,146,33,.5)!important;box-shadow:inset 0 0 0 0 #418217!important;color:#fff!important}.ui.inverted.positive.basic.button:focus,.ui.inverted.positive.basic.buttons .button:focus{background-color:rgba(77,146,33,.5)!important;box-shadow:inset 0 0 0 0 #3a7911!important;color:#fff!important}.ui.inverted.positive.basic.active.button,.ui.inverted.positive.basic.buttons .active.button,.ui.inverted.positive.buttons .basic.active.button{background-color:rgba(77,146,33,.2)!important;box-shadow:inset 0 0 0 0 #408415!important;color:#4d9221!important}.ui.inverted.positive.basic.button:active,.ui.inverted.positive.basic.buttons .button:active,.ui.inverted.positive.buttons .basic.button:active{background-color:rgba(77,146,33,.2)!important;box-shadow:inset 0 0 0 0 #376818!important;color:#4d9221!important}.ui.negative.button,.ui.negative.buttons .button{background-color:#c51b7d;color:#fff}.ui.basic.negative.button,.ui.basic.negative.buttons .button{box-shadow:inset 0 0 0 0 #c51b7d!important;color:#c51b7d!important}.ui.basic.negative.button:hover,.ui.basic.negative.buttons .button:hover{background:rgba(197,27,125,.2)!important;box-shadow:inset 0 0 0 0 #b61070!important;color:#b61070!important}.ui.basic.negative.button:focus,.ui.basic.negative.buttons .button:focus{background:rgba(197,27,125,.3)!important;box-shadow:inset 0 0 0 0 #af0868!important;color:#b61070!important}.ui.basic.negative.active.button,.ui.basic.negative.buttons .active.button{background:rgba(152,21,97,.2)!important;box-shadow:inset 0 0 0 0 #ba0d70!important;color:#981561!important}.ui.basic.negative.button:active,.ui.basic.negative.buttons .button:active{box-shadow:inset 0 0 0 0 #981561!important;color:#981561!important}.ui.buttons:not(.vertical)>.basic.negative.button:not(:first-child){margin-left:0}.ui.inverted.negative.button,.ui.inverted.negative.buttons .button{background-color:#c51b7d;box-shadow:inset 0 0 0 0 #d4d4d5!important;color:#fff}.ui.inverted.negative.button.active,.ui.inverted.negative.button:active,.ui.inverted.negative.button:focus,.ui.inverted.negative.button:hover,.ui.inverted.negative.buttons .button.active,.ui.inverted.negative.buttons .button:active,.ui.inverted.negative.buttons .button:focus,.ui.inverted.negative.buttons .button:hover{box-shadow:none!important;color:#fff}.ui.inverted.negative.button:hover,.ui.inverted.negative.buttons .button:hover{background-color:#b61070}.ui.inverted.negative.button:focus,.ui.inverted.negative.buttons .button:focus{background-color:#af0868}.ui.inverted.negative.active.button,.ui.inverted.negative.buttons .active.button{background-color:#ba0d70}.ui.inverted.negative.button:active,.ui.inverted.negative.buttons .button:active{background-color:#981561}.ui.inverted.negative.basic.button,.ui.inverted.negative.basic.buttons .button,.ui.inverted.negative.buttons .basic.button{background-color:transparent;box-shadow:inset 0 0 0 0 hsla(0,0%,100%,.5)!important;color:#c51b7d!important}.ui.inverted.negative.basic.button:hover,.ui.inverted.negative.basic.buttons .button:hover,.ui.inverted.negative.buttons .basic.button:hover{background-color:rgba(197,27,125,.5)!important;box-shadow:inset 0 0 0 0 #b61070!important;color:#fff!important}.ui.inverted.negative.basic.button:focus,.ui.inverted.negative.basic.buttons .button:focus{background-color:rgba(197,27,125,.5)!important;box-shadow:inset 0 0 0 0 #af0868!important;color:#fff!important}.ui.inverted.negative.basic.active.button,.ui.inverted.negative.basic.buttons .active.button,.ui.inverted.negative.buttons .basic.active.button{background-color:rgba(197,27,125,.2)!important;box-shadow:inset 0 0 0 0 #ba0d70!important;color:#c51b7d!important}.ui.inverted.negative.basic.button:active,.ui.inverted.negative.basic.buttons .button:active,.ui.inverted.negative.buttons .basic.button:active{background-color:rgba(197,27,125,.2)!important;box-shadow:inset 0 0 0 0 #981561!important;color:#c51b7d!important}", ""]);
	
	// exports


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Container\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.container{display:block;max-width:100%!important}@media only screen and (max-width:767px){.ui.container{margin-left:1em!important;margin-right:1em!important}.ui.container,.ui.grid.container,.ui.relaxed.grid.container,.ui.very.relaxed.grid.container{width:auto!important}}@media only screen and (min-width:768px) and (max-width:991px){.ui.container{width:717px;margin-left:auto!important;margin-right:auto!important}.ui.grid.container{width:calc(717px + 2rem)!important}.ui.relaxed.grid.container{width:calc(717px + 3rem)!important}.ui.very.relaxed.grid.container{width:calc(717px + 5rem)!important}}@media only screen and (min-width:992px) and (max-width:1199px){.ui.container{width:924px;margin-left:auto!important;margin-right:auto!important}.ui.grid.container{width:calc(924px + 2rem)!important}.ui.relaxed.grid.container{width:calc(924px + 3rem)!important}.ui.very.relaxed.grid.container{width:calc(924px + 5rem)!important}}@media only screen and (min-width:1200px){.ui.container{width:1115px;margin-left:auto!important;margin-right:auto!important}.ui.grid.container{width:calc(1115px + 2rem)!important}.ui.relaxed.grid.container{width:calc(1115px + 3rem)!important}.ui.very.relaxed.grid.container{width:calc(1115px + 5rem)!important}}.ui.text.container{font-family:Georgia,serif;max-width:700px!important;line-height:1.5;font-size:1rem}.ui.fluid.container{width:100%}.ui[class*=\"left aligned\"].container{text-align:left}.ui[class*=\"center aligned\"].container{text-align:center}.ui[class*=\"right aligned\"].container{text-align:right}.ui.justified.container{text-align:justify;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}.ui.infographic.infographic.container{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}", ""]);
	
	// exports


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Dimmer\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.dimmable:not(.body){position:relative}.ui.dimmer{display:none;position:absolute;top:0!important;left:0!important;width:100%;height:100%;text-align:center;vertical-align:middle;background-color:rgba(0,0,0,.85);opacity:0;line-height:1;-webkit-animation-fill-mode:both;animation-fill-mode:both;-webkit-animation-duration:.5s;animation-duration:.5s;-webkit-transition:background-color .5s linear;transition:background-color .5s linear;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;will-change:opacity;z-index:1000}.ui.dimmer>.content{width:100%;height:100%;display:table;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text}.ui.dimmer>.content>*{display:table-cell;vertical-align:middle;color:#fff}.ui.segment>.ui.dimmer{border-radius:inherit!important}.animating.dimmable:not(body),.dimmed.dimmable:not(body){overflow:hidden}.dimmed.dimmable>.ui.animating.dimmer,.dimmed.dimmable>.ui.visible.dimmer,.ui.active.dimmer{display:block;opacity:1}.ui.disabled.dimmer{width:0!important;height:0!important}.ui.page.dimmer{position:fixed;-webkit-transform-style:'';transform-style:'';-webkit-perspective:2000px;perspective:2000px;-webkit-transform-origin:center center;transform-origin:center center}body.animating.in.dimmable,body.dimmed.dimmable{overflow:hidden}body.dimmable>.dimmer{position:fixed}.blurring.dimmable>:not(.dimmer){-webkit-filter:blur(0) grayscale(0);filter:blur(0) grayscale(0);-webkit-transition:-webkit-filter .8s ease;transition:-webkit-filter .8s ease;transition:filter .8s ease;transition:filter .8s ease,-webkit-filter .8s ease}.blurring.dimmed.dimmable>:not(.dimmer){-webkit-filter:blur(5px) grayscale(.7);filter:blur(5px) grayscale(.7)}.blurring.dimmable>.dimmer{background-color:rgba(0,0,0,.6)}.blurring.dimmable>.inverted.dimmer{background-color:hsla(0,0%,100%,.6)}.ui.dimmer>.top.aligned.content>*{vertical-align:top}.ui.dimmer>.bottom.aligned.content>*{vertical-align:bottom}.ui.inverted.dimmer{background-color:hsla(0,0%,100%,.85)}.ui.inverted.dimmer>.content>*{color:#fff}.ui.simple.dimmer{display:block;overflow:hidden;opacity:1;width:0;height:0%;z-index:-100;background-color:transparent}.dimmed.dimmable>.ui.simple.dimmer{overflow:visible;opacity:1;width:100%;height:100%;background-color:rgba(0,0,0,.85);z-index:1}.ui.simple.inverted.dimmer{background-color:hsla(0,0%,100%,0)}.dimmed.dimmable>.ui.simple.inverted.dimmer{background-color:hsla(0,0%,100%,.85)}", ""]);
	
	// exports


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Divider\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.divider{margin:1rem 0;line-height:1;height:0;font-weight:700;text-transform:uppercase;letter-spacing:.05em;color:rgba(0,0,0,.85);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0)}.ui.divider:not(.vertical):not(.horizontal){border-top:1px solid rgba(34,36,38,.15);border-bottom:1px solid hsla(0,0%,100%,.1)}.ui.grid>.column+.divider,.ui.grid>.row>.column+.divider{left:auto}.ui.horizontal.divider{display:table;white-space:nowrap;height:auto;margin:'';line-height:1;text-align:center}.ui.horizontal.divider:after,.ui.horizontal.divider:before{content:'';display:table-cell;position:relative;top:50%;width:50%;background-repeat:no-repeat}.ui.horizontal.divider:before{background-position:right 1em top 50%}.ui.horizontal.divider:after{background-position:left 1em top 50%}.ui.vertical.divider{position:absolute;z-index:2;top:50%;left:50%;margin:0;padding:0;width:auto;height:50%;line-height:0;text-align:center;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.ui.vertical.divider:after,.ui.vertical.divider:before{position:absolute;left:50%;content:'';z-index:3;border-left:1px solid rgba(34,36,38,.15);border-right:1px solid hsla(0,0%,100%,.1);width:0;height:calc(100% - 1rem)}.ui.vertical.divider:before{top:-100%}.ui.vertical.divider:after{top:auto;bottom:0}@media only screen and (max-width:767px){.ui.grid .stackable.row .ui.vertical.divider,.ui.stackable.grid .ui.vertical.divider{display:table;white-space:nowrap;height:auto;margin:'';overflow:hidden;line-height:1;text-align:center;position:static;top:0;left:0;-webkit-transform:none;transform:none}.ui.grid .stackable.row .ui.vertical.divider:after,.ui.grid .stackable.row .ui.vertical.divider:before,.ui.stackable.grid .ui.vertical.divider:after,.ui.stackable.grid .ui.vertical.divider:before{position:static;left:0;border-left:none;border-right:none;content:'';display:table-cell;position:relative;top:50%;width:50%;background-repeat:no-repeat}.ui.grid .stackable.row .ui.vertical.divider:before,.ui.stackable.grid .ui.vertical.divider:before{background-position:right 1em top 50%}.ui.grid .stackable.row .ui.vertical.divider:after,.ui.stackable.grid .ui.vertical.divider:after{background-position:left 1em top 50%}}.ui.divider>.icon{margin:0;font-size:1rem;height:1em;vertical-align:middle}.ui.hidden.divider{border-color:transparent!important}.ui.hidden.divider:after,.ui.hidden.divider:before{display:none}.ui.divider.inverted,.ui.horizontal.inverted.divider,.ui.vertical.inverted.divider{color:#fff}.ui.divider.inverted,.ui.divider.inverted:after,.ui.divider.inverted:before{border-top-color:rgba(34,36,38,.15)!important;border-left-color:rgba(34,36,38,.15)!important;border-bottom-color:hsla(0,0%,100%,.15)!important;border-right-color:hsla(0,0%,100%,.15)!important}.ui.fitted.divider{margin:0}.ui.clearing.divider{clear:both}.ui.section.divider{margin-top:2rem;margin-bottom:2rem}.ui.divider{font-size:1rem}.ui.horizontal.divider:after,.ui.horizontal.divider:before{background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC')}@media only screen and (max-width:767px){.ui.grid .stackable.row .ui.vertical.divider:after,.ui.grid .stackable.row .ui.vertical.divider:before,.ui.stackable.grid .ui.vertical.divider:after,.ui.stackable.grid .ui.vertical.divider:before{background-image:url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAABaAAAAACCAYAAACuTHuKAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyFpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNS1jMDE0IDc5LjE1MTQ4MSwgMjAxMy8wMy8xMy0xMjowOToxNSAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIChXaW5kb3dzKSIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDo1OThBRDY4OUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyIgeG1wTU06RG9jdW1lbnRJRD0ieG1wLmRpZDo1OThBRDY4QUNDMTYxMUU0OUE3NUVGOEJDMzMzMjE2NyI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOjU5OEFENjg3Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOjU5OEFENjg4Q0MxNjExRTQ5QTc1RUY4QkMzMzMyMTY3Ii8+IDwvcmRmOkRlc2NyaXB0aW9uPiA8L3JkZjpSREY+IDwveDp4bXBtZXRhPiA8P3hwYWNrZXQgZW5kPSJyIj8+VU513gAAADVJREFUeNrs0DENACAQBDBIWLGBJQby/mUcJn5sJXQmOQMAAAAAAJqt+2prAAAAAACg2xdgANk6BEVuJgyMAAAAAElFTkSuQmCC')}}.ui.divider.header,h1.ui.divider,h2.ui.divider,h3.ui.divider,h4.ui.divider,h5.ui.divider{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;font-weight:700}", ""]);
	
	// exports


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Grid\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.grid{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;padding:0;margin:-1rem}.ui.relaxed.grid{margin-left:-1.5rem;margin-right:-1.5rem}.ui[class*=\"very relaxed\"].grid{margin-left:-2.5rem;margin-right:-2.5rem}.ui.grid+.grid{margin-top:1rem}.ui.grid>.column:not(.row),.ui.grid>.row>.column{position:relative;display:inline-block;width:6.25%;padding-left:1rem;padding-right:1rem;vertical-align:top}.ui.grid>*{padding-left:1rem;padding-right:1rem}.ui.grid>.row{position:relative;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;-ms-flex-wrap:wrap;flex-wrap:wrap;-webkit-box-pack:inherit;-ms-flex-pack:inherit;justify-content:inherit;-webkit-box-align:stretch;-ms-flex-align:stretch;align-items:stretch;width:100%!important;padding:0;padding-top:1rem;padding-bottom:1rem}.ui.grid>.column:not(.row){padding-top:1rem;padding-bottom:1rem}.ui.grid>.row>.column{margin-top:0;margin-bottom:0}.ui.grid>.row>.column>img,.ui.grid>.row>img{max-width:100%}.ui.grid>.ui.grid:first-child{margin-top:0}.ui.grid>.ui.grid:last-child{margin-bottom:0}.ui.aligned.grid .column>.segment:not(.compact):not(.attached),.ui.grid .aligned.row>.column>.segment:not(.compact):not(.attached){width:100%}.ui.grid .row+.ui.divider{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;margin:1rem}.ui.grid .column+.ui.vertical.divider{height:calc(50% - 1rem)}.ui.grid>.column:last-child>.horizontal.segment,.ui.grid>.row>.column:last-child>.horizontal.segment{box-shadow:none}@media only screen and (max-width:767px){.ui.page.grid{width:auto;padding-left:0;padding-right:0;margin-left:0;margin-right:0}}@media only screen and (min-width:768px) and (max-width:991px){.ui.page.grid{width:auto;margin-left:0;margin-right:0;padding-left:2em;padding-right:2em}}@media only screen and (min-width:992px) and (max-width:1199px){.ui.page.grid{width:auto;margin-left:0;margin-right:0;padding-left:3%;padding-right:3%}}@media only screen and (min-width:1200px) and (max-width:1919px){.ui.page.grid{width:auto;margin-left:0;margin-right:0;padding-left:15%;padding-right:15%}}@media only screen and (min-width:1920px){.ui.page.grid{width:auto;margin-left:0;margin-right:0;padding-left:23%;padding-right:23%}}.ui.grid>.column:only-child,.ui.grid>.row>.column:only-child,.ui[class*=\"one column\"].grid>.column:not(.row),.ui[class*=\"one column\"].grid>.row>.column{width:100%}.ui[class*=\"two column\"].grid>.column:not(.row),.ui[class*=\"two column\"].grid>.row>.column{width:50%}.ui[class*=\"three column\"].grid>.column:not(.row),.ui[class*=\"three column\"].grid>.row>.column{width:33.33333333%}.ui[class*=\"four column\"].grid>.column:not(.row),.ui[class*=\"four column\"].grid>.row>.column{width:25%}.ui[class*=\"five column\"].grid>.column:not(.row),.ui[class*=\"five column\"].grid>.row>.column{width:20%}.ui[class*=\"six column\"].grid>.column:not(.row),.ui[class*=\"six column\"].grid>.row>.column{width:16.66666667%}.ui[class*=\"seven column\"].grid>.column:not(.row),.ui[class*=\"seven column\"].grid>.row>.column{width:14.28571429%}.ui[class*=\"eight column\"].grid>.column:not(.row),.ui[class*=\"eight column\"].grid>.row>.column{width:12.5%}.ui[class*=\"nine column\"].grid>.column:not(.row),.ui[class*=\"nine column\"].grid>.row>.column{width:11.11111111%}.ui[class*=\"ten column\"].grid>.column:not(.row),.ui[class*=\"ten column\"].grid>.row>.column{width:10%}.ui[class*=\"eleven column\"].grid>.column:not(.row),.ui[class*=\"eleven column\"].grid>.row>.column{width:9.09090909%}.ui[class*=\"twelve column\"].grid>.column:not(.row),.ui[class*=\"twelve column\"].grid>.row>.column{width:8.33333333%}.ui[class*=\"thirteen column\"].grid>.column:not(.row),.ui[class*=\"thirteen column\"].grid>.row>.column{width:7.69230769%}.ui[class*=\"fourteen column\"].grid>.column:not(.row),.ui[class*=\"fourteen column\"].grid>.row>.column{width:7.14285714%}.ui[class*=\"fifteen column\"].grid>.column:not(.row),.ui[class*=\"fifteen column\"].grid>.row>.column{width:6.66666667%}.ui[class*=\"sixteen column\"].grid>.column:not(.row),.ui[class*=\"sixteen column\"].grid>.row>.column{width:6.25%}.ui.grid>[class*=\"one column\"].row>.column{width:100%!important}.ui.grid>[class*=\"two column\"].row>.column{width:50%!important}.ui.grid>[class*=\"three column\"].row>.column{width:33.33333333%!important}.ui.grid>[class*=\"four column\"].row>.column{width:25%!important}.ui.grid>[class*=\"five column\"].row>.column{width:20%!important}.ui.grid>[class*=\"six column\"].row>.column{width:16.66666667%!important}.ui.grid>[class*=\"seven column\"].row>.column{width:14.28571429%!important}.ui.grid>[class*=\"eight column\"].row>.column{width:12.5%!important}.ui.grid>[class*=\"nine column\"].row>.column{width:11.11111111%!important}.ui.grid>[class*=\"ten column\"].row>.column{width:10%!important}.ui.grid>[class*=\"eleven column\"].row>.column{width:9.09090909%!important}.ui.grid>[class*=\"twelve column\"].row>.column{width:8.33333333%!important}.ui.grid>[class*=\"thirteen column\"].row>.column{width:7.69230769%!important}.ui.grid>[class*=\"fourteen column\"].row>.column{width:7.14285714%!important}.ui.grid>[class*=\"fifteen column\"].row>.column{width:6.66666667%!important}.ui.grid>[class*=\"sixteen column\"].row>.column{width:6.25%!important}.ui.celled.page.grid{box-shadow:none}.ui.column.grid>[class*=\"one wide\"].column,.ui.grid>.column.row>[class*=\"one wide\"].column,.ui.grid>.row>[class*=\"one wide\"].column,.ui.grid>[class*=\"one wide\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide\"].column,.ui.grid>.column.row>[class*=\"two wide\"].column,.ui.grid>.row>[class*=\"two wide\"].column,.ui.grid>[class*=\"two wide\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide\"].column,.ui.grid>.column.row>[class*=\"three wide\"].column,.ui.grid>.row>[class*=\"three wide\"].column,.ui.grid>[class*=\"three wide\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide\"].column,.ui.grid>.column.row>[class*=\"four wide\"].column,.ui.grid>.row>[class*=\"four wide\"].column,.ui.grid>[class*=\"four wide\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide\"].column,.ui.grid>.column.row>[class*=\"five wide\"].column,.ui.grid>.row>[class*=\"five wide\"].column,.ui.grid>[class*=\"five wide\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide\"].column,.ui.grid>.column.row>[class*=\"six wide\"].column,.ui.grid>.row>[class*=\"six wide\"].column,.ui.grid>[class*=\"six wide\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide\"].column,.ui.grid>.column.row>[class*=\"seven wide\"].column,.ui.grid>.row>[class*=\"seven wide\"].column,.ui.grid>[class*=\"seven wide\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide\"].column,.ui.grid>.column.row>[class*=\"eight wide\"].column,.ui.grid>.row>[class*=\"eight wide\"].column,.ui.grid>[class*=\"eight wide\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide\"].column,.ui.grid>.column.row>[class*=\"nine wide\"].column,.ui.grid>.row>[class*=\"nine wide\"].column,.ui.grid>[class*=\"nine wide\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide\"].column,.ui.grid>.column.row>[class*=\"ten wide\"].column,.ui.grid>.row>[class*=\"ten wide\"].column,.ui.grid>[class*=\"ten wide\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide\"].column,.ui.grid>.column.row>[class*=\"eleven wide\"].column,.ui.grid>.row>[class*=\"eleven wide\"].column,.ui.grid>[class*=\"eleven wide\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide\"].column,.ui.grid>.column.row>[class*=\"twelve wide\"].column,.ui.grid>.row>[class*=\"twelve wide\"].column,.ui.grid>[class*=\"twelve wide\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide\"].column,.ui.grid>.column.row>[class*=\"thirteen wide\"].column,.ui.grid>.row>[class*=\"thirteen wide\"].column,.ui.grid>[class*=\"thirteen wide\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide\"].column,.ui.grid>.column.row>[class*=\"fourteen wide\"].column,.ui.grid>.row>[class*=\"fourteen wide\"].column,.ui.grid>[class*=\"fourteen wide\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide\"].column,.ui.grid>.column.row>[class*=\"fifteen wide\"].column,.ui.grid>.row>[class*=\"fifteen wide\"].column,.ui.grid>[class*=\"fifteen wide\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide\"].column,.ui.grid>.column.row>[class*=\"sixteen wide\"].column,.ui.grid>.row>[class*=\"sixteen wide\"].column,.ui.grid>[class*=\"sixteen wide\"].column{width:100%!important}@media only screen and (min-width:320px) and (max-width:767px){.ui.column.grid>[class*=\"one wide mobile\"].column,.ui.grid>.column.row>[class*=\"one wide mobile\"].column,.ui.grid>.row>[class*=\"one wide mobile\"].column,.ui.grid>[class*=\"one wide mobile\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide mobile\"].column,.ui.grid>.column.row>[class*=\"two wide mobile\"].column,.ui.grid>.row>[class*=\"two wide mobile\"].column,.ui.grid>[class*=\"two wide mobile\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide mobile\"].column,.ui.grid>.column.row>[class*=\"three wide mobile\"].column,.ui.grid>.row>[class*=\"three wide mobile\"].column,.ui.grid>[class*=\"three wide mobile\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide mobile\"].column,.ui.grid>.column.row>[class*=\"four wide mobile\"].column,.ui.grid>.row>[class*=\"four wide mobile\"].column,.ui.grid>[class*=\"four wide mobile\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide mobile\"].column,.ui.grid>.column.row>[class*=\"five wide mobile\"].column,.ui.grid>.row>[class*=\"five wide mobile\"].column,.ui.grid>[class*=\"five wide mobile\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide mobile\"].column,.ui.grid>.column.row>[class*=\"six wide mobile\"].column,.ui.grid>.row>[class*=\"six wide mobile\"].column,.ui.grid>[class*=\"six wide mobile\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide mobile\"].column,.ui.grid>.column.row>[class*=\"seven wide mobile\"].column,.ui.grid>.row>[class*=\"seven wide mobile\"].column,.ui.grid>[class*=\"seven wide mobile\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide mobile\"].column,.ui.grid>.column.row>[class*=\"eight wide mobile\"].column,.ui.grid>.row>[class*=\"eight wide mobile\"].column,.ui.grid>[class*=\"eight wide mobile\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide mobile\"].column,.ui.grid>.column.row>[class*=\"nine wide mobile\"].column,.ui.grid>.row>[class*=\"nine wide mobile\"].column,.ui.grid>[class*=\"nine wide mobile\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide mobile\"].column,.ui.grid>.column.row>[class*=\"ten wide mobile\"].column,.ui.grid>.row>[class*=\"ten wide mobile\"].column,.ui.grid>[class*=\"ten wide mobile\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide mobile\"].column,.ui.grid>.column.row>[class*=\"eleven wide mobile\"].column,.ui.grid>.row>[class*=\"eleven wide mobile\"].column,.ui.grid>[class*=\"eleven wide mobile\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide mobile\"].column,.ui.grid>.column.row>[class*=\"twelve wide mobile\"].column,.ui.grid>.row>[class*=\"twelve wide mobile\"].column,.ui.grid>[class*=\"twelve wide mobile\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide mobile\"].column,.ui.grid>.column.row>[class*=\"thirteen wide mobile\"].column,.ui.grid>.row>[class*=\"thirteen wide mobile\"].column,.ui.grid>[class*=\"thirteen wide mobile\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide mobile\"].column,.ui.grid>.column.row>[class*=\"fourteen wide mobile\"].column,.ui.grid>.row>[class*=\"fourteen wide mobile\"].column,.ui.grid>[class*=\"fourteen wide mobile\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide mobile\"].column,.ui.grid>.column.row>[class*=\"fifteen wide mobile\"].column,.ui.grid>.row>[class*=\"fifteen wide mobile\"].column,.ui.grid>[class*=\"fifteen wide mobile\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide mobile\"].column,.ui.grid>.column.row>[class*=\"sixteen wide mobile\"].column,.ui.grid>.row>[class*=\"sixteen wide mobile\"].column,.ui.grid>[class*=\"sixteen wide mobile\"].column{width:100%!important}}@media only screen and (min-width:768px) and (max-width:991px){.ui.column.grid>[class*=\"one wide tablet\"].column,.ui.grid>.column.row>[class*=\"one wide tablet\"].column,.ui.grid>.row>[class*=\"one wide tablet\"].column,.ui.grid>[class*=\"one wide tablet\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide tablet\"].column,.ui.grid>.column.row>[class*=\"two wide tablet\"].column,.ui.grid>.row>[class*=\"two wide tablet\"].column,.ui.grid>[class*=\"two wide tablet\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide tablet\"].column,.ui.grid>.column.row>[class*=\"three wide tablet\"].column,.ui.grid>.row>[class*=\"three wide tablet\"].column,.ui.grid>[class*=\"three wide tablet\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide tablet\"].column,.ui.grid>.column.row>[class*=\"four wide tablet\"].column,.ui.grid>.row>[class*=\"four wide tablet\"].column,.ui.grid>[class*=\"four wide tablet\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide tablet\"].column,.ui.grid>.column.row>[class*=\"five wide tablet\"].column,.ui.grid>.row>[class*=\"five wide tablet\"].column,.ui.grid>[class*=\"five wide tablet\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide tablet\"].column,.ui.grid>.column.row>[class*=\"six wide tablet\"].column,.ui.grid>.row>[class*=\"six wide tablet\"].column,.ui.grid>[class*=\"six wide tablet\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide tablet\"].column,.ui.grid>.column.row>[class*=\"seven wide tablet\"].column,.ui.grid>.row>[class*=\"seven wide tablet\"].column,.ui.grid>[class*=\"seven wide tablet\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide tablet\"].column,.ui.grid>.column.row>[class*=\"eight wide tablet\"].column,.ui.grid>.row>[class*=\"eight wide tablet\"].column,.ui.grid>[class*=\"eight wide tablet\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide tablet\"].column,.ui.grid>.column.row>[class*=\"nine wide tablet\"].column,.ui.grid>.row>[class*=\"nine wide tablet\"].column,.ui.grid>[class*=\"nine wide tablet\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide tablet\"].column,.ui.grid>.column.row>[class*=\"ten wide tablet\"].column,.ui.grid>.row>[class*=\"ten wide tablet\"].column,.ui.grid>[class*=\"ten wide tablet\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide tablet\"].column,.ui.grid>.column.row>[class*=\"eleven wide tablet\"].column,.ui.grid>.row>[class*=\"eleven wide tablet\"].column,.ui.grid>[class*=\"eleven wide tablet\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide tablet\"].column,.ui.grid>.column.row>[class*=\"twelve wide tablet\"].column,.ui.grid>.row>[class*=\"twelve wide tablet\"].column,.ui.grid>[class*=\"twelve wide tablet\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide tablet\"].column,.ui.grid>.column.row>[class*=\"thirteen wide tablet\"].column,.ui.grid>.row>[class*=\"thirteen wide tablet\"].column,.ui.grid>[class*=\"thirteen wide tablet\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide tablet\"].column,.ui.grid>.column.row>[class*=\"fourteen wide tablet\"].column,.ui.grid>.row>[class*=\"fourteen wide tablet\"].column,.ui.grid>[class*=\"fourteen wide tablet\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide tablet\"].column,.ui.grid>.column.row>[class*=\"fifteen wide tablet\"].column,.ui.grid>.row>[class*=\"fifteen wide tablet\"].column,.ui.grid>[class*=\"fifteen wide tablet\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide tablet\"].column,.ui.grid>.column.row>[class*=\"sixteen wide tablet\"].column,.ui.grid>.row>[class*=\"sixteen wide tablet\"].column,.ui.grid>[class*=\"sixteen wide tablet\"].column{width:100%!important}}@media only screen and (min-width:992px){.ui.column.grid>[class*=\"one wide computer\"].column,.ui.grid>.column.row>[class*=\"one wide computer\"].column,.ui.grid>.row>[class*=\"one wide computer\"].column,.ui.grid>[class*=\"one wide computer\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide computer\"].column,.ui.grid>.column.row>[class*=\"two wide computer\"].column,.ui.grid>.row>[class*=\"two wide computer\"].column,.ui.grid>[class*=\"two wide computer\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide computer\"].column,.ui.grid>.column.row>[class*=\"three wide computer\"].column,.ui.grid>.row>[class*=\"three wide computer\"].column,.ui.grid>[class*=\"three wide computer\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide computer\"].column,.ui.grid>.column.row>[class*=\"four wide computer\"].column,.ui.grid>.row>[class*=\"four wide computer\"].column,.ui.grid>[class*=\"four wide computer\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide computer\"].column,.ui.grid>.column.row>[class*=\"five wide computer\"].column,.ui.grid>.row>[class*=\"five wide computer\"].column,.ui.grid>[class*=\"five wide computer\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide computer\"].column,.ui.grid>.column.row>[class*=\"six wide computer\"].column,.ui.grid>.row>[class*=\"six wide computer\"].column,.ui.grid>[class*=\"six wide computer\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide computer\"].column,.ui.grid>.column.row>[class*=\"seven wide computer\"].column,.ui.grid>.row>[class*=\"seven wide computer\"].column,.ui.grid>[class*=\"seven wide computer\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide computer\"].column,.ui.grid>.column.row>[class*=\"eight wide computer\"].column,.ui.grid>.row>[class*=\"eight wide computer\"].column,.ui.grid>[class*=\"eight wide computer\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide computer\"].column,.ui.grid>.column.row>[class*=\"nine wide computer\"].column,.ui.grid>.row>[class*=\"nine wide computer\"].column,.ui.grid>[class*=\"nine wide computer\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide computer\"].column,.ui.grid>.column.row>[class*=\"ten wide computer\"].column,.ui.grid>.row>[class*=\"ten wide computer\"].column,.ui.grid>[class*=\"ten wide computer\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide computer\"].column,.ui.grid>.column.row>[class*=\"eleven wide computer\"].column,.ui.grid>.row>[class*=\"eleven wide computer\"].column,.ui.grid>[class*=\"eleven wide computer\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide computer\"].column,.ui.grid>.column.row>[class*=\"twelve wide computer\"].column,.ui.grid>.row>[class*=\"twelve wide computer\"].column,.ui.grid>[class*=\"twelve wide computer\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide computer\"].column,.ui.grid>.column.row>[class*=\"thirteen wide computer\"].column,.ui.grid>.row>[class*=\"thirteen wide computer\"].column,.ui.grid>[class*=\"thirteen wide computer\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide computer\"].column,.ui.grid>.column.row>[class*=\"fourteen wide computer\"].column,.ui.grid>.row>[class*=\"fourteen wide computer\"].column,.ui.grid>[class*=\"fourteen wide computer\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide computer\"].column,.ui.grid>.column.row>[class*=\"fifteen wide computer\"].column,.ui.grid>.row>[class*=\"fifteen wide computer\"].column,.ui.grid>[class*=\"fifteen wide computer\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide computer\"].column,.ui.grid>.column.row>[class*=\"sixteen wide computer\"].column,.ui.grid>.row>[class*=\"sixteen wide computer\"].column,.ui.grid>[class*=\"sixteen wide computer\"].column{width:100%!important}}@media only screen and (min-width:1200px) and (max-width:1919px){.ui.column.grid>[class*=\"one wide large screen\"].column,.ui.grid>.column.row>[class*=\"one wide large screen\"].column,.ui.grid>.row>[class*=\"one wide large screen\"].column,.ui.grid>[class*=\"one wide large screen\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide large screen\"].column,.ui.grid>.column.row>[class*=\"two wide large screen\"].column,.ui.grid>.row>[class*=\"two wide large screen\"].column,.ui.grid>[class*=\"two wide large screen\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide large screen\"].column,.ui.grid>.column.row>[class*=\"three wide large screen\"].column,.ui.grid>.row>[class*=\"three wide large screen\"].column,.ui.grid>[class*=\"three wide large screen\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide large screen\"].column,.ui.grid>.column.row>[class*=\"four wide large screen\"].column,.ui.grid>.row>[class*=\"four wide large screen\"].column,.ui.grid>[class*=\"four wide large screen\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide large screen\"].column,.ui.grid>.column.row>[class*=\"five wide large screen\"].column,.ui.grid>.row>[class*=\"five wide large screen\"].column,.ui.grid>[class*=\"five wide large screen\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide large screen\"].column,.ui.grid>.column.row>[class*=\"six wide large screen\"].column,.ui.grid>.row>[class*=\"six wide large screen\"].column,.ui.grid>[class*=\"six wide large screen\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide large screen\"].column,.ui.grid>.column.row>[class*=\"seven wide large screen\"].column,.ui.grid>.row>[class*=\"seven wide large screen\"].column,.ui.grid>[class*=\"seven wide large screen\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide large screen\"].column,.ui.grid>.column.row>[class*=\"eight wide large screen\"].column,.ui.grid>.row>[class*=\"eight wide large screen\"].column,.ui.grid>[class*=\"eight wide large screen\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide large screen\"].column,.ui.grid>.column.row>[class*=\"nine wide large screen\"].column,.ui.grid>.row>[class*=\"nine wide large screen\"].column,.ui.grid>[class*=\"nine wide large screen\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide large screen\"].column,.ui.grid>.column.row>[class*=\"ten wide large screen\"].column,.ui.grid>.row>[class*=\"ten wide large screen\"].column,.ui.grid>[class*=\"ten wide large screen\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide large screen\"].column,.ui.grid>.column.row>[class*=\"eleven wide large screen\"].column,.ui.grid>.row>[class*=\"eleven wide large screen\"].column,.ui.grid>[class*=\"eleven wide large screen\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide large screen\"].column,.ui.grid>.column.row>[class*=\"twelve wide large screen\"].column,.ui.grid>.row>[class*=\"twelve wide large screen\"].column,.ui.grid>[class*=\"twelve wide large screen\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide large screen\"].column,.ui.grid>.column.row>[class*=\"thirteen wide large screen\"].column,.ui.grid>.row>[class*=\"thirteen wide large screen\"].column,.ui.grid>[class*=\"thirteen wide large screen\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide large screen\"].column,.ui.grid>.column.row>[class*=\"fourteen wide large screen\"].column,.ui.grid>.row>[class*=\"fourteen wide large screen\"].column,.ui.grid>[class*=\"fourteen wide large screen\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide large screen\"].column,.ui.grid>.column.row>[class*=\"fifteen wide large screen\"].column,.ui.grid>.row>[class*=\"fifteen wide large screen\"].column,.ui.grid>[class*=\"fifteen wide large screen\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide large screen\"].column,.ui.grid>.column.row>[class*=\"sixteen wide large screen\"].column,.ui.grid>.row>[class*=\"sixteen wide large screen\"].column,.ui.grid>[class*=\"sixteen wide large screen\"].column{width:100%!important}}@media only screen and (min-width:1920px){.ui.column.grid>[class*=\"one wide widescreen\"].column,.ui.grid>.column.row>[class*=\"one wide widescreen\"].column,.ui.grid>.row>[class*=\"one wide widescreen\"].column,.ui.grid>[class*=\"one wide widescreen\"].column{width:6.25%!important}.ui.column.grid>[class*=\"two wide widescreen\"].column,.ui.grid>.column.row>[class*=\"two wide widescreen\"].column,.ui.grid>.row>[class*=\"two wide widescreen\"].column,.ui.grid>[class*=\"two wide widescreen\"].column{width:12.5%!important}.ui.column.grid>[class*=\"three wide widescreen\"].column,.ui.grid>.column.row>[class*=\"three wide widescreen\"].column,.ui.grid>.row>[class*=\"three wide widescreen\"].column,.ui.grid>[class*=\"three wide widescreen\"].column{width:18.75%!important}.ui.column.grid>[class*=\"four wide widescreen\"].column,.ui.grid>.column.row>[class*=\"four wide widescreen\"].column,.ui.grid>.row>[class*=\"four wide widescreen\"].column,.ui.grid>[class*=\"four wide widescreen\"].column{width:25%!important}.ui.column.grid>[class*=\"five wide widescreen\"].column,.ui.grid>.column.row>[class*=\"five wide widescreen\"].column,.ui.grid>.row>[class*=\"five wide widescreen\"].column,.ui.grid>[class*=\"five wide widescreen\"].column{width:31.25%!important}.ui.column.grid>[class*=\"six wide widescreen\"].column,.ui.grid>.column.row>[class*=\"six wide widescreen\"].column,.ui.grid>.row>[class*=\"six wide widescreen\"].column,.ui.grid>[class*=\"six wide widescreen\"].column{width:37.5%!important}.ui.column.grid>[class*=\"seven wide widescreen\"].column,.ui.grid>.column.row>[class*=\"seven wide widescreen\"].column,.ui.grid>.row>[class*=\"seven wide widescreen\"].column,.ui.grid>[class*=\"seven wide widescreen\"].column{width:43.75%!important}.ui.column.grid>[class*=\"eight wide widescreen\"].column,.ui.grid>.column.row>[class*=\"eight wide widescreen\"].column,.ui.grid>.row>[class*=\"eight wide widescreen\"].column,.ui.grid>[class*=\"eight wide widescreen\"].column{width:50%!important}.ui.column.grid>[class*=\"nine wide widescreen\"].column,.ui.grid>.column.row>[class*=\"nine wide widescreen\"].column,.ui.grid>.row>[class*=\"nine wide widescreen\"].column,.ui.grid>[class*=\"nine wide widescreen\"].column{width:56.25%!important}.ui.column.grid>[class*=\"ten wide widescreen\"].column,.ui.grid>.column.row>[class*=\"ten wide widescreen\"].column,.ui.grid>.row>[class*=\"ten wide widescreen\"].column,.ui.grid>[class*=\"ten wide widescreen\"].column{width:62.5%!important}.ui.column.grid>[class*=\"eleven wide widescreen\"].column,.ui.grid>.column.row>[class*=\"eleven wide widescreen\"].column,.ui.grid>.row>[class*=\"eleven wide widescreen\"].column,.ui.grid>[class*=\"eleven wide widescreen\"].column{width:68.75%!important}.ui.column.grid>[class*=\"twelve wide widescreen\"].column,.ui.grid>.column.row>[class*=\"twelve wide widescreen\"].column,.ui.grid>.row>[class*=\"twelve wide widescreen\"].column,.ui.grid>[class*=\"twelve wide widescreen\"].column{width:75%!important}.ui.column.grid>[class*=\"thirteen wide widescreen\"].column,.ui.grid>.column.row>[class*=\"thirteen wide widescreen\"].column,.ui.grid>.row>[class*=\"thirteen wide widescreen\"].column,.ui.grid>[class*=\"thirteen wide widescreen\"].column{width:81.25%!important}.ui.column.grid>[class*=\"fourteen wide widescreen\"].column,.ui.grid>.column.row>[class*=\"fourteen wide widescreen\"].column,.ui.grid>.row>[class*=\"fourteen wide widescreen\"].column,.ui.grid>[class*=\"fourteen wide widescreen\"].column{width:87.5%!important}.ui.column.grid>[class*=\"fifteen wide widescreen\"].column,.ui.grid>.column.row>[class*=\"fifteen wide widescreen\"].column,.ui.grid>.row>[class*=\"fifteen wide widescreen\"].column,.ui.grid>[class*=\"fifteen wide widescreen\"].column{width:93.75%!important}.ui.column.grid>[class*=\"sixteen wide widescreen\"].column,.ui.grid>.column.row>[class*=\"sixteen wide widescreen\"].column,.ui.grid>.row>[class*=\"sixteen wide widescreen\"].column,.ui.grid>[class*=\"sixteen wide widescreen\"].column{width:100%!important}}.ui.centered.grid,.ui.centered.grid>.row,.ui.grid>.centered.row{text-align:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ui.centered.grid>.column:not(.aligned):not(.justified):not(.row),.ui.centered.grid>.row>.column:not(.aligned):not(.justified),.ui.grid .centered.row>.column:not(.aligned):not(.justified){text-align:left}.ui.grid>.centered.column,.ui.grid>.row>.centered.column{display:block;margin-left:auto;margin-right:auto}.ui.grid>.relaxed.row>.column,.ui.relaxed.grid>.column:not(.row),.ui.relaxed.grid>.row>.column{padding-left:1.5rem;padding-right:1.5rem}.ui.grid>[class*=\"very relaxed\"].row>.column,.ui[class*=\"very relaxed\"].grid>.column:not(.row),.ui[class*=\"very relaxed\"].grid>.row>.column{padding-left:2.5rem;padding-right:2.5rem}.ui.grid .relaxed.row+.ui.divider,.ui.relaxed.grid .row+.ui.divider{margin-left:1.5rem;margin-right:1.5rem}.ui.grid [class*=\"very relaxed\"].row+.ui.divider,.ui[class*=\"very relaxed\"].grid .row+.ui.divider{margin-left:2.5rem;margin-right:2.5rem}.ui.padded.grid:not(.vertically):not(.horizontally){margin:0!important}[class*=\"horizontally padded\"].ui.grid{margin-left:0!important;margin-right:0!important}[class*=\"vertically padded\"].ui.grid{margin-top:0!important;margin-bottom:0!important}.ui.grid [class*=\"left floated\"].column{margin-right:auto}.ui.grid [class*=\"right floated\"].column{margin-left:auto}.ui.divided.grid:not([class*=\"vertically divided\"])>.column:not(.row),.ui.divided.grid:not([class*=\"vertically divided\"])>.row>.column{box-shadow:-1px 0 0 0 rgba(34,36,38,.15)}.ui[class*=\"vertically divided\"].grid>.column:not(.row),.ui[class*=\"vertically divided\"].grid>.row>.column{margin-top:1rem;margin-bottom:1rem;padding-top:0;padding-bottom:0}.ui[class*=\"vertically divided\"].grid>.row{margin-top:0;margin-bottom:0}.ui.divided.grid:not([class*=\"vertically divided\"])>.column:first-child,.ui.divided.grid:not([class*=\"vertically divided\"])>.row>.column:first-child{box-shadow:none}.ui[class*=\"vertically divided\"].grid>.row:first-child>.column{margin-top:0}.ui.grid>.divided.row>.column{box-shadow:-1px 0 0 0 rgba(34,36,38,.15)}.ui.grid>.divided.row>.column:first-child{box-shadow:none}.ui[class*=\"vertically divided\"].grid>.row{position:relative}.ui[class*=\"vertically divided\"].grid>.row:before{position:absolute;content:\"\";top:0;left:0;width:calc(100% - 2rem);height:1px;margin:0 1rem;box-shadow:0 -1px 0 0 rgba(34,36,38,.15)}.ui.padded.divided.grid:not(.vertically):not(.horizontally),[class*=\"horizontally padded\"].ui.divided.grid{width:100%}.ui[class*=\"vertically divided\"].grid>.row:first-child:before{box-shadow:none}.ui.inverted.divided.grid:not([class*=\"vertically divided\"])>.column:not(.row),.ui.inverted.divided.grid:not([class*=\"vertically divided\"])>.row>.column{box-shadow:-1px 0 0 0 hsla(0,0%,100%,.1)}.ui.inverted.divided.grid:not([class*=\"vertically divided\"])>.column:not(.row):first-child,.ui.inverted.divided.grid:not([class*=\"vertically divided\"])>.row>.column:first-child{box-shadow:none}.ui.inverted[class*=\"vertically divided\"].grid>.row:before{box-shadow:0 -1px 0 0 hsla(0,0%,100%,.1)}.ui.relaxed[class*=\"vertically divided\"].grid>.row:before{margin-left:1.5rem;margin-right:1.5rem;width:calc(100% - 3rem)}.ui[class*=\"very relaxed\"][class*=\"vertically divided\"].grid>.row:before{margin-left:5rem;margin-right:5rem;width:calc(100% - 5rem)}.ui.celled.grid{width:100%;margin:1em 0;box-shadow:0 0 0 1px #d4d4d5}.ui.celled.grid>.row{width:100%!important;margin:0;padding:0;box-shadow:0 -1px 0 0 #d4d4d5}.ui.celled.grid>.column:not(.row),.ui.celled.grid>.row>.column{box-shadow:-1px 0 0 0 #d4d4d5}.ui.celled.grid>.column:first-child,.ui.celled.grid>.row>.column:first-child{box-shadow:none}.ui.celled.grid>.column:not(.row),.ui.celled.grid>.row>.column{padding:1em}.ui.relaxed.celled.grid>.column:not(.row),.ui.relaxed.celled.grid>.row>.column{padding:1.5em}.ui[class*=\"very relaxed\"].celled.grid>.column:not(.row),.ui[class*=\"very relaxed\"].celled.grid>.row>.column{padding:2em}.ui[class*=\"internally celled\"].grid{box-shadow:none;margin:0}.ui[class*=\"internally celled\"].grid>.row:first-child,.ui[class*=\"internally celled\"].grid>.row>.column:first-child{box-shadow:none}.ui.grid>.row>[class*=\"top aligned\"].column,.ui.grid>[class*=\"top aligned\"].column:not(.row),.ui.grid>[class*=\"top aligned\"].row>.column,.ui[class*=\"top aligned\"].grid>.column:not(.row),.ui[class*=\"top aligned\"].grid>.row>.column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;vertical-align:top;-ms-flex-item-align:start!important;align-self:flex-start!important}.ui.grid>.row>[class*=\"middle aligned\"].column,.ui.grid>[class*=\"middle aligned\"].column:not(.row),.ui.grid>[class*=\"middle aligned\"].row>.column,.ui[class*=\"middle aligned\"].grid>.column:not(.row),.ui[class*=\"middle aligned\"].grid>.row>.column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;vertical-align:middle;-ms-flex-item-align:center!important;align-self:center!important}.ui.grid>.row>[class*=\"bottom aligned\"].column,.ui.grid>[class*=\"bottom aligned\"].column:not(.row),.ui.grid>[class*=\"bottom aligned\"].row>.column,.ui[class*=\"bottom aligned\"].grid>.column:not(.row),.ui[class*=\"bottom aligned\"].grid>.row>.column{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;vertical-align:bottom;-ms-flex-item-align:end!important;align-self:flex-end!important}.ui.grid>.row>.stretched.column,.ui.grid>.stretched.column:not(.row),.ui.grid>.stretched.row>.column,.ui.stretched.grid>.column,.ui.stretched.grid>.row>.column{display:-webkit-inline-box!important;display:-ms-inline-flexbox!important;display:inline-flex!important;-ms-flex-item-align:stretch;align-self:stretch;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column}.ui.grid>.row>.stretched.column>*,.ui.grid>.stretched.column:not(.row)>*,.ui.grid>.stretched.row>.column>*,.ui.stretched.grid>.column>*,.ui.stretched.grid>.row>.column>*{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.ui.grid>.row>[class*=\"left aligned\"].column.column,.ui.grid>[class*=\"left aligned\"].column.column,.ui.grid>[class*=\"left aligned\"].row>.column,.ui[class*=\"left aligned\"].grid>.column,.ui[class*=\"left aligned\"].grid>.row>.column{text-align:left;-ms-flex-item-align:inherit;align-self:inherit}.ui.grid>.row>[class*=\"center aligned\"].column.column,.ui.grid>[class*=\"center aligned\"].column.column,.ui.grid>[class*=\"center aligned\"].row>.column,.ui[class*=\"center aligned\"].grid>.column,.ui[class*=\"center aligned\"].grid>.row>.column{text-align:center;-ms-flex-item-align:inherit;align-self:inherit}.ui[class*=\"center aligned\"].grid{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}.ui.grid>.row>[class*=\"right aligned\"].column.column,.ui.grid>[class*=\"right aligned\"].column.column,.ui.grid>[class*=\"right aligned\"].row>.column,.ui[class*=\"right aligned\"].grid>.column,.ui[class*=\"right aligned\"].grid>.row>.column{text-align:right;-ms-flex-item-align:inherit;align-self:inherit}.ui.grid>.justified.column.column,.ui.grid>.justified.row>.column,.ui.grid>.row>.justified.column.column,.ui.justified.grid>.column,.ui.justified.grid>.row>.column{text-align:justify;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}.ui.grid>.row>.black.column,.ui.grid>.row>.blue.column,.ui.grid>.row>.brown.column,.ui.grid>.row>.green.column,.ui.grid>.row>.grey.column,.ui.grid>.row>.olive.column,.ui.grid>.row>.orange.column,.ui.grid>.row>.pink.column,.ui.grid>.row>.purple.column,.ui.grid>.row>.red.column,.ui.grid>.row>.teal.column,.ui.grid>.row>.violet.column,.ui.grid>.row>.yellow.column{margin-top:-1rem;margin-bottom:-1rem;padding-top:1rem;padding-bottom:1rem}.ui.grid>.red.column,.ui.grid>.red.row,.ui.grid>.row>.red.column{background-color:#e23c4e!important;color:#fff}.ui.grid>.orange.column,.ui.grid>.orange.row,.ui.grid>.row>.orange.column{background-color:#f8813d!important;color:#fff}.ui.grid>.row>.yellow.column,.ui.grid>.yellow.column,.ui.grid>.yellow.row{background-color:#ffca18!important;color:#fff}.ui.grid>.olive.column,.ui.grid>.olive.row,.ui.grid>.row>.olive.column{background-color:#456558!important;color:#fff}.ui.grid>.green.column,.ui.grid>.green.row,.ui.grid>.row>.green.column{background-color:#54af71!important;color:#fff}.ui.grid>.row>.teal.column,.ui.grid>.teal.column,.ui.grid>.teal.row{background-color:#00a1ca!important;color:#fff}.ui.grid>.blue.column,.ui.grid>.blue.row,.ui.grid>.row>.blue.column{background-color:#1d5f82!important;color:#fff}.ui.grid>.row>.violet.column,.ui.grid>.violet.column,.ui.grid>.violet.row{background-color:#525394!important;color:#fff}.ui.grid>.purple.column,.ui.grid>.purple.row,.ui.grid>.row>.purple.column{background-color:#ad427f!important;color:#fff}.ui.grid>.pink.column,.ui.grid>.pink.row,.ui.grid>.row>.pink.column{background-color:#e03997!important;color:#fff}.ui.grid>.brown.column,.ui.grid>.brown.row,.ui.grid>.row>.brown.column{background-color:#a67a00!important;color:#fff}.ui.grid>.grey.column,.ui.grid>.grey.row,.ui.grid>.row>.grey.column{background-color:#5a686d!important;color:#fff}.ui.grid>.black.column,.ui.grid>.black.row,.ui.grid>.row>.black.column{background-color:#1b1c1d!important;color:#fff}.ui.grid>[class*=\"equal width\"].row>.column,.ui[class*=\"equal width\"].grid>.column:not(.row),.ui[class*=\"equal width\"].grid>.row>.column{display:inline-block;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}.ui.grid>[class*=\"equal width\"].row>.wide.column,.ui[class*=\"equal width\"].grid>.row>.wide.column,.ui[class*=\"equal width\"].grid>.wide.column{-webkit-box-flex:0;-ms-flex-positive:0;flex-grow:0}@media only screen and (max-width:767px){.ui.grid>[class*=\"mobile reversed\"].row,.ui[class*=\"mobile reversed\"].grid,.ui[class*=\"mobile reversed\"].grid>.row{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.ui.stackable[class*=\"mobile reversed\"],.ui[class*=\"mobile vertically reversed\"].grid{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:first-child,.ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:first-child{box-shadow:-1px 0 0 0 rgba(34,36,38,.15)}.ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:last-child,.ui[class*=\"mobile reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:last-child{box-shadow:none}.ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"]>.row:first-child:before{box-shadow:0 -1px 0 0 rgba(34,36,38,.15)}.ui.grid[class*=\"vertically divided\"][class*=\"mobile vertically reversed\"]>.row:last-child:before{box-shadow:none}.ui[class*=\"mobile reversed\"].celled.grid>.row>.column:first-child{box-shadow:-1px 0 0 0 #d4d4d5}.ui[class*=\"mobile reversed\"].celled.grid>.row>.column:last-child{box-shadow:none}}@media only screen and (min-width:768px) and (max-width:991px){.ui.grid>[class*=\"tablet reversed\"].row,.ui[class*=\"tablet reversed\"].grid,.ui[class*=\"tablet reversed\"].grid>.row{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.ui[class*=\"tablet vertically reversed\"].grid{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:first-child,.ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:first-child{box-shadow:-1px 0 0 0 rgba(34,36,38,.15)}.ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:last-child,.ui[class*=\"tablet reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:last-child{box-shadow:none}.ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"]>.row:first-child:before{box-shadow:0 -1px 0 0 rgba(34,36,38,.15)}.ui.grid[class*=\"vertically divided\"][class*=\"tablet vertically reversed\"]>.row:last-child:before{box-shadow:none}.ui[class*=\"tablet reversed\"].celled.grid>.row>.column:first-child{box-shadow:-1px 0 0 0 #d4d4d5}.ui[class*=\"tablet reversed\"].celled.grid>.row>.column:last-child{box-shadow:none}}@media only screen and (min-width:992px){.ui.grid>[class*=\"computer reversed\"].row,.ui[class*=\"computer reversed\"].grid,.ui[class*=\"computer reversed\"].grid>.row{-webkit-box-orient:horizontal;-webkit-box-direction:reverse;-ms-flex-direction:row-reverse;flex-direction:row-reverse}.ui[class*=\"computer vertically reversed\"].grid{-webkit-box-orient:vertical;-webkit-box-direction:reverse;-ms-flex-direction:column-reverse;flex-direction:column-reverse}.ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:first-child,.ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:first-child{box-shadow:-1px 0 0 0 rgba(34,36,38,.15)}.ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"])>.column:last-child,.ui[class*=\"computer reversed\"].divided.grid:not([class*=\"vertically divided\"])>.row>.column:last-child{box-shadow:none}.ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"]>.row:first-child:before{box-shadow:0 -1px 0 0 rgba(34,36,38,.15)}.ui.grid[class*=\"vertically divided\"][class*=\"computer vertically reversed\"]>.row:last-child:before{box-shadow:none}.ui[class*=\"computer reversed\"].celled.grid>.row>.column:first-child{box-shadow:-1px 0 0 0 #d4d4d5}.ui[class*=\"computer reversed\"].celled.grid>.row>.column:last-child{box-shadow:none}}@media only screen and (min-width:768px) and (max-width:991px){.ui.doubling.grid{width:auto}.ui.doubling.grid>.row,.ui.grid>.doubling.row{margin:0!important;padding:0!important}.ui.doubling.grid>.row>.column,.ui.grid>.doubling.row>.column{display:inline-block!important;padding-top:1rem!important;padding-bottom:1rem!important;box-shadow:none!important;margin:0}.ui.grid>[class*=\"two column\"].doubling.row.row>.column,.ui[class*=\"two column\"].doubling.grid>.column:not(.row),.ui[class*=\"two column\"].doubling.grid>.row>.column{width:100%!important}.ui.grid>[class*=\"four column\"].doubling.row.row>.column,.ui.grid>[class*=\"three column\"].doubling.row.row>.column,.ui[class*=\"four column\"].doubling.grid>.column:not(.row),.ui[class*=\"four column\"].doubling.grid>.row>.column,.ui[class*=\"three column\"].doubling.grid>.column:not(.row),.ui[class*=\"three column\"].doubling.grid>.row>.column{width:50%!important}.ui.grid>[class*=\"five column\"].doubling.row.row>.column,.ui.grid>[class*=\"seven column\"].doubling.row.row>.column,.ui.grid>[class*=\"six column\"].doubling.row.row>.column,.ui[class*=\"five column\"].doubling.grid>.column:not(.row),.ui[class*=\"five column\"].doubling.grid>.row>.column,.ui[class*=\"seven column\"].doubling.grid>.column:not(.row),.ui[class*=\"seven column\"].doubling.grid>.row>.column,.ui[class*=\"six column\"].doubling.grid>.column:not(.row),.ui[class*=\"six column\"].doubling.grid>.row>.column{width:33.33333333%!important}.ui.grid>[class*=\"eight column\"].doubling.row.row>.column,.ui.grid>[class*=\"nine column\"].doubling.row.row>.column,.ui[class*=\"eight column\"].doubling.grid>.column:not(.row),.ui[class*=\"eight column\"].doubling.grid>.row>.column,.ui[class*=\"nine column\"].doubling.grid>.column:not(.row),.ui[class*=\"nine column\"].doubling.grid>.row>.column{width:25%!important}.ui.grid>[class*=\"eleven column\"].doubling.row.row>.column,.ui.grid>[class*=\"ten column\"].doubling.row.row>.column,.ui[class*=\"eleven column\"].doubling.grid>.column:not(.row),.ui[class*=\"eleven column\"].doubling.grid>.row>.column,.ui[class*=\"ten column\"].doubling.grid>.column:not(.row),.ui[class*=\"ten column\"].doubling.grid>.row>.column{width:20%!important}.ui.grid>[class*=\"thirteen column\"].doubling.row.row>.column,.ui.grid>[class*=\"twelve column\"].doubling.row.row>.column,.ui[class*=\"thirteen column\"].doubling.grid>.column:not(.row),.ui[class*=\"thirteen column\"].doubling.grid>.row>.column,.ui[class*=\"twelve column\"].doubling.grid>.column:not(.row),.ui[class*=\"twelve column\"].doubling.grid>.row>.column{width:16.66666667%!important}.ui.grid>[class*=\"fifteen column\"].doubling.row.row>.column,.ui.grid>[class*=\"fourteen column\"].doubling.row.row>.column,.ui[class*=\"fifteen column\"].doubling.grid>.column:not(.row),.ui[class*=\"fifteen column\"].doubling.grid>.row>.column,.ui[class*=\"fourteen column\"].doubling.grid>.column:not(.row),.ui[class*=\"fourteen column\"].doubling.grid>.row>.column{width:14.28571429%!important}.ui.grid>[class*=\"sixteen column\"].doubling.row.row>.column,.ui[class*=\"sixteen column\"].doubling.grid>.column:not(.row),.ui[class*=\"sixteen column\"].doubling.grid>.row>.column{width:12.5%!important}}@media only screen and (max-width:767px){.ui.doubling.grid>.row,.ui.grid>.doubling.row{margin:0!important;padding:0!important}.ui.doubling.grid>.row>.column,.ui.grid>.doubling.row>.column{padding-top:1rem!important;padding-bottom:1rem!important;margin:0!important;box-shadow:none!important}.ui.grid>[class*=\"two column\"].doubling:not(.stackable).row.row>.column,.ui[class*=\"two column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"two column\"].doubling:not(.stackable).grid>.row>.column{width:100%!important}.ui.grid>[class*=\"eight column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"five column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"four column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"seven column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"six column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"three column\"].doubling:not(.stackable).row.row>.column,.ui[class*=\"eight column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"eight column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"five column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"five column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"four column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"four column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"seven column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"seven column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"six column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"six column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"three column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"three column\"].doubling:not(.stackable).grid>.row>.column{width:50%!important}.ui.grid>[class*=\"eleven column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"nine column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"ten column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"thirteen column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"twelve column\"].doubling:not(.stackable).row.row>.column,.ui[class*=\"eleven column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"eleven column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"nine column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"nine column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"ten column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"ten column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"thirteen column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"thirteen column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"twelve column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"twelve column\"].doubling:not(.stackable).grid>.row>.column{width:33.33333333%!important}.ui.grid>[class*=\"fifteen column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"fourteen column\"].doubling:not(.stackable).row.row>.column,.ui.grid>[class*=\"sixteen column\"].doubling:not(.stackable).row.row>.column,.ui[class*=\"fifteen column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"fifteen column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"fourteen column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"fourteen column\"].doubling:not(.stackable).grid>.row>.column,.ui[class*=\"sixteen column\"].doubling:not(.stackable).grid>.column:not(.row),.ui[class*=\"sixteen column\"].doubling:not(.stackable).grid>.row>.column{width:25%!important}}@media only screen and (max-width:767px){.ui.stackable.grid{width:auto;margin-left:0!important;margin-right:0!important}.ui.grid>.stackable.stackable.row>.column,.ui.stackable.grid>.column.grid>.column,.ui.stackable.grid>.column.row>.column,.ui.stackable.grid>.column:not(.row),.ui.stackable.grid>.row>.column,.ui.stackable.grid>.row>.wide.column,.ui.stackable.grid>.wide.column{width:100%!important;margin:0!important;box-shadow:none!important;padding:1rem!important}.ui.stackable.grid:not(.vertically)>.row{margin:0;padding:0}.ui.container>.ui.stackable.grid>.column,.ui.container>.ui.stackable.grid>.row>.column{padding-left:0!important;padding-right:0!important}.ui.grid .ui.stackable.grid,.ui.segment:not(.vertical) .ui.stackable.page.grid{margin-left:-1rem!important;margin-right:-1rem!important}.ui.stackable.celled.grid>.column:not(.row):first-child,.ui.stackable.celled.grid>.row:first-child>.column:first-child,.ui.stackable.divided.grid>.column:not(.row):first-child,.ui.stackable.divided.grid>.row:first-child>.column:first-child{border-top:none!important}.ui.inverted.stackable.celled.grid>.column:not(.row),.ui.inverted.stackable.celled.grid>.row>.column,.ui.inverted.stackable.divided.grid>.column:not(.row),.ui.inverted.stackable.divided.grid>.row>.column{border-top:1px solid hsla(0,0%,100%,.1)}.ui.stackable.celled.grid>.column:not(.row),.ui.stackable.celled.grid>.row>.column,.ui.stackable.divided:not(.vertically).grid>.column:not(.row),.ui.stackable.divided:not(.vertically).grid>.row>.column{border-top:1px solid rgba(34,36,38,.15);box-shadow:none!important;padding-top:2rem!important;padding-bottom:2rem!important}.ui.stackable.celled.grid>.row{box-shadow:none!important}.ui.stackable.divided:not(.vertically).grid>.column:not(.row),.ui.stackable.divided:not(.vertically).grid>.row>.column{padding-left:0!important;padding-right:0!important}}@media only screen and (max-width:767px){.ui.grid.grid.grid>.row>[class*=\"computer only\"].column:not(.mobile),.ui.grid.grid.grid>.row>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>.row>[class*=\"tablet only\"].column:not(.mobile),.ui.grid.grid.grid>.row>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"computer only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"computer only\"].row:not(.mobile),.ui.grid.grid.grid>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"large screen only\"].row:not(.mobile),.ui.grid.grid.grid>[class*=\"tablet only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"tablet only\"].row:not(.mobile),.ui.grid.grid.grid>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"widescreen only\"].row:not(.mobile),.ui[class*=\"computer only\"].grid.grid.grid:not(.mobile),.ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),.ui[class*=\"tablet only\"].grid.grid.grid:not(.mobile),.ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile){display:none!important}}@media only screen and (min-width:768px) and (max-width:991px){.ui.grid.grid.grid>.row>[class*=\"computer only\"].column:not(.tablet),.ui.grid.grid.grid>.row>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>.row>[class*=\"mobile only\"].column:not(.tablet),.ui.grid.grid.grid>.row>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"computer only\"].column:not(.tablet),.ui.grid.grid.grid>[class*=\"computer only\"].row:not(.tablet),.ui.grid.grid.grid>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"large screen only\"].row:not(.mobile),.ui.grid.grid.grid>[class*=\"mobile only\"].column:not(.tablet),.ui.grid.grid.grid>[class*=\"mobile only\"].row:not(.tablet),.ui.grid.grid.grid>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"widescreen only\"].row:not(.mobile),.ui[class*=\"computer only\"].grid.grid.grid:not(.tablet),.ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),.ui[class*=\"mobile only\"].grid.grid.grid:not(.tablet),.ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile){display:none!important}}@media only screen and (min-width:992px) and (max-width:1199px){.ui.grid.grid.grid>.row>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>.row>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>.row>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>.row>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"large screen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"large screen only\"].row:not(.mobile),.ui.grid.grid.grid>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"mobile only\"].row:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].row:not(.computer),.ui.grid.grid.grid>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"widescreen only\"].row:not(.mobile),.ui[class*=\"large screen only\"].grid.grid.grid:not(.mobile),.ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),.ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),.ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile){display:none!important}}@media only screen and (min-width:1200px) and (max-width:1919px){.ui.grid.grid.grid>.row>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>.row>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>.row>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"mobile only\"].row:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].row:not(.computer),.ui.grid.grid.grid>[class*=\"widescreen only\"].column:not(.mobile),.ui.grid.grid.grid>[class*=\"widescreen only\"].row:not(.mobile),.ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),.ui[class*=\"tablet only\"].grid.grid.grid:not(.computer),.ui[class*=\"widescreen only\"].grid.grid.grid:not(.mobile){display:none!important}}@media only screen and (min-width:1920px){.ui.grid.grid.grid>.row>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>.row>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"mobile only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"mobile only\"].row:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].column:not(.computer),.ui.grid.grid.grid>[class*=\"tablet only\"].row:not(.computer),.ui[class*=\"mobile only\"].grid.grid.grid:not(.computer),.ui[class*=\"tablet only\"].grid.grid.grid:not(.computer){display:none!important}}", ""]);
	
	// exports


/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Header\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.header{border:none;margin:calc(2rem - .1em) 0 1rem;padding:0;font-family:Publico Headline,Georgia,serif;font-weight:500;line-height:1.2em;text-transform:none;color:rgba(0,0,0,.87)}.ui.header:first-child{margin-top:-.1em}.ui.header:last-child{margin-bottom:0}.ui.header .sub.header{display:block;font-weight:400;padding:0;margin:0;font-size:1rem;line-height:1.2em;color:rgba(0,0,0,.6)}.ui.header>.icon{display:table-cell;opacity:1;font-size:1.5em;padding-top:.1em;vertical-align:middle}.ui.header .icon:only-child{display:inline-block;padding:0;margin-right:.75rem}.ui.header>.image,.ui.header>img{display:inline-block;margin-top:.1em;width:2.5em;height:auto;vertical-align:middle}.ui.header>.image:only-child,.ui.header>img:only-child{margin-right:.75rem}.ui.header .content{display:inline-block;vertical-align:top}.ui.header>.icon+.content,.ui.header>.image+.content,.ui.header>img+.content{padding-left:.75rem;vertical-align:middle}.ui.header>.icon+.content{display:table-cell}.ui.header .ui.label{font-size:'';margin-left:.5rem;vertical-align:middle}.ui.header+p{margin-top:0}h1.ui.header{font-size:3.998rem}h2.ui.header{font-size:2.827rem}h3.ui.header{font-size:1.999rem}h4.ui.header{font-size:1.414rem}h5.ui.header{font-size:1rem}h1.ui.header .sub.header,h2.ui.header .sub.header{font-size:1.11764706rem}h3.ui.header .sub.header,h4.ui.header .sub.header{font-size:1rem}h5.ui.header .sub.header{font-size:.82352941rem}.ui.huge.header{min-height:1em;font-size:3.998em}.ui.large.header{font-size:2.827em}.ui.medium.header{font-size:1.999em}.ui.small.header{font-size:1.414em}.ui.tiny.header{font-size:1em}.ui.huge.header .sub.header,.ui.large.header .sub.header{font-size:1.11764706rem}.ui.header .sub.header,.ui.small.header .sub.header{font-size:1rem}.ui.tiny.header .sub.header{font-size:.82352941rem}.ui.sub.header{padding:0;margin-bottom:.11764706rem;font-weight:700;font-size:.76470588em;text-transform:uppercase;color:''}.ui.small.sub.header{font-size:.64705882em}.ui.sub.header{font-size:.76470588em}.ui.large.sub.header{font-size:.82352941em}.ui.huge.sub.header{font-size:1em}.ui.icon.header{display:inline-block;text-align:center;margin:2rem 0 1rem}.ui.icon.header:after{content:'';display:block;height:0;clear:both;visibility:hidden}.ui.icon.header:first-child{margin-top:0}.ui.icon.header .icon{float:none;width:auto;height:auto;line-height:1;font-size:3em;margin:0 auto .5rem;opacity:1}.ui.icon.header .content,.ui.icon.header .icon{display:block;padding:0}.ui.icon.header .circular.icon,.ui.icon.header .square.icon{font-size:2em}.ui.block.icon.header .icon{margin-bottom:0}.ui.icon.header.aligned{margin-left:auto;margin-right:auto;display:block}.ui.disabled.header{opacity:.45}.ui.inverted.header{color:#fff}.ui.inverted.header .sub.header{color:hsla(0,0%,100%,.8)}.ui.inverted.attached.header{border-color:transparent}.ui.inverted.attached.header,.ui.inverted.block.header{background:#545454 -webkit-linear-gradient(transparent,rgba(0,0,0,.05));background:#545454 linear-gradient(transparent,rgba(0,0,0,.05));box-shadow:none}.ui.inverted.block.header{border-bottom:none}.ui.red.header{color:#e23c4e!important}a.ui.red.header:hover{color:#e81d33!important}.ui.red.dividing.header{border-bottom:2px solid #e23c4e}.ui.inverted.red.header{color:#f77482!important}a.ui.inverted.red.header:hover{color:#fd5466!important}.ui.orange.header{color:#f8813d!important}a.ui.orange.header:hover{color:#ff6f1c!important}.ui.orange.dividing.header{border-bottom:2px solid #f8813d}.ui.inverted.orange.header{color:#ff8945!important}a.ui.inverted.orange.header:hover{color:#ff792c!important}.ui.olive.header{color:#456558!important}a.ui.olive.header:hover{color:#39574b!important}.ui.olive.dividing.header{border-bottom:2px solid #456558}.ui.inverted.olive.header{color:#52a583!important}a.ui.inverted.olive.header:hover{color:#459876!important}.ui.yellow.header{color:#ffca18!important}a.ui.yellow.header:hover{color:#fec300!important}.ui.yellow.dividing.header{border-bottom:2px solid #ffca18}.ui.inverted.yellow.header{color:#ffca18!important}a.ui.inverted.yellow.header:hover{color:#fec300!important}.ui.green.header{color:#54af71!important}a.ui.green.header:hover{color:#46a364!important}.ui.green.dividing.header{border-bottom:2px solid #54af71}.ui.inverted.green.header{color:#68ce88!important}a.ui.inverted.green.header:hover{color:#4fce77!important}.ui.teal.header{color:#00a1ca!important}a.ui.teal.header:hover{color:#008db1!important}.ui.teal.dividing.header{border-bottom:2px solid #00a1ca}.ui.inverted.teal.header{color:#00cafd!important}a.ui.inverted.teal.header:hover{color:#00b5e4!important}.ui.blue.header{color:#1d5f82!important}a.ui.blue.header:hover{color:#145171!important}.ui.blue.dividing.header{border-bottom:2px solid #1d5f82}.ui.inverted.blue.header{color:#1782bb!important}a.ui.inverted.blue.header:hover{color:#0d75ac!important}.ui.violet.header{color:#525394!important}a.ui.violet.header:hover{color:#464787!important}.ui.violet.dividing.header{border-bottom:2px solid #525394}.ui.inverted.violet.header{color:#6d6ec6!important}a.ui.inverted.violet.header:hover{color:#5557c4!important}.ui.purple.header{color:#ad427f!important}a.ui.purple.header:hover{color:#9f3672!important}.ui.purple.dividing.header{border-bottom:2px solid #ad427f}.ui.inverted.purple.header{color:#d864a6!important}a.ui.inverted.purple.header:hover{color:#d9499b!important}.ui.pink.header{color:#e03997!important}a.ui.pink.header:hover{color:#e61a8d!important}.ui.pink.dividing.header{border-bottom:2px solid #e03997}.ui.inverted.pink.header{color:#f670bb!important}a.ui.inverted.pink.header:hover{color:#fc50b1!important}.ui.brown.header{color:#a67a00!important}a.ui.brown.header:hover{color:#8d6700!important}.ui.brown.dividing.header{border-bottom:2px solid #a67a00}.ui.inverted.brown.header{color:#f3b200!important}a.ui.inverted.brown.header:hover{color:#d99f00!important}.ui.grey.header{color:#5a686d!important}a.ui.grey.header:hover{color:#66757b!important}.ui.grey.dividing.header{border-bottom:2px solid #5a686d}.ui.inverted.grey.header{color:#7f8f95!important}a.ui.inverted.grey.header:hover{color:#70838a!important}.ui.left.aligned.header{text-align:left}.ui.right.aligned.header{text-align:right}.ui.center.aligned.header,.ui.centered.header{text-align:center}.ui.justified.header{text-align:justify}.ui.justified.header:after{display:inline-block;content:'';width:100%}.ui.floated.header,.ui[class*=\"left floated\"].header{float:left;margin-top:0;margin-right:.5em}.ui[class*=\"right floated\"].header{float:right;margin-top:0;margin-left:.5em}.ui.fitted.header{padding:0}.ui.dividing.header{border-bottom:1px solid rgba(34,36,38,.8)}.ui.dividing.header,.ui.dividing.header .sub.header{padding-bottom:.17647059rem}.ui.inverted.dividing.header{border-bottom-color:hsla(0,0%,98%,.8)}.ui.block.header{background:#f3f4f5;padding:.64705882rem 1rem;box-shadow:none;border:1px solid #d4d4d5;border-radius:.11764706rem}.ui.tiny.block.header{font-size:.76470588rem}.ui.small.block.header{font-size:.82352941rem}.ui.block.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6){font-size:1rem}.ui.large.block.header{font-size:1.11764706rem}.ui.huge.block.header{font-size:1.41176471rem}.ui.attached.header{background:#fff;padding:.64705882rem 1rem;margin-left:-1px;margin-right:-1px;box-shadow:none;border:1px solid #d4d4d5}.ui.attached.block.header{background:#f3f4f5}.ui.attached:not(.top):not(.bottom).header{margin-top:0;margin-bottom:0;border-top:none;border-radius:0}.ui.top.attached.header{margin-bottom:0;border-radius:.11764706rem .11764706rem 0 0}.ui.bottom.attached.header{margin-top:0;border-top:none;border-radius:0 0 .11764706rem .11764706rem}.ui.tiny.attached.header{font-size:.76470588em}.ui.small.attached.header{font-size:.82352941em}.ui.attached.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6){font-size:1em}.ui.large.attached.header{font-size:1.11764706em}.ui.huge.attached.header{font-size:1.41176471em}.ui.header:not(h1):not(h2):not(h3):not(h4):not(h5):not(h6){font-size:1.999em}.ui.header .sub.header{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;font-weight:700}.ui.header .sub.header.meta{color:rgba(0,0,0,.4);font-weight:500}.infographic .ui.header,.ui.infographic.header{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;font-weight:700}.ui.sub.header{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.ui.dividing.header{padding-bottom:0;padding-top:.17647059rem;border-top:1px solid rgba(34,36,38,.8);border-bottom:none}.ui.dividing.header .sub.header{padding-bottom:0}.ui.dividing.header .icon{margin-bottom:0}.ui.dividing.header.inverted{border-bottom-color:transparent;border-top-color:hsla(0,0%,98%,.8)}@media all and (max-width:768px){h1.ui.header{font-size:1.602rem}h2.ui.header{font-size:1.424rem}h3.ui.header{font-size:1.266rem}h4.ui.header{font-size:1.125rem}h5.ui.header{font-size:1rem}}", ""]);
	
	// exports


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Icon\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */@font-face{font-family:Icons;src:url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.eot\");src:url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.eot?#iefix\") format('embedded-opentype'),url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.woff2\") format('woff2'),url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.woff\") format('woff'),url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.ttf\") format('truetype'),url(\"//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.svg#icons\") format('svg');font-style:normal;font-weight:400;font-variant:normal;text-decoration:inherit;text-transform:none}i.icon{display:inline-block;opacity:1;margin:0 .25rem 0 0;width:1.18em;height:1em;font-family:Icons;font-style:normal;font-weight:400;text-decoration:inherit;text-align:center;speak:none;font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;-webkit-backface-visibility:hidden;backface-visibility:hidden}i.icon:before{background:none!important}i.icon.loading{height:1em;line-height:1;-webkit-animation:icon-loading 2s linear infinite;animation:icon-loading 2s linear infinite}@-webkit-keyframes icon-loading{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes icon-loading{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}i.emphasized.icon,i.icon.active,i.icon.hover{opacity:1!important}i.disabled.icon{opacity:.45!important}i.fitted.icon{width:auto;margin:0}i.link.icon,i.link.icons{cursor:pointer;opacity:.8;-webkit-transition:opacity .1s ease;transition:opacity .1s ease}i.link.icon:hover,i.link.icons:hover{opacity:1!important}i.circular.icon{border-radius:500em!important;line-height:1!important;padding:.5em!important;box-shadow:inset 0 0 0 .1em rgba(0,0,0,.1);width:2em!important;height:2em!important}i.circular.inverted.icon{border:none;box-shadow:none}i.flipped.icon,i.horizontally.flipped.icon{-webkit-transform:scaleX(-1);transform:scaleX(-1)}i.vertically.flipped.icon{-webkit-transform:scaleY(-1);transform:scaleY(-1)}i.clockwise.rotated.icon,i.right.rotated.icon,i.rotated.icon{-webkit-transform:rotate(90deg);transform:rotate(90deg)}i.counterclockwise.rotated.icon,i.left.rotated.icon{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}i.bordered.icon{line-height:1;vertical-align:baseline;width:2em;height:2em;padding:.5em .41em!important;box-shadow:inset 0 0 0 .1em rgba(0,0,0,.1)}i.bordered.inverted.icon{border:none;box-shadow:none}i.inverted.bordered.icon,i.inverted.circular.icon{background-color:#1b1c1d!important;color:#fff!important}i.inverted.icon{color:#fff}i.red.icon{color:#e23c4e!important}i.inverted.red.icon{color:#f77482!important}i.inverted.bordered.red.icon,i.inverted.circular.red.icon{background-color:#e23c4e!important;color:#fff!important}i.orange.icon{color:#f8813d!important}i.inverted.orange.icon{color:#ff8945!important}i.inverted.bordered.orange.icon,i.inverted.circular.orange.icon{background-color:#f8813d!important;color:#fff!important}i.inverted.yellow.icon,i.yellow.icon{color:#ffca18!important}i.inverted.bordered.yellow.icon,i.inverted.circular.yellow.icon{background-color:#ffca18!important;color:#fff!important}i.olive.icon{color:#456558!important}i.inverted.olive.icon{color:#52a583!important}i.inverted.bordered.olive.icon,i.inverted.circular.olive.icon{background-color:#456558!important;color:#fff!important}i.green.icon{color:#54af71!important}i.inverted.green.icon{color:#68ce88!important}i.inverted.bordered.green.icon,i.inverted.circular.green.icon{background-color:#54af71!important;color:#fff!important}i.teal.icon{color:#00a1ca!important}i.inverted.teal.icon{color:#00cafd!important}i.inverted.bordered.teal.icon,i.inverted.circular.teal.icon{background-color:#00a1ca!important;color:#fff!important}i.blue.icon{color:#1d5f82!important}i.inverted.blue.icon{color:#1782bb!important}i.inverted.bordered.blue.icon,i.inverted.circular.blue.icon{background-color:#1d5f82!important;color:#fff!important}i.violet.icon{color:#525394!important}i.inverted.violet.icon{color:#6d6ec6!important}i.inverted.bordered.violet.icon,i.inverted.circular.violet.icon{background-color:#525394!important;color:#fff!important}i.purple.icon{color:#ad427f!important}i.inverted.purple.icon{color:#d864a6!important}i.inverted.bordered.purple.icon,i.inverted.circular.purple.icon{background-color:#ad427f!important;color:#fff!important}i.pink.icon{color:#e03997!important}i.inverted.pink.icon{color:#f670bb!important}i.inverted.bordered.pink.icon,i.inverted.circular.pink.icon{background-color:#e03997!important;color:#fff!important}i.brown.icon{color:#a67a00!important}i.inverted.brown.icon{color:#f3b200!important}i.inverted.bordered.brown.icon,i.inverted.circular.brown.icon{background-color:#a67a00!important;color:#fff!important}i.grey.icon{color:#5a686d!important}i.inverted.grey.icon{color:#7f8f95!important}i.inverted.bordered.grey.icon,i.inverted.circular.grey.icon{background-color:#5a686d!important;color:#fff!important}i.black.icon{color:#1b1c1d!important}i.inverted.black.icon{color:#545454!important}i.inverted.bordered.black.icon,i.inverted.circular.black.icon{background-color:#1b1c1d!important;color:#fff!important}i.mini.icon,i.mini.icons{line-height:1;font-size:.4em}i.tiny.icon,i.tiny.icons{line-height:1;font-size:.5em}i.small.icon,i.small.icons{line-height:1;font-size:.75em}i.icon,i.icons{font-size:1em}i.large.icon,i.large.icons{line-height:1;vertical-align:middle;font-size:1.5em}i.big.icon,i.big.icons{line-height:1;vertical-align:middle;font-size:2em}i.huge.icon,i.huge.icons{line-height:1;vertical-align:middle;font-size:4em}i.massive.icon,i.massive.icons{line-height:1;vertical-align:middle;font-size:8em}i.icons{display:inline-block;position:relative;line-height:1}i.icons .icon{position:absolute;top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);margin:0}i.icons .icon:first-child{position:static;width:auto;height:auto;vertical-align:top;-webkit-transform:none;transform:none;margin-right:.25rem}i.icons .corner.icon{top:auto;left:auto;right:0;bottom:0;-webkit-transform:none;transform:none;font-size:.45em;text-shadow:-1px -1px 0 #fff,1px -1px 0 #fff,-1px 1px 0 #fff,1px 1px 0 #fff}i.icons .inverted.corner.icon{text-shadow:-1px -1px 0 #1b1c1d,1px -1px 0 #1b1c1d,-1px 1px 0 #1b1c1d,1px 1px 0 #1b1c1d}i.icon.search:before{content:\"\\F002\"}i.icon.mail.outline:before{content:\"\\F003\"}i.icon.signal:before{content:\"\\F012\"}i.icon.setting:before{content:\"\\F013\"}i.icon.home:before{content:\"\\F015\"}i.icon.inbox:before{content:\"\\F01C\"}i.icon.browser:before{content:\"\\F022\"}i.icon.tag:before{content:\"\\F02B\"}i.icon.tags:before{content:\"\\F02C\"}i.icon.image:before{content:\"\\F03E\"}i.icon.calendar:before{content:\"\\F073\"}i.icon.comment:before{content:\"\\F075\"}i.icon.shop:before{content:\"\\F07A\"}i.icon.privacy:before{content:\"\\F084\"}i.icon.settings:before{content:\"\\F085\"}i.icon.comments:before{content:\"\\F086\"}i.icon.external:before{content:\"\\F08E\"}i.icon.trophy:before{content:\"\\F091\"}i.icon.payment:before{content:\"\\F09D\"}i.icon.feed:before{content:\"\\F09E\"}i.icon.alarm.outline:before{content:\"\\F0A2\"}i.icon.tasks:before{content:\"\\F0AE\"}i.icon.cloud:before{content:\"\\F0C2\"}i.icon.lab:before{content:\"\\F0C3\"}i.icon.mail:before{content:\"\\F0E0\"}i.icon.dashboard:before{content:\"\\F0E4\"}i.icon.comment.outline:before{content:\"\\F0E5\"}i.icon.comments.outline:before{content:\"\\F0E6\"}i.icon.sitemap:before{content:\"\\F0E8\"}i.icon.idea:before{content:\"\\F0EB\"}i.icon.alarm:before{content:\"\\F0F3\"}i.icon.terminal:before{content:\"\\F120\"}i.icon.code:before{content:\"\\F121\"}i.icon.protect:before{content:\"\\F132\"}i.icon.calendar.outline:before{content:\"\\F133\"}i.icon.ticket:before{content:\"\\F145\"}i.icon.external.square:before{content:\"\\F14C\"}i.icon.bug:before{content:\"\\F188\"}i.icon.mail.square:before{content:\"\\F199\"}i.icon.history:before{content:\"\\F1DA\"}i.icon.options:before{content:\"\\F1DE\"}i.icon.text.telephone:before{content:\"\\F1E4\"}i.icon.find:before{content:\"\\F1E5\"}i.icon.wifi:before{content:\"\\F1EB\"}i.icon.alarm.mute:before{content:\"\\F1F6\"}i.icon.alarm.mute.outline:before{content:\"\\F1F7\"}i.icon.copyright:before{content:\"\\F1F9\"}i.icon.at:before{content:\"\\F1FA\"}i.icon.eyedropper:before{content:\"\\F1FB\"}i.icon.paint.brush:before{content:\"\\F1FC\"}i.icon.heartbeat:before{content:\"\\F21E\"}i.icon.mouse.pointer:before{content:\"\\F245\"}i.icon.hourglass.empty:before{content:\"\\F250\"}i.icon.hourglass.start:before{content:\"\\F251\"}i.icon.hourglass.half:before{content:\"\\F252\"}i.icon.hourglass.end:before{content:\"\\F253\"}i.icon.hourglass.full:before{content:\"\\F254\"}i.icon.hand.pointer:before{content:\"\\F25A\"}i.icon.trademark:before{content:\"\\F25C\"}i.icon.registered:before{content:\"\\F25D\"}i.icon.creative.commons:before{content:\"\\F25E\"}i.icon.add.to.calendar:before{content:\"\\F271\"}i.icon.remove.from.calendar:before{content:\"\\F272\"}i.icon.delete.calendar:before{content:\"\\F273\"}i.icon.checked.calendar:before{content:\"\\F274\"}i.icon.industry:before{content:\"\\F275\"}i.icon.shopping.bag:before{content:\"\\F290\"}i.icon.shopping.basket:before{content:\"\\F291\"}i.icon.hashtag:before{content:\"\\F292\"}i.icon.percent:before{content:\"\\F295\"}i.icon.wait:before{content:\"\\F017\"}i.icon.download:before{content:\"\\F019\"}i.icon.repeat:before{content:\"\\F01E\"}i.icon.refresh:before{content:\"\\F021\"}i.icon.lock:before{content:\"\\F023\"}i.icon.bookmark:before{content:\"\\F02E\"}i.icon.print:before{content:\"\\F02F\"}i.icon.write:before{content:\"\\F040\"}i.icon.adjust:before{content:\"\\F042\"}i.icon.theme:before{content:\"\\F043\"}i.icon.edit:before{content:\"\\F044\"}i.icon.external.share:before{content:\"\\F045\"}i.icon.ban:before{content:\"\\F05E\"}i.icon.mail.forward:before,i.icon.share:before{content:\"\\F064\"}i.icon.expand:before{content:\"\\F065\"}i.icon.compress:before{content:\"\\F066\"}i.icon.unhide:before{content:\"\\F06E\"}i.icon.hide:before{content:\"\\F070\"}i.icon.random:before{content:\"\\F074\"}i.icon.retweet:before{content:\"\\F079\"}i.icon.sign.out:before{content:\"\\F08B\"}i.icon.pin:before{content:\"\\F08D\"}i.icon.sign.in:before{content:\"\\F090\"}i.icon.upload:before{content:\"\\F093\"}i.icon.call:before{content:\"\\F095\"}i.icon.remove.bookmark:before{content:\"\\F097\"}i.icon.call.square:before{content:\"\\F098\"}i.icon.unlock:before{content:\"\\F09C\"}i.icon.configure:before{content:\"\\F0AD\"}i.icon.filter:before{content:\"\\F0B0\"}i.icon.wizard:before{content:\"\\F0D0\"}i.icon.undo:before{content:\"\\F0E2\"}i.icon.exchange:before{content:\"\\F0EC\"}i.icon.cloud.download:before{content:\"\\F0ED\"}i.icon.cloud.upload:before{content:\"\\F0EE\"}i.icon.reply:before{content:\"\\F112\"}i.icon.reply.all:before{content:\"\\F122\"}i.icon.erase:before{content:\"\\F12D\"}i.icon.unlock.alternate:before{content:\"\\F13E\"}i.icon.write.square:before{content:\"\\F14B\"}i.icon.share.square:before{content:\"\\F14D\"}i.icon.archive:before{content:\"\\F187\"}i.icon.translate:before{content:\"\\F1AB\"}i.icon.recycle:before{content:\"\\F1B8\"}i.icon.send:before{content:\"\\F1D8\"}i.icon.send.outline:before{content:\"\\F1D9\"}i.icon.share.alternate:before{content:\"\\F1E0\"}i.icon.share.alternate.square:before{content:\"\\F1E1\"}i.icon.add.to.cart:before{content:\"\\F217\"}i.icon.in.cart:before{content:\"\\F218\"}i.icon.add.user:before{content:\"\\F234\"}i.icon.remove.user:before{content:\"\\F235\"}i.icon.object.group:before{content:\"\\F247\"}i.icon.object.ungroup:before{content:\"\\F248\"}i.icon.clone:before{content:\"\\F24D\"}i.icon.talk:before{content:\"\\F27A\"}i.icon.talk.outline:before{content:\"\\F27B\"}i.icon.help.circle:before{content:\"\\F059\"}i.icon.info.circle:before{content:\"\\F05A\"}i.icon.warning.circle:before{content:\"\\F06A\"}i.icon.warning.sign:before{content:\"\\F071\"}i.icon.announcement:before{content:\"\\F0A1\"}i.icon.help:before{content:\"\\F128\"}i.icon.info:before{content:\"\\F129\"}i.icon.warning:before{content:\"\\F12A\"}i.icon.birthday:before{content:\"\\F1FD\"}i.icon.help.circle.outline:before{content:\"\\F29C\"}i.icon.user:before{content:\"\\F007\"}i.icon.users:before{content:\"\\F0C0\"}i.icon.doctor:before{content:\"\\F0F0\"}i.icon.handicap:before{content:\"\\F193\"}i.icon.student:before{content:\"\\F19D\"}i.icon.child:before{content:\"\\F1AE\"}i.icon.spy:before{content:\"\\F21B\"}i.icon.female:before{content:\"\\F182\"}i.icon.male:before{content:\"\\F183\"}i.icon.woman:before{content:\"\\F221\"}i.icon.man:before{content:\"\\F222\"}i.icon.non.binary.transgender:before{content:\"\\F223\"}i.icon.intergender:before{content:\"\\F224\"}i.icon.transgender:before{content:\"\\F225\"}i.icon.lesbian:before{content:\"\\F226\"}i.icon.gay:before{content:\"\\F227\"}i.icon.heterosexual:before{content:\"\\F228\"}i.icon.other.gender:before{content:\"\\F229\"}i.icon.other.gender.vertical:before{content:\"\\F22A\"}i.icon.other.gender.horizontal:before{content:\"\\F22B\"}i.icon.neuter:before{content:\"\\F22C\"}i.icon.genderless:before{content:\"\\F22D\"}i.icon.universal.access:before{content:\"\\F29A\"}i.icon.wheelchair:before{content:\"\\F29B\"}i.icon.blind:before{content:\"\\F29D\"}i.icon.audio.description:before{content:\"\\F29E\"}i.icon.volume.control.phone:before{content:\"\\F2A0\"}i.icon.braille:before{content:\"\\F2A1\"}i.icon.asl:before{content:\"\\F2A3\"}i.icon.assistive.listening.systems:before{content:\"\\F2A2\"}i.icon.deafness:before{content:\"\\F2A4\"}i.icon.sign.language:before{content:\"\\F2A7\"}i.icon.low.vision:before{content:\"\\F2A8\"}i.icon.block.layout:before{content:\"\\F009\"}i.icon.grid.layout:before{content:\"\\F00A\"}i.icon.list.layout:before{content:\"\\F00B\"}i.icon.zoom:before{content:\"\\F00E\"}i.icon.zoom.out:before{content:\"\\F010\"}i.icon.resize.vertical:before{content:\"\\F07D\"}i.icon.resize.horizontal:before{content:\"\\F07E\"}i.icon.maximize:before{content:\"\\F0B2\"}i.icon.crop:before{content:\"\\F125\"}i.icon.cocktail:before{content:\"\\F000\"}i.icon.road:before{content:\"\\F018\"}i.icon.flag:before{content:\"\\F024\"}i.icon.book:before{content:\"\\F02D\"}i.icon.gift:before{content:\"\\F06B\"}i.icon.leaf:before{content:\"\\F06C\"}i.icon.fire:before{content:\"\\F06D\"}i.icon.plane:before{content:\"\\F072\"}i.icon.magnet:before{content:\"\\F076\"}i.icon.lemon:before{content:\"\\F094\"}i.icon.world:before{content:\"\\F0AC\"}i.icon.travel:before{content:\"\\F0B1\"}i.icon.shipping:before{content:\"\\F0D1\"}i.icon.money:before{content:\"\\F0D6\"}i.icon.legal:before{content:\"\\F0E3\"}i.icon.lightning:before{content:\"\\F0E7\"}i.icon.umbrella:before{content:\"\\F0E9\"}i.icon.treatment:before{content:\"\\F0F1\"}i.icon.suitcase:before{content:\"\\F0F2\"}i.icon.bar:before{content:\"\\F0FC\"}i.icon.flag.outline:before{content:\"\\F11D\"}i.icon.flag.checkered:before{content:\"\\F11E\"}i.icon.puzzle:before{content:\"\\F12E\"}i.icon.fire.extinguisher:before{content:\"\\F134\"}i.icon.rocket:before{content:\"\\F135\"}i.icon.anchor:before{content:\"\\F13D\"}i.icon.bullseye:before{content:\"\\F140\"}i.icon.sun:before{content:\"\\F185\"}i.icon.moon:before{content:\"\\F186\"}i.icon.fax:before{content:\"\\F1AC\"}i.icon.life.ring:before{content:\"\\F1CD\"}i.icon.bomb:before{content:\"\\F1E2\"}i.icon.soccer:before{content:\"\\F1E3\"}i.icon.calculator:before{content:\"\\F1EC\"}i.icon.diamond:before{content:\"\\F219\"}i.icon.sticky.note:before{content:\"\\F249\"}i.icon.sticky.note.outline:before{content:\"\\F24A\"}i.icon.law:before{content:\"\\F24E\"}i.icon.hand.peace:before{content:\"\\F25B\"}i.icon.hand.rock:before{content:\"\\F255\"}i.icon.hand.paper:before{content:\"\\F256\"}i.icon.hand.scissors:before{content:\"\\F257\"}i.icon.hand.lizard:before{content:\"\\F258\"}i.icon.hand.spock:before{content:\"\\F259\"}i.icon.tv:before{content:\"\\F26C\"}i.icon.crosshairs:before{content:\"\\F05B\"}i.icon.asterisk:before{content:\"\\F069\"}i.icon.square.outline:before{content:\"\\F096\"}i.icon.certificate:before{content:\"\\F0A3\"}i.icon.square:before{content:\"\\F0C8\"}i.icon.quote.left:before{content:\"\\F10D\"}i.icon.quote.right:before{content:\"\\F10E\"}i.icon.spinner:before{content:\"\\F110\"}i.icon.circle:before{content:\"\\F111\"}i.icon.ellipsis.horizontal:before{content:\"\\F141\"}i.icon.ellipsis.vertical:before{content:\"\\F142\"}i.icon.cube:before{content:\"\\F1B2\"}i.icon.cubes:before{content:\"\\F1B3\"}i.icon.circle.notched:before{content:\"\\F1CE\"}i.icon.circle.thin:before{content:\"\\F1DB\"}i.icon.checkmark:before{content:\"\\F00C\"}i.icon.remove:before{content:\"\\F00D\"}i.icon.checkmark.box:before{content:\"\\F046\"}i.icon.move:before{content:\"\\F047\"}i.icon.add.circle:before{content:\"\\F055\"}i.icon.minus.circle:before{content:\"\\F056\"}i.icon.remove.circle:before{content:\"\\F057\"}i.icon.check.circle:before{content:\"\\F058\"}i.icon.remove.circle.outline:before{content:\"\\F05C\"}i.icon.check.circle.outline:before{content:\"\\F05D\"}i.icon.plus:before{content:\"\\F067\"}i.icon.minus:before{content:\"\\F068\"}i.icon.add.square:before{content:\"\\F0FE\"}i.icon.radio:before{content:\"\\F10C\"}i.icon.minus.square:before{content:\"\\F146\"}i.icon.minus.square.outline:before{content:\"\\F147\"}i.icon.check.square:before{content:\"\\F14A\"}i.icon.selected.radio:before{content:\"\\F192\"}i.icon.plus.square.outline:before{content:\"\\F196\"}i.icon.toggle.off:before{content:\"\\F204\"}i.icon.toggle.on:before{content:\"\\F205\"}i.icon.film:before{content:\"\\F008\"}i.icon.sound:before{content:\"\\F025\"}i.icon.photo:before{content:\"\\F030\"}i.icon.bar.chart:before{content:\"\\F080\"}i.icon.camera.retro:before{content:\"\\F083\"}i.icon.newspaper:before{content:\"\\F1EA\"}i.icon.area.chart:before{content:\"\\F1FE\"}i.icon.pie.chart:before{content:\"\\F200\"}i.icon.line.chart:before{content:\"\\F201\"}i.icon.arrow.circle.outline.down:before{content:\"\\F01A\"}i.icon.arrow.circle.outline.up:before{content:\"\\F01B\"}i.icon.chevron.left:before{content:\"\\F053\"}i.icon.chevron.right:before{content:\"\\F054\"}i.icon.arrow.left:before{content:\"\\F060\"}i.icon.arrow.right:before{content:\"\\F061\"}i.icon.arrow.up:before{content:\"\\F062\"}i.icon.arrow.down:before{content:\"\\F063\"}i.icon.chevron.up:before{content:\"\\F077\"}i.icon.chevron.down:before{content:\"\\F078\"}i.icon.pointing.right:before{content:\"\\F0A4\"}i.icon.pointing.left:before{content:\"\\F0A5\"}i.icon.pointing.up:before{content:\"\\F0A6\"}i.icon.pointing.down:before{content:\"\\F0A7\"}i.icon.arrow.circle.left:before{content:\"\\F0A8\"}i.icon.arrow.circle.right:before{content:\"\\F0A9\"}i.icon.arrow.circle.up:before{content:\"\\F0AA\"}i.icon.arrow.circle.down:before{content:\"\\F0AB\"}i.icon.caret.down:before{content:\"\\F0D7\"}i.icon.caret.up:before{content:\"\\F0D8\"}i.icon.caret.left:before{content:\"\\F0D9\"}i.icon.caret.right:before{content:\"\\F0DA\"}i.icon.angle.double.left:before{content:\"\\F100\"}i.icon.angle.double.right:before{content:\"\\F101\"}i.icon.angle.double.up:before{content:\"\\F102\"}i.icon.angle.double.down:before{content:\"\\F103\"}i.icon.angle.left:before{content:\"\\F104\"}i.icon.angle.right:before{content:\"\\F105\"}i.icon.angle.up:before{content:\"\\F106\"}i.icon.angle.down:before{content:\"\\F107\"}i.icon.chevron.circle.left:before{content:\"\\F137\"}i.icon.chevron.circle.right:before{content:\"\\F138\"}i.icon.chevron.circle.up:before{content:\"\\F139\"}i.icon.chevron.circle.down:before{content:\"\\F13A\"}i.icon.toggle.down:before{content:\"\\F150\"}i.icon.toggle.up:before{content:\"\\F151\"}i.icon.toggle.right:before{content:\"\\F152\"}i.icon.long.arrow.down:before{content:\"\\F175\"}i.icon.long.arrow.up:before{content:\"\\F176\"}i.icon.long.arrow.left:before{content:\"\\F177\"}i.icon.long.arrow.right:before{content:\"\\F178\"}i.icon.arrow.circle.outline.right:before{content:\"\\F18E\"}i.icon.arrow.circle.outline.left:before{content:\"\\F190\"}i.icon.toggle.left:before{content:\"\\F191\"}i.icon.tablet:before{content:\"\\F10A\"}i.icon.mobile:before{content:\"\\F10B\"}i.icon.battery.full:before{content:\"\\F240\"}i.icon.battery.high:before{content:\"\\F241\"}i.icon.battery.medium:before{content:\"\\F242\"}i.icon.battery.low:before{content:\"\\F243\"}i.icon.battery.empty:before{content:\"\\F244\"}i.icon.power:before{content:\"\\F011\"}i.icon.trash.outline:before{content:\"\\F014\"}i.icon.disk.outline:before{content:\"\\F0A0\"}i.icon.desktop:before{content:\"\\F108\"}i.icon.laptop:before{content:\"\\F109\"}i.icon.game:before{content:\"\\F11B\"}i.icon.keyboard:before{content:\"\\F11C\"}i.icon.plug:before{content:\"\\F1E6\"}i.icon.trash:before{content:\"\\F1F8\"}i.icon.file.outline:before{content:\"\\F016\"}i.icon.folder:before{content:\"\\F07B\"}i.icon.folder.open:before{content:\"\\F07C\"}i.icon.file.text.outline:before{content:\"\\F0F6\"}i.icon.folder.outline:before{content:\"\\F114\"}i.icon.folder.open.outline:before{content:\"\\F115\"}i.icon.level.up:before{content:\"\\F148\"}i.icon.level.down:before{content:\"\\F149\"}i.icon.file:before{content:\"\\F15B\"}i.icon.file.text:before{content:\"\\F15C\"}i.icon.file.pdf.outline:before{content:\"\\F1C1\"}i.icon.file.word.outline:before{content:\"\\F1C2\"}i.icon.file.excel.outline:before{content:\"\\F1C3\"}i.icon.file.powerpoint.outline:before{content:\"\\F1C4\"}i.icon.file.image.outline:before{content:\"\\F1C5\"}i.icon.file.archive.outline:before{content:\"\\F1C6\"}i.icon.file.audio.outline:before{content:\"\\F1C7\"}i.icon.file.video.outline:before{content:\"\\F1C8\"}i.icon.file.code.outline:before{content:\"\\F1C9\"}i.icon.qrcode:before{content:\"\\F029\"}i.icon.barcode:before{content:\"\\F02A\"}i.icon.rss:before{content:\"\\F09E\"}i.icon.fork:before{content:\"\\F126\"}i.icon.html5:before{content:\"\\F13B\"}i.icon.css3:before{content:\"\\F13C\"}i.icon.rss.square:before{content:\"\\F143\"}i.icon.openid:before{content:\"\\F19B\"}i.icon.database:before{content:\"\\F1C0\"}i.icon.server:before{content:\"\\F233\"}i.icon.usb:before{content:\"\\F287\"}i.icon.bluetooth:before{content:\"\\F293\"}i.icon.bluetooth.alternative:before{content:\"\\F294\"}i.icon.heart:before{content:\"\\F004\"}i.icon.star:before{content:\"\\F005\"}i.icon.empty.star:before{content:\"\\F006\"}i.icon.thumbs.outline.up:before{content:\"\\F087\"}i.icon.thumbs.outline.down:before{content:\"\\F088\"}i.icon.star.half:before{content:\"\\F089\"}i.icon.empty.heart:before{content:\"\\F08A\"}i.icon.smile:before{content:\"\\F118\"}i.icon.frown:before{content:\"\\F119\"}i.icon.meh:before{content:\"\\F11A\"}i.icon.star.half.empty:before{content:\"\\F123\"}i.icon.thumbs.up:before{content:\"\\F164\"}i.icon.thumbs.down:before{content:\"\\F165\"}i.icon.music:before{content:\"\\F001\"}i.icon.video.play.outline:before{content:\"\\F01D\"}i.icon.volume.off:before{content:\"\\F026\"}i.icon.volume.down:before{content:\"\\F027\"}i.icon.volume.up:before{content:\"\\F028\"}i.icon.record:before{content:\"\\F03D\"}i.icon.step.backward:before{content:\"\\F048\"}i.icon.fast.backward:before{content:\"\\F049\"}i.icon.backward:before{content:\"\\F04A\"}i.icon.play:before{content:\"\\F04B\"}i.icon.pause:before{content:\"\\F04C\"}i.icon.stop:before{content:\"\\F04D\"}i.icon.forward:before{content:\"\\F04E\"}i.icon.fast.forward:before{content:\"\\F050\"}i.icon.step.forward:before{content:\"\\F051\"}i.icon.eject:before{content:\"\\F052\"}i.icon.unmute:before{content:\"\\F130\"}i.icon.mute:before{content:\"\\F131\"}i.icon.video.play:before{content:\"\\F144\"}i.icon.closed.captioning:before{content:\"\\F20A\"}i.icon.pause.circle:before{content:\"\\F28B\"}i.icon.pause.circle.outline:before{content:\"\\F28C\"}i.icon.stop.circle:before{content:\"\\F28D\"}i.icon.stop.circle.outline:before{content:\"\\F28E\"}i.icon.marker:before{content:\"\\F041\"}i.icon.coffee:before{content:\"\\F0F4\"}i.icon.food:before{content:\"\\F0F5\"}i.icon.building.outline:before{content:\"\\F0F7\"}i.icon.hospital:before{content:\"\\F0F8\"}i.icon.emergency:before{content:\"\\F0F9\"}i.icon.first.aid:before{content:\"\\F0FA\"}i.icon.military:before{content:\"\\F0FB\"}i.icon.h:before{content:\"\\F0FD\"}i.icon.location.arrow:before{content:\"\\F124\"}i.icon.compass:before{content:\"\\F14E\"}i.icon.space.shuttle:before{content:\"\\F197\"}i.icon.university:before{content:\"\\F19C\"}i.icon.building:before{content:\"\\F1AD\"}i.icon.paw:before{content:\"\\F1B0\"}i.icon.spoon:before{content:\"\\F1B1\"}i.icon.car:before{content:\"\\F1B9\"}i.icon.taxi:before{content:\"\\F1BA\"}i.icon.tree:before{content:\"\\F1BB\"}i.icon.bicycle:before{content:\"\\F206\"}i.icon.bus:before{content:\"\\F207\"}i.icon.ship:before{content:\"\\F21A\"}i.icon.motorcycle:before{content:\"\\F21C\"}i.icon.street.view:before{content:\"\\F21D\"}i.icon.hotel:before{content:\"\\F236\"}i.icon.train:before{content:\"\\F238\"}i.icon.subway:before{content:\"\\F239\"}i.icon.map.pin:before{content:\"\\F276\"}i.icon.map.signs:before{content:\"\\F277\"}i.icon.map.outline:before{content:\"\\F278\"}i.icon.map:before{content:\"\\F279\"}i.icon.table:before{content:\"\\F0CE\"}i.icon.columns:before{content:\"\\F0DB\"}i.icon.sort:before{content:\"\\F0DC\"}i.icon.sort.descending:before{content:\"\\F0DD\"}i.icon.sort.ascending:before{content:\"\\F0DE\"}i.icon.sort.alphabet.ascending:before{content:\"\\F15D\"}i.icon.sort.alphabet.descending:before{content:\"\\F15E\"}i.icon.sort.content.ascending:before{content:\"\\F160\"}i.icon.sort.content.descending:before{content:\"\\F161\"}i.icon.sort.numeric.ascending:before{content:\"\\F162\"}i.icon.sort.numeric.descending:before{content:\"\\F163\"}i.icon.font:before{content:\"\\F031\"}i.icon.bold:before{content:\"\\F032\"}i.icon.italic:before{content:\"\\F033\"}i.icon.text.height:before{content:\"\\F034\"}i.icon.text.width:before{content:\"\\F035\"}i.icon.align.left:before{content:\"\\F036\"}i.icon.align.center:before{content:\"\\F037\"}i.icon.align.right:before{content:\"\\F038\"}i.icon.align.justify:before{content:\"\\F039\"}i.icon.list:before{content:\"\\F03A\"}i.icon.outdent:before{content:\"\\F03B\"}i.icon.indent:before{content:\"\\F03C\"}i.icon.cut:before{content:\"\\F0C4\"}i.icon.copy:before{content:\"\\F0C5\"}i.icon.attach:before{content:\"\\F0C6\"}i.icon.save:before{content:\"\\F0C7\"}i.icon.content:before{content:\"\\F0C9\"}i.icon.unordered.list:before{content:\"\\F0CA\"}i.icon.ordered.list:before{content:\"\\F0CB\"}i.icon.strikethrough:before{content:\"\\F0CC\"}i.icon.underline:before{content:\"\\F0CD\"}i.icon.paste:before{content:\"\\F0EA\"}i.icon.unlinkify:before{content:\"\\F127\"}i.icon.superscript:before{content:\"\\F12B\"}i.icon.subscript:before{content:\"\\F12C\"}i.icon.header:before{content:\"\\F1DC\"}i.icon.paragraph:before{content:\"\\F1DD\"}i.icon.text.cursor:before{content:\"\\F246\"}i.icon.euro:before{content:\"\\F153\"}i.icon.pound:before{content:\"\\F154\"}i.icon.dollar:before{content:\"\\F155\"}i.icon.rupee:before{content:\"\\F156\"}i.icon.yen:before{content:\"\\F157\"}i.icon.ruble:before{content:\"\\F158\"}i.icon.won:before{content:\"\\F159\"}i.icon.bitcoin:before{content:\"\\F15A\"}i.icon.lira:before{content:\"\\F195\"}i.icon.shekel:before{content:\"\\F20B\"}i.icon.paypal:before{content:\"\\F1ED\"}i.icon.google.wallet:before{content:\"\\F1EE\"}i.icon.visa:before{content:\"\\F1F0\"}i.icon.mastercard:before{content:\"\\F1F1\"}i.icon.discover:before{content:\"\\F1F2\"}i.icon.american.express:before{content:\"\\F1F3\"}i.icon.paypal.card:before{content:\"\\F1F4\"}i.icon.stripe:before{content:\"\\F1F5\"}i.icon.japan.credit.bureau:before{content:\"\\F24B\"}i.icon.diners.club:before{content:\"\\F24C\"}i.icon.credit.card.alternative:before{content:\"\\F283\"}i.icon.twitter.square:before{content:\"\\F081\"}i.icon.facebook.square:before{content:\"\\F082\"}i.icon.linkedin.square:before{content:\"\\F08C\"}i.icon.github.square:before{content:\"\\F092\"}i.icon.twitter:before{content:\"\\F099\"}i.icon.facebook.f:before{content:\"\\F09A\"}i.icon.github:before{content:\"\\F09B\"}i.icon.pinterest:before{content:\"\\F0D2\"}i.icon.pinterest.square:before{content:\"\\F0D3\"}i.icon.google.plus.square:before{content:\"\\F0D4\"}i.icon.google.plus:before{content:\"\\F0D5\"}i.icon.linkedin:before{content:\"\\F0E1\"}i.icon.github.alternate:before{content:\"\\F113\"}i.icon.maxcdn:before{content:\"\\F136\"}i.icon.youtube.square:before{content:\"\\F166\"}i.icon.youtube:before{content:\"\\F167\"}i.icon.xing:before{content:\"\\F168\"}i.icon.xing.square:before{content:\"\\F169\"}i.icon.youtube.play:before{content:\"\\F16A\"}i.icon.dropbox:before{content:\"\\F16B\"}i.icon.stack.overflow:before{content:\"\\F16C\"}i.icon.instagram:before{content:\"\\F16D\"}i.icon.flickr:before{content:\"\\F16E\"}i.icon.adn:before{content:\"\\F170\"}i.icon.bitbucket:before{content:\"\\F171\"}i.icon.bitbucket.square:before{content:\"\\F172\"}i.icon.tumblr:before{content:\"\\F173\"}i.icon.tumblr.square:before{content:\"\\F174\"}i.icon.apple:before{content:\"\\F179\"}i.icon.windows:before{content:\"\\F17A\"}i.icon.android:before{content:\"\\F17B\"}i.icon.linux:before{content:\"\\F17C\"}i.icon.dribble:before{content:\"\\F17D\"}i.icon.skype:before{content:\"\\F17E\"}i.icon.foursquare:before{content:\"\\F180\"}i.icon.trello:before{content:\"\\F181\"}i.icon.gittip:before{content:\"\\F184\"}i.icon.vk:before{content:\"\\F189\"}i.icon.weibo:before{content:\"\\F18A\"}i.icon.renren:before{content:\"\\F18B\"}i.icon.pagelines:before{content:\"\\F18C\"}i.icon.stack.exchange:before{content:\"\\F18D\"}i.icon.vimeo.square:before{content:\"\\F194\"}i.icon.slack:before{content:\"\\F198\"}i.icon.wordpress:before{content:\"\\F19A\"}i.icon.yahoo:before{content:\"\\F19E\"}i.icon.google:before{content:\"\\F1A0\"}i.icon.reddit:before{content:\"\\F1A1\"}i.icon.reddit.square:before{content:\"\\F1A2\"}i.icon.stumbleupon.circle:before{content:\"\\F1A3\"}i.icon.stumbleupon:before{content:\"\\F1A4\"}i.icon.delicious:before{content:\"\\F1A5\"}i.icon.digg:before{content:\"\\F1A6\"}i.icon.pied.piper:before{content:\"\\F1A7\"}i.icon.pied.piper.alternate:before{content:\"\\F1A8\"}i.icon.drupal:before{content:\"\\F1A9\"}i.icon.joomla:before{content:\"\\F1AA\"}i.icon.behance:before{content:\"\\F1B4\"}i.icon.behance.square:before{content:\"\\F1B5\"}i.icon.steam:before{content:\"\\F1B6\"}i.icon.steam.square:before{content:\"\\F1B7\"}i.icon.spotify:before{content:\"\\F1BC\"}i.icon.deviantart:before{content:\"\\F1BD\"}i.icon.soundcloud:before{content:\"\\F1BE\"}i.icon.vine:before{content:\"\\F1CA\"}i.icon.codepen:before{content:\"\\F1CB\"}i.icon.jsfiddle:before{content:\"\\F1CC\"}i.icon.rebel:before{content:\"\\F1D0\"}i.icon.empire:before{content:\"\\F1D1\"}i.icon.git.square:before{content:\"\\F1D2\"}i.icon.git:before{content:\"\\F1D3\"}i.icon.hacker.news:before{content:\"\\F1D4\"}i.icon.tencent.weibo:before{content:\"\\F1D5\"}i.icon.qq:before{content:\"\\F1D6\"}i.icon.wechat:before{content:\"\\F1D7\"}i.icon.slideshare:before{content:\"\\F1E7\"}i.icon.twitch:before{content:\"\\F1E8\"}i.icon.yelp:before{content:\"\\F1E9\"}i.icon.lastfm:before{content:\"\\F202\"}i.icon.lastfm.square:before{content:\"\\F203\"}i.icon.ioxhost:before{content:\"\\F208\"}i.icon.angellist:before{content:\"\\F209\"}i.icon.meanpath:before{content:\"\\F20C\"}i.icon.buysellads:before{content:\"\\F20D\"}i.icon.connectdevelop:before{content:\"\\F20E\"}i.icon.dashcube:before{content:\"\\F210\"}i.icon.forumbee:before{content:\"\\F211\"}i.icon.leanpub:before{content:\"\\F212\"}i.icon.sellsy:before{content:\"\\F213\"}i.icon.shirtsinbulk:before{content:\"\\F214\"}i.icon.simplybuilt:before{content:\"\\F215\"}i.icon.skyatlas:before{content:\"\\F216\"}i.icon.facebook:before{content:\"\\F230\"}i.icon.pinterest:before{content:\"\\F231\"}i.icon.whatsapp:before{content:\"\\F232\"}i.icon.viacoin:before{content:\"\\F237\"}i.icon.medium:before{content:\"\\F23A\"}i.icon.y.combinator:before{content:\"\\F23B\"}i.icon.optinmonster:before{content:\"\\F23C\"}i.icon.opencart:before{content:\"\\F23D\"}i.icon.expeditedssl:before{content:\"\\F23E\"}i.icon.gg:before{content:\"\\F260\"}i.icon.gg.circle:before{content:\"\\F261\"}i.icon.tripadvisor:before{content:\"\\F262\"}i.icon.odnoklassniki:before{content:\"\\F263\"}i.icon.odnoklassniki.square:before{content:\"\\F264\"}i.icon.pocket:before{content:\"\\F265\"}i.icon.wikipedia:before{content:\"\\F266\"}i.icon.safari:before{content:\"\\F267\"}i.icon.chrome:before{content:\"\\F268\"}i.icon.firefox:before{content:\"\\F269\"}i.icon.opera:before{content:\"\\F26A\"}i.icon.internet.explorer:before{content:\"\\F26B\"}i.icon.contao:before{content:\"\\F26D\"}i.icon.\\35 00px:before{content:\"\\F26E\"}i.icon.amazon:before{content:\"\\F270\"}i.icon.houzz:before{content:\"\\F27C\"}i.icon.vimeo:before{content:\"\\F27D\"}i.icon.black.tie:before{content:\"\\F27E\"}i.icon.fonticons:before{content:\"\\F280\"}i.icon.reddit.alien:before{content:\"\\F281\"}i.icon.microsoft.edge:before{content:\"\\F282\"}i.icon.codiepie:before{content:\"\\F284\"}i.icon.modx:before{content:\"\\F285\"}i.icon.fort.awesome:before{content:\"\\F286\"}i.icon.product.hunt:before{content:\"\\F288\"}i.icon.mixcloud:before{content:\"\\F289\"}i.icon.scribd:before{content:\"\\F28A\"}i.icon.gitlab:before{content:\"\\F296\"}i.icon.wpbeginner:before{content:\"\\F297\"}i.icon.wpforms:before{content:\"\\F298\"}i.icon.envira.gallery:before{content:\"\\F299\"}i.icon.glide:before{content:\"\\F2A5\"}i.icon.glide.g:before{content:\"\\F2A6\"}i.icon.viadeo:before{content:\"\\F2A9\"}i.icon.viadeo.square:before{content:\"\\F2AA\"}i.icon.snapchat:before{content:\"\\F2AB\"}i.icon.snapchat.ghost:before{content:\"\\F2AC\"}i.icon.snapchat.square:before{content:\"\\F2AD\"}i.icon.pied.piper.hat:before{content:\"\\F2AE\"}i.icon.first.order:before{content:\"\\F2B0\"}i.icon.yoast:before{content:\"\\F2B1\"}i.icon.themeisle:before{content:\"\\F2B2\"}i.icon.google.plus.circle:before{content:\"\\F2B3\"}i.icon.font.awesome:before{content:\"\\F2B4\"}i.icon.like:before{content:\"\\F004\"}i.icon.favorite:before{content:\"\\F005\"}i.icon.video:before{content:\"\\F008\"}i.icon.check:before{content:\"\\F00C\"}i.icon.cancel:before,i.icon.close:before,i.icon.delete:before,i.icon.x:before{content:\"\\F00D\"}i.icon.magnify:before,i.icon.zoom.in:before{content:\"\\F00E\"}i.icon.shutdown:before{content:\"\\F011\"}i.icon.clock:before,i.icon.time:before{content:\"\\F017\"}i.icon.play.circle.outline:before{content:\"\\F01D\"}i.icon.headphone:before{content:\"\\F025\"}i.icon.camera:before{content:\"\\F030\"}i.icon.video.camera:before{content:\"\\F03D\"}i.icon.picture:before{content:\"\\F03E\"}i.icon.compose:before,i.icon.pencil:before{content:\"\\F040\"}i.icon.point:before{content:\"\\F041\"}i.icon.tint:before{content:\"\\F043\"}i.icon.signup:before{content:\"\\F044\"}i.icon.plus.circle:before{content:\"\\F055\"}i.icon.question.circle:before{content:\"\\F059\"}i.icon.dont:before{content:\"\\F05E\"}i.icon.minimize:before{content:\"\\F066\"}i.icon.add:before{content:\"\\F067\"}i.icon.attention:before,i.icon.exclamation.circle:before{content:\"\\F06A\"}i.icon.eye:before{content:\"\\F06E\"}i.icon.exclamation.triangle:before{content:\"\\F071\"}i.icon.shuffle:before{content:\"\\F074\"}i.icon.chat:before{content:\"\\F075\"}i.icon.cart:before,i.icon.shopping.cart:before{content:\"\\F07A\"}i.icon.bar.graph:before{content:\"\\F080\"}i.icon.key:before{content:\"\\F084\"}i.icon.cogs:before{content:\"\\F085\"}i.icon.discussions:before{content:\"\\F086\"}i.icon.like.outline:before{content:\"\\F087\"}i.icon.dislike.outline:before{content:\"\\F088\"}i.icon.heart.outline:before{content:\"\\F08A\"}i.icon.log.out:before{content:\"\\F08B\"}i.icon.thumb.tack:before{content:\"\\F08D\"}i.icon.winner:before{content:\"\\F091\"}i.icon.phone:before{content:\"\\F095\"}i.icon.bookmark.outline:before{content:\"\\F097\"}i.icon.phone.square:before{content:\"\\F098\"}i.icon.credit.card:before{content:\"\\F09D\"}i.icon.hdd.outline:before{content:\"\\F0A0\"}i.icon.bullhorn:before{content:\"\\F0A1\"}i.icon.bell.outline:before{content:\"\\F0A2\"}i.icon.hand.outline.right:before{content:\"\\F0A4\"}i.icon.hand.outline.left:before{content:\"\\F0A5\"}i.icon.hand.outline.up:before{content:\"\\F0A6\"}i.icon.hand.outline.down:before{content:\"\\F0A7\"}i.icon.globe:before{content:\"\\F0AC\"}i.icon.wrench:before{content:\"\\F0AD\"}i.icon.briefcase:before{content:\"\\F0B1\"}i.icon.group:before{content:\"\\F0C0\"}i.icon.chain:before,i.icon.linkify:before{content:\"\\F0C1\"}i.icon.flask:before{content:\"\\F0C3\"}i.icon.bars:before,i.icon.sidebar:before{content:\"\\F0C9\"}i.icon.list.ul:before{content:\"\\F0CA\"}i.icon.list.ol:before,i.icon.numbered.list:before{content:\"\\F0CB\"}i.icon.magic:before{content:\"\\F0D0\"}i.icon.truck:before{content:\"\\F0D1\"}i.icon.currency:before{content:\"\\F0D6\"}i.icon.dropdown:before,i.icon.triangle.down:before{content:\"\\F0D7\"}i.icon.triangle.up:before{content:\"\\F0D8\"}i.icon.triangle.left:before{content:\"\\F0D9\"}i.icon.triangle.right:before{content:\"\\F0DA\"}i.icon.envelope:before{content:\"\\F0E0\"}i.icon.conversation:before{content:\"\\F0E6\"}i.icon.rain:before{content:\"\\F0E9\"}i.icon.clipboard:before{content:\"\\F0EA\"}i.icon.lightbulb:before{content:\"\\F0EB\"}i.icon.bell:before{content:\"\\F0F3\"}i.icon.ambulance:before{content:\"\\F0F9\"}i.icon.medkit:before{content:\"\\F0FA\"}i.icon.fighter.jet:before{content:\"\\F0FB\"}i.icon.beer:before{content:\"\\F0FC\"}i.icon.plus.square:before{content:\"\\F0FE\"}i.icon.computer:before{content:\"\\F108\"}i.icon.circle.outline:before{content:\"\\F10C\"}i.icon.gamepad:before{content:\"\\F11B\"}i.icon.star.half.full:before{content:\"\\F123\"}i.icon.broken.chain:before{content:\"\\F127\"}i.icon.question:before{content:\"\\F128\"}i.icon.exclamation:before{content:\"\\F12A\"}i.icon.eraser:before{content:\"\\F12D\"}i.icon.microphone:before{content:\"\\F130\"}i.icon.microphone.slash:before{content:\"\\F131\"}i.icon.shield:before{content:\"\\F132\"}i.icon.target:before{content:\"\\F140\"}i.icon.play.circle:before{content:\"\\F144\"}i.icon.pencil.square:before{content:\"\\F14B\"}i.icon.eur:before{content:\"\\F153\"}i.icon.gbp:before{content:\"\\F154\"}i.icon.usd:before{content:\"\\F155\"}i.icon.inr:before{content:\"\\F156\"}i.icon.cny:before,i.icon.jpy:before,i.icon.rmb:before{content:\"\\F157\"}i.icon.rouble:before,i.icon.rub:before{content:\"\\F158\"}i.icon.krw:before{content:\"\\F159\"}i.icon.btc:before{content:\"\\F15A\"}i.icon.gratipay:before{content:\"\\F184\"}i.icon.zip:before{content:\"\\F187\"}i.icon.dot.circle.outline:before{content:\"\\F192\"}i.icon.try:before{content:\"\\F195\"}i.icon.graduation:before{content:\"\\F19D\"}i.icon.circle.outline:before{content:\"\\F1DB\"}i.icon.sliders:before{content:\"\\F1DE\"}i.icon.weixin:before{content:\"\\F1D7\"}i.icon.teletype:before,i.icon.tty:before{content:\"\\F1E4\"}i.icon.binoculars:before{content:\"\\F1E5\"}i.icon.power.cord:before{content:\"\\F1E6\"}i.icon.wi-fi:before{content:\"\\F1EB\"}i.icon.visa.card:before{content:\"\\F1F0\"}i.icon.mastercard.card:before{content:\"\\F1F1\"}i.icon.discover.card:before{content:\"\\F1F2\"}i.icon.american.express.card:before,i.icon.amex:before{content:\"\\F1F3\"}i.icon.stripe.card:before{content:\"\\F1F5\"}i.icon.bell.slash:before{content:\"\\F1F6\"}i.icon.bell.slash.outline:before{content:\"\\F1F7\"}i.icon.area.graph:before{content:\"\\F1FE\"}i.icon.pie.graph:before{content:\"\\F200\"}i.icon.line.graph:before{content:\"\\F201\"}i.icon.cc:before{content:\"\\F20A\"}i.icon.ils:before,i.icon.sheqel:before{content:\"\\F20B\"}i.icon.plus.cart:before{content:\"\\F217\"}i.icon.arrow.down.cart:before{content:\"\\F218\"}i.icon.detective:before{content:\"\\F21B\"}i.icon.venus:before{content:\"\\F221\"}i.icon.mars:before{content:\"\\F222\"}i.icon.mercury:before{content:\"\\F223\"}i.icon.intersex:before{content:\"\\F224\"}i.icon.female.homosexual:before,i.icon.venus.double:before{content:\"\\F226\"}i.icon.male.homosexual:before,i.icon.mars.double:before{content:\"\\F227\"}i.icon.venus.mars:before{content:\"\\F228\"}i.icon.mars.alternate:before,i.icon.mars.stroke:before{content:\"\\F229\"}i.icon.mars.stroke.vertical:before,i.icon.mars.vertical:before{content:\"\\F22A\"}i.icon.mars.horizontal:before,i.icon.mars.stroke.horizontal:before{content:\"\\F22B\"}i.icon.asexual:before{content:\"\\F22D\"}i.icon.facebook.official:before{content:\"\\F230\"}i.icon.user.plus:before{content:\"\\F234\"}i.icon.user.cancel:before,i.icon.user.close:before,i.icon.user.delete:before,i.icon.user.times:before,i.icon.user.x:before{content:\"\\F235\"}i.icon.bed:before{content:\"\\F236\"}i.icon.yc:before,i.icon.ycombinator:before{content:\"\\F23B\"}i.icon.battery.four:before{content:\"\\F240\"}i.icon.battery.three.quarters:before,i.icon.battery.three:before{content:\"\\F241\"}i.icon.battery.half:before,i.icon.battery.two:before{content:\"\\F242\"}i.icon.battery.one:before,i.icon.battery.quarter:before{content:\"\\F243\"}i.icon.battery.zero:before{content:\"\\F244\"}i.icon.i.cursor:before{content:\"\\F246\"}i.icon.japan.credit.bureau.card:before,i.icon.jcb:before{content:\"\\F24B\"}i.icon.diners.club.card:before{content:\"\\F24C\"}i.icon.balance:before{content:\"\\F24E\"}i.icon.hourglass.outline:before,i.icon.hourglass.zero:before{content:\"\\F250\"}i.icon.hourglass.one:before{content:\"\\F251\"}i.icon.hourglass.two:before{content:\"\\F252\"}i.icon.hourglass.three:before{content:\"\\F253\"}i.icon.hourglass.four:before{content:\"\\F254\"}i.icon.grab:before{content:\"\\F255\"}i.icon.hand.victory:before{content:\"\\F25B\"}i.icon.tm:before{content:\"\\F25C\"}i.icon.r.circle:before{content:\"\\F25D\"}i.icon.television:before{content:\"\\F26C\"}i.icon.five.hundred.pixels:before{content:\"\\F26E\"}i.icon.calendar.plus:before{content:\"\\F271\"}i.icon.calendar.minus:before{content:\"\\F272\"}i.icon.calendar.times:before{content:\"\\F273\"}i.icon.calendar.check:before{content:\"\\F274\"}i.icon.factory:before{content:\"\\F275\"}i.icon.commenting:before{content:\"\\F27A\"}i.icon.commenting.outline:before{content:\"\\F27B\"}i.icon.edge:before,i.icon.ms.edge:before{content:\"\\F282\"}i.icon.wordpress.beginner:before{content:\"\\F297\"}i.icon.wordpress.forms:before{content:\"\\F298\"}i.icon.envira:before{content:\"\\F299\"}i.icon.question.circle.outline:before{content:\"\\F29C\"}i.icon.ald:before,i.icon.als:before,i.icon.assistive.listening.devices:before{content:\"\\F2A2\"}i.icon.asl.interpreting:before{content:\"\\F2A3\"}i.icon.deaf:before{content:\"\\F2A4\"}i.icon.american.sign.language.interpreting:before{content:\"\\F2A3\"}i.icon.hard.of.hearing:before{content:\"\\F2A4\"}i.icon.signing:before{content:\"\\F2A7\"}i.icon.new.pied.piper:before{content:\"\\F2AE\"}i.icon.theme.isle:before{content:\"\\F2B2\"}i.icon.google.plus.official:before{content:\"\\F2B3\"}i.icon.fa:before{content:\"\\F2B4\"}", ""]);
	
	// exports


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Icon\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */@font-face{font-family:Icons;src:url(//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.eot);src:url(//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.eot?#iefix) format('embedded-opentype'),url(//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.woff2) format('woff2'),url(//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.woff) format('woff'),url(//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.ttf) format('truetype'),url(//interaktiv.tagesanzeiger.ch/static/semantic/assets/fonts/icons.svg#icons) format('svg');font-style:normal;font-weight:400;font-variant:normal;text-decoration:inherit;text-transform:none}i.icon{display:inline-block;opacity:1;margin:0 .25rem 0 0;width:1.18em;height:1em;font-family:Icons;font-style:normal;font-weight:400;text-decoration:inherit;text-align:center;speak:none;font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-font-smoothing:antialiased;-webkit-backface-visibility:hidden;backface-visibility:hidden}i.icon:before{background:0 0!important}i.icon.loading{height:1em;line-height:1;-webkit-animation:icon-loading 2s linear infinite;animation:icon-loading 2s linear infinite}@-webkit-keyframes icon-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes icon-loading{0%{-webkit-transform:rotate(0);transform:rotate(0)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}i.emphasized.icon,i.icon.active,i.icon.hover{opacity:1!important}i.disabled.icon{opacity:.45!important}i.fitted.icon{width:auto;margin:0}i.link.icon,i.link.icons{cursor:pointer;opacity:.8;-webkit-transition:opacity .1s ease;transition:opacity .1s ease}i.link.icon:hover,i.link.icons:hover{opacity:1!important}i.circular.icon{border-radius:500em!important;line-height:1!important;padding:.5em!important;box-shadow:inset 0 0 0 .1em rgba(0,0,0,.1);width:2em!important;height:2em!important}i.circular.inverted.icon{border:none;box-shadow:none}i.flipped.icon,i.horizontally.flipped.icon{-webkit-transform:scaleX(-1);transform:scaleX(-1)}i.vertically.flipped.icon{-webkit-transform:scaleY(-1);transform:scaleY(-1)}i.clockwise.rotated.icon,i.right.rotated.icon,i.rotated.icon{-webkit-transform:rotate(90deg);transform:rotate(90deg)}i.counterclockwise.rotated.icon,i.left.rotated.icon{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}i.bordered.icon{line-height:1;vertical-align:baseline;width:2em;height:2em;padding:.5em .41em!important;box-shadow:inset 0 0 0 .1em rgba(0,0,0,.1)}i.bordered.inverted.icon{border:none;box-shadow:none}i.inverted.bordered.icon,i.inverted.circular.icon{background-color:#1b1c1d!important;color:#fff!important}i.inverted.icon{color:#fff}i.red.icon{color:#e23c4e!important}i.inverted.red.icon{color:#f77482!important}i.inverted.bordered.red.icon,i.inverted.circular.red.icon{background-color:#e23c4e!important;color:#fff!important}i.orange.icon{color:#f8813d!important}i.inverted.orange.icon{color:#ff8945!important}i.inverted.bordered.orange.icon,i.inverted.circular.orange.icon{background-color:#f8813d!important;color:#fff!important}i.inverted.yellow.icon,i.yellow.icon{color:#ffca18!important}i.inverted.bordered.yellow.icon,i.inverted.circular.yellow.icon{background-color:#ffca18!important;color:#fff!important}i.olive.icon{color:#456558!important}i.inverted.olive.icon{color:#52a583!important}i.inverted.bordered.olive.icon,i.inverted.circular.olive.icon{background-color:#456558!important;color:#fff!important}i.green.icon{color:#54af71!important}i.inverted.green.icon{color:#68ce88!important}i.inverted.bordered.green.icon,i.inverted.circular.green.icon{background-color:#54af71!important;color:#fff!important}i.teal.icon{color:#00a1ca!important}i.inverted.teal.icon{color:#00cafd!important}i.inverted.bordered.teal.icon,i.inverted.circular.teal.icon{background-color:#00a1ca!important;color:#fff!important}i.blue.icon{color:#1d5f82!important}i.inverted.blue.icon{color:#1782bb!important}i.inverted.bordered.blue.icon,i.inverted.circular.blue.icon{background-color:#1d5f82!important;color:#fff!important}i.violet.icon{color:#525394!important}i.inverted.violet.icon{color:#6d6ec6!important}i.inverted.bordered.violet.icon,i.inverted.circular.violet.icon{background-color:#525394!important;color:#fff!important}i.purple.icon{color:#ad427f!important}i.inverted.purple.icon{color:#d864a6!important}i.inverted.bordered.purple.icon,i.inverted.circular.purple.icon{background-color:#ad427f!important;color:#fff!important}i.pink.icon{color:#e03997!important}i.inverted.pink.icon{color:#f670bb!important}i.inverted.bordered.pink.icon,i.inverted.circular.pink.icon{background-color:#e03997!important;color:#fff!important}i.brown.icon{color:#a67a00!important}i.inverted.brown.icon{color:#f3b200!important}i.inverted.bordered.brown.icon,i.inverted.circular.brown.icon{background-color:#a67a00!important;color:#fff!important}i.grey.icon{color:#5a686d!important}i.inverted.grey.icon{color:#7f8f95!important}i.inverted.bordered.grey.icon,i.inverted.circular.grey.icon{background-color:#5a686d!important;color:#fff!important}i.black.icon{color:#1b1c1d!important}i.inverted.black.icon{color:#545454!important}i.inverted.bordered.black.icon,i.inverted.circular.black.icon{background-color:#1b1c1d!important;color:#fff!important}i.mini.icon,i.mini.icons{line-height:1;font-size:.4em}i.tiny.icon,i.tiny.icons{line-height:1;font-size:.5em}i.small.icon,i.small.icons{line-height:1;font-size:.75em}i.icon,i.icons{font-size:1em}i.large.icon,i.large.icons{line-height:1;vertical-align:middle;font-size:1.5em}i.big.icon,i.big.icons{line-height:1;vertical-align:middle;font-size:2em}i.huge.icon,i.huge.icons{line-height:1;vertical-align:middle;font-size:4em}i.massive.icon,i.massive.icons{line-height:1;vertical-align:middle;font-size:8em}i.icons{display:inline-block;position:relative;line-height:1}i.icons .icon{position:absolute;top:50%;left:50%;-webkit-transform:translateX(-50%) translateY(-50%);transform:translateX(-50%) translateY(-50%);margin:0}i.icons .icon:first-child{position:static;width:auto;height:auto;vertical-align:top;-webkit-transform:none;transform:none;margin-right:.25rem}i.icons .corner.icon{top:auto;left:auto;right:0;bottom:0;-webkit-transform:none;transform:none;font-size:.45em;text-shadow:-1px -1px 0 #fff,1px -1px 0 #fff,-1px 1px 0 #fff,1px 1px 0 #fff}i.icons .inverted.corner.icon{text-shadow:-1px -1px 0 #1b1c1d,1px -1px 0 #1b1c1d,-1px 1px 0 #1b1c1d,1px 1px 0 #1b1c1d}i.icon.search:before{content:\"\\F002\"}i.icon.mail.outline:before{content:\"\\F003\"}i.icon.signal:before{content:\"\\F012\"}i.icon.setting:before{content:\"\\F013\"}i.icon.home:before{content:\"\\F015\"}i.icon.inbox:before{content:\"\\F01C\"}i.icon.browser:before{content:\"\\F022\"}i.icon.tag:before{content:\"\\F02B\"}i.icon.tags:before{content:\"\\F02C\"}i.icon.image:before{content:\"\\F03E\"}i.icon.calendar:before{content:\"\\F073\"}i.icon.comment:before{content:\"\\F075\"}i.icon.shop:before{content:\"\\F07A\"}i.icon.privacy:before{content:\"\\F084\"}i.icon.settings:before{content:\"\\F085\"}i.icon.comments:before{content:\"\\F086\"}i.icon.external:before{content:\"\\F08E\"}i.icon.trophy:before{content:\"\\F091\"}i.icon.payment:before{content:\"\\F09D\"}i.icon.feed:before{content:\"\\F09E\"}i.icon.alarm.outline:before{content:\"\\F0A2\"}i.icon.tasks:before{content:\"\\F0AE\"}i.icon.cloud:before{content:\"\\F0C2\"}i.icon.lab:before{content:\"\\F0C3\"}i.icon.mail:before{content:\"\\F0E0\"}i.icon.dashboard:before{content:\"\\F0E4\"}i.icon.comment.outline:before{content:\"\\F0E5\"}i.icon.comments.outline:before{content:\"\\F0E6\"}i.icon.sitemap:before{content:\"\\F0E8\"}i.icon.idea:before{content:\"\\F0EB\"}i.icon.alarm:before{content:\"\\F0F3\"}i.icon.terminal:before{content:\"\\F120\"}i.icon.code:before{content:\"\\F121\"}i.icon.protect:before{content:\"\\F132\"}i.icon.calendar.outline:before{content:\"\\F133\"}i.icon.ticket:before{content:\"\\F145\"}i.icon.external.square:before{content:\"\\F14C\"}i.icon.bug:before{content:\"\\F188\"}i.icon.mail.square:before{content:\"\\F199\"}i.icon.history:before{content:\"\\F1DA\"}i.icon.options:before{content:\"\\F1DE\"}i.icon.text.telephone:before{content:\"\\F1E4\"}i.icon.find:before{content:\"\\F1E5\"}i.icon.wifi:before{content:\"\\F1EB\"}i.icon.alarm.mute:before{content:\"\\F1F6\"}i.icon.alarm.mute.outline:before{content:\"\\F1F7\"}i.icon.copyright:before{content:\"\\F1F9\"}i.icon.at:before{content:\"\\F1FA\"}i.icon.eyedropper:before{content:\"\\F1FB\"}i.icon.paint.brush:before{content:\"\\F1FC\"}i.icon.heartbeat:before{content:\"\\F21E\"}i.icon.mouse.pointer:before{content:\"\\F245\"}i.icon.hourglass.empty:before{content:\"\\F250\"}i.icon.hourglass.start:before{content:\"\\F251\"}i.icon.hourglass.half:before{content:\"\\F252\"}i.icon.hourglass.end:before{content:\"\\F253\"}i.icon.hourglass.full:before{content:\"\\F254\"}i.icon.hand.pointer:before{content:\"\\F25A\"}i.icon.trademark:before{content:\"\\F25C\"}i.icon.registered:before{content:\"\\F25D\"}i.icon.creative.commons:before{content:\"\\F25E\"}i.icon.add.to.calendar:before{content:\"\\F271\"}i.icon.remove.from.calendar:before{content:\"\\F272\"}i.icon.delete.calendar:before{content:\"\\F273\"}i.icon.checked.calendar:before{content:\"\\F274\"}i.icon.industry:before{content:\"\\F275\"}i.icon.shopping.bag:before{content:\"\\F290\"}i.icon.shopping.basket:before{content:\"\\F291\"}i.icon.hashtag:before{content:\"\\F292\"}i.icon.percent:before{content:\"\\F295\"}i.icon.wait:before{content:\"\\F017\"}i.icon.download:before{content:\"\\F019\"}i.icon.repeat:before{content:\"\\F01E\"}i.icon.refresh:before{content:\"\\F021\"}i.icon.lock:before{content:\"\\F023\"}i.icon.bookmark:before{content:\"\\F02E\"}i.icon.print:before{content:\"\\F02F\"}i.icon.write:before{content:\"\\F040\"}i.icon.adjust:before{content:\"\\F042\"}i.icon.theme:before{content:\"\\F043\"}i.icon.edit:before{content:\"\\F044\"}i.icon.external.share:before{content:\"\\F045\"}i.icon.ban:before{content:\"\\F05E\"}i.icon.mail.forward:before,i.icon.share:before{content:\"\\F064\"}i.icon.expand:before{content:\"\\F065\"}i.icon.compress:before{content:\"\\F066\"}i.icon.unhide:before{content:\"\\F06E\"}i.icon.hide:before{content:\"\\F070\"}i.icon.random:before{content:\"\\F074\"}i.icon.retweet:before{content:\"\\F079\"}i.icon.sign.out:before{content:\"\\F08B\"}i.icon.pin:before{content:\"\\F08D\"}i.icon.sign.in:before{content:\"\\F090\"}i.icon.upload:before{content:\"\\F093\"}i.icon.call:before{content:\"\\F095\"}i.icon.remove.bookmark:before{content:\"\\F097\"}i.icon.call.square:before{content:\"\\F098\"}i.icon.unlock:before{content:\"\\F09C\"}i.icon.configure:before{content:\"\\F0AD\"}i.icon.filter:before{content:\"\\F0B0\"}i.icon.wizard:before{content:\"\\F0D0\"}i.icon.undo:before{content:\"\\F0E2\"}i.icon.exchange:before{content:\"\\F0EC\"}i.icon.cloud.download:before{content:\"\\F0ED\"}i.icon.cloud.upload:before{content:\"\\F0EE\"}i.icon.reply:before{content:\"\\F112\"}i.icon.reply.all:before{content:\"\\F122\"}i.icon.erase:before{content:\"\\F12D\"}i.icon.unlock.alternate:before{content:\"\\F13E\"}i.icon.write.square:before{content:\"\\F14B\"}i.icon.share.square:before{content:\"\\F14D\"}i.icon.archive:before{content:\"\\F187\"}i.icon.translate:before{content:\"\\F1AB\"}i.icon.recycle:before{content:\"\\F1B8\"}i.icon.send:before{content:\"\\F1D8\"}i.icon.send.outline:before{content:\"\\F1D9\"}i.icon.share.alternate:before{content:\"\\F1E0\"}i.icon.share.alternate.square:before{content:\"\\F1E1\"}i.icon.add.to.cart:before{content:\"\\F217\"}i.icon.in.cart:before{content:\"\\F218\"}i.icon.add.user:before{content:\"\\F234\"}i.icon.remove.user:before{content:\"\\F235\"}i.icon.object.group:before{content:\"\\F247\"}i.icon.object.ungroup:before{content:\"\\F248\"}i.icon.clone:before{content:\"\\F24D\"}i.icon.talk:before{content:\"\\F27A\"}i.icon.talk.outline:before{content:\"\\F27B\"}i.icon.help.circle:before{content:\"\\F059\"}i.icon.info.circle:before{content:\"\\F05A\"}i.icon.warning.circle:before{content:\"\\F06A\"}i.icon.warning.sign:before{content:\"\\F071\"}i.icon.announcement:before{content:\"\\F0A1\"}i.icon.help:before{content:\"\\F128\"}i.icon.info:before{content:\"\\F129\"}i.icon.warning:before{content:\"\\F12A\"}i.icon.birthday:before{content:\"\\F1FD\"}i.icon.help.circle.outline:before{content:\"\\F29C\"}i.icon.user:before{content:\"\\F007\"}i.icon.users:before{content:\"\\F0C0\"}i.icon.doctor:before{content:\"\\F0F0\"}i.icon.handicap:before{content:\"\\F193\"}i.icon.student:before{content:\"\\F19D\"}i.icon.child:before{content:\"\\F1AE\"}i.icon.spy:before{content:\"\\F21B\"}i.icon.female:before{content:\"\\F182\"}i.icon.male:before{content:\"\\F183\"}i.icon.woman:before{content:\"\\F221\"}i.icon.man:before{content:\"\\F222\"}i.icon.non.binary.transgender:before{content:\"\\F223\"}i.icon.intergender:before{content:\"\\F224\"}i.icon.transgender:before{content:\"\\F225\"}i.icon.lesbian:before{content:\"\\F226\"}i.icon.gay:before{content:\"\\F227\"}i.icon.heterosexual:before{content:\"\\F228\"}i.icon.other.gender:before{content:\"\\F229\"}i.icon.other.gender.vertical:before{content:\"\\F22A\"}i.icon.other.gender.horizontal:before{content:\"\\F22B\"}i.icon.neuter:before{content:\"\\F22C\"}i.icon.genderless:before{content:\"\\F22D\"}i.icon.universal.access:before{content:\"\\F29A\"}i.icon.wheelchair:before{content:\"\\F29B\"}i.icon.blind:before{content:\"\\F29D\"}i.icon.audio.description:before{content:\"\\F29E\"}i.icon.volume.control.phone:before{content:\"\\F2A0\"}i.icon.braille:before{content:\"\\F2A1\"}i.icon.asl:before{content:\"\\F2A3\"}i.icon.assistive.listening.systems:before{content:\"\\F2A2\"}i.icon.deafness:before{content:\"\\F2A4\"}i.icon.sign.language:before{content:\"\\F2A7\"}i.icon.low.vision:before{content:\"\\F2A8\"}i.icon.block.layout:before{content:\"\\F009\"}i.icon.grid.layout:before{content:\"\\F00A\"}i.icon.list.layout:before{content:\"\\F00B\"}i.icon.zoom:before{content:\"\\F00E\"}i.icon.zoom.out:before{content:\"\\F010\"}i.icon.resize.vertical:before{content:\"\\F07D\"}i.icon.resize.horizontal:before{content:\"\\F07E\"}i.icon.maximize:before{content:\"\\F0B2\"}i.icon.crop:before{content:\"\\F125\"}i.icon.cocktail:before{content:\"\\F000\"}i.icon.road:before{content:\"\\F018\"}i.icon.flag:before{content:\"\\F024\"}i.icon.book:before{content:\"\\F02D\"}i.icon.gift:before{content:\"\\F06B\"}i.icon.leaf:before{content:\"\\F06C\"}i.icon.fire:before{content:\"\\F06D\"}i.icon.plane:before{content:\"\\F072\"}i.icon.magnet:before{content:\"\\F076\"}i.icon.lemon:before{content:\"\\F094\"}i.icon.world:before{content:\"\\F0AC\"}i.icon.travel:before{content:\"\\F0B1\"}i.icon.shipping:before{content:\"\\F0D1\"}i.icon.money:before{content:\"\\F0D6\"}i.icon.legal:before{content:\"\\F0E3\"}i.icon.lightning:before{content:\"\\F0E7\"}i.icon.umbrella:before{content:\"\\F0E9\"}i.icon.treatment:before{content:\"\\F0F1\"}i.icon.suitcase:before{content:\"\\F0F2\"}i.icon.bar:before{content:\"\\F0FC\"}i.icon.flag.outline:before{content:\"\\F11D\"}i.icon.flag.checkered:before{content:\"\\F11E\"}i.icon.puzzle:before{content:\"\\F12E\"}i.icon.fire.extinguisher:before{content:\"\\F134\"}i.icon.rocket:before{content:\"\\F135\"}i.icon.anchor:before{content:\"\\F13D\"}i.icon.bullseye:before{content:\"\\F140\"}i.icon.sun:before{content:\"\\F185\"}i.icon.moon:before{content:\"\\F186\"}i.icon.fax:before{content:\"\\F1AC\"}i.icon.life.ring:before{content:\"\\F1CD\"}i.icon.bomb:before{content:\"\\F1E2\"}i.icon.soccer:before{content:\"\\F1E3\"}i.icon.calculator:before{content:\"\\F1EC\"}i.icon.diamond:before{content:\"\\F219\"}i.icon.sticky.note:before{content:\"\\F249\"}i.icon.sticky.note.outline:before{content:\"\\F24A\"}i.icon.law:before{content:\"\\F24E\"}i.icon.hand.peace:before{content:\"\\F25B\"}i.icon.hand.rock:before{content:\"\\F255\"}i.icon.hand.paper:before{content:\"\\F256\"}i.icon.hand.scissors:before{content:\"\\F257\"}i.icon.hand.lizard:before{content:\"\\F258\"}i.icon.hand.spock:before{content:\"\\F259\"}i.icon.tv:before{content:\"\\F26C\"}i.icon.crosshairs:before{content:\"\\F05B\"}i.icon.asterisk:before{content:\"\\F069\"}i.icon.square.outline:before{content:\"\\F096\"}i.icon.certificate:before{content:\"\\F0A3\"}i.icon.square:before{content:\"\\F0C8\"}i.icon.quote.left:before{content:\"\\F10D\"}i.icon.quote.right:before{content:\"\\F10E\"}i.icon.spinner:before{content:\"\\F110\"}i.icon.circle:before{content:\"\\F111\"}i.icon.ellipsis.horizontal:before{content:\"\\F141\"}i.icon.ellipsis.vertical:before{content:\"\\F142\"}i.icon.cube:before{content:\"\\F1B2\"}i.icon.cubes:before{content:\"\\F1B3\"}i.icon.circle.notched:before{content:\"\\F1CE\"}i.icon.circle.thin:before{content:\"\\F1DB\"}i.icon.checkmark:before{content:\"\\F00C\"}i.icon.remove:before{content:\"\\F00D\"}i.icon.checkmark.box:before{content:\"\\F046\"}i.icon.move:before{content:\"\\F047\"}i.icon.add.circle:before{content:\"\\F055\"}i.icon.minus.circle:before{content:\"\\F056\"}i.icon.remove.circle:before{content:\"\\F057\"}i.icon.check.circle:before{content:\"\\F058\"}i.icon.remove.circle.outline:before{content:\"\\F05C\"}i.icon.check.circle.outline:before{content:\"\\F05D\"}i.icon.plus:before{content:\"\\F067\"}i.icon.minus:before{content:\"\\F068\"}i.icon.add.square:before{content:\"\\F0FE\"}i.icon.radio:before{content:\"\\F10C\"}i.icon.minus.square:before{content:\"\\F146\"}i.icon.minus.square.outline:before{content:\"\\F147\"}i.icon.check.square:before{content:\"\\F14A\"}i.icon.selected.radio:before{content:\"\\F192\"}i.icon.plus.square.outline:before{content:\"\\F196\"}i.icon.toggle.off:before{content:\"\\F204\"}i.icon.toggle.on:before{content:\"\\F205\"}i.icon.film:before{content:\"\\F008\"}i.icon.sound:before{content:\"\\F025\"}i.icon.photo:before{content:\"\\F030\"}i.icon.bar.chart:before{content:\"\\F080\"}i.icon.camera.retro:before{content:\"\\F083\"}i.icon.newspaper:before{content:\"\\F1EA\"}i.icon.area.chart:before{content:\"\\F1FE\"}i.icon.pie.chart:before{content:\"\\F200\"}i.icon.line.chart:before{content:\"\\F201\"}i.icon.arrow.circle.outline.down:before{content:\"\\F01A\"}i.icon.arrow.circle.outline.up:before{content:\"\\F01B\"}i.icon.chevron.left:before{content:\"\\F053\"}i.icon.chevron.right:before{content:\"\\F054\"}i.icon.arrow.left:before{content:\"\\F060\"}i.icon.arrow.right:before{content:\"\\F061\"}i.icon.arrow.up:before{content:\"\\F062\"}i.icon.arrow.down:before{content:\"\\F063\"}i.icon.chevron.up:before{content:\"\\F077\"}i.icon.chevron.down:before{content:\"\\F078\"}i.icon.pointing.right:before{content:\"\\F0A4\"}i.icon.pointing.left:before{content:\"\\F0A5\"}i.icon.pointing.up:before{content:\"\\F0A6\"}i.icon.pointing.down:before{content:\"\\F0A7\"}i.icon.arrow.circle.left:before{content:\"\\F0A8\"}i.icon.arrow.circle.right:before{content:\"\\F0A9\"}i.icon.arrow.circle.up:before{content:\"\\F0AA\"}i.icon.arrow.circle.down:before{content:\"\\F0AB\"}i.icon.caret.down:before{content:\"\\F0D7\"}i.icon.caret.up:before{content:\"\\F0D8\"}i.icon.caret.left:before{content:\"\\F0D9\"}i.icon.caret.right:before{content:\"\\F0DA\"}i.icon.angle.double.left:before{content:\"\\F100\"}i.icon.angle.double.right:before{content:\"\\F101\"}i.icon.angle.double.up:before{content:\"\\F102\"}i.icon.angle.double.down:before{content:\"\\F103\"}i.icon.angle.left:before{content:\"\\F104\"}i.icon.angle.right:before{content:\"\\F105\"}i.icon.angle.up:before{content:\"\\F106\"}i.icon.angle.down:before{content:\"\\F107\"}i.icon.chevron.circle.left:before{content:\"\\F137\"}i.icon.chevron.circle.right:before{content:\"\\F138\"}i.icon.chevron.circle.up:before{content:\"\\F139\"}i.icon.chevron.circle.down:before{content:\"\\F13A\"}i.icon.toggle.down:before{content:\"\\F150\"}i.icon.toggle.up:before{content:\"\\F151\"}i.icon.toggle.right:before{content:\"\\F152\"}i.icon.long.arrow.down:before{content:\"\\F175\"}i.icon.long.arrow.up:before{content:\"\\F176\"}i.icon.long.arrow.left:before{content:\"\\F177\"}i.icon.long.arrow.right:before{content:\"\\F178\"}i.icon.arrow.circle.outline.right:before{content:\"\\F18E\"}i.icon.arrow.circle.outline.left:before{content:\"\\F190\"}i.icon.toggle.left:before{content:\"\\F191\"}i.icon.tablet:before{content:\"\\F10A\"}i.icon.mobile:before{content:\"\\F10B\"}i.icon.battery.full:before{content:\"\\F240\"}i.icon.battery.high:before{content:\"\\F241\"}i.icon.battery.medium:before{content:\"\\F242\"}i.icon.battery.low:before{content:\"\\F243\"}i.icon.battery.empty:before{content:\"\\F244\"}i.icon.power:before{content:\"\\F011\"}i.icon.trash.outline:before{content:\"\\F014\"}i.icon.disk.outline:before{content:\"\\F0A0\"}i.icon.desktop:before{content:\"\\F108\"}i.icon.laptop:before{content:\"\\F109\"}i.icon.game:before{content:\"\\F11B\"}i.icon.keyboard:before{content:\"\\F11C\"}i.icon.plug:before{content:\"\\F1E6\"}i.icon.trash:before{content:\"\\F1F8\"}i.icon.file.outline:before{content:\"\\F016\"}i.icon.folder:before{content:\"\\F07B\"}i.icon.folder.open:before{content:\"\\F07C\"}i.icon.file.text.outline:before{content:\"\\F0F6\"}i.icon.folder.outline:before{content:\"\\F114\"}i.icon.folder.open.outline:before{content:\"\\F115\"}i.icon.level.up:before{content:\"\\F148\"}i.icon.level.down:before{content:\"\\F149\"}i.icon.file:before{content:\"\\F15B\"}i.icon.file.text:before{content:\"\\F15C\"}i.icon.file.pdf.outline:before{content:\"\\F1C1\"}i.icon.file.word.outline:before{content:\"\\F1C2\"}i.icon.file.excel.outline:before{content:\"\\F1C3\"}i.icon.file.powerpoint.outline:before{content:\"\\F1C4\"}i.icon.file.image.outline:before{content:\"\\F1C5\"}i.icon.file.archive.outline:before{content:\"\\F1C6\"}i.icon.file.audio.outline:before{content:\"\\F1C7\"}i.icon.file.video.outline:before{content:\"\\F1C8\"}i.icon.file.code.outline:before{content:\"\\F1C9\"}i.icon.qrcode:before{content:\"\\F029\"}i.icon.barcode:before{content:\"\\F02A\"}i.icon.rss:before{content:\"\\F09E\"}i.icon.fork:before{content:\"\\F126\"}i.icon.html5:before{content:\"\\F13B\"}i.icon.css3:before{content:\"\\F13C\"}i.icon.rss.square:before{content:\"\\F143\"}i.icon.openid:before{content:\"\\F19B\"}i.icon.database:before{content:\"\\F1C0\"}i.icon.server:before{content:\"\\F233\"}i.icon.usb:before{content:\"\\F287\"}i.icon.bluetooth:before{content:\"\\F293\"}i.icon.bluetooth.alternative:before{content:\"\\F294\"}i.icon.heart:before{content:\"\\F004\"}i.icon.star:before{content:\"\\F005\"}i.icon.empty.star:before{content:\"\\F006\"}i.icon.thumbs.outline.up:before{content:\"\\F087\"}i.icon.thumbs.outline.down:before{content:\"\\F088\"}i.icon.star.half:before{content:\"\\F089\"}i.icon.empty.heart:before{content:\"\\F08A\"}i.icon.smile:before{content:\"\\F118\"}i.icon.frown:before{content:\"\\F119\"}i.icon.meh:before{content:\"\\F11A\"}i.icon.star.half.empty:before{content:\"\\F123\"}i.icon.thumbs.up:before{content:\"\\F164\"}i.icon.thumbs.down:before{content:\"\\F165\"}i.icon.music:before{content:\"\\F001\"}i.icon.video.play.outline:before{content:\"\\F01D\"}i.icon.volume.off:before{content:\"\\F026\"}i.icon.volume.down:before{content:\"\\F027\"}i.icon.volume.up:before{content:\"\\F028\"}i.icon.record:before{content:\"\\F03D\"}i.icon.step.backward:before{content:\"\\F048\"}i.icon.fast.backward:before{content:\"\\F049\"}i.icon.backward:before{content:\"\\F04A\"}i.icon.play:before{content:\"\\F04B\"}i.icon.pause:before{content:\"\\F04C\"}i.icon.stop:before{content:\"\\F04D\"}i.icon.forward:before{content:\"\\F04E\"}i.icon.fast.forward:before{content:\"\\F050\"}i.icon.step.forward:before{content:\"\\F051\"}i.icon.eject:before{content:\"\\F052\"}i.icon.unmute:before{content:\"\\F130\"}i.icon.mute:before{content:\"\\F131\"}i.icon.video.play:before{content:\"\\F144\"}i.icon.closed.captioning:before{content:\"\\F20A\"}i.icon.pause.circle:before{content:\"\\F28B\"}i.icon.pause.circle.outline:before{content:\"\\F28C\"}i.icon.stop.circle:before{content:\"\\F28D\"}i.icon.stop.circle.outline:before{content:\"\\F28E\"}i.icon.marker:before{content:\"\\F041\"}i.icon.coffee:before{content:\"\\F0F4\"}i.icon.food:before{content:\"\\F0F5\"}i.icon.building.outline:before{content:\"\\F0F7\"}i.icon.hospital:before{content:\"\\F0F8\"}i.icon.emergency:before{content:\"\\F0F9\"}i.icon.first.aid:before{content:\"\\F0FA\"}i.icon.military:before{content:\"\\F0FB\"}i.icon.h:before{content:\"\\F0FD\"}i.icon.location.arrow:before{content:\"\\F124\"}i.icon.compass:before{content:\"\\F14E\"}i.icon.space.shuttle:before{content:\"\\F197\"}i.icon.university:before{content:\"\\F19C\"}i.icon.building:before{content:\"\\F1AD\"}i.icon.paw:before{content:\"\\F1B0\"}i.icon.spoon:before{content:\"\\F1B1\"}i.icon.car:before{content:\"\\F1B9\"}i.icon.taxi:before{content:\"\\F1BA\"}i.icon.tree:before{content:\"\\F1BB\"}i.icon.bicycle:before{content:\"\\F206\"}i.icon.bus:before{content:\"\\F207\"}i.icon.ship:before{content:\"\\F21A\"}i.icon.motorcycle:before{content:\"\\F21C\"}i.icon.street.view:before{content:\"\\F21D\"}i.icon.hotel:before{content:\"\\F236\"}i.icon.train:before{content:\"\\F238\"}i.icon.subway:before{content:\"\\F239\"}i.icon.map.pin:before{content:\"\\F276\"}i.icon.map.signs:before{content:\"\\F277\"}i.icon.map.outline:before{content:\"\\F278\"}i.icon.map:before{content:\"\\F279\"}i.icon.table:before{content:\"\\F0CE\"}i.icon.columns:before{content:\"\\F0DB\"}i.icon.sort:before{content:\"\\F0DC\"}i.icon.sort.descending:before{content:\"\\F0DD\"}i.icon.sort.ascending:before{content:\"\\F0DE\"}i.icon.sort.alphabet.ascending:before{content:\"\\F15D\"}i.icon.sort.alphabet.descending:before{content:\"\\F15E\"}i.icon.sort.content.ascending:before{content:\"\\F160\"}i.icon.sort.content.descending:before{content:\"\\F161\"}i.icon.sort.numeric.ascending:before{content:\"\\F162\"}i.icon.sort.numeric.descending:before{content:\"\\F163\"}i.icon.font:before{content:\"\\F031\"}i.icon.bold:before{content:\"\\F032\"}i.icon.italic:before{content:\"\\F033\"}i.icon.text.height:before{content:\"\\F034\"}i.icon.text.width:before{content:\"\\F035\"}i.icon.align.left:before{content:\"\\F036\"}i.icon.align.center:before{content:\"\\F037\"}i.icon.align.right:before{content:\"\\F038\"}i.icon.align.justify:before{content:\"\\F039\"}i.icon.list:before{content:\"\\F03A\"}i.icon.outdent:before{content:\"\\F03B\"}i.icon.indent:before{content:\"\\F03C\"}i.icon.cut:before{content:\"\\F0C4\"}i.icon.copy:before{content:\"\\F0C5\"}i.icon.attach:before{content:\"\\F0C6\"}i.icon.save:before{content:\"\\F0C7\"}i.icon.content:before{content:\"\\F0C9\"}i.icon.unordered.list:before{content:\"\\F0CA\"}i.icon.ordered.list:before{content:\"\\F0CB\"}i.icon.strikethrough:before{content:\"\\F0CC\"}i.icon.underline:before{content:\"\\F0CD\"}i.icon.paste:before{content:\"\\F0EA\"}i.icon.unlinkify:before{content:\"\\F127\"}i.icon.superscript:before{content:\"\\F12B\"}i.icon.subscript:before{content:\"\\F12C\"}i.icon.header:before{content:\"\\F1DC\"}i.icon.paragraph:before{content:\"\\F1DD\"}i.icon.text.cursor:before{content:\"\\F246\"}i.icon.euro:before{content:\"\\F153\"}i.icon.pound:before{content:\"\\F154\"}i.icon.dollar:before{content:\"\\F155\"}i.icon.rupee:before{content:\"\\F156\"}i.icon.yen:before{content:\"\\F157\"}i.icon.ruble:before{content:\"\\F158\"}i.icon.won:before{content:\"\\F159\"}i.icon.bitcoin:before{content:\"\\F15A\"}i.icon.lira:before{content:\"\\F195\"}i.icon.shekel:before{content:\"\\F20B\"}i.icon.paypal:before{content:\"\\F1ED\"}i.icon.google.wallet:before{content:\"\\F1EE\"}i.icon.visa:before{content:\"\\F1F0\"}i.icon.mastercard:before{content:\"\\F1F1\"}i.icon.discover:before{content:\"\\F1F2\"}i.icon.american.express:before{content:\"\\F1F3\"}i.icon.paypal.card:before{content:\"\\F1F4\"}i.icon.stripe:before{content:\"\\F1F5\"}i.icon.japan.credit.bureau:before{content:\"\\F24B\"}i.icon.diners.club:before{content:\"\\F24C\"}i.icon.credit.card.alternative:before{content:\"\\F283\"}i.icon.twitter.square:before{content:\"\\F081\"}i.icon.facebook.square:before{content:\"\\F082\"}i.icon.linkedin.square:before{content:\"\\F08C\"}i.icon.github.square:before{content:\"\\F092\"}i.icon.twitter:before{content:\"\\F099\"}i.icon.facebook.f:before{content:\"\\F09A\"}i.icon.github:before{content:\"\\F09B\"}i.icon.pinterest.square:before{content:\"\\F0D3\"}i.icon.google.plus.square:before{content:\"\\F0D4\"}i.icon.google.plus:before{content:\"\\F0D5\"}i.icon.linkedin:before{content:\"\\F0E1\"}i.icon.github.alternate:before{content:\"\\F113\"}i.icon.maxcdn:before{content:\"\\F136\"}i.icon.youtube.square:before{content:\"\\F166\"}i.icon.youtube:before{content:\"\\F167\"}i.icon.xing:before{content:\"\\F168\"}i.icon.xing.square:before{content:\"\\F169\"}i.icon.youtube.play:before{content:\"\\F16A\"}i.icon.dropbox:before{content:\"\\F16B\"}i.icon.stack.overflow:before{content:\"\\F16C\"}i.icon.instagram:before{content:\"\\F16D\"}i.icon.flickr:before{content:\"\\F16E\"}i.icon.adn:before{content:\"\\F170\"}i.icon.bitbucket:before{content:\"\\F171\"}i.icon.bitbucket.square:before{content:\"\\F172\"}i.icon.tumblr:before{content:\"\\F173\"}i.icon.tumblr.square:before{content:\"\\F174\"}i.icon.apple:before{content:\"\\F179\"}i.icon.windows:before{content:\"\\F17A\"}i.icon.android:before{content:\"\\F17B\"}i.icon.linux:before{content:\"\\F17C\"}i.icon.dribble:before{content:\"\\F17D\"}i.icon.skype:before{content:\"\\F17E\"}i.icon.foursquare:before{content:\"\\F180\"}i.icon.trello:before{content:\"\\F181\"}i.icon.gittip:before{content:\"\\F184\"}i.icon.vk:before{content:\"\\F189\"}i.icon.weibo:before{content:\"\\F18A\"}i.icon.renren:before{content:\"\\F18B\"}i.icon.pagelines:before{content:\"\\F18C\"}i.icon.stack.exchange:before{content:\"\\F18D\"}i.icon.vimeo.square:before{content:\"\\F194\"}i.icon.slack:before{content:\"\\F198\"}i.icon.wordpress:before{content:\"\\F19A\"}i.icon.yahoo:before{content:\"\\F19E\"}i.icon.google:before{content:\"\\F1A0\"}i.icon.reddit:before{content:\"\\F1A1\"}i.icon.reddit.square:before{content:\"\\F1A2\"}i.icon.stumbleupon.circle:before{content:\"\\F1A3\"}i.icon.stumbleupon:before{content:\"\\F1A4\"}i.icon.delicious:before{content:\"\\F1A5\"}i.icon.digg:before{content:\"\\F1A6\"}i.icon.pied.piper:before{content:\"\\F1A7\"}i.icon.pied.piper.alternate:before{content:\"\\F1A8\"}i.icon.drupal:before{content:\"\\F1A9\"}i.icon.joomla:before{content:\"\\F1AA\"}i.icon.behance:before{content:\"\\F1B4\"}i.icon.behance.square:before{content:\"\\F1B5\"}i.icon.steam:before{content:\"\\F1B6\"}i.icon.steam.square:before{content:\"\\F1B7\"}i.icon.spotify:before{content:\"\\F1BC\"}i.icon.deviantart:before{content:\"\\F1BD\"}i.icon.soundcloud:before{content:\"\\F1BE\"}i.icon.vine:before{content:\"\\F1CA\"}i.icon.codepen:before{content:\"\\F1CB\"}i.icon.jsfiddle:before{content:\"\\F1CC\"}i.icon.rebel:before{content:\"\\F1D0\"}i.icon.empire:before{content:\"\\F1D1\"}i.icon.git.square:before{content:\"\\F1D2\"}i.icon.git:before{content:\"\\F1D3\"}i.icon.hacker.news:before{content:\"\\F1D4\"}i.icon.tencent.weibo:before{content:\"\\F1D5\"}i.icon.qq:before{content:\"\\F1D6\"}i.icon.wechat:before{content:\"\\F1D7\"}i.icon.slideshare:before{content:\"\\F1E7\"}i.icon.twitch:before{content:\"\\F1E8\"}i.icon.yelp:before{content:\"\\F1E9\"}i.icon.lastfm:before{content:\"\\F202\"}i.icon.lastfm.square:before{content:\"\\F203\"}i.icon.ioxhost:before{content:\"\\F208\"}i.icon.angellist:before{content:\"\\F209\"}i.icon.meanpath:before{content:\"\\F20C\"}i.icon.buysellads:before{content:\"\\F20D\"}i.icon.connectdevelop:before{content:\"\\F20E\"}i.icon.dashcube:before{content:\"\\F210\"}i.icon.forumbee:before{content:\"\\F211\"}i.icon.leanpub:before{content:\"\\F212\"}i.icon.sellsy:before{content:\"\\F213\"}i.icon.shirtsinbulk:before{content:\"\\F214\"}i.icon.simplybuilt:before{content:\"\\F215\"}i.icon.skyatlas:before{content:\"\\F216\"}i.icon.facebook:before{content:\"\\F230\"}i.icon.pinterest:before{content:\"\\F231\"}i.icon.whatsapp:before{content:\"\\F232\"}i.icon.viacoin:before{content:\"\\F237\"}i.icon.medium:before{content:\"\\F23A\"}i.icon.y.combinator:before{content:\"\\F23B\"}i.icon.optinmonster:before{content:\"\\F23C\"}i.icon.opencart:before{content:\"\\F23D\"}i.icon.expeditedssl:before{content:\"\\F23E\"}i.icon.gg:before{content:\"\\F260\"}i.icon.gg.circle:before{content:\"\\F261\"}i.icon.tripadvisor:before{content:\"\\F262\"}i.icon.odnoklassniki:before{content:\"\\F263\"}i.icon.odnoklassniki.square:before{content:\"\\F264\"}i.icon.pocket:before{content:\"\\F265\"}i.icon.wikipedia:before{content:\"\\F266\"}i.icon.safari:before{content:\"\\F267\"}i.icon.chrome:before{content:\"\\F268\"}i.icon.firefox:before{content:\"\\F269\"}i.icon.opera:before{content:\"\\F26A\"}i.icon.internet.explorer:before{content:\"\\F26B\"}i.icon.contao:before{content:\"\\F26D\"}i.icon.\\35 00px:before{content:\"\\F26E\"}i.icon.amazon:before{content:\"\\F270\"}i.icon.houzz:before{content:\"\\F27C\"}i.icon.vimeo:before{content:\"\\F27D\"}i.icon.black.tie:before{content:\"\\F27E\"}i.icon.fonticons:before{content:\"\\F280\"}i.icon.reddit.alien:before{content:\"\\F281\"}i.icon.microsoft.edge:before{content:\"\\F282\"}i.icon.codiepie:before{content:\"\\F284\"}i.icon.modx:before{content:\"\\F285\"}i.icon.fort.awesome:before{content:\"\\F286\"}i.icon.product.hunt:before{content:\"\\F288\"}i.icon.mixcloud:before{content:\"\\F289\"}i.icon.scribd:before{content:\"\\F28A\"}i.icon.gitlab:before{content:\"\\F296\"}i.icon.wpbeginner:before{content:\"\\F297\"}i.icon.wpforms:before{content:\"\\F298\"}i.icon.envira.gallery:before{content:\"\\F299\"}i.icon.glide:before{content:\"\\F2A5\"}i.icon.glide.g:before{content:\"\\F2A6\"}i.icon.viadeo:before{content:\"\\F2A9\"}i.icon.viadeo.square:before{content:\"\\F2AA\"}i.icon.snapchat:before{content:\"\\F2AB\"}i.icon.snapchat.ghost:before{content:\"\\F2AC\"}i.icon.snapchat.square:before{content:\"\\F2AD\"}i.icon.pied.piper.hat:before{content:\"\\F2AE\"}i.icon.first.order:before{content:\"\\F2B0\"}i.icon.yoast:before{content:\"\\F2B1\"}i.icon.themeisle:before{content:\"\\F2B2\"}i.icon.google.plus.circle:before{content:\"\\F2B3\"}i.icon.font.awesome:before{content:\"\\F2B4\"}i.icon.like:before{content:\"\\F004\"}i.icon.favorite:before{content:\"\\F005\"}i.icon.video:before{content:\"\\F008\"}i.icon.check:before{content:\"\\F00C\"}i.icon.cancel:before,i.icon.close:before,i.icon.delete:before,i.icon.x:before{content:\"\\F00D\"}i.icon.magnify:before,i.icon.zoom.in:before{content:\"\\F00E\"}i.icon.shutdown:before{content:\"\\F011\"}i.icon.clock:before,i.icon.time:before{content:\"\\F017\"}i.icon.play.circle.outline:before{content:\"\\F01D\"}i.icon.headphone:before{content:\"\\F025\"}i.icon.camera:before{content:\"\\F030\"}i.icon.video.camera:before{content:\"\\F03D\"}i.icon.picture:before{content:\"\\F03E\"}i.icon.compose:before,i.icon.pencil:before{content:\"\\F040\"}i.icon.point:before{content:\"\\F041\"}i.icon.tint:before{content:\"\\F043\"}i.icon.signup:before{content:\"\\F044\"}i.icon.plus.circle:before{content:\"\\F055\"}i.icon.question.circle:before{content:\"\\F059\"}i.icon.dont:before{content:\"\\F05E\"}i.icon.minimize:before{content:\"\\F066\"}i.icon.add:before{content:\"\\F067\"}i.icon.attention:before,i.icon.exclamation.circle:before{content:\"\\F06A\"}i.icon.eye:before{content:\"\\F06E\"}i.icon.exclamation.triangle:before{content:\"\\F071\"}i.icon.shuffle:before{content:\"\\F074\"}i.icon.chat:before{content:\"\\F075\"}i.icon.cart:before,i.icon.shopping.cart:before{content:\"\\F07A\"}i.icon.bar.graph:before{content:\"\\F080\"}i.icon.key:before{content:\"\\F084\"}i.icon.cogs:before{content:\"\\F085\"}i.icon.discussions:before{content:\"\\F086\"}i.icon.like.outline:before{content:\"\\F087\"}i.icon.dislike.outline:before{content:\"\\F088\"}i.icon.heart.outline:before{content:\"\\F08A\"}i.icon.log.out:before{content:\"\\F08B\"}i.icon.thumb.tack:before{content:\"\\F08D\"}i.icon.winner:before{content:\"\\F091\"}i.icon.phone:before{content:\"\\F095\"}i.icon.bookmark.outline:before{content:\"\\F097\"}i.icon.phone.square:before{content:\"\\F098\"}i.icon.credit.card:before{content:\"\\F09D\"}i.icon.hdd.outline:before{content:\"\\F0A0\"}i.icon.bullhorn:before{content:\"\\F0A1\"}i.icon.bell.outline:before{content:\"\\F0A2\"}i.icon.hand.outline.right:before{content:\"\\F0A4\"}i.icon.hand.outline.left:before{content:\"\\F0A5\"}i.icon.hand.outline.up:before{content:\"\\F0A6\"}i.icon.hand.outline.down:before{content:\"\\F0A7\"}i.icon.globe:before{content:\"\\F0AC\"}i.icon.wrench:before{content:\"\\F0AD\"}i.icon.briefcase:before{content:\"\\F0B1\"}i.icon.group:before{content:\"\\F0C0\"}i.icon.chain:before,i.icon.linkify:before{content:\"\\F0C1\"}i.icon.flask:before{content:\"\\F0C3\"}i.icon.bars:before,i.icon.sidebar:before{content:\"\\F0C9\"}i.icon.list.ul:before{content:\"\\F0CA\"}i.icon.list.ol:before,i.icon.numbered.list:before{content:\"\\F0CB\"}i.icon.magic:before{content:\"\\F0D0\"}i.icon.truck:before{content:\"\\F0D1\"}i.icon.currency:before{content:\"\\F0D6\"}i.icon.dropdown:before,i.icon.triangle.down:before{content:\"\\F0D7\"}i.icon.triangle.up:before{content:\"\\F0D8\"}i.icon.triangle.left:before{content:\"\\F0D9\"}i.icon.triangle.right:before{content:\"\\F0DA\"}i.icon.envelope:before{content:\"\\F0E0\"}i.icon.conversation:before{content:\"\\F0E6\"}i.icon.rain:before{content:\"\\F0E9\"}i.icon.clipboard:before{content:\"\\F0EA\"}i.icon.lightbulb:before{content:\"\\F0EB\"}i.icon.bell:before{content:\"\\F0F3\"}i.icon.ambulance:before{content:\"\\F0F9\"}i.icon.medkit:before{content:\"\\F0FA\"}i.icon.fighter.jet:before{content:\"\\F0FB\"}i.icon.beer:before{content:\"\\F0FC\"}i.icon.plus.square:before{content:\"\\F0FE\"}i.icon.computer:before{content:\"\\F108\"}i.icon.gamepad:before{content:\"\\F11B\"}i.icon.star.half.full:before{content:\"\\F123\"}i.icon.broken.chain:before{content:\"\\F127\"}i.icon.question:before{content:\"\\F128\"}i.icon.exclamation:before{content:\"\\F12A\"}i.icon.eraser:before{content:\"\\F12D\"}i.icon.microphone:before{content:\"\\F130\"}i.icon.microphone.slash:before{content:\"\\F131\"}i.icon.shield:before{content:\"\\F132\"}i.icon.target:before{content:\"\\F140\"}i.icon.play.circle:before{content:\"\\F144\"}i.icon.pencil.square:before{content:\"\\F14B\"}i.icon.eur:before{content:\"\\F153\"}i.icon.gbp:before{content:\"\\F154\"}i.icon.usd:before{content:\"\\F155\"}i.icon.inr:before{content:\"\\F156\"}i.icon.cny:before,i.icon.jpy:before,i.icon.rmb:before{content:\"\\F157\"}i.icon.rouble:before,i.icon.rub:before{content:\"\\F158\"}i.icon.krw:before{content:\"\\F159\"}i.icon.btc:before{content:\"\\F15A\"}i.icon.gratipay:before{content:\"\\F184\"}i.icon.zip:before{content:\"\\F187\"}i.icon.dot.circle.outline:before{content:\"\\F192\"}i.icon.try:before{content:\"\\F195\"}i.icon.graduation:before{content:\"\\F19D\"}i.icon.circle.outline:before{content:\"\\F1DB\"}i.icon.sliders:before{content:\"\\F1DE\"}i.icon.weixin:before{content:\"\\F1D7\"}i.icon.teletype:before,i.icon.tty:before{content:\"\\F1E4\"}i.icon.binoculars:before{content:\"\\F1E5\"}i.icon.power.cord:before{content:\"\\F1E6\"}i.icon.wi-fi:before{content:\"\\F1EB\"}i.icon.visa.card:before{content:\"\\F1F0\"}i.icon.mastercard.card:before{content:\"\\F1F1\"}i.icon.discover.card:before{content:\"\\F1F2\"}i.icon.american.express.card:before,i.icon.amex:before{content:\"\\F1F3\"}i.icon.stripe.card:before{content:\"\\F1F5\"}i.icon.bell.slash:before{content:\"\\F1F6\"}i.icon.bell.slash.outline:before{content:\"\\F1F7\"}i.icon.area.graph:before{content:\"\\F1FE\"}i.icon.pie.graph:before{content:\"\\F200\"}i.icon.line.graph:before{content:\"\\F201\"}i.icon.cc:before{content:\"\\F20A\"}i.icon.ils:before,i.icon.sheqel:before{content:\"\\F20B\"}i.icon.plus.cart:before{content:\"\\F217\"}i.icon.arrow.down.cart:before{content:\"\\F218\"}i.icon.detective:before{content:\"\\F21B\"}i.icon.venus:before{content:\"\\F221\"}i.icon.mars:before{content:\"\\F222\"}i.icon.mercury:before{content:\"\\F223\"}i.icon.intersex:before{content:\"\\F224\"}i.icon.female.homosexual:before,i.icon.venus.double:before{content:\"\\F226\"}i.icon.male.homosexual:before,i.icon.mars.double:before{content:\"\\F227\"}i.icon.venus.mars:before{content:\"\\F228\"}i.icon.mars.alternate:before,i.icon.mars.stroke:before{content:\"\\F229\"}i.icon.mars.stroke.vertical:before,i.icon.mars.vertical:before{content:\"\\F22A\"}i.icon.mars.horizontal:before,i.icon.mars.stroke.horizontal:before{content:\"\\F22B\"}i.icon.asexual:before{content:\"\\F22D\"}i.icon.facebook.official:before{content:\"\\F230\"}i.icon.user.plus:before{content:\"\\F234\"}i.icon.user.cancel:before,i.icon.user.close:before,i.icon.user.delete:before,i.icon.user.times:before,i.icon.user.x:before{content:\"\\F235\"}i.icon.bed:before{content:\"\\F236\"}i.icon.yc:before,i.icon.ycombinator:before{content:\"\\F23B\"}i.icon.battery.four:before{content:\"\\F240\"}i.icon.battery.three.quarters:before,i.icon.battery.three:before{content:\"\\F241\"}i.icon.battery.half:before,i.icon.battery.two:before{content:\"\\F242\"}i.icon.battery.one:before,i.icon.battery.quarter:before{content:\"\\F243\"}i.icon.battery.zero:before{content:\"\\F244\"}i.icon.i.cursor:before{content:\"\\F246\"}i.icon.japan.credit.bureau.card:before,i.icon.jcb:before{content:\"\\F24B\"}i.icon.diners.club.card:before{content:\"\\F24C\"}i.icon.balance:before{content:\"\\F24E\"}i.icon.hourglass.outline:before,i.icon.hourglass.zero:before{content:\"\\F250\"}i.icon.hourglass.one:before{content:\"\\F251\"}i.icon.hourglass.two:before{content:\"\\F252\"}i.icon.hourglass.three:before{content:\"\\F253\"}i.icon.hourglass.four:before{content:\"\\F254\"}i.icon.grab:before{content:\"\\F255\"}i.icon.hand.victory:before{content:\"\\F25B\"}i.icon.tm:before{content:\"\\F25C\"}i.icon.r.circle:before{content:\"\\F25D\"}i.icon.television:before{content:\"\\F26C\"}i.icon.five.hundred.pixels:before{content:\"\\F26E\"}i.icon.calendar.plus:before{content:\"\\F271\"}i.icon.calendar.minus:before{content:\"\\F272\"}i.icon.calendar.times:before{content:\"\\F273\"}i.icon.calendar.check:before{content:\"\\F274\"}i.icon.factory:before{content:\"\\F275\"}i.icon.commenting:before{content:\"\\F27A\"}i.icon.commenting.outline:before{content:\"\\F27B\"}i.icon.edge:before,i.icon.ms.edge:before{content:\"\\F282\"}i.icon.wordpress.beginner:before{content:\"\\F297\"}i.icon.wordpress.forms:before{content:\"\\F298\"}i.icon.envira:before{content:\"\\F299\"}i.icon.question.circle.outline:before{content:\"\\F29C\"}i.icon.ald:before,i.icon.als:before,i.icon.assistive.listening.devices:before{content:\"\\F2A2\"}i.icon.asl.interpreting:before{content:\"\\F2A3\"}i.icon.deaf:before{content:\"\\F2A4\"}i.icon.american.sign.language.interpreting:before{content:\"\\F2A3\"}i.icon.hard.of.hearing:before{content:\"\\F2A4\"}i.icon.signing:before{content:\"\\F2A7\"}i.icon.new.pied.piper:before{content:\"\\F2AE\"}i.icon.theme.isle:before{content:\"\\F2B2\"}i.icon.google.plus.official:before{content:\"\\F2B3\"}i.icon.fa:before{content:\"\\F2B4\"}", ""]);
	
	// exports


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Image\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.image{position:relative;display:inline-block;vertical-align:middle;max-width:100%;background-color:transparent}img.ui.image{display:block}.ui.image img,.ui.image svg{display:block;max-width:100%;height:auto}.ui.hidden.image,.ui.hidden.images{display:none}.ui.hidden.transition.image,.ui.hidden.transition.images{display:block;visibility:hidden}.ui.disabled.image,.ui.disabled.images{cursor:default;opacity:.45}.ui.inline.image,.ui.inline.image img,.ui.inline.image svg{display:inline-block}.ui.top.aligned.image,.ui.top.aligned.image img,.ui.top.aligned.images .image,.ui.top.aligned.image svg{display:inline-block;vertical-align:top}.ui.middle.aligned.image,.ui.middle.aligned.image img,.ui.middle.aligned.images .image,.ui.middle.aligned.image svg{display:inline-block;vertical-align:middle}.ui.bottom.aligned.image,.ui.bottom.aligned.image img,.ui.bottom.aligned.images .image,.ui.bottom.aligned.image svg{display:inline-block;vertical-align:bottom}.ui.rounded.image,.ui.rounded.image>*,.ui.rounded.images .image,.ui.rounded.images .image>*{border-radius:.3125em}.ui.bordered.image img,.ui.bordered.images .image,.ui.bordered.images img,.ui.bordered.images svg,.ui.bordered.image svg,img.ui.bordered.image{border:1px solid rgba(0,0,0,.1)}.ui.circular.image,.ui.circular.images{overflow:hidden}.ui.circular.image,.ui.circular.image>*,.ui.circular.images .image,.ui.circular.images .image>*{border-radius:500rem}.ui.fluid.image,.ui.fluid.image img,.ui.fluid.images,.ui.fluid.images img,.ui.fluid.images svg,.ui.fluid.image svg{display:block;width:100%;height:auto}.ui.avatar.image,.ui.avatar.image img,.ui.avatar.images .image,.ui.avatar.images img,.ui.avatar.images svg,.ui.avatar.image svg{margin-right:.25em;display:inline-block;width:2em;height:2em;border-radius:500rem}.ui.spaced.image{display:inline-block!important;margin-left:.5em;margin-right:.5em}.ui[class*=\"left spaced\"].image{margin-left:.5em;margin-right:0}.ui[class*=\"right spaced\"].image{margin-left:0;margin-right:.5em}.ui.floated.image,.ui.floated.images{float:left;margin-right:1em;margin-bottom:1em}.ui.right.floated.image,.ui.right.floated.images{float:right;margin-right:0;margin-bottom:1em;margin-left:1em}.ui.floated.image:last-child,.ui.floated.images:last-child{margin-bottom:0}.ui.centered.image,.ui.centered.images{margin-left:auto;margin-right:auto}.ui.mini.image,.ui.mini.images .image,.ui.mini.images img,.ui.mini.images svg{width:35px;height:auto;font-size:.64705882rem}.ui.tiny.image,.ui.tiny.images .image,.ui.tiny.images img,.ui.tiny.images svg{width:80px;height:auto;font-size:.76470588rem}.ui.small.image,.ui.small.images .image,.ui.small.images img,.ui.small.images svg{width:150px;height:auto;font-size:.82352941rem}.ui.medium.image,.ui.medium.images .image,.ui.medium.images img,.ui.medium.images svg{width:300px;height:auto;font-size:1rem}.ui.large.image,.ui.large.images .image,.ui.large.images img,.ui.large.images svg{width:450px;height:auto;font-size:1.11764706rem}.ui.big.image,.ui.big.images .image,.ui.big.images img,.ui.big.images svg{width:600px;height:auto;font-size:1.29411765rem}.ui.huge.image,.ui.huge.images .image,.ui.huge.images img,.ui.huge.images svg{width:800px;height:auto;font-size:1.41176471rem}.ui.massive.image,.ui.massive.images .image,.ui.massive.images img,.ui.massive.images svg{width:960px;height:auto;font-size:1.58823529rem}.ui.images{font-size:0;margin:0 -.25rem}.ui.images .image,.ui.images img,.ui.images svg{display:inline-block;margin:0 .25rem .5rem}", ""]);
	
	// exports


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Input\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.input{position:relative;font-weight:400;font-style:normal;display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex;color:rgba(0,0,0,.87)}.ui.input input{margin:0;max-width:100%;-webkit-box-flex:1;-ms-flex:1 0 auto;flex:1 0 auto;outline:none;-webkit-tap-highlight-color:rgba(255,255,255,0);text-align:left;line-height:1.2142em;font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;padding:.53995882em .82352941em;background:#fff;border:1px solid rgba(34,36,38,.15);color:rgba(0,0,0,.87);border-radius:.11764706rem;-webkit-transition:box-shadow .1s ease,border-color .1s ease;transition:box-shadow .1s ease,border-color .1s ease;box-shadow:none}.ui.input input::-webkit-input-placeholder{color:hsla(0,0%,75%,.87)}.ui.input input::-moz-placeholder{color:hsla(0,0%,75%,.87)}.ui.input input:-ms-input-placeholder{color:hsla(0,0%,75%,.87)}.ui.disabled.input,.ui.input input[disabled]{opacity:.45}.ui.disabled.input input,.ui.input input[disabled]{pointer-events:none}.ui.input.down input,.ui.input input:active{border-color:rgba(0,0,0,.3);background:#fafafa;color:rgba(0,0,0,.87);box-shadow:none}.ui.loading.loading.input>i.icon:before{border-radius:500rem;border:.2em solid rgba(0,0,0,.1)}.ui.loading.loading.input>i.icon:after,.ui.loading.loading.input>i.icon:before{position:absolute;content:'';top:50%;left:50%;margin:-.64705882em 0 0 -.64705882em;width:1.29411765em;height:1.29411765em}.ui.loading.loading.input>i.icon:after{-webkit-animation:button-spin .6s linear;animation:button-spin .6s linear;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;border-radius:500rem;border-color:#5a686d transparent transparent;border-style:solid;border-width:.2em;box-shadow:0 0 0 1px transparent}.ui.input.focus input,.ui.input input:focus{border-color:#007abf;background:#fff;color:rgba(0,0,0,.8);box-shadow:none}.ui.input.focus input::-webkit-input-placeholder,.ui.input input:focus::-webkit-input-placeholder{color:hsla(0,0%,45%,.87)}.ui.input.focus input::-moz-placeholder,.ui.input input:focus::-moz-placeholder{color:hsla(0,0%,45%,.87)}.ui.input.focus input:-ms-input-placeholder,.ui.input input:focus:-ms-input-placeholder{color:hsla(0,0%,45%,.87)}.ui.input.error input{background-color:#fde0ef;border-color:#f1b6da;color:#8e0152;box-shadow:none}.ui.input.error input::-webkit-input-placeholder{color:#fe5db9}.ui.input.error input::-moz-placeholder{color:#fe5db9}.ui.input.error input:-ms-input-placeholder{color:#fe5db9!important}.ui.input.error input:focus::-webkit-input-placeholder{color:#fe2aa4}.ui.input.error input:focus::-moz-placeholder{color:#fe2aa4}.ui.input.error input:focus:-ms-input-placeholder{color:#fe2aa4!important}.ui.transparent.input input{border-color:transparent!important;background-color:transparent!important;padding:0!important;box-shadow:none!important}.ui.transparent.icon.input>i.icon{width:1.1em}.ui.transparent.icon.input>input{padding-left:0!important;padding-right:2em!important}.ui.transparent[class*=\"left icon\"].input>input{padding-left:2em!important;padding-right:0!important}.ui.transparent.inverted.input{color:#fff}.ui.transparent.inverted.input input{color:inherit}.ui.transparent.inverted.input input::-webkit-input-placeholder{color:hsla(0,0%,100%,.5)}.ui.transparent.inverted.input input::-moz-placeholder{color:hsla(0,0%,100%,.5)}.ui.transparent.inverted.input input:-ms-input-placeholder{color:hsla(0,0%,100%,.5)}.ui.icon.input>i.icon{cursor:default;position:absolute;line-height:1;text-align:center;top:0;right:0;margin:0;height:100%;width:2.39411765em;opacity:.5;border-radius:0 .11764706rem .11764706rem 0;-webkit-transition:opacity .3s ease;transition:opacity .3s ease}.ui.icon.input>i.icon:not(.link){pointer-events:none}.ui.icon.input input{padding-right:2.39411765em!important}.ui.icon.input>i.icon:after,.ui.icon.input>i.icon:before{left:0;position:absolute;text-align:center;top:50%;width:100%;margin-top:-.5em}.ui.icon.input>i.link.icon{cursor:pointer}.ui.icon.input>i.circular.icon{top:.35em;right:.5em}.ui[class*=\"left icon\"].input>i.icon{right:auto;left:1px;border-radius:.11764706rem 0 0 .11764706rem}.ui[class*=\"left icon\"].input>i.circular.icon{right:auto;left:.5em}.ui[class*=\"left icon\"].input>input{padding-left:2.39411765em!important;padding-right:.82352941em!important}.ui.icon.input>input:focus~i.icon{opacity:1}.ui.labeled.input>.label{-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;margin:0;font-size:1em}.ui.labeled.input>.label:not(.corner){padding-top:.64705882em;padding-bottom:.64705882em}.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child{border-top-right-radius:0;border-bottom-right-radius:0}.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child+input{border-top-left-radius:0;border-bottom-left-radius:0;border-left-color:transparent}.ui.labeled.input:not([class*=\"corner labeled\"]) .label:first-child+input:focus{border-left-color:#007abf}.ui[class*=\"right labeled\"].input input{border-top-right-radius:0!important;border-bottom-right-radius:0!important;border-right-color:transparent!important}.ui[class*=\"right labeled\"].input input+.label{border-top-left-radius:0;border-bottom-left-radius:0}.ui[class*=\"right labeled\"].input input:focus{border-right-color:#007abf!important}.ui.labeled.input .corner.label{top:1px;right:1px;font-size:.52941176em;border-radius:0 .11764706rem 0 0}.ui[class*=\"corner labeled\"]:not([class*=\"left corner labeled\"]).labeled.input input{padding-right:2.5em!important}.ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"])>input{padding-right:3.25em!important}.ui[class*=\"corner labeled\"].icon.input:not([class*=\"left corner labeled\"])>.icon{margin-right:1.25em}.ui[class*=\"left corner labeled\"].labeled.input input{padding-left:2.5em!important}.ui[class*=\"left corner labeled\"].icon.input>input{padding-left:3.25em!important}.ui[class*=\"left corner labeled\"].icon.input>.icon{margin-left:1.25em}.ui.input>.ui.corner.label{top:1px;right:1px}.ui.input>.ui.left.corner.label{right:auto;left:1px}.ui.action.input>.button,.ui.action.input>.buttons{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto}.ui.action.input>.button,.ui.action.input>.buttons>.button{padding-top:.64705882em;padding-bottom:.64705882em;margin:0}.ui.action.input:not([class*=\"left action\"])>input{border-top-right-radius:0!important;border-bottom-right-radius:0!important;border-right-color:transparent!important}.ui.action.input:not([class*=\"left action\"])>.button:not(:first-child),.ui.action.input:not([class*=\"left action\"])>.buttons:not(:first-child)>.button,.ui.action.input:not([class*=\"left action\"])>.dropdown:not(:first-child){border-radius:0}.ui.action.input:not([class*=\"left action\"])>.button:last-child,.ui.action.input:not([class*=\"left action\"])>.buttons:last-child>.button,.ui.action.input:not([class*=\"left action\"])>.dropdown:last-child{border-radius:0 .11764706rem .11764706rem 0}.ui.action.input:not([class*=\"left action\"]) input:focus{border-right-color:#007abf!important}.ui[class*=\"left action\"].input>input{border-top-left-radius:0!important;border-bottom-left-radius:0!important;border-left-color:transparent!important}.ui[class*=\"left action\"].input>.button,.ui[class*=\"left action\"].input>.buttons>.button,.ui[class*=\"left action\"].input>.dropdown{border-radius:0}.ui[class*=\"left action\"].input>.button:first-child,.ui[class*=\"left action\"].input>.buttons:first-child>.button,.ui[class*=\"left action\"].input>.dropdown:first-child{border-radius:.11764706rem 0 0 .11764706rem}.ui[class*=\"left action\"].input>input:focus{border-left-color:#007abf!important}.ui.inverted.input input{border:none}.ui.fluid.input{display:-webkit-box;display:-ms-flexbox;display:flex}.ui.fluid.input>input{width:0!important}.ui.mini.input{font-size:.64705882em}.ui.small.input{font-size:.82352941em}.ui.input{font-size:1em}.ui.large.input{font-size:1.11764706em}.ui.big.input{font-size:1.29411765em}.ui.huge.input{font-size:1.41176471em}.ui.massive.input{font-size:1.58823529em}", ""]);
	
	// exports


/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Label\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.label{display:inline-block;line-height:1;vertical-align:baseline;margin:0 .11764706em;background-color:#e8e8e8;background-image:none;padding:.5833em .833em;color:rgba(0,0,0,.6);text-transform:none;font-weight:700;border:0 solid transparent;border-radius:.11764706rem;-webkit-transition:background .1s ease;transition:background .1s ease}.ui.label:first-child{margin-left:0}.ui.label:last-child{margin-right:0}.ui.label>a,a.ui.label{cursor:pointer}.ui.label>a{color:inherit;opacity:.5;-webkit-transition:opacity .1s ease;transition:opacity .1s ease}.ui.label>a:hover{opacity:1}.ui.label>img{width:auto!important;vertical-align:middle;height:2.1666em!important}.ui.label>.icon{width:auto;margin:0 .75em 0 0}.ui.label>.detail{display:inline-block;vertical-align:top;font-weight:700;margin-left:1em;opacity:.8}.ui.label>.detail .icon{margin:0 .25em 0 0}.ui.label>.close.icon,.ui.label>.delete.icon{cursor:pointer;margin-right:0;margin-left:.5em;font-size:.82352941em;opacity:.5;-webkit-transition:background .1s ease;transition:background .1s ease}.ui.label>.delete.icon:hover{opacity:1}.ui.labels>.label{margin:0 .5em .5em 0}.ui.header>.ui.label{margin-top:-.29165em}.ui.attached.segment>.ui.top.left.attached.label,.ui.bottom.attached.segment>.ui.top.left.attached.label{border-top-left-radius:0}.ui.attached.segment>.ui.top.right.attached.label,.ui.bottom.attached.segment>.ui.top.right.attached.label{border-top-right-radius:0}.ui.top.attached.segment>.ui.bottom.left.attached.label{border-bottom-left-radius:0}.ui.top.attached.segment>.ui.bottom.right.attached.label{border-bottom-right-radius:0}.ui.top.attached.label+[class*=\"right floated\"]+*,.ui.top.attached.label:first-child+:not(.attached){margin-top:2rem!important}.ui.bottom.attached.label:first-child~:last-child:not(.attached){margin-top:0;margin-bottom:2rem!important}.ui.image.label{width:auto!important;margin-top:0;margin-bottom:0;max-width:9999px;vertical-align:baseline;text-transform:none;background:#e8e8e8;padding:.5833em .833em .5833em .5em;border-radius:.11764706rem;box-shadow:none}.ui.image.label img{display:inline-block;vertical-align:top;height:2.1666em;margin:-.5833em .5em -.5833em -.5em;border-radius:.11764706rem 0 0 .11764706rem}.ui.image.label .detail{background:rgba(0,0,0,.1);margin:-.5833em -.833em -.5833em .5em;padding:.5833em .833em;border-radius:0 .11764706rem .11764706rem 0}.ui.tag.label,.ui.tag.labels .label{margin-left:1em;position:relative;padding-left:1.5em;padding-right:1.5em;border-radius:0 .11764706rem .11764706rem 0;-webkit-transition:none;transition:none}.ui.tag.label:before,.ui.tag.labels .label:before{position:absolute;-webkit-transform:translateY(-50%) translateX(50%) rotate(-45deg);transform:translateY(-50%) translateX(50%) rotate(-45deg);top:50%;right:100%;content:'';background-color:inherit;background-image:none;width:1.56em;height:1.56em;-webkit-transition:none;transition:none}.ui.tag.label:after,.ui.tag.labels .label:after{position:absolute;content:'';top:50%;left:-.25em;margin-top:-.25em;background-color:#fff!important;width:.5em;height:.5em;box-shadow:0 -1px 1px 0 rgba(0,0,0,.3);border-radius:500rem}.ui.corner.label{margin:0;padding:0;text-align:center;border-color:#e8e8e8;width:4em;height:4em;z-index:1}.ui.corner.label,.ui.corner.label:after{position:absolute;top:0;right:0;-webkit-transition:border-color .1s ease;transition:border-color .1s ease;background-color:transparent!important}.ui.corner.label:after{content:\"\";z-index:-1;width:0;height:0;border-top:0 solid transparent;border-right:4em solid transparent;border-bottom:4em solid transparent;border-left:0 solid transparent;border-right-color:inherit}.ui.corner.label .icon{cursor:default;position:relative;top:.52941176em;left:.64705882em;font-size:1.11764706em;margin:0}.ui.left.corner.label,.ui.left.corner.label:after{right:auto;left:0}.ui.left.corner.label:after{border-top:4em solid transparent;border-right:4em solid transparent;border-bottom:0 solid transparent;border-left:0 solid transparent;border-top-color:inherit}.ui.left.corner.label .icon{left:-.64705882em}.ui.segment>.ui.corner.label{top:-1px;right:-1px}.ui.segment>.ui.left.corner.label{right:auto;left:-1px}.ui.ribbon.label{position:relative;margin:0;min-width:-webkit-max-content;min-width:-moz-max-content;min-width:max-content;border-radius:0 .11764706rem .11764706rem 0;border-color:rgba(0,0,0,.15)}.ui.ribbon.label:after{position:absolute;content:'';top:100%;left:0;background-color:transparent!important;border-style:solid;border-width:0 1.2em 1.2em 0;border-color:transparent;border-right-color:inherit;width:0;height:0}.ui.ribbon.label{left:calc(-1rem - 1.2em);margin-right:-1.2em;padding-left:calc(1rem + 1.2em);padding-right:1.2em}.ui[class*=\"right ribbon\"].label{left:calc(100% + 1rem + 1.2em);padding-left:1.2em;padding-right:calc(1rem + 1.2em);text-align:left;-webkit-transform:translateX(-100%);transform:translateX(-100%);border-radius:.11764706rem 0 0 .11764706rem}.ui[class*=\"right ribbon\"].label:after{left:auto;right:0;border-style:solid;border-width:1.2em 1.2em 0 0;border-color:transparent;border-top-color:inherit}.ui.card .image>.ribbon.label,.ui.image>.ribbon.label{position:absolute;top:1rem}.ui.card .image>.ui.ribbon.label,.ui.image>.ui.ribbon.label{left:calc(.05rem - 1.2em)}.ui.card .image>.ui[class*=\"right ribbon\"].label,.ui.image>.ui[class*=\"right ribbon\"].label{left:calc(100% + -.05rem + 1.2em);padding-left:.833em}.ui.table td>.ui.ribbon.label{left:-1.84706em}.ui.table td>.ui[class*=\"right ribbon\"].label{left:calc(100% + .64705882em + 1.2em);padding-left:.833em}.ui.attached.label,.ui[class*=\"top attached\"].label{width:100%;position:absolute;margin:0;top:0;left:0;padding:.75em 1em;border-radius:.17647059rem .17647059rem 0 0}.ui[class*=\"bottom attached\"].label{top:auto;bottom:0;border-radius:0 0 .17647059rem .17647059rem}.ui[class*=\"top left attached\"].label{width:auto;margin-top:0!important;border-radius:.17647059rem 0 .11764706rem 0}.ui[class*=\"top right attached\"].label{width:auto;left:auto;right:0;border-radius:0 .17647059rem 0 .11764706rem}.ui[class*=\"bottom left attached\"].label{width:auto;top:auto;bottom:0;border-radius:0 .11764706rem 0 .17647059rem}.ui[class*=\"bottom right attached\"].label{top:auto;bottom:0;left:auto;right:0;width:auto;border-radius:.11764706rem 0 .17647059rem 0}.ui.label.disabled{opacity:.5}a.ui.label:hover,a.ui.labels .label:hover{background-color:#e0e0e0;border-color:#e0e0e0;background-image:none;color:rgba(0,0,0,.8)}.ui.labels a.label:hover:before,a.ui.label:hover:before{color:rgba(0,0,0,.8)}.ui.active.label{border-color:#d0d0d0}.ui.active.label,.ui.active.label:before{background-color:#d0d0d0;background-image:none;color:rgba(0,0,0,.95)}a.ui.active.label:hover,a.ui.labels .active.label:hover{border-color:#c8c8c8}.ui.labels a.active.label:ActiveHover:before,a.ui.active.label:ActiveHover:before,a.ui.active.label:hover,a.ui.labels .active.label:hover{background-color:#c8c8c8;background-image:none;color:rgba(0,0,0,.95)}.ui.label.visible:not(.dropdown),.ui.labels.visible .label{display:inline-block!important}.ui.label.hidden,.ui.labels.hidden .label{display:none!important}.ui.red.label,.ui.red.labels .label{background-color:#e23c4e!important;border-color:#e23c4e!important;color:#fff!important}.ui.red.labels .label:hover,a.ui.red.label:hover{background-color:#e81d33!important;border-color:#e81d33!important;color:#fff!important}.ui.red.corner.label,.ui.red.corner.label:hover{background-color:transparent!important}.ui.red.ribbon.label{border-color:#cd1e31!important}.ui.basic.red.label{background-color:#fff!important;color:#e23c4e!important;border-color:#e23c4e!important}.ui.basic.red.labels a.label:hover,a.ui.basic.red.label:hover{background-color:#fff!important;color:#e81d33!important;border-color:#e81d33!important}.ui.orange.label,.ui.orange.labels .label{background-color:#f8813d!important;border-color:#f8813d!important;color:#fff!important}.ui.orange.labels .label:hover,a.ui.orange.label:hover{background-color:#ff6f1c!important;border-color:#ff6f1c!important;color:#fff!important}.ui.orange.corner.label,.ui.orange.corner.label:hover{background-color:transparent!important}.ui.orange.ribbon.label{border-color:#f6610c!important}.ui.basic.orange.label{background-color:#fff!important;color:#f8813d!important;border-color:#f8813d!important}.ui.basic.orange.labels a.label:hover,a.ui.basic.orange.label:hover{background-color:#fff!important;color:#ff6f1c!important;border-color:#ff6f1c!important}.ui.yellow.label,.ui.yellow.labels .label{background-color:#ffca18!important;border-color:#ffca18!important;color:#fff!important}.ui.yellow.labels .label:hover,a.ui.yellow.label:hover{background-color:#fec300!important;border-color:#fec300!important;color:#fff!important}.ui.yellow.corner.label,.ui.yellow.corner.label:hover{background-color:transparent!important}.ui.yellow.ribbon.label{border-color:#e4b000!important}.ui.basic.yellow.label{background-color:#fff!important;color:#ffca18!important;border-color:#ffca18!important}.ui.basic.yellow.labels a.label:hover,a.ui.basic.yellow.label:hover{background-color:#fff!important;color:#fec300!important;border-color:#fec300!important}.ui.olive.label,.ui.olive.labels .label{background-color:#456558!important;border-color:#456558!important;color:#fff!important}.ui.olive.labels .label:hover,a.ui.olive.label:hover{background-color:#39574b!important;border-color:#39574b!important;color:#fff!important}.ui.olive.corner.label,.ui.olive.corner.label:hover{background-color:transparent!important}.ui.olive.ribbon.label{border-color:#428e5a!important}.ui.basic.olive.label{background-color:#fff!important;color:#456558!important;border-color:#456558!important}.ui.basic.olive.labels a.label:hover,a.ui.basic.olive.label:hover{background-color:#fff!important;color:#39574b!important;border-color:#39574b!important}.ui.green.label,.ui.green.labels .label{background-color:#54af71!important;border-color:#54af71!important;color:#fff!important}.ui.green.labels .label:hover,a.ui.green.label:hover{background-color:#46a364!important;border-color:#46a364!important;color:#fff!important}.ui.green.corner.label,.ui.green.corner.label:hover{background-color:transparent!important}.ui.green.ribbon.label{border-color:#428e5a!important}.ui.basic.green.label{background-color:#fff!important;color:#54af71!important;border-color:#54af71!important}.ui.basic.green.labels a.label:hover,a.ui.basic.green.label:hover{background-color:#fff!important;color:#46a364!important;border-color:#46a364!important}.ui.teal.label,.ui.teal.labels .label{background-color:#00a1ca!important;border-color:#00a1ca!important;color:#fff!important}.ui.teal.labels .label:hover,a.ui.teal.label:hover{background-color:#008db1!important;border-color:#008db1!important;color:#fff!important}.ui.teal.corner.label,.ui.teal.corner.label:hover{background-color:transparent!important}.ui.teal.ribbon.label{border-color:#007897!important}.ui.basic.teal.label{background-color:#fff!important;color:#00a1ca!important;border-color:#00a1ca!important}.ui.basic.teal.labels a.label:hover,a.ui.basic.teal.label:hover{background-color:#fff!important;color:#008db1!important;border-color:#008db1!important}.ui.blue.label,.ui.blue.labels .label{background-color:#1d5f82!important;border-color:#1d5f82!important;color:#fff!important}.ui.blue.labels .label:hover,a.ui.blue.label:hover{background-color:#145171!important;border-color:#145171!important;color:#fff!important}.ui.blue.corner.label,.ui.blue.corner.label:hover{background-color:transparent!important}.ui.blue.ribbon.label{border-color:#144158!important}.ui.basic.blue.label{background-color:#fff!important;color:#1d5f82!important;border-color:#1d5f82!important}.ui.basic.blue.labels a.label:hover,a.ui.basic.blue.label:hover{background-color:#fff!important;color:#145171!important;border-color:#145171!important}.ui.violet.label,.ui.violet.labels .label{background-color:#525394!important;border-color:#525394!important;color:#fff!important}.ui.violet.labels .label:hover,a.ui.violet.label:hover{background-color:#464787!important;border-color:#464787!important;color:#fff!important}.ui.violet.corner.label,.ui.violet.corner.label:hover{background-color:transparent!important}.ui.violet.ribbon.label{border-color:#404173!important}.ui.basic.violet.label{background-color:#fff!important;color:#525394!important;border-color:#525394!important}.ui.basic.violet.labels a.label:hover,a.ui.basic.violet.label:hover{background-color:#fff!important;color:#464787!important;border-color:#464787!important}.ui.purple.label,.ui.purple.labels .label{background-color:#ad427f!important;border-color:#ad427f!important;color:#fff!important}.ui.purple.labels .label:hover,a.ui.purple.label:hover{background-color:#9f3672!important;border-color:#9f3672!important;color:#fff!important}.ui.purple.corner.label,.ui.purple.corner.label:hover{background-color:transparent!important}.ui.purple.ribbon.label{border-color:#883464!important}.ui.basic.purple.label{background-color:#fff!important;color:#ad427f!important;border-color:#ad427f!important}.ui.basic.purple.labels a.label:hover,a.ui.basic.purple.label:hover{background-color:#fff!important;color:#9f3672!important;border-color:#9f3672!important}.ui.pink.label,.ui.pink.labels .label{background-color:#e03997!important;border-color:#e03997!important;color:#fff!important}.ui.pink.labels .label:hover,a.ui.pink.label:hover{background-color:#e61a8d!important;border-color:#e61a8d!important;color:#fff!important}.ui.pink.corner.label,.ui.pink.corner.label:hover{background-color:transparent!important}.ui.pink.ribbon.label{border-color:#c71f7e!important}.ui.basic.pink.label{background-color:#fff!important;color:#e03997!important;border-color:#e03997!important}.ui.basic.pink.labels a.label:hover,a.ui.basic.pink.label:hover{background-color:#fff!important;color:#e61a8d!important;border-color:#e61a8d!important}.ui.brown.label,.ui.brown.labels .label{background-color:#a67a00!important;border-color:#a67a00!important;color:#fff!important}.ui.brown.labels .label:hover,a.ui.brown.label:hover{background-color:#8d6700!important;border-color:#8d6700!important;color:#fff!important}.ui.brown.corner.label,.ui.brown.corner.label:hover{background-color:transparent!important}.ui.brown.ribbon.label{border-color:#735500!important}.ui.basic.brown.label{background-color:#fff!important;color:#a67a00!important;border-color:#a67a00!important}.ui.basic.brown.labels a.label:hover,a.ui.basic.brown.label:hover{background-color:#fff!important;color:#8d6700!important;border-color:#8d6700!important}.ui.grey.label,.ui.grey.labels .label{background-color:#5a686d!important;border-color:#5a686d!important;color:#fff!important}.ui.grey.labels .label:hover,a.ui.grey.label:hover{background-color:#66757b!important;border-color:#66757b!important;color:#fff!important}.ui.grey.corner.label,.ui.grey.corner.label:hover{background-color:transparent!important}.ui.grey.ribbon.label{border-color:#735500!important}.ui.basic.grey.label{background-color:#fff!important;color:#5a686d!important;border-color:#5a686d!important}.ui.basic.grey.labels a.label:hover,a.ui.basic.grey.label:hover{background-color:#fff!important;color:#66757b!important;border-color:#66757b!important}.ui.black.label,.ui.black.labels .label{background-color:#1b1c1d!important;border-color:#1b1c1d!important;color:#fff!important}.ui.black.labels .label:hover,a.ui.black.label:hover{background-color:#27292a!important;border-color:#27292a!important;color:#fff!important}.ui.black.corner.label,.ui.black.corner.label:hover{background-color:transparent!important}.ui.black.ribbon.label{border-color:#735500!important}.ui.basic.black.label{background-color:#fff!important;color:#1b1c1d!important;border-color:#1b1c1d!important}.ui.basic.black.labels a.label:hover,a.ui.basic.black.label:hover{background-color:#fff!important;color:#27292a!important;border-color:#27292a!important}.ui.basic.label{border:1px solid rgba(34,36,38,.15);box-shadow:none}.ui.basic.label,a.ui.basic.label:hover{background:none #fff;color:rgba(0,0,0,.87)}a.ui.basic.label:hover{text-decoration:none;box-shadow:1px solid rgba(34,36,38,.15);box-shadow:none}.ui.basic.pointing.label:before{border-color:inherit}.ui.fluid.labels>.label,.ui.label.fluid{width:100%;box-sizing:border-box}.ui.inverted.label,.ui.inverted.labels .label{color:hsla(0,0%,100%,.9)!important}.ui.horizontal.label,.ui.horizontal.labels .label{margin:0 .5em 0 0;padding:.4em .833em;min-width:3em;text-align:center}.ui.circular.label,.ui.circular.labels .label{min-width:2em;min-height:2em;padding:.5em!important;line-height:1em;text-align:center;border-radius:500rem}.ui.empty.circular.label,.ui.empty.circular.labels .label{min-width:0;min-height:0;overflow:hidden;width:.5em;height:.5em;vertical-align:baseline}.ui.pointing.label{position:relative}.ui.attached.pointing.label{position:absolute}.ui.pointing.label:before{background-color:inherit;background-image:inherit;border-width:none;border-style:solid;border-color:inherit;position:absolute;content:'';-webkit-transform:rotate(45deg);transform:rotate(45deg);background-image:none;z-index:2;width:.6666em;height:.6666em;-webkit-transition:background .1s ease;transition:background .1s ease}.ui.pointing.label,.ui[class*=\"pointing above\"].label{margin-top:1em}.ui.pointing.label:before,.ui[class*=\"pointing above\"].label:before{border-width:1px 0 0 1px;-webkit-transform:translateX(-50%) translateY(-50%) rotate(45deg);transform:translateX(-50%) translateY(-50%) rotate(45deg);top:0;left:50%}.ui[class*=\"bottom pointing\"].label,.ui[class*=\"pointing below\"].label{margin-top:0;margin-bottom:1em}.ui[class*=\"bottom pointing\"].label:before,.ui[class*=\"pointing below\"].label:before{border-width:0 1px 1px 0;top:auto;right:auto;-webkit-transform:translateX(-50%) translateY(-50%) rotate(45deg);transform:translateX(-50%) translateY(-50%) rotate(45deg);top:100%;left:50%}.ui[class*=\"left pointing\"].label{margin-top:0;margin-left:.6666em}.ui[class*=\"left pointing\"].label:before{border-width:0 0 1px 1px;-webkit-transform:translateX(-50%) translateY(-50%) rotate(45deg);transform:translateX(-50%) translateY(-50%) rotate(45deg);bottom:auto;right:auto;top:50%;left:0}.ui[class*=\"right pointing\"].label{margin-top:0;margin-right:.6666em}.ui[class*=\"right pointing\"].label:before{border-width:1px 1px 0 0;-webkit-transform:translateX(50%) translateY(-50%) rotate(45deg);transform:translateX(50%) translateY(-50%) rotate(45deg);top:50%;right:0;bottom:auto;left:auto}.ui.basic.pointing.label:before,.ui.basic[class*=\"pointing above\"].label:before{margin-top:-1px}.ui.basic[class*=\"bottom pointing\"].label:before,.ui.basic[class*=\"pointing below\"].label:before{bottom:auto;top:100%;margin-top:1px}.ui.basic[class*=\"left pointing\"].label:before{top:50%;left:-1px}.ui.basic[class*=\"right pointing\"].label:before{top:50%;right:-1px}.ui.floating.label{position:absolute;z-index:100;top:-1em;left:100%;margin:0 0 0 -1.5em!important}.ui.mini.label,.ui.mini.labels .label{font-size:.52941176rem}.ui.tiny.label,.ui.tiny.labels .label{font-size:.58823529rem}.ui.small.label,.ui.small.labels .label{font-size:.64705882rem}.ui.label,.ui.labels .label{font-size:.70588235rem}.ui.large.label,.ui.large.labels .label{font-size:1rem}.ui.big.label,.ui.big.labels .label{font-size:1.29411765rem}.ui.huge.label,.ui.huge.labels .label{font-size:1.41176471rem}.ui.massive.label,.ui.massive.labels .label{font-size:1.58823529rem}.ui.label{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}", ""]);
	
	// exports


/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - List\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.list,ol.ui.list,ul.ui.list{list-style-type:none;margin:1em 0;padding:0}.ui.list:first-child,ol.ui.list:first-child,ul.ui.list:first-child{margin-top:0;padding-top:0}.ui.list:last-child,ol.ui.list:last-child,ul.ui.list:last-child{margin-bottom:0;padding-bottom:0}.ui.list .list>.item,.ui.list>.item,ol.ui.list li,ul.ui.list li{display:list-item;table-layout:fixed;list-style-type:none;list-style-position:outside;padding:.17647059em 0;line-height:1.11764706em}.ui.list>.item:after,.ui.list>.list>.item,ol.ui.list>li:first-child:after,ul.ui.list>li:first-child:after{content:'';display:block;height:0;clear:both;visibility:hidden}.ui.list .list>.item:first-child,.ui.list>.item:first-child,ol.ui.list li:first-child,ul.ui.list li:first-child{padding-top:0}.ui.list .list>.item:last-child,.ui.list>.item:last-child,ol.ui.list li:last-child,ul.ui.list li:last-child{padding-bottom:0}.ui.list .list,ol.ui.list ol,ul.ui.list ul{clear:both;margin:0;padding:.75em 0 .25em .5em}.ui.list .list>.item,ol.ui.list ol li,ul.ui.list ul li{padding:.11764706em 0;line-height:inherit}.ui.list .list>.item>i.icon,.ui.list>.item>i.icon{display:table-cell;margin:0;padding-top:.05882353em;padding-right:.23529412em;vertical-align:top;-webkit-transition:color .1s ease;transition:color .1s ease}.ui.list .list>.item>i.icon:only-child,.ui.list>.item>i.icon:only-child{display:inline-block;vertical-align:top}.ui.list .list>.item>.image,.ui.list>.item>.image{display:table-cell;background-color:transparent;margin:0;vertical-align:top}.ui.list .list>.item>.image:not(:only-child):not(img),.ui.list>.item>.image:not(:only-child):not(img){padding-right:.5em}.ui.list .list>.item>.image img,.ui.list>.item>.image img{vertical-align:top}.ui.list .list>.item>.image:only-child,.ui.list .list>.item>img.image,.ui.list>.item>.image:only-child,.ui.list>.item>img.image{display:inline-block}.ui.list .list>.item>.content,.ui.list>.item>.content{line-height:1.11764706em}.ui.list .list>.item>.icon+.content,.ui.list .list>.item>.image+.content,.ui.list>.item>.icon+.content,.ui.list>.item>.image+.content{display:table-cell;padding:0 0 0 .5em;vertical-align:top}.ui.list .list>.item>img.image+.content,.ui.list>.item>img.image+.content{display:inline-block}.ui.list .list>.item>.content>.list,.ui.list>.item>.content>.list{margin-left:0;padding-left:0}.ui.list .list>.item .header,.ui.list>.item .header{display:block;margin:0;font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;font-weight:700;color:rgba(0,0,0,.87)}.ui.list .list>.item .description,.ui.list>.item .description{display:block;color:rgba(0,0,0,.7)}.ui.list .list>.item a,.ui.list>.item a{cursor:pointer}.ui.list .list>a.item,.ui.list>a.item{cursor:pointer;color:#007abf}.ui.list .list>a.item:hover,.ui.list>a.item:hover{color:rgba(0,0,0,.87)}.ui.list .list>a.item i.icon,.ui.list>a.item i.icon{color:rgba(0,0,0,.4)}.ui.list .list>.item a.header,.ui.list>.item a.header{cursor:pointer;color:#007abf!important}.ui.list .list>.item a.header:hover,.ui.list>.item a.header:hover{color:rgba(0,0,0,.87)!important}.ui[class*=\"left floated\"].list{float:left}.ui[class*=\"right floated\"].list{float:right}.ui.list .list>.item [class*=\"left floated\"],.ui.list>.item [class*=\"left floated\"]{float:left;margin:0 1em 0 0}.ui.list .list>.item [class*=\"right floated\"],.ui.list>.item [class*=\"right floated\"]{float:right;margin:0 0 0 1em}.ui.menu .ui.list .list>.item,.ui.menu .ui.list>.item{display:list-item;table-layout:fixed;background-color:transparent;list-style-type:none;list-style-position:outside;padding:.17647059em 0;line-height:1.11764706em}.ui.menu .ui.list .list>.item:before,.ui.menu .ui.list>.item:before{border:none;background:none}.ui.menu .ui.list .list>.item:first-child,.ui.menu .ui.list>.item:first-child{padding-top:0}.ui.menu .ui.list .list>.item:last-child,.ui.menu .ui.list>.item:last-child{padding-bottom:0}.ui.horizontal.list{display:inline-block;font-size:0}.ui.horizontal.list>.item{display:inline-block;margin-left:1em;font-size:1rem}.ui.horizontal.list:not(.celled)>.item:first-child{margin-left:0!important;padding-left:0!important}.ui.horizontal.list .list{padding-left:0;padding-bottom:0}.ui.horizontal.list .list>.item>.content,.ui.horizontal.list .list>.item>.icon,.ui.horizontal.list .list>.item>.image,.ui.horizontal.list>.item>.content,.ui.horizontal.list>.item>.icon,.ui.horizontal.list>.item>.image{vertical-align:middle}.ui.horizontal.list>.item:first-child,.ui.horizontal.list>.item:last-child{padding-top:.17647059em;padding-bottom:.17647059em}.ui.horizontal.list>.item>i.icon{margin:0;padding:0 .25em 0 0}.ui.horizontal.list>.item>.icon,.ui.horizontal.list>.item>.icon+.content{float:none;display:inline-block}.ui.list .list>.disabled.item,.ui.list>.disabled.item{pointer-events:none;color:rgba(40,40,40,.3)!important}.ui.inverted.list .list>.disabled.item,.ui.inverted.list>.disabled.item{color:hsla(0,0%,88%,.3)!important}.ui.list .list>a.item:hover .icon,.ui.list>a.item:hover .icon{color:rgba(0,0,0,.87)}.ui.inverted.list .list>a.item>.icon,.ui.inverted.list>a.item>.icon{color:hsla(0,0%,100%,.7)}.ui.inverted.list .list>.item .header,.ui.inverted.list>.item .header{color:hsla(0,0%,100%,.9)}.ui.inverted.list .list>.item .description,.ui.inverted.list>.item .description{color:hsla(0,0%,100%,.7)}.ui.inverted.list .list>a.item,.ui.inverted.list>a.item{cursor:pointer;color:hsla(0,0%,100%,.9)}.ui.inverted.list .list>a.item:hover,.ui.inverted.list>a.item:hover{color:rgba(0,0,0,.87)}.ui.inverted.list .item a:not(.ui){color:hsla(0,0%,100%,.9)!important}.ui.inverted.list .item a:not(.ui):hover{color:rgba(0,0,0,.87)!important}.ui.list [class*=\"top aligned\"],.ui.list[class*=\"top aligned\"] .content,.ui.list[class*=\"top aligned\"] .image{vertical-align:top!important}.ui.list [class*=\"middle aligned\"],.ui.list[class*=\"middle aligned\"] .content,.ui.list[class*=\"middle aligned\"] .image{vertical-align:middle!important}.ui.list [class*=\"bottom aligned\"],.ui.list[class*=\"bottom aligned\"] .content,.ui.list[class*=\"bottom aligned\"] .image{vertical-align:bottom!important}.ui.link.list .item,.ui.link.list .item a:not(.ui),.ui.link.list a.item{color:rgba(0,0,0,.4);-webkit-transition:color .1s ease;transition:color .1s ease}.ui.link.list .item a:not(.ui):hover,.ui.link.list a.item:hover{color:rgba(0,0,0,.8)}.ui.link.list .item a:not(.ui):active,.ui.link.list a.item:active{color:rgba(0,0,0,.9)}.ui.link.list .active.item,.ui.link.list .active.item a:not(.ui){color:rgba(0,0,0,.95)}.ui.inverted.link.list .item,.ui.inverted.link.list .item a:not(.ui),.ui.inverted.link.list a.item{color:hsla(0,0%,100%,.5)}.ui.inverted.link.list .active.item a:not(.ui),.ui.inverted.link.list .item a:not(.ui):active,.ui.inverted.link.list .item a:not(.ui):hover,.ui.inverted.link.list a.active.item,.ui.inverted.link.list a.item:active,.ui.inverted.link.list a.item:hover{color:#fff}.ui.selection.list .list>.item,.ui.selection.list>.item{cursor:pointer;background:transparent;padding:.5em;margin:0;color:rgba(0,0,0,.4);border-radius:.5em;-webkit-transition:color .1s ease,padding-left .1s ease,background-color .1s ease;transition:color .1s ease,padding-left .1s ease,background-color .1s ease}.ui.selection.list .list>.item:last-child,.ui.selection.list>.item:last-child{margin-bottom:0}.ui.selection.list.list>.item:hover,.ui.selection.list>.item:hover{background:rgba(0,0,0,.03);color:rgba(0,0,0,.8)}.ui.selection.list .list>.item:active,.ui.selection.list>.item:active{background:rgba(0,0,0,.05);color:rgba(0,0,0,.9)}.ui.selection.list .list>.item.active,.ui.selection.list>.item.active{background:rgba(0,0,0,.05);color:rgba(0,0,0,.95)}.ui.inverted.selection.list>.item{background:transparent;color:hsla(0,0%,100%,.5)}.ui.inverted.selection.list>.item:hover{background:hsla(0,0%,100%,.02);color:#fff}.ui.inverted.selection.list>.item.active,.ui.inverted.selection.list>.item:active{background:hsla(0,0%,100%,.08);color:#fff}.ui.celled.selection.list .list>.item,.ui.celled.selection.list>.item,.ui.divided.selection.list .list>.item,.ui.divided.selection.list>.item{border-radius:0}.ui.animated.list>.item{-webkit-transition:color .25s ease .1s,padding-left .25s ease .1s,background-color .25s ease .1s;transition:color .25s ease .1s,padding-left .25s ease .1s,background-color .25s ease .1s}.ui.animated.list:not(.horizontal)>.item:hover{padding-left:1em}.ui.fitted.list:not(.selection) .list>.item,.ui.fitted.list:not(.selection)>.item{padding-left:0;padding-right:0}.ui.fitted.selection.list .list>.item,.ui.fitted.selection.list>.item{margin-left:-.5em;margin-right:-.5em}.ui.bulleted.list,ul.ui.list{margin-left:1.25rem}.ui.bulleted.list .list>.item,.ui.bulleted.list>.item,ul.ui.list li{position:relative}.ui.bulleted.list .list>.item:before,.ui.bulleted.list>.item:before,ul.ui.list li:before{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;position:absolute;top:auto;left:auto;font-weight:400;margin-left:-1.25rem;content:'\\2022';opacity:1;color:inherit;vertical-align:top}.ui.bulleted.list .list>a.item:before,.ui.bulleted.list>a.item:before,ul.ui.list li:before{color:rgba(0,0,0,.87)}.ui.bulleted.list .list,ul.ui.list ul{padding-left:1.25rem}.ui.horizontal.bulleted.list,ul.ui.horizontal.bulleted.list{margin-left:0}.ui.horizontal.bulleted.list>.item,ul.ui.horizontal.bulleted.list li{margin-left:1.75rem}.ui.horizontal.bulleted.list>.item:first-child,ul.ui.horizontal.bulleted.list li:first-child{margin-left:0}.ui.horizontal.bulleted.list>.item:before,ul.ui.horizontal.bulleted.list li:before{color:rgba(0,0,0,.87)}.ui.horizontal.bulleted.list>.item:first-child:before,ul.ui.horizontal.bulleted.list li:first-child:before{display:none}.ui.ordered.list,.ui.ordered.list .list,ol.ui.list,ol.ui.list ol{counter-reset:ordered;margin-left:1.25rem;list-style-type:none}.ui.ordered.list .list>.item,.ui.ordered.list>.item,ol.ui.list li{list-style-type:none;position:relative}.ui.ordered.list .list>.item:before,.ui.ordered.list>.item:before,ol.ui.list li:before{position:absolute;top:auto;left:auto;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;pointer-events:none;margin-left:-1.25rem;counter-increment:ordered;content:counters(ordered,\".\") \" \";text-align:right;color:rgba(0,0,0,.87);vertical-align:middle;opacity:.8}.ui.ordered.inverted.list .list>.item:before,.ui.ordered.inverted.list>.item:before,ol.ui.inverted.list li:before{color:hsla(0,0%,100%,.7)}.ui.ordered.list>.item[data-value],.ui.ordered.list>.list>.item[data-value]{content:attr(data-value)}ol.ui.list li[value]:before{content:attr(value)}.ui.ordered.list .list,ol.ui.list ol{margin-left:1em}.ui.ordered.list .list>.item:before,ol.ui.list ol li:before{margin-left:-2em}.ui.ordered.horizontal.list,ol.ui.horizontal.list{margin-left:0}.ui.ordered.horizontal.list .list>.item:before,.ui.ordered.horizontal.list>.item:before,ol.ui.horizontal.list li:before{position:static;margin:0 .5em 0 0}.ui.divided.list>.item{border-top:1px solid rgba(34,36,38,.15)}.ui.divided.list .item .list>.item,.ui.divided.list .list>.item,.ui.divided.list .list>.item:first-child,.ui.divided.list>.item:first-child{border-top:none}.ui.divided.list:not(.horizontal) .list>.item:first-child{border-top-width:1px}.ui.divided.bulleted.list .list,.ui.divided.bulleted.list:not(.horizontal){margin-left:0;padding-left:0}.ui.divided.bulleted.list>.item:not(.horizontal){padding-left:1.25rem}.ui.divided.ordered.list{margin-left:0}.ui.divided.ordered.list .list>.item,.ui.divided.ordered.list>.item{padding-left:1.25rem}.ui.divided.ordered.list .item .list{margin-left:0;margin-right:0;padding-bottom:.17647059em}.ui.divided.ordered.list .item .list>.item{padding-left:1em}.ui.divided.selection.list .list>.item,.ui.divided.selection.list>.item{margin:0;border-radius:0}.ui.divided.horizontal.list{margin-left:0}.ui.divided.horizontal.list>.item:not(:first-child){padding-left:.5em}.ui.divided.horizontal.list>.item:not(:last-child){padding-right:.5em}.ui.divided.horizontal.list>.item{border-top:none;border-left:1px solid rgba(34,36,38,.15);margin:0;line-height:.6}.ui.horizontal.divided.list>.item:first-child{border-left:none}.ui.divided.inverted.horizontal.list>.item,.ui.divided.inverted.list>.item,.ui.divided.inverted.list>.list{border-color:hsla(0,0%,100%,.1)}.ui.celled.list>.item,.ui.celled.list>.list{border-top:1px solid rgba(34,36,38,.15);padding-left:.5em;padding-right:.5em}.ui.celled.list>.item:last-child{border-bottom:1px solid rgba(34,36,38,.15)}.ui.celled.list>.item:first-child,.ui.celled.list>.item:last-child{padding-top:.17647059em;padding-bottom:.17647059em}.ui.celled.list .item .list>.item{border-width:0}.ui.celled.list .list>.item:first-child{border-top-width:0}.ui.celled.bulleted.list{margin-left:0}.ui.celled.bulleted.list .list>.item,.ui.celled.bulleted.list>.item{padding-left:1.25rem}.ui.celled.bulleted.list .item .list{margin-left:-1.25rem;margin-right:-1.25rem;padding-bottom:.17647059em}.ui.celled.ordered.list{margin-left:0}.ui.celled.ordered.list .list>.item,.ui.celled.ordered.list>.item{padding-left:1.25rem}.ui.celled.ordered.list .item .list{margin-left:0;margin-right:0;padding-bottom:.17647059em}.ui.celled.ordered.list .list>.item{padding-left:1em}.ui.horizontal.celled.list{margin-left:0}.ui.horizontal.celled.list .list>.item,.ui.horizontal.celled.list>.item{border-top:none;border-left:1px solid rgba(34,36,38,.15);margin:0;padding-left:.5em;padding-right:.5em;line-height:.6}.ui.horizontal.celled.list .list>.item:last-child,.ui.horizontal.celled.list>.item:last-child{border-bottom:none;border-right:1px solid rgba(34,36,38,.15)}.ui.celled.inverted.horizontal.list .list>.item,.ui.celled.inverted.horizontal.list>.item,.ui.celled.inverted.list>.item,.ui.celled.inverted.list>.list{border-color:1px solid hsla(0,0%,100%,.1)}.ui.relaxed.list:not(.horizontal)>.item:not(:first-child){padding-top:.35294118em}.ui.relaxed.list:not(.horizontal)>.item:not(:last-child){padding-bottom:.35294118em}.ui.horizontal.relaxed.list .list>.item:not(:first-child),.ui.horizontal.relaxed.list>.item:not(:first-child){padding-left:1rem}.ui.horizontal.relaxed.list .list>.item:not(:last-child),.ui.horizontal.relaxed.list>.item:not(:last-child){padding-right:1rem}.ui[class*=\"very relaxed\"].list:not(.horizontal)>.item:not(:first-child){padding-top:.70588235em}.ui[class*=\"very relaxed\"].list:not(.horizontal)>.item:not(:last-child){padding-bottom:.70588235em}.ui.horizontal[class*=\"very relaxed\"].list .list>.item:not(:first-child),.ui.horizontal[class*=\"very relaxed\"].list>.item:not(:first-child){padding-left:1.5rem}.ui.horizontal[class*=\"very relaxed\"].list .list>.item:not(:last-child),.ui.horizontal[class*=\"very relaxed\"].list>.item:not(:last-child){padding-right:1.5rem}.ui.mini.list{font-size:.64705882em}.ui.tiny.list{font-size:.76470588em}.ui.small.list{font-size:.82352941em}.ui.list{font-size:1em}.ui.large.list{font-size:1.11764706em}.ui.big.list{font-size:1.29411765em}.ui.huge.list{font-size:1.41176471em}.ui.massive.list{font-size:1.58823529em}.ui.mini.horizontal.list .list>.item,.ui.mini.horizontal.list>.item{font-size:.64705882rem}.ui.tiny.horizontal.list .list>.item,.ui.tiny.horizontal.list>.item{font-size:.76470588rem}.ui.small.horizontal.list .list>.item,.ui.small.horizontal.list>.item{font-size:.82352941rem}.ui.horizontal.list .list>.item,.ui.horizontal.list>.item{font-size:1rem}.ui.large.horizontal.list .list>.item,.ui.large.horizontal.list>.item{font-size:1.11764706rem}.ui.big.horizontal.list .list>.item,.ui.big.horizontal.list>.item{font-size:1.29411765rem}.ui.huge.horizontal.list .list>.item,.ui.huge.horizontal.list>.item{font-size:1.41176471rem}.ui.massive.horizontal.list .list>.item,.ui.massive.horizontal.list>.item{font-size:1.58823529rem}.ui.list,ol.ui.list,ul.ui.list{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.ui.list.infographic,ol.ui.list.infographic,ul.ui.list.infographic{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.ui.list.text,ol.ui.list.text,ul.ui.list.text{font-family:Georgia,serif}.ui.list.caption,ol.ui.list.caption,ul.ui.list.caption{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.infographic .ui.list,.infographic ol.ui.list,.infographic ul.ui.list{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.text .ui.list,.text ol.ui.list,.text ul.ui.list{font-family:Georgia,serif}.infographic .list>.item .header,.ui.infographic.list>.item .header{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}", ""]);
	
	// exports


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Message\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.message{position:relative;min-height:1em;margin:1em 0;background:#f8f8f9;padding:1em 1.5em;line-height:1.414em;color:rgba(0,0,0,.87);-webkit-transition:opacity .1s ease,color .1s ease,background .1s ease,box-shadow .1s ease;transition:opacity .1s ease,color .1s ease,background .1s ease,box-shadow .1s ease;border-radius:.11764706rem;box-shadow:0 0 0 0 transparent}.ui.message:first-child{margin-top:0}.ui.message:last-child{margin-bottom:0}.ui.message .header{display:block;font-family:Publico Headline,Georgia,serif;font-weight:700;margin:-.1em 0 0}.ui.message .header:not(.ui){font-size:1em}.ui.message p{opacity:.85;margin:.75em 0}.ui.message p:first-child{margin-top:0}.ui.message p:last-child{margin-bottom:0}.ui.message .header+p{margin-top:.25em}.ui.message .list:not(.ui){text-align:left;padding:0;opacity:.85;list-style-position:inside;margin:.5em 0 0}.ui.message .list:not(.ui):first-child{margin-top:0}.ui.message .list:not(.ui):last-child{margin-bottom:0}.ui.message .list:not(.ui) li{position:relative;list-style-type:none;margin:0 0 .3em 1em;padding:0}.ui.message .list:not(.ui) li:before{position:absolute;content:'\\2022';left:-1em;height:100%;vertical-align:baseline}.ui.message .list:not(.ui) li:last-child{margin-bottom:0}.ui.message>.icon{margin-right:.6em}.ui.message>.close.icon{cursor:pointer;position:absolute;margin:0;top:.793em;right:.5em;opacity:.7;-webkit-transition:opacity .1s ease;transition:opacity .1s ease}.ui.message>.close.icon:hover{opacity:1}.ui.message>:first-child{margin-top:0}.ui.message>:last-child{margin-bottom:0}.ui.dropdown .menu>.message{margin:0 -1px}.ui.visible.visible.visible.visible.message{display:block}.ui.icon.visible.visible.visible.visible.message{display:-webkit-box;display:-ms-flexbox;display:flex}.ui.hidden.hidden.hidden.hidden.message{display:none}.ui.compact.message{display:inline-block}.ui.attached.message{margin-bottom:-1px;border-radius:.11764706rem .11764706rem 0 0;box-shadow:inset 0 0 0 1px rgba(34,36,38,.15);margin-left:-1px;margin-right:-1px}.ui.attached+.ui.attached.message:not(.top):not(.bottom){margin-top:-1px;border-radius:0}.ui.bottom.attached.message{margin-top:-1px;border-radius:0 0 .11764706rem .11764706rem;box-shadow:inset 0 0 0 1px rgba(34,36,38,.15),none}.ui.bottom.attached.message:not(:last-child){margin-bottom:1em}.ui.attached.icon.message{width:auto}.ui.icon.message{display:-webkit-box;display:-ms-flexbox;display:flex;width:100%;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ui.icon.message>.icon:not(.close){display:block;-webkit-box-flex:0;-ms-flex:0 0 auto;flex:0 0 auto;width:auto;line-height:1;vertical-align:middle;font-size:3em;opacity:.8}.ui.icon.message>.content{display:block;-webkit-box-flex:1;-ms-flex:1 1 auto;flex:1 1 auto;vertical-align:middle}.ui.icon.message .icon:not(.close)+.content{padding-left:0}.ui.icon.message .circular.icon{width:1em}.ui.floating.message{box-shadow:inset 0 0 0 1px rgba(34,36,38,.22),0 2px 4px 0 rgba(0,0,0,.15),0 2px 10px 0 rgba(0,0,0,.1)}.ui.black.message{background-color:#1b1c1d;color:hsla(0,0%,100%,.9)}.ui.positive.message{background-color:#e6f5d0;color:#276419}.ui.attached.positive.message,.ui.positive.message{box-shadow:inset 0 0 0 1px #b8e186,0 0 0 0 transparent}.ui.positive.message .header{color:#153f0b}.ui.negative.message{background-color:#fde0ef;color:#8e0152}.ui.attached.negative.message,.ui.negative.message{box-shadow:inset 0 0 0 1px #f1b6da,0 0 0 0 transparent}.ui.negative.message .header{color:#5c0035}.ui.info.message{background-color:#cae8f4;color:#005064}.ui.attached.info.message,.ui.info.message{box-shadow:inset 0 0 0 1px #19bbe4,0 0 0 0 transparent}.ui.info.message .header{color:#002731}.ui.warning.message{background-color:#fff1bd;color:#735500}.ui.attached.warning.message,.ui.warning.message{box-shadow:inset 0 0 0 1px #ecc353,0 0 0 0 transparent}.ui.warning.message .header{color:#402f00}.ui.error.message{background-color:#fde0ef;color:#8e0152}.ui.attached.error.message,.ui.error.message{box-shadow:inset 0 0 0 1px #f1b6da,0 0 0 0 transparent}.ui.error.message .header{color:#5c0035}.ui.success.message{background-color:#e6f5d0;color:#276419}.ui.attached.success.message,.ui.success.message{box-shadow:inset 0 0 0 1px #b8e186,0 0 0 0 transparent}.ui.success.message .header{color:#153f0b}.ui.black.message,.ui.inverted.message{background-color:#1b1c1d;color:hsla(0,0%,100%,.9)}.ui.red.message{background-color:#fbcecd;color:#e23c4e;box-shadow:inset 0 0 0 1px #e23c4e,0 0 0 0 transparent}.ui.red.message .header{color:#df263a}.ui.orange.message{background-color:#ffe2c7;color:#f8813d;box-shadow:inset 0 0 0 1px #f8813d,0 0 0 0 transparent}.ui.orange.message .header{color:#f77124}.ui.yellow.message{background-color:#fff1bd;color:#a67a00;box-shadow:inset 0 0 0 1px #a67a00,0 0 0 0 transparent}.ui.yellow.message .header{color:#8d6700}.ui.olive.message{background-color:#d7ebda;color:#456558;box-shadow:inset 0 0 0 1px #456558,0 0 0 0 transparent}.ui.olive.message .header{color:#3b564b}.ui.green.message{background-color:#d0dad6;color:#326b44;box-shadow:inset 0 0 0 1px #326b44,0 0 0 0 transparent}.ui.green.message .header{color:#2a5a39}.ui.teal.message{background-color:#cae8f4;color:#005064;box-shadow:inset 0 0 0 1px #005064,0 0 0 0 transparent}.ui.teal.message .header{color:#003b4a}.ui.blue.message{background-color:#c7d2df;color:#1d5f82;box-shadow:inset 0 0 0 1px #1d5f82,0 0 0 0 transparent}.ui.blue.message .header{color:#18506d}.ui.violet.message{background-color:#dbd8ea;color:#525394;box-shadow:inset 0 0 0 1px #525394,0 0 0 0 transparent}.ui.violet.message .header{color:#494a84}.ui.purple.message{background-color:#eed0e1;color:#ad427f;box-shadow:inset 0 0 0 1px #ad427f,0 0 0 0 transparent}.ui.purple.message .header{color:#9b3b71}.ui.pink.message{background-color:#ffe3fb;color:#e03997;box-shadow:inset 0 0 0 1px #e03997,0 0 0 0 transparent}.ui.pink.message .header{color:#dd238b}.ui.brown.message{background-color:#f1e2d3;color:#a67a00;box-shadow:inset 0 0 0 1px #a67a00,0 0 0 0 transparent}.ui.brown.message .header{color:#8d6700}.ui.mini.message{font-size:.64705882em}.ui.tiny.message{font-size:.76470588em}.ui.small.message{font-size:.82352941em}.ui.message{font-size:1em}.ui.large.message{font-size:1.11764706em}.ui.big.message{font-size:1.29411765em}.ui.huge.message{font-size:1.41176471em}.ui.massive.message{font-size:1.58823529em}", ""]);
	
	// exports


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Reset\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */*,:after,:before{box-sizing:inherit}html{box-sizing:border-box}input[type=email],input[type=password],input[type=search],input[type=text]{-webkit-appearance:none;-moz-appearance:none}\n\n/*! normalize.css v3.0.1 | MIT License | git.io/normalize */\n/*! normalize.css v3.0.1 | MIT License | git.io/normalize */html{font-family:sans-serif;-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%}body{margin:0}article,aside,details,figcaption,figure,footer,header,hgroup,main,nav,section,summary{display:block}audio,canvas,progress,video{display:inline-block;vertical-align:baseline}audio:not([controls]){display:none;height:0}[hidden],template{display:none}a{background:transparent}a:active,a:hover{outline:0}abbr[title]{border-bottom:1px dotted}b,strong{font-weight:700}dfn{font-style:italic}h1{font-size:2em;margin:.67em 0}mark{background:#ff0;color:#000}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sup{top:-.5em}sub{bottom:-.25em}img{border:0}svg:not(:root){overflow:hidden}figure{margin:1em 40px}hr{height:0}pre{overflow:auto}code,kbd,pre,samp{font-family:monospace,monospace;font-size:1em}button,input,optgroup,select,textarea{color:inherit;font:inherit;margin:0}button{overflow:visible}button,select{text-transform:none}button,html input[type=button],input[type=reset],input[type=submit]{-webkit-appearance:button;cursor:pointer}button[disabled],html input[disabled]{cursor:default}button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0}input{line-height:normal}input[type=checkbox],input[type=radio]{box-sizing:border-box;padding:0}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{height:auto}input[type=search]{-webkit-appearance:textfield}input[type=search]::-webkit-search-cancel-button,input[type=search]::-webkit-search-decoration{-webkit-appearance:none}fieldset{border:1px solid silver;margin:0 2px;padding:.35em .625em .75em}legend{border:0;padding:0}textarea{overflow:auto}optgroup{font-weight:700}table{border-collapse:collapse;border-spacing:0}td,th{padding:0}", ""]);
	
	// exports


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Segment\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.segment{position:relative;background:hsla(0,0%,100%,.85);box-shadow:none;margin:1rem 0;padding:1em;border-radius:0;border:1px solid rgba(34,36,38,.15)}.ui.segment:first-child{margin-top:0}.ui.segment:last-child{margin-bottom:0}.ui.vertical.segment{margin:0;padding-left:0;padding-right:0;background:none transparent;border-radius:0;box-shadow:none;border:none;border-bottom:1px solid rgba(34,36,38,.15)}.ui.vertical.segment:last-child{border-bottom:none}.ui.inverted.segment>.ui.header{color:#fff}.ui[class*=\"bottom attached\"].segment>[class*=\"top attached\"].label{border-top-left-radius:0;border-top-right-radius:0}.ui[class*=\"top attached\"].segment>[class*=\"bottom attached\"].label{border-bottom-left-radius:0;border-bottom-right-radius:0}.ui.attached.segment:not(.top):not(.bottom)>[class*=\"top attached\"].label{border-top-left-radius:0;border-top-right-radius:0}.ui.attached.segment:not(.top):not(.bottom)>[class*=\"bottom attached\"].label{border-bottom-left-radius:0;border-bottom-right-radius:0}.ui.grid>.row>.ui.segment.column,.ui.grid>.ui.segment.column,.ui.page.grid.segment{padding-top:2em;padding-bottom:2em}.ui.grid.segment{margin:1rem 0;border-radius:0}.ui.basic.table.segment{background:hsla(0,0%,100%,.85);border:1px solid rgba(34,36,38,.15);box-shadow:none}.ui[class*=\"very basic\"].table.segment{padding:1em}.ui.piled.segment,.ui.piled.segments{margin:3em 0;box-shadow:'';z-index:auto}.ui.piled.segment:first-child{margin-top:0}.ui.piled.segment:last-child{margin-bottom:0}.ui.piled.segment:after,.ui.piled.segment:before,.ui.piled.segments:after,.ui.piled.segments:before{background-color:#fff;visibility:visible;content:'';display:block;height:100%;left:0;position:absolute;width:100%;border:1px solid rgba(34,36,38,.15);box-shadow:''}.ui.piled.segment:before,.ui.piled.segments:before{-webkit-transform:rotate(-1.2deg);transform:rotate(-1.2deg);top:0;z-index:-2}.ui.piled.segment:after,.ui.piled.segments:after{-webkit-transform:rotate(1.2deg);transform:rotate(1.2deg);top:0;z-index:-1}.ui[class*=\"top attached\"].piled.segment{margin-top:3em;margin-bottom:0}.ui.piled.segment[class*=\"top attached\"]:first-child{margin-top:0}.ui.piled.segment[class*=\"bottom attached\"]{margin-top:0;margin-bottom:3em}.ui.piled.segment[class*=\"bottom attached\"]:last-child{margin-bottom:0}.ui.stacked.segment{padding-bottom:1.4em}.ui.stacked.segment:after,.ui.stacked.segment:before,.ui.stacked.segments:after,.ui.stacked.segments:before{content:'';position:absolute;bottom:-3px;left:0;border-top:1px solid rgba(34,36,38,.15);background:rgba(0,0,0,.03);width:100%;height:6px;visibility:visible}.ui.stacked.segment:before,.ui.stacked.segments:before{display:none}.ui.tall.stacked.segment:before,.ui.tall.stacked.segments:before{display:block;bottom:0}.ui.stacked.inverted.segment:after,.ui.stacked.inverted.segment:before,.ui.stacked.inverted.segments:after,.ui.stacked.inverted.segments:before{background-color:rgba(0,0,0,.03);border-top:1px solid rgba(34,36,38,.35)}.ui.padded.segment{padding:1.5em}.ui[class*=\"very padded\"].segment{padding:3em}.ui.compact.segment{display:table}.ui.compact.segments{display:-webkit-inline-box;display:-ms-inline-flexbox;display:inline-flex}.ui.compact.segments .segment,.ui.segments .compact.segment{display:block;-webkit-box-flex:0;-ms-flex:0 1 auto;flex:0 1 auto}.ui.circular.segment{display:table-cell;padding:2em;text-align:center;vertical-align:middle;border-radius:500em}.ui.raised.segment,.ui.raised.segments{box-shadow:0 2px 4px 0 rgba(0,0,0,.15),0 2px 10px 0 rgba(0,0,0,.1)}.ui.segments{-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;position:relative;margin:1rem 0;border:1px solid rgba(34,36,38,.15);box-shadow:none;border-radius:0}.ui.segments:first-child{margin-top:0}.ui.segments:last-child{margin-bottom:0}.ui.segments>.segment{top:0;bottom:0;border-radius:0;margin:0;width:auto;box-shadow:none;border:none;border-top:1px solid rgba(34,36,38,.15)}.ui.segments:not(.horizontal)>.segment:first-child{border-top:none;margin-top:0;bottom:0;margin-bottom:0;top:0;border-radius:0 0 0 0}.ui.segments:not(.horizontal)>.segment:last-child{top:0;bottom:0;margin-top:0;margin-bottom:0;box-shadow:none,none;border-radius:0 0 0 0}.ui.segments:not(.horizontal)>.segment:only-child{border-radius:0}.ui.segments>.ui.segments{border-top:1px solid rgba(34,36,38,.15);margin:1rem}.ui.segments>.segments:first-child{border-top:none}.ui.segments>.segment+.segments:not(.horizontal){margin-top:0}.ui.horizontal.segments{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-direction:row;flex-direction:row;background-color:transparent;padding:0;background-color:hsla(0,0%,100%,.85);box-shadow:none;margin:1rem 0;border-radius:0;border:1px solid rgba(34,36,38,.15)}.ui.segments>.horizontal.segments{margin:0;background-color:transparent;border-radius:0;border:none;box-shadow:none;border-top:1px solid rgba(34,36,38,.15)}.ui.horizontal.segments>.segment{-webkit-box-flex:1;flex:1 1 auto;-ms-flex:1 1 0px;margin:0;min-width:0;background-color:transparent;border-radius:0;border:none;box-shadow:none;border-left:1px solid rgba(34,36,38,.15)}.ui.segments>.horizontal.segments:first-child{border-top:none}.ui.horizontal.segments>.segment:first-child{border-left:none}.ui.disabled.segment{opacity:.45;color:rgba(40,40,40,.3)}.ui.loading.segment{position:relative;cursor:default;pointer-events:none;text-shadow:none!important;color:transparent!important;-webkit-transition:all 0s linear;transition:all 0s linear}.ui.loading.segment:before{position:absolute;content:'';top:0;left:0;background:hsla(0,0%,100%,.8);width:100%;height:100%;border-radius:0;z-index:100}.ui.loading.segment:after{position:absolute;content:'';top:50%;left:50%;margin:-1.5em 0 0 -1.5em;width:3em;height:3em;-webkit-animation:segment-spin .6s linear;animation:segment-spin .6s linear;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;border-radius:500rem;border-color:#5a686d rgba(0,0,0,.1) rgba(0,0,0,.1);border-style:solid;border-width:.2em;box-shadow:0 0 0 1px transparent;visibility:visible;z-index:101}@-webkit-keyframes segment-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes segment-spin{0%{-webkit-transform:rotate(0deg);transform:rotate(0deg)}to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.ui.basic.segment{background:none transparent;box-shadow:none;border:none;border-radius:0}.ui.clearing.segment:after{content:\".\";display:block;height:0;clear:both;visibility:hidden}.ui.red.segment:not(.inverted){border-top:1px solid #e23c4e}.ui.inverted.red.segment{background-color:#e23c4e!important;color:#fff!important}.ui.orange.segment:not(.inverted){border-top:1px solid #f8813d}.ui.inverted.orange.segment{background-color:#f8813d!important;color:#fff!important}.ui.yellow.segment:not(.inverted){border-top:1px solid #ffca18}.ui.inverted.yellow.segment{background-color:#ffca18!important;color:#fff!important}.ui.olive.segment:not(.inverted){border-top:1px solid #456558}.ui.inverted.olive.segment{background-color:#456558!important;color:#fff!important}.ui.green.segment:not(.inverted){border-top:1px solid #54af71}.ui.inverted.green.segment{background-color:#54af71!important;color:#fff!important}.ui.teal.segment:not(.inverted){border-top:1px solid #00a1ca}.ui.inverted.teal.segment{background-color:#00a1ca!important;color:#fff!important}.ui.blue.segment:not(.inverted){border-top:1px solid #1d5f82}.ui.inverted.blue.segment{background-color:#1d5f82!important;color:#fff!important}.ui.violet.segment:not(.inverted){border-top:1px solid #525394}.ui.inverted.violet.segment{background-color:#525394!important;color:#fff!important}.ui.purple.segment:not(.inverted){border-top:1px solid #ad427f}.ui.inverted.purple.segment{background-color:#ad427f!important;color:#fff!important}.ui.pink.segment:not(.inverted){border-top:1px solid #e03997}.ui.inverted.pink.segment{background-color:#e03997!important;color:#fff!important}.ui.brown.segment:not(.inverted){border-top:1px solid #a67a00}.ui.inverted.brown.segment{background-color:#a67a00!important;color:#fff!important}.ui.grey.segment:not(.inverted){border-top:1px solid #5a686d}.ui.inverted.grey.segment{background-color:#5a686d!important;color:#fff!important}.ui.black.segment:not(.inverted){border-top:1px solid #1b1c1d}.ui.inverted.black.segment{background-color:#1b1c1d!important;color:#fff!important}.ui[class*=\"left aligned\"].segment{text-align:left}.ui[class*=\"right aligned\"].segment{text-align:right}.ui[class*=\"center aligned\"].segment{text-align:center}.ui.floated.segment,.ui[class*=\"left floated\"].segment{float:left;margin-right:1em}.ui[class*=\"right floated\"].segment{float:right;margin-left:1em}.ui.inverted.segment{border:none;box-shadow:none}.ui.inverted.segment,.ui.primary.inverted.segment{background:rgba(0,0,0,.85);color:hsla(0,0%,100%,.9)}.ui.inverted.segment .segment{color:rgba(0,0,0,.87)}.ui.inverted.segment .inverted.segment{color:hsla(0,0%,100%,.9)}.ui.inverted.attached.segment{border-color:#555}.ui.secondary.segment{background:hsla(0,0%,100%,.15);color:rgba(0,0,0,.6)}.ui.secondary.inverted.segment{background:rgba(0,0,0,.85);color:hsla(0,0%,100%,.8)}.ui.tertiary.segment{background:transparent;color:rgba(0,0,0,.4)}.ui.tertiary.inverted.segment{background:rgba(0,0,0,.85);color:hsla(0,0%,100%,.8)}.ui.attached.segment{top:0;bottom:0;border-radius:0;margin:0 -1px;width:calc(100% + 2px);max-width:calc(100% + 2px);box-shadow:none;border:1px solid #d4d4d5}.ui.attached:not(.message)+.ui.attached.segment:not(.top){border-top:none}.ui[class*=\"top attached\"].segment{bottom:0;margin-bottom:0;top:0;margin-top:1rem;border-radius:0 0 0 0}.ui.segment[class*=\"top attached\"]:first-child{margin-top:0}.ui.segment[class*=\"bottom attached\"]{bottom:0;margin-top:0;top:0;margin-bottom:1rem;box-shadow:none,none;border-radius:0 0 0 0}.ui.segment[class*=\"bottom attached\"]:last-child{margin-bottom:0}.ui.mini.segment,.ui.mini.segments .segment{font-size:.64705882rem}.ui.tiny.segment,.ui.tiny.segments .segment{font-size:.76470588rem}.ui.small.segment,.ui.small.segments .segment{font-size:.82352941rem}.ui.segment,.ui.segments .segment{font-size:1rem}.ui.large.segment,.ui.large.segments .segment{font-size:1.11764706rem}.ui.big.segment,.ui.big.segments .segment{font-size:1.29411765rem}.ui.huge.segment,.ui.huge.segments .segment{font-size:1.41176471rem}.ui.massive.segment,.ui.massive.segments .segment{font-size:1.58823529rem}.ui.segment:not(.vertical):not(.stacked):not(.piled):not(.attached){border:none}.ui.segments.segments .ui.segment{border-top:1px solid rgba(34,36,38,.15)}.ui.segments.segments .ui.segment:first-child{border-top:none}.ui.vertical.segment{padding-top:3em;padding-bottom:3em}.ui.vertical.segment.padded{padding:6em 0}.ui.vertical.segment[class*=\"very padded\"]{padding:12em 0}.ui.vertical.segment.fitted{padding:1.5em 0}.ui.vertical.segment[class*=\"very fitted\"]{padding:1em 0}.ui.vertical.segment:first-child{padding-top:0}.ui.vertical.segment:last-child{padding-bottom:0}.ui.basic.basic.basic.basic.segment{background:none transparent;box-shadow:none;border:none;border-radius:0}.ui.secondary.inverted.segment{opacity:.8}.ui.tertiary.inverted.segment{opacity:.5}.ui.red.segment:not(.inverted){background-color:#fbcecd}.ui.orange.segment:not(.inverted){background-color:#ffe2c7}.ui.yellow.segment:not(.inverted){background-color:#fff1bd}.ui.olive.segment:not(.inverted){background-color:#d7ebda}.ui.green.segment:not(.inverted){background-color:#d0dad6}.ui.teal.segment:not(.inverted){background-color:#cae8f4}.ui.blue.segment:not(.inverted){background-color:#c7d2df}.ui.violet.segment:not(.inverted){background-color:#dbd8ea}.ui.purple.segment:not(.inverted){background-color:#eed0e1}.ui.pink.segment:not(.inverted){background-color:#ffe3fb}.ui.brown.segment:not(.inverted){background-color:#f1e2d3}.ui.grey.segment:not(.inverted){background-color:#7f8f95}.ui.black.segment:not(.inverted){background-color:#545454;color:hsla(0,0%,100%,.85)!important}", ""]);
	
	// exports


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Source+Sans+Pro:300,600,700&subset=latin);", ""]);
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Site\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */body,html{height:100%}body,html{font-size:17px}body{margin:0;padding:0;overflow-x:hidden;min-width:320px;background:#fff;font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif;line-height:1.414em;color:rgba(0,0,0,.87);font-smoothing:antialiased}h1,h2,h3,h4,h5{font-family:Publico Headline,Georgia,serif;line-height:1.2em;margin:calc(2rem - .1em) 0 1rem;font-weight:500;padding:0}h1{min-height:1rem;font-size:3.998rem}h2{font-size:2.827rem}h3{font-size:1.999rem}h4{font-size:1.414rem}h5{font-size:1rem}h1:first-child,h2:first-child,h3:first-child,h4:first-child,h5:first-child{margin-top:0}h1:last-child,h2:last-child,h3:last-child,h4:last-child,h5:last-child{margin-bottom:0}p{margin:0 0 1em;line-height:1.414em}p:first-child{margin-top:0}p:last-child{margin-bottom:0}a{color:#007abf}a,a:hover{text-decoration:none}a:hover{color:rgba(0,0,0,.87)}::-webkit-selection{background-color:#cce2ff;color:rgba(0,0,0,.87)}::-moz-selection{background-color:#cce2ff;color:rgba(0,0,0,.87)}::selection{background-color:#cce2ff;color:rgba(0,0,0,.87)}input::-webkit-selection,textarea::-webkit-selection{background-color:hsla(0,0%,39%,.4);color:rgba(0,0,0,.87)}input::-moz-selection,textarea::-moz-selection{background-color:hsla(0,0%,39%,.4);color:rgba(0,0,0,.87)}input::selection,textarea::selection{background-color:hsla(0,0%,39%,.4);color:rgba(0,0,0,.87)}@font-face{font-family:Benton Sans Cond;src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/3d37dcaf-9dfb-45f0-bd8f-a635fea92d0b-2.eot\");src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/3d37dcaf-9dfb-45f0-bd8f-a635fea92d0b-2.eot?\") format(\"embedded-opentype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/3d37dcaf-9dfb-45f0-bd8f-a635fea92d0b-3.woff\") format(\"woff\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/3d37dcaf-9dfb-45f0-bd8f-a635fea92d0b-1.ttf\") format(\"truetype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/3d37dcaf-9dfb-45f0-bd8f-a635fea92d0b-4.svg#web\") format(\"svg\");font-style:normal;font-weight:900}@font-face{font-family:Benton Sans Cond;src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/2e86b3e0-b624-4270-befe-3f44606d827a-2.eot\");src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/2e86b3e0-b624-4270-befe-3f44606d827a-2.eot?\") format(\"embedded-opentype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/2e86b3e0-b624-4270-befe-3f44606d827a-3.woff\") format(\"woff\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/2e86b3e0-b624-4270-befe-3f44606d827a-1.ttf\") format(\"truetype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/2e86b3e0-b624-4270-befe-3f44606d827a-4.svg#web\") format(\"svg\");font-style:normal;font-weight:300}@font-face{font-family:Benton Sans Cond;src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/7bb9e5d1-f5d9-4a09-8b5d-770aa2f4228e-2.eot\");src:url(\"//www.tagesanzeiger.ch/css/fonts/benton/7bb9e5d1-f5d9-4a09-8b5d-770aa2f4228e-2.eot?\") format(\"embedded-opentype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/7bb9e5d1-f5d9-4a09-8b5d-770aa2f4228e-3.woff\") format(\"woff\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/7bb9e5d1-f5d9-4a09-8b5d-770aa2f4228e-1.ttf\") format(\"truetype\"),url(\"//www.tagesanzeiger.ch/css/fonts/benton/7bb9e5d1-f5d9-4a09-8b5d-770aa2f4228e-4.svg#web\") format(\"svg\");font-style:normal;font-weight:500}@font-face{font-family:Publico Headline;src:url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Medium-Web.eot\");src:url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Medium-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Medium-Web.woff\") format(\"woff\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Medium-Web.ttf\") format(\"truetype\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Medium-Web.svg\") format(\"svg\");font-weight:500;font-style:normal}@font-face{font-family:Publico Headline;src:url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Bold-Web.eot\");src:url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Bold-Web.eot?#iefix\") format(\"embedded-opentype\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Bold-Web.woff\") format(\"woff\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Bold-Web.ttf\") format(\"truetype\"),url(\"//www.tagesanzeiger.ch/css/fonts/publico/PublicoHeadline-Bold-Web.svg\") format(\"svg\");font-weight:700;font-style:normal}body.inverted{background-color:#1b1c1d}", ""]);
	
	// exports


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, "/*!\n * # Semantic UI 2.2.4 - Table\n * http://github.com/semantic-org/semantic-ui/\n *\n *\n * Released under the MIT license\n * http://opensource.org/licenses/MIT\n *\n */.ui.table{width:100%;background:transparent;margin:1em 0;border:1px solid rgba(34,36,38,.15);box-shadow:none;border-radius:.11764706rem;text-align:left;color:rgba(0,0,0,.87);border-collapse:separate;border-spacing:0}.ui.table:first-child{margin-top:0}.ui.table:last-child{margin-bottom:0}.ui.table td,.ui.table th{-webkit-transition:background .1s ease,color .1s ease;transition:background .1s ease,color .1s ease}.ui.table thead{box-shadow:none}.ui.table thead th{cursor:auto;background:rgba(0,0,0,.05);text-align:inherit;color:rgba(0,0,0,.87);padding:.82352941em .64705882em;vertical-align:inherit;font-style:none;font-weight:700;text-transform:none;border-bottom:2px solid rgba(34,36,38,.1);border-left:none}.ui.table thead tr>th:first-child{border-left:none}.ui.table thead tr:first-child>th:first-child{border-radius:.11764706rem 0 0 0}.ui.table thead tr:first-child>th:last-child{border-radius:0 .11764706rem 0 0}.ui.table thead tr:first-child>th:only-child{border-radius:.11764706rem .11764706rem 0 0}.ui.table tfoot{box-shadow:none}.ui.table tfoot th{cursor:auto;border-top:1px solid rgba(34,36,38,.15);background:rgba(0,0,0,.05);text-align:inherit;color:rgba(0,0,0,.87);padding:.64705882em;vertical-align:middle;font-style:normal;font-weight:400;text-transform:none}.ui.table tfoot tr>th:first-child{border-left:none}.ui.table tfoot tr:first-child>th:first-child{border-radius:0 0 0 .11764706rem}.ui.table tfoot tr:first-child>th:last-child{border-radius:0 0 .11764706rem 0}.ui.table tfoot tr:first-child>th:only-child{border-radius:0 0 .11764706rem .11764706rem}.ui.table tr td{border-top:1px solid rgba(34,36,38,.1)}.ui.table tr:first-child td{border-top:none}.ui.table td{padding:.64705882em;text-align:inherit}.ui.table>.icon{vertical-align:baseline}.ui.table>.icon:only-child{margin:0}.ui.table.segment{padding:0}.ui.table.segment:after{display:none}.ui.table.segment.stacked:after{display:block}@media only screen and (max-width:767px){.ui.table:not(.unstackable){width:100%}.ui.table:not(.unstackable) tbody,.ui.table:not(.unstackable) tr,.ui.table:not(.unstackable) tr>td,.ui.table:not(.unstackable) tr>th{width:auto!important;display:block!important}.ui.table:not(.unstackable){padding:0}.ui.table:not(.unstackable) tfoot,.ui.table:not(.unstackable) thead{display:block}.ui.table:not(.unstackable) tr{padding-top:1em;padding-bottom:1em;box-shadow:inset 0 -1px 0 0 rgba(0,0,0,.1)!important}.ui.table:not(.unstackable) tr>td,.ui.table:not(.unstackable) tr>th{background:none;border:none!important;padding:.25em .75em!important;box-shadow:none!important}.ui.table:not(.unstackable) td:first-child,.ui.table:not(.unstackable) th:first-child{font-weight:700}.ui.definition.table:not(.unstackable) thead th:first-child{box-shadow:none!important}}.ui.table td .image,.ui.table td .image img,.ui.table th .image,.ui.table th .image img{max-width:none}.ui.structured.table{border-collapse:collapse}.ui.structured.table thead th{border-left:none;border-right:none}.ui.structured.sortable.table thead th{border-left:1px solid rgba(34,36,38,.15);border-right:1px solid rgba(34,36,38,.15)}.ui.structured.basic.table th{border-left:none;border-right:none}.ui.structured.celled.table tr td,.ui.structured.celled.table tr th{border-left:1px solid rgba(34,36,38,.1);border-right:1px solid rgba(34,36,38,.1)}.ui.definition.table thead:not(.full-width) th:first-child{pointer-events:none;background:transparent;font-weight:400;color:rgba(0,0,0,.4);box-shadow:-1px -1px 0 1px transparent}.ui.definition.table tfoot:not(.full-width) th:first-child{pointer-events:none;background:transparent;font-weight:rgba(0,0,0,.4);color:normal;box-shadow:1px 1px 0 1px transparent}.ui.celled.definition.table thead:not(.full-width) th:first-child{box-shadow:0 -1px 0 1px transparent}.ui.celled.definition.table tfoot:not(.full-width) th:first-child{box-shadow:0 1px 0 1px transparent}.ui.definition.table tr td.definition,.ui.definition.table tr td:first-child:not(.ignored){background:transparent;font-weight:700;color:rgba(0,0,0,.95);text-transform:'';box-shadow:'';text-align:'';font-size:1em;padding-left:'';padding-right:''}.ui.definition.table td:nth-child(2),.ui.definition.table tfoot:not(.full-width) th:nth-child(2),.ui.definition.table thead:not(.full-width) th:nth-child(2){border-left:1px solid rgba(34,36,38,.15)}.ui.table td.positive,.ui.table tr.positive{box-shadow:inset 0 0 0 #b8e186;background:#e6f5d0!important;color:#276419!important}.ui.table td.negative,.ui.table tr.negative{box-shadow:inset 0 0 0 #f1b6da;background:#fde0ef!important;color:#8e0152!important}.ui.table td.error,.ui.table tr.error{box-shadow:inset 0 0 0 #f1b6da;background:#fde0ef!important;color:#8e0152!important}.ui.table td.warning,.ui.table tr.warning{box-shadow:inset 0 0 0 #ecc353;background:#fff1bd!important;color:#735500!important}.ui.table td.active,.ui.table tr.active{box-shadow:inset 0 0 0 rgba(0,0,0,.87);background:#e0e0e0!important;color:rgba(0,0,0,.87)!important}.ui.table tr.disabled:hover,.ui.table tr.disabled td,.ui.table tr:hover td.disabled,.ui.table tr td.disabled{pointer-events:none;color:rgba(40,40,40,.3)}@media only screen and (max-width:991px){.ui[class*=\"tablet stackable\"].table,.ui[class*=\"tablet stackable\"].table tbody,.ui[class*=\"tablet stackable\"].table tr,.ui[class*=\"tablet stackable\"].table tr>td,.ui[class*=\"tablet stackable\"].table tr>th{width:100%!important;display:block!important}.ui[class*=\"tablet stackable\"].table{padding:0}.ui[class*=\"tablet stackable\"].table tfoot,.ui[class*=\"tablet stackable\"].table thead{display:block}.ui[class*=\"tablet stackable\"].table tr{padding-top:1em;padding-bottom:1em;box-shadow:inset 0 -1px 0 0 rgba(0,0,0,.1)!important}.ui[class*=\"tablet stackable\"].table tr>td,.ui[class*=\"tablet stackable\"].table tr>th{background:none;border:none!important;padding:.25em .75em;box-shadow:none!important}.ui.definition[class*=\"tablet stackable\"].table thead th:first-child{box-shadow:none!important}}.ui.table[class*=\"left aligned\"],.ui.table [class*=\"left aligned\"]{text-align:left}.ui.table[class*=\"center aligned\"],.ui.table [class*=\"center aligned\"]{text-align:center}.ui.table[class*=\"right aligned\"],.ui.table [class*=\"right aligned\"]{text-align:right}.ui.table[class*=\"top aligned\"],.ui.table [class*=\"top aligned\"]{vertical-align:top}.ui.table[class*=\"middle aligned\"],.ui.table [class*=\"middle aligned\"]{vertical-align:middle}.ui.table[class*=\"bottom aligned\"],.ui.table [class*=\"bottom aligned\"]{vertical-align:bottom}.ui.table td.collapsing,.ui.table th.collapsing{width:1px;white-space:nowrap}.ui.fixed.table{table-layout:fixed}.ui.fixed.table td,.ui.fixed.table th{overflow:hidden;text-overflow:ellipsis}.ui.selectable.table tbody tr:hover,.ui.table tbody tr td.selectable:hover{background:rgba(0,0,0,.05)!important;color:rgba(0,0,0,.95)!important}.ui.inverted.table tbody tr td.selectable:hover,.ui.selectable.inverted.table tbody tr:hover{background:hsla(0,0%,100%,.08)!important;color:#fff!important}.ui.table tbody tr td.selectable{padding:0}.ui.table tbody tr td.selectable>a:not(.ui){display:block;color:inherit;padding:.64705882em}.ui.selectable.table tr.error:hover,.ui.selectable.table tr:hover td.error,.ui.table tr td.selectable.error:hover{background:#fcd2e8!important;color:#7f0149!important}.ui.selectable.table tr.warning:hover,.ui.selectable.table tr:hover td.warning,.ui.table tr td.selectable.warning:hover{background:#ffeeae!important;color:#644900!important}.ui.selectable.table tr.active:hover,.ui.selectable.table tr:hover td.active,.ui.table tr td.selectable.active:hover{background:#e0e0e0!important;color:rgba(0,0,0,.87)!important}.ui.selectable.table tr.positive:hover,.ui.selectable.table tr:hover td.positive,.ui.table tr td.selectable.positive:hover{background:#dff2c3!important;color:#225816!important}.ui.selectable.table tr.negative:hover,.ui.selectable.table tr:hover td.negative,.ui.table tr td.selectable.negative:hover{background:#fcd2e8!important;color:#7f0149!important}.ui.attached.table{top:0;bottom:0;border-radius:0;margin:0 -1px;width:calc(100% + 2px);max-width:calc(100% + 2px);box-shadow:none;border:1px solid #d4d4d5}.ui.attached+.ui.attached.table:not(.top){border-top:none}.ui[class*=\"top attached\"].table{bottom:0;margin-bottom:0;top:0;margin-top:1em;border-radius:.11764706rem .11764706rem 0 0}.ui.table[class*=\"top attached\"]:first-child{margin-top:0}.ui[class*=\"bottom attached\"].table{bottom:0;margin-top:0;top:0;margin-bottom:1em;box-shadow:none,none;border-radius:0 0 .11764706rem .11764706rem}.ui[class*=\"bottom attached\"].table:last-child{margin-bottom:0}.ui.striped.table>tr:nth-child(2n),.ui.striped.table tbody tr:nth-child(2n){background-color:rgba(0,0,50,.02)}.ui.inverted.striped.table>tr:nth-child(2n),.ui.inverted.striped.table tbody tr:nth-child(2n){background-color:hsla(0,0%,100%,.05)}.ui.striped.selectable.selectable.selectable.table tbody tr.active:hover{background:#efefef!important;color:rgba(0,0,0,.95)!important}.ui.table[class*=\"single line\"],.ui.table [class*=\"single line\"]{white-space:nowrap}.ui.red.table{border-top:.2em solid #e23c4e}.ui.inverted.red.table{background-color:#e23c4e!important;color:#fff!important}.ui.orange.table{border-top:.2em solid #f8813d}.ui.inverted.orange.table{background-color:#f8813d!important;color:#fff!important}.ui.yellow.table{border-top:.2em solid #ffca18}.ui.inverted.yellow.table{background-color:#ffca18!important;color:#fff!important}.ui.olive.table{border-top:.2em solid #456558}.ui.inverted.olive.table{background-color:#456558!important;color:#fff!important}.ui.green.table{border-top:.2em solid #54af71}.ui.inverted.green.table{background-color:#54af71!important;color:#fff!important}.ui.teal.table{border-top:.2em solid #00a1ca}.ui.inverted.teal.table{background-color:#00a1ca!important;color:#fff!important}.ui.blue.table{border-top:.2em solid #1d5f82}.ui.inverted.blue.table{background-color:#1d5f82!important;color:#fff!important}.ui.violet.table{border-top:.2em solid #525394}.ui.inverted.violet.table{background-color:#525394!important;color:#fff!important}.ui.purple.table{border-top:.2em solid #ad427f}.ui.inverted.purple.table{background-color:#ad427f!important;color:#fff!important}.ui.pink.table{border-top:.2em solid #e03997}.ui.inverted.pink.table{background-color:#e03997!important;color:#fff!important}.ui.brown.table{border-top:.2em solid #a67a00}.ui.inverted.brown.table{background-color:#a67a00!important;color:#fff!important}.ui.grey.table{border-top:.2em solid #5a686d}.ui.inverted.grey.table{background-color:#5a686d!important;color:#fff!important}.ui.black.table{border-top:.2em solid #1b1c1d}.ui.inverted.black.table{background-color:#1b1c1d!important;color:#fff!important}.ui.one.column.table td{width:100%}.ui.two.column.table td{width:50%}.ui.three.column.table td{width:33.33333333%}.ui.four.column.table td{width:25%}.ui.five.column.table td{width:20%}.ui.six.column.table td{width:16.66666667%}.ui.seven.column.table td{width:14.28571429%}.ui.eight.column.table td{width:12.5%}.ui.nine.column.table td{width:11.11111111%}.ui.ten.column.table td{width:10%}.ui.eleven.column.table td{width:9.09090909%}.ui.twelve.column.table td{width:8.33333333%}.ui.thirteen.column.table td{width:7.69230769%}.ui.fourteen.column.table td{width:7.14285714%}.ui.fifteen.column.table td{width:6.66666667%}.ui.sixteen.column.table td,.ui.table td.one.wide,.ui.table th.one.wide{width:6.25%}.ui.table td.two.wide,.ui.table th.two.wide{width:12.5%}.ui.table td.three.wide,.ui.table th.three.wide{width:18.75%}.ui.table td.four.wide,.ui.table th.four.wide{width:25%}.ui.table td.five.wide,.ui.table th.five.wide{width:31.25%}.ui.table td.six.wide,.ui.table th.six.wide{width:37.5%}.ui.table td.seven.wide,.ui.table th.seven.wide{width:43.75%}.ui.table td.eight.wide,.ui.table th.eight.wide{width:50%}.ui.table td.nine.wide,.ui.table th.nine.wide{width:56.25%}.ui.table td.ten.wide,.ui.table th.ten.wide{width:62.5%}.ui.table td.eleven.wide,.ui.table th.eleven.wide{width:68.75%}.ui.table td.twelve.wide,.ui.table th.twelve.wide{width:75%}.ui.table td.thirteen.wide,.ui.table th.thirteen.wide{width:81.25%}.ui.table td.fourteen.wide,.ui.table th.fourteen.wide{width:87.5%}.ui.table td.fifteen.wide,.ui.table th.fifteen.wide{width:93.75%}.ui.table td.sixteen.wide,.ui.table th.sixteen.wide{width:100%}.ui.sortable.table thead th{cursor:pointer;white-space:nowrap;border-left:1px solid rgba(34,36,38,.15);color:rgba(0,0,0,.87)}.ui.sortable.table thead th:first-child{border-left:none}.ui.sortable.table thead th.sorted,.ui.sortable.table thead th.sorted:hover{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.ui.sortable.table thead th:after{display:none;font-style:normal;font-weight:400;text-decoration:inherit;content:'';height:1em;width:auto;opacity:.8;margin:0 0 0 .5em;font-family:Icons}.ui.sortable.table thead th.ascending:after{content:'\\F0D8'}.ui.sortable.table thead th.descending:after{content:'\\F0D7'}.ui.sortable.table th.disabled:hover{cursor:auto;color:rgba(40,40,40,.3)}.ui.sortable.table thead th:hover{background:rgba(0,0,0,.05);color:rgba(0,0,0,.8)}.ui.sortable.table thead th.sorted{background:rgba(0,0,0,.05);color:rgba(0,0,0,.95)}.ui.sortable.table thead th.sorted:after{display:inline-block}.ui.sortable.table thead th.sorted:hover{background:rgba(0,0,0,.05);color:rgba(0,0,0,.95)}.ui.inverted.sortable.table thead th.sorted{background:hsla(0,0%,100%,.15) -webkit-linear-gradient(transparent,rgba(0,0,0,.05));background:hsla(0,0%,100%,.15) linear-gradient(transparent,rgba(0,0,0,.05));color:#fff}.ui.inverted.sortable.table thead th:hover{background:hsla(0,0%,100%,.08) -webkit-linear-gradient(transparent,rgba(0,0,0,.05));background:hsla(0,0%,100%,.08) linear-gradient(transparent,rgba(0,0,0,.05));color:#fff}.ui.inverted.sortable.table thead th{border-left-color:transparent;border-right-color:transparent}.ui.inverted.table{background:#333;color:hsla(0,0%,100%,.9);border:none}.ui.inverted.table th{background-color:rgba(0,0,0,.15);color:hsla(0,0%,100%,.9)}.ui.inverted.table th,.ui.inverted.table tr td{border-color:hsla(0,0%,100%,.1)!important}.ui.inverted.table tr.disabled:hover td,.ui.inverted.table tr.disabled td,.ui.inverted.table tr:hover td.disabled,.ui.inverted.table tr td.disabled{pointer-events:none;color:hsla(0,0%,88%,.3)}.ui.inverted.definition.table tfoot:not(.full-width) th:first-child,.ui.inverted.definition.table thead:not(.full-width) th:first-child{background:transparent}.ui.inverted.definition.table tr td:first-child{background:hsla(0,0%,100%,.02);color:#fff}.ui.collapsing.table{width:auto}.ui.basic.table{background:transparent;border:1px solid rgba(34,36,38,.15);box-shadow:none}.ui.basic.table tfoot,.ui.basic.table thead{box-shadow:none}.ui.basic.table th{background:transparent;border-left:none}.ui.basic.table tbody tr{border-bottom:1px solid rgba(0,0,0,.1)}.ui.basic.table td{background:transparent}.ui.basic.striped.table tbody tr:nth-child(2n){background-color:rgba(0,0,0,.05)!important}.ui[class*=\"very basic\"].table{border:none}.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td,.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th{padding:''}.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td:first-child,.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th:first-child{padding-left:0}.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) td:last-child,.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) th:last-child{padding-right:0}.ui[class*=\"very basic\"].table:not(.sortable):not(.striped) thead tr:first-child th{padding-top:0}.ui.celled.table tr td,.ui.celled.table tr th{border-left:1px solid rgba(34,36,38,.1)}.ui.celled.table tr td:first-child,.ui.celled.table tr th:first-child{border-left:none}.ui.padded.table th{padding-left:1em;padding-right:1em}.ui.padded.table td,.ui.padded.table th{padding:1em}.ui[class*=\"very padded\"].table th{padding-left:1.5em;padding-right:1.5em}.ui[class*=\"very padded\"].table td{padding:1.5em}.ui.compact.table th{padding-left:.7em;padding-right:.7em}.ui.compact.table td{padding:.5em .7em}.ui[class*=\"very compact\"].table th{padding-left:.6em;padding-right:.6em}.ui[class*=\"very compact\"].table td{padding:.4em .6em}.ui.small.table{font-size:.9em}.ui.table{font-size:1em}.ui.large.table{font-size:1.1em}.ui.table{border-style:none none solid}.caption .ui.table,.ui.caption.table,.ui.table{font-family:Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.infographic .ui.table,.ui.infographic.table{font-family:Benton Sans Cond,Source Sans Pro,Helvetica Neue,Arial,Helvetica,sans-serif}.text .ui.table,.ui.text.table{font-family:Georgia,serif}.text .ui.table thead th,.ui.text.table thead th{font-family:Publico Headline,Georgia,serif}.ui.definition.table:not(.celled) td:nth-child(2),.ui.definition.table:not(.celled) tfoot:not(.full-width) th:nth-child(2),.ui.definition.table:not(.celled) thead:not(.full-width) th:nth-child(2){border-left:none}", ""]);
	
	// exports


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".react-autosuggest__container{position:relative}.react-autosuggest__input{width:240px;height:30px!important;padding:10px 20px;font-family:Helvetica,sans-serif;font-weight:300;font-size:16px;border:1px solid #aaa;border-radius:4px}.react-autosuggest__input:focus{outline:none}.react-autosuggest__container--open .react-autosuggest__input{border-bottom-left-radius:0;border-bottom-right-radius:0}.react-autosuggest__suggestions-container{display:none}.react-autosuggest__container--open .react-autosuggest__suggestions-container{display:block;position:absolute;top:51px;width:280px;border:1px solid #aaa;background-color:#fff;font-family:Helvetica,sans-serif;font-weight:300;font-size:16px;border-bottom-left-radius:4px;border-bottom-right-radius:4px;z-index:2}.react-autosuggest__suggestions-list{margin:0;padding:0;list-style-type:none}.react-autosuggest__suggestion{cursor:pointer;padding:10px 20px}.react-autosuggest__suggestion--focused{background-color:#ddd}div.react-autosuggest__container{width:100%}input.react-autosuggest__input{width:100%;height:52px!important;text-align:center!important}div.react-autosuggest__suggestions-container{width:100%!important}", ""]);
	
	// exports


/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(3)();
	// imports
	
	
	// module
	exports.push([module.id, ".linechart-wrapper{max-width:640px;width:100%;margin:0 auto}@media screen and (max-width:650px) .ui.dimmable.segment.padded padding 0px 10px div.lead padding 0px 10px", ""]);
	
	// exports


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dispatch/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var noop = {value: function() {}};
	
	  function dispatch() {
	    for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	      if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	      _[t] = [];
	    }
	    return new Dispatch(_);
	  }
	
	  function Dispatch(_) {
	    this._ = _;
	  }
	
	  function parseTypenames(typenames, types) {
	    return typenames.trim().split(/^|\s+/).map(function(t) {
	      var name = "", i = t.indexOf(".");
	      if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	      if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	      return {type: t, name: name};
	    });
	  }
	
	  Dispatch.prototype = dispatch.prototype = {
	    constructor: Dispatch,
	    on: function(typename, callback) {
	      var _ = this._,
	          T = parseTypenames(typename + "", _),
	          t,
	          i = -1,
	          n = T.length;
	
	      // If no callback was specified, return the callback of the given type and name.
	      if (arguments.length < 2) {
	        while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	        return;
	      }
	
	      // If a type was specified, set the callback for the given type and name.
	      // Otherwise, if a null callback was specified, remove callbacks of the given name.
	      if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	      while (++i < n) {
	        if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
	        else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
	      }
	
	      return this;
	    },
	    copy: function() {
	      var copy = {}, _ = this._;
	      for (var t in _) copy[t] = _[t].slice();
	      return new Dispatch(copy);
	    },
	    call: function(type, that) {
	      if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	      if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	      for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	    },
	    apply: function(type, that, args) {
	      if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	      for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	    }
	  };
	
	  function get(type, name) {
	    for (var i = 0, n = type.length, c; i < n; ++i) {
	      if ((c = type[i]).name === name) {
	        return c.value;
	      }
	    }
	  }
	
	  function set(type, name, callback) {
	    for (var i = 0, n = type.length; i < n; ++i) {
	      if (type[i].name === name) {
	        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	        break;
	      }
	    }
	    if (callback != null) type.push({name: name, value: callback});
	    return type;
	  }
	
	  exports.dispatch = dispatch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dsv/ Version 1.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function(name, i) {
	    return JSON.stringify(name) + ": d[" + i + "]";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function(row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function(row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}
	
	function dsv(delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n]"),
	      delimiterCode = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert, columns, rows = parseRows(text, function(row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns;
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var EOL = {}, // sentinel value for end-of-line
	        EOF = {}, // sentinel value for end-of-file
	        rows = [], // output rows
	        N = text.length,
	        I = 0, // current character index
	        n = 0, // the current line number
	        t, // the current token
	        eol; // is the current token followed by EOL?
	
	    function token() {
	      if (I >= N) return EOF; // special case: end of file
	      if (eol) return eol = false, EOL; // special case: end of line
	
	      // special case: quotes
	      var j = I, c;
	      if (text.charCodeAt(j) === 34) {
	        var i = j;
	        while (i++ < N) {
	          if (text.charCodeAt(i) === 34) {
	            if (text.charCodeAt(i + 1) !== 34) break;
	            ++i;
	          }
	        }
	        I = i + 2;
	        c = text.charCodeAt(i + 1);
	        if (c === 13) {
	          eol = true;
	          if (text.charCodeAt(i + 2) === 10) ++I;
	        } else if (c === 10) {
	          eol = true;
	        }
	        return text.slice(j + 1, i).replace(/""/g, "\"");
	      }
	
	      // common case: find next delimiter or newline
	      while (I < N) {
	        var k = 1;
	        c = text.charCodeAt(I++);
	        if (c === 10) eol = true; // \n
	        else if (c === 13) { eol = true; if (text.charCodeAt(I) === 10) ++I, ++k; } // \r|\r\n
	        else if (c !== delimiterCode) continue;
	        return text.slice(j, I - k);
	      }
	
	      // special case: last token before EOF
	      return text.slice(j);
	    }
	
	    while ((t = token()) !== EOF) {
	      var a = [];
	      while (t !== EOL && t !== EOF) {
	        a.push(t);
	        t = token();
	      }
	      if (f && (a = f(a, n++)) == null) continue;
	      rows.push(a);
	    }
	
	    return rows;
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(rows.map(function(row) {
	      return columns.map(function(column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    })).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(text) {
	    return text == null ? ""
	        : reFormat.test(text += "") ? "\"" + text.replace(/\"/g, "\"\"") + "\""
	        : text;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatRows: formatRows
	  };
	}
	
	var csv = dsv(",");
	
	var csvParse = csv.parse;
	var csvParseRows = csv.parseRows;
	var csvFormat = csv.format;
	var csvFormatRows = csv.formatRows;
	
	var tsv = dsv("\t");
	
	var tsvParse = tsv.parse;
	var tsvParseRows = tsv.parseRows;
	var tsvFormat = tsv.format;
	var tsvFormatRows = tsv.formatRows;
	
	exports.dsvFormat = dsv;
	exports.csvParse = csvParse;
	exports.csvParseRows = csvParseRows;
	exports.csvFormat = csvFormat;
	exports.csvFormatRows = csvFormatRows;
	exports.tsvParse = tsvParse;
	exports.tsvParseRows = tsvParseRows;
	exports.tsvFormat = tsvFormat;
	exports.tsvFormatRows = tsvFormatRows;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  function define(constructor, factory, prototype) {
	    constructor.prototype = factory.prototype = prototype;
	    prototype.constructor = constructor;
	  }
	
	  function extend(parent, definition) {
	    var prototype = Object.create(parent.prototype);
	    for (var key in definition) prototype[key] = definition[key];
	    return prototype;
	  }
	
	  function Color() {}
	
	  var darker = 0.7;
	  var brighter = 1 / darker;
	
	  var reHex3 = /^#([0-9a-f]{3})$/;
	  var reHex6 = /^#([0-9a-f]{6})$/;
	  var reRgbInteger = /^rgb\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*\)$/;
	  var reRgbPercent = /^rgb\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	  var reRgbaInteger = /^rgba\(\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+)\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	  var reRgbaPercent = /^rgba\(\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	  var reHslPercent = /^hsl\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*\)$/;
	  var reHslaPercent = /^hsla\(\s*([-+]?\d+(?:\.\d+)?)\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)%\s*,\s*([-+]?\d+(?:\.\d+)?)\s*\)$/;
	  var named = {
	    aliceblue: 0xf0f8ff,
	    antiquewhite: 0xfaebd7,
	    aqua: 0x00ffff,
	    aquamarine: 0x7fffd4,
	    azure: 0xf0ffff,
	    beige: 0xf5f5dc,
	    bisque: 0xffe4c4,
	    black: 0x000000,
	    blanchedalmond: 0xffebcd,
	    blue: 0x0000ff,
	    blueviolet: 0x8a2be2,
	    brown: 0xa52a2a,
	    burlywood: 0xdeb887,
	    cadetblue: 0x5f9ea0,
	    chartreuse: 0x7fff00,
	    chocolate: 0xd2691e,
	    coral: 0xff7f50,
	    cornflowerblue: 0x6495ed,
	    cornsilk: 0xfff8dc,
	    crimson: 0xdc143c,
	    cyan: 0x00ffff,
	    darkblue: 0x00008b,
	    darkcyan: 0x008b8b,
	    darkgoldenrod: 0xb8860b,
	    darkgray: 0xa9a9a9,
	    darkgreen: 0x006400,
	    darkgrey: 0xa9a9a9,
	    darkkhaki: 0xbdb76b,
	    darkmagenta: 0x8b008b,
	    darkolivegreen: 0x556b2f,
	    darkorange: 0xff8c00,
	    darkorchid: 0x9932cc,
	    darkred: 0x8b0000,
	    darksalmon: 0xe9967a,
	    darkseagreen: 0x8fbc8f,
	    darkslateblue: 0x483d8b,
	    darkslategray: 0x2f4f4f,
	    darkslategrey: 0x2f4f4f,
	    darkturquoise: 0x00ced1,
	    darkviolet: 0x9400d3,
	    deeppink: 0xff1493,
	    deepskyblue: 0x00bfff,
	    dimgray: 0x696969,
	    dimgrey: 0x696969,
	    dodgerblue: 0x1e90ff,
	    firebrick: 0xb22222,
	    floralwhite: 0xfffaf0,
	    forestgreen: 0x228b22,
	    fuchsia: 0xff00ff,
	    gainsboro: 0xdcdcdc,
	    ghostwhite: 0xf8f8ff,
	    gold: 0xffd700,
	    goldenrod: 0xdaa520,
	    gray: 0x808080,
	    green: 0x008000,
	    greenyellow: 0xadff2f,
	    grey: 0x808080,
	    honeydew: 0xf0fff0,
	    hotpink: 0xff69b4,
	    indianred: 0xcd5c5c,
	    indigo: 0x4b0082,
	    ivory: 0xfffff0,
	    khaki: 0xf0e68c,
	    lavender: 0xe6e6fa,
	    lavenderblush: 0xfff0f5,
	    lawngreen: 0x7cfc00,
	    lemonchiffon: 0xfffacd,
	    lightblue: 0xadd8e6,
	    lightcoral: 0xf08080,
	    lightcyan: 0xe0ffff,
	    lightgoldenrodyellow: 0xfafad2,
	    lightgray: 0xd3d3d3,
	    lightgreen: 0x90ee90,
	    lightgrey: 0xd3d3d3,
	    lightpink: 0xffb6c1,
	    lightsalmon: 0xffa07a,
	    lightseagreen: 0x20b2aa,
	    lightskyblue: 0x87cefa,
	    lightslategray: 0x778899,
	    lightslategrey: 0x778899,
	    lightsteelblue: 0xb0c4de,
	    lightyellow: 0xffffe0,
	    lime: 0x00ff00,
	    limegreen: 0x32cd32,
	    linen: 0xfaf0e6,
	    magenta: 0xff00ff,
	    maroon: 0x800000,
	    mediumaquamarine: 0x66cdaa,
	    mediumblue: 0x0000cd,
	    mediumorchid: 0xba55d3,
	    mediumpurple: 0x9370db,
	    mediumseagreen: 0x3cb371,
	    mediumslateblue: 0x7b68ee,
	    mediumspringgreen: 0x00fa9a,
	    mediumturquoise: 0x48d1cc,
	    mediumvioletred: 0xc71585,
	    midnightblue: 0x191970,
	    mintcream: 0xf5fffa,
	    mistyrose: 0xffe4e1,
	    moccasin: 0xffe4b5,
	    navajowhite: 0xffdead,
	    navy: 0x000080,
	    oldlace: 0xfdf5e6,
	    olive: 0x808000,
	    olivedrab: 0x6b8e23,
	    orange: 0xffa500,
	    orangered: 0xff4500,
	    orchid: 0xda70d6,
	    palegoldenrod: 0xeee8aa,
	    palegreen: 0x98fb98,
	    paleturquoise: 0xafeeee,
	    palevioletred: 0xdb7093,
	    papayawhip: 0xffefd5,
	    peachpuff: 0xffdab9,
	    peru: 0xcd853f,
	    pink: 0xffc0cb,
	    plum: 0xdda0dd,
	    powderblue: 0xb0e0e6,
	    purple: 0x800080,
	    rebeccapurple: 0x663399,
	    red: 0xff0000,
	    rosybrown: 0xbc8f8f,
	    royalblue: 0x4169e1,
	    saddlebrown: 0x8b4513,
	    salmon: 0xfa8072,
	    sandybrown: 0xf4a460,
	    seagreen: 0x2e8b57,
	    seashell: 0xfff5ee,
	    sienna: 0xa0522d,
	    silver: 0xc0c0c0,
	    skyblue: 0x87ceeb,
	    slateblue: 0x6a5acd,
	    slategray: 0x708090,
	    slategrey: 0x708090,
	    snow: 0xfffafa,
	    springgreen: 0x00ff7f,
	    steelblue: 0x4682b4,
	    tan: 0xd2b48c,
	    teal: 0x008080,
	    thistle: 0xd8bfd8,
	    tomato: 0xff6347,
	    turquoise: 0x40e0d0,
	    violet: 0xee82ee,
	    wheat: 0xf5deb3,
	    white: 0xffffff,
	    whitesmoke: 0xf5f5f5,
	    yellow: 0xffff00,
	    yellowgreen: 0x9acd32
	  };
	
	  define(Color, color, {
	    displayable: function() {
	      return this.rgb().displayable();
	    },
	    toString: function() {
	      return this.rgb() + "";
	    }
	  });
	
	  function color(format) {
	    var m;
	    format = (format + "").trim().toLowerCase();
	    return (m = reHex3.exec(format)) ? (m = parseInt(m[1], 16), new Rgb((m >> 8 & 0xf) | (m >> 4 & 0x0f0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1)) // #f00
	        : (m = reHex6.exec(format)) ? rgbn(parseInt(m[1], 16)) // #ff0000
	        : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	        : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	        : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	        : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	        : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	        : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	        : named.hasOwnProperty(format) ? rgbn(named[format])
	        : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	        : null;
	  }
	
	  function rgbn(n) {
	    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	  }
	
	  function rgba(r, g, b, a) {
	    if (a <= 0) r = g = b = NaN;
	    return new Rgb(r, g, b, a);
	  }
	
	  function rgbConvert(o) {
	    if (!(o instanceof Color)) o = color(o);
	    if (!o) return new Rgb;
	    o = o.rgb();
	    return new Rgb(o.r, o.g, o.b, o.opacity);
	  }
	
	  function rgb(r, g, b, opacity) {
	    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	  }
	
	  function Rgb(r, g, b, opacity) {
	    this.r = +r;
	    this.g = +g;
	    this.b = +b;
	    this.opacity = +opacity;
	  }
	
	  define(Rgb, rgb, extend(Color, {
	    brighter: function(k) {
	      k = k == null ? brighter : Math.pow(brighter, k);
	      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	    },
	    darker: function(k) {
	      k = k == null ? darker : Math.pow(darker, k);
	      return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	    },
	    rgb: function() {
	      return this;
	    },
	    displayable: function() {
	      return (0 <= this.r && this.r <= 255)
	          && (0 <= this.g && this.g <= 255)
	          && (0 <= this.b && this.b <= 255)
	          && (0 <= this.opacity && this.opacity <= 1);
	    },
	    toString: function() {
	      var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	      return (a === 1 ? "rgb(" : "rgba(")
	          + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	          + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	          + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	          + (a === 1 ? ")" : ", " + a + ")");
	    }
	  }));
	
	  function hsla(h, s, l, a) {
	    if (a <= 0) h = s = l = NaN;
	    else if (l <= 0 || l >= 1) h = s = NaN;
	    else if (s <= 0) h = NaN;
	    return new Hsl(h, s, l, a);
	  }
	
	  function hslConvert(o) {
	    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	    if (!(o instanceof Color)) o = color(o);
	    if (!o) return new Hsl;
	    if (o instanceof Hsl) return o;
	    o = o.rgb();
	    var r = o.r / 255,
	        g = o.g / 255,
	        b = o.b / 255,
	        min = Math.min(r, g, b),
	        max = Math.max(r, g, b),
	        h = NaN,
	        s = max - min,
	        l = (max + min) / 2;
	    if (s) {
	      if (r === max) h = (g - b) / s + (g < b) * 6;
	      else if (g === max) h = (b - r) / s + 2;
	      else h = (r - g) / s + 4;
	      s /= l < 0.5 ? max + min : 2 - max - min;
	      h *= 60;
	    } else {
	      s = l > 0 && l < 1 ? 0 : h;
	    }
	    return new Hsl(h, s, l, o.opacity);
	  }
	
	  function hsl(h, s, l, opacity) {
	    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	  }
	
	  function Hsl(h, s, l, opacity) {
	    this.h = +h;
	    this.s = +s;
	    this.l = +l;
	    this.opacity = +opacity;
	  }
	
	  define(Hsl, hsl, extend(Color, {
	    brighter: function(k) {
	      k = k == null ? brighter : Math.pow(brighter, k);
	      return new Hsl(this.h, this.s, this.l * k, this.opacity);
	    },
	    darker: function(k) {
	      k = k == null ? darker : Math.pow(darker, k);
	      return new Hsl(this.h, this.s, this.l * k, this.opacity);
	    },
	    rgb: function() {
	      var h = this.h % 360 + (this.h < 0) * 360,
	          s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	          l = this.l,
	          m2 = l + (l < 0.5 ? l : 1 - l) * s,
	          m1 = 2 * l - m2;
	      return new Rgb(
	        hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	        hsl2rgb(h, m1, m2),
	        hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	        this.opacity
	      );
	    },
	    displayable: function() {
	      return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	          && (0 <= this.l && this.l <= 1)
	          && (0 <= this.opacity && this.opacity <= 1);
	    }
	  }));
	
	  /* From FvD 13.37, CSS Color Module Level 3 */
	  function hsl2rgb(h, m1, m2) {
	    return (h < 60 ? m1 + (m2 - m1) * h / 60
	        : h < 180 ? m2
	        : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	        : m1) * 255;
	  }
	
	  var deg2rad = Math.PI / 180;
	  var rad2deg = 180 / Math.PI;
	
	  var Kn = 18;
	  var Xn = 0.950470;
	  var Yn = 1;
	  var Zn = 1.088830;
	  var t0 = 4 / 29;
	  var t1 = 6 / 29;
	  var t2 = 3 * t1 * t1;
	  var t3 = t1 * t1 * t1;
	  function labConvert(o) {
	    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	    if (o instanceof Hcl) {
	      var h = o.h * deg2rad;
	      return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	    }
	    if (!(o instanceof Rgb)) o = rgbConvert(o);
	    var b = rgb2xyz(o.r),
	        a = rgb2xyz(o.g),
	        l = rgb2xyz(o.b),
	        x = xyz2lab((0.4124564 * b + 0.3575761 * a + 0.1804375 * l) / Xn),
	        y = xyz2lab((0.2126729 * b + 0.7151522 * a + 0.0721750 * l) / Yn),
	        z = xyz2lab((0.0193339 * b + 0.1191920 * a + 0.9503041 * l) / Zn);
	    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	  }
	
	  function lab(l, a, b, opacity) {
	    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	  }
	
	  function Lab(l, a, b, opacity) {
	    this.l = +l;
	    this.a = +a;
	    this.b = +b;
	    this.opacity = +opacity;
	  }
	
	  define(Lab, lab, extend(Color, {
	    brighter: function(k) {
	      return new Lab(this.l + Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	    },
	    darker: function(k) {
	      return new Lab(this.l - Kn * (k == null ? 1 : k), this.a, this.b, this.opacity);
	    },
	    rgb: function() {
	      var y = (this.l + 16) / 116,
	          x = isNaN(this.a) ? y : y + this.a / 500,
	          z = isNaN(this.b) ? y : y - this.b / 200;
	      y = Yn * lab2xyz(y);
	      x = Xn * lab2xyz(x);
	      z = Zn * lab2xyz(z);
	      return new Rgb(
	        xyz2rgb( 3.2404542 * x - 1.5371385 * y - 0.4985314 * z), // D65 -> sRGB
	        xyz2rgb(-0.9692660 * x + 1.8760108 * y + 0.0415560 * z),
	        xyz2rgb( 0.0556434 * x - 0.2040259 * y + 1.0572252 * z),
	        this.opacity
	      );
	    }
	  }));
	
	  function xyz2lab(t) {
	    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	  }
	
	  function lab2xyz(t) {
	    return t > t1 ? t * t * t : t2 * (t - t0);
	  }
	
	  function xyz2rgb(x) {
	    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	  }
	
	  function rgb2xyz(x) {
	    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	  }
	
	  function hclConvert(o) {
	    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	    if (!(o instanceof Lab)) o = labConvert(o);
	    var h = Math.atan2(o.b, o.a) * rad2deg;
	    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	  }
	
	  function hcl(h, c, l, opacity) {
	    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	  }
	
	  function Hcl(h, c, l, opacity) {
	    this.h = +h;
	    this.c = +c;
	    this.l = +l;
	    this.opacity = +opacity;
	  }
	
	  define(Hcl, hcl, extend(Color, {
	    brighter: function(k) {
	      return new Hcl(this.h, this.c, this.l + Kn * (k == null ? 1 : k), this.opacity);
	    },
	    darker: function(k) {
	      return new Hcl(this.h, this.c, this.l - Kn * (k == null ? 1 : k), this.opacity);
	    },
	    rgb: function() {
	      return labConvert(this).rgb();
	    }
	  }));
	
	  var A = -0.14861;
	  var B = +1.78277;
	  var C = -0.29227;
	  var D = -0.90649;
	  var E = +1.97294;
	  var ED = E * D;
	  var EB = E * B;
	  var BC_DA = B * C - D * A;
	  function cubehelixConvert(o) {
	    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	    if (!(o instanceof Rgb)) o = rgbConvert(o);
	    var r = o.r / 255,
	        g = o.g / 255,
	        b = o.b / 255,
	        l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	        bl = b - l,
	        k = (E * (g - l) - C * bl) / D,
	        s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	        h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	  }
	
	  function cubehelix(h, s, l, opacity) {
	    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	  }
	
	  function Cubehelix(h, s, l, opacity) {
	    this.h = +h;
	    this.s = +s;
	    this.l = +l;
	    this.opacity = +opacity;
	  }
	
	  define(Cubehelix, cubehelix, extend(Color, {
	    brighter: function(k) {
	      k = k == null ? brighter : Math.pow(brighter, k);
	      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	    },
	    darker: function(k) {
	      k = k == null ? darker : Math.pow(darker, k);
	      return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	    },
	    rgb: function() {
	      var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	          l = +this.l,
	          a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	          cosh = Math.cos(h),
	          sinh = Math.sin(h);
	      return new Rgb(
	        255 * (l + a * (A * cosh + B * sinh)),
	        255 * (l + a * (C * cosh + D * sinh)),
	        255 * (l + a * (E * cosh)),
	        this.opacity
	      );
	    }
	  }));
	
	  exports.color = color;
	  exports.rgb = rgb;
	  exports.hsl = hsl;
	  exports.lab = lab;
	  exports.hcl = hcl;
	  exports.cubehelix = cubehelix;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-path/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var pi = Math.PI;
	var tau = 2 * pi;
	var epsilon = 1e-6;
	var tauEpsilon = tau - epsilon;
	
	function Path() {
	  this._x0 = this._y0 = // start of current subpath
	  this._x1 = this._y1 = null; // end of current subpath
	  this._ = [];
	}
	
	function path() {
	  return new Path;
	}
	
	Path.prototype = path.prototype = {
	  constructor: Path,
	  moveTo: function(x, y) {
	    this._.push("M", this._x0 = this._x1 = +x, ",", this._y0 = this._y1 = +y);
	  },
	  closePath: function() {
	    if (this._x1 !== null) {
	      this._x1 = this._x0, this._y1 = this._y0;
	      this._.push("Z");
	    }
	  },
	  lineTo: function(x, y) {
	    this._.push("L", this._x1 = +x, ",", this._y1 = +y);
	  },
	  quadraticCurveTo: function(x1, y1, x, y) {
	    this._.push("Q", +x1, ",", +y1, ",", this._x1 = +x, ",", this._y1 = +y);
	  },
	  bezierCurveTo: function(x1, y1, x2, y2, x, y) {
	    this._.push("C", +x1, ",", +y1, ",", +x2, ",", +y2, ",", this._x1 = +x, ",", this._y1 = +y);
	  },
	  arcTo: function(x1, y1, x2, y2, r) {
	    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
	    var x0 = this._x1,
	        y0 = this._y1,
	        x21 = x2 - x1,
	        y21 = y2 - y1,
	        x01 = x0 - x1,
	        y01 = y0 - y1,
	        l01_2 = x01 * x01 + y01 * y01;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x1,y1).
	    if (this._x1 === null) {
	      this._.push(
	        "M", this._x1 = x1, ",", this._y1 = y1
	      );
	    }
	
	    // Or, is (x1,y1) coincident with (x0,y0)? Do nothing.
	    else if (!(l01_2 > epsilon)) {}
	
	    // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
	    // Equivalently, is (x1,y1) coincident with (x2,y2)?
	    // Or, is the radius zero? Line to (x1,y1).
	    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) {
	      this._.push(
	        "L", this._x1 = x1, ",", this._y1 = y1
	      );
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      var x20 = x2 - x0,
	          y20 = y2 - y0,
	          l21_2 = x21 * x21 + y21 * y21,
	          l20_2 = x20 * x20 + y20 * y20,
	          l21 = Math.sqrt(l21_2),
	          l01 = Math.sqrt(l01_2),
	          l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2),
	          t01 = l / l01,
	          t21 = l / l21;
	
	      // If the start tangent is not coincident with (x0,y0), line to.
	      if (Math.abs(t01 - 1) > epsilon) {
	        this._.push(
	          "L", x1 + t01 * x01, ",", y1 + t01 * y01
	        );
	      }
	
	      this._.push(
	        "A", r, ",", r, ",0,0,", +(y01 * x20 > x01 * y20), ",", this._x1 = x1 + t21 * x21, ",", this._y1 = y1 + t21 * y21
	      );
	    }
	  },
	  arc: function(x, y, r, a0, a1, ccw) {
	    x = +x, y = +y, r = +r;
	    var dx = r * Math.cos(a0),
	        dy = r * Math.sin(a0),
	        x0 = x + dx,
	        y0 = y + dy,
	        cw = 1 ^ ccw,
	        da = ccw ? a0 - a1 : a1 - a0;
	
	    // Is the radius negative? Error.
	    if (r < 0) throw new Error("negative radius: " + r);
	
	    // Is this path empty? Move to (x0,y0).
	    if (this._x1 === null) {
	      this._.push(
	        "M", x0, ",", y0
	      );
	    }
	
	    // Or, is (x0,y0) not coincident with the previous point? Line to (x0,y0).
	    else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) {
	      this._.push(
	        "L", x0, ",", y0
	      );
	    }
	
	    // Is this arc empty? We’re done.
	    if (!r) return;
	
	    // Is this a complete circle? Draw two arcs to complete the circle.
	    if (da > tauEpsilon) {
	      this._.push(
	        "A", r, ",", r, ",0,1,", cw, ",", x - dx, ",", y - dy,
	        "A", r, ",", r, ",0,1,", cw, ",", this._x1 = x0, ",", this._y1 = y0
	      );
	    }
	
	    // Otherwise, draw an arc!
	    else {
	      if (da < 0) da = da % tau + tau;
	      this._.push(
	        "A", r, ",", r, ",0,", +(da >= pi), ",", cw, ",", this._x1 = x + r * Math.cos(a1), ",", this._y1 = y + r * Math.sin(a1)
	      );
	    }
	  },
	  rect: function(x, y, w, h) {
	    this._.push("M", this._x0 = this._x1 = +x, ",", this._y0 = this._y1 = +y, "h", +w, "v", +h, "h", -w, "Z");
	  },
	  toString: function() {
	    return this._.join("");
	  }
	};
	
	exports.path = path;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));

/***/ },
/* 227 */
225,
/* 228 */
/***/ function(module, exports) {

	module.exports = function(opts) {
	  return new ElementClass(opts)
	}
	
	function indexOf(arr, prop) {
	  if (arr.indexOf) return arr.indexOf(prop)
	  for (var i = 0, len = arr.length; i < len; i++)
	    if (arr[i] === prop) return i
	  return -1
	}
	
	function ElementClass(opts) {
	  if (!(this instanceof ElementClass)) return new ElementClass(opts)
	  var self = this
	  if (!opts) opts = {}
	
	  // similar doing instanceof HTMLElement but works in IE8
	  if (opts.nodeType) opts = {el: opts}
	
	  this.opts = opts
	  this.el = opts.el || document.body
	  if (typeof this.el !== 'object') this.el = document.querySelector(this.el)
	}
	
	ElementClass.prototype.add = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return el.className = className
	  var classes = el.className.split(' ')
	  if (indexOf(classes, className) > -1) return classes
	  classes.push(className)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.remove = function(className) {
	  var el = this.el
	  if (!el) return
	  if (el.className === "") return
	  var classes = el.className.split(' ')
	  var idx = indexOf(classes, className)
	  if (idx > -1) classes.splice(idx, 1)
	  el.className = classes.join(' ')
	  return classes
	}
	
	ElementClass.prototype.has = function(className) {
	  var el = this.el
	  if (!el) return
	  var classes = el.className.split(' ')
	  return indexOf(classes, className) > -1
	}
	
	ElementClass.prototype.toggle = function(className) {
	  var el = this.el
	  if (!el) return
	  if (this.has(className)) this.remove(className)
	  else this.add(className)
	}


/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Resize detection strategy that injects objects to elements in order to detect resize events.
	 * Heavily inspired by: http://www.backalleycoder.com/2013/03/18/cross-browser-event-based-element-resize-detection/
	 */
	
	"use strict";
	
	var browserDetector = __webpack_require__(94);
	
	module.exports = function(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var batchProcessor  = options.batchProcessor;
	    var getState        = options.stateHandler.getState;
	
	    if(!reporter) {
	        throw new Error("Missing required dependency: reporter.");
	    }
	
	    /**
	     * Adds a resize event listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
	     */
	    function addListener(element, listener) {
	        if(!getObject(element)) {
	            throw new Error("Element is not detectable by this strategy.");
	        }
	
	        function listenerProxy() {
	            listener(element);
	        }
	
	        if(browserDetector.isIE(8)) {
	            //IE 8 does not support object, but supports the resize event directly on elements.
	            getState(element).object = {
	                proxy: listenerProxy
	            };
	            element.attachEvent("onresize", listenerProxy);
	        } else {
	            var object = getObject(element);
	            object.contentDocument.defaultView.addEventListener("resize", listenerProxy);
	        }
	    }
	
	    /**
	     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
	     * @private
	     * @param {object} options Optional options object.
	     * @param {element} element The element to make detectable
	     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
	     */
	    function makeDetectable(options, element, callback) {
	        if (!callback) {
	            callback = element;
	            element = options;
	            options = null;
	        }
	
	        options = options || {};
	        var debug = options.debug;
	
	        function injectObject(element, callback) {
	            var OBJECT_STYLE = "display: block; position: absolute; top: 0; left: 0; width: 100%; height: 100%; border: none; padding: 0; margin: 0; opacity: 0; z-index: -1000; pointer-events: none;";
	
	            //The target element needs to be positioned (everything except static) so the absolute positioned object will be positioned relative to the target element.
	
	            // Position altering may be performed directly or on object load, depending on if style resolution is possible directly or not.
	            var positionCheckPerformed = false;
	
	            // The element may not yet be attached to the DOM, and therefore the style object may be empty in some browsers.
	            // Since the style object is a reference, it will be updated as soon as the element is attached to the DOM.
	            var style = window.getComputedStyle(element);
	            var width = element.offsetWidth;
	            var height = element.offsetHeight;
	
	            getState(element).startSize = {
	                width: width,
	                height: height
	            };
	
	            function mutateDom() {
	                function alterPositionStyles() {
	                    if(style.position === "static") {
	                        element.style.position = "relative";
	
	                        var removeRelativeStyles = function(reporter, element, style, property) {
	                            function getNumericalValue(value) {
	                                return value.replace(/[^-\d\.]/g, "");
	                            }
	
	                            var value = style[property];
	
	                            if(value !== "auto" && getNumericalValue(value) !== "0") {
	                                reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
	                                element.style[property] = 0;
	                            }
	                        };
	
	                        //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
	                        //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
	                        removeRelativeStyles(reporter, element, style, "top");
	                        removeRelativeStyles(reporter, element, style, "right");
	                        removeRelativeStyles(reporter, element, style, "bottom");
	                        removeRelativeStyles(reporter, element, style, "left");
	                    }
	                }
	
	                function onObjectLoad() {
	                    // The object has been loaded, which means that the element now is guaranteed to be attached to the DOM.
	                    if (!positionCheckPerformed) {
	                        alterPositionStyles();
	                    }
	
	                    /*jshint validthis: true */
	
	                    function getDocument(element, callback) {
	                        //Opera 12 seem to call the object.onload before the actual document has been created.
	                        //So if it is not present, poll it with an timeout until it is present.
	                        //TODO: Could maybe be handled better with object.onreadystatechange or similar.
	                        if(!element.contentDocument) {
	                            setTimeout(function checkForObjectDocument() {
	                                getDocument(element, callback);
	                            }, 100);
	
	                            return;
	                        }
	
	                        callback(element.contentDocument);
	                    }
	
	                    //Mutating the object element here seems to fire another load event.
	                    //Mutating the inner document of the object element is fine though.
	                    var objectElement = this;
	
	                    //Create the style element to be added to the object.
	                    getDocument(objectElement, function onObjectDocumentReady(objectDocument) {
	                        //Notify that the element is ready to be listened to.
	                        callback(element);
	                    });
	                }
	
	                // The element may be detached from the DOM, and some browsers does not support style resolving of detached elements.
	                // The alterPositionStyles needs to be delayed until we know the element has been attached to the DOM (which we are sure of when the onObjectLoad has been fired), if style resolution is not possible.
	                if (style.position !== "") {
	                    alterPositionStyles(style);
	                    positionCheckPerformed = true;
	                }
	
	                //Add an object element as a child to the target element that will be listened to for resize events.
	                var object = document.createElement("object");
	                object.style.cssText = OBJECT_STYLE;
	                object.type = "text/html";
	                object.onload = onObjectLoad;
	
	                //Safari: This must occur before adding the object to the DOM.
	                //IE: Does not like that this happens before, even if it is also added after.
	                if(!browserDetector.isIE()) {
	                    object.data = "about:blank";
	                }
	
	                element.appendChild(object);
	                getState(element).object = object;
	
	                //IE: This must occur after adding the object to the DOM.
	                if(browserDetector.isIE()) {
	                    object.data = "about:blank";
	                }
	            }
	
	            if(batchProcessor) {
	                batchProcessor.add(mutateDom);
	            } else {
	                mutateDom();
	            }
	        }
	
	        if(browserDetector.isIE(8)) {
	            //IE 8 does not support objects properly. Luckily they do support the resize event.
	            //So do not inject the object and notify that the element is already ready to be listened to.
	            //The event handler for the resize event is attached in the utils.addListener instead.
	            callback(element);
	        } else {
	            injectObject(element, callback);
	        }
	    }
	
	    /**
	     * Returns the child object of the target element.
	     * @private
	     * @param {element} element The target element.
	     * @returns The object element of the target.
	     */
	    function getObject(element) {
	        return getState(element).object;
	    }
	
	    function uninstall(element) {
	        if(browserDetector.isIE(8)) {
	            element.detachEvent("onresize", getState(element).object.proxy);
	        } else {
	            element.removeChild(getObject(element));
	        }
	        delete getState(element).object;
	    }
	
	    return {
	        makeDetectable: makeDetectable,
	        addListener: addListener,
	        uninstall: uninstall
	    };
	};


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Resize detection strategy that injects divs to elements in order to detect resize events on scroll events.
	 * Heavily inspired by: https://github.com/marcj/css-element-queries/blob/master/src/ResizeSensor.js
	 */
	
	"use strict";
	
	var forEach = __webpack_require__(95).forEach;
	
	module.exports = function(options) {
	    options             = options || {};
	    var reporter        = options.reporter;
	    var batchProcessor  = options.batchProcessor;
	    var getState        = options.stateHandler.getState;
	    var hasState        = options.stateHandler.hasState;
	    var idHandler       = options.idHandler;
	
	    if (!batchProcessor) {
	        throw new Error("Missing required dependency: batchProcessor");
	    }
	
	    if (!reporter) {
	        throw new Error("Missing required dependency: reporter.");
	    }
	
	    //TODO: Could this perhaps be done at installation time?
	    var scrollbarSizes = getScrollbarSizes();
	
	    // Inject the scrollbar styling that prevents them from appearing sometimes in Chrome.
	    // The injected container needs to have a class, so that it may be styled with CSS (pseudo elements).
	    var styleId = "erd_scroll_detection_scrollbar_style";
	    var detectionContainerClass = "erd_scroll_detection_container";
	    injectScrollStyle(styleId, detectionContainerClass);
	
	    function getScrollbarSizes() {
	        var width = 500;
	        var height = 500;
	
	        var child = document.createElement("div");
	        child.style.cssText = "position: absolute; width: " + width*2 + "px; height: " + height*2 + "px; visibility: hidden; margin: 0; padding: 0;";
	
	        var container = document.createElement("div");
	        container.style.cssText = "position: absolute; width: " + width + "px; height: " + height + "px; overflow: scroll; visibility: none; top: " + -width*3 + "px; left: " + -height*3 + "px; visibility: hidden; margin: 0; padding: 0;";
	
	        container.appendChild(child);
	
	        document.body.insertBefore(container, document.body.firstChild);
	
	        var widthSize = width - container.clientWidth;
	        var heightSize = height - container.clientHeight;
	
	        document.body.removeChild(container);
	
	        return {
	            width: widthSize,
	            height: heightSize
	        };
	    }
	
	    function injectScrollStyle(styleId, containerClass) {
	        function injectStyle(style, method) {
	            method = method || function (element) {
	                document.head.appendChild(element);
	            };
	
	            var styleElement = document.createElement("style");
	            styleElement.innerHTML = style;
	            styleElement.id = styleId;
	            method(styleElement);
	            return styleElement;
	        }
	
	        if (!document.getElementById(styleId)) {
	            var containerAnimationClass = containerClass + "_animation";
	            var containerAnimationActiveClass = containerClass + "_animation_active";
	            var style = "/* Created by the element-resize-detector library. */\n";
	            style += "." + containerClass + " > div::-webkit-scrollbar { display: none; }\n\n";
	            style += "." + containerAnimationActiveClass + " { -webkit-animation-duration: 0.1s; animation-duration: 0.1s; -webkit-animation-name: " + containerAnimationClass + "; animation-name: " + containerAnimationClass + "; }\n";
	            style += "@-webkit-keyframes " + containerAnimationClass +  " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }\n";
	            style += "@keyframes " + containerAnimationClass +          " { 0% { opacity: 1; } 50% { opacity: 0; } 100% { opacity: 1; } }";
	            injectStyle(style);
	        }
	    }
	
	    function addAnimationClass(element) {
	        element.className += " " + detectionContainerClass + "_animation_active";
	    }
	
	    function addEvent(el, name, cb) {
	        if (el.addEventListener) {
	            el.addEventListener(name, cb);
	        } else if(el.attachEvent) {
	            el.attachEvent("on" + name, cb);
	        } else {
	            return reporter.error("[scroll] Don't know how to add event listeners.");
	        }
	    }
	
	    function removeEvent(el, name, cb) {
	        if (el.removeEventListener) {
	            el.removeEventListener(name, cb);
	        } else if(el.detachEvent) {
	            el.detachEvent("on" + name, cb);
	        } else {
	            return reporter.error("[scroll] Don't know how to remove event listeners.");
	        }
	    }
	
	    function getExpandElement(element) {
	        return getState(element).container.childNodes[0].childNodes[0].childNodes[0];
	    }
	
	    function getShrinkElement(element) {
	        return getState(element).container.childNodes[0].childNodes[0].childNodes[1];
	    }
	
	    /**
	     * Adds a resize event listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The listener callback to be called for each resize event of the element. The element will be given as a parameter to the listener callback.
	     */
	    function addListener(element, listener) {
	        var listeners = getState(element).listeners;
	
	        if (!listeners.push) {
	            throw new Error("Cannot add listener to an element that is not detectable.");
	        }
	
	        getState(element).listeners.push(listener);
	    }
	
	    /**
	     * Makes an element detectable and ready to be listened for resize events. Will call the callback when the element is ready to be listened for resize changes.
	     * @private
	     * @param {object} options Optional options object.
	     * @param {element} element The element to make detectable
	     * @param {function} callback The callback to be called when the element is ready to be listened for resize changes. Will be called with the element as first parameter.
	     */
	    function makeDetectable(options, element, callback) {
	        if (!callback) {
	            callback = element;
	            element = options;
	            options = null;
	        }
	
	        options = options || {};
	
	        function debug() {
	            if (options.debug) {
	                var args = Array.prototype.slice.call(arguments);
	                args.unshift(idHandler.get(element), "Scroll: ");
	                if (reporter.log.apply) {
	                    reporter.log.apply(null, args);
	                } else {
	                    for (var i = 0; i < args.length; i++) {
	                        reporter.log(args[i]);
	                    }
	                }
	            }
	        }
	
	        function isDetached(element) {
	            function isInDocument(element) {
	                return element === element.ownerDocument.body || element.ownerDocument.body.contains(element);
	            }
	            return !isInDocument(element);
	        }
	
	        function isUnrendered(element) {
	            // Check the absolute positioned container since the top level container is display: inline.
	            var container = getState(element).container.childNodes[0];
	            return getComputedStyle(container).width.indexOf("px") === -1; //Can only compute pixel value when rendered.
	        }
	
	        function getStyle() {
	            // Some browsers only force layouts when actually reading the style properties of the style object, so make sure that they are all read here,
	            // so that the user of the function can be sure that it will perform the layout here, instead of later (important for batching).
	            var elementStyle            = getComputedStyle(element);
	            var style                   = {};
	            style.position              = elementStyle.position;
	            style.width                 = element.offsetWidth;
	            style.height                = element.offsetHeight;
	            style.top                   = elementStyle.top;
	            style.right                 = elementStyle.right;
	            style.bottom                = elementStyle.bottom;
	            style.left                  = elementStyle.left;
	            style.widthCSS              = elementStyle.width;
	            style.heightCSS             = elementStyle.height;
	            return style;
	        }
	
	        function storeStartSize() {
	            var style = getStyle();
	            getState(element).startSize = {
	                width: style.width,
	                height: style.height
	            };
	            debug("Element start size", getState(element).startSize);
	        }
	
	        function initListeners() {
	            getState(element).listeners = [];
	        }
	
	        function storeStyle() {
	            debug("storeStyle invoked.");
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            var style = getStyle();
	            getState(element).style = style;
	        }
	
	        function storeCurrentSize(element, width, height) {
	            getState(element).lastWidth = width;
	            getState(element).lastHeight  = height;
	        }
	
	        function getExpandChildElement(element) {
	            return getExpandElement(element).childNodes[0];
	        }
	
	        function getWidthOffset() {
	            return 2 * scrollbarSizes.width + 1;
	        }
	
	        function getHeightOffset() {
	            return 2 * scrollbarSizes.height + 1;
	        }
	
	        function getExpandWidth(width) {
	            return width + 10 + getWidthOffset();
	        }
	
	        function getExpandHeight(height) {
	            return height + 10 + getHeightOffset();
	        }
	
	        function getShrinkWidth(width) {
	            return width * 2 + getWidthOffset();
	        }
	
	        function getShrinkHeight(height) {
	            return height * 2 + getHeightOffset();
	        }
	
	        function positionScrollbars(element, width, height) {
	            var expand          = getExpandElement(element);
	            var shrink          = getShrinkElement(element);
	            var expandWidth     = getExpandWidth(width);
	            var expandHeight    = getExpandHeight(height);
	            var shrinkWidth     = getShrinkWidth(width);
	            var shrinkHeight    = getShrinkHeight(height);
	            expand.scrollLeft   = expandWidth;
	            expand.scrollTop    = expandHeight;
	            shrink.scrollLeft   = shrinkWidth;
	            shrink.scrollTop    = shrinkHeight;
	        }
	
	        function injectContainerElement() {
	            var container = getState(element).container;
	
	            if (!container) {
	                container                   = document.createElement("div");
	                container.className         = detectionContainerClass;
	                container.style.cssText     = "visibility: hidden; display: inline; width: 0px; height: 0px; z-index: -1; overflow: hidden; margin: 0; padding: 0;";
	                getState(element).container = container;
	                addAnimationClass(container);
	                element.appendChild(container);
	
	                var onAnimationStart = function () {
	                    getState(element).onRendered && getState(element).onRendered();
	                };
	
	                addEvent(container, "animationstart", onAnimationStart);
	
	                // Store the event handler here so that they may be removed when uninstall is called.
	                // See uninstall function for an explanation why it is needed.
	                getState(element).onAnimationStart = onAnimationStart;
	            }
	
	            return container;
	        }
	
	        function injectScrollElements() {
	            function alterPositionStyles() {
	                var style = getState(element).style;
	
	                if(style.position === "static") {
	                    element.style.position = "relative";
	
	                    var removeRelativeStyles = function(reporter, element, style, property) {
	                        function getNumericalValue(value) {
	                            return value.replace(/[^-\d\.]/g, "");
	                        }
	
	                        var value = style[property];
	
	                        if(value !== "auto" && getNumericalValue(value) !== "0") {
	                            reporter.warn("An element that is positioned static has style." + property + "=" + value + " which is ignored due to the static positioning. The element will need to be positioned relative, so the style." + property + " will be set to 0. Element: ", element);
	                            element.style[property] = 0;
	                        }
	                    };
	
	                    //Check so that there are no accidental styles that will make the element styled differently now that is is relative.
	                    //If there are any, set them to 0 (this should be okay with the user since the style properties did nothing before [since the element was positioned static] anyway).
	                    removeRelativeStyles(reporter, element, style, "top");
	                    removeRelativeStyles(reporter, element, style, "right");
	                    removeRelativeStyles(reporter, element, style, "bottom");
	                    removeRelativeStyles(reporter, element, style, "left");
	                }
	            }
	
	            function getLeftTopBottomRightCssText(left, top, bottom, right) {
	                left = (!left ? "0" : (left + "px"));
	                top = (!top ? "0" : (top + "px"));
	                bottom = (!bottom ? "0" : (bottom + "px"));
	                right = (!right ? "0" : (right + "px"));
	
	                return "left: " + left + "; top: " + top + "; right: " + right + "; bottom: " + bottom + ";";
	            }
	
	            debug("Injecting elements");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            alterPositionStyles();
	
	            var rootContainer = getState(element).container;
	
	            if (!rootContainer) {
	                rootContainer = injectContainerElement();
	            }
	
	            // Due to this WebKit bug https://bugs.webkit.org/show_bug.cgi?id=80808 (currently fixed in Blink, but still present in WebKit browsers such as Safari),
	            // we need to inject two containers, one that is width/height 100% and another that is left/top -1px so that the final container always is 1x1 pixels bigger than
	            // the targeted element.
	            // When the bug is resolved, "containerContainer" may be removed.
	
	            // The outer container can occasionally be less wide than the targeted when inside inline elements element in WebKit (see https://bugs.webkit.org/show_bug.cgi?id=152980).
	            // This should be no problem since the inner container either way makes sure the injected scroll elements are at least 1x1 px.
	
	            var scrollbarWidth          = scrollbarSizes.width;
	            var scrollbarHeight         = scrollbarSizes.height;
	            var containerContainerStyle = "position: absolute; overflow: hidden; z-index: -1; visibility: hidden; width: 100%; height: 100%; left: 0px; top: 0px;";
	            var containerStyle          = "position: absolute; overflow: hidden; z-index: -1; visibility: hidden; " + getLeftTopBottomRightCssText(-(1 + scrollbarWidth), -(1 + scrollbarHeight), -scrollbarHeight, -scrollbarWidth);
	            var expandStyle             = "position: absolute; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
	            var shrinkStyle             = "position: absolute; overflow: scroll; z-index: -1; visibility: hidden; width: 100%; height: 100%;";
	            var expandChildStyle        = "position: absolute; left: 0; top: 0;";
	            var shrinkChildStyle        = "position: absolute; width: 200%; height: 200%;";
	
	            var containerContainer      = document.createElement("div");
	            var container               = document.createElement("div");
	            var expand                  = document.createElement("div");
	            var expandChild             = document.createElement("div");
	            var shrink                  = document.createElement("div");
	            var shrinkChild             = document.createElement("div");
	
	            // Some browsers choke on the resize system being rtl, so force it to ltr. https://github.com/wnr/element-resize-detector/issues/56
	            // However, dir should not be set on the top level container as it alters the dimensions of the target element in some browsers.
	            containerContainer.dir              = "ltr";
	
	            containerContainer.style.cssText    = containerContainerStyle;
	            containerContainer.className        = detectionContainerClass;
	            container.className                 = detectionContainerClass;
	            container.style.cssText             = containerStyle;
	            expand.style.cssText                = expandStyle;
	            expandChild.style.cssText           = expandChildStyle;
	            shrink.style.cssText                = shrinkStyle;
	            shrinkChild.style.cssText           = shrinkChildStyle;
	
	            expand.appendChild(expandChild);
	            shrink.appendChild(shrinkChild);
	            container.appendChild(expand);
	            container.appendChild(shrink);
	            containerContainer.appendChild(container);
	            rootContainer.appendChild(containerContainer);
	
	            function onExpandScroll() {
	                getState(element).onExpand && getState(element).onExpand();
	            }
	
	            function onShrinkScroll() {
	                getState(element).onShrink && getState(element).onShrink();
	            }
	
	            addEvent(expand, "scroll", onExpandScroll);
	            addEvent(shrink, "scroll", onShrinkScroll);
	
	            // Store the event handlers here so that they may be removed when uninstall is called.
	            // See uninstall function for an explanation why it is needed.
	            getState(element).onExpandScroll = onExpandScroll;
	            getState(element).onShrinkScroll = onShrinkScroll;
	        }
	
	        function registerListenersAndPositionElements() {
	            function updateChildSizes(element, width, height) {
	                var expandChild             = getExpandChildElement(element);
	                var expandWidth             = getExpandWidth(width);
	                var expandHeight            = getExpandHeight(height);
	                expandChild.style.width     = expandWidth + "px";
	                expandChild.style.height    = expandHeight + "px";
	            }
	
	            function updateDetectorElements(done) {
	                var width           = element.offsetWidth;
	                var height          = element.offsetHeight;
	
	                debug("Storing current size", width, height);
	
	                // Store the size of the element sync here, so that multiple scroll events may be ignored in the event listeners.
	                // Otherwise the if-check in handleScroll is useless.
	                storeCurrentSize(element, width, height);
	
	                // Since we delay the processing of the batch, there is a risk that uninstall has been called before the batch gets to execute.
	                // Since there is no way to cancel the fn executions, we need to add an uninstall guard to all fns of the batch.
	
	                batchProcessor.add(0, function performUpdateChildSizes() {
	                    if (!getState(element)) {
	                        debug("Aborting because element has been uninstalled");
	                        return;
	                    }
	
	                    if (options.debug) {
	                        var w = element.offsetWidth;
	                        var h = element.offsetHeight;
	
	                        if (w !== width || h !== height) {
	                            reporter.warn(idHandler.get(element), "Scroll: Size changed before updating detector elements.");
	                        }
	                    }
	
	                    updateChildSizes(element, width, height);
	                });
	
	                batchProcessor.add(1, function updateScrollbars() {
	                    if (!getState(element)) {
	                        debug("Aborting because element has been uninstalled");
	                        return;
	                    }
	
	                    positionScrollbars(element, width, height);
	                });
	
	                if (done) {
	                    batchProcessor.add(2, function () {
	                        if (!getState(element)) {
	                            debug("Aborting because element has been uninstalled");
	                            return;
	                        }
	
	                        done();
	                    });
	                }
	            }
	
	            function areElementsInjected() {
	                return !!getState(element).container;
	            }
	
	            function notifyListenersIfNeeded() {
	                function isFirstNotify() {
	                    return getState(element).lastNotifiedWidth === undefined;
	                }
	
	                debug("notifyListenersIfNeeded invoked");
	
	                var state = getState(element);
	
	                // Don't notify the if the current size is the start size, and this is the first notification.
	                if (isFirstNotify() && state.lastWidth === state.startSize.width && state.lastHeight === state.startSize.height) {
	                    return debug("Not notifying: Size is the same as the start size, and there has been no notification yet.");
	                }
	
	                // Don't notify if the size already has been notified.
	                if (state.lastWidth === state.lastNotifiedWidth && state.lastHeight === state.lastNotifiedHeight) {
	                    return debug("Not notifying: Size already notified");
	                }
	
	
	                debug("Current size not notified, notifying...");
	                state.lastNotifiedWidth = state.lastWidth;
	                state.lastNotifiedHeight = state.lastHeight;
	                forEach(getState(element).listeners, function (listener) {
	                    listener(element);
	                });
	            }
	
	            function handleRender() {
	                debug("startanimation triggered.");
	
	                if (isUnrendered(element)) {
	                    debug("Ignoring since element is still unrendered...");
	                    return;
	                }
	
	                debug("Element rendered.");
	                var expand = getExpandElement(element);
	                var shrink = getShrinkElement(element);
	                if (expand.scrollLeft === 0 || expand.scrollTop === 0 || shrink.scrollLeft === 0 || shrink.scrollTop === 0) {
	                    debug("Scrollbars out of sync. Updating detector elements...");
	                    updateDetectorElements(notifyListenersIfNeeded);
	                }
	            }
	
	            function handleScroll() {
	                debug("Scroll detected.");
	
	                if (isUnrendered(element)) {
	                    // Element is still unrendered. Skip this scroll event.
	                    debug("Scroll event fired while unrendered. Ignoring...");
	                    return;
	                }
	
	                var width = element.offsetWidth;
	                var height = element.offsetHeight;
	
	                if (width !== element.lastWidth || height !== element.lastHeight) {
	                    debug("Element size changed.");
	                    updateDetectorElements(notifyListenersIfNeeded);
	                } else {
	                    debug("Element size has not changed (" + width + "x" + height + ").");
	                }
	            }
	
	            debug("registerListenersAndPositionElements invoked.");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            getState(element).onRendered = handleRender;
	            getState(element).onExpand = handleScroll;
	            getState(element).onShrink = handleScroll;
	
	            var style = getState(element).style;
	            updateChildSizes(element, style.width, style.height);
	        }
	
	        function finalizeDomMutation() {
	            debug("finalizeDomMutation invoked.");
	
	            if (!getState(element)) {
	                debug("Aborting because element has been uninstalled");
	                return;
	            }
	
	            var style = getState(element).style;
	            storeCurrentSize(element, style.width, style.height);
	            positionScrollbars(element, style.width, style.height);
	        }
	
	        function ready() {
	            callback(element);
	        }
	
	        function install() {
	            debug("Installing...");
	            initListeners();
	            storeStartSize();
	
	            batchProcessor.add(0, storeStyle);
	            batchProcessor.add(1, injectScrollElements);
	            batchProcessor.add(2, registerListenersAndPositionElements);
	            batchProcessor.add(3, finalizeDomMutation);
	            batchProcessor.add(4, ready);
	        }
	
	        debug("Making detectable...");
	
	        if (isDetached(element)) {
	            debug("Element is detached");
	
	            injectContainerElement();
	
	            debug("Waiting until element is attached...");
	
	            getState(element).onRendered = function () {
	                debug("Element is now attached");
	                install();
	            };
	        } else {
	            install();
	        }
	    }
	
	    function uninstall(element) {
	        var state = getState(element);
	
	        if (!state) {
	            // Uninstall has been called on a non-erd element.
	            return;
	        }
	
	        // Uninstall may have been called in the following scenarios:
	        // (1) Right between the sync code and async batch (here state.busy = true, but nothing have been registered or injected).
	        // (2) In the ready callback of the last level of the batch by another element (here, state.busy = true, but all the stuff has been injected).
	        // (3) After the installation process (here, state.busy = false and all the stuff has been injected).
	        // So to be on the safe side, let's check for each thing before removing.
	
	        // We need to remove the event listeners, because otherwise the event might fire on an uninstall element which results in an error when trying to get the state of the element.
	        state.onExpandScroll && removeEvent(getExpandElement(element), "scroll", state.onExpandScroll);
	        state.onShrinkScroll && removeEvent(getShrinkElement(element), "scroll", state.onShrinkScroll);
	        state.onAnimationStart && removeEvent(state.container, "animationstart", state.onAnimationStart);
	
	        state.container && element.removeChild(state.container);
	    }
	
	    return {
	        makeDetectable: makeDetectable,
	        addListener: addListener,
	        uninstall: uninstall
	    };
	};


/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var forEach                 = __webpack_require__(95).forEach;
	var elementUtilsMaker       = __webpack_require__(232);
	var listenerHandlerMaker    = __webpack_require__(235);
	var idGeneratorMaker        = __webpack_require__(233);
	var idHandlerMaker          = __webpack_require__(234);
	var reporterMaker           = __webpack_require__(236);
	var browserDetector         = __webpack_require__(94);
	var batchProcessorMaker     = __webpack_require__(161);
	var stateHandler            = __webpack_require__(237);
	
	//Detection strategies.
	var objectStrategyMaker     = __webpack_require__(229);
	var scrollStrategyMaker     = __webpack_require__(230);
	
	function isCollection(obj) {
	    return Array.isArray(obj) || obj.length !== undefined;
	}
	
	function toArray(collection) {
	    if (!Array.isArray(collection)) {
	        var array = [];
	        forEach(collection, function (obj) {
	            array.push(obj);
	        });
	        return array;
	    } else {
	        return collection;
	    }
	}
	
	function isElement(obj) {
	    return obj && obj.nodeType === 1;
	}
	
	/**
	 * @typedef idHandler
	 * @type {object}
	 * @property {function} get Gets the resize detector id of the element.
	 * @property {function} set Generate and sets the resize detector id of the element.
	 */
	
	/**
	 * @typedef Options
	 * @type {object}
	 * @property {boolean} callOnAdd    Determines if listeners should be called when they are getting added.
	                                    Default is true. If true, the listener is guaranteed to be called when it has been added.
	                                    If false, the listener will not be guarenteed to be called when it has been added (does not prevent it from being called).
	 * @property {idHandler} idHandler  A custom id handler that is responsible for generating, setting and retrieving id's for elements.
	                                    If not provided, a default id handler will be used.
	 * @property {reporter} reporter    A custom reporter that handles reporting logs, warnings and errors.
	                                    If not provided, a default id handler will be used.
	                                    If set to false, then nothing will be reported.
	 * @property {boolean} debug        If set to true, the the system will report debug messages as default for the listenTo method.
	 */
	
	/**
	 * Creates an element resize detector instance.
	 * @public
	 * @param {Options?} options Optional global options object that will decide how this instance will work.
	 */
	module.exports = function(options) {
	    options = options || {};
	
	    //idHandler is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var idHandler;
	
	    if (options.idHandler) {
	        // To maintain compatability with idHandler.get(element, readonly), make sure to wrap the given idHandler
	        // so that readonly flag always is true when it's used here. This may be removed next major version bump.
	        idHandler = {
	            get: function (element) { return options.idHandler.get(element, true); },
	            set: options.idHandler.set
	        };
	    } else {
	        var idGenerator = idGeneratorMaker();
	        var defaultIdHandler = idHandlerMaker({
	            idGenerator: idGenerator,
	            stateHandler: stateHandler
	        });
	        idHandler = defaultIdHandler;
	    }
	
	    //reporter is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var reporter = options.reporter;
	
	    if(!reporter) {
	        //If options.reporter is false, then the reporter should be quiet.
	        var quiet = reporter === false;
	        reporter = reporterMaker(quiet);
	    }
	
	    //batchProcessor is currently not an option to the listenTo function, so it should not be added to globalOptions.
	    var batchProcessor = getOption(options, "batchProcessor", batchProcessorMaker({ reporter: reporter }));
	
	    //Options to be used as default for the listenTo function.
	    var globalOptions = {};
	    globalOptions.callOnAdd     = !!getOption(options, "callOnAdd", true);
	    globalOptions.debug         = !!getOption(options, "debug", false);
	
	    var eventListenerHandler    = listenerHandlerMaker(idHandler);
	    var elementUtils            = elementUtilsMaker({
	        stateHandler: stateHandler
	    });
	
	    //The detection strategy to be used.
	    var detectionStrategy;
	    var desiredStrategy = getOption(options, "strategy", "object");
	    var strategyOptions = {
	        reporter: reporter,
	        batchProcessor: batchProcessor,
	        stateHandler: stateHandler,
	        idHandler: idHandler
	    };
	
	    if(desiredStrategy === "scroll") {
	        if (browserDetector.isLegacyOpera()) {
	            reporter.warn("Scroll strategy is not supported on legacy Opera. Changing to object strategy.");
	            desiredStrategy = "object";
	        } else if (browserDetector.isIE(9)) {
	            reporter.warn("Scroll strategy is not supported on IE9. Changing to object strategy.");
	            desiredStrategy = "object";
	        }
	    }
	
	    if(desiredStrategy === "scroll") {
	        detectionStrategy = scrollStrategyMaker(strategyOptions);
	    } else if(desiredStrategy === "object") {
	        detectionStrategy = objectStrategyMaker(strategyOptions);
	    } else {
	        throw new Error("Invalid strategy name: " + desiredStrategy);
	    }
	
	    //Calls can be made to listenTo with elements that are still being installed.
	    //Also, same elements can occur in the elements list in the listenTo function.
	    //With this map, the ready callbacks can be synchronized between the calls
	    //so that the ready callback can always be called when an element is ready - even if
	    //it wasn't installed from the function itself.
	    var onReadyCallbacks = {};
	
	    /**
	     * Makes the given elements resize-detectable and starts listening to resize events on the elements. Calls the event callback for each event for each element.
	     * @public
	     * @param {Options?} options Optional options object. These options will override the global options. Some options may not be overriden, such as idHandler.
	     * @param {element[]|element} elements The given array of elements to detect resize events of. Single element is also valid.
	     * @param {function} listener The callback to be executed for each resize event for each element.
	     */
	    function listenTo(options, elements, listener) {
	        function onResizeCallback(element) {
	            var listeners = eventListenerHandler.get(element);
	            forEach(listeners, function callListenerProxy(listener) {
	                listener(element);
	            });
	        }
	
	        function addListener(callOnAdd, element, listener) {
	            eventListenerHandler.add(element, listener);
	
	            if(callOnAdd) {
	                listener(element);
	            }
	        }
	
	        //Options object may be omitted.
	        if(!listener) {
	            listener = elements;
	            elements = options;
	            options = {};
	        }
	
	        if(!elements) {
	            throw new Error("At least one element required.");
	        }
	
	        if(!listener) {
	            throw new Error("Listener required.");
	        }
	
	        if (isElement(elements)) {
	            // A single element has been passed in.
	            elements = [elements];
	        } else if (isCollection(elements)) {
	            // Convert collection to array for plugins.
	            // TODO: May want to check so that all the elements in the collection are valid elements.
	            elements = toArray(elements);
	        } else {
	            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
	        }
	
	        var elementsReady = 0;
	
	        var callOnAdd = getOption(options, "callOnAdd", globalOptions.callOnAdd);
	        var onReadyCallback = getOption(options, "onReady", function noop() {});
	        var debug = getOption(options, "debug", globalOptions.debug);
	
	        forEach(elements, function attachListenerToElement(element) {
	            if (!stateHandler.getState(element)) {
	                stateHandler.initState(element);
	                idHandler.set(element);
	            }
	
	            var id = idHandler.get(element);
	
	            debug && reporter.log("Attaching listener to element", id, element);
	
	            if(!elementUtils.isDetectable(element)) {
	                debug && reporter.log(id, "Not detectable.");
	                if(elementUtils.isBusy(element)) {
	                    debug && reporter.log(id, "System busy making it detectable");
	
	                    //The element is being prepared to be detectable. Do not make it detectable.
	                    //Just add the listener, because the element will soon be detectable.
	                    addListener(callOnAdd, element, listener);
	                    onReadyCallbacks[id] = onReadyCallbacks[id] || [];
	                    onReadyCallbacks[id].push(function onReady() {
	                        elementsReady++;
	
	                        if(elementsReady === elements.length) {
	                            onReadyCallback();
	                        }
	                    });
	                    return;
	                }
	
	                debug && reporter.log(id, "Making detectable...");
	                //The element is not prepared to be detectable, so do prepare it and add a listener to it.
	                elementUtils.markBusy(element, true);
	                return detectionStrategy.makeDetectable({ debug: debug }, element, function onElementDetectable(element) {
	                    debug && reporter.log(id, "onElementDetectable");
	
	                    if (stateHandler.getState(element)) {
	                        elementUtils.markAsDetectable(element);
	                        elementUtils.markBusy(element, false);
	                        detectionStrategy.addListener(element, onResizeCallback);
	                        addListener(callOnAdd, element, listener);
	
	                        // Since the element size might have changed since the call to "listenTo", we need to check for this change,
	                        // so that a resize event may be emitted.
	                        // Having the startSize object is optional (since it does not make sense in some cases such as unrendered elements), so check for its existance before.
	                        // Also, check the state existance before since the element may have been uninstalled in the installation process.
	                        var state = stateHandler.getState(element);
	                        if (state && state.startSize) {
	                            var width = element.offsetWidth;
	                            var height = element.offsetHeight;
	                            if (state.startSize.width !== width || state.startSize.height !== height) {
	                                onResizeCallback(element);
	                            }
	                        }
	
	                        if(onReadyCallbacks[id]) {
	                            forEach(onReadyCallbacks[id], function(callback) {
	                                callback();
	                            });
	                        }
	                    } else {
	                        // The element has been unisntalled before being detectable.
	                        debug && reporter.log(id, "Element uninstalled before being detectable.");
	                    }
	
	                    delete onReadyCallbacks[id];
	
	                    elementsReady++;
	                    if(elementsReady === elements.length) {
	                        onReadyCallback();
	                    }
	                });
	            }
	
	            debug && reporter.log(id, "Already detecable, adding listener.");
	
	            //The element has been prepared to be detectable and is ready to be listened to.
	            addListener(callOnAdd, element, listener);
	            elementsReady++;
	        });
	
	        if(elementsReady === elements.length) {
	            onReadyCallback();
	        }
	    }
	
	    function uninstall(elements) {
	        if(!elements) {
	            return reporter.error("At least one element is required.");
	        }
	
	        if (isElement(elements)) {
	            // A single element has been passed in.
	            elements = [elements];
	        } else if (isCollection(elements)) {
	            // Convert collection to array for plugins.
	            // TODO: May want to check so that all the elements in the collection are valid elements.
	            elements = toArray(elements);
	        } else {
	            return reporter.error("Invalid arguments. Must be a DOM element or a collection of DOM elements.");
	        }
	
	        forEach(elements, function (element) {
	            eventListenerHandler.removeAllListeners(element);
	            detectionStrategy.uninstall(element);
	            stateHandler.cleanState(element);
	        });
	    }
	
	    return {
	        listenTo: listenTo,
	        removeListener: eventListenerHandler.removeListener,
	        removeAllListeners: eventListenerHandler.removeAllListeners,
	        uninstall: uninstall
	    };
	};
	
	function getOption(options, name, defaultValue) {
	    var value = options[name];
	
	    if((value === undefined || value === null) && defaultValue !== undefined) {
	        return defaultValue;
	    }
	
	    return value;
	}


/***/ },
/* 232 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function(options) {
	    var getState = options.stateHandler.getState;
	
	    /**
	     * Tells if the element has been made detectable and ready to be listened for resize events.
	     * @public
	     * @param {element} The element to check.
	     * @returns {boolean} True or false depending on if the element is detectable or not.
	     */
	    function isDetectable(element) {
	        var state = getState(element);
	        return state && !!state.isDetectable;
	    }
	
	    /**
	     * Marks the element that it has been made detectable and ready to be listened for resize events.
	     * @public
	     * @param {element} The element to mark.
	     */
	    function markAsDetectable(element) {
	        getState(element).isDetectable = true;
	    }
	
	    /**
	     * Tells if the element is busy or not.
	     * @public
	     * @param {element} The element to check.
	     * @returns {boolean} True or false depending on if the element is busy or not.
	     */
	    function isBusy(element) {
	        return !!getState(element).busy;
	    }
	
	    /**
	     * Marks the object is busy and should not be made detectable.
	     * @public
	     * @param {element} element The element to mark.
	     * @param {boolean} busy If the element is busy or not.
	     */
	    function markBusy(element, busy) {
	        getState(element).busy = !!busy;
	    }
	
	    return {
	        isDetectable: isDetectable,
	        markAsDetectable: markAsDetectable,
	        isBusy: isBusy,
	        markBusy: markBusy
	    };
	};


/***/ },
/* 233 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function() {
	    var idCount = 1;
	
	    /**
	     * Generates a new unique id in the context.
	     * @public
	     * @returns {number} A unique id in the context.
	     */
	    function generate() {
	        return idCount++;
	    }
	
	    return {
	        generate: generate
	    };
	};


/***/ },
/* 234 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function(options) {
	    var idGenerator     = options.idGenerator;
	    var getState        = options.stateHandler.getState;
	
	    /**
	     * Gets the resize detector id of the element.
	     * @public
	     * @param {element} element The target element to get the id of.
	     * @returns {string|number|null} The id of the element. Null if it has no id.
	     */
	    function getId(element) {
	        var state = getState(element);
	
	        if (state && state.id !== undefined) {
	            return state.id;
	        }
	
	        return null;
	    }
	
	    /**
	     * Sets the resize detector id of the element. Requires the element to have a resize detector state initialized.
	     * @public
	     * @param {element} element The target element to set the id of.
	     * @returns {string|number|null} The id of the element.
	     */
	    function setId(element) {
	        var state = getState(element);
	
	        if (!state) {
	            throw new Error("setId required the element to have a resize detection state.");
	        }
	
	        var id = idGenerator.generate();
	
	        state.id = id;
	
	        return id;
	    }
	
	    return {
	        get: getId,
	        set: setId
	    };
	};


/***/ },
/* 235 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = function(idHandler) {
	    var eventListeners = {};
	
	    /**
	     * Gets all listeners for the given element.
	     * @public
	     * @param {element} element The element to get all listeners for.
	     * @returns All listeners for the given element.
	     */
	    function getListeners(element) {
	        var id = idHandler.get(element);
	
	        if (id === undefined) {
	            return [];
	        }
	
	        return eventListeners[id] || [];
	    }
	
	    /**
	     * Stores the given listener for the given element. Will not actually add the listener to the element.
	     * @public
	     * @param {element} element The element that should have the listener added.
	     * @param {function} listener The callback that the element has added.
	     */
	    function addListener(element, listener) {
	        var id = idHandler.get(element);
	
	        if(!eventListeners[id]) {
	            eventListeners[id] = [];
	        }
	
	        eventListeners[id].push(listener);
	    }
	
	    function removeListener(element, listener) {
	        var listeners = getListeners(element);
	        for (var i = 0, len = listeners.length; i < len; ++i) {
	            if (listeners[i] === listener) {
	              listeners.splice(i, 1);
	              break;
	            }
	        }
	    }
	
	    function removeAllListeners(element) {
	      var listeners = getListeners(element);
	      if (!listeners) { return; }
	      listeners.length = 0;
	    }
	
	    return {
	        get: getListeners,
	        add: addListener,
	        removeListener: removeListener,
	        removeAllListeners: removeAllListeners
	    };
	};


/***/ },
/* 236 */
/***/ function(module, exports) {

	"use strict";
	
	/* global console: false */
	
	/**
	 * Reporter that handles the reporting of logs, warnings and errors.
	 * @public
	 * @param {boolean} quiet Tells if the reporter should be quiet or not.
	 */
	module.exports = function(quiet) {
	    function noop() {
	        //Does nothing.
	    }
	
	    var reporter = {
	        log: noop,
	        warn: noop,
	        error: noop
	    };
	
	    if(!quiet && window.console) {
	        var attachFunction = function(reporter, name) {
	            //The proxy is needed to be able to call the method with the console context,
	            //since we cannot use bind.
	            reporter[name] = function reporterProxy() {
	                var f = console[name];
	                if (f.apply) { //IE9 does not support console.log.apply :)
	                    f.apply(console, arguments);
	                } else {
	                    for (var i = 0; i < arguments.length; i++) {
	                        f(arguments[i]);
	                    }
	                }
	            };
	        };
	
	        attachFunction(reporter, "log");
	        attachFunction(reporter, "warn");
	        attachFunction(reporter, "error");
	    }
	
	    return reporter;
	};

/***/ },
/* 237 */
/***/ function(module, exports) {

	"use strict";
	
	var prop = "_erd";
	
	function initState(element) {
	    element[prop] = {};
	    return getState(element);
	}
	
	function getState(element) {
	    return element[prop];
	}
	
	function cleanState(element) {
	    delete element[prop];
	}
	
	module.exports = {
	    initState: initState,
	    getState: getState,
	    cleanState: cleanState
	};


/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ },
/* 239 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(239);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(249);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createArrayFromMixed = __webpack_require__(242);
	var getMarkupWrap = __webpack_require__(244);
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 245 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 246 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(246);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 248 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(248);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 250 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "cb40f71fe3abe35312c24f0048674b36.svg";

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "fa3996818d13a9c2ce2a8f78a8b5a773.svg";

/***/ },
/* 253 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 254 */
/***/ function(module, exports) {

	module.exports = [
		{
			"ID": 33,
			"circle": "Kreis 1",
			"name": "Rathaus"
		},
		{
			"ID": 41,
			"circle": "Kreis 1",
			"name": "Hochschulen"
		},
		{
			"ID": 51,
			"circle": "Kreis 1",
			"name": "Lindenhof"
		},
		{
			"ID": 62,
			"circle": "Kreis 1",
			"name": "City"
		},
		{
			"ID": 84,
			"circle": "Kreis 2",
			"name": "Wollishofen"
		},
		{
			"ID": 95,
			"circle": "Kreis 2",
			"name": "Leimbach"
		},
		{
			"ID": 106,
			"circle": "Kreis 2",
			"name": "Enge"
		},
		{
			"ID": 128,
			"circle": "Kreis 3",
			"name": "Wiedikon"
		},
		{
			"ID": 139,
			"circle": "Kreis 3",
			"name": "Friesenberg"
		},
		{
			"ID": 150,
			"circle": "Kreis 3",
			"name": "Sihlfeld"
		},
		{
			"ID": 172,
			"circle": "Kreis 4",
			"name": "Werd"
		},
		{
			"ID": 183,
			"circle": "Kreis 4",
			"name": "Langstrasse"
		},
		{
			"ID": 194,
			"circle": "Kreis 4",
			"name": "Hard"
		},
		{
			"ID": 216,
			"circle": "Kreis 5",
			"name": "Gewerbeschule"
		},
		{
			"ID": 227,
			"circle": "Kreis 5",
			"name": "Escher Wyss"
		},
		{
			"ID": 249,
			"circle": "Kreis 6",
			"name": "Unterstrass"
		},
		{
			"ID": 260,
			"circle": "Kreis 6",
			"name": "Oberstrass"
		},
		{
			"ID": 282,
			"circle": "Kreis 7",
			"name": "Fluntern"
		},
		{
			"ID": 293,
			"circle": "Kreis 7",
			"name": "Hottingen"
		},
		{
			"ID": 304,
			"circle": "Kreis 7",
			"name": "Hirslanden"
		},
		{
			"ID": 315,
			"circle": "Kreis 7",
			"name": "Witikon"
		},
		{
			"ID": 336,
			"circle": "Kreis 8",
			"name": "Seefeld"
		},
		{
			"ID": 347,
			"circle": "Kreis 8",
			"name": "Mühlebach"
		},
		{
			"ID": 358,
			"circle": "Kreis 8",
			"name": "Weinegg"
		},
		{
			"ID": 380,
			"circle": "Kreis 9",
			"name": "Albisrieden"
		},
		{
			"ID": 391,
			"circle": "Kreis 9",
			"name": "Altstetten"
		},
		{
			"ID": 413,
			"circle": "Kreis 10",
			"name": "Höngg"
		},
		{
			"ID": 424,
			"circle": "Kreis 10",
			"name": "Wipkingen"
		},
		{
			"ID": 446,
			"circle": "Kreis 11",
			"name": "Affoltern"
		},
		{
			"ID": 457,
			"circle": "Kreis 11",
			"name": "Oerlikon"
		},
		{
			"ID": 468,
			"circle": "Kreis 11",
			"name": "Seebach"
		},
		{
			"ID": 490,
			"circle": "Kreis 12",
			"name": "Saatlen"
		},
		{
			"ID": 501,
			"circle": "Kreis 12",
			"name": "Schwamendingen-Mitte"
		},
		{
			"ID": 512,
			"circle": "Kreis 12",
			"name": "Hirzenbach"
		}
	];

/***/ },
/* 255 */
/***/ function(module, exports) {

	module.exports = [
		{
			"circle": 1,
			"quarterName": "Rathaus",
			"quarterId": "Rathaus"
		},
		{
			"circle": 1,
			"quarterName": "Hochschulen",
			"quarterId": "Hochschulen"
		},
		{
			"circle": 1,
			"quarterName": "Lindenhof",
			"quarterId": "Lindenhof"
		},
		{
			"circle": 1,
			"quarterName": "City",
			"quarterId": "City"
		},
		{
			"circle": 2,
			"quarterName": "Wollishofen",
			"quarterId": "Wollishofen"
		},
		{
			"circle": 2,
			"quarterName": "Leimbach",
			"quarterId": "Leimbach"
		},
		{
			"circle": 2,
			"quarterName": "Enge",
			"quarterId": "Enge"
		},
		{
			"circle": 3,
			"quarterName": "Wiedikon (Alt-Wiedikon)",
			"quarterId": "Wiedikon"
		},
		{
			"circle": 3,
			"quarterName": "Friesenberg",
			"quarterId": "Friesenberg"
		},
		{
			"circle": 3,
			"quarterName": "Sihlfeld",
			"quarterId": "Sihlfeld"
		},
		{
			"circle": 4,
			"quarterName": "Werd",
			"quarterId": "Werd"
		},
		{
			"circle": 4,
			"quarterName": "Langstrasse",
			"quarterId": "Langstrasse"
		},
		{
			"circle": 4,
			"quarterName": "Hard",
			"quarterId": "Hard"
		},
		{
			"circle": 5,
			"quarterName": "Gewerbeschule",
			"quarterId": "Gewerbeschule"
		},
		{
			"circle": 5,
			"quarterName": "Escher Wyss",
			"quarterId": "Escher Wyss"
		},
		{
			"circle": 6,
			"quarterName": "Unterstrass",
			"quarterId": "Unterstrass"
		},
		{
			"circle": 6,
			"quarterName": "Oberstrass",
			"quarterId": "Oberstrass"
		},
		{
			"circle": 7,
			"quarterName": "Fluntern",
			"quarterId": "Fluntern"
		},
		{
			"circle": 7,
			"quarterName": "Hottingen",
			"quarterId": "Hottingen"
		},
		{
			"circle": 7,
			"quarterName": "Hirslanden",
			"quarterId": "Hirslanden"
		},
		{
			"circle": 7,
			"quarterName": "Witikon",
			"quarterId": "Witikon"
		},
		{
			"circle": 8,
			"quarterName": "Seefeld",
			"quarterId": "Seefeld"
		},
		{
			"circle": 8,
			"quarterName": "Mühlebach",
			"quarterId": "Mühlebach"
		},
		{
			"circle": 8,
			"quarterName": "Weinegg",
			"quarterId": "Weinegg"
		},
		{
			"circle": 9,
			"quarterName": "Albisrieden",
			"quarterId": "Albisrieden"
		},
		{
			"circle": 9,
			"quarterName": "Altstetten",
			"quarterId": "Altstetten"
		},
		{
			"circle": 10,
			"quarterName": "Höngg",
			"quarterId": "Höngg"
		},
		{
			"circle": 10,
			"quarterName": "Wipkingen",
			"quarterId": "Wipkingen"
		},
		{
			"circle": 11,
			"quarterName": "Affoltern",
			"quarterId": "Affoltern"
		},
		{
			"circle": 11,
			"quarterName": "Oerlikon",
			"quarterId": "Oerlikon"
		},
		{
			"circle": 11,
			"quarterName": "Seebach",
			"quarterId": "Seebach"
		},
		{
			"circle": 12,
			"quarterName": "Saatlen",
			"quarterId": "Saatlen"
		},
		{
			"circle": 12,
			"quarterName": "Schwamendingen-Mitte",
			"quarterId": "Schwamendingen-Mitte"
		},
		{
			"circle": 12,
			"quarterName": "Hirzenbach",
			"quarterId": "Hirzenbach"
		}
	];

/***/ },
/* 256 */
/***/ function(module, exports) {

	module.exports = [
		{
			"id": 2,
			"SteuerJahr": 1999,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 141624,
			"SteuerEinkommen_P25": 17.6,
			"SteuerEinkommen_Median": 34.5,
			"SteuerEinkommen_P75": 53.5,
			"eink_arm_Sum": 34801,
			"ant_eink_arm": 24.6,
			"p25": 100,
			"p50": 100,
			"p75": 100
		},
		{
			"id": 3,
			"SteuerJahr": 1999,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 58576,
			"SteuerEinkommen_P25": 44.2,
			"SteuerEinkommen_Median": 63.1,
			"SteuerEinkommen_P75": 89.5,
			"eink_arm_Sum": 7527,
			"ant_eink_arm": 12.8,
			"p25": 100,
			"p50": 100,
			"p75": 100
		},
		{
			"id": 1070,
			"SteuerJahr": 2000,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 143142,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 36,
			"SteuerEinkommen_P75": 55.8,
			"eink_arm_Sum": 35103,
			"ant_eink_arm": 24.5,
			"p25": 105.1136363636,
			"p50": 104.347826087,
			"p75": 104.2990654206
		},
		{
			"id": 1071,
			"SteuerJahr": 2000,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 57847,
			"SteuerEinkommen_P25": 46,
			"SteuerEinkommen_Median": 65.4,
			"SteuerEinkommen_P75": 93.4,
			"eink_arm_Sum": 7156,
			"ant_eink_arm": 12.4,
			"p25": 104.07239819,
			"p50": 103.6450079239,
			"p75": 104.3575418994
		},
		{
			"id": 2143,
			"SteuerJahr": 2001,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 145186,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 37.6,
			"SteuerEinkommen_P75": 58.3,
			"eink_arm_Sum": 35483,
			"ant_eink_arm": 24.4,
			"p25": 110.2272727273,
			"p50": 108.9855072464,
			"p75": 108.9719626168
		},
		{
			"id": 2144,
			"SteuerJahr": 2001,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 57571,
			"SteuerEinkommen_P25": 47.5,
			"SteuerEinkommen_Median": 67.6,
			"SteuerEinkommen_P75": 97.4,
			"eink_arm_Sum": 7159,
			"ant_eink_arm": 12.4,
			"p25": 107.4660633484,
			"p50": 107.1315372425,
			"p75": 108.8268156425
		},
		{
			"id": 3219,
			"SteuerJahr": 2002,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 146657,
			"SteuerEinkommen_P25": 19,
			"SteuerEinkommen_Median": 37.7,
			"SteuerEinkommen_P75": 58.4,
			"eink_arm_Sum": 36522,
			"ant_eink_arm": 24.9,
			"p25": 107.9545454545,
			"p50": 109.2753623188,
			"p75": 109.1588785047
		},
		{
			"id": 3220,
			"SteuerJahr": 2002,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 57099,
			"SteuerEinkommen_P25": 47.25,
			"SteuerEinkommen_Median": 67.5,
			"SteuerEinkommen_P75": 96.9,
			"eink_arm_Sum": 7197,
			"ant_eink_arm": 12.6,
			"p25": 106.9004524887,
			"p50": 106.9730586371,
			"p75": 108.2681564246
		},
		{
			"id": 4293,
			"SteuerJahr": 2003,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 147336,
			"SteuerEinkommen_P25": 18.9,
			"SteuerEinkommen_Median": 37.7,
			"SteuerEinkommen_P75": 58.3,
			"eink_arm_Sum": 36881,
			"ant_eink_arm": 25,
			"p25": 107.3863636364,
			"p50": 109.2753623188,
			"p75": 108.9719626168
		},
		{
			"id": 4294,
			"SteuerJahr": 2003,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 56473,
			"SteuerEinkommen_P25": 46.8,
			"SteuerEinkommen_Median": 67.3,
			"SteuerEinkommen_P75": 96.9,
			"eink_arm_Sum": 7197,
			"ant_eink_arm": 12.7,
			"p25": 105.8823529412,
			"p50": 106.6561014263,
			"p75": 108.2681564246
		},
		{
			"id": 5369,
			"SteuerJahr": 2004,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 147893,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 37.5,
			"SteuerEinkommen_P75": 58.5,
			"eink_arm_Sum": 37943,
			"ant_eink_arm": 25.7,
			"p25": 103.9772727273,
			"p50": 108.6956521739,
			"p75": 109.3457943925
		},
		{
			"id": 5370,
			"SteuerJahr": 2004,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 56015,
			"SteuerEinkommen_P25": 46.2,
			"SteuerEinkommen_Median": 67.1,
			"SteuerEinkommen_P75": 97.7,
			"eink_arm_Sum": 7597,
			"ant_eink_arm": 13.6,
			"p25": 104.5248868778,
			"p50": 106.3391442155,
			"p75": 109.1620111732
		},
		{
			"id": 6449,
			"SteuerJahr": 2005,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 149487,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 37.9,
			"SteuerEinkommen_P75": 59.7,
			"eink_arm_Sum": 38636,
			"ant_eink_arm": 25.8,
			"p25": 103.9772727273,
			"p50": 109.8550724638,
			"p75": 111.5887850467
		},
		{
			"id": 6450,
			"SteuerJahr": 2005,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 55657,
			"SteuerEinkommen_P25": 46.1,
			"SteuerEinkommen_Median": 67.7,
			"SteuerEinkommen_P75": 100,
			"eink_arm_Sum": 7838,
			"ant_eink_arm": 14.1,
			"p25": 104.2986425339,
			"p50": 107.2900158479,
			"p75": 111.7318435754
		},
		{
			"id": 7521,
			"SteuerJahr": 2006,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 151121,
			"SteuerEinkommen_P25": 18.8,
			"SteuerEinkommen_Median": 38.9,
			"SteuerEinkommen_P75": 61,
			"eink_arm_Sum": 39194,
			"ant_eink_arm": 25.9,
			"p25": 106.8181818182,
			"p50": 112.7536231884,
			"p75": 114.0186915888
		},
		{
			"id": 7522,
			"SteuerJahr": 2006,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 55576,
			"SteuerEinkommen_P25": 44.6,
			"SteuerEinkommen_Median": 67.1,
			"SteuerEinkommen_P75": 100.9,
			"eink_arm_Sum": 8467,
			"ant_eink_arm": 15.2,
			"p25": 100.9049773756,
			"p50": 106.3391442155,
			"p75": 112.7374301676
		},
		{
			"id": 8585,
			"SteuerJahr": 2007,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 154430,
			"SteuerEinkommen_P25": 19.9,
			"SteuerEinkommen_Median": 40.1,
			"SteuerEinkommen_P75": 63.3,
			"eink_arm_Sum": 40237,
			"ant_eink_arm": 26.1,
			"p25": 113.0681818182,
			"p50": 116.231884058,
			"p75": 118.3177570093
		},
		{
			"id": 8586,
			"SteuerJahr": 2007,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 55274,
			"SteuerEinkommen_P25": 46.3,
			"SteuerEinkommen_Median": 70,
			"SteuerEinkommen_P75": 105.4,
			"eink_arm_Sum": 8478,
			"ant_eink_arm": 15.3,
			"p25": 104.7511312217,
			"p50": 110.9350237718,
			"p75": 117.7653631285
		},
		{
			"id": 9642,
			"SteuerJahr": 2008,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 156260,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 41.7,
			"SteuerEinkommen_P75": 65.8,
			"eink_arm_Sum": 40695,
			"ant_eink_arm": 26,
			"p25": 113.6363636364,
			"p50": 120.8695652174,
			"p75": 122.9906542056
		},
		{
			"id": 9643,
			"SteuerJahr": 2008,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 55846,
			"SteuerEinkommen_P25": 47.6,
			"SteuerEinkommen_Median": 72.2,
			"SteuerEinkommen_P75": 110.7,
			"eink_arm_Sum": 8428,
			"ant_eink_arm": 15.1,
			"p25": 107.6923076923,
			"p50": 114.4215530903,
			"p75": 123.687150838
		},
		{
			"id": 10690,
			"SteuerJahr": 2009,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 157472,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 42,
			"SteuerEinkommen_P75": 66.4,
			"eink_arm_Sum": 41472,
			"ant_eink_arm": 26.3,
			"p25": 113.6363636364,
			"p50": 121.7391304348,
			"p75": 124.1121495327
		},
		{
			"id": 10691,
			"SteuerJahr": 2009,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 55756,
			"SteuerEinkommen_P25": 48.9,
			"SteuerEinkommen_Median": 74.2,
			"SteuerEinkommen_P75": 113.65,
			"eink_arm_Sum": 8492,
			"ant_eink_arm": 15.2,
			"p25": 110.6334841629,
			"p50": 117.5911251981,
			"p75": 126.9832402235
		},
		{
			"id": 11733,
			"SteuerJahr": 2010,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 158606,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 42.2,
			"SteuerEinkommen_P75": 66.8,
			"eink_arm_Sum": 41963,
			"ant_eink_arm": 26.5,
			"p25": 113.6363636364,
			"p50": 122.3188405797,
			"p75": 124.8598130841
		},
		{
			"id": 11734,
			"SteuerJahr": 2010,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 55676,
			"SteuerEinkommen_P25": 49.6,
			"SteuerEinkommen_Median": 75.4,
			"SteuerEinkommen_P75": 116.3,
			"eink_arm_Sum": 8620,
			"ant_eink_arm": 15.5,
			"p25": 112.2171945701,
			"p50": 119.4928684628,
			"p75": 129.9441340782
		},
		{
			"id": 12772,
			"SteuerJahr": 2011,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 159548,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 42.6,
			"SteuerEinkommen_P75": 67.6,
			"eink_arm_Sum": 42392,
			"ant_eink_arm": 26.6,
			"p25": 113.6363636364,
			"p50": 123.4782608696,
			"p75": 126.3551401869
		},
		{
			"id": 12773,
			"SteuerJahr": 2011,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 55775,
			"SteuerEinkommen_P25": 50,
			"SteuerEinkommen_Median": 76.6,
			"SteuerEinkommen_P75": 118.8,
			"eink_arm_Sum": 8788,
			"ant_eink_arm": 15.8,
			"p25": 113.1221719457,
			"p50": 121.3946117274,
			"p75": 132.7374301676
		},
		{
			"id": 13818,
			"SteuerJahr": 2012,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 161460,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 42.7,
			"SteuerEinkommen_P75": 68,
			"eink_arm_Sum": 43351,
			"ant_eink_arm": 26.8,
			"p25": 113.6363636364,
			"p50": 123.768115942,
			"p75": 127.1028037383
		},
		{
			"id": 13819,
			"SteuerJahr": 2012,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 55732,
			"SteuerEinkommen_P25": 49.4,
			"SteuerEinkommen_Median": 76.5,
			"SteuerEinkommen_P75": 119.2,
			"eink_arm_Sum": 9094,
			"ant_eink_arm": 16.3,
			"p25": 111.7647058824,
			"p50": 121.236133122,
			"p75": 133.1843575419
		},
		{
			"id": 14868,
			"SteuerJahr": 2013,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 163488,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 43,
			"SteuerEinkommen_P75": 68,
			"eink_arm_Sum": 44112,
			"ant_eink_arm": 27,
			"p25": 113.6363636364,
			"p50": 124.6376811594,
			"p75": 127.1028037383
		},
		{
			"id": 14869,
			"SteuerJahr": 2013,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 55700,
			"SteuerEinkommen_P25": 48.4,
			"SteuerEinkommen_Median": 76.2,
			"SteuerEinkommen_P75": 119.5,
			"eink_arm_Sum": 9570,
			"ant_eink_arm": 17.2,
			"p25": 109.5022624434,
			"p50": 120.7606973059,
			"p75": 133.5195530726
		},
		{
			"id": 15920,
			"SteuerJahr": 2014,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 159172,
			"SteuerEinkommen_P25": 19.6,
			"SteuerEinkommen_Median": 42.2,
			"SteuerEinkommen_P75": 66,
			"eink_arm_Sum": 43332,
			"ant_eink_arm": 27.2,
			"p25": 111.3636363636,
			"p50": 122.3188405797,
			"p75": 123.3644859813
		},
		{
			"id": 15921,
			"SteuerJahr": 2014,
			"KreisSort": "Total",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 56562,
			"SteuerEinkommen_P25": 48.8,
			"SteuerEinkommen_Median": 76.5,
			"SteuerEinkommen_P75": 119,
			"eink_arm_Sum": 9536,
			"ant_eink_arm": 16.9,
			"p25": 110.407239819,
			"p50": 121.236133122,
			"p75": 132.9608938547
		}
	];

/***/ },
/* 257 */
/***/ function(module, exports) {

	module.exports = [
		{
			"": 26,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4467,
			"SteuerEinkommen_P25": 4.6,
			"SteuerEinkommen_Median": 22.2,
			"SteuerEinkommen_P75": 50,
			"eink_arm_Sum": 1875,
			"ant_eink_arm": 42,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 27,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 627,
			"SteuerEinkommen_P25": 47.1,
			"SteuerEinkommen_Median": 80.3,
			"SteuerEinkommen_P75": 128,
			"eink_arm_Sum": 95,
			"ant_eink_arm": 15.2,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 132,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11170,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 38,
			"SteuerEinkommen_P75": 58.4,
			"eink_arm_Sum": 2405,
			"ant_eink_arm": 21.5,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 133,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4923,
			"SteuerEinkommen_P25": 49.1,
			"SteuerEinkommen_Median": 69.8,
			"SteuerEinkommen_P75": 101.5,
			"eink_arm_Sum": 530,
			"ant_eink_arm": 10.8,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 225,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18050,
			"SteuerEinkommen_P25": 17.7,
			"SteuerEinkommen_Median": 32.9,
			"SteuerEinkommen_P75": 50,
			"eink_arm_Sum": 4431,
			"ant_eink_arm": 24.5,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 226,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6768,
			"SteuerEinkommen_P25": 40.4,
			"SteuerEinkommen_Median": 59,
			"SteuerEinkommen_P75": 80,
			"eink_arm_Sum": 1019,
			"ant_eink_arm": 15.1,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 318,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11879,
			"SteuerEinkommen_P25": 14.4,
			"SteuerEinkommen_Median": 28.8,
			"SteuerEinkommen_P75": 46,
			"eink_arm_Sum": 3575,
			"ant_eink_arm": 30.1,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 319,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3483,
			"SteuerEinkommen_P25": 34.8,
			"SteuerEinkommen_Median": 51.6,
			"SteuerEinkommen_P75": 70.8,
			"eink_arm_Sum": 712,
			"ant_eink_arm": 20.4,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 409,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5000,
			"SteuerEinkommen_P25": 15.75,
			"SteuerEinkommen_Median": 32.3,
			"SteuerEinkommen_P75": 49.9,
			"eink_arm_Sum": 1346,
			"ant_eink_arm": 26.9,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 410,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1386,
			"SteuerEinkommen_P25": 37.1,
			"SteuerEinkommen_Median": 54,
			"SteuerEinkommen_P75": 74,
			"eink_arm_Sum": 268,
			"ant_eink_arm": 19.3,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 476,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12388,
			"SteuerEinkommen_P25": 18.9,
			"SteuerEinkommen_Median": 37.7,
			"SteuerEinkommen_P75": 59.3,
			"eink_arm_Sum": 2850,
			"ant_eink_arm": 23,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 477,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4399,
			"SteuerEinkommen_P25": 48.5,
			"SteuerEinkommen_Median": 70,
			"SteuerEinkommen_P75": 104.1,
			"eink_arm_Sum": 469,
			"ant_eink_arm": 10.7,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 545,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13877,
			"SteuerEinkommen_P25": 18.4,
			"SteuerEinkommen_Median": 41.8,
			"SteuerEinkommen_P75": 66.3,
			"eink_arm_Sum": 3314,
			"ant_eink_arm": 23.9,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 546,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5550,
			"SteuerEinkommen_P25": 58.4,
			"SteuerEinkommen_Median": 91,
			"SteuerEinkommen_P75": 149.5,
			"eink_arm_Sum": 511,
			"ant_eink_arm": 9.2,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 658,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7276,
			"SteuerEinkommen_P25": 20.1,
			"SteuerEinkommen_Median": 40.9,
			"SteuerEinkommen_P75": 63.1,
			"eink_arm_Sum": 1573,
			"ant_eink_arm": 21.6,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 659,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1874,
			"SteuerEinkommen_P25": 51.2,
			"SteuerEinkommen_Median": 78,
			"SteuerEinkommen_P75": 121.4,
			"eink_arm_Sum": 205,
			"ant_eink_arm": 10.9,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 750,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16139,
			"SteuerEinkommen_P25": 18.9,
			"SteuerEinkommen_Median": 34,
			"SteuerEinkommen_P75": 50,
			"eink_arm_Sum": 3675,
			"ant_eink_arm": 22.8,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 751,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8547,
			"SteuerEinkommen_P25": 44,
			"SteuerEinkommen_Median": 59.1,
			"SteuerEinkommen_P75": 80.5,
			"eink_arm_Sum": 1015,
			"ant_eink_arm": 11.9,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 818,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14173,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 38.5,
			"SteuerEinkommen_P75": 57.4,
			"eink_arm_Sum": 3045,
			"ant_eink_arm": 21.5,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 819,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6113,
			"SteuerEinkommen_P25": 49.6,
			"SteuerEinkommen_Median": 69,
			"SteuerEinkommen_P75": 98.6,
			"eink_arm_Sum": 681,
			"ant_eink_arm": 11.1,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 887,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18183,
			"SteuerEinkommen_P25": 18.4,
			"SteuerEinkommen_Median": 33.8,
			"SteuerEinkommen_P75": 50,
			"eink_arm_Sum": 4227,
			"ant_eink_arm": 23.2,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 888,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 9535,
			"SteuerEinkommen_P25": 42.3,
			"SteuerEinkommen_Median": 60,
			"SteuerEinkommen_P75": 81.9,
			"eink_arm_Sum": 1233,
			"ant_eink_arm": 12.9,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 981,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9022,
			"SteuerEinkommen_P25": 15.7,
			"SteuerEinkommen_Median": 28.4,
			"SteuerEinkommen_P75": 43.1,
			"eink_arm_Sum": 2485,
			"ant_eink_arm": 27.5,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 982,
			"SteuerJahr": 1999,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5371,
			"SteuerEinkommen_P25": 40,
			"SteuerEinkommen_Median": 55.05,
			"SteuerEinkommen_P75": 72.1,
			"eink_arm_Sum": 789,
			"ant_eink_arm": 14.7,
			"p25": 100,
			"p50": 100,
			"p75": 100,
			"armindex": 100
		},
		{
			"": 1094,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4542,
			"SteuerEinkommen_P25": 2.8,
			"SteuerEinkommen_Median": 22.5,
			"SteuerEinkommen_P75": 53.7,
			"eink_arm_Sum": 1996,
			"ant_eink_arm": 43.9,
			"p25": 60.8695652173913,
			"p50": 101.351351351351,
			"p75": 107.4,
			"armindex": 104.52380952381
		},
		{
			"": 1095,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 613,
			"SteuerEinkommen_P25": 47.3,
			"SteuerEinkommen_Median": 84.95,
			"SteuerEinkommen_P75": 133.85,
			"eink_arm_Sum": 103,
			"ant_eink_arm": 16.8,
			"p25": 100.424628450106,
			"p50": 105.790784557908,
			"p75": 104.5703125,
			"armindex": 110.526315789474
		},
		{
			"": 1204,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11322,
			"SteuerEinkommen_P25": 20.1,
			"SteuerEinkommen_Median": 39.5,
			"SteuerEinkommen_P75": 61,
			"eink_arm_Sum": 2496,
			"ant_eink_arm": 22,
			"p25": 100.5,
			"p50": 103.947368421053,
			"p75": 104.452054794521,
			"armindex": 102.325581395349
		},
		{
			"": 1205,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4883,
			"SteuerEinkommen_P25": 51.2,
			"SteuerEinkommen_Median": 72.6,
			"SteuerEinkommen_P75": 106.7,
			"eink_arm_Sum": 480,
			"ant_eink_arm": 9.8,
			"p25": 104.276985743381,
			"p50": 104.011461318052,
			"p75": 105.12315270936,
			"armindex": 90.7407407407407
		},
		{
			"": 1297,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18152,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 34.7,
			"SteuerEinkommen_P75": 52.4,
			"eink_arm_Sum": 4445,
			"ant_eink_arm": 24.5,
			"p25": 104.519774011299,
			"p50": 105.471124620061,
			"p75": 104.8,
			"armindex": 100
		},
		{
			"": 1298,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6599,
			"SteuerEinkommen_P25": 42,
			"SteuerEinkommen_Median": 60.3,
			"SteuerEinkommen_P75": 82.2,
			"eink_arm_Sum": 1007,
			"ant_eink_arm": 15.3,
			"p25": 103.960396039604,
			"p50": 102.203389830508,
			"p75": 102.75,
			"armindex": 101.324503311258
		},
		{
			"": 1388,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11929,
			"SteuerEinkommen_P25": 15.3,
			"SteuerEinkommen_Median": 30,
			"SteuerEinkommen_P75": 48.4,
			"eink_arm_Sum": 3486,
			"ant_eink_arm": 29.2,
			"p25": 106.25,
			"p50": 104.166666666667,
			"p75": 105.217391304348,
			"armindex": 97.0099667774086
		},
		{
			"": 1389,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3386,
			"SteuerEinkommen_P25": 36,
			"SteuerEinkommen_Median": 53.85,
			"SteuerEinkommen_P75": 72,
			"eink_arm_Sum": 706,
			"ant_eink_arm": 20.9,
			"p25": 103.448275862069,
			"p50": 104.360465116279,
			"p75": 101.694915254237,
			"armindex": 102.450980392157
		},
		{
			"": 1479,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5222,
			"SteuerEinkommen_P25": 18.1,
			"SteuerEinkommen_Median": 35,
			"SteuerEinkommen_P75": 53.7,
			"eink_arm_Sum": 1303,
			"ant_eink_arm": 25,
			"p25": 114.920634920635,
			"p50": 108.359133126935,
			"p75": 107.615230460922,
			"armindex": 92.9368029739777
		},
		{
			"": 1480,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1362,
			"SteuerEinkommen_P25": 40.1,
			"SteuerEinkommen_Median": 56.5,
			"SteuerEinkommen_P75": 77.2,
			"eink_arm_Sum": 234,
			"ant_eink_arm": 17.2,
			"p25": 108.086253369272,
			"p50": 104.62962962963,
			"p75": 104.324324324324,
			"armindex": 89.1191709844559
		},
		{
			"": 1547,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12356,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 39.5,
			"SteuerEinkommen_P75": 61.9,
			"eink_arm_Sum": 2803,
			"ant_eink_arm": 22.7,
			"p25": 105.820105820106,
			"p50": 104.774535809019,
			"p75": 104.384485666105,
			"armindex": 98.695652173913
		},
		{
			"": 1548,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4285,
			"SteuerEinkommen_P25": 51.1,
			"SteuerEinkommen_Median": 74.5,
			"SteuerEinkommen_P75": 112.3,
			"eink_arm_Sum": 453,
			"ant_eink_arm": 10.6,
			"p25": 105.360824742268,
			"p50": 106.428571428571,
			"p75": 107.877041306436,
			"armindex": 99.0654205607477
		},
		{
			"": 1616,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13952,
			"SteuerEinkommen_P25": 19.5,
			"SteuerEinkommen_Median": 43.4,
			"SteuerEinkommen_P75": 70,
			"eink_arm_Sum": 3308,
			"ant_eink_arm": 23.7,
			"p25": 105.978260869565,
			"p50": 103.827751196172,
			"p75": 105.580693815988,
			"armindex": 99.163179916318
		},
		{
			"": 1617,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5485,
			"SteuerEinkommen_P25": 61.3,
			"SteuerEinkommen_Median": 97.8,
			"SteuerEinkommen_P75": 165.4,
			"eink_arm_Sum": 424,
			"ant_eink_arm": 7.7,
			"p25": 104.965753424658,
			"p50": 107.472527472527,
			"p75": 110.635451505017,
			"armindex": 83.695652173913
		},
		{
			"": 1730,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7320,
			"SteuerEinkommen_P25": 21.6,
			"SteuerEinkommen_Median": 43.8,
			"SteuerEinkommen_P75": 67.4,
			"eink_arm_Sum": 1519,
			"ant_eink_arm": 20.8,
			"p25": 107.462686567164,
			"p50": 107.090464547677,
			"p75": 106.814580031696,
			"armindex": 96.2962962962963
		},
		{
			"": 1731,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1854,
			"SteuerEinkommen_P25": 55.9,
			"SteuerEinkommen_Median": 83.45,
			"SteuerEinkommen_P75": 130,
			"eink_arm_Sum": 162,
			"ant_eink_arm": 8.7,
			"p25": 109.1796875,
			"p50": 106.987179487179,
			"p75": 107.084019769357,
			"armindex": 79.8165137614679
		},
		{
			"": 1820,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16455,
			"SteuerEinkommen_P25": 19.7,
			"SteuerEinkommen_Median": 35,
			"SteuerEinkommen_P75": 51.8,
			"eink_arm_Sum": 3739,
			"ant_eink_arm": 22.7,
			"p25": 104.232804232804,
			"p50": 102.941176470588,
			"p75": 103.6,
			"armindex": 99.5614035087719
		},
		{
			"": 1821,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8521,
			"SteuerEinkommen_P25": 45.5,
			"SteuerEinkommen_Median": 61.3,
			"SteuerEinkommen_P75": 83.3,
			"eink_arm_Sum": 1003,
			"ant_eink_arm": 11.8,
			"p25": 103.409090909091,
			"p50": 103.722504230118,
			"p75": 103.478260869565,
			"armindex": 99.1596638655462
		},
		{
			"": 1889,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14446,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 40.1,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 3090,
			"ant_eink_arm": 21.4,
			"p25": 103,
			"p50": 104.155844155844,
			"p75": 104.529616724739,
			"armindex": 99.5348837209302
		},
		{
			"": 1890,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5991,
			"SteuerEinkommen_P25": 51.1,
			"SteuerEinkommen_Median": 72.1,
			"SteuerEinkommen_P75": 103.5,
			"eink_arm_Sum": 601,
			"ant_eink_arm": 10,
			"p25": 103.024193548387,
			"p50": 104.492753623188,
			"p75": 104.969574036511,
			"armindex": 90.0900900900901
		},
		{
			"": 1958,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18409,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 34.9,
			"SteuerEinkommen_P75": 52,
			"eink_arm_Sum": 4424,
			"ant_eink_arm": 24,
			"p25": 101.630434782609,
			"p50": 103.254437869822,
			"p75": 104,
			"armindex": 103.448275862069
		},
		{
			"": 1959,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 9524,
			"SteuerEinkommen_P25": 44.2,
			"SteuerEinkommen_Median": 61.9,
			"SteuerEinkommen_P75": 84.7,
			"eink_arm_Sum": 1209,
			"ant_eink_arm": 12.7,
			"p25": 104.491725768322,
			"p50": 103.166666666667,
			"p75": 103.418803418803,
			"armindex": 98.4496124031008
		},
		{
			"": 2052,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9037,
			"SteuerEinkommen_P25": 16.5,
			"SteuerEinkommen_Median": 29.8,
			"SteuerEinkommen_P75": 44.5,
			"eink_arm_Sum": 2494,
			"ant_eink_arm": 27.6,
			"p25": 105.095541401274,
			"p50": 104.929577464789,
			"p75": 103.248259860789,
			"armindex": 100.363636363636
		},
		{
			"": 2053,
			"SteuerJahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5344,
			"SteuerEinkommen_P25": 40.9,
			"SteuerEinkommen_Median": 56.6,
			"SteuerEinkommen_P75": 74.4,
			"eink_arm_Sum": 774,
			"ant_eink_arm": 14.5,
			"p25": 102.25,
			"p50": 102.815622161671,
			"p75": 103.190013869626,
			"armindex": 98.6394557823129
		},
		{
			"": 2167,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4587,
			"SteuerEinkommen_P25": 3.5,
			"SteuerEinkommen_Median": 22.95,
			"SteuerEinkommen_P75": 56.3,
			"eink_arm_Sum": 2040,
			"ant_eink_arm": 44.5,
			"p25": 76.0869565217391,
			"p50": 103.378378378378,
			"p75": 112.6,
			"armindex": 105.952380952381
		},
		{
			"": 2168,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 596,
			"SteuerEinkommen_P25": 49.2,
			"SteuerEinkommen_Median": 91.8,
			"SteuerEinkommen_P75": 149.4,
			"eink_arm_Sum": 106,
			"ant_eink_arm": 17.8,
			"p25": 104.458598726115,
			"p50": 114.321295143213,
			"p75": 116.71875,
			"armindex": 117.105263157895
		},
		{
			"": 2277,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11381,
			"SteuerEinkommen_P25": 21,
			"SteuerEinkommen_Median": 41,
			"SteuerEinkommen_P75": 63.9,
			"eink_arm_Sum": 2513,
			"ant_eink_arm": 22.1,
			"p25": 105,
			"p50": 107.894736842105,
			"p75": 109.417808219178,
			"armindex": 102.790697674419
		},
		{
			"": 2278,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4821,
			"SteuerEinkommen_P25": 53.1,
			"SteuerEinkommen_Median": 76,
			"SteuerEinkommen_P75": 112.2,
			"eink_arm_Sum": 463,
			"ant_eink_arm": 9.6,
			"p25": 108.146639511202,
			"p50": 108.882521489971,
			"p75": 110.541871921182,
			"armindex": 88.8888888888889
		},
		{
			"": 2370,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18338,
			"SteuerEinkommen_P25": 19.7,
			"SteuerEinkommen_Median": 36.1,
			"SteuerEinkommen_P75": 54.7,
			"eink_arm_Sum": 4381,
			"ant_eink_arm": 23.9,
			"p25": 111.299435028249,
			"p50": 109.726443768997,
			"p75": 109.4,
			"armindex": 97.5510204081633
		},
		{
			"": 2371,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6541,
			"SteuerEinkommen_P25": 43.5,
			"SteuerEinkommen_Median": 62.4,
			"SteuerEinkommen_P75": 85.2,
			"eink_arm_Sum": 973,
			"ant_eink_arm": 14.9,
			"p25": 107.673267326733,
			"p50": 105.762711864407,
			"p75": 106.5,
			"armindex": 98.6754966887417
		},
		{
			"": 2460,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12119,
			"SteuerEinkommen_P25": 16.9,
			"SteuerEinkommen_Median": 32,
			"SteuerEinkommen_P75": 50.3,
			"eink_arm_Sum": 3421,
			"ant_eink_arm": 28.2,
			"p25": 117.361111111111,
			"p50": 111.111111111111,
			"p75": 109.347826086957,
			"armindex": 93.687707641196
		},
		{
			"": 2461,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3371,
			"SteuerEinkommen_P25": 37.15,
			"SteuerEinkommen_Median": 55.35,
			"SteuerEinkommen_P75": 73.8,
			"eink_arm_Sum": 713,
			"ant_eink_arm": 21.2,
			"p25": 106.752873563218,
			"p50": 107.267441860465,
			"p75": 104.237288135593,
			"armindex": 103.921568627451
		},
		{
			"": 2551,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5507,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 36.8,
			"SteuerEinkommen_P75": 56.5,
			"eink_arm_Sum": 1403,
			"ant_eink_arm": 25.5,
			"p25": 117.460317460317,
			"p50": 113.931888544892,
			"p75": 113.226452905812,
			"armindex": 94.7955390334573
		},
		{
			"": 2552,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1358,
			"SteuerEinkommen_P25": 41.4,
			"SteuerEinkommen_Median": 58.8,
			"SteuerEinkommen_P75": 79.2,
			"eink_arm_Sum": 240,
			"ant_eink_arm": 17.7,
			"p25": 111.590296495957,
			"p50": 108.888888888889,
			"p75": 107.027027027027,
			"armindex": 91.7098445595855
		},
		{
			"": 2619,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12430,
			"SteuerEinkommen_P25": 20.4,
			"SteuerEinkommen_Median": 41.1,
			"SteuerEinkommen_P75": 64.7,
			"eink_arm_Sum": 2856,
			"ant_eink_arm": 23,
			"p25": 107.936507936508,
			"p50": 109.018567639257,
			"p75": 109.106239460371,
			"armindex": 100
		},
		{
			"": 2620,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4266,
			"SteuerEinkommen_P25": 52.8,
			"SteuerEinkommen_Median": 77.7,
			"SteuerEinkommen_P75": 120.5,
			"eink_arm_Sum": 455,
			"ant_eink_arm": 10.7,
			"p25": 108.865979381443,
			"p50": 111,
			"p75": 115.754082612872,
			"armindex": 100
		},
		{
			"": 2687,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14030,
			"SteuerEinkommen_P25": 20.2,
			"SteuerEinkommen_Median": 44.9,
			"SteuerEinkommen_P75": 71.9,
			"eink_arm_Sum": 3316,
			"ant_eink_arm": 23.6,
			"p25": 109.782608695652,
			"p50": 107.416267942584,
			"p75": 108.446455505279,
			"armindex": 98.744769874477
		},
		{
			"": 2688,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5437,
			"SteuerEinkommen_P25": 63.7,
			"SteuerEinkommen_Median": 101.4,
			"SteuerEinkommen_P75": 168.45,
			"eink_arm_Sum": 439,
			"ant_eink_arm": 8.1,
			"p25": 109.075342465753,
			"p50": 111.428571428571,
			"p75": 112.675585284281,
			"armindex": 88.0434782608696
		},
		{
			"": 2803,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7270,
			"SteuerEinkommen_P25": 22.7,
			"SteuerEinkommen_Median": 45.6,
			"SteuerEinkommen_P75": 70.1,
			"eink_arm_Sum": 1507,
			"ant_eink_arm": 20.7,
			"p25": 112.935323383085,
			"p50": 111.491442542787,
			"p75": 111.093502377179,
			"armindex": 95.8333333333333
		},
		{
			"": 2804,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1881,
			"SteuerEinkommen_P25": 58.2,
			"SteuerEinkommen_Median": 86.6,
			"SteuerEinkommen_P75": 139.3,
			"eink_arm_Sum": 172,
			"ant_eink_arm": 9.1,
			"p25": 113.671875,
			"p50": 111.025641025641,
			"p75": 114.744645799012,
			"armindex": 83.4862385321101
		},
		{
			"": 2896,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16911,
			"SteuerEinkommen_P25": 20.2,
			"SteuerEinkommen_Median": 36.615,
			"SteuerEinkommen_P75": 53.7,
			"eink_arm_Sum": 3878,
			"ant_eink_arm": 22.9,
			"p25": 106.878306878307,
			"p50": 107.691176470588,
			"p75": 107.4,
			"armindex": 100.438596491228
		},
		{
			"": 2897,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8558,
			"SteuerEinkommen_P25": 46.6,
			"SteuerEinkommen_Median": 63.45,
			"SteuerEinkommen_P75": 86,
			"eink_arm_Sum": 1037,
			"ant_eink_arm": 12.1,
			"p25": 105.909090909091,
			"p50": 107.360406091371,
			"p75": 106.832298136646,
			"armindex": 101.680672268908
		},
		{
			"": 2965,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14731,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 42.1,
			"SteuerEinkommen_P75": 62.6,
			"eink_arm_Sum": 3113,
			"ant_eink_arm": 21.1,
			"p25": 108.5,
			"p50": 109.350649350649,
			"p75": 109.059233449477,
			"armindex": 98.1395348837209
		},
		{
			"": 2966,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5875,
			"SteuerEinkommen_P25": 53.8,
			"SteuerEinkommen_Median": 75,
			"SteuerEinkommen_P75": 108,
			"eink_arm_Sum": 553,
			"ant_eink_arm": 9.4,
			"p25": 108.467741935484,
			"p50": 108.695652173913,
			"p75": 109.533468559838,
			"armindex": 84.6846846846847
		},
		{
			"": 3034,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18904,
			"SteuerEinkommen_P25": 19.6,
			"SteuerEinkommen_Median": 36.1,
			"SteuerEinkommen_P75": 54.1,
			"eink_arm_Sum": 4543,
			"ant_eink_arm": 24,
			"p25": 106.521739130435,
			"p50": 106.804733727811,
			"p75": 108.2,
			"armindex": 103.448275862069
		},
		{
			"": 3035,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 9573,
			"SteuerEinkommen_P25": 45.4,
			"SteuerEinkommen_Median": 64.3,
			"SteuerEinkommen_P75": 88.4,
			"eink_arm_Sum": 1240,
			"ant_eink_arm": 13,
			"p25": 107.328605200946,
			"p50": 107.166666666667,
			"p75": 107.936507936508,
			"armindex": 100.77519379845
		},
		{
			"": 3128,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8978,
			"SteuerEinkommen_P25": 16.9,
			"SteuerEinkommen_Median": 30.8,
			"SteuerEinkommen_P75": 45.8,
			"eink_arm_Sum": 2512,
			"ant_eink_arm": 28,
			"p25": 107.643312101911,
			"p50": 108.450704225352,
			"p75": 106.264501160093,
			"armindex": 101.818181818182
		},
		{
			"": 3129,
			"SteuerJahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5294,
			"SteuerEinkommen_P25": 42.5,
			"SteuerEinkommen_Median": 58.9,
			"SteuerEinkommen_P75": 76.9,
			"eink_arm_Sum": 768,
			"ant_eink_arm": 14.5,
			"p25": 106.25,
			"p50": 106.993642143506,
			"p75": 106.657420249653,
			"armindex": 98.6394557823129
		},
		{
			"": 3243,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4514,
			"SteuerEinkommen_P25": 3.2,
			"SteuerEinkommen_Median": 22.6,
			"SteuerEinkommen_P75": 55.8,
			"eink_arm_Sum": 2008,
			"ant_eink_arm": 44.5,
			"p25": 69.5652173913044,
			"p50": 101.801801801802,
			"p75": 111.6,
			"armindex": 105.952380952381
		},
		{
			"": 3244,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 603,
			"SteuerEinkommen_P25": 50,
			"SteuerEinkommen_Median": 88.3,
			"SteuerEinkommen_P75": 148.3,
			"eink_arm_Sum": 100,
			"ant_eink_arm": 16.6,
			"p25": 106.157112526539,
			"p50": 109.962640099626,
			"p75": 115.859375,
			"armindex": 109.210526315789
		},
		{
			"": 3353,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11467,
			"SteuerEinkommen_P25": 20.4,
			"SteuerEinkommen_Median": 40.8,
			"SteuerEinkommen_P75": 63.6,
			"eink_arm_Sum": 2638,
			"ant_eink_arm": 23,
			"p25": 102,
			"p50": 107.368421052632,
			"p75": 108.904109589041,
			"armindex": 106.976744186047
		},
		{
			"": 3354,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4747,
			"SteuerEinkommen_P25": 53,
			"SteuerEinkommen_Median": 75.9,
			"SteuerEinkommen_P75": 113,
			"eink_arm_Sum": 477,
			"ant_eink_arm": 10,
			"p25": 107.942973523422,
			"p50": 108.739255014327,
			"p75": 111.330049261084,
			"armindex": 92.5925925925926
		},
		{
			"": 3446,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18494,
			"SteuerEinkommen_P25": 18.9,
			"SteuerEinkommen_Median": 36.2,
			"SteuerEinkommen_P75": 55,
			"eink_arm_Sum": 4623,
			"ant_eink_arm": 25,
			"p25": 106.779661016949,
			"p50": 110.030395136778,
			"p75": 110,
			"armindex": 102.040816326531
		},
		{
			"": 3447,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6463,
			"SteuerEinkommen_P25": 42.9,
			"SteuerEinkommen_Median": 61.9,
			"SteuerEinkommen_P75": 85.5,
			"eink_arm_Sum": 982,
			"ant_eink_arm": 15.2,
			"p25": 106.188118811881,
			"p50": 104.915254237288,
			"p75": 106.875,
			"armindex": 100.662251655629
		},
		{
			"": 3537,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12113,
			"SteuerEinkommen_P25": 16,
			"SteuerEinkommen_Median": 31.9,
			"SteuerEinkommen_P75": 50.4,
			"eink_arm_Sum": 3576,
			"ant_eink_arm": 29.5,
			"p25": 111.111111111111,
			"p50": 110.763888888889,
			"p75": 109.565217391304,
			"armindex": 98.0066445182724
		},
		{
			"": 3538,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3384,
			"SteuerEinkommen_P25": 37.1,
			"SteuerEinkommen_Median": 55.4,
			"SteuerEinkommen_P75": 74.4,
			"eink_arm_Sum": 714,
			"ant_eink_arm": 21.1,
			"p25": 106.609195402299,
			"p50": 107.364341085271,
			"p75": 105.084745762712,
			"armindex": 103.43137254902
		},
		{
			"": 3629,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5774,
			"SteuerEinkommen_P25": 19.5,
			"SteuerEinkommen_Median": 37.7,
			"SteuerEinkommen_P75": 57.5,
			"eink_arm_Sum": 1405,
			"ant_eink_arm": 24.3,
			"p25": 123.809523809524,
			"p50": 116.71826625387,
			"p75": 115.230460921844,
			"armindex": 90.3345724907063
		},
		{
			"": 3630,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1364,
			"SteuerEinkommen_P25": 39.85,
			"SteuerEinkommen_Median": 59.6,
			"SteuerEinkommen_P75": 81.7,
			"eink_arm_Sum": 251,
			"ant_eink_arm": 18.4,
			"p25": 107.412398921833,
			"p50": 110.37037037037,
			"p75": 110.405405405405,
			"armindex": 95.3367875647668
		},
		{
			"": 3696,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12469,
			"SteuerEinkommen_P25": 20.9,
			"SteuerEinkommen_Median": 41.5,
			"SteuerEinkommen_P75": 65.4,
			"eink_arm_Sum": 2793,
			"ant_eink_arm": 22.4,
			"p25": 110.582010582011,
			"p50": 110.079575596817,
			"p75": 110.286677908938,
			"armindex": 97.3913043478261
		},
		{
			"": 3697,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4177,
			"SteuerEinkommen_P25": 53.5,
			"SteuerEinkommen_Median": 78.4,
			"SteuerEinkommen_P75": 119.4,
			"eink_arm_Sum": 446,
			"ant_eink_arm": 10.7,
			"p25": 110.309278350515,
			"p50": 112,
			"p75": 114.697406340058,
			"armindex": 100
		},
		{
			"": 3764,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14100,
			"SteuerEinkommen_P25": 20.3,
			"SteuerEinkommen_Median": 45,
			"SteuerEinkommen_P75": 72.7,
			"eink_arm_Sum": 3310,
			"ant_eink_arm": 23.5,
			"p25": 110.326086956522,
			"p50": 107.655502392345,
			"p75": 109.653092006033,
			"armindex": 98.326359832636
		},
		{
			"": 3765,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5341,
			"SteuerEinkommen_P25": 63.2,
			"SteuerEinkommen_Median": 101.2,
			"SteuerEinkommen_P75": 167,
			"eink_arm_Sum": 437,
			"ant_eink_arm": 8.2,
			"p25": 108.219178082192,
			"p50": 111.208791208791,
			"p75": 111.705685618729,
			"armindex": 89.1304347826087
		},
		{
			"": 3880,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7315,
			"SteuerEinkommen_P25": 21.9,
			"SteuerEinkommen_Median": 45,
			"SteuerEinkommen_P75": 70.3,
			"eink_arm_Sum": 1558,
			"ant_eink_arm": 21.3,
			"p25": 108.955223880597,
			"p50": 110.024449877751,
			"p75": 111.410459587956,
			"armindex": 98.6111111111111
		},
		{
			"": 3881,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1835,
			"SteuerEinkommen_P25": 58,
			"SteuerEinkommen_Median": 87.7,
			"SteuerEinkommen_P75": 136.3,
			"eink_arm_Sum": 171,
			"ant_eink_arm": 9.3,
			"p25": 113.28125,
			"p50": 112.435897435897,
			"p75": 112.273476112026,
			"armindex": 85.3211009174312
		},
		{
			"": 3970,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16986,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 36.5,
			"SteuerEinkommen_P75": 53.6,
			"eink_arm_Sum": 3947,
			"ant_eink_arm": 23.2,
			"p25": 105.820105820106,
			"p50": 107.352941176471,
			"p75": 107.2,
			"armindex": 101.754385964912
		},
		{
			"": 3971,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8456,
			"SteuerEinkommen_P25": 46.9,
			"SteuerEinkommen_Median": 63.6,
			"SteuerEinkommen_P75": 85.6,
			"eink_arm_Sum": 1017,
			"ant_eink_arm": 12,
			"p25": 106.590909090909,
			"p50": 107.61421319797,
			"p75": 106.335403726708,
			"armindex": 100.840336134454
		},
		{
			"": 4038,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14990,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 42.5,
			"SteuerEinkommen_P75": 63,
			"eink_arm_Sum": 3273,
			"ant_eink_arm": 21.8,
			"p25": 106,
			"p50": 110.38961038961,
			"p75": 109.756097560976,
			"armindex": 101.395348837209
		},
		{
			"": 4039,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5787,
			"SteuerEinkommen_P25": 53.1,
			"SteuerEinkommen_Median": 74.4,
			"SteuerEinkommen_P75": 107.4,
			"eink_arm_Sum": 583,
			"ant_eink_arm": 10.1,
			"p25": 107.056451612903,
			"p50": 107.826086956522,
			"p75": 108.924949290061,
			"armindex": 90.990990990991
		},
		{
			"": 4109,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 19384,
			"SteuerEinkommen_P25": 19,
			"SteuerEinkommen_Median": 36.5,
			"SteuerEinkommen_P75": 54.4,
			"eink_arm_Sum": 4810,
			"ant_eink_arm": 24.8,
			"p25": 103.260869565217,
			"p50": 107.988165680473,
			"p75": 108.8,
			"armindex": 106.896551724138
		},
		{
			"": 4110,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 9604,
			"SteuerEinkommen_P25": 45.4,
			"SteuerEinkommen_Median": 64.4,
			"SteuerEinkommen_P75": 88,
			"eink_arm_Sum": 1237,
			"ant_eink_arm": 12.9,
			"p25": 107.328605200946,
			"p50": 107.333333333333,
			"p75": 107.448107448107,
			"armindex": 100
		},
		{
			"": 4203,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9051,
			"SteuerEinkommen_P25": 16.5,
			"SteuerEinkommen_Median": 30.9,
			"SteuerEinkommen_P75": 46,
			"eink_arm_Sum": 2581,
			"ant_eink_arm": 28.5,
			"p25": 105.095541401274,
			"p50": 108.802816901408,
			"p75": 106.728538283063,
			"armindex": 103.636363636364
		},
		{
			"": 4204,
			"SteuerJahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5338,
			"SteuerEinkommen_P25": 41.9,
			"SteuerEinkommen_Median": 58.5,
			"SteuerEinkommen_P75": 76.3,
			"eink_arm_Sum": 782,
			"ant_eink_arm": 14.6,
			"p25": 104.75,
			"p50": 106.267029972752,
			"p75": 105.825242718447,
			"armindex": 99.3197278911565
		},
		{
			"": 4317,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 4150,
			"SteuerEinkommen_P25": 5,
			"SteuerEinkommen_Median": 25.5,
			"SteuerEinkommen_P75": 59.1,
			"eink_arm_Sum": 1716,
			"ant_eink_arm": 41.3,
			"p25": 108.695652173913,
			"p50": 114.864864864865,
			"p75": 118.2,
			"armindex": 98.3333333333333
		},
		{
			"": 4318,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 597,
			"SteuerEinkommen_P25": 50,
			"SteuerEinkommen_Median": 89,
			"SteuerEinkommen_P75": 147,
			"eink_arm_Sum": 86,
			"ant_eink_arm": 14.4,
			"p25": 106.157112526539,
			"p50": 110.834371108344,
			"p75": 114.84375,
			"armindex": 94.7368421052632
		},
		{
			"": 4426,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11582,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 40.5,
			"SteuerEinkommen_P75": 62.9,
			"eink_arm_Sum": 2651,
			"ant_eink_arm": 22.9,
			"p25": 103,
			"p50": 106.578947368421,
			"p75": 107.705479452055,
			"armindex": 106.511627906977
		},
		{
			"": 4427,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4659,
			"SteuerEinkommen_P25": 52.5,
			"SteuerEinkommen_Median": 75.5,
			"SteuerEinkommen_P75": 111.9,
			"eink_arm_Sum": 445,
			"ant_eink_arm": 9.6,
			"p25": 106.924643584521,
			"p50": 108.166189111748,
			"p75": 110.246305418719,
			"armindex": 88.8888888888889
		},
		{
			"": 4518,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18546,
			"SteuerEinkommen_P25": 18.8,
			"SteuerEinkommen_Median": 36.2,
			"SteuerEinkommen_P75": 55,
			"eink_arm_Sum": 4658,
			"ant_eink_arm": 25.1,
			"p25": 106.214689265537,
			"p50": 110.030395136778,
			"p75": 110,
			"armindex": 102.448979591837
		},
		{
			"": 4519,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6408,
			"SteuerEinkommen_P25": 42.2,
			"SteuerEinkommen_Median": 61.5,
			"SteuerEinkommen_P75": 83.6,
			"eink_arm_Sum": 1023,
			"ant_eink_arm": 16,
			"p25": 104.455445544554,
			"p50": 104.237288135593,
			"p75": 104.5,
			"armindex": 105.960264900662
		},
		{
			"": 4609,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12114,
			"SteuerEinkommen_P25": 16.2,
			"SteuerEinkommen_Median": 32.4,
			"SteuerEinkommen_P75": 50.4,
			"eink_arm_Sum": 3515,
			"ant_eink_arm": 29,
			"p25": 112.5,
			"p50": 112.5,
			"p75": 109.565217391304,
			"armindex": 96.3455149501661
		},
		{
			"": 4610,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3249,
			"SteuerEinkommen_P25": 36.4,
			"SteuerEinkommen_Median": 54.8,
			"SteuerEinkommen_P75": 74.1,
			"eink_arm_Sum": 687,
			"ant_eink_arm": 21.1,
			"p25": 104.597701149425,
			"p50": 106.201550387597,
			"p75": 104.661016949153,
			"armindex": 103.43137254902
		},
		{
			"": 4702,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5708,
			"SteuerEinkommen_P25": 19.3,
			"SteuerEinkommen_Median": 38.7,
			"SteuerEinkommen_P75": 58.6,
			"eink_arm_Sum": 1404,
			"ant_eink_arm": 24.6,
			"p25": 122.539682539683,
			"p50": 119.814241486068,
			"p75": 117.434869739479,
			"armindex": 91.4498141263941
		},
		{
			"": 4703,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1353,
			"SteuerEinkommen_P25": 40.3,
			"SteuerEinkommen_Median": 59.6,
			"SteuerEinkommen_P75": 79.9,
			"eink_arm_Sum": 255,
			"ant_eink_arm": 18.8,
			"p25": 108.625336927224,
			"p50": 110.37037037037,
			"p75": 107.972972972973,
			"armindex": 97.4093264248705
		},
		{
			"": 4771,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12497,
			"SteuerEinkommen_P25": 20.8,
			"SteuerEinkommen_Median": 41.8,
			"SteuerEinkommen_P75": 65.1,
			"eink_arm_Sum": 2861,
			"ant_eink_arm": 22.9,
			"p25": 110.05291005291,
			"p50": 110.875331564987,
			"p75": 109.780775716695,
			"armindex": 99.5652173913043
		},
		{
			"": 4772,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4109,
			"SteuerEinkommen_P25": 53.6,
			"SteuerEinkommen_Median": 78.7,
			"SteuerEinkommen_P75": 120.9,
			"eink_arm_Sum": 440,
			"ant_eink_arm": 10.7,
			"p25": 110.515463917526,
			"p50": 112.428571428571,
			"p75": 116.138328530259,
			"armindex": 100
		},
		{
			"": 4839,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14122,
			"SteuerEinkommen_P25": 19.5,
			"SteuerEinkommen_Median": 45,
			"SteuerEinkommen_P75": 72.9,
			"eink_arm_Sum": 3453,
			"ant_eink_arm": 24.5,
			"p25": 105.978260869565,
			"p50": 107.655502392345,
			"p75": 109.954751131222,
			"armindex": 102.510460251046
		},
		{
			"": 4840,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5371,
			"SteuerEinkommen_P25": 64,
			"SteuerEinkommen_Median": 100,
			"SteuerEinkommen_P75": 169.1,
			"eink_arm_Sum": 438,
			"ant_eink_arm": 8.2,
			"p25": 109.58904109589,
			"p50": 109.89010989011,
			"p75": 113.110367892977,
			"armindex": 89.1304347826087
		},
		{
			"": 4956,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7306,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 45.9,
			"SteuerEinkommen_P75": 70.2,
			"eink_arm_Sum": 1588,
			"ant_eink_arm": 21.7,
			"p25": 107.960199004975,
			"p50": 112.224938875306,
			"p75": 111.251980982567,
			"armindex": 100.462962962963
		},
		{
			"": 4957,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1798,
			"SteuerEinkommen_P25": 57.3,
			"SteuerEinkommen_Median": 88.3,
			"SteuerEinkommen_P75": 138.4,
			"eink_arm_Sum": 170,
			"ant_eink_arm": 9.5,
			"p25": 111.9140625,
			"p50": 113.205128205128,
			"p75": 114.003294892916,
			"armindex": 87.1559633027523
		},
		{
			"": 5047,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 17113,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 36.6,
			"SteuerEinkommen_P75": 53.8,
			"eink_arm_Sum": 4002,
			"ant_eink_arm": 23.4,
			"p25": 105.820105820106,
			"p50": 107.647058823529,
			"p75": 107.6,
			"armindex": 102.631578947368
		},
		{
			"": 5048,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8281,
			"SteuerEinkommen_P25": 46.4,
			"SteuerEinkommen_Median": 62.6,
			"SteuerEinkommen_P75": 85.2,
			"eink_arm_Sum": 991,
			"ant_eink_arm": 12,
			"p25": 105.454545454545,
			"p50": 105.922165820643,
			"p75": 105.83850931677,
			"armindex": 100.840336134454
		},
		{
			"": 5115,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 15376,
			"SteuerEinkommen_P25": 20.8,
			"SteuerEinkommen_Median": 41.9,
			"SteuerEinkommen_P75": 62.4,
			"eink_arm_Sum": 3449,
			"ant_eink_arm": 22.4,
			"p25": 104,
			"p50": 108.831168831169,
			"p75": 108.710801393728,
			"armindex": 104.186046511628
		},
		{
			"": 5116,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5687,
			"SteuerEinkommen_P25": 52.8,
			"SteuerEinkommen_Median": 74.3,
			"SteuerEinkommen_P75": 107.2,
			"eink_arm_Sum": 587,
			"ant_eink_arm": 10.3,
			"p25": 106.451612903226,
			"p50": 107.68115942029,
			"p75": 108.722109533469,
			"armindex": 92.7927927927928
		},
		{
			"": 5185,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 19806,
			"SteuerEinkommen_P25": 18.6,
			"SteuerEinkommen_Median": 36.2,
			"SteuerEinkommen_P75": 54.1,
			"eink_arm_Sum": 5012,
			"ant_eink_arm": 25.3,
			"p25": 101.086956521739,
			"p50": 107.100591715976,
			"p75": 108.2,
			"armindex": 109.051724137931
		},
		{
			"": 5186,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 9714,
			"SteuerEinkommen_P25": 45,
			"SteuerEinkommen_Median": 64.1,
			"SteuerEinkommen_P75": 88.4,
			"eink_arm_Sum": 1296,
			"ant_eink_arm": 13.3,
			"p25": 106.382978723404,
			"p50": 106.833333333333,
			"p75": 107.936507936508,
			"armindex": 103.100775193798
		},
		{
			"": 5279,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9016,
			"SteuerEinkommen_P25": 16.4,
			"SteuerEinkommen_Median": 30.9,
			"SteuerEinkommen_P75": 45.5,
			"eink_arm_Sum": 2572,
			"ant_eink_arm": 28.5,
			"p25": 104.458598726115,
			"p50": 108.802816901408,
			"p75": 105.568445475638,
			"armindex": 103.636363636364
		},
		{
			"": 5280,
			"SteuerJahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5247,
			"SteuerEinkommen_P25": 41.7,
			"SteuerEinkommen_Median": 58.3,
			"SteuerEinkommen_P75": 75.6,
			"eink_arm_Sum": 779,
			"ant_eink_arm": 14.8,
			"p25": 104.25,
			"p50": 105.903723887375,
			"p75": 104.854368932039,
			"armindex": 100.680272108844
		},
		{
			"": 5393,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3831,
			"SteuerEinkommen_P25": 6.5,
			"SteuerEinkommen_Median": 28.1,
			"SteuerEinkommen_P75": 62.4,
			"eink_arm_Sum": 1509,
			"ant_eink_arm": 39.4,
			"p25": 141.304347826087,
			"p50": 126.576576576577,
			"p75": 124.8,
			"armindex": 93.8095238095238
		},
		{
			"": 5394,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 590,
			"SteuerEinkommen_P25": 56,
			"SteuerEinkommen_Median": 93.8,
			"SteuerEinkommen_P75": 150.3,
			"eink_arm_Sum": 77,
			"ant_eink_arm": 13.1,
			"p25": 118.895966029724,
			"p50": 116.81195516812,
			"p75": 117.421875,
			"armindex": 86.1842105263158
		},
		{
			"": 5505,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11720,
			"SteuerEinkommen_P25": 19.9,
			"SteuerEinkommen_Median": 40.1,
			"SteuerEinkommen_P75": 63,
			"eink_arm_Sum": 2814,
			"ant_eink_arm": 24,
			"p25": 99.5,
			"p50": 105.526315789474,
			"p75": 107.876712328767,
			"armindex": 111.627906976744
		},
		{
			"": 5506,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4603,
			"SteuerEinkommen_P25": 51.9,
			"SteuerEinkommen_Median": 76.4,
			"SteuerEinkommen_P75": 114.5,
			"eink_arm_Sum": 487,
			"ant_eink_arm": 10.6,
			"p25": 105.702647657841,
			"p50": 109.45558739255,
			"p75": 112.807881773399,
			"armindex": 98.1481481481481
		},
		{
			"": 5598,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18552,
			"SteuerEinkommen_P25": 18.4,
			"SteuerEinkommen_Median": 36.1,
			"SteuerEinkommen_P75": 55.3,
			"eink_arm_Sum": 4725,
			"ant_eink_arm": 25.5,
			"p25": 103.954802259887,
			"p50": 109.726443768997,
			"p75": 110.6,
			"armindex": 104.081632653061
		},
		{
			"": 5599,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6372,
			"SteuerEinkommen_P25": 41.2,
			"SteuerEinkommen_Median": 61.1,
			"SteuerEinkommen_P75": 85.3,
			"eink_arm_Sum": 1085,
			"ant_eink_arm": 17,
			"p25": 101.980198019802,
			"p50": 103.559322033898,
			"p75": 106.625,
			"armindex": 112.582781456954
		},
		{
			"": 5690,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12182,
			"SteuerEinkommen_P25": 15.7,
			"SteuerEinkommen_Median": 31.9,
			"SteuerEinkommen_P75": 50.9,
			"eink_arm_Sum": 3628,
			"ant_eink_arm": 29.8,
			"p25": 109.027777777778,
			"p50": 110.763888888889,
			"p75": 110.652173913043,
			"armindex": 99.0033222591362
		},
		{
			"": 5691,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3180,
			"SteuerEinkommen_P25": 34.6,
			"SteuerEinkommen_Median": 53,
			"SteuerEinkommen_P75": 72.5,
			"eink_arm_Sum": 751,
			"ant_eink_arm": 23.6,
			"p25": 99.4252873563219,
			"p50": 102.713178294574,
			"p75": 102.401129943503,
			"armindex": 115.686274509804
		},
		{
			"": 5784,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 5985,
			"SteuerEinkommen_P25": 16.2,
			"SteuerEinkommen_Median": 37.7,
			"SteuerEinkommen_P75": 58.4,
			"eink_arm_Sum": 1682,
			"ant_eink_arm": 28.1,
			"p25": 102.857142857143,
			"p50": 116.71826625387,
			"p75": 117.034068136273,
			"armindex": 104.460966542751
		},
		{
			"": 5785,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1353,
			"SteuerEinkommen_P25": 40.3,
			"SteuerEinkommen_Median": 59.5,
			"SteuerEinkommen_P75": 82.8,
			"eink_arm_Sum": 239,
			"ant_eink_arm": 17.7,
			"p25": 108.625336927224,
			"p50": 110.185185185185,
			"p75": 111.891891891892,
			"armindex": 91.7098445595855
		},
		{
			"": 5852,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12357,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 42.3,
			"SteuerEinkommen_P75": 66,
			"eink_arm_Sum": 2822,
			"ant_eink_arm": 22.8,
			"p25": 108.465608465608,
			"p50": 112.201591511936,
			"p75": 111.298482293423,
			"armindex": 99.1304347826087
		},
		{
			"": 5853,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4058,
			"SteuerEinkommen_P25": 53,
			"SteuerEinkommen_Median": 78.7,
			"SteuerEinkommen_P75": 121.8,
			"eink_arm_Sum": 441,
			"ant_eink_arm": 10.9,
			"p25": 109.278350515464,
			"p50": 112.428571428571,
			"p75": 117.00288184438,
			"armindex": 101.869158878505
		},
		{
			"": 5920,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14106,
			"SteuerEinkommen_P25": 19.5,
			"SteuerEinkommen_Median": 44.7,
			"SteuerEinkommen_P75": 72.9,
			"eink_arm_Sum": 3435,
			"ant_eink_arm": 24.4,
			"p25": 105.978260869565,
			"p50": 106.937799043062,
			"p75": 109.954751131222,
			"armindex": 102.092050209205
		},
		{
			"": 5921,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5403,
			"SteuerEinkommen_P25": 63.5,
			"SteuerEinkommen_Median": 101.6,
			"SteuerEinkommen_P75": 174,
			"eink_arm_Sum": 459,
			"ant_eink_arm": 8.5,
			"p25": 108.732876712329,
			"p50": 111.648351648352,
			"p75": 116.387959866221,
			"armindex": 92.3913043478261
		},
		{
			"": 6036,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7346,
			"SteuerEinkommen_P25": 20.8,
			"SteuerEinkommen_Median": 45.1,
			"SteuerEinkommen_P75": 70.6,
			"eink_arm_Sum": 1664,
			"ant_eink_arm": 22.7,
			"p25": 103.482587064677,
			"p50": 110.268948655257,
			"p75": 111.88589540412,
			"armindex": 105.092592592593
		},
		{
			"": 6037,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1817,
			"SteuerEinkommen_P25": 58.1,
			"SteuerEinkommen_Median": 88,
			"SteuerEinkommen_P75": 139.9,
			"eink_arm_Sum": 173,
			"ant_eink_arm": 9.5,
			"p25": 113.4765625,
			"p50": 112.820512820513,
			"p75": 115.238879736409,
			"armindex": 87.1559633027523
		},
		{
			"": 6126,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 17369,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 36.3,
			"SteuerEinkommen_P75": 53.5,
			"eink_arm_Sum": 4224,
			"ant_eink_arm": 24.3,
			"p25": 102.645502645503,
			"p50": 106.764705882353,
			"p75": 107,
			"armindex": 106.578947368421
		},
		{
			"": 6127,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8185,
			"SteuerEinkommen_P25": 45.4,
			"SteuerEinkommen_Median": 62.5,
			"SteuerEinkommen_P75": 85.4,
			"eink_arm_Sum": 1087,
			"ant_eink_arm": 13.3,
			"p25": 103.181818181818,
			"p50": 105.75296108291,
			"p75": 106.086956521739,
			"armindex": 111.764705882353
		},
		{
			"": 6194,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 15446,
			"SteuerEinkommen_P25": 20.2,
			"SteuerEinkommen_Median": 41.7,
			"SteuerEinkommen_P75": 62,
			"eink_arm_Sum": 3544,
			"ant_eink_arm": 22.9,
			"p25": 101,
			"p50": 108.311688311688,
			"p75": 108.01393728223,
			"armindex": 106.511627906977
		},
		{
			"": 6195,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5631,
			"SteuerEinkommen_P25": 52.3,
			"SteuerEinkommen_Median": 74.5,
			"SteuerEinkommen_P75": 108.9,
			"eink_arm_Sum": 584,
			"ant_eink_arm": 10.4,
			"p25": 105.443548387097,
			"p50": 107.971014492754,
			"p75": 110.446247464503,
			"armindex": 93.6936936936937
		},
		{
			"": 6265,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 20098,
			"SteuerEinkommen_P25": 17.6,
			"SteuerEinkommen_Median": 35.6,
			"SteuerEinkommen_P75": 54.1,
			"eink_arm_Sum": 5302,
			"ant_eink_arm": 26.4,
			"p25": 95.6521739130435,
			"p50": 105.325443786982,
			"p75": 108.2,
			"armindex": 113.793103448276
		},
		{
			"": 6266,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 9666,
			"SteuerEinkommen_P25": 44.3,
			"SteuerEinkommen_Median": 64.2,
			"SteuerEinkommen_P75": 88.7,
			"eink_arm_Sum": 1383,
			"ant_eink_arm": 14.3,
			"p25": 104.728132387707,
			"p50": 107,
			"p75": 108.302808302808,
			"armindex": 110.852713178295
		},
		{
			"": 6359,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8901,
			"SteuerEinkommen_P25": 15.8,
			"SteuerEinkommen_Median": 30.3,
			"SteuerEinkommen_P75": 45,
			"eink_arm_Sum": 2594,
			"ant_eink_arm": 29.1,
			"p25": 100.636942675159,
			"p50": 106.69014084507,
			"p75": 104.408352668213,
			"armindex": 105.818181818182
		},
		{
			"": 6360,
			"SteuerJahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5157,
			"SteuerEinkommen_P25": 40.6,
			"SteuerEinkommen_Median": 57.4,
			"SteuerEinkommen_P75": 75.8,
			"eink_arm_Sum": 831,
			"ant_eink_arm": 16.1,
			"p25": 101.5,
			"p50": 104.268846503179,
			"p75": 105.131761442441,
			"armindex": 109.52380952381
		},
		{
			"": 6473,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3738,
			"SteuerEinkommen_P25": 7.4,
			"SteuerEinkommen_Median": 30,
			"SteuerEinkommen_P75": 65,
			"eink_arm_Sum": 1417,
			"ant_eink_arm": 37.9,
			"p25": 160.869565217391,
			"p50": 135.135135135135,
			"p75": 130,
			"armindex": 90.2380952380952
		},
		{
			"": 6474,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 589,
			"SteuerEinkommen_P25": 59.8,
			"SteuerEinkommen_Median": 97.55,
			"SteuerEinkommen_P75": 156.7,
			"eink_arm_Sum": 63,
			"ant_eink_arm": 10.7,
			"p25": 126.963906581741,
			"p50": 121.481942714819,
			"p75": 122.421875,
			"armindex": 70.3947368421053
		},
		{
			"": 6584,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11838,
			"SteuerEinkommen_P25": 19.9,
			"SteuerEinkommen_Median": 40.7,
			"SteuerEinkommen_P75": 64,
			"eink_arm_Sum": 2846,
			"ant_eink_arm": 24,
			"p25": 99.5,
			"p50": 107.105263157895,
			"p75": 109.58904109589,
			"armindex": 111.627906976744
		},
		{
			"": 6585,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4607,
			"SteuerEinkommen_P25": 52.7,
			"SteuerEinkommen_Median": 77.5,
			"SteuerEinkommen_P75": 118.8,
			"eink_arm_Sum": 508,
			"ant_eink_arm": 11,
			"p25": 107.331975560081,
			"p50": 111.031518624642,
			"p75": 117.044334975369,
			"armindex": 101.851851851852
		},
		{
			"": 6676,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18795,
			"SteuerEinkommen_P25": 18.5,
			"SteuerEinkommen_Median": 36.9,
			"SteuerEinkommen_P75": 56.6,
			"eink_arm_Sum": 4829,
			"ant_eink_arm": 25.7,
			"p25": 104.519774011299,
			"p50": 112.158054711246,
			"p75": 113.2,
			"armindex": 104.897959183673
		},
		{
			"": 6677,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6321,
			"SteuerEinkommen_P25": 41.2,
			"SteuerEinkommen_Median": 60.9,
			"SteuerEinkommen_P75": 85.4,
			"eink_arm_Sum": 1107,
			"ant_eink_arm": 17.5,
			"p25": 101.980198019802,
			"p50": 103.220338983051,
			"p75": 106.75,
			"armindex": 115.894039735099
		},
		{
			"": 6768,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12444,
			"SteuerEinkommen_P25": 15.4,
			"SteuerEinkommen_Median": 32.5,
			"SteuerEinkommen_P75": 51.9,
			"eink_arm_Sum": 3811,
			"ant_eink_arm": 30.6,
			"p25": 106.944444444444,
			"p50": 112.847222222222,
			"p75": 112.826086956522,
			"armindex": 101.661129568106
		},
		{
			"": 6769,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3102,
			"SteuerEinkommen_P25": 33.7,
			"SteuerEinkommen_Median": 52.6,
			"SteuerEinkommen_P75": 73.1,
			"eink_arm_Sum": 787,
			"ant_eink_arm": 25.4,
			"p25": 96.8390804597701,
			"p50": 101.937984496124,
			"p75": 103.248587570621,
			"armindex": 124.509803921569
		},
		{
			"": 6858,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6043,
			"SteuerEinkommen_P25": 17.4,
			"SteuerEinkommen_Median": 38.5,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 1627,
			"ant_eink_arm": 26.9,
			"p25": 110.47619047619,
			"p50": 119.195046439628,
			"p75": 120.240480961924,
			"armindex": 100
		},
		{
			"": 6859,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1369,
			"SteuerEinkommen_P25": 39.65,
			"SteuerEinkommen_Median": 58.35,
			"SteuerEinkommen_P75": 83.45,
			"eink_arm_Sum": 261,
			"ant_eink_arm": 19.1,
			"p25": 106.873315363881,
			"p50": 108.055555555556,
			"p75": 112.77027027027,
			"armindex": 98.9637305699482
		},
		{
			"": 6925,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12292,
			"SteuerEinkommen_P25": 21.4,
			"SteuerEinkommen_Median": 43.1,
			"SteuerEinkommen_P75": 67.3,
			"eink_arm_Sum": 2704,
			"ant_eink_arm": 22,
			"p25": 113.227513227513,
			"p50": 114.323607427056,
			"p75": 113.490725126476,
			"armindex": 95.6521739130435
		},
		{
			"": 6926,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4043,
			"SteuerEinkommen_P25": 53.3,
			"SteuerEinkommen_Median": 80.3,
			"SteuerEinkommen_P75": 125.2,
			"eink_arm_Sum": 420,
			"ant_eink_arm": 10.4,
			"p25": 109.896907216495,
			"p50": 114.714285714286,
			"p75": 120.268972142171,
			"armindex": 97.196261682243
		},
		{
			"": 6993,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14222,
			"SteuerEinkommen_P25": 19.9,
			"SteuerEinkommen_Median": 45.9,
			"SteuerEinkommen_P75": 74.1,
			"eink_arm_Sum": 3459,
			"ant_eink_arm": 24.3,
			"p25": 108.152173913043,
			"p50": 109.808612440191,
			"p75": 111.764705882353,
			"armindex": 101.673640167364
		},
		{
			"": 6994,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5450,
			"SteuerEinkommen_P25": 64.6,
			"SteuerEinkommen_Median": 105.65,
			"SteuerEinkommen_P75": 179.9,
			"eink_arm_Sum": 460,
			"ant_eink_arm": 8.4,
			"p25": 110.616438356164,
			"p50": 116.098901098901,
			"p75": 120.334448160535,
			"armindex": 91.304347826087
		},
		{
			"": 7109,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7348,
			"SteuerEinkommen_P25": 21.3,
			"SteuerEinkommen_Median": 46.3,
			"SteuerEinkommen_P75": 72.6,
			"eink_arm_Sum": 1655,
			"ant_eink_arm": 22.5,
			"p25": 105.970149253731,
			"p50": 113.20293398533,
			"p75": 115.055467511886,
			"armindex": 104.166666666667
		},
		{
			"": 7110,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1808,
			"SteuerEinkommen_P25": 59.3,
			"SteuerEinkommen_Median": 92.1,
			"SteuerEinkommen_P75": 141.5,
			"eink_arm_Sum": 155,
			"ant_eink_arm": 8.6,
			"p25": 115.8203125,
			"p50": 118.076923076923,
			"p75": 116.556836902801,
			"armindex": 78.8990825688073
		},
		{
			"": 7199,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 17647,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 35.9,
			"SteuerEinkommen_P75": 54,
			"eink_arm_Sum": 4483,
			"ant_eink_arm": 25.4,
			"p25": 98.9417989417989,
			"p50": 105.588235294118,
			"p75": 108,
			"armindex": 111.40350877193
		},
		{
			"": 7200,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8153,
			"SteuerEinkommen_P25": 45,
			"SteuerEinkommen_Median": 62.8,
			"SteuerEinkommen_P75": 85.8,
			"eink_arm_Sum": 1176,
			"ant_eink_arm": 14.4,
			"p25": 102.272727272727,
			"p50": 106.260575296108,
			"p75": 106.583850931677,
			"armindex": 121.008403361345
		},
		{
			"": 7267,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 15676,
			"SteuerEinkommen_P25": 20.4,
			"SteuerEinkommen_Median": 42,
			"SteuerEinkommen_P75": 63.1,
			"eink_arm_Sum": 3591,
			"ant_eink_arm": 22.9,
			"p25": 102,
			"p50": 109.090909090909,
			"p75": 109.93031358885,
			"armindex": 106.511627906977
		},
		{
			"": 7268,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5558,
			"SteuerEinkommen_P25": 52.9,
			"SteuerEinkommen_Median": 75.6,
			"SteuerEinkommen_P75": 112.7,
			"eink_arm_Sum": 581,
			"ant_eink_arm": 10.5,
			"p25": 106.653225806452,
			"p50": 109.565217391304,
			"p75": 114.300202839757,
			"armindex": 94.5945945945946
		},
		{
			"": 7339,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 20557,
			"SteuerEinkommen_P25": 17.8,
			"SteuerEinkommen_Median": 35.9,
			"SteuerEinkommen_P75": 55,
			"eink_arm_Sum": 5453,
			"ant_eink_arm": 26.5,
			"p25": 96.7391304347826,
			"p50": 106.213017751479,
			"p75": 110,
			"armindex": 114.224137931034
		},
		{
			"": 7340,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 9575,
			"SteuerEinkommen_P25": 44.5,
			"SteuerEinkommen_Median": 64.6,
			"SteuerEinkommen_P75": 89,
			"eink_arm_Sum": 1396,
			"ant_eink_arm": 14.6,
			"p25": 105.200945626478,
			"p50": 107.666666666667,
			"p75": 108.669108669109,
			"armindex": 113.178294573643
		},
		{
			"": 7431,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8887,
			"SteuerEinkommen_P25": 15.1,
			"SteuerEinkommen_Median": 30,
			"SteuerEinkommen_P75": 45,
			"eink_arm_Sum": 2761,
			"ant_eink_arm": 31.1,
			"p25": 96.1783439490446,
			"p50": 105.633802816901,
			"p75": 104.408352668213,
			"armindex": 113.090909090909
		},
		{
			"": 7432,
			"SteuerJahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5082,
			"SteuerEinkommen_P25": 39.4,
			"SteuerEinkommen_Median": 56.7,
			"SteuerEinkommen_P75": 75,
			"eink_arm_Sum": 924,
			"ant_eink_arm": 18.2,
			"p25": 98.5,
			"p50": 102.99727520436,
			"p75": 104.022191400832,
			"armindex": 123.809523809524
		},
		{
			"": 7545,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3651,
			"SteuerEinkommen_P25": 7.9,
			"SteuerEinkommen_Median": 30.55,
			"SteuerEinkommen_P75": 65.8,
			"eink_arm_Sum": 1400,
			"ant_eink_arm": 38.3,
			"p25": 171.739130434783,
			"p50": 137.612612612613,
			"p75": 131.6,
			"armindex": 91.1904761904762
		},
		{
			"": 7546,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 614,
			"SteuerEinkommen_P25": 58.1,
			"SteuerEinkommen_Median": 100.7,
			"SteuerEinkommen_P75": 161.5,
			"eink_arm_Sum": 69,
			"ant_eink_arm": 11.2,
			"p25": 123.354564755839,
			"p50": 125.404732254047,
			"p75": 126.171875,
			"armindex": 73.6842105263158
		},
		{
			"": 7654,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11817,
			"SteuerEinkommen_P25": 20.4,
			"SteuerEinkommen_Median": 41.7,
			"SteuerEinkommen_P75": 65.7,
			"eink_arm_Sum": 2835,
			"ant_eink_arm": 24,
			"p25": 102,
			"p50": 109.736842105263,
			"p75": 112.5,
			"armindex": 111.627906976744
		},
		{
			"": 7655,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4592,
			"SteuerEinkommen_P25": 52.7,
			"SteuerEinkommen_Median": 76.7,
			"SteuerEinkommen_P75": 119.3,
			"eink_arm_Sum": 507,
			"ant_eink_arm": 11,
			"p25": 107.331975560081,
			"p50": 109.885386819484,
			"p75": 117.536945812808,
			"armindex": 101.851851851852
		},
		{
			"": 7747,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18937,
			"SteuerEinkommen_P25": 19.1,
			"SteuerEinkommen_Median": 38.1,
			"SteuerEinkommen_P75": 58.6,
			"eink_arm_Sum": 4853,
			"ant_eink_arm": 25.6,
			"p25": 107.909604519774,
			"p50": 115.80547112462,
			"p75": 117.2,
			"armindex": 104.489795918367
		},
		{
			"": 7748,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6276,
			"SteuerEinkommen_P25": 39,
			"SteuerEinkommen_Median": 59.9,
			"SteuerEinkommen_P75": 86.3,
			"eink_arm_Sum": 1200,
			"ant_eink_arm": 19.1,
			"p25": 96.5346534653465,
			"p50": 101.525423728814,
			"p75": 107.875,
			"armindex": 126.490066225166
		},
		{
			"": 7838,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12543,
			"SteuerEinkommen_P25": 15.8,
			"SteuerEinkommen_Median": 33.3,
			"SteuerEinkommen_P75": 53.3,
			"eink_arm_Sum": 3833,
			"ant_eink_arm": 30.6,
			"p25": 109.722222222222,
			"p50": 115.625,
			"p75": 115.869565217391,
			"armindex": 101.661129568106
		},
		{
			"": 7839,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3021,
			"SteuerEinkommen_P25": 31.7,
			"SteuerEinkommen_Median": 50.4,
			"SteuerEinkommen_P75": 71.35,
			"eink_arm_Sum": 822,
			"ant_eink_arm": 27.2,
			"p25": 91.0919540229885,
			"p50": 97.6744186046512,
			"p75": 100.776836158192,
			"armindex": 133.333333333333
		},
		{
			"": 7929,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6252,
			"SteuerEinkommen_P25": 18.05,
			"SteuerEinkommen_Median": 39.7,
			"SteuerEinkommen_P75": 62.7,
			"eink_arm_Sum": 1666,
			"ant_eink_arm": 26.6,
			"p25": 114.603174603175,
			"p50": 122.910216718266,
			"p75": 125.65130260521,
			"armindex": 98.8847583643123
		},
		{
			"": 7930,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1386,
			"SteuerEinkommen_P25": 39.1,
			"SteuerEinkommen_Median": 58.4,
			"SteuerEinkommen_P75": 82.9,
			"eink_arm_Sum": 265,
			"ant_eink_arm": 19.1,
			"p25": 105.390835579515,
			"p50": 108.148148148148,
			"p75": 112.027027027027,
			"armindex": 98.9637305699482
		},
		{
			"": 7995,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12381,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 43.5,
			"SteuerEinkommen_P75": 68.9,
			"eink_arm_Sum": 2763,
			"ant_eink_arm": 22.3,
			"p25": 114.814814814815,
			"p50": 115.384615384615,
			"p75": 116.188870151771,
			"armindex": 96.9565217391304
		},
		{
			"": 7996,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 3997,
			"SteuerEinkommen_P25": 54.2,
			"SteuerEinkommen_Median": 82.2,
			"SteuerEinkommen_P75": 128.4,
			"eink_arm_Sum": 412,
			"ant_eink_arm": 10.3,
			"p25": 111.752577319588,
			"p50": 117.428571428571,
			"p75": 123.342939481268,
			"armindex": 96.2616822429907
		},
		{
			"": 8063,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14396,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 46.4,
			"SteuerEinkommen_P75": 76.3,
			"eink_arm_Sum": 3523,
			"ant_eink_arm": 24.5,
			"p25": 108.695652173913,
			"p50": 111.004784688995,
			"p75": 115.082956259427,
			"armindex": 102.510460251046
		},
		{
			"": 8064,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5444,
			"SteuerEinkommen_P25": 65.5,
			"SteuerEinkommen_Median": 108.6,
			"SteuerEinkommen_P75": 184.2,
			"eink_arm_Sum": 444,
			"ant_eink_arm": 8.2,
			"p25": 112.157534246575,
			"p50": 119.340659340659,
			"p75": 123.210702341137,
			"armindex": 89.1304347826087
		},
		{
			"": 8178,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7195,
			"SteuerEinkommen_P25": 22.1,
			"SteuerEinkommen_Median": 48,
			"SteuerEinkommen_P75": 75.45,
			"eink_arm_Sum": 1626,
			"ant_eink_arm": 22.6,
			"p25": 109.950248756219,
			"p50": 117.359413202934,
			"p75": 119.572107765452,
			"armindex": 104.62962962963
		},
		{
			"": 8179,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1792,
			"SteuerEinkommen_P25": 59.6,
			"SteuerEinkommen_Median": 93.4,
			"SteuerEinkommen_P75": 152.8,
			"eink_arm_Sum": 167,
			"ant_eink_arm": 9.3,
			"p25": 116.40625,
			"p50": 119.74358974359,
			"p75": 125.864909390445,
			"armindex": 85.3211009174312
		},
		{
			"": 8268,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 17991,
			"SteuerEinkommen_P25": 19.2,
			"SteuerEinkommen_Median": 36.7,
			"SteuerEinkommen_P75": 55,
			"eink_arm_Sum": 4584,
			"ant_eink_arm": 25.5,
			"p25": 101.587301587302,
			"p50": 107.941176470588,
			"p75": 110,
			"armindex": 111.842105263158
		},
		{
			"": 8269,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8127,
			"SteuerEinkommen_P25": 43.1,
			"SteuerEinkommen_Median": 61.7,
			"SteuerEinkommen_P75": 85.5,
			"eink_arm_Sum": 1277,
			"ant_eink_arm": 15.7,
			"p25": 97.9545454545455,
			"p50": 104.399323181049,
			"p75": 106.211180124224,
			"armindex": 131.932773109244
		},
		{
			"": 8336,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 15776,
			"SteuerEinkommen_P25": 21.4,
			"SteuerEinkommen_Median": 43,
			"SteuerEinkommen_P75": 64.7,
			"eink_arm_Sum": 3593,
			"ant_eink_arm": 22.8,
			"p25": 107,
			"p50": 111.688311688312,
			"p75": 112.717770034843,
			"armindex": 106.046511627907
		},
		{
			"": 8337,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5520,
			"SteuerEinkommen_P25": 52,
			"SteuerEinkommen_Median": 75.9,
			"SteuerEinkommen_P75": 112.7,
			"eink_arm_Sum": 636,
			"ant_eink_arm": 11.5,
			"p25": 104.838709677419,
			"p50": 110,
			"p75": 114.300202839757,
			"armindex": 103.603603603604
		},
		{
			"": 8404,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 21202,
			"SteuerEinkommen_P25": 17.9,
			"SteuerEinkommen_Median": 36.6,
			"SteuerEinkommen_P75": 56.4,
			"eink_arm_Sum": 5748,
			"ant_eink_arm": 27.1,
			"p25": 97.2826086956522,
			"p50": 108.284023668639,
			"p75": 112.8,
			"armindex": 116.810344827586
		},
		{
			"": 8405,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 9708,
			"SteuerEinkommen_P25": 42.3,
			"SteuerEinkommen_Median": 63.1,
			"SteuerEinkommen_P75": 89.5,
			"eink_arm_Sum": 1600,
			"ant_eink_arm": 16.5,
			"p25": 100,
			"p50": 105.166666666667,
			"p75": 109.279609279609,
			"armindex": 127.906976744186
		},
		{
			"": 8495,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 8980,
			"SteuerEinkommen_P25": 15.3,
			"SteuerEinkommen_Median": 30.1,
			"SteuerEinkommen_P75": 45.5,
			"eink_arm_Sum": 2770,
			"ant_eink_arm": 30.8,
			"p25": 97.4522292993631,
			"p50": 105.985915492958,
			"p75": 105.568445475638,
			"armindex": 112
		},
		{
			"": 8496,
			"SteuerJahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5099,
			"SteuerEinkommen_P25": 37.05,
			"SteuerEinkommen_Median": 55.2,
			"SteuerEinkommen_P75": 74.8,
			"eink_arm_Sum": 1068,
			"ant_eink_arm": 20.9,
			"p25": 92.625,
			"p50": 100.272479564033,
			"p75": 103.74479889043,
			"armindex": 142.176870748299
		},
		{
			"": 8609,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3652,
			"SteuerEinkommen_P25": 9.2,
			"SteuerEinkommen_Median": 32.8,
			"SteuerEinkommen_P75": 69.9,
			"eink_arm_Sum": 1387,
			"ant_eink_arm": 38,
			"p25": 200,
			"p50": 147.747747747748,
			"p75": 139.8,
			"armindex": 90.4761904761905
		},
		{
			"": 8610,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 596,
			"SteuerEinkommen_P25": 59.5,
			"SteuerEinkommen_Median": 105.5,
			"SteuerEinkommen_P75": 175.8,
			"eink_arm_Sum": 75,
			"ant_eink_arm": 12.6,
			"p25": 126.326963906582,
			"p50": 131.382316313823,
			"p75": 137.34375,
			"armindex": 82.8947368421053
		},
		{
			"": 8715,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11995,
			"SteuerEinkommen_P25": 21.3,
			"SteuerEinkommen_Median": 43,
			"SteuerEinkommen_P75": 68.4,
			"eink_arm_Sum": 2863,
			"ant_eink_arm": 23.9,
			"p25": 106.5,
			"p50": 113.157894736842,
			"p75": 117.123287671233,
			"armindex": 111.162790697674
		},
		{
			"": 8716,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4618,
			"SteuerEinkommen_P25": 54.2,
			"SteuerEinkommen_Median": 81.2,
			"SteuerEinkommen_P75": 127.6,
			"eink_arm_Sum": 510,
			"ant_eink_arm": 11,
			"p25": 110.386965376782,
			"p50": 116.332378223496,
			"p75": 125.714285714286,
			"armindex": 101.851851851852
		},
		{
			"": 8805,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 19385,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 39.9,
			"SteuerEinkommen_P75": 60.5,
			"eink_arm_Sum": 4957,
			"ant_eink_arm": 25.6,
			"p25": 112.994350282486,
			"p50": 121.276595744681,
			"p75": 121,
			"armindex": 104.489795918367
		},
		{
			"": 8806,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6188,
			"SteuerEinkommen_P25": 40.3,
			"SteuerEinkommen_Median": 62,
			"SteuerEinkommen_P75": 89.7,
			"eink_arm_Sum": 1217,
			"ant_eink_arm": 19.7,
			"p25": 99.7524752475248,
			"p50": 105.084745762712,
			"p75": 112.125,
			"armindex": 130.46357615894
		},
		{
			"": 8896,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12837,
			"SteuerEinkommen_P25": 16.9,
			"SteuerEinkommen_Median": 34.6,
			"SteuerEinkommen_P75": 55.1,
			"eink_arm_Sum": 3994,
			"ant_eink_arm": 31.1,
			"p25": 117.361111111111,
			"p50": 120.138888888889,
			"p75": 119.782608695652,
			"armindex": 103.322259136213
		},
		{
			"": 8897,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2925,
			"SteuerEinkommen_P25": 33.3,
			"SteuerEinkommen_Median": 52.2,
			"SteuerEinkommen_P75": 74.8,
			"eink_arm_Sum": 802,
			"ant_eink_arm": 27.4,
			"p25": 95.6896551724138,
			"p50": 101.162790697674,
			"p75": 105.649717514124,
			"armindex": 134.313725490196
		},
		{
			"": 8984,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6387,
			"SteuerEinkommen_P25": 18.9,
			"SteuerEinkommen_Median": 41.7,
			"SteuerEinkommen_P75": 65,
			"eink_arm_Sum": 1712,
			"ant_eink_arm": 26.8,
			"p25": 120,
			"p50": 129.102167182663,
			"p75": 130.260521042084,
			"armindex": 99.6282527881041
		},
		{
			"": 8985,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1359,
			"SteuerEinkommen_P25": 39.3,
			"SteuerEinkommen_Median": 60,
			"SteuerEinkommen_P75": 86.4,
			"eink_arm_Sum": 276,
			"ant_eink_arm": 20.3,
			"p25": 105.929919137466,
			"p50": 111.111111111111,
			"p75": 116.756756756757,
			"armindex": 105.181347150259
		},
		{
			"": 9052,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12479,
			"SteuerEinkommen_P25": 22.6,
			"SteuerEinkommen_Median": 45.6,
			"SteuerEinkommen_P75": 71.9,
			"eink_arm_Sum": 2794,
			"ant_eink_arm": 22.4,
			"p25": 119.57671957672,
			"p50": 120.954907161804,
			"p75": 121.247892074199,
			"armindex": 97.3913043478261
		},
		{
			"": 9053,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4040,
			"SteuerEinkommen_P25": 55.2,
			"SteuerEinkommen_Median": 84.1,
			"SteuerEinkommen_P75": 135.2,
			"eink_arm_Sum": 430,
			"ant_eink_arm": 10.6,
			"p25": 113.814432989691,
			"p50": 120.142857142857,
			"p75": 129.875120076849,
			"armindex": 99.0654205607477
		},
		{
			"": 9120,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14378,
			"SteuerEinkommen_P25": 21.1,
			"SteuerEinkommen_Median": 48.85,
			"SteuerEinkommen_P75": 80.9,
			"eink_arm_Sum": 3519,
			"ant_eink_arm": 24.5,
			"p25": 114.673913043478,
			"p50": 116.866028708134,
			"p75": 122.021116138763,
			"armindex": 102.510460251046
		},
		{
			"": 9121,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5488,
			"SteuerEinkommen_P25": 69,
			"SteuerEinkommen_Median": 112.2,
			"SteuerEinkommen_P75": 190.7,
			"eink_arm_Sum": 427,
			"ant_eink_arm": 7.8,
			"p25": 118.150684931507,
			"p50": 123.296703296703,
			"p75": 127.558528428094,
			"armindex": 84.7826086956522
		},
		{
			"": 9233,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7347,
			"SteuerEinkommen_P25": 23.1,
			"SteuerEinkommen_Median": 50.6,
			"SteuerEinkommen_P75": 81.6,
			"eink_arm_Sum": 1650,
			"ant_eink_arm": 22.5,
			"p25": 114.925373134328,
			"p50": 123.716381418093,
			"p75": 129.31854199683,
			"armindex": 104.166666666667
		},
		{
			"": 9234,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1776,
			"SteuerEinkommen_P25": 62.4,
			"SteuerEinkommen_Median": 97,
			"SteuerEinkommen_P75": 161.3,
			"eink_arm_Sum": 160,
			"ant_eink_arm": 9,
			"p25": 121.875,
			"p50": 124.358974358974,
			"p75": 132.866556836903,
			"armindex": 82.5688073394495
		},
		{
			"": 9324,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18513,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 38.2,
			"SteuerEinkommen_P75": 57.1,
			"eink_arm_Sum": 4730,
			"ant_eink_arm": 25.5,
			"p25": 105.820105820106,
			"p50": 112.352941176471,
			"p75": 114.2,
			"armindex": 111.842105263158
		},
		{
			"": 9325,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8017,
			"SteuerEinkommen_P25": 44.7,
			"SteuerEinkommen_Median": 64.3,
			"SteuerEinkommen_P75": 89.3,
			"eink_arm_Sum": 1260,
			"ant_eink_arm": 15.7,
			"p25": 101.590909090909,
			"p50": 108.798646362098,
			"p75": 110.931677018634,
			"armindex": 131.932773109244
		},
		{
			"": 9395,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16114,
			"SteuerEinkommen_P25": 22.3,
			"SteuerEinkommen_Median": 44.4,
			"SteuerEinkommen_P75": 66.9,
			"eink_arm_Sum": 3670,
			"ant_eink_arm": 22.8,
			"p25": 111.5,
			"p50": 115.324675324675,
			"p75": 116.550522648084,
			"armindex": 106.046511627907
		},
		{
			"": 9396,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5398,
			"SteuerEinkommen_P25": 54.8,
			"SteuerEinkommen_Median": 79.5,
			"SteuerEinkommen_P75": 119,
			"eink_arm_Sum": 615,
			"ant_eink_arm": 11.4,
			"p25": 110.483870967742,
			"p50": 115.217391304348,
			"p75": 120.689655172414,
			"armindex": 102.702702702703
		},
		{
			"": 9463,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 22156,
			"SteuerEinkommen_P25": 19.1,
			"SteuerEinkommen_Median": 38.2,
			"SteuerEinkommen_P75": 58.7,
			"eink_arm_Sum": 6027,
			"ant_eink_arm": 27.2,
			"p25": 103.804347826087,
			"p50": 113.01775147929,
			"p75": 117.4,
			"armindex": 117.241379310345
		},
		{
			"": 9464,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 9863,
			"SteuerEinkommen_P25": 44.2,
			"SteuerEinkommen_Median": 65.6,
			"SteuerEinkommen_P75": 92.8,
			"eink_arm_Sum": 1632,
			"ant_eink_arm": 16.5,
			"p25": 104.491725768322,
			"p50": 109.333333333333,
			"p75": 113.308913308913,
			"armindex": 127.906976744186
		},
		{
			"": 9551,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9187,
			"SteuerEinkommen_P25": 16,
			"SteuerEinkommen_Median": 31.1,
			"SteuerEinkommen_P75": 46.6,
			"eink_arm_Sum": 2934,
			"ant_eink_arm": 31.9,
			"p25": 101.910828025478,
			"p50": 109.507042253521,
			"p75": 108.120649651972,
			"armindex": 116
		},
		{
			"": 9552,
			"SteuerJahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5006,
			"SteuerEinkommen_P25": 38.2,
			"SteuerEinkommen_Median": 56.8,
			"SteuerEinkommen_P75": 76.3,
			"eink_arm_Sum": 1074,
			"ant_eink_arm": 21.5,
			"p25": 95.5,
			"p50": 103.178928247048,
			"p75": 105.825242718447,
			"armindex": 146.258503401361
		},
		{
			"": 9666,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3639,
			"SteuerEinkommen_P25": 9.85,
			"SteuerEinkommen_Median": 33.45,
			"SteuerEinkommen_P75": 73.8,
			"eink_arm_Sum": 1409,
			"ant_eink_arm": 38.7,
			"p25": 214.130434782609,
			"p50": 150.675675675676,
			"p75": 147.6,
			"armindex": 92.1428571428572
		},
		{
			"": 9667,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 598,
			"SteuerEinkommen_P25": 62.7,
			"SteuerEinkommen_Median": 112.7,
			"SteuerEinkommen_P75": 183.8,
			"eink_arm_Sum": 67,
			"ant_eink_arm": 11.2,
			"p25": 133.12101910828,
			"p50": 140.348692403487,
			"p75": 143.59375,
			"armindex": 73.6842105263158
		},
		{
			"": 9771,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12077,
			"SteuerEinkommen_P25": 22.2,
			"SteuerEinkommen_Median": 44.8,
			"SteuerEinkommen_P75": 70.7,
			"eink_arm_Sum": 2869,
			"ant_eink_arm": 23.8,
			"p25": 111,
			"p50": 117.894736842105,
			"p75": 121.061643835616,
			"armindex": 110.697674418605
		},
		{
			"": 9772,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4652,
			"SteuerEinkommen_P25": 56.1,
			"SteuerEinkommen_Median": 85.5,
			"SteuerEinkommen_P75": 134.6,
			"eink_arm_Sum": 528,
			"ant_eink_arm": 11.3,
			"p25": 114.256619144603,
			"p50": 122.492836676218,
			"p75": 132.610837438424,
			"armindex": 104.62962962963
		},
		{
			"": 9861,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 19672,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 40.8,
			"SteuerEinkommen_P75": 62.9,
			"eink_arm_Sum": 5119,
			"ant_eink_arm": 26,
			"p25": 112.994350282486,
			"p50": 124.012158054711,
			"p75": 125.8,
			"armindex": 106.122448979592
		},
		{
			"": 9862,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6206,
			"SteuerEinkommen_P25": 42,
			"SteuerEinkommen_Median": 64.4,
			"SteuerEinkommen_P75": 93.6,
			"eink_arm_Sum": 1175,
			"ant_eink_arm": 18.9,
			"p25": 103.960396039604,
			"p50": 109.152542372881,
			"p75": 117,
			"armindex": 125.165562913907
		},
		{
			"": 9952,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13092,
			"SteuerEinkommen_P25": 17.8,
			"SteuerEinkommen_Median": 36.4,
			"SteuerEinkommen_P75": 58.3,
			"eink_arm_Sum": 3934,
			"ant_eink_arm": 30,
			"p25": 123.611111111111,
			"p50": 126.388888888889,
			"p75": 126.739130434783,
			"armindex": 99.6677740863787
		},
		{
			"": 9953,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2956,
			"SteuerEinkommen_P25": 34.7,
			"SteuerEinkommen_Median": 53.9,
			"SteuerEinkommen_P75": 77,
			"eink_arm_Sum": 807,
			"ant_eink_arm": 27.3,
			"p25": 99.7126436781609,
			"p50": 104.457364341085,
			"p75": 108.757062146893,
			"armindex": 133.823529411765
		},
		{
			"": 10039,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6432,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 43.6,
			"SteuerEinkommen_P75": 67.8,
			"eink_arm_Sum": 1674,
			"ant_eink_arm": 26,
			"p25": 126.984126984127,
			"p50": 134.984520123839,
			"p75": 135.871743486974,
			"armindex": 96.6542750929368
		},
		{
			"": 10040,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1373,
			"SteuerEinkommen_P25": 40.6,
			"SteuerEinkommen_Median": 62.05,
			"SteuerEinkommen_P75": 91.3,
			"eink_arm_Sum": 273,
			"ant_eink_arm": 19.9,
			"p25": 109.433962264151,
			"p50": 114.907407407407,
			"p75": 123.378378378378,
			"armindex": 103.108808290155
		},
		{
			"": 10104,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12642,
			"SteuerEinkommen_P25": 22.9,
			"SteuerEinkommen_Median": 47.5,
			"SteuerEinkommen_P75": 74.4,
			"eink_arm_Sum": 2887,
			"ant_eink_arm": 22.8,
			"p25": 121.164021164021,
			"p50": 125.994694960212,
			"p75": 125.463743676223,
			"armindex": 99.1304347826087
		},
		{
			"": 10105,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4142,
			"SteuerEinkommen_P25": 57.6,
			"SteuerEinkommen_Median": 88.1,
			"SteuerEinkommen_P75": 142.8,
			"eink_arm_Sum": 445,
			"ant_eink_arm": 10.7,
			"p25": 118.762886597938,
			"p50": 125.857142857143,
			"p75": 137.175792507205,
			"armindex": 100
		},
		{
			"": 10173,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14426,
			"SteuerEinkommen_P25": 21.7,
			"SteuerEinkommen_Median": 50,
			"SteuerEinkommen_P75": 83.9,
			"eink_arm_Sum": 3518,
			"ant_eink_arm": 24.4,
			"p25": 117.934782608696,
			"p50": 119.617224880383,
			"p75": 126.546003016591,
			"armindex": 102.092050209205
		},
		{
			"": 10174,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5560,
			"SteuerEinkommen_P25": 71.5,
			"SteuerEinkommen_Median": 118.85,
			"SteuerEinkommen_P75": 203.3,
			"eink_arm_Sum": 422,
			"ant_eink_arm": 7.6,
			"p25": 122.431506849315,
			"p50": 130.604395604396,
			"p75": 135.986622073579,
			"armindex": 82.6086956521739
		},
		{
			"": 10286,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7295,
			"SteuerEinkommen_P25": 24.9,
			"SteuerEinkommen_Median": 52.6,
			"SteuerEinkommen_P75": 85.25,
			"eink_arm_Sum": 1613,
			"ant_eink_arm": 22.1,
			"p25": 123.880597014925,
			"p50": 128.606356968215,
			"p75": 135.103011093502,
			"armindex": 102.314814814815
		},
		{
			"": 10287,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1806,
			"SteuerEinkommen_P25": 65.8,
			"SteuerEinkommen_Median": 103.6,
			"SteuerEinkommen_P75": 172.4,
			"eink_arm_Sum": 141,
			"ant_eink_arm": 7.8,
			"p25": 128.515625,
			"p50": 132.820512820513,
			"p75": 142.009884678748,
			"armindex": 71.5596330275229
		},
		{
			"": 10375,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 18888,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 39.9,
			"SteuerEinkommen_P75": 59.7,
			"eink_arm_Sum": 4796,
			"ant_eink_arm": 25.4,
			"p25": 108.465608465608,
			"p50": 117.352941176471,
			"p75": 119.4,
			"armindex": 111.40350877193
		},
		{
			"": 10376,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8011,
			"SteuerEinkommen_P25": 45.9,
			"SteuerEinkommen_Median": 66.4,
			"SteuerEinkommen_P75": 92.4,
			"eink_arm_Sum": 1252,
			"ant_eink_arm": 15.6,
			"p25": 104.318181818182,
			"p50": 112.351945854484,
			"p75": 114.782608695652,
			"armindex": 131.09243697479
		},
		{
			"": 10443,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16082,
			"SteuerEinkommen_P25": 23,
			"SteuerEinkommen_Median": 45.8,
			"SteuerEinkommen_P75": 69.3,
			"eink_arm_Sum": 3671,
			"ant_eink_arm": 22.8,
			"p25": 115,
			"p50": 118.961038961039,
			"p75": 120.731707317073,
			"armindex": 106.046511627907
		},
		{
			"": 10444,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5458,
			"SteuerEinkommen_P25": 55.7,
			"SteuerEinkommen_Median": 80.7,
			"SteuerEinkommen_P75": 122.95,
			"eink_arm_Sum": 609,
			"ant_eink_arm": 11.2,
			"p25": 112.298387096774,
			"p50": 116.95652173913,
			"p75": 124.695740365112,
			"armindex": 100.900900900901
		},
		{
			"": 10509,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 22726,
			"SteuerEinkommen_P25": 19.7,
			"SteuerEinkommen_Median": 39.8,
			"SteuerEinkommen_P75": 60.8,
			"eink_arm_Sum": 6166,
			"ant_eink_arm": 27.1,
			"p25": 107.065217391304,
			"p50": 117.751479289941,
			"p75": 121.6,
			"armindex": 116.810344827586
		},
		{
			"": 10510,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 10050,
			"SteuerEinkommen_P25": 45.3,
			"SteuerEinkommen_Median": 67.8,
			"SteuerEinkommen_P75": 95.9,
			"eink_arm_Sum": 1648,
			"ant_eink_arm": 16.4,
			"p25": 107.09219858156,
			"p50": 113,
			"p75": 117.094017094017,
			"armindex": 127.131782945736
		},
		{
			"": 10599,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9289,
			"SteuerEinkommen_P25": 16,
			"SteuerEinkommen_Median": 31.7,
			"SteuerEinkommen_P75": 48,
			"eink_arm_Sum": 3039,
			"ant_eink_arm": 32.7,
			"p25": 101.910828025478,
			"p50": 111.619718309859,
			"p75": 111.368909512761,
			"armindex": 118.909090909091
		},
		{
			"": 10600,
			"SteuerJahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5034,
			"SteuerEinkommen_P25": 39.4,
			"SteuerEinkommen_Median": 57.9,
			"SteuerEinkommen_P75": 78.9,
			"eink_arm_Sum": 1061,
			"ant_eink_arm": 21.1,
			"p25": 98.5,
			"p50": 105.177111716621,
			"p75": 109.431345353675,
			"armindex": 143.537414965986
		},
		{
			"": 10714,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3543,
			"SteuerEinkommen_P25": 9.2,
			"SteuerEinkommen_Median": 33.9,
			"SteuerEinkommen_P75": 73.7,
			"eink_arm_Sum": 1337,
			"ant_eink_arm": 37.7,
			"p25": 200,
			"p50": 152.702702702703,
			"p75": 147.4,
			"armindex": 89.7619047619048
		},
		{
			"": 10715,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 615,
			"SteuerEinkommen_P25": 65.2,
			"SteuerEinkommen_Median": 117,
			"SteuerEinkommen_P75": 183.4,
			"eink_arm_Sum": 75,
			"ant_eink_arm": 12.2,
			"p25": 138.428874734607,
			"p50": 145.703611457036,
			"p75": 143.28125,
			"armindex": 80.2631578947368
		},
		{
			"": 10819,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12107,
			"SteuerEinkommen_P25": 21.5,
			"SteuerEinkommen_Median": 44.7,
			"SteuerEinkommen_P75": 71.4,
			"eink_arm_Sum": 2978,
			"ant_eink_arm": 24.6,
			"p25": 107.5,
			"p50": 117.631578947368,
			"p75": 122.260273972603,
			"armindex": 114.418604651163
		},
		{
			"": 10820,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4706,
			"SteuerEinkommen_P25": 57.5,
			"SteuerEinkommen_Median": 87.35,
			"SteuerEinkommen_P75": 136.85,
			"eink_arm_Sum": 549,
			"ant_eink_arm": 11.7,
			"p25": 117.107942973523,
			"p50": 125.143266475645,
			"p75": 134.827586206897,
			"armindex": 108.333333333333
		},
		{
			"": 10907,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 20069,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 41.4,
			"SteuerEinkommen_P75": 64.2,
			"eink_arm_Sum": 5153,
			"ant_eink_arm": 25.7,
			"p25": 116.38418079096,
			"p50": 125.835866261398,
			"p75": 128.4,
			"armindex": 104.897959183673
		},
		{
			"": 10908,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6173,
			"SteuerEinkommen_P25": 43.5,
			"SteuerEinkommen_Median": 66.5,
			"SteuerEinkommen_P75": 96.8,
			"eink_arm_Sum": 1190,
			"ant_eink_arm": 19.3,
			"p25": 107.673267326733,
			"p50": 112.71186440678,
			"p75": 121,
			"armindex": 127.814569536424
		},
		{
			"": 10997,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13154,
			"SteuerEinkommen_P25": 17.6,
			"SteuerEinkommen_Median": 36.6,
			"SteuerEinkommen_P75": 59.1,
			"eink_arm_Sum": 3992,
			"ant_eink_arm": 30.3,
			"p25": 122.222222222222,
			"p50": 127.083333333333,
			"p75": 128.478260869565,
			"armindex": 100.664451827243
		},
		{
			"": 10998,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2956,
			"SteuerEinkommen_P25": 35.7,
			"SteuerEinkommen_Median": 55,
			"SteuerEinkommen_P75": 79.6,
			"eink_arm_Sum": 794,
			"ant_eink_arm": 26.9,
			"p25": 102.586206896552,
			"p50": 106.589147286822,
			"p75": 112.429378531073,
			"armindex": 131.862745098039
		},
		{
			"": 11084,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6466,
			"SteuerEinkommen_P25": 19.2,
			"SteuerEinkommen_Median": 42.9,
			"SteuerEinkommen_P75": 68.2,
			"eink_arm_Sum": 1766,
			"ant_eink_arm": 27.3,
			"p25": 121.904761904762,
			"p50": 132.8173374613,
			"p75": 136.673346693387,
			"armindex": 101.486988847584
		},
		{
			"": 11085,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1371,
			"SteuerEinkommen_P25": 43.1,
			"SteuerEinkommen_Median": 64.4,
			"SteuerEinkommen_P75": 97.5,
			"eink_arm_Sum": 280,
			"ant_eink_arm": 20.4,
			"p25": 116.172506738544,
			"p50": 119.259259259259,
			"p75": 131.756756756757,
			"armindex": 105.699481865285
		},
		{
			"": 11152,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12797,
			"SteuerEinkommen_P25": 23.2,
			"SteuerEinkommen_Median": 47.9,
			"SteuerEinkommen_P75": 75,
			"eink_arm_Sum": 2966,
			"ant_eink_arm": 23.2,
			"p25": 122.751322751323,
			"p50": 127.055702917772,
			"p75": 126.475548060708,
			"armindex": 100.869565217391
		},
		{
			"": 11153,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4180,
			"SteuerEinkommen_P25": 58.9,
			"SteuerEinkommen_Median": 91.1,
			"SteuerEinkommen_P75": 149,
			"eink_arm_Sum": 441,
			"ant_eink_arm": 10.6,
			"p25": 121.443298969072,
			"p50": 130.142857142857,
			"p75": 143.131604226705,
			"armindex": 99.0654205607477
		},
		{
			"": 11218,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14385,
			"SteuerEinkommen_P25": 21,
			"SteuerEinkommen_Median": 49.9,
			"SteuerEinkommen_P75": 83.6,
			"eink_arm_Sum": 3618,
			"ant_eink_arm": 25.2,
			"p25": 114.130434782609,
			"p50": 119.377990430622,
			"p75": 126.093514328808,
			"armindex": 105.439330543933
		},
		{
			"": 11219,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5584,
			"SteuerEinkommen_P25": 75.1,
			"SteuerEinkommen_Median": 120,
			"SteuerEinkommen_P75": 203.6,
			"eink_arm_Sum": 450,
			"ant_eink_arm": 8.1,
			"p25": 128.595890410959,
			"p50": 131.868131868132,
			"p75": 136.1872909699,
			"armindex": 88.0434782608696
		},
		{
			"": 11330,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7233,
			"SteuerEinkommen_P25": 24.2,
			"SteuerEinkommen_Median": 53.6,
			"SteuerEinkommen_P75": 85.9,
			"eink_arm_Sum": 1603,
			"ant_eink_arm": 22.2,
			"p25": 120.398009950249,
			"p50": 131.051344743276,
			"p75": 136.133122028526,
			"armindex": 102.777777777778
		},
		{
			"": 11331,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1806,
			"SteuerEinkommen_P25": 67.1,
			"SteuerEinkommen_Median": 108.2,
			"SteuerEinkommen_P75": 172.1,
			"eink_arm_Sum": 137,
			"ant_eink_arm": 7.6,
			"p25": 131.0546875,
			"p50": 138.717948717949,
			"p75": 141.762767710049,
			"armindex": 69.7247706422018
		},
		{
			"": 11418,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 19132,
			"SteuerEinkommen_P25": 20.8,
			"SteuerEinkommen_Median": 40.3,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 4859,
			"ant_eink_arm": 25.4,
			"p25": 110.05291005291,
			"p50": 118.529411764706,
			"p75": 120,
			"armindex": 111.40350877193
		},
		{
			"": 11419,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 7925,
			"SteuerEinkommen_P25": 46.6,
			"SteuerEinkommen_Median": 67.6,
			"SteuerEinkommen_P75": 94.2,
			"eink_arm_Sum": 1236,
			"ant_eink_arm": 15.6,
			"p25": 105.909090909091,
			"p50": 114.382402707276,
			"p75": 117.018633540373,
			"armindex": 131.09243697479
		},
		{
			"": 11486,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16233,
			"SteuerEinkommen_P25": 23.3,
			"SteuerEinkommen_Median": 46,
			"SteuerEinkommen_P75": 69.6,
			"eink_arm_Sum": 3720,
			"ant_eink_arm": 22.9,
			"p25": 116.5,
			"p50": 119.480519480519,
			"p75": 121.254355400697,
			"armindex": 106.511627906977
		},
		{
			"": 11487,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5388,
			"SteuerEinkommen_P25": 57.6,
			"SteuerEinkommen_Median": 84.2,
			"SteuerEinkommen_P75": 126.3,
			"eink_arm_Sum": 595,
			"ant_eink_arm": 11,
			"p25": 116.129032258065,
			"p50": 122.028985507246,
			"p75": 128.093306288032,
			"armindex": 99.0990990990991
		},
		{
			"": 11554,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 22905,
			"SteuerEinkommen_P25": 19.2,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 61.5,
			"eink_arm_Sum": 6354,
			"ant_eink_arm": 27.7,
			"p25": 104.347826086957,
			"p50": 118.343195266272,
			"p75": 123,
			"armindex": 119.396551724138
		},
		{
			"": 11555,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 10048,
			"SteuerEinkommen_P25": 46.6,
			"SteuerEinkommen_Median": 69.5,
			"SteuerEinkommen_P75": 98.6,
			"eink_arm_Sum": 1642,
			"ant_eink_arm": 16.3,
			"p25": 110.16548463357,
			"p50": 115.833333333333,
			"p75": 120.39072039072,
			"armindex": 126.356589147287
		},
		{
			"": 11644,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9448,
			"SteuerEinkommen_P25": 16,
			"SteuerEinkommen_Median": 32.1,
			"SteuerEinkommen_P75": 48.7,
			"eink_arm_Sum": 3126,
			"ant_eink_arm": 33.1,
			"p25": 101.910828025478,
			"p50": 113.028169014085,
			"p75": 112.993039443155,
			"armindex": 120.363636363636
		},
		{
			"": 11645,
			"SteuerJahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5004,
			"SteuerEinkommen_P25": 39.6,
			"SteuerEinkommen_Median": 59,
			"SteuerEinkommen_P75": 79.8,
			"eink_arm_Sum": 1103,
			"ant_eink_arm": 22,
			"p25": 99,
			"p50": 107.175295186194,
			"p75": 110.679611650485,
			"armindex": 149.659863945578
		},
		{
			"": 11756,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3517,
			"SteuerEinkommen_P25": 7.5,
			"SteuerEinkommen_Median": 33.75,
			"SteuerEinkommen_P75": 73.3,
			"eink_arm_Sum": 1359,
			"ant_eink_arm": 38.6,
			"p25": 163.04347826087,
			"p50": 152.027027027027,
			"p75": 146.6,
			"armindex": 91.9047619047619
		},
		{
			"": 11757,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 611,
			"SteuerEinkommen_P25": 68.8,
			"SteuerEinkommen_Median": 117.1,
			"SteuerEinkommen_P75": 186.4,
			"eink_arm_Sum": 73,
			"ant_eink_arm": 11.9,
			"p25": 146.072186836518,
			"p50": 145.828144458281,
			"p75": 145.625,
			"armindex": 78.2894736842105
		},
		{
			"": 11861,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12212,
			"SteuerEinkommen_P25": 21.5,
			"SteuerEinkommen_Median": 44.9,
			"SteuerEinkommen_P75": 72.3,
			"eink_arm_Sum": 3026,
			"ant_eink_arm": 24.8,
			"p25": 107.5,
			"p50": 118.157894736842,
			"p75": 123.801369863014,
			"armindex": 115.348837209302
		},
		{
			"": 11862,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4635,
			"SteuerEinkommen_P25": 58.4,
			"SteuerEinkommen_Median": 89.35,
			"SteuerEinkommen_P75": 138.9,
			"eink_arm_Sum": 514,
			"ant_eink_arm": 11.1,
			"p25": 118.940936863544,
			"p50": 128.008595988539,
			"p75": 136.847290640394,
			"armindex": 102.777777777778
		},
		{
			"": 11951,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 20233,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 41.4,
			"SteuerEinkommen_P75": 64.8,
			"eink_arm_Sum": 5244,
			"ant_eink_arm": 25.9,
			"p25": 115.819209039548,
			"p50": 125.835866261398,
			"p75": 129.6,
			"armindex": 105.714285714286
		},
		{
			"": 11952,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6129,
			"SteuerEinkommen_P25": 43.5,
			"SteuerEinkommen_Median": 67.3,
			"SteuerEinkommen_P75": 100.1,
			"eink_arm_Sum": 1194,
			"ant_eink_arm": 19.5,
			"p25": 107.673267326733,
			"p50": 114.067796610169,
			"p75": 125.125,
			"armindex": 129.139072847682
		},
		{
			"": 12041,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13375,
			"SteuerEinkommen_P25": 17.7,
			"SteuerEinkommen_Median": 37,
			"SteuerEinkommen_P75": 59.7,
			"eink_arm_Sum": 4060,
			"ant_eink_arm": 30.4,
			"p25": 122.916666666667,
			"p50": 128.472222222222,
			"p75": 129.782608695652,
			"armindex": 100.996677740864
		},
		{
			"": 12042,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2891,
			"SteuerEinkommen_P25": 35.5,
			"SteuerEinkommen_Median": 55.9,
			"SteuerEinkommen_P75": 80.5,
			"eink_arm_Sum": 804,
			"ant_eink_arm": 27.8,
			"p25": 102.011494252874,
			"p50": 108.333333333333,
			"p75": 113.700564971751,
			"armindex": 136.274509803922
		},
		{
			"": 12128,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6455,
			"SteuerEinkommen_P25": 18.8,
			"SteuerEinkommen_Median": 43.6,
			"SteuerEinkommen_P75": 69.2,
			"eink_arm_Sum": 1780,
			"ant_eink_arm": 27.6,
			"p25": 119.365079365079,
			"p50": 134.984520123839,
			"p75": 138.677354709419,
			"armindex": 102.602230483271
		},
		{
			"": 12129,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1380,
			"SteuerEinkommen_P25": 43.6,
			"SteuerEinkommen_Median": 65.4,
			"SteuerEinkommen_P75": 98.8,
			"eink_arm_Sum": 276,
			"ant_eink_arm": 20,
			"p25": 117.520215633423,
			"p50": 121.111111111111,
			"p75": 133.513513513514,
			"armindex": 103.626943005181
		},
		{
			"": 12194,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12894,
			"SteuerEinkommen_P25": 23.6,
			"SteuerEinkommen_Median": 47.7,
			"SteuerEinkommen_P75": 76.4,
			"eink_arm_Sum": 2913,
			"ant_eink_arm": 22.6,
			"p25": 124.867724867725,
			"p50": 126.525198938992,
			"p75": 128.836424957842,
			"armindex": 98.2608695652174
		},
		{
			"": 12195,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4187,
			"SteuerEinkommen_P25": 60,
			"SteuerEinkommen_Median": 93.65,
			"SteuerEinkommen_P75": 150,
			"eink_arm_Sum": 445,
			"ant_eink_arm": 10.6,
			"p25": 123.711340206186,
			"p50": 133.785714285714,
			"p75": 144.092219020173,
			"armindex": 99.0654205607477
		},
		{
			"": 12260,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14276,
			"SteuerEinkommen_P25": 21.1,
			"SteuerEinkommen_Median": 49.6,
			"SteuerEinkommen_P75": 83.8,
			"eink_arm_Sum": 3596,
			"ant_eink_arm": 25.2,
			"p25": 114.673913043478,
			"p50": 118.66028708134,
			"p75": 126.395173453997,
			"armindex": 105.439330543933
		},
		{
			"": 12261,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5571,
			"SteuerEinkommen_P25": 75.8,
			"SteuerEinkommen_Median": 123,
			"SteuerEinkommen_P75": 209.5,
			"eink_arm_Sum": 424,
			"ant_eink_arm": 7.6,
			"p25": 129.794520547945,
			"p50": 135.164835164835,
			"p75": 140.133779264214,
			"armindex": 82.6086956521739
		},
		{
			"": 12372,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7242,
			"SteuerEinkommen_P25": 24.9,
			"SteuerEinkommen_Median": 54,
			"SteuerEinkommen_P75": 88.7,
			"eink_arm_Sum": 1585,
			"ant_eink_arm": 21.9,
			"p25": 123.880597014925,
			"p50": 132.029339853301,
			"p75": 140.570522979398,
			"armindex": 101.388888888889
		},
		{
			"": 12373,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1843,
			"SteuerEinkommen_P25": 68.5,
			"SteuerEinkommen_Median": 108.6,
			"SteuerEinkommen_P75": 182.2,
			"eink_arm_Sum": 158,
			"ant_eink_arm": 8.6,
			"p25": 133.7890625,
			"p50": 139.230769230769,
			"p75": 150.082372322899,
			"armindex": 78.8990825688073
		},
		{
			"": 12459,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 19462,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 40.6,
			"SteuerEinkommen_P75": 60.3,
			"eink_arm_Sum": 5031,
			"ant_eink_arm": 25.9,
			"p25": 108.465608465608,
			"p50": 119.411764705882,
			"p75": 120.6,
			"armindex": 113.59649122807
		},
		{
			"": 12460,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 7939,
			"SteuerEinkommen_P25": 46.8,
			"SteuerEinkommen_Median": 67.9,
			"SteuerEinkommen_P75": 95.2,
			"eink_arm_Sum": 1295,
			"ant_eink_arm": 16.3,
			"p25": 106.363636363636,
			"p50": 114.890016920474,
			"p75": 118.260869565217,
			"armindex": 136.974789915966
		},
		{
			"": 12525,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16131,
			"SteuerEinkommen_P25": 23.4,
			"SteuerEinkommen_Median": 46.2,
			"SteuerEinkommen_P75": 70,
			"eink_arm_Sum": 3693,
			"ant_eink_arm": 22.9,
			"p25": 117,
			"p50": 120,
			"p75": 121.951219512195,
			"armindex": 106.511627906977
		},
		{
			"": 12526,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5383,
			"SteuerEinkommen_P25": 58.3,
			"SteuerEinkommen_Median": 85.1,
			"SteuerEinkommen_P75": 128.7,
			"eink_arm_Sum": 609,
			"ant_eink_arm": 11.3,
			"p25": 117.540322580645,
			"p50": 123.333333333333,
			"p75": 130.52738336714,
			"armindex": 101.801801801802
		},
		{
			"": 12591,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 23274,
			"SteuerEinkommen_P25": 19.1,
			"SteuerEinkommen_Median": 40.1,
			"SteuerEinkommen_P75": 62.1,
			"eink_arm_Sum": 6490,
			"ant_eink_arm": 27.9,
			"p25": 103.804347826087,
			"p50": 118.639053254438,
			"p75": 124.2,
			"armindex": 120.258620689655
		},
		{
			"": 12592,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 10129,
			"SteuerEinkommen_P25": 47.2,
			"SteuerEinkommen_Median": 70.8,
			"SteuerEinkommen_P75": 100.6,
			"eink_arm_Sum": 1691,
			"ant_eink_arm": 16.7,
			"p25": 111.583924349882,
			"p50": 118,
			"p75": 122.832722832723,
			"armindex": 129.457364341085
		},
		{
			"": 12682,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9535,
			"SteuerEinkommen_P25": 15.5,
			"SteuerEinkommen_Median": 31.7,
			"SteuerEinkommen_P75": 49.1,
			"eink_arm_Sum": 3186,
			"ant_eink_arm": 33.4,
			"p25": 98.7261146496815,
			"p50": 111.619718309859,
			"p75": 113.921113689095,
			"armindex": 121.454545454545
		},
		{
			"": 12683,
			"SteuerJahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4978,
			"SteuerEinkommen_P25": 39.7,
			"SteuerEinkommen_Median": 59.5,
			"SteuerEinkommen_P75": 80.9,
			"eink_arm_Sum": 1137,
			"ant_eink_arm": 22.8,
			"p25": 99.25,
			"p50": 108.083560399637,
			"p75": 112.205270457698,
			"armindex": 155.102040816327
		},
		{
			"": 12795,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3520,
			"SteuerEinkommen_P25": 8.2,
			"SteuerEinkommen_Median": 33.4,
			"SteuerEinkommen_P75": 74.2,
			"eink_arm_Sum": 1364,
			"ant_eink_arm": 38.8,
			"p25": 178.260869565217,
			"p50": 150.45045045045,
			"p75": 148.4,
			"armindex": 92.3809523809524
		},
		{
			"": 12796,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 616,
			"SteuerEinkommen_P25": 61.3,
			"SteuerEinkommen_Median": 112.65,
			"SteuerEinkommen_P75": 193.4,
			"eink_arm_Sum": 79,
			"ant_eink_arm": 12.8,
			"p25": 130.148619957537,
			"p50": 140.286425902864,
			"p75": 151.09375,
			"armindex": 84.2105263157895
		},
		{
			"": 12904,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12185,
			"SteuerEinkommen_P25": 21.5,
			"SteuerEinkommen_Median": 44.6,
			"SteuerEinkommen_P75": 72,
			"eink_arm_Sum": 3049,
			"ant_eink_arm": 25,
			"p25": 107.5,
			"p50": 117.368421052632,
			"p75": 123.287671232877,
			"armindex": 116.279069767442
		},
		{
			"": 12905,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4617,
			"SteuerEinkommen_P25": 57.9,
			"SteuerEinkommen_Median": 89.1,
			"SteuerEinkommen_P75": 140.8,
			"eink_arm_Sum": 561,
			"ant_eink_arm": 12.2,
			"p25": 117.922606924644,
			"p50": 127.650429799427,
			"p75": 138.71921182266,
			"armindex": 112.962962962963
		},
		{
			"": 12992,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 20388,
			"SteuerEinkommen_P25": 21,
			"SteuerEinkommen_Median": 42.9,
			"SteuerEinkommen_P75": 66,
			"eink_arm_Sum": 5217,
			"ant_eink_arm": 25.6,
			"p25": 118.64406779661,
			"p50": 130.395136778115,
			"p75": 132,
			"armindex": 104.489795918367
		},
		{
			"": 12993,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6083,
			"SteuerEinkommen_P25": 43.8,
			"SteuerEinkommen_Median": 68.8,
			"SteuerEinkommen_P75": 104.3,
			"eink_arm_Sum": 1250,
			"ant_eink_arm": 20.5,
			"p25": 108.415841584158,
			"p50": 116.610169491525,
			"p75": 130.375,
			"armindex": 135.761589403974
		},
		{
			"": 13080,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13417,
			"SteuerEinkommen_P25": 17.8,
			"SteuerEinkommen_Median": 37.5,
			"SteuerEinkommen_P75": 60,
			"eink_arm_Sum": 4089,
			"ant_eink_arm": 30.5,
			"p25": 123.611111111111,
			"p50": 130.208333333333,
			"p75": 130.434782608696,
			"armindex": 101.328903654485
		},
		{
			"": 13081,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2863,
			"SteuerEinkommen_P25": 36.8,
			"SteuerEinkommen_Median": 56.9,
			"SteuerEinkommen_P75": 82.9,
			"eink_arm_Sum": 772,
			"ant_eink_arm": 27,
			"p25": 105.747126436782,
			"p50": 110.271317829457,
			"p75": 117.090395480226,
			"armindex": 132.352941176471
		},
		{
			"": 13170,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6480,
			"SteuerEinkommen_P25": 18.1,
			"SteuerEinkommen_Median": 42.7,
			"SteuerEinkommen_P75": 70,
			"eink_arm_Sum": 1840,
			"ant_eink_arm": 28.4,
			"p25": 114.920634920635,
			"p50": 132.198142414861,
			"p75": 140.280561122245,
			"armindex": 105.576208178439
		},
		{
			"": 13171,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1356,
			"SteuerEinkommen_P25": 45,
			"SteuerEinkommen_Median": 68,
			"SteuerEinkommen_P75": 101.3,
			"eink_arm_Sum": 260,
			"ant_eink_arm": 19.2,
			"p25": 121.293800539084,
			"p50": 125.925925925926,
			"p75": 136.891891891892,
			"armindex": 99.4818652849741
		},
		{
			"": 13236,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12886,
			"SteuerEinkommen_P25": 23.9,
			"SteuerEinkommen_Median": 48.1,
			"SteuerEinkommen_P75": 77,
			"eink_arm_Sum": 2926,
			"ant_eink_arm": 22.7,
			"p25": 126.455026455026,
			"p50": 127.586206896552,
			"p75": 129.848229342327,
			"armindex": 98.695652173913
		},
		{
			"": 13237,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4164,
			"SteuerEinkommen_P25": 61.2,
			"SteuerEinkommen_Median": 95.2,
			"SteuerEinkommen_P75": 155.25,
			"eink_arm_Sum": 427,
			"ant_eink_arm": 10.3,
			"p25": 126.185567010309,
			"p50": 136,
			"p75": 149.135446685879,
			"armindex": 96.2616822429907
		},
		{
			"": 13304,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14198,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 50.3,
			"SteuerEinkommen_P75": 85.7,
			"eink_arm_Sum": 3587,
			"ant_eink_arm": 25.3,
			"p25": 115.217391304348,
			"p50": 120.334928229665,
			"p75": 129.260935143288,
			"armindex": 105.857740585774
		},
		{
			"": 13305,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5591,
			"SteuerEinkommen_P25": 77.7,
			"SteuerEinkommen_Median": 126.85,
			"SteuerEinkommen_P75": 211.65,
			"eink_arm_Sum": 406,
			"ant_eink_arm": 7.3,
			"p25": 133.047945205479,
			"p50": 139.395604395604,
			"p75": 141.571906354515,
			"armindex": 79.3478260869565
		},
		{
			"": 13416,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7253,
			"SteuerEinkommen_P25": 25.6,
			"SteuerEinkommen_Median": 55,
			"SteuerEinkommen_P75": 90,
			"eink_arm_Sum": 1583,
			"ant_eink_arm": 21.8,
			"p25": 127.363184079602,
			"p50": 134.474327628362,
			"p75": 142.630744849445,
			"armindex": 100.925925925926
		},
		{
			"": 13417,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1828,
			"SteuerEinkommen_P25": 68.7,
			"SteuerEinkommen_Median": 111.4,
			"SteuerEinkommen_P75": 186.9,
			"eink_arm_Sum": 169,
			"ant_eink_arm": 9.2,
			"p25": 134.1796875,
			"p50": 142.820512820513,
			"p75": 153.953871499176,
			"armindex": 84.4036697247706
		},
		{
			"": 13504,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 19720,
			"SteuerEinkommen_P25": 20.8,
			"SteuerEinkommen_Median": 41,
			"SteuerEinkommen_P75": 61.1,
			"eink_arm_Sum": 5059,
			"ant_eink_arm": 25.7,
			"p25": 110.05291005291,
			"p50": 120.588235294118,
			"p75": 122.2,
			"armindex": 112.719298245614
		},
		{
			"": 13505,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8044,
			"SteuerEinkommen_P25": 47.1,
			"SteuerEinkommen_Median": 68.9,
			"SteuerEinkommen_P75": 96.5,
			"eink_arm_Sum": 1337,
			"ant_eink_arm": 16.6,
			"p25": 107.045454545455,
			"p50": 116.5820642978,
			"p75": 119.875776397516,
			"armindex": 139.495798319328
		},
		{
			"": 13572,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16122,
			"SteuerEinkommen_P25": 23.2,
			"SteuerEinkommen_Median": 46.9,
			"SteuerEinkommen_P75": 70.2,
			"eink_arm_Sum": 3743,
			"ant_eink_arm": 23.2,
			"p25": 116,
			"p50": 121.818181818182,
			"p75": 122.299651567944,
			"armindex": 107.906976744186
		},
		{
			"": 13573,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5343,
			"SteuerEinkommen_P25": 58.9,
			"SteuerEinkommen_Median": 86.9,
			"SteuerEinkommen_P75": 132.1,
			"eink_arm_Sum": 609,
			"ant_eink_arm": 11.4,
			"p25": 118.75,
			"p50": 125.942028985507,
			"p75": 133.975659229209,
			"armindex": 102.702702702703
		},
		{
			"": 13638,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 23807,
			"SteuerEinkommen_P25": 19.4,
			"SteuerEinkommen_Median": 40.3,
			"SteuerEinkommen_P75": 62.7,
			"eink_arm_Sum": 6642,
			"ant_eink_arm": 27.9,
			"p25": 105.434782608696,
			"p50": 119.230769230769,
			"p75": 125.4,
			"armindex": 120.258620689655
		},
		{
			"": 13639,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 10386,
			"SteuerEinkommen_P25": 47.7,
			"SteuerEinkommen_Median": 71.3,
			"SteuerEinkommen_P75": 103.1,
			"eink_arm_Sum": 1778,
			"ant_eink_arm": 17.1,
			"p25": 112.765957446809,
			"p50": 118.833333333333,
			"p75": 125.885225885226,
			"armindex": 132.558139534884
		},
		{
			"": 13728,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9572,
			"SteuerEinkommen_P25": 15.3,
			"SteuerEinkommen_Median": 31.5,
			"SteuerEinkommen_P75": 48.8,
			"eink_arm_Sum": 3293,
			"ant_eink_arm": 34.4,
			"p25": 97.4522292993631,
			"p50": 110.915492957746,
			"p75": 113.22505800464,
			"armindex": 125.090909090909
		},
		{
			"": 13729,
			"SteuerJahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4884,
			"SteuerEinkommen_P25": 39.9,
			"SteuerEinkommen_Median": 59.75,
			"SteuerEinkommen_P75": 81.5,
			"eink_arm_Sum": 1140,
			"ant_eink_arm": 23.3,
			"p25": 99.75,
			"p50": 108.537693006358,
			"p75": 113.037447988904,
			"armindex": 158.503401360544
		},
		{
			"": 13841,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3529,
			"SteuerEinkommen_P25": 6.2,
			"SteuerEinkommen_Median": 33.5,
			"SteuerEinkommen_P75": 73.7,
			"eink_arm_Sum": 1383,
			"ant_eink_arm": 39.2,
			"p25": 134.782608695652,
			"p50": 150.900900900901,
			"p75": 147.4,
			"armindex": 93.3333333333333
		},
		{
			"": 13842,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 614,
			"SteuerEinkommen_P25": 61.5,
			"SteuerEinkommen_Median": 115.7,
			"SteuerEinkommen_P75": 189.9,
			"eink_arm_Sum": 93,
			"ant_eink_arm": 15.1,
			"p25": 130.573248407643,
			"p50": 144.084682440847,
			"p75": 148.359375,
			"armindex": 99.3421052631579
		},
		{
			"": 13950,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12288,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 44.6,
			"SteuerEinkommen_P75": 72.9,
			"eink_arm_Sum": 3185,
			"ant_eink_arm": 25.9,
			"p25": 102.5,
			"p50": 117.368421052632,
			"p75": 124.828767123288,
			"armindex": 120.46511627907
		},
		{
			"": 13951,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4563,
			"SteuerEinkommen_P25": 57.4,
			"SteuerEinkommen_Median": 87.5,
			"SteuerEinkommen_P75": 142.2,
			"eink_arm_Sum": 561,
			"ant_eink_arm": 12.3,
			"p25": 116.904276985743,
			"p50": 125.358166189112,
			"p75": 140.098522167488,
			"armindex": 113.888888888889
		},
		{
			"": 14040,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 20760,
			"SteuerEinkommen_P25": 20.7,
			"SteuerEinkommen_Median": 42.7,
			"SteuerEinkommen_P75": 66.7,
			"eink_arm_Sum": 5390,
			"ant_eink_arm": 26,
			"p25": 116.949152542373,
			"p50": 129.787234042553,
			"p75": 133.4,
			"armindex": 106.122448979592
		},
		{
			"": 14041,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6120,
			"SteuerEinkommen_P25": 43.4,
			"SteuerEinkommen_Median": 68.5,
			"SteuerEinkommen_P75": 104.15,
			"eink_arm_Sum": 1269,
			"ant_eink_arm": 20.7,
			"p25": 107.425742574257,
			"p50": 116.101694915254,
			"p75": 130.1875,
			"armindex": 137.086092715232
		},
		{
			"": 14128,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13657,
			"SteuerEinkommen_P25": 17.95,
			"SteuerEinkommen_Median": 38.6,
			"SteuerEinkommen_P75": 61.7,
			"eink_arm_Sum": 4128,
			"ant_eink_arm": 30.2,
			"p25": 124.652777777778,
			"p50": 134.027777777778,
			"p75": 134.130434782609,
			"armindex": 100.332225913621
		},
		{
			"": 14129,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2842,
			"SteuerEinkommen_P25": 35,
			"SteuerEinkommen_Median": 56,
			"SteuerEinkommen_P75": 82.95,
			"eink_arm_Sum": 824,
			"ant_eink_arm": 29,
			"p25": 100.574712643678,
			"p50": 108.527131782946,
			"p75": 117.161016949153,
			"armindex": 142.156862745098
		},
		{
			"": 14218,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6575,
			"SteuerEinkommen_P25": 18.7,
			"SteuerEinkommen_Median": 43.7,
			"SteuerEinkommen_P75": 69.95,
			"eink_arm_Sum": 1836,
			"ant_eink_arm": 27.9,
			"p25": 118.730158730159,
			"p50": 135.294117647059,
			"p75": 140.180360721443,
			"armindex": 103.717472118959
		},
		{
			"": 14219,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1377,
			"SteuerEinkommen_P25": 46.5,
			"SteuerEinkommen_Median": 69.5,
			"SteuerEinkommen_P75": 106.9,
			"eink_arm_Sum": 261,
			"ant_eink_arm": 19,
			"p25": 125.33692722372,
			"p50": 128.703703703704,
			"p75": 144.459459459459,
			"armindex": 98.4455958549223
		},
		{
			"": 14284,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12881,
			"SteuerEinkommen_P25": 23.15,
			"SteuerEinkommen_Median": 48,
			"SteuerEinkommen_P75": 77.05,
			"eink_arm_Sum": 3017,
			"ant_eink_arm": 23.4,
			"p25": 122.486772486772,
			"p50": 127.320954907162,
			"p75": 129.932546374368,
			"armindex": 101.739130434783
		},
		{
			"": 14285,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4182,
			"SteuerEinkommen_P25": 60.3,
			"SteuerEinkommen_Median": 95.5,
			"SteuerEinkommen_P75": 154.4,
			"eink_arm_Sum": 447,
			"ant_eink_arm": 10.7,
			"p25": 124.329896907216,
			"p50": 136.428571428571,
			"p75": 148.318924111431,
			"armindex": 100
		},
		{
			"": 14352,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14121,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 50.5,
			"SteuerEinkommen_P75": 84.7,
			"eink_arm_Sum": 3570,
			"ant_eink_arm": 25.3,
			"p25": 115.217391304348,
			"p50": 120.813397129187,
			"p75": 127.752639517345,
			"armindex": 105.857740585774
		},
		{
			"": 14353,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5598,
			"SteuerEinkommen_P25": 78.2,
			"SteuerEinkommen_Median": 125.9,
			"SteuerEinkommen_P75": 212.8,
			"eink_arm_Sum": 437,
			"ant_eink_arm": 7.8,
			"p25": 133.904109589041,
			"p50": 138.351648351648,
			"p75": 142.341137123746,
			"armindex": 84.7826086956522
		},
		{
			"": 14465,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7209,
			"SteuerEinkommen_P25": 25.15,
			"SteuerEinkommen_Median": 55.5,
			"SteuerEinkommen_P75": 91.8,
			"eink_arm_Sum": 1587,
			"ant_eink_arm": 22,
			"p25": 125.124378109453,
			"p50": 135.696821515892,
			"p75": 145.483359746434,
			"armindex": 101.851851851852
		},
		{
			"": 14466,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1838,
			"SteuerEinkommen_P25": 71,
			"SteuerEinkommen_Median": 114.9,
			"SteuerEinkommen_P75": 189.8,
			"eink_arm_Sum": 158,
			"ant_eink_arm": 8.6,
			"p25": 138.671875,
			"p50": 147.307692307692,
			"p75": 156.342668863262,
			"armindex": 78.8990825688073
		},
		{
			"": 14553,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 20044,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 41.1,
			"SteuerEinkommen_P75": 61.2,
			"eink_arm_Sum": 5209,
			"ant_eink_arm": 26,
			"p25": 108.994708994709,
			"p50": 120.882352941176,
			"p75": 122.4,
			"armindex": 114.035087719298
		},
		{
			"": 14554,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8050,
			"SteuerEinkommen_P25": 46.4,
			"SteuerEinkommen_Median": 68.9,
			"SteuerEinkommen_P75": 97.3,
			"eink_arm_Sum": 1413,
			"ant_eink_arm": 17.6,
			"p25": 105.454545454545,
			"p50": 116.5820642978,
			"p75": 120.869565217391,
			"armindex": 147.899159663866
		},
		{
			"": 14621,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16326,
			"SteuerEinkommen_P25": 23.1,
			"SteuerEinkommen_Median": 47,
			"SteuerEinkommen_P75": 71.2,
			"eink_arm_Sum": 3840,
			"ant_eink_arm": 23.5,
			"p25": 115.5,
			"p50": 122.077922077922,
			"p75": 124.04181184669,
			"armindex": 109.302325581395
		},
		{
			"": 14622,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5263,
			"SteuerEinkommen_P25": 57.9,
			"SteuerEinkommen_Median": 86.9,
			"SteuerEinkommen_P75": 133.1,
			"eink_arm_Sum": 627,
			"ant_eink_arm": 11.9,
			"p25": 116.733870967742,
			"p50": 125.942028985507,
			"p75": 134.98985801217,
			"armindex": 107.207207207207
		},
		{
			"": 14687,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 24404,
			"SteuerEinkommen_P25": 19.3,
			"SteuerEinkommen_Median": 40.6,
			"SteuerEinkommen_P75": 63,
			"eink_arm_Sum": 6784,
			"ant_eink_arm": 27.8,
			"p25": 104.891304347826,
			"p50": 120.118343195266,
			"p75": 126,
			"armindex": 119.827586206897
		},
		{
			"": 14688,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 10497,
			"SteuerEinkommen_P25": 47.2,
			"SteuerEinkommen_Median": 71.4,
			"SteuerEinkommen_P75": 103.4,
			"eink_arm_Sum": 1816,
			"ant_eink_arm": 17.3,
			"p25": 111.583924349882,
			"p50": 119,
			"p75": 126.251526251526,
			"armindex": 134.108527131783
		},
		{
			"": 14778,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9666,
			"SteuerEinkommen_P25": 14.6,
			"SteuerEinkommen_Median": 31.1,
			"SteuerEinkommen_P75": 49,
			"eink_arm_Sum": 3422,
			"ant_eink_arm": 35.4,
			"p25": 92.9936305732484,
			"p50": 109.507042253521,
			"p75": 113.68909512761,
			"armindex": 128.727272727273
		},
		{
			"": 14779,
			"SteuerJahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4788,
			"SteuerEinkommen_P25": 38.5,
			"SteuerEinkommen_Median": 58.7,
			"SteuerEinkommen_P75": 80.3,
			"eink_arm_Sum": 1188,
			"ant_eink_arm": 24.8,
			"p25": 96.25,
			"p50": 106.630336058129,
			"p75": 111.373092926491,
			"armindex": 168.707482993197
		},
		{
			"": 14891,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3539,
			"SteuerEinkommen_P25": 7.1,
			"SteuerEinkommen_Median": 33.7,
			"SteuerEinkommen_P75": 71.2,
			"eink_arm_Sum": 1403,
			"ant_eink_arm": 39.6,
			"p25": 154.347826086957,
			"p50": 151.801801801802,
			"p75": 142.4,
			"armindex": 94.2857142857143
		},
		{
			"": 14892,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 612,
			"SteuerEinkommen_P25": 64.5,
			"SteuerEinkommen_Median": 113.9,
			"SteuerEinkommen_P75": 198,
			"eink_arm_Sum": 90,
			"ant_eink_arm": 14.7,
			"p25": 136.942675159236,
			"p50": 141.843088418431,
			"p75": 154.6875,
			"armindex": 96.7105263157895
		},
		{
			"": 15001,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12307,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 45.4,
			"SteuerEinkommen_P75": 72.95,
			"eink_arm_Sum": 3141,
			"ant_eink_arm": 25.5,
			"p25": 106,
			"p50": 119.473684210526,
			"p75": 124.914383561644,
			"armindex": 118.604651162791
		},
		{
			"": 15002,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4565,
			"SteuerEinkommen_P25": 55.8,
			"SteuerEinkommen_Median": 87.5,
			"SteuerEinkommen_P75": 142.3,
			"eink_arm_Sum": 623,
			"ant_eink_arm": 13.6,
			"p25": 113.645621181263,
			"p50": 125.358166189112,
			"p75": 140.197044334975,
			"armindex": 125.925925925926
		},
		{
			"": 15091,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 21216,
			"SteuerEinkommen_P25": 21.2,
			"SteuerEinkommen_Median": 43.8,
			"SteuerEinkommen_P75": 67.6,
			"eink_arm_Sum": 5434,
			"ant_eink_arm": 25.6,
			"p25": 119.774011299435,
			"p50": 133.130699088146,
			"p75": 135.2,
			"armindex": 104.489795918367
		},
		{
			"": 15092,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6128,
			"SteuerEinkommen_P25": 42.8,
			"SteuerEinkommen_Median": 69.2,
			"SteuerEinkommen_P75": 106.6,
			"eink_arm_Sum": 1278,
			"ant_eink_arm": 20.9,
			"p25": 105.940594059406,
			"p50": 117.28813559322,
			"p75": 133.25,
			"armindex": 138.41059602649
		},
		{
			"": 15182,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13911,
			"SteuerEinkommen_P25": 18,
			"SteuerEinkommen_Median": 38.8,
			"SteuerEinkommen_P75": 62.5,
			"eink_arm_Sum": 4218,
			"ant_eink_arm": 30.3,
			"p25": 125,
			"p50": 134.722222222222,
			"p75": 135.869565217391,
			"armindex": 100.664451827243
		},
		{
			"": 15183,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2822,
			"SteuerEinkommen_P25": 33.9,
			"SteuerEinkommen_Median": 54.5,
			"SteuerEinkommen_P75": 83,
			"eink_arm_Sum": 865,
			"ant_eink_arm": 30.7,
			"p25": 97.4137931034483,
			"p50": 105.62015503876,
			"p75": 117.231638418079,
			"armindex": 150.490196078431
		},
		{
			"": 15271,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6836,
			"SteuerEinkommen_P25": 19.7,
			"SteuerEinkommen_Median": 45.1,
			"SteuerEinkommen_P75": 72.9,
			"eink_arm_Sum": 1861,
			"ant_eink_arm": 27.2,
			"p25": 125.079365079365,
			"p50": 139.628482972136,
			"p75": 146.092184368737,
			"armindex": 101.115241635688
		},
		{
			"": 15272,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1384,
			"SteuerEinkommen_P25": 45.8,
			"SteuerEinkommen_Median": 72.45,
			"SteuerEinkommen_P75": 112.3,
			"eink_arm_Sum": 254,
			"ant_eink_arm": 18.4,
			"p25": 123.450134770889,
			"p50": 134.166666666667,
			"p75": 151.756756756757,
			"armindex": 95.3367875647668
		},
		{
			"": 15336,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13041,
			"SteuerEinkommen_P25": 22.4,
			"SteuerEinkommen_Median": 47.8,
			"SteuerEinkommen_P75": 76,
			"eink_arm_Sum": 3183,
			"ant_eink_arm": 24.4,
			"p25": 118.518518518519,
			"p50": 126.790450928382,
			"p75": 128.161888701518,
			"armindex": 106.086956521739
		},
		{
			"": 15337,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4137,
			"SteuerEinkommen_P25": 60.4,
			"SteuerEinkommen_Median": 95,
			"SteuerEinkommen_P75": 157,
			"eink_arm_Sum": 490,
			"ant_eink_arm": 11.8,
			"p25": 124.536082474227,
			"p50": 135.714285714286,
			"p75": 150.816522574448,
			"armindex": 110.280373831776
		},
		{
			"": 15405,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 14190,
			"SteuerEinkommen_P25": 21.1,
			"SteuerEinkommen_Median": 50,
			"SteuerEinkommen_P75": 84.2,
			"eink_arm_Sum": 3617,
			"ant_eink_arm": 25.5,
			"p25": 114.673913043478,
			"p50": 119.617224880383,
			"p75": 126.998491704374,
			"armindex": 106.694560669456
		},
		{
			"": 15406,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5630,
			"SteuerEinkommen_P25": 76.55,
			"SteuerEinkommen_Median": 124.7,
			"SteuerEinkommen_P75": 210,
			"eink_arm_Sum": 466,
			"ant_eink_arm": 8.3,
			"p25": 131.078767123288,
			"p50": 137.032967032967,
			"p75": 140.468227424749,
			"armindex": 90.2173913043478
		},
		{
			"": 15519,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 7357,
			"SteuerEinkommen_P25": 23.9,
			"SteuerEinkommen_Median": 54.6,
			"SteuerEinkommen_P75": 90.7,
			"eink_arm_Sum": 1715,
			"ant_eink_arm": 23.3,
			"p25": 118.905472636816,
			"p50": 133.496332518337,
			"p75": 143.740095087163,
			"armindex": 107.87037037037
		},
		{
			"": 15520,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1869,
			"SteuerEinkommen_P25": 69.5,
			"SteuerEinkommen_Median": 113.8,
			"SteuerEinkommen_P75": 194.95,
			"eink_arm_Sum": 177,
			"ant_eink_arm": 9.5,
			"p25": 135.7421875,
			"p50": 145.897435897436,
			"p75": 160.584843492586,
			"armindex": 87.1559633027523
		},
		{
			"": 15607,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 20209,
			"SteuerEinkommen_P25": 20.8,
			"SteuerEinkommen_Median": 41.1,
			"SteuerEinkommen_P75": 61.2,
			"eink_arm_Sum": 5244,
			"ant_eink_arm": 25.9,
			"p25": 110.05291005291,
			"p50": 120.882352941176,
			"p75": 122.4,
			"armindex": 113.59649122807
		},
		{
			"": 15608,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 7977,
			"SteuerEinkommen_P25": 45.7,
			"SteuerEinkommen_Median": 68.4,
			"SteuerEinkommen_P75": 97.5,
			"eink_arm_Sum": 1471,
			"ant_eink_arm": 18.4,
			"p25": 103.863636363636,
			"p50": 115.736040609137,
			"p75": 121.11801242236,
			"armindex": 154.621848739496
		},
		{
			"": 15675,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 16349,
			"SteuerEinkommen_P25": 23.2,
			"SteuerEinkommen_Median": 46.8,
			"SteuerEinkommen_P75": 70.4,
			"eink_arm_Sum": 3855,
			"ant_eink_arm": 23.6,
			"p25": 116,
			"p50": 121.558441558442,
			"p75": 122.648083623693,
			"armindex": 109.767441860465
		},
		{
			"": 15676,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5241,
			"SteuerEinkommen_P25": 57.2,
			"SteuerEinkommen_Median": 85.8,
			"SteuerEinkommen_P75": 131.6,
			"eink_arm_Sum": 682,
			"ant_eink_arm": 13,
			"p25": 115.322580645161,
			"p50": 124.347826086957,
			"p75": 133.468559837728,
			"armindex": 117.117117117117
		},
		{
			"": 15741,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 24809,
			"SteuerEinkommen_P25": 19.3,
			"SteuerEinkommen_Median": 40.7,
			"SteuerEinkommen_P75": 62.7,
			"eink_arm_Sum": 6983,
			"ant_eink_arm": 28.1,
			"p25": 104.891304347826,
			"p50": 120.414201183432,
			"p75": 125.4,
			"armindex": 121.120689655172
		},
		{
			"": 15742,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 10621,
			"SteuerEinkommen_P25": 46.2,
			"SteuerEinkommen_Median": 70.6,
			"SteuerEinkommen_P75": 102.6,
			"eink_arm_Sum": 1947,
			"ant_eink_arm": 18.3,
			"p25": 109.219858156028,
			"p50": 117.666666666667,
			"p75": 125.274725274725,
			"armindex": 141.860465116279
		},
		{
			"": 15831,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9724,
			"SteuerEinkommen_P25": 14.5,
			"SteuerEinkommen_Median": 31.4,
			"SteuerEinkommen_P75": 49.9,
			"eink_arm_Sum": 3458,
			"ant_eink_arm": 35.6,
			"p25": 92.3566878980892,
			"p50": 110.56338028169,
			"p75": 115.777262180974,
			"armindex": 129.454545454545
		},
		{
			"": 15832,
			"SteuerJahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4714,
			"SteuerEinkommen_P25": 37.1,
			"SteuerEinkommen_Median": 57.35,
			"SteuerEinkommen_P75": 79.8,
			"eink_arm_Sum": 1227,
			"ant_eink_arm": 26,
			"p25": 92.75,
			"p50": 104.178019981835,
			"p75": 110.679611650485,
			"armindex": 176.87074829932
		},
		{
			"": 15944,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 3456,
			"SteuerEinkommen_P25": 6.2,
			"SteuerEinkommen_Median": 32.7,
			"SteuerEinkommen_P75": 68,
			"eink_arm_Sum": 1389,
			"ant_eink_arm": 40.2,
			"p25": 134.782608695652,
			"p50": 147.297297297297,
			"p75": 136,
			"armindex": 95.7142857142857
		},
		{
			"": 15945,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 594,
			"SteuerEinkommen_P25": 62.7,
			"SteuerEinkommen_Median": 109.1,
			"SteuerEinkommen_P75": 182.6,
			"eink_arm_Sum": 78,
			"ant_eink_arm": 13.1,
			"p25": 133.12101910828,
			"p50": 135.865504358655,
			"p75": 142.65625,
			"armindex": 86.1842105263158
		},
		{
			"": 16051,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 11957,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 43.8,
			"SteuerEinkommen_P75": 69.5,
			"eink_arm_Sum": 3152,
			"ant_eink_arm": 26.4,
			"p25": 100,
			"p50": 115.263157894737,
			"p75": 119.006849315068,
			"armindex": 122.790697674419
		},
		{
			"": 16052,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4568,
			"SteuerEinkommen_P25": 56.7,
			"SteuerEinkommen_Median": 88.45,
			"SteuerEinkommen_P75": 139.8,
			"eink_arm_Sum": 583,
			"ant_eink_arm": 12.8,
			"p25": 115.478615071283,
			"p50": 126.719197707736,
			"p75": 137.733990147783,
			"armindex": 118.518518518519
		},
		{
			"": 16141,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 20375,
			"SteuerEinkommen_P25": 20.7,
			"SteuerEinkommen_Median": 42.7,
			"SteuerEinkommen_P75": 65.6,
			"eink_arm_Sum": 5214,
			"ant_eink_arm": 25.6,
			"p25": 116.949152542373,
			"p50": 129.787234042553,
			"p75": 131.2,
			"armindex": 104.489795918367
		},
		{
			"": 16142,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 6270,
			"SteuerEinkommen_P25": 44.5,
			"SteuerEinkommen_Median": 69.8,
			"SteuerEinkommen_P75": 106.3,
			"eink_arm_Sum": 1262,
			"ant_eink_arm": 20.1,
			"p25": 110.148514851485,
			"p50": 118.305084745763,
			"p75": 132.875,
			"armindex": 133.112582781457
		},
		{
			"": 16231,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13644,
			"SteuerEinkommen_P25": 17.8,
			"SteuerEinkommen_Median": 38.2,
			"SteuerEinkommen_P75": 60.5,
			"eink_arm_Sum": 4158,
			"ant_eink_arm": 30.5,
			"p25": 123.611111111111,
			"p50": 132.638888888889,
			"p75": 131.521739130435,
			"armindex": 101.328903654485
		},
		{
			"": 16232,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 2927,
			"SteuerEinkommen_P25": 35,
			"SteuerEinkommen_Median": 55.3,
			"SteuerEinkommen_P75": 83.8,
			"eink_arm_Sum": 845,
			"ant_eink_arm": 28.9,
			"p25": 100.574712643678,
			"p50": 107.170542635659,
			"p75": 118.361581920904,
			"armindex": 141.666666666667
		},
		{
			"": 16322,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6850,
			"SteuerEinkommen_P25": 20,
			"SteuerEinkommen_Median": 45.8,
			"SteuerEinkommen_P75": 71.6,
			"eink_arm_Sum": 1804,
			"ant_eink_arm": 26.3,
			"p25": 126.984126984127,
			"p50": 141.795665634675,
			"p75": 143.486973947896,
			"armindex": 97.7695167286245
		},
		{
			"": 16323,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 5",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1499,
			"SteuerEinkommen_P25": 47.7,
			"SteuerEinkommen_Median": 77.3,
			"SteuerEinkommen_P75": 120,
			"eink_arm_Sum": 251,
			"ant_eink_arm": 16.7,
			"p25": 128.571428571429,
			"p50": 143.148148148148,
			"p75": 162.162162162162,
			"armindex": 86.5284974093264
		},
		{
			"": 16388,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 12706,
			"SteuerEinkommen_P25": 21.3,
			"SteuerEinkommen_Median": 46.5,
			"SteuerEinkommen_P75": 72.7,
			"eink_arm_Sum": 3171,
			"ant_eink_arm": 25,
			"p25": 112.698412698413,
			"p50": 123.342175066313,
			"p75": 122.596964586847,
			"armindex": 108.695652173913
		},
		{
			"": 16389,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 6",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4228,
			"SteuerEinkommen_P25": 60,
			"SteuerEinkommen_Median": 95,
			"SteuerEinkommen_P75": 155,
			"eink_arm_Sum": 502,
			"ant_eink_arm": 11.9,
			"p25": 123.711340206186,
			"p50": 135.714285714286,
			"p75": 148.895292987512,
			"armindex": 111.214953271028
		},
		{
			"": 16458,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 13711,
			"SteuerEinkommen_P25": 20.5,
			"SteuerEinkommen_Median": 49.8,
			"SteuerEinkommen_P75": 80.6,
			"eink_arm_Sum": 3525,
			"ant_eink_arm": 25.7,
			"p25": 111.413043478261,
			"p50": 119.138755980861,
			"p75": 121.56862745098,
			"armindex": 107.531380753138
		},
		{
			"": 16459,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5557,
			"SteuerEinkommen_P25": 76.3,
			"SteuerEinkommen_Median": 121.85,
			"SteuerEinkommen_P75": 201,
			"eink_arm_Sum": 434,
			"ant_eink_arm": 7.8,
			"p25": 130.650684931507,
			"p50": 133.901098901099,
			"p75": 134.448160535117,
			"armindex": 84.7826086956522
		},
		{
			"": 16572,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 6832,
			"SteuerEinkommen_P25": 22.7,
			"SteuerEinkommen_Median": 51.15,
			"SteuerEinkommen_P75": 81.65,
			"eink_arm_Sum": 1639,
			"ant_eink_arm": 24,
			"p25": 112.935323383085,
			"p50": 125.061124694377,
			"p75": 129.397781299525,
			"armindex": 111.111111111111
		},
		{
			"": 16573,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 1838,
			"SteuerEinkommen_P25": 68.2,
			"SteuerEinkommen_Median": 110.2,
			"SteuerEinkommen_P75": 185.05,
			"eink_arm_Sum": 167,
			"ant_eink_arm": 9.1,
			"p25": 133.203125,
			"p50": 141.282051282051,
			"p75": 152.429983525535,
			"armindex": 83.4862385321101
		},
		{
			"": 16659,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 19750,
			"SteuerEinkommen_P25": 20.6,
			"SteuerEinkommen_Median": 41.1,
			"SteuerEinkommen_P75": 60.6,
			"eink_arm_Sum": 5087,
			"ant_eink_arm": 25.8,
			"p25": 108.994708994709,
			"p50": 120.882352941176,
			"p75": 121.2,
			"armindex": 113.157894736842
		},
		{
			"": 16660,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 9",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 8104,
			"SteuerEinkommen_P25": 45.5,
			"SteuerEinkommen_Median": 68.4,
			"SteuerEinkommen_P75": 97.7,
			"eink_arm_Sum": 1490,
			"ant_eink_arm": 18.4,
			"p25": 103.409090909091,
			"p50": 115.736040609137,
			"p75": 121.366459627329,
			"armindex": 154.621848739496
		},
		{
			"": 16727,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 15954,
			"SteuerEinkommen_P25": 22.5,
			"SteuerEinkommen_Median": 46.55,
			"SteuerEinkommen_P75": 69.7,
			"eink_arm_Sum": 3782,
			"ant_eink_arm": 23.7,
			"p25": 112.5,
			"p50": 120.909090909091,
			"p75": 121.428571428571,
			"armindex": 110.232558139535
		},
		{
			"": 16728,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 10",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 5369,
			"SteuerEinkommen_P25": 57.4,
			"SteuerEinkommen_Median": 87.6,
			"SteuerEinkommen_P75": 132.5,
			"eink_arm_Sum": 647,
			"ant_eink_arm": 12.1,
			"p25": 115.725806451613,
			"p50": 126.95652173913,
			"p75": 134.381338742393,
			"armindex": 109.009009009009
		},
		{
			"": 16798,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 24107,
			"SteuerEinkommen_P25": 18.3,
			"SteuerEinkommen_Median": 40,
			"SteuerEinkommen_P75": 60.8,
			"eink_arm_Sum": 6972,
			"ant_eink_arm": 28.9,
			"p25": 99.4565217391304,
			"p50": 118.343195266272,
			"p75": 121.6,
			"armindex": 124.568965517241
		},
		{
			"": 16799,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 10752,
			"SteuerEinkommen_P25": 45.6,
			"SteuerEinkommen_Median": 70.4,
			"SteuerEinkommen_P75": 102.4,
			"eink_arm_Sum": 1996,
			"ant_eink_arm": 18.6,
			"p25": 107.801418439716,
			"p50": 117.333333333333,
			"p75": 125.030525030525,
			"armindex": 144.186046511628
		},
		{
			"": 16888,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Grundtarif",
			"AnzBestZiv_sum": 9830,
			"SteuerEinkommen_P25": 14.8,
			"SteuerEinkommen_Median": 31.7,
			"SteuerEinkommen_P75": 50,
			"eink_arm_Sum": 3439,
			"ant_eink_arm": 35,
			"p25": 94.2675159235669,
			"p50": 111.619718309859,
			"p75": 116.009280742459,
			"armindex": 127.272727272727
		},
		{
			"": 16889,
			"SteuerJahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Total",
			"SteuerTariflang": "Verheiratet",
			"AnzBestZiv_sum": 4856,
			"SteuerEinkommen_P25": 36.6,
			"SteuerEinkommen_Median": 57.4,
			"SteuerEinkommen_P75": 80.4,
			"eink_arm_Sum": 1281,
			"ant_eink_arm": 26.4,
			"p25": 91.5,
			"p50": 104.268846503179,
			"p75": 111.511789181692,
			"armindex": 179.591836734694
		}
	];

/***/ },
/* 258 */
/***/ function(module, exports) {

	module.exports = [
		{
			"id": 31,
			"Jahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 105,
			"SozialhilfeQuote": 3.9
		},
		{
			"id": 32,
			"Jahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 96,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 33,
			"Jahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 122,
			"SozialhilfeQuote": 4.4
		},
		{
			"id": 34,
			"Jahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 151,
			"SozialhilfeQuote": 5.4
		},
		{
			"id": 35,
			"Jahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 140,
			"SozialhilfeQuote": 5.1
		},
		{
			"id": 36,
			"Jahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 137,
			"SozialhilfeQuote": 5.1
		},
		{
			"id": 37,
			"Jahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 102,
			"SozialhilfeQuote": 3.8
		},
		{
			"id": 38,
			"Jahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 95,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 39,
			"Jahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 58,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 40,
			"Jahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 58,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 41,
			"Jahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 53,
			"SozialhilfeQuote": 1.9
		},
		{
			"id": 42,
			"Jahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 56,
			"SozialhilfeQuote": 2
		},
		{
			"id": 43,
			"Jahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 73,
			"SozialhilfeQuote": 2.5
		},
		{
			"id": 44,
			"Jahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 60,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 45,
			"Jahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Rathaus",
			"SozialhilfeBeziehende": 63,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 46,
			"Jahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 20,
			"SozialhilfeQuote": 3.4
		},
		{
			"id": 47,
			"Jahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 19,
			"SozialhilfeQuote": 3.2
		},
		{
			"id": 48,
			"Jahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 21,
			"SozialhilfeQuote": 3.6
		},
		{
			"id": 49,
			"Jahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 10,
			"SozialhilfeQuote": 1.7
		},
		{
			"id": 50,
			"Jahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 12,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 51,
			"Jahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 15,
			"SozialhilfeQuote": 2.7
		},
		{
			"id": 52,
			"Jahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 10,
			"SozialhilfeQuote": 1.8
		},
		{
			"id": 53,
			"Jahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 8,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 54,
			"Jahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 12,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 55,
			"Jahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 7,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 56,
			"Jahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 12,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 57,
			"Jahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 8,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 58,
			"Jahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 10,
			"SozialhilfeQuote": 1.8
		},
		{
			"id": 59,
			"Jahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 6,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 60,
			"Jahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Hochschulen",
			"SozialhilfeBeziehende": 11,
			"SozialhilfeQuote": 2
		},
		{
			"id": 61,
			"Jahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 8,
			"SozialhilfeQuote": 0.5
		},
		{
			"id": 62,
			"Jahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 6,
			"SozialhilfeQuote": 0.4
		},
		{
			"id": 63,
			"Jahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 10,
			"SozialhilfeQuote": 0.6
		},
		{
			"id": 64,
			"Jahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 10,
			"SozialhilfeQuote": 0.6
		},
		{
			"id": 65,
			"Jahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 18,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 66,
			"Jahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 19,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 67,
			"Jahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 161,
			"SozialhilfeQuote": 9.9
		},
		{
			"id": 68,
			"Jahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 172,
			"SozialhilfeQuote": 10.7
		},
		{
			"id": 69,
			"Jahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 144,
			"SozialhilfeQuote": 8.9
		},
		{
			"id": 70,
			"Jahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 128,
			"SozialhilfeQuote": 8
		},
		{
			"id": 71,
			"Jahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 124,
			"SozialhilfeQuote": 7.8
		},
		{
			"id": 72,
			"Jahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 113,
			"SozialhilfeQuote": 7.2
		},
		{
			"id": 73,
			"Jahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 110,
			"SozialhilfeQuote": 7
		},
		{
			"id": 74,
			"Jahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 115,
			"SozialhilfeQuote": 7.4
		},
		{
			"id": 75,
			"Jahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "Lindenhof",
			"SozialhilfeBeziehende": 119,
			"SozialhilfeQuote": 7.5
		},
		{
			"id": 76,
			"Jahr": 2000,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 74,
			"SozialhilfeQuote": 3.9
		},
		{
			"id": 77,
			"Jahr": 2001,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 55,
			"SozialhilfeQuote": 2.9
		},
		{
			"id": 78,
			"Jahr": 2002,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 61,
			"SozialhilfeQuote": 3.2
		},
		{
			"id": 79,
			"Jahr": 2003,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 64,
			"SozialhilfeQuote": 4.4
		},
		{
			"id": 80,
			"Jahr": 2004,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 72,
			"SozialhilfeQuote": 6.5
		},
		{
			"id": 81,
			"Jahr": 2005,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 58,
			"SozialhilfeQuote": 5.7
		},
		{
			"id": 82,
			"Jahr": 2006,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 142,
			"SozialhilfeQuote": 13.7
		},
		{
			"id": 83,
			"Jahr": 2007,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 143,
			"SozialhilfeQuote": 13.4
		},
		{
			"id": 84,
			"Jahr": 2008,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 138,
			"SozialhilfeQuote": 13.3
		},
		{
			"id": 85,
			"Jahr": 2009,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 124,
			"SozialhilfeQuote": 12.1
		},
		{
			"id": 86,
			"Jahr": 2010,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 137,
			"SozialhilfeQuote": 13.9
		},
		{
			"id": 87,
			"Jahr": 2011,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 143,
			"SozialhilfeQuote": 15
		},
		{
			"id": 88,
			"Jahr": 2012,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 127,
			"SozialhilfeQuote": 13.4
		},
		{
			"id": 89,
			"Jahr": 2013,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 120,
			"SozialhilfeQuote": 12.6
		},
		{
			"id": 90,
			"Jahr": 2014,
			"KreisSort": "Kreis 1",
			"QuarSort": "City",
			"SozialhilfeBeziehende": 119,
			"SozialhilfeQuote": 12.6
		},
		{
			"id": 106,
			"Jahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 442,
			"SozialhilfeQuote": 2.9
		},
		{
			"id": 107,
			"Jahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 440,
			"SozialhilfeQuote": 2.9
		},
		{
			"id": 108,
			"Jahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 425,
			"SozialhilfeQuote": 2.8
		},
		{
			"id": 109,
			"Jahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 468,
			"SozialhilfeQuote": 3.2
		},
		{
			"id": 110,
			"Jahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 569,
			"SozialhilfeQuote": 3.8
		},
		{
			"id": 111,
			"Jahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 573,
			"SozialhilfeQuote": 3.9
		},
		{
			"id": 112,
			"Jahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 579,
			"SozialhilfeQuote": 3.9
		},
		{
			"id": 113,
			"Jahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 501,
			"SozialhilfeQuote": 3.3
		},
		{
			"id": 114,
			"Jahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 431,
			"SozialhilfeQuote": 2.8
		},
		{
			"id": 115,
			"Jahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 403,
			"SozialhilfeQuote": 2.6
		},
		{
			"id": 116,
			"Jahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 405,
			"SozialhilfeQuote": 2.6
		},
		{
			"id": 117,
			"Jahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 420,
			"SozialhilfeQuote": 2.7
		},
		{
			"id": 118,
			"Jahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 425,
			"SozialhilfeQuote": 2.7
		},
		{
			"id": 119,
			"Jahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 437,
			"SozialhilfeQuote": 2.8
		},
		{
			"id": 120,
			"Jahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Wollishofen",
			"SozialhilfeBeziehende": 418,
			"SozialhilfeQuote": 2.7
		},
		{
			"id": 121,
			"Jahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 130,
			"SozialhilfeQuote": 2.9
		},
		{
			"id": 122,
			"Jahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 145,
			"SozialhilfeQuote": 3.2
		},
		{
			"id": 123,
			"Jahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 168,
			"SozialhilfeQuote": 3.6
		},
		{
			"id": 124,
			"Jahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 194,
			"SozialhilfeQuote": 4.1
		},
		{
			"id": 125,
			"Jahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 228,
			"SozialhilfeQuote": 4.9
		},
		{
			"id": 126,
			"Jahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 249,
			"SozialhilfeQuote": 5.2
		},
		{
			"id": 127,
			"Jahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 217,
			"SozialhilfeQuote": 4.5
		},
		{
			"id": 128,
			"Jahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 233,
			"SozialhilfeQuote": 4.6
		},
		{
			"id": 129,
			"Jahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 244,
			"SozialhilfeQuote": 4.8
		},
		{
			"id": 130,
			"Jahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 222,
			"SozialhilfeQuote": 4.2
		},
		{
			"id": 131,
			"Jahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 224,
			"SozialhilfeQuote": 4.3
		},
		{
			"id": 132,
			"Jahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 239,
			"SozialhilfeQuote": 4.5
		},
		{
			"id": 133,
			"Jahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 254,
			"SozialhilfeQuote": 4.8
		},
		{
			"id": 134,
			"Jahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 305,
			"SozialhilfeQuote": 5.4
		},
		{
			"id": 135,
			"Jahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Leimbach",
			"SozialhilfeBeziehende": 327,
			"SozialhilfeQuote": 5.6
		},
		{
			"id": 136,
			"Jahr": 2000,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 187,
			"SozialhilfeQuote": 2.5
		},
		{
			"id": 137,
			"Jahr": 2001,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 167,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 138,
			"Jahr": 2002,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 206,
			"SozialhilfeQuote": 2.7
		},
		{
			"id": 139,
			"Jahr": 2003,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 212,
			"SozialhilfeQuote": 2.8
		},
		{
			"id": 140,
			"Jahr": 2004,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 219,
			"SozialhilfeQuote": 2.8
		},
		{
			"id": 141,
			"Jahr": 2005,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 238,
			"SozialhilfeQuote": 3
		},
		{
			"id": 142,
			"Jahr": 2006,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 231,
			"SozialhilfeQuote": 3
		},
		{
			"id": 143,
			"Jahr": 2007,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 210,
			"SozialhilfeQuote": 2.6
		},
		{
			"id": 144,
			"Jahr": 2008,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 223,
			"SozialhilfeQuote": 2.7
		},
		{
			"id": 145,
			"Jahr": 2009,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 201,
			"SozialhilfeQuote": 2.4
		},
		{
			"id": 146,
			"Jahr": 2010,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 197,
			"SozialhilfeQuote": 2.4
		},
		{
			"id": 147,
			"Jahr": 2011,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 188,
			"SozialhilfeQuote": 2.3
		},
		{
			"id": 148,
			"Jahr": 2012,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 177,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 149,
			"Jahr": 2013,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 180,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 150,
			"Jahr": 2014,
			"KreisSort": "Kreis 2",
			"QuarSort": "Enge",
			"SozialhilfeBeziehende": 181,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 166,
			"Jahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 810,
			"SozialhilfeQuote": 6.2
		},
		{
			"id": 167,
			"Jahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 733,
			"SozialhilfeQuote": 5.6
		},
		{
			"id": 168,
			"Jahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 771,
			"SozialhilfeQuote": 5.8
		},
		{
			"id": 169,
			"Jahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 843,
			"SozialhilfeQuote": 6.4
		},
		{
			"id": 170,
			"Jahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 966,
			"SozialhilfeQuote": 7.3
		},
		{
			"id": 171,
			"Jahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 992,
			"SozialhilfeQuote": 7.2
		},
		{
			"id": 172,
			"Jahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 961,
			"SozialhilfeQuote": 6.9
		},
		{
			"id": 173,
			"Jahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 861,
			"SozialhilfeQuote": 6
		},
		{
			"id": 174,
			"Jahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 713,
			"SozialhilfeQuote": 4.8
		},
		{
			"id": 175,
			"Jahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 614,
			"SozialhilfeQuote": 4.2
		},
		{
			"id": 176,
			"Jahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 542,
			"SozialhilfeQuote": 3.6
		},
		{
			"id": 177,
			"Jahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 539,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 178,
			"Jahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 509,
			"SozialhilfeQuote": 3.3
		},
		{
			"id": 179,
			"Jahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 547,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 180,
			"Jahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Wiedikon",
			"SozialhilfeBeziehende": 523,
			"SozialhilfeQuote": 3.3
		},
		{
			"id": 181,
			"Jahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 471,
			"SozialhilfeQuote": 4.9
		},
		{
			"id": 182,
			"Jahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 436,
			"SozialhilfeQuote": 4.5
		},
		{
			"id": 183,
			"Jahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 422,
			"SozialhilfeQuote": 4.3
		},
		{
			"id": 184,
			"Jahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 515,
			"SozialhilfeQuote": 5.1
		},
		{
			"id": 185,
			"Jahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 584,
			"SozialhilfeQuote": 5.8
		},
		{
			"id": 186,
			"Jahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 593,
			"SozialhilfeQuote": 5.9
		},
		{
			"id": 187,
			"Jahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 604,
			"SozialhilfeQuote": 6.1
		},
		{
			"id": 188,
			"Jahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 559,
			"SozialhilfeQuote": 5.6
		},
		{
			"id": 189,
			"Jahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 556,
			"SozialhilfeQuote": 5.5
		},
		{
			"id": 190,
			"Jahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 474,
			"SozialhilfeQuote": 4.5
		},
		{
			"id": 191,
			"Jahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 463,
			"SozialhilfeQuote": 4.5
		},
		{
			"id": 192,
			"Jahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 470,
			"SozialhilfeQuote": 4.5
		},
		{
			"id": 193,
			"Jahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 466,
			"SozialhilfeQuote": 4.4
		},
		{
			"id": 194,
			"Jahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 475,
			"SozialhilfeQuote": 4.5
		},
		{
			"id": 195,
			"Jahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Friesenberg",
			"SozialhilfeBeziehende": 466,
			"SozialhilfeQuote": 4.4
		},
		{
			"id": 196,
			"Jahr": 2000,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1372,
			"SozialhilfeQuote": 7.4
		},
		{
			"id": 197,
			"Jahr": 2001,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1228,
			"SozialhilfeQuote": 6.6
		},
		{
			"id": 198,
			"Jahr": 2002,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1344,
			"SozialhilfeQuote": 7.1
		},
		{
			"id": 199,
			"Jahr": 2003,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1506,
			"SozialhilfeQuote": 8
		},
		{
			"id": 200,
			"Jahr": 2004,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1716,
			"SozialhilfeQuote": 9.1
		},
		{
			"id": 201,
			"Jahr": 2005,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1808,
			"SozialhilfeQuote": 9.6
		},
		{
			"id": 202,
			"Jahr": 2006,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1634,
			"SozialhilfeQuote": 8.8
		},
		{
			"id": 203,
			"Jahr": 2007,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1496,
			"SozialhilfeQuote": 7.9
		},
		{
			"id": 204,
			"Jahr": 2008,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1391,
			"SozialhilfeQuote": 7.2
		},
		{
			"id": 205,
			"Jahr": 2009,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1335,
			"SozialhilfeQuote": 6.9
		},
		{
			"id": 206,
			"Jahr": 2010,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1163,
			"SozialhilfeQuote": 6.1
		},
		{
			"id": 207,
			"Jahr": 2011,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 1028,
			"SozialhilfeQuote": 5.3
		},
		{
			"id": 208,
			"Jahr": 2012,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 990,
			"SozialhilfeQuote": 5
		},
		{
			"id": 209,
			"Jahr": 2013,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 954,
			"SozialhilfeQuote": 4.8
		},
		{
			"id": 210,
			"Jahr": 2014,
			"KreisSort": "Kreis 3",
			"QuarSort": "Sihlfeld",
			"SozialhilfeBeziehende": 982,
			"SozialhilfeQuote": 4.9
		},
		{
			"id": 226,
			"Jahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 291,
			"SozialhilfeQuote": 8.4
		},
		{
			"id": 227,
			"Jahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 346,
			"SozialhilfeQuote": 10.2
		},
		{
			"id": 228,
			"Jahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 274,
			"SozialhilfeQuote": 8
		},
		{
			"id": 229,
			"Jahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 311,
			"SozialhilfeQuote": 9.3
		},
		{
			"id": 230,
			"Jahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 288,
			"SozialhilfeQuote": 8.6
		},
		{
			"id": 231,
			"Jahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 224,
			"SozialhilfeQuote": 6.5
		},
		{
			"id": 232,
			"Jahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 210,
			"SozialhilfeQuote": 6.1
		},
		{
			"id": 233,
			"Jahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 172,
			"SozialhilfeQuote": 4.8
		},
		{
			"id": 234,
			"Jahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 167,
			"SozialhilfeQuote": 4.5
		},
		{
			"id": 235,
			"Jahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 135,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 236,
			"Jahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 147,
			"SozialhilfeQuote": 3.7
		},
		{
			"id": 237,
			"Jahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 136,
			"SozialhilfeQuote": 3.4
		},
		{
			"id": 238,
			"Jahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 137,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 239,
			"Jahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 146,
			"SozialhilfeQuote": 3.7
		},
		{
			"id": 240,
			"Jahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Werd",
			"SozialhilfeBeziehende": 146,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 241,
			"Jahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 977,
			"SozialhilfeQuote": 11.1
		},
		{
			"id": 242,
			"Jahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 934,
			"SozialhilfeQuote": 10.4
		},
		{
			"id": 243,
			"Jahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 1047,
			"SozialhilfeQuote": 11.5
		},
		{
			"id": 244,
			"Jahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 1163,
			"SozialhilfeQuote": 12.9
		},
		{
			"id": 245,
			"Jahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 1205,
			"SozialhilfeQuote": 13.4
		},
		{
			"id": 246,
			"Jahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 1248,
			"SozialhilfeQuote": 13.7
		},
		{
			"id": 247,
			"Jahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 1257,
			"SozialhilfeQuote": 13.9
		},
		{
			"id": 248,
			"Jahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 1133,
			"SozialhilfeQuote": 12.2
		},
		{
			"id": 249,
			"Jahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 1062,
			"SozialhilfeQuote": 11
		},
		{
			"id": 250,
			"Jahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 1016,
			"SozialhilfeQuote": 10.6
		},
		{
			"id": 251,
			"Jahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 978,
			"SozialhilfeQuote": 10.2
		},
		{
			"id": 252,
			"Jahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 945,
			"SozialhilfeQuote": 9.7
		},
		{
			"id": 253,
			"Jahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 911,
			"SozialhilfeQuote": 9.3
		},
		{
			"id": 254,
			"Jahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 913,
			"SozialhilfeQuote": 9.2
		},
		{
			"id": 255,
			"Jahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Langstrasse",
			"SozialhilfeBeziehende": 876,
			"SozialhilfeQuote": 8.6
		},
		{
			"id": 256,
			"Jahr": 2000,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 1074,
			"SozialhilfeQuote": 9.2
		},
		{
			"id": 257,
			"Jahr": 2001,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 943,
			"SozialhilfeQuote": 8
		},
		{
			"id": 258,
			"Jahr": 2002,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 919,
			"SozialhilfeQuote": 7.8
		},
		{
			"id": 259,
			"Jahr": 2003,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 1094,
			"SozialhilfeQuote": 9.3
		},
		{
			"id": 260,
			"Jahr": 2004,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 1134,
			"SozialhilfeQuote": 9.6
		},
		{
			"id": 261,
			"Jahr": 2005,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 1196,
			"SozialhilfeQuote": 10.3
		},
		{
			"id": 262,
			"Jahr": 2006,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 1174,
			"SozialhilfeQuote": 10.3
		},
		{
			"id": 263,
			"Jahr": 2007,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 1168,
			"SozialhilfeQuote": 9.9
		},
		{
			"id": 264,
			"Jahr": 2008,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 996,
			"SozialhilfeQuote": 8.3
		},
		{
			"id": 265,
			"Jahr": 2009,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 964,
			"SozialhilfeQuote": 8
		},
		{
			"id": 266,
			"Jahr": 2010,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 884,
			"SozialhilfeQuote": 7.3
		},
		{
			"id": 267,
			"Jahr": 2011,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 838,
			"SozialhilfeQuote": 7
		},
		{
			"id": 268,
			"Jahr": 2012,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 838,
			"SozialhilfeQuote": 6.8
		},
		{
			"id": 269,
			"Jahr": 2013,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 836,
			"SozialhilfeQuote": 6.7
		},
		{
			"id": 270,
			"Jahr": 2014,
			"KreisSort": "Kreis 4",
			"QuarSort": "Hard",
			"SozialhilfeBeziehende": 855,
			"SozialhilfeQuote": 6.9
		},
		{
			"id": 286,
			"Jahr": 2000,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 767,
			"SozialhilfeQuote": 9.1
		},
		{
			"id": 287,
			"Jahr": 2001,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 664,
			"SozialhilfeQuote": 7.8
		},
		{
			"id": 288,
			"Jahr": 2002,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 658,
			"SozialhilfeQuote": 7.6
		},
		{
			"id": 289,
			"Jahr": 2003,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 712,
			"SozialhilfeQuote": 8.3
		},
		{
			"id": 290,
			"Jahr": 2004,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 753,
			"SozialhilfeQuote": 8.5
		},
		{
			"id": 291,
			"Jahr": 2005,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 724,
			"SozialhilfeQuote": 8.2
		},
		{
			"id": 292,
			"Jahr": 2006,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 771,
			"SozialhilfeQuote": 8.7
		},
		{
			"id": 293,
			"Jahr": 2007,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 787,
			"SozialhilfeQuote": 8.7
		},
		{
			"id": 294,
			"Jahr": 2008,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 748,
			"SozialhilfeQuote": 8.1
		},
		{
			"id": 295,
			"Jahr": 2009,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 741,
			"SozialhilfeQuote": 8
		},
		{
			"id": 296,
			"Jahr": 2010,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 751,
			"SozialhilfeQuote": 8.1
		},
		{
			"id": 297,
			"Jahr": 2011,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 747,
			"SozialhilfeQuote": 8
		},
		{
			"id": 298,
			"Jahr": 2012,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 691,
			"SozialhilfeQuote": 7.4
		},
		{
			"id": 299,
			"Jahr": 2013,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 658,
			"SozialhilfeQuote": 7.1
		},
		{
			"id": 300,
			"Jahr": 2014,
			"KreisSort": "Kreis 5",
			"QuarSort": "Gewerbeschule",
			"SozialhilfeBeziehende": 617,
			"SozialhilfeQuote": 6.7
		},
		{
			"id": 301,
			"Jahr": 2000,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 119,
			"SozialhilfeQuote": 7
		},
		{
			"id": 302,
			"Jahr": 2001,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 135,
			"SozialhilfeQuote": 7
		},
		{
			"id": 303,
			"Jahr": 2002,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 133,
			"SozialhilfeQuote": 5.9
		},
		{
			"id": 304,
			"Jahr": 2003,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 138,
			"SozialhilfeQuote": 6.1
		},
		{
			"id": 305,
			"Jahr": 2004,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 138,
			"SozialhilfeQuote": 5.7
		},
		{
			"id": 306,
			"Jahr": 2005,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 174,
			"SozialhilfeQuote": 7
		},
		{
			"id": 307,
			"Jahr": 2006,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 148,
			"SozialhilfeQuote": 5.5
		},
		{
			"id": 308,
			"Jahr": 2007,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 126,
			"SozialhilfeQuote": 4.6
		},
		{
			"id": 309,
			"Jahr": 2008,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 103,
			"SozialhilfeQuote": 3.7
		},
		{
			"id": 310,
			"Jahr": 2009,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 111,
			"SozialhilfeQuote": 3.8
		},
		{
			"id": 311,
			"Jahr": 2010,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 103,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 312,
			"Jahr": 2011,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 90,
			"SozialhilfeQuote": 3
		},
		{
			"id": 313,
			"Jahr": 2012,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 103,
			"SozialhilfeQuote": 3.2
		},
		{
			"id": 314,
			"Jahr": 2013,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 114,
			"SozialhilfeQuote": 3
		},
		{
			"id": 315,
			"Jahr": 2014,
			"KreisSort": "Kreis 5",
			"QuarSort": "Escher-Wyss",
			"SozialhilfeBeziehende": 109,
			"SozialhilfeQuote": 2.5
		},
		{
			"id": 331,
			"Jahr": 2000,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 624,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 332,
			"Jahr": 2001,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 593,
			"SozialhilfeQuote": 3.3
		},
		{
			"id": 333,
			"Jahr": 2002,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 701,
			"SozialhilfeQuote": 3.8
		},
		{
			"id": 334,
			"Jahr": 2003,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 617,
			"SozialhilfeQuote": 3.4
		},
		{
			"id": 335,
			"Jahr": 2004,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 771,
			"SozialhilfeQuote": 4.2
		},
		{
			"id": 336,
			"Jahr": 2005,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 748,
			"SozialhilfeQuote": 4.1
		},
		{
			"id": 337,
			"Jahr": 2006,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 766,
			"SozialhilfeQuote": 4.2
		},
		{
			"id": 338,
			"Jahr": 2007,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 756,
			"SozialhilfeQuote": 4
		},
		{
			"id": 339,
			"Jahr": 2008,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 683,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 340,
			"Jahr": 2009,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 643,
			"SozialhilfeQuote": 3.2
		},
		{
			"id": 341,
			"Jahr": 2010,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 602,
			"SozialhilfeQuote": 3
		},
		{
			"id": 342,
			"Jahr": 2011,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 557,
			"SozialhilfeQuote": 2.8
		},
		{
			"id": 343,
			"Jahr": 2012,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 571,
			"SozialhilfeQuote": 2.8
		},
		{
			"id": 344,
			"Jahr": 2013,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 541,
			"SozialhilfeQuote": 2.6
		},
		{
			"id": 345,
			"Jahr": 2014,
			"KreisSort": "Kreis 6",
			"QuarSort": "Unterstrass",
			"SozialhilfeBeziehende": 537,
			"SozialhilfeQuote": 2.6
		},
		{
			"id": 346,
			"Jahr": 2000,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 131,
			"SozialhilfeQuote": 1.5
		},
		{
			"id": 347,
			"Jahr": 2001,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 188,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 348,
			"Jahr": 2002,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 162,
			"SozialhilfeQuote": 1.9
		},
		{
			"id": 349,
			"Jahr": 2003,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 182,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 350,
			"Jahr": 2004,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 182,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 351,
			"Jahr": 2005,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 157,
			"SozialhilfeQuote": 1.9
		},
		{
			"id": 352,
			"Jahr": 2006,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 164,
			"SozialhilfeQuote": 1.9
		},
		{
			"id": 353,
			"Jahr": 2007,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 124,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 354,
			"Jahr": 2008,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 98,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 355,
			"Jahr": 2009,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 85,
			"SozialhilfeQuote": 0.9
		},
		{
			"id": 356,
			"Jahr": 2010,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 77,
			"SozialhilfeQuote": 0.8
		},
		{
			"id": 357,
			"Jahr": 2011,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 94,
			"SozialhilfeQuote": 1
		},
		{
			"id": 358,
			"Jahr": 2012,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 97,
			"SozialhilfeQuote": 1
		},
		{
			"id": 359,
			"Jahr": 2013,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 82,
			"SozialhilfeQuote": 0.8
		},
		{
			"id": 360,
			"Jahr": 2014,
			"KreisSort": "Kreis 6",
			"QuarSort": "Oberstrass",
			"SozialhilfeBeziehende": 97,
			"SozialhilfeQuote": 1
		},
		{
			"id": 376,
			"Jahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 50,
			"SozialhilfeQuote": 0.8
		},
		{
			"id": 377,
			"Jahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 57,
			"SozialhilfeQuote": 0.9
		},
		{
			"id": 378,
			"Jahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 61,
			"SozialhilfeQuote": 0.9
		},
		{
			"id": 379,
			"Jahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 77,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 380,
			"Jahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 97,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 381,
			"Jahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 93,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 382,
			"Jahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 89,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 383,
			"Jahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 67,
			"SozialhilfeQuote": 1
		},
		{
			"id": 384,
			"Jahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 67,
			"SozialhilfeQuote": 0.9
		},
		{
			"id": 385,
			"Jahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 53,
			"SozialhilfeQuote": 0.7
		},
		{
			"id": 386,
			"Jahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 59,
			"SozialhilfeQuote": 0.8
		},
		{
			"id": 387,
			"Jahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 69,
			"SozialhilfeQuote": 0.9
		},
		{
			"id": 388,
			"Jahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 53,
			"SozialhilfeQuote": 0.7
		},
		{
			"id": 389,
			"Jahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 51,
			"SozialhilfeQuote": 0.7
		},
		{
			"id": 390,
			"Jahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Fluntern",
			"SozialhilfeBeziehende": 55,
			"SozialhilfeQuote": 0.7
		},
		{
			"id": 391,
			"Jahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 187,
			"SozialhilfeQuote": 2
		},
		{
			"id": 392,
			"Jahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 171,
			"SozialhilfeQuote": 1.9
		},
		{
			"id": 393,
			"Jahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 143,
			"SozialhilfeQuote": 1.6
		},
		{
			"id": 394,
			"Jahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 157,
			"SozialhilfeQuote": 1.7
		},
		{
			"id": 395,
			"Jahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 164,
			"SozialhilfeQuote": 1.8
		},
		{
			"id": 396,
			"Jahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 137,
			"SozialhilfeQuote": 1.5
		},
		{
			"id": 397,
			"Jahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 144,
			"SozialhilfeQuote": 1.5
		},
		{
			"id": 398,
			"Jahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 127,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 399,
			"Jahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 117,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 400,
			"Jahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 100,
			"SozialhilfeQuote": 1
		},
		{
			"id": 401,
			"Jahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 102,
			"SozialhilfeQuote": 1
		},
		{
			"id": 402,
			"Jahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 108,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 403,
			"Jahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 112,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 404,
			"Jahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 108,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 405,
			"Jahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hottingen",
			"SozialhilfeBeziehende": 107,
			"SozialhilfeQuote": 1
		},
		{
			"id": 406,
			"Jahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 150,
			"SozialhilfeQuote": 2.4
		},
		{
			"id": 407,
			"Jahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 139,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 408,
			"Jahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 137,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 409,
			"Jahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 134,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 410,
			"Jahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 130,
			"SozialhilfeQuote": 2
		},
		{
			"id": 411,
			"Jahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 161,
			"SozialhilfeQuote": 2.5
		},
		{
			"id": 412,
			"Jahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 149,
			"SozialhilfeQuote": 2.3
		},
		{
			"id": 413,
			"Jahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 144,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 414,
			"Jahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 122,
			"SozialhilfeQuote": 1.8
		},
		{
			"id": 415,
			"Jahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 127,
			"SozialhilfeQuote": 1.9
		},
		{
			"id": 416,
			"Jahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 116,
			"SozialhilfeQuote": 1.7
		},
		{
			"id": 417,
			"Jahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 107,
			"SozialhilfeQuote": 1.6
		},
		{
			"id": 418,
			"Jahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 98,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 419,
			"Jahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 100,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 420,
			"Jahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Hirslanden",
			"SozialhilfeBeziehende": 100,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 421,
			"Jahr": 2000,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 114,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 422,
			"Jahr": 2001,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 110,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 423,
			"Jahr": 2002,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 118,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 424,
			"Jahr": 2003,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 122,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 425,
			"Jahr": 2004,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 126,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 426,
			"Jahr": 2005,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 158,
			"SozialhilfeQuote": 1.6
		},
		{
			"id": 427,
			"Jahr": 2006,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 137,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 428,
			"Jahr": 2007,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 130,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 429,
			"Jahr": 2008,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 107,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 430,
			"Jahr": 2009,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 118,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 431,
			"Jahr": 2010,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 132,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 432,
			"Jahr": 2011,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 123,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 433,
			"Jahr": 2012,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 135,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 434,
			"Jahr": 2013,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 150,
			"SozialhilfeQuote": 1.5
		},
		{
			"id": 435,
			"Jahr": 2014,
			"KreisSort": "Kreis 7",
			"QuarSort": "Witikon",
			"SozialhilfeBeziehende": 163,
			"SozialhilfeQuote": 1.6
		},
		{
			"id": 451,
			"Jahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 104,
			"SozialhilfeQuote": 2.3
		},
		{
			"id": 452,
			"Jahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 97,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 453,
			"Jahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 126,
			"SozialhilfeQuote": 2.7
		},
		{
			"id": 454,
			"Jahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 126,
			"SozialhilfeQuote": 2.8
		},
		{
			"id": 455,
			"Jahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 137,
			"SozialhilfeQuote": 3
		},
		{
			"id": 456,
			"Jahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 139,
			"SozialhilfeQuote": 3.1
		},
		{
			"id": 457,
			"Jahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 92,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 458,
			"Jahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 94,
			"SozialhilfeQuote": 2.1
		},
		{
			"id": 459,
			"Jahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 85,
			"SozialhilfeQuote": 1.9
		},
		{
			"id": 460,
			"Jahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 66,
			"SozialhilfeQuote": 1.5
		},
		{
			"id": 461,
			"Jahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 49,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 462,
			"Jahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 64,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 463,
			"Jahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 54,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 464,
			"Jahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 68,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 465,
			"Jahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Seefeld",
			"SozialhilfeBeziehende": 58,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 466,
			"Jahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 113,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 467,
			"Jahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 120,
			"SozialhilfeQuote": 2.4
		},
		{
			"id": 468,
			"Jahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 112,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 469,
			"Jahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 116,
			"SozialhilfeQuote": 2.3
		},
		{
			"id": 470,
			"Jahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 118,
			"SozialhilfeQuote": 2.3
		},
		{
			"id": 471,
			"Jahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 123,
			"SozialhilfeQuote": 2.4
		},
		{
			"id": 472,
			"Jahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 119,
			"SozialhilfeQuote": 2.4
		},
		{
			"id": 473,
			"Jahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 118,
			"SozialhilfeQuote": 2.3
		},
		{
			"id": 474,
			"Jahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 91,
			"SozialhilfeQuote": 1.8
		},
		{
			"id": 475,
			"Jahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 92,
			"SozialhilfeQuote": 1.8
		},
		{
			"id": 476,
			"Jahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 90,
			"SozialhilfeQuote": 1.7
		},
		{
			"id": 477,
			"Jahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 118,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 478,
			"Jahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 106,
			"SozialhilfeQuote": 2
		},
		{
			"id": 479,
			"Jahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 108,
			"SozialhilfeQuote": 1.9
		},
		{
			"id": 480,
			"Jahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Mühlebach",
			"SozialhilfeBeziehende": 117,
			"SozialhilfeQuote": 2
		},
		{
			"id": 481,
			"Jahr": 2000,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 73,
			"SozialhilfeQuote": 1.7
		},
		{
			"id": 482,
			"Jahr": 2001,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 55,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 483,
			"Jahr": 2002,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 46,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 484,
			"Jahr": 2003,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 61,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 485,
			"Jahr": 2004,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 80,
			"SozialhilfeQuote": 1.8
		},
		{
			"id": 486,
			"Jahr": 2005,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 86,
			"SozialhilfeQuote": 1.9
		},
		{
			"id": 487,
			"Jahr": 2006,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 70,
			"SozialhilfeQuote": 1.6
		},
		{
			"id": 488,
			"Jahr": 2007,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 60,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 489,
			"Jahr": 2008,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 54,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 490,
			"Jahr": 2009,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 61,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 491,
			"Jahr": 2010,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 54,
			"SozialhilfeQuote": 1.2
		},
		{
			"id": 492,
			"Jahr": 2011,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 49,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 493,
			"Jahr": 2012,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 52,
			"SozialhilfeQuote": 1.1
		},
		{
			"id": 494,
			"Jahr": 2013,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 63,
			"SozialhilfeQuote": 1.3
		},
		{
			"id": 495,
			"Jahr": 2014,
			"KreisSort": "Kreis 8",
			"QuarSort": "Weinegg",
			"SozialhilfeBeziehende": 67,
			"SozialhilfeQuote": 1.4
		},
		{
			"id": 511,
			"Jahr": 2000,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 633,
			"SozialhilfeQuote": 4
		},
		{
			"id": 512,
			"Jahr": 2001,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 578,
			"SozialhilfeQuote": 3.7
		},
		{
			"id": 513,
			"Jahr": 2002,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 649,
			"SozialhilfeQuote": 4.1
		},
		{
			"id": 514,
			"Jahr": 2003,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 690,
			"SozialhilfeQuote": 4.2
		},
		{
			"id": 515,
			"Jahr": 2004,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 812,
			"SozialhilfeQuote": 5
		},
		{
			"id": 516,
			"Jahr": 2005,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 939,
			"SozialhilfeQuote": 5.7
		},
		{
			"id": 517,
			"Jahr": 2006,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 926,
			"SozialhilfeQuote": 5.6
		},
		{
			"id": 518,
			"Jahr": 2007,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 826,
			"SozialhilfeQuote": 4.9
		},
		{
			"id": 519,
			"Jahr": 2008,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 739,
			"SozialhilfeQuote": 4.3
		},
		{
			"id": 520,
			"Jahr": 2009,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 718,
			"SozialhilfeQuote": 4.1
		},
		{
			"id": 521,
			"Jahr": 2010,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 678,
			"SozialhilfeQuote": 3.9
		},
		{
			"id": 522,
			"Jahr": 2011,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 680,
			"SozialhilfeQuote": 3.8
		},
		{
			"id": 523,
			"Jahr": 2012,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 711,
			"SozialhilfeQuote": 3.8
		},
		{
			"id": 524,
			"Jahr": 2013,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 712,
			"SozialhilfeQuote": 3.8
		},
		{
			"id": 525,
			"Jahr": 2014,
			"KreisSort": "Kreis 9",
			"QuarSort": "Albisrieden",
			"SozialhilfeBeziehende": 672,
			"SozialhilfeQuote": 3.6
		},
		{
			"id": 526,
			"Jahr": 2000,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1707,
			"SozialhilfeQuote": 6.3
		},
		{
			"id": 527,
			"Jahr": 2001,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1676,
			"SozialhilfeQuote": 6.1
		},
		{
			"id": 528,
			"Jahr": 2002,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1724,
			"SozialhilfeQuote": 6.3
		},
		{
			"id": 529,
			"Jahr": 2003,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1833,
			"SozialhilfeQuote": 6.8
		},
		{
			"id": 530,
			"Jahr": 2004,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 2012,
			"SozialhilfeQuote": 7.4
		},
		{
			"id": 531,
			"Jahr": 2005,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 2164,
			"SozialhilfeQuote": 8
		},
		{
			"id": 532,
			"Jahr": 2006,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 2179,
			"SozialhilfeQuote": 7.9
		},
		{
			"id": 533,
			"Jahr": 2007,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 2022,
			"SozialhilfeQuote": 7.2
		},
		{
			"id": 534,
			"Jahr": 2008,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1913,
			"SozialhilfeQuote": 6.7
		},
		{
			"id": 535,
			"Jahr": 2009,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1853,
			"SozialhilfeQuote": 6.5
		},
		{
			"id": 536,
			"Jahr": 2010,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1823,
			"SozialhilfeQuote": 6.2
		},
		{
			"id": 537,
			"Jahr": 2011,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1800,
			"SozialhilfeQuote": 6
		},
		{
			"id": 538,
			"Jahr": 2012,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1743,
			"SozialhilfeQuote": 5.8
		},
		{
			"id": 539,
			"Jahr": 2013,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1679,
			"SozialhilfeQuote": 5.6
		},
		{
			"id": 540,
			"Jahr": 2014,
			"KreisSort": "Kreis 9",
			"QuarSort": "Altstetten",
			"SozialhilfeBeziehende": 1598,
			"SozialhilfeQuote": 5.3
		},
		{
			"id": 556,
			"Jahr": 2000,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 534,
			"SozialhilfeQuote": 2.7
		},
		{
			"id": 557,
			"Jahr": 2001,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 476,
			"SozialhilfeQuote": 2.4
		},
		{
			"id": 558,
			"Jahr": 2002,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 548,
			"SozialhilfeQuote": 2.8
		},
		{
			"id": 559,
			"Jahr": 2003,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 576,
			"SozialhilfeQuote": 2.9
		},
		{
			"id": 560,
			"Jahr": 2004,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 680,
			"SozialhilfeQuote": 3.4
		},
		{
			"id": 561,
			"Jahr": 2005,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 720,
			"SozialhilfeQuote": 3.6
		},
		{
			"id": 562,
			"Jahr": 2006,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 712,
			"SozialhilfeQuote": 3.5
		},
		{
			"id": 563,
			"Jahr": 2007,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 639,
			"SozialhilfeQuote": 3.1
		},
		{
			"id": 564,
			"Jahr": 2008,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 514,
			"SozialhilfeQuote": 2.5
		},
		{
			"id": 565,
			"Jahr": 2009,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 504,
			"SozialhilfeQuote": 2.4
		},
		{
			"id": 566,
			"Jahr": 2010,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 463,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 567,
			"Jahr": 2011,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 419,
			"SozialhilfeQuote": 2
		},
		{
			"id": 568,
			"Jahr": 2012,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 453,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 569,
			"Jahr": 2013,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 472,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 570,
			"Jahr": 2014,
			"KreisSort": "Kreis 10",
			"QuarSort": "Höngg",
			"SozialhilfeBeziehende": 461,
			"SozialhilfeQuote": 2.2
		},
		{
			"id": 571,
			"Jahr": 2000,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 826,
			"SozialhilfeQuote": 6
		},
		{
			"id": 572,
			"Jahr": 2001,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 704,
			"SozialhilfeQuote": 5.1
		},
		{
			"id": 573,
			"Jahr": 2002,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 732,
			"SozialhilfeQuote": 5.3
		},
		{
			"id": 574,
			"Jahr": 2003,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 877,
			"SozialhilfeQuote": 6.1
		},
		{
			"id": 575,
			"Jahr": 2004,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 998,
			"SozialhilfeQuote": 7
		},
		{
			"id": 576,
			"Jahr": 2005,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 970,
			"SozialhilfeQuote": 6.8
		},
		{
			"id": 577,
			"Jahr": 2006,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 904,
			"SozialhilfeQuote": 6.4
		},
		{
			"id": 578,
			"Jahr": 2007,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 757,
			"SozialhilfeQuote": 5.3
		},
		{
			"id": 579,
			"Jahr": 2008,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 736,
			"SozialhilfeQuote": 5
		},
		{
			"id": 580,
			"Jahr": 2009,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 705,
			"SozialhilfeQuote": 4.8
		},
		{
			"id": 581,
			"Jahr": 2010,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 711,
			"SozialhilfeQuote": 4.7
		},
		{
			"id": 582,
			"Jahr": 2011,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 678,
			"SozialhilfeQuote": 4.5
		},
		{
			"id": 583,
			"Jahr": 2012,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 629,
			"SozialhilfeQuote": 4.2
		},
		{
			"id": 584,
			"Jahr": 2013,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 638,
			"SozialhilfeQuote": 4.2
		},
		{
			"id": 585,
			"Jahr": 2014,
			"KreisSort": "Kreis 10",
			"QuarSort": "Wipkingen",
			"SozialhilfeBeziehende": 640,
			"SozialhilfeQuote": 4.3
		},
		{
			"id": 601,
			"Jahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 847,
			"SozialhilfeQuote": 4.8
		},
		{
			"id": 602,
			"Jahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 779,
			"SozialhilfeQuote": 4.4
		},
		{
			"id": 603,
			"Jahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 811,
			"SozialhilfeQuote": 4.6
		},
		{
			"id": 604,
			"Jahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1030,
			"SozialhilfeQuote": 5.8
		},
		{
			"id": 605,
			"Jahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1171,
			"SozialhilfeQuote": 6.6
		},
		{
			"id": 606,
			"Jahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1266,
			"SozialhilfeQuote": 7.1
		},
		{
			"id": 607,
			"Jahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1292,
			"SozialhilfeQuote": 7.3
		},
		{
			"id": 608,
			"Jahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1397,
			"SozialhilfeQuote": 7
		},
		{
			"id": 609,
			"Jahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1311,
			"SozialhilfeQuote": 6.2
		},
		{
			"id": 610,
			"Jahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1194,
			"SozialhilfeQuote": 5.6
		},
		{
			"id": 611,
			"Jahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1162,
			"SozialhilfeQuote": 5.3
		},
		{
			"id": 612,
			"Jahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1212,
			"SozialhilfeQuote": 5.2
		},
		{
			"id": 613,
			"Jahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1196,
			"SozialhilfeQuote": 5
		},
		{
			"id": 614,
			"Jahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1208,
			"SozialhilfeQuote": 5.1
		},
		{
			"id": 615,
			"Jahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Affoltern",
			"SozialhilfeBeziehende": 1256,
			"SozialhilfeQuote": 5.1
		},
		{
			"id": 616,
			"Jahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 858,
			"SozialhilfeQuote": 5.5
		},
		{
			"id": 617,
			"Jahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 791,
			"SozialhilfeQuote": 4.9
		},
		{
			"id": 618,
			"Jahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 768,
			"SozialhilfeQuote": 4.7
		},
		{
			"id": 619,
			"Jahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 940,
			"SozialhilfeQuote": 5.6
		},
		{
			"id": 620,
			"Jahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1098,
			"SozialhilfeQuote": 6.4
		},
		{
			"id": 621,
			"Jahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1186,
			"SozialhilfeQuote": 6.8
		},
		{
			"id": 622,
			"Jahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1250,
			"SozialhilfeQuote": 6.9
		},
		{
			"id": 623,
			"Jahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1207,
			"SozialhilfeQuote": 6.5
		},
		{
			"id": 624,
			"Jahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1143,
			"SozialhilfeQuote": 6.1
		},
		{
			"id": 625,
			"Jahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1123,
			"SozialhilfeQuote": 5.9
		},
		{
			"id": 626,
			"Jahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1072,
			"SozialhilfeQuote": 5.6
		},
		{
			"id": 627,
			"Jahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1050,
			"SozialhilfeQuote": 5.4
		},
		{
			"id": 628,
			"Jahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1028,
			"SozialhilfeQuote": 5.3
		},
		{
			"id": 629,
			"Jahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1024,
			"SozialhilfeQuote": 5.2
		},
		{
			"id": 630,
			"Jahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Oerlikon",
			"SozialhilfeBeziehende": 1094,
			"SozialhilfeQuote": 5.5
		},
		{
			"id": 631,
			"Jahr": 2000,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1247,
			"SozialhilfeQuote": 7.5
		},
		{
			"id": 632,
			"Jahr": 2001,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1111,
			"SozialhilfeQuote": 6.6
		},
		{
			"id": 633,
			"Jahr": 2002,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1145,
			"SozialhilfeQuote": 6.5
		},
		{
			"id": 634,
			"Jahr": 2003,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1415,
			"SozialhilfeQuote": 7.8
		},
		{
			"id": 635,
			"Jahr": 2004,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1660,
			"SozialhilfeQuote": 9.1
		},
		{
			"id": 636,
			"Jahr": 2005,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1813,
			"SozialhilfeQuote": 9.8
		},
		{
			"id": 637,
			"Jahr": 2006,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1840,
			"SozialhilfeQuote": 9.7
		},
		{
			"id": 638,
			"Jahr": 2007,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1813,
			"SozialhilfeQuote": 9.2
		},
		{
			"id": 639,
			"Jahr": 2008,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1624,
			"SozialhilfeQuote": 8.2
		},
		{
			"id": 640,
			"Jahr": 2009,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1523,
			"SozialhilfeQuote": 7.6
		},
		{
			"id": 641,
			"Jahr": 2010,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1532,
			"SozialhilfeQuote": 7.5
		},
		{
			"id": 642,
			"Jahr": 2011,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1474,
			"SozialhilfeQuote": 7.1
		},
		{
			"id": 643,
			"Jahr": 2012,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1397,
			"SozialhilfeQuote": 6.4
		},
		{
			"id": 644,
			"Jahr": 2013,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1327,
			"SozialhilfeQuote": 5.9
		},
		{
			"id": 645,
			"Jahr": 2014,
			"KreisSort": "Kreis 11",
			"QuarSort": "Seebach",
			"SozialhilfeBeziehende": 1365,
			"SozialhilfeQuote": 6
		},
		{
			"id": 661,
			"Jahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 473,
			"SozialhilfeQuote": 7.6
		},
		{
			"id": 662,
			"Jahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 386,
			"SozialhilfeQuote": 6.2
		},
		{
			"id": 663,
			"Jahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 444,
			"SozialhilfeQuote": 6.8
		},
		{
			"id": 664,
			"Jahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 478,
			"SozialhilfeQuote": 7.5
		},
		{
			"id": 665,
			"Jahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 595,
			"SozialhilfeQuote": 9.2
		},
		{
			"id": 666,
			"Jahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 782,
			"SozialhilfeQuote": 12
		},
		{
			"id": 667,
			"Jahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 777,
			"SozialhilfeQuote": 12
		},
		{
			"id": 668,
			"Jahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 692,
			"SozialhilfeQuote": 10.5
		},
		{
			"id": 669,
			"Jahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 697,
			"SozialhilfeQuote": 10.4
		},
		{
			"id": 670,
			"Jahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 622,
			"SozialhilfeQuote": 9
		},
		{
			"id": 671,
			"Jahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 588,
			"SozialhilfeQuote": 8.4
		},
		{
			"id": 672,
			"Jahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 613,
			"SozialhilfeQuote": 8.9
		},
		{
			"id": 673,
			"Jahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 591,
			"SozialhilfeQuote": 8.6
		},
		{
			"id": 674,
			"Jahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 591,
			"SozialhilfeQuote": 8.5
		},
		{
			"id": 675,
			"Jahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Saatlen",
			"SozialhilfeBeziehende": 628,
			"SozialhilfeQuote": 8.7
		},
		{
			"id": 676,
			"Jahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 736,
			"SozialhilfeQuote": 7.5
		},
		{
			"id": 677,
			"Jahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 662,
			"SozialhilfeQuote": 6.8
		},
		{
			"id": 678,
			"Jahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 658,
			"SozialhilfeQuote": 6.8
		},
		{
			"id": 679,
			"Jahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 768,
			"SozialhilfeQuote": 8
		},
		{
			"id": 680,
			"Jahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 883,
			"SozialhilfeQuote": 9.2
		},
		{
			"id": 681,
			"Jahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 1003,
			"SozialhilfeQuote": 10.4
		},
		{
			"id": 682,
			"Jahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 1140,
			"SozialhilfeQuote": 11.6
		},
		{
			"id": 683,
			"Jahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 1147,
			"SozialhilfeQuote": 11.5
		},
		{
			"id": 684,
			"Jahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 1034,
			"SozialhilfeQuote": 10.3
		},
		{
			"id": 685,
			"Jahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 992,
			"SozialhilfeQuote": 9.8
		},
		{
			"id": 686,
			"Jahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 943,
			"SozialhilfeQuote": 9.2
		},
		{
			"id": 687,
			"Jahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 896,
			"SozialhilfeQuote": 8.8
		},
		{
			"id": 688,
			"Jahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 902,
			"SozialhilfeQuote": 8.8
		},
		{
			"id": 689,
			"Jahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 919,
			"SozialhilfeQuote": 8.8
		},
		{
			"id": 690,
			"Jahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Schwamendingen-Mitte",
			"SozialhilfeBeziehende": 895,
			"SozialhilfeQuote": 8.5
		},
		{
			"id": 691,
			"Jahr": 2000,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 616,
			"SozialhilfeQuote": 5.7
		},
		{
			"id": 692,
			"Jahr": 2001,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 543,
			"SozialhilfeQuote": 5
		},
		{
			"id": 693,
			"Jahr": 2002,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 608,
			"SozialhilfeQuote": 5.5
		},
		{
			"id": 694,
			"Jahr": 2003,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 740,
			"SozialhilfeQuote": 6.8
		},
		{
			"id": 695,
			"Jahr": 2004,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 877,
			"SozialhilfeQuote": 8.1
		},
		{
			"id": 696,
			"Jahr": 2005,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 1057,
			"SozialhilfeQuote": 9.8
		},
		{
			"id": 697,
			"Jahr": 2006,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 1046,
			"SozialhilfeQuote": 9.9
		},
		{
			"id": 698,
			"Jahr": 2007,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 967,
			"SozialhilfeQuote": 9
		},
		{
			"id": 699,
			"Jahr": 2008,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 905,
			"SozialhilfeQuote": 8.3
		},
		{
			"id": 700,
			"Jahr": 2009,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 860,
			"SozialhilfeQuote": 7.7
		},
		{
			"id": 701,
			"Jahr": 2010,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 872,
			"SozialhilfeQuote": 8
		},
		{
			"id": 702,
			"Jahr": 2011,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 930,
			"SozialhilfeQuote": 8.4
		},
		{
			"id": 703,
			"Jahr": 2012,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 926,
			"SozialhilfeQuote": 8.5
		},
		{
			"id": 704,
			"Jahr": 2013,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 908,
			"SozialhilfeQuote": 8.5
		},
		{
			"id": 705,
			"Jahr": 2014,
			"KreisSort": "Kreis 12",
			"QuarSort": "Hirzenbach",
			"SozialhilfeBeziehende": 856,
			"SozialhilfeQuote": 7.7
		}
	];

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.2.0 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var baseCopy = __webpack_require__(260),
	    keys = __webpack_require__(100);
	
	/**
	 * The base implementation of `_.assign` without support for argument juggling,
	 * multiple sources, and `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return source == null
	    ? object
	    : baseCopy(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 260 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property names to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @returns {Object} Returns `object`.
	 */
	function baseCopy(source, props, object) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	    object[key] = source[key];
	  }
	  return object;
	}
	
	module.exports = baseCopy;


/***/ },
/* 261 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/**
	 * A specialized version of `baseCallback` which only supports `this` binding
	 * and specifying the number of arguments to provide to `func`.
	 *
	 * @private
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {number} [argCount] The number of arguments to provide to `func`.
	 * @returns {Function} Returns the callback.
	 */
	function bindCallback(func, thisArg, argCount) {
	  if (typeof func != 'function') {
	    return identity;
	  }
	  if (thisArg === undefined) {
	    return func;
	  }
	  switch (argCount) {
	    case 1: return function(value) {
	      return func.call(thisArg, value);
	    };
	    case 3: return function(value, index, collection) {
	      return func.call(thisArg, value, index, collection);
	    };
	    case 4: return function(accumulator, value, index, collection) {
	      return func.call(thisArg, accumulator, value, index, collection);
	    };
	    case 5: return function(value, other, key, object, source) {
	      return func.call(thisArg, value, other, key, object, source);
	    };
	  }
	  return function() {
	    return func.apply(thisArg, arguments);
	  };
	}
	
	/**
	 * This method returns the first argument provided to it.
	 *
	 * @static
	 * @memberOf _
	 * @category Utility
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * _.identity(object) === object;
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = bindCallback;


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var bindCallback = __webpack_require__(261),
	    isIterateeCall = __webpack_require__(264),
	    restParam = __webpack_require__(267);
	
	/**
	 * Creates a function that assigns properties of source object(s) to a given
	 * destination object.
	 *
	 * **Note:** This function is used to create `_.assign`, `_.defaults`, and `_.merge`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return restParam(function(object, sources) {
	    var index = -1,
	        length = object == null ? 0 : sources.length,
	        customizer = length > 2 ? sources[length - 2] : undefined,
	        guard = length > 2 ? sources[2] : undefined,
	        thisArg = length > 1 ? sources[length - 1] : undefined;
	
	    if (typeof customizer == 'function') {
	      customizer = bindCallback(customizer, thisArg, 5);
	      length -= 2;
	    } else {
	      customizer = typeof thisArg == 'function' ? thisArg : undefined;
	      length -= (customizer ? 1 : 0);
	    }
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 263 */
/***/ function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ },
/* 264 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.9 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/**
	 * Used as the [maximum length](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if the provided arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call, else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	      ? (isArrayLike(object) && isIndex(index, object.length))
	      : (type == 'string' && index in object)) {
	    var other = object[index];
	    return value === value ? (value === other) : (other !== other);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](https://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 265 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ },
/* 266 */
/***/ function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ },
/* 267 */
/***/ function(module, exports) {

	/**
	 * lodash 3.6.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as an array.
	 *
	 * **Note:** This method is based on the [rest parameter](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.restParam(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function restParam(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : (+start || 0), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        rest = Array(length);
	
	    while (++index < length) {
	      rest[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, rest);
	      case 1: return func.call(this, args[0], rest);
	      case 2: return func.call(this, args[0], args[1], rest);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = rest;
	    return func.apply(this, otherArgs);
	  };
	}
	
	module.exports = restParam;


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(269);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 269 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 270 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(288);
	
	var _arrays = __webpack_require__(362);
	
	var _arrays2 = _interopRequireDefault(_arrays);
	
	var _redux = __webpack_require__(101);
	
	var _reactAutowhatever = __webpack_require__(278);
	
	var _reactAutowhatever2 = _interopRequireDefault(_reactAutowhatever);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var mapStateToProps = function mapStateToProps(state) {
	  return {
	    isFocused: state.isFocused,
	    isCollapsed: state.isCollapsed,
	    focusedSectionIndex: state.focusedSectionIndex,
	    focusedSuggestionIndex: state.focusedSuggestionIndex,
	    valueBeforeUpDown: state.valueBeforeUpDown
	  };
	};
	
	var Autosuggest = function (_Component) {
	  _inherits(Autosuggest, _Component);
	
	  function Autosuggest() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Autosuggest);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Autosuggest.__proto__ || Object.getPrototypeOf(Autosuggest)).call.apply(_ref, [this].concat(args))), _this), _this.onDocumentMouseDown = function (event) {
	      _this.justClickedOnSuggestionsContainer = false;
	
	      var node = event.detail && event.detail.target || // This is for testing only. Please show me a better way to emulate this.
	      event.target;
	
	      do {
	        if (node.getAttribute('data-suggestion-index') !== null) {
	          // Suggestion was clicked
	          return;
	        }
	
	        if (node === _this.suggestionsContainer) {
	          // Something else inside suggestions container was clicked
	          _this.justClickedOnSuggestionsContainer = true;
	          return;
	        }
	
	        node = node.parentNode;
	      } while (node !== null && node !== document);
	    }, _this.storeReferences = function (autowhatever) {
	      if (autowhatever !== null) {
	        var input = autowhatever.input;
	
	
	        _this.input = input;
	        _this.props.inputRef(input);
	
	        _this.suggestionsContainer = autowhatever.itemsContainer;
	      }
	    }, _this.onSuggestionMouseEnter = function (event, _ref2) {
	      var sectionIndex = _ref2.sectionIndex;
	      var itemIndex = _ref2.itemIndex;
	
	      _this.props.updateFocusedSuggestion(sectionIndex, itemIndex);
	    }, _this.focusFirstSuggestion = function () {
	      _this.props.updateFocusedSuggestion(_this.props.multiSection ? 0 : null, 0);
	    }, _this.onSuggestionMouseDown = function () {
	      _this.justSelectedSuggestion = true;
	    }, _this.onSuggestionsClearRequested = function () {
	      var onSuggestionsClearRequested = _this.props.onSuggestionsClearRequested;
	
	
	      onSuggestionsClearRequested && onSuggestionsClearRequested();
	    }, _this.onSuggestionSelected = function (event, data) {
	      var _this$props = _this.props;
	      var alwaysRenderSuggestions = _this$props.alwaysRenderSuggestions;
	      var onSuggestionSelected = _this$props.onSuggestionSelected;
	      var onSuggestionsFetchRequested = _this$props.onSuggestionsFetchRequested;
	      var resetFocusedSuggestion = _this$props.resetFocusedSuggestion;
	
	
	      onSuggestionSelected && onSuggestionSelected(event, data);
	
	      if (alwaysRenderSuggestions) {
	        onSuggestionsFetchRequested({ value: data.suggestionValue });
	      } else {
	        _this.onSuggestionsClearRequested();
	      }
	
	      resetFocusedSuggestion();
	    }, _this.onSuggestionClick = function (event) {
	      var _this$props2 = _this.props;
	      var alwaysRenderSuggestions = _this$props2.alwaysRenderSuggestions;
	      var focusInputOnSuggestionClick = _this$props2.focusInputOnSuggestionClick;
	      var closeSuggestions = _this$props2.closeSuggestions;
	
	      var _this$getSuggestionIn = _this.getSuggestionIndices(_this.findSuggestionElement(event.target));
	
	      var sectionIndex = _this$getSuggestionIn.sectionIndex;
	      var suggestionIndex = _this$getSuggestionIn.suggestionIndex;
	
	      var clickedSuggestion = _this.getSuggestion(sectionIndex, suggestionIndex);
	      var clickedSuggestionValue = _this.props.getSuggestionValue(clickedSuggestion);
	
	      _this.maybeCallOnChange(event, clickedSuggestionValue, 'click');
	      _this.onSuggestionSelected(event, {
	        suggestion: clickedSuggestion,
	        suggestionValue: clickedSuggestionValue,
	        sectionIndex: sectionIndex,
	        method: 'click'
	      });
	
	      if (!alwaysRenderSuggestions) {
	        closeSuggestions();
	      }
	
	      if (focusInputOnSuggestionClick === true) {
	        _this.input.focus();
	      } else {
	        _this.onBlur();
	      }
	
	      setTimeout(function () {
	        _this.justSelectedSuggestion = false;
	      });
	    }, _this.onBlur = function () {
	      var _this$props3 = _this.props;
	      var inputProps = _this$props3.inputProps;
	      var shouldRenderSuggestions = _this$props3.shouldRenderSuggestions;
	      var inputBlurred = _this$props3.inputBlurred;
	      var value = inputProps.value;
	      var onBlur = inputProps.onBlur;
	
	      var focusedSuggestion = _this.getFocusedSuggestion();
	
	      inputBlurred(shouldRenderSuggestions(value));
	      onBlur && onBlur(_this.blurEvent, { focusedSuggestion: focusedSuggestion });
	    }, _this.resetFocusedSuggestionOnMouseLeave = function () {
	      _this.props.resetFocusedSuggestion(false);
	    }, _this.itemProps = function (_ref3) {
	      var sectionIndex = _ref3.sectionIndex;
	      var itemIndex = _ref3.itemIndex;
	
	      return {
	        'data-section-index': sectionIndex,
	        'data-suggestion-index': itemIndex,
	        onMouseEnter: _this.onSuggestionMouseEnter,
	        onMouseLeave: _this.resetFocusedSuggestionOnMouseLeave,
	        onMouseDown: _this.onSuggestionMouseDown,
	        onTouchStart: _this.onSuggestionMouseDown, // Because on iOS `onMouseDown` is not triggered
	        onClick: _this.onSuggestionClick
	      };
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Autosuggest, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      document.addEventListener('mousedown', this.onDocumentMouseDown);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((0, _arrays2.default)(nextProps.suggestions, this.props.suggestions)) {
	        if (nextProps.focusFirstSuggestion && nextProps.suggestions.length > 0 && nextProps.focusedSuggestionIndex === null && nextProps.inputProps.value !== this.props.inputProps.value && nextProps.valueBeforeUpDown === this.props.valueBeforeUpDown) {
	          this.focusFirstSuggestion();
	        }
	      } else {
	        if (this.willRenderSuggestions(nextProps)) {
	          if (nextProps.focusFirstSuggestion) {
	            this.focusFirstSuggestion();
	          }
	
	          var isCollapsed = nextProps.isCollapsed;
	          var revealSuggestions = nextProps.revealSuggestions;
	
	
	          if (isCollapsed && !this.justSelectedSuggestion) {
	            revealSuggestions();
	          }
	        } else {
	          nextProps.resetFocusedSuggestion();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      document.removeEventListener('mousedown', this.onDocumentMouseDown);
	    }
	  }, {
	    key: 'getSuggestion',
	    value: function getSuggestion(sectionIndex, suggestionIndex) {
	      var _props = this.props;
	      var suggestions = _props.suggestions;
	      var multiSection = _props.multiSection;
	      var getSectionSuggestions = _props.getSectionSuggestions;
	
	
	      if (multiSection) {
	        return getSectionSuggestions(suggestions[sectionIndex])[suggestionIndex];
	      }
	
	      return suggestions[suggestionIndex];
	    }
	  }, {
	    key: 'getFocusedSuggestion',
	    value: function getFocusedSuggestion() {
	      var _props2 = this.props;
	      var focusedSectionIndex = _props2.focusedSectionIndex;
	      var focusedSuggestionIndex = _props2.focusedSuggestionIndex;
	
	
	      if (focusedSuggestionIndex === null) {
	        return null;
	      }
	
	      return this.getSuggestion(focusedSectionIndex, focusedSuggestionIndex);
	    }
	  }, {
	    key: 'getSuggestionValueByIndex',
	    value: function getSuggestionValueByIndex(sectionIndex, suggestionIndex) {
	      var getSuggestionValue = this.props.getSuggestionValue;
	
	
	      return getSuggestionValue(this.getSuggestion(sectionIndex, suggestionIndex));
	    }
	  }, {
	    key: 'getSuggestionIndices',
	    value: function getSuggestionIndices(suggestionElement) {
	      var sectionIndex = suggestionElement.getAttribute('data-section-index');
	      var suggestionIndex = suggestionElement.getAttribute('data-suggestion-index');
	
	      return {
	        sectionIndex: typeof sectionIndex === 'string' ? parseInt(sectionIndex, 10) : null,
	        suggestionIndex: parseInt(suggestionIndex, 10)
	      };
	    }
	  }, {
	    key: 'findSuggestionElement',
	    value: function findSuggestionElement(startNode) {
	      var node = startNode;
	
	      do {
	        if (node.getAttribute('data-suggestion-index') !== null) {
	          return node;
	        }
	
	        node = node.parentNode;
	      } while (node !== null);
	
	      console.error('Clicked element:', startNode); // eslint-disable-line no-console
	      throw new Error('Couldn\'t find suggestion element');
	    }
	  }, {
	    key: 'maybeCallOnChange',
	    value: function maybeCallOnChange(event, newValue, method) {
	      var _props$inputProps = this.props.inputProps;
	      var value = _props$inputProps.value;
	      var onChange = _props$inputProps.onChange;
	
	
	      if (newValue !== value) {
	        onChange(event, { newValue: newValue, method: method });
	      }
	    }
	  }, {
	    key: 'willRenderSuggestions',
	    value: function willRenderSuggestions(props) {
	      var suggestions = props.suggestions;
	      var inputProps = props.inputProps;
	      var shouldRenderSuggestions = props.shouldRenderSuggestions;
	      var value = inputProps.value;
	
	
	      return suggestions.length > 0 && shouldRenderSuggestions(value);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props;
	      var suggestions = _props3.suggestions;
	      var renderInputComponent = _props3.renderInputComponent;
	      var renderSuggestionsContainer = _props3.renderSuggestionsContainer;
	      var onSuggestionsFetchRequested = _props3.onSuggestionsFetchRequested;
	      var renderSuggestion = _props3.renderSuggestion;
	      var inputProps = _props3.inputProps;
	      var shouldRenderSuggestions = _props3.shouldRenderSuggestions;
	      var multiSection = _props3.multiSection;
	      var renderSectionTitle = _props3.renderSectionTitle;
	      var id = _props3.id;
	      var getSectionSuggestions = _props3.getSectionSuggestions;
	      var theme = _props3.theme;
	      var isFocused = _props3.isFocused;
	      var isCollapsed = _props3.isCollapsed;
	      var focusedSectionIndex = _props3.focusedSectionIndex;
	      var focusedSuggestionIndex = _props3.focusedSuggestionIndex;
	      var valueBeforeUpDown = _props3.valueBeforeUpDown;
	      var inputFocused = _props3.inputFocused;
	      var inputChanged = _props3.inputChanged;
	      var updateFocusedSuggestion = _props3.updateFocusedSuggestion;
	      var resetFocusedSuggestion = _props3.resetFocusedSuggestion;
	      var revealSuggestions = _props3.revealSuggestions;
	      var closeSuggestions = _props3.closeSuggestions;
	      var getSuggestionValue = _props3.getSuggestionValue;
	      var alwaysRenderSuggestions = _props3.alwaysRenderSuggestions;
	      var value = inputProps.value;
	      var _onFocus = inputProps.onFocus;
	      var _onKeyDown = inputProps.onKeyDown;
	
	      var willRenderSuggestions = this.willRenderSuggestions(this.props);
	      var isOpen = alwaysRenderSuggestions || isFocused && !isCollapsed && willRenderSuggestions;
	      var items = isOpen ? suggestions : [];
	      var autowhateverInputProps = _extends({}, inputProps, {
	        onFocus: function onFocus(event) {
	          if (!_this2.justSelectedSuggestion && !_this2.justClickedOnSuggestionsContainer) {
	            inputFocused(shouldRenderSuggestions(value));
	            _onFocus && _onFocus(event);
	
	            if (shouldRenderSuggestions(value)) {
	              onSuggestionsFetchRequested({ value: value });
	            }
	          }
	        },
	        onBlur: function onBlur(event) {
	          if (_this2.justClickedOnSuggestionsContainer) {
	            _this2.input.focus();
	            return;
	          }
	
	          _this2.blurEvent = event;
	
	          if (!_this2.justSelectedSuggestion) {
	            _this2.onBlur();
	            _this2.onSuggestionsClearRequested();
	          }
	        },
	        onChange: function onChange(event) {
	          var value = event.target.value;
	
	          var shouldRender = shouldRenderSuggestions(value);
	
	          _this2.maybeCallOnChange(event, value, 'type');
	          inputChanged(shouldRender);
	
	          if (shouldRender) {
	            onSuggestionsFetchRequested({ value: value });
	          } else {
	            _this2.onSuggestionsClearRequested();
	          }
	        },
	        onKeyDown: function onKeyDown(event, data) {
	          switch (event.key) {
	            case 'ArrowDown':
	            case 'ArrowUp':
	              if (isCollapsed) {
	                if (shouldRenderSuggestions(value)) {
	                  onSuggestionsFetchRequested({ value: value });
	                  revealSuggestions();
	                }
	              } else if (suggestions.length > 0) {
	                var newFocusedSectionIndex = data.newFocusedSectionIndex;
	                var newFocusedItemIndex = data.newFocusedItemIndex;
	
	
	                var newValue = void 0;
	
	                if (newFocusedItemIndex === null) {
	                  // valueBeforeUpDown can be null if, for example, user
	                  // hovers on the first suggestion and then pressed Up.
	                  // If that happens, use the original input value.
	                  newValue = valueBeforeUpDown === null ? value : valueBeforeUpDown;
	                } else {
	                  newValue = _this2.getSuggestionValueByIndex(newFocusedSectionIndex, newFocusedItemIndex);
	                }
	
	                updateFocusedSuggestion(newFocusedSectionIndex, newFocusedItemIndex, value);
	                _this2.maybeCallOnChange(event, newValue, event.key === 'ArrowDown' ? 'down' : 'up');
	              }
	
	              event.preventDefault(); // Prevents the cursor from moving
	
	              break;
	
	            case 'Enter':
	              {
	                var focusedSuggestion = _this2.getFocusedSuggestion();
	
	                if (isOpen && !alwaysRenderSuggestions) {
	                  closeSuggestions();
	                }
	
	                if (focusedSuggestion !== null) {
	                  var _newValue = getSuggestionValue(focusedSuggestion);
	
	                  _this2.onSuggestionSelected(event, {
	                    suggestion: focusedSuggestion,
	                    suggestionValue: _newValue,
	                    sectionIndex: focusedSectionIndex,
	                    method: 'enter'
	                  });
	
	                  _this2.maybeCallOnChange(event, _newValue, 'enter');
	
	                  _this2.justSelectedSuggestion = true;
	
	                  setTimeout(function () {
	                    _this2.justSelectedSuggestion = false;
	                  });
	                }
	
	                break;
	              }
	
	            case 'Escape':
	              {
	                if (isOpen) {
	                  // If input.type === 'search', the browser clears the input
	                  // when Escape is pressed. We want to disable this default
	                  // behaviour so that, when suggestions are shown, we just hide
	                  // them, without clearing the input.
	                  event.preventDefault();
	                }
	
	                var willCloseSuggestions = isOpen && !alwaysRenderSuggestions;
	
	                if (valueBeforeUpDown === null) {
	                  // Didn't interact with Up/Down
	                  if (!willCloseSuggestions) {
	                    var _newValue2 = '';
	
	                    _this2.maybeCallOnChange(event, _newValue2, 'escape');
	
	                    if (shouldRenderSuggestions(_newValue2)) {
	                      onSuggestionsFetchRequested({ value: _newValue2 });
	                    } else {
	                      _this2.onSuggestionsClearRequested();
	                    }
	                  }
	                } else {
	                  // Interacted with Up/Down
	                  _this2.maybeCallOnChange(event, valueBeforeUpDown, 'escape');
	                }
	
	                if (willCloseSuggestions) {
	                  _this2.onSuggestionsClearRequested();
	                  closeSuggestions();
	                } else {
	                  resetFocusedSuggestion();
	                }
	
	                break;
	              }
	          }
	
	          _onKeyDown && _onKeyDown(event);
	        }
	      });
	      var renderSuggestionData = {
	        query: (valueBeforeUpDown || value).trim()
	      };
	
	      return _react2.default.createElement(_reactAutowhatever2.default, {
	        multiSection: multiSection,
	        items: items,
	        renderInputComponent: renderInputComponent,
	        renderItemsContainer: renderSuggestionsContainer,
	        renderItem: renderSuggestion,
	        renderItemData: renderSuggestionData,
	        renderSectionTitle: renderSectionTitle,
	        getSectionItems: getSectionSuggestions,
	        focusedSectionIndex: focusedSectionIndex,
	        focusedItemIndex: focusedSuggestionIndex,
	        inputProps: autowhateverInputProps,
	        itemProps: this.itemProps,
	        theme: theme,
	        id: id,
	        ref: this.storeReferences
	      });
	    }
	  }]);
	
	  return Autosuggest;
	}(_react.Component);
	
	Autosuggest.propTypes = {
	  suggestions: _react.PropTypes.array.isRequired,
	  onSuggestionsFetchRequested: _react.PropTypes.func.isRequired,
	  onSuggestionsClearRequested: _react.PropTypes.func,
	  onSuggestionSelected: _react.PropTypes.func,
	  renderInputComponent: _react.PropTypes.func,
	  renderSuggestionsContainer: _react.PropTypes.func,
	  getSuggestionValue: _react.PropTypes.func.isRequired,
	  renderSuggestion: _react.PropTypes.func.isRequired,
	  inputProps: _react.PropTypes.object.isRequired,
	  shouldRenderSuggestions: _react.PropTypes.func.isRequired,
	  alwaysRenderSuggestions: _react.PropTypes.bool.isRequired,
	  multiSection: _react.PropTypes.bool.isRequired,
	  renderSectionTitle: _react.PropTypes.func,
	  getSectionSuggestions: _react.PropTypes.func,
	  focusInputOnSuggestionClick: _react.PropTypes.bool.isRequired,
	  focusFirstSuggestion: _react.PropTypes.bool.isRequired,
	  theme: _react.PropTypes.object.isRequired,
	  id: _react.PropTypes.string.isRequired,
	  inputRef: _react.PropTypes.func.isRequired,
	
	  isFocused: _react.PropTypes.bool.isRequired,
	  isCollapsed: _react.PropTypes.bool.isRequired,
	  focusedSectionIndex: _react.PropTypes.number,
	  focusedSuggestionIndex: _react.PropTypes.number,
	  valueBeforeUpDown: _react.PropTypes.string,
	
	  inputFocused: _react.PropTypes.func.isRequired,
	  inputBlurred: _react.PropTypes.func.isRequired,
	  inputChanged: _react.PropTypes.func.isRequired,
	  updateFocusedSuggestion: _react.PropTypes.func.isRequired,
	  resetFocusedSuggestion: _react.PropTypes.func.isRequired,
	  revealSuggestions: _react.PropTypes.func.isRequired,
	  closeSuggestions: _react.PropTypes.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(mapStateToProps, _redux.actionCreators)(Autosuggest);

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(134);
	
	var _redux2 = __webpack_require__(101);
	
	var _redux3 = _interopRequireDefault(_redux2);
	
	var _Autosuggest = __webpack_require__(271);
	
	var _Autosuggest2 = _interopRequireDefault(_Autosuggest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var alwaysTrue = function alwaysTrue() {
	  return true;
	};
	var defaultShouldRenderSuggestions = function defaultShouldRenderSuggestions(value) {
	  return value.trim().length > 0;
	};
	var defaultTheme = {
	  container: 'react-autosuggest__container',
	  containerOpen: 'react-autosuggest__container--open',
	  input: 'react-autosuggest__input',
	  suggestionsContainer: 'react-autosuggest__suggestions-container',
	  suggestionsList: 'react-autosuggest__suggestions-list',
	  suggestion: 'react-autosuggest__suggestion',
	  suggestionFocused: 'react-autosuggest__suggestion--focused',
	  sectionContainer: 'react-autosuggest__section-container',
	  sectionTitle: 'react-autosuggest__section-title'
	};
	
	var mapToAutowhateverTheme = function mapToAutowhateverTheme(theme) {
	  var result = {};
	
	  for (var key in theme) {
	    switch (key) {
	      case 'suggestionsContainer':
	        result['itemsContainer'] = theme[key];
	        break;
	
	      case 'suggestion':
	        result['item'] = theme[key];
	        break;
	
	      case 'suggestionFocused':
	        result['itemFocused'] = theme[key];
	        break;
	
	      case 'suggestionsList':
	        result['itemsList'] = theme[key];
	        break;
	
	      default:
	        result[key] = theme[key];
	    }
	  }
	
	  return result;
	};
	
	var AutosuggestContainer = function (_Component) {
	  _inherits(AutosuggestContainer, _Component);
	
	  function AutosuggestContainer(_ref) {
	    var alwaysRenderSuggestions = _ref.alwaysRenderSuggestions;
	
	    _classCallCheck(this, AutosuggestContainer);
	
	    var _this = _possibleConstructorReturn(this, (AutosuggestContainer.__proto__ || Object.getPrototypeOf(AutosuggestContainer)).call(this));
	
	    _this.storeInputReference = function (input) {
	      _this.input = input;
	    };
	
	    var initialState = {
	      isFocused: false,
	      isCollapsed: !alwaysRenderSuggestions,
	      focusedSectionIndex: null,
	      focusedSuggestionIndex: null,
	      valueBeforeUpDown: null
	    };
	
	    _this.store = (0, _redux.createStore)(_redux3.default, initialState);
	    return _this;
	  }
	
	  _createClass(AutosuggestContainer, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var suggestions = _props.suggestions;
	      var onSuggestionsFetchRequested = _props.onSuggestionsFetchRequested;
	      var onSuggestionsClearRequested = _props.onSuggestionsClearRequested;
	      var multiSection = _props.multiSection;
	      var shouldRenderSuggestions = _props.shouldRenderSuggestions;
	      var renderInputComponent = _props.renderInputComponent;
	      var renderSuggestionsContainer = _props.renderSuggestionsContainer;
	      var getSuggestionValue = _props.getSuggestionValue;
	      var renderSuggestion = _props.renderSuggestion;
	      var renderSectionTitle = _props.renderSectionTitle;
	      var getSectionSuggestions = _props.getSectionSuggestions;
	      var inputProps = _props.inputProps;
	      var onSuggestionSelected = _props.onSuggestionSelected;
	      var focusInputOnSuggestionClick = _props.focusInputOnSuggestionClick;
	      var focusFirstSuggestion = _props.focusFirstSuggestion;
	      var alwaysRenderSuggestions = _props.alwaysRenderSuggestions;
	      var theme = _props.theme;
	      var id = _props.id;
	
	
	      return _react2.default.createElement(_Autosuggest2.default, {
	        suggestions: suggestions,
	        onSuggestionsFetchRequested: onSuggestionsFetchRequested,
	        onSuggestionsClearRequested: onSuggestionsClearRequested,
	        multiSection: multiSection,
	        shouldRenderSuggestions: alwaysRenderSuggestions ? alwaysTrue : shouldRenderSuggestions,
	        alwaysRenderSuggestions: alwaysRenderSuggestions,
	        renderInputComponent: renderInputComponent,
	        renderSuggestionsContainer: renderSuggestionsContainer,
	        getSuggestionValue: getSuggestionValue,
	        renderSuggestion: renderSuggestion,
	        renderSectionTitle: renderSectionTitle,
	        getSectionSuggestions: getSectionSuggestions,
	        inputProps: inputProps,
	        onSuggestionSelected: onSuggestionSelected,
	        focusInputOnSuggestionClick: focusInputOnSuggestionClick,
	        focusFirstSuggestion: focusFirstSuggestion,
	        theme: mapToAutowhateverTheme(theme),
	        id: id,
	        inputRef: this.storeInputReference,
	        store: this.store
	      });
	    }
	  }]);
	
	  return AutosuggestContainer;
	}(_react.Component);
	
	AutosuggestContainer.propTypes = {
	  suggestions: _react.PropTypes.array.isRequired,
	  onSuggestionsFetchRequested: function onSuggestionsFetchRequested(props, propName) {
	    var onSuggestionsFetchRequested = props[propName];
	
	    if (typeof onSuggestionsFetchRequested !== 'function') {
	      throw new Error('\'onSuggestionsFetchRequested\' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsFetchRequestedProp');
	    }
	  },
	  onSuggestionsClearRequested: function onSuggestionsClearRequested(props, propName) {
	    var onSuggestionsClearRequested = props[propName];
	
	    if (props.alwaysRenderSuggestions === false && typeof onSuggestionsClearRequested !== 'function') {
	      throw new Error('\'onSuggestionsClearRequested\' must be implemented. See: https://github.com/moroshko/react-autosuggest#onSuggestionsClearRequestedProp');
	    }
	  },
	  onSuggestionSelected: _react.PropTypes.func,
	  renderInputComponent: _react.PropTypes.func,
	  renderSuggestionsContainer: _react.PropTypes.func,
	  getSuggestionValue: _react.PropTypes.func.isRequired,
	  renderSuggestion: _react.PropTypes.func.isRequired,
	  inputProps: function inputProps(props, propName) {
	    var inputProps = props[propName];
	
	    if (!inputProps.hasOwnProperty('value')) {
	      throw new Error('\'inputProps\' must have \'value\'.');
	    }
	
	    if (!inputProps.hasOwnProperty('onChange')) {
	      throw new Error('\'inputProps\' must have \'onChange\'.');
	    }
	  },
	  shouldRenderSuggestions: _react.PropTypes.func,
	  alwaysRenderSuggestions: _react.PropTypes.bool,
	  multiSection: _react.PropTypes.bool,
	  renderSectionTitle: function renderSectionTitle(props, propName) {
	    var renderSectionTitle = props[propName];
	
	    if (props.multiSection === true && typeof renderSectionTitle !== 'function') {
	      throw new Error('\'renderSectionTitle\' must be implemented. See: https://github.com/moroshko/react-autosuggest#renderSectionTitleProp');
	    }
	  },
	  getSectionSuggestions: function getSectionSuggestions(props, propName) {
	    var getSectionSuggestions = props[propName];
	
	    if (props.multiSection === true && typeof getSectionSuggestions !== 'function') {
	      throw new Error('\'getSectionSuggestions\' must be implemented. See: https://github.com/moroshko/react-autosuggest#getSectionSuggestionsProp');
	    }
	  },
	  focusInputOnSuggestionClick: _react.PropTypes.bool,
	  focusFirstSuggestion: _react.PropTypes.bool,
	  theme: _react.PropTypes.object,
	  id: _react.PropTypes.string
	};
	AutosuggestContainer.defaultProps = {
	  shouldRenderSuggestions: defaultShouldRenderSuggestions,
	  alwaysRenderSuggestions: false,
	  multiSection: false,
	  focusInputOnSuggestionClick: true,
	  focusFirstSuggestion: false,
	  theme: defaultTheme,
	  id: '1'
	};
	exports.default = AutosuggestContainer;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(272).default;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sectionIterator = __webpack_require__(361);
	
	var _sectionIterator2 = _interopRequireDefault(_sectionIterator);
	
	var _reactThemeable = __webpack_require__(292);
	
	var _reactThemeable2 = _interopRequireDefault(_reactThemeable);
	
	var _SectionTitle = __webpack_require__(277);
	
	var _SectionTitle2 = _interopRequireDefault(_SectionTitle);
	
	var _ItemsList = __webpack_require__(276);
	
	var _ItemsList2 = _interopRequireDefault(_ItemsList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var alwaysTrue = function alwaysTrue() {
	  return true;
	};
	var emptyObject = {};
	var defaultRenderInputComponent = function defaultRenderInputComponent(props) {
	  return _react2.default.createElement('input', props);
	};
	var defaultRenderItemsContainer = function defaultRenderItemsContainer(props) {
	  return _react2.default.createElement('div', props);
	};
	var defaultTheme = {
	  container: 'react-autowhatever__container',
	  containerOpen: 'react-autowhatever__container--open',
	  input: 'react-autowhatever__input',
	  itemsContainer: 'react-autowhatever__items-container',
	  itemsList: 'react-autowhatever__items-list',
	  item: 'react-autowhatever__item',
	  itemFocused: 'react-autowhatever__item--focused',
	  sectionContainer: 'react-autowhatever__section-container',
	  sectionTitle: 'react-autowhatever__section-title'
	};
	
	var Autowhatever = function (_Component) {
	  _inherits(Autowhatever, _Component);
	
	  function Autowhatever(props) {
	    _classCallCheck(this, Autowhatever);
	
	    var _this = _possibleConstructorReturn(this, (Autowhatever.__proto__ || Object.getPrototypeOf(Autowhatever)).call(this, props));
	
	    _this.focusedItem = null;
	
	    _this.setSectionsItems(props);
	    _this.setSectionIterator(props);
	    _this.setTheme(props);
	
	    _this.onKeyDown = _this.onKeyDown.bind(_this);
	    _this.storeInputReference = _this.storeInputReference.bind(_this);
	    _this.storeItemsContainerReference = _this.storeItemsContainerReference.bind(_this);
	    _this.onFocusedItemChange = _this.onFocusedItemChange.bind(_this);
	    _this.getItemId = _this.getItemId.bind(_this);
	    return _this;
	  }
	
	  _createClass(Autowhatever, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureFocusedItemIsVisible();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.items !== this.props.items) {
	        this.setSectionsItems(nextProps);
	      }
	
	      if (nextProps.items !== this.props.items || nextProps.multiSection !== this.props.multiSection) {
	        this.setSectionIterator(nextProps);
	      }
	
	      if (nextProps.theme !== this.props.theme) {
	        this.setTheme(nextProps);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureFocusedItemIsVisible();
	    }
	  }, {
	    key: 'setSectionsItems',
	    value: function setSectionsItems(props) {
	      if (props.multiSection) {
	        this.sectionsItems = props.items.map(function (section) {
	          return props.getSectionItems(section);
	        });
	        this.sectionsLengths = this.sectionsItems.map(function (items) {
	          return items.length;
	        });
	        this.allSectionsAreEmpty = this.sectionsLengths.every(function (itemsCount) {
	          return itemsCount === 0;
	        });
	      }
	    }
	  }, {
	    key: 'setSectionIterator',
	    value: function setSectionIterator(props) {
	      this.sectionIterator = (0, _sectionIterator2.default)({
	        multiSection: props.multiSection,
	        data: props.multiSection ? this.sectionsLengths : props.items.length
	      });
	    }
	  }, {
	    key: 'setTheme',
	    value: function setTheme(props) {
	      this.theme = (0, _reactThemeable2.default)(props.theme);
	    }
	  }, {
	    key: 'storeInputReference',
	    value: function storeInputReference(input) {
	      if (input !== null) {
	        this.input = input;
	      }
	    }
	  }, {
	    key: 'storeItemsContainerReference',
	    value: function storeItemsContainerReference(itemsContainer) {
	      if (itemsContainer !== null) {
	        this.itemsContainer = itemsContainer;
	      }
	    }
	  }, {
	    key: 'onFocusedItemChange',
	    value: function onFocusedItemChange(focusedItem) {
	      this.focusedItem = focusedItem;
	    }
	  }, {
	    key: 'getItemId',
	    value: function getItemId(sectionIndex, itemIndex) {
	      if (itemIndex === null) {
	        return null;
	      }
	
	      var id = this.props.id;
	
	      var section = sectionIndex === null ? '' : 'section-' + sectionIndex;
	
	      return 'react-autowhatever-' + id + '-' + section + '-item-' + itemIndex;
	    }
	  }, {
	    key: 'renderSections',
	    value: function renderSections() {
	      var _this2 = this;
	
	      if (this.allSectionsAreEmpty) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _props = this.props;
	      var id = _props.id;
	      var items = _props.items;
	      var renderItem = _props.renderItem;
	      var renderItemData = _props.renderItemData;
	      var shouldRenderSection = _props.shouldRenderSection;
	      var renderSectionTitle = _props.renderSectionTitle;
	      var focusedSectionIndex = _props.focusedSectionIndex;
	      var focusedItemIndex = _props.focusedItemIndex;
	      var itemProps = _props.itemProps;
	
	
	      return items.map(function (section, sectionIndex) {
	        if (!shouldRenderSection(section)) {
	          return null;
	        }
	
	        var keyPrefix = 'react-autowhatever-' + id + '-';
	        var sectionKeyPrefix = keyPrefix + 'section-' + sectionIndex + '-';
	
	        // `key` is provided by theme()
	        /* eslint-disable react/jsx-key */
	        return _react2.default.createElement(
	          'div',
	          theme(sectionKeyPrefix + 'container', 'sectionContainer'),
	          _react2.default.createElement(_SectionTitle2.default, {
	            section: section,
	            renderSectionTitle: renderSectionTitle,
	            theme: theme,
	            sectionKeyPrefix: sectionKeyPrefix
	          }),
	          _react2.default.createElement(_ItemsList2.default, {
	            items: _this2.sectionsItems[sectionIndex],
	            itemProps: itemProps,
	            renderItem: renderItem,
	            renderItemData: renderItemData,
	            sectionIndex: sectionIndex,
	            focusedItemIndex: focusedSectionIndex === sectionIndex ? focusedItemIndex : null,
	            onFocusedItemChange: _this2.onFocusedItemChange,
	            getItemId: _this2.getItemId,
	            theme: theme,
	            keyPrefix: keyPrefix,
	            ref: _this2.storeItemsListReference
	          })
	        );
	        /* eslint-enable react/jsx-key */
	      });
	    }
	  }, {
	    key: 'renderItems',
	    value: function renderItems() {
	      var items = this.props.items;
	
	
	      if (items.length === 0) {
	        return null;
	      }
	
	      var theme = this.theme;
	      var _props2 = this.props;
	      var id = _props2.id;
	      var renderItem = _props2.renderItem;
	      var renderItemData = _props2.renderItemData;
	      var focusedSectionIndex = _props2.focusedSectionIndex;
	      var focusedItemIndex = _props2.focusedItemIndex;
	      var itemProps = _props2.itemProps;
	
	
	      return _react2.default.createElement(_ItemsList2.default, {
	        items: items,
	        itemProps: itemProps,
	        renderItem: renderItem,
	        renderItemData: renderItemData,
	        focusedItemIndex: focusedSectionIndex === null ? focusedItemIndex : null,
	        onFocusedItemChange: this.onFocusedItemChange,
	        getItemId: this.getItemId,
	        theme: theme,
	        keyPrefix: 'react-autowhatever-' + id + '-'
	      });
	    }
	  }, {
	    key: 'onKeyDown',
	    value: function onKeyDown(event) {
	      var _props3 = this.props;
	      var inputProps = _props3.inputProps;
	      var focusedSectionIndex = _props3.focusedSectionIndex;
	      var focusedItemIndex = _props3.focusedItemIndex;
	
	
	      switch (event.key) {
	        case 'ArrowDown':
	        case 'ArrowUp':
	          {
	            var nextPrev = event.key === 'ArrowDown' ? 'next' : 'prev';
	
	            var _sectionIterator$next = this.sectionIterator[nextPrev]([focusedSectionIndex, focusedItemIndex]);
	
	            var _sectionIterator$next2 = _slicedToArray(_sectionIterator$next, 2);
	
	            var newFocusedSectionIndex = _sectionIterator$next2[0];
	            var newFocusedItemIndex = _sectionIterator$next2[1];
	
	
	            inputProps.onKeyDown(event, { newFocusedSectionIndex: newFocusedSectionIndex, newFocusedItemIndex: newFocusedItemIndex });
	            break;
	          }
	
	        default:
	          inputProps.onKeyDown(event, { focusedSectionIndex: focusedSectionIndex, focusedItemIndex: focusedItemIndex });
	      }
	    }
	  }, {
	    key: 'ensureFocusedItemIsVisible',
	    value: function ensureFocusedItemIsVisible() {
	      var focusedItem = this.focusedItem;
	
	
	      if (!focusedItem) {
	        return;
	      }
	
	      var itemsContainer = this.itemsContainer;
	
	      var itemOffsetRelativeToContainer = focusedItem.offsetParent === itemsContainer ? focusedItem.offsetTop : focusedItem.offsetTop - itemsContainer.offsetTop;
	
	      var scrollTop = itemsContainer.scrollTop; // Top of the visible area
	
	      if (itemOffsetRelativeToContainer < scrollTop) {
	        // Item is off the top of the visible area
	        scrollTop = itemOffsetRelativeToContainer;
	      } else if (itemOffsetRelativeToContainer + focusedItem.offsetHeight > scrollTop + itemsContainer.offsetHeight) {
	        // Item is off the bottom of the visible area
	        scrollTop = itemOffsetRelativeToContainer + focusedItem.offsetHeight - itemsContainer.offsetHeight;
	      }
	
	      if (scrollTop !== itemsContainer.scrollTop) {
	        itemsContainer.scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var theme = this.theme;
	      var _props4 = this.props;
	      var id = _props4.id;
	      var multiSection = _props4.multiSection;
	      var renderInputComponent = _props4.renderInputComponent;
	      var renderItemsContainer = _props4.renderItemsContainer;
	      var focusedSectionIndex = _props4.focusedSectionIndex;
	      var focusedItemIndex = _props4.focusedItemIndex;
	
	      var renderedItems = multiSection ? this.renderSections() : this.renderItems();
	      var isOpen = renderedItems !== null;
	      var ariaActivedescendant = this.getItemId(focusedSectionIndex, focusedItemIndex);
	      var containerProps = theme('react-autowhatever-' + id + '-container', 'container', isOpen && 'containerOpen');
	      var itemsContainerId = 'react-autowhatever-' + id;
	      var inputComponent = renderInputComponent(_extends({
	        type: 'text',
	        value: '',
	        autoComplete: 'off',
	        role: 'combobox',
	        'aria-autocomplete': 'list',
	        'aria-owns': itemsContainerId,
	        'aria-expanded': isOpen,
	        'aria-haspopup': isOpen,
	        'aria-activedescendant': ariaActivedescendant
	      }, theme('react-autowhatever-' + id + '-input', 'input'), this.props.inputProps, {
	        onKeyDown: this.props.inputProps.onKeyDown && this.onKeyDown,
	        ref: this.storeInputReference
	      }));
	      var itemsContainer = renderItemsContainer(_extends({
	        id: itemsContainerId
	      }, theme('react-autowhatever-' + id + '-items-container', 'itemsContainer'), {
	        ref: this.storeItemsContainerReference,
	        children: renderedItems
	      }));
	
	      return _react2.default.createElement(
	        'div',
	        containerProps,
	        inputComponent,
	        itemsContainer
	      );
	    }
	  }]);
	
	  return Autowhatever;
	}(_react.Component);
	
	Autowhatever.propTypes = {
	  id: _react.PropTypes.string, // Used in aria-* attributes. If multiple Autowhatever's are rendered on a page, they must have unique ids.
	  multiSection: _react.PropTypes.bool, // Indicates whether a multi section layout should be rendered.
	  renderInputComponent: _react.PropTypes.func, // Renders the input component.
	  items: _react.PropTypes.array.isRequired, // Array of items or sections to render.
	  renderItemsContainer: _react.PropTypes.func, // Renders the items container.
	  renderItem: _react.PropTypes.func, // This function renders a single item.
	  renderItemData: _react.PropTypes.object, // Arbitrary data that will be passed to renderItem()
	  shouldRenderSection: _react.PropTypes.func, // This function gets a section and returns whether it should be rendered, or not.
	  renderSectionTitle: _react.PropTypes.func, // This function gets a section and renders its title.
	  getSectionItems: _react.PropTypes.func, // This function gets a section and returns its items, which will be passed into `renderItem` for rendering.
	  inputComponent: _react.PropTypes.func, // When specified, it is used to render the input element
	  inputProps: _react.PropTypes.object, // Arbitrary input props
	  itemProps: _react.PropTypes.oneOfType([// Arbitrary item props
	  _react.PropTypes.object, _react.PropTypes.func]),
	  focusedSectionIndex: _react.PropTypes.number, // Section index of the focused item
	  focusedItemIndex: _react.PropTypes.number, // Focused item index (within a section)
	  theme: _react.PropTypes.oneOfType([// Styles. See: https://github.com/markdalgleish/react-themeable
	  _react.PropTypes.object, _react.PropTypes.array])
	};
	Autowhatever.defaultProps = {
	  id: '1',
	  multiSection: false,
	  renderInputComponent: defaultRenderInputComponent,
	  renderItemsContainer: defaultRenderItemsContainer,
	  shouldRenderSection: alwaysTrue,
	  renderItem: function renderItem() {
	    throw new Error('`renderItem` must be provided');
	  },
	  renderItemData: emptyObject,
	  renderSectionTitle: function renderSectionTitle() {
	    throw new Error('`renderSectionTitle` must be provided');
	  },
	  getSectionItems: function getSectionItems() {
	    throw new Error('`getSectionItems` must be provided');
	  },
	  inputProps: emptyObject,
	  itemProps: emptyObject,
	  focusedSectionIndex: null,
	  focusedItemIndex: null,
	  theme: defaultTheme
	};
	exports.default = Autowhatever;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compareObjects = __webpack_require__(57);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Item = function (_Component) {
	  _inherits(Item, _Component);
	
	  function Item() {
	    _classCallCheck(this, Item);
	
	    var _this = _possibleConstructorReturn(this, (Item.__proto__ || Object.getPrototypeOf(Item)).call(this));
	
	    _this.storeItemReference = _this.storeItemReference.bind(_this);
	    _this.onMouseEnter = _this.onMouseEnter.bind(_this);
	    _this.onMouseLeave = _this.onMouseLeave.bind(_this);
	    _this.onMouseDown = _this.onMouseDown.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props, ['renderItemData']);
	    }
	  }, {
	    key: 'storeItemReference',
	    value: function storeItemReference(item) {
	      if (item !== null) {
	        this.item = item;
	      }
	    }
	  }, {
	    key: 'onMouseEnter',
	    value: function onMouseEnter(event) {
	      var _props = this.props;
	      var sectionIndex = _props.sectionIndex;
	      var itemIndex = _props.itemIndex;
	
	
	      this.props.onMouseEnter(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }
	  }, {
	    key: 'onMouseLeave',
	    value: function onMouseLeave(event) {
	      var _props2 = this.props;
	      var sectionIndex = _props2.sectionIndex;
	      var itemIndex = _props2.itemIndex;
	
	
	      this.props.onMouseLeave(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }
	  }, {
	    key: 'onMouseDown',
	    value: function onMouseDown(event) {
	      var _props3 = this.props;
	      var sectionIndex = _props3.sectionIndex;
	      var itemIndex = _props3.itemIndex;
	
	
	      this.props.onMouseDown(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }
	  }, {
	    key: 'onClick',
	    value: function onClick(event) {
	      var _props4 = this.props;
	      var sectionIndex = _props4.sectionIndex;
	      var itemIndex = _props4.itemIndex;
	
	
	      this.props.onClick(event, { sectionIndex: sectionIndex, itemIndex: itemIndex });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props5 = this.props;
	      var item = _props5.item;
	      var renderItem = _props5.renderItem;
	      var renderItemData = _props5.renderItemData;
	
	      var restProps = _objectWithoutProperties(_props5, ['item', 'renderItem', 'renderItemData']);
	
	      delete restProps.sectionIndex;
	      delete restProps.itemIndex;
	
	      if (typeof restProps.onMouseEnter === 'function') {
	        restProps.onMouseEnter = this.onMouseEnter;
	      }
	
	      if (typeof restProps.onMouseLeave === 'function') {
	        restProps.onMouseLeave = this.onMouseLeave;
	      }
	
	      if (typeof restProps.onMouseDown === 'function') {
	        restProps.onMouseDown = this.onMouseDown;
	      }
	
	      if (typeof restProps.onClick === 'function') {
	        restProps.onClick = this.onClick;
	      }
	
	      return _react2.default.createElement(
	        'li',
	        _extends({ role: 'option' }, restProps, { ref: this.storeItemReference }),
	        renderItem(item, renderItemData)
	      );
	    }
	  }]);
	
	  return Item;
	}(_react.Component);
	
	Item.propTypes = {
	  sectionIndex: _react.PropTypes.number,
	  itemIndex: _react.PropTypes.number.isRequired,
	  item: _react.PropTypes.any.isRequired,
	  renderItem: _react.PropTypes.func.isRequired,
	  renderItemData: _react.PropTypes.object.isRequired,
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onMouseDown: _react.PropTypes.func,
	  onClick: _react.PropTypes.func
	};
	exports.default = Item;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Item = __webpack_require__(275);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	var _compareObjects = __webpack_require__(57);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ItemsList = function (_Component) {
	  _inherits(ItemsList, _Component);
	
	  function ItemsList() {
	    _classCallCheck(this, ItemsList);
	
	    var _this = _possibleConstructorReturn(this, (ItemsList.__proto__ || Object.getPrototypeOf(ItemsList)).call(this));
	
	    _this.storeFocusedItemReference = _this.storeFocusedItemReference.bind(_this);
	    return _this;
	  }
	
	  _createClass(ItemsList, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props, ['itemProps']);
	    }
	  }, {
	    key: 'storeFocusedItemReference',
	    value: function storeFocusedItemReference(focusedItem) {
	      this.props.onFocusedItemChange(focusedItem === null ? null : focusedItem.item);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var items = _props.items;
	      var itemProps = _props.itemProps;
	      var renderItem = _props.renderItem;
	      var renderItemData = _props.renderItemData;
	      var sectionIndex = _props.sectionIndex;
	      var focusedItemIndex = _props.focusedItemIndex;
	      var getItemId = _props.getItemId;
	      var theme = _props.theme;
	      var keyPrefix = _props.keyPrefix;
	
	      var sectionPrefix = sectionIndex === null ? keyPrefix : keyPrefix + 'section-' + sectionIndex + '-';
	      var isItemPropsFunction = typeof itemProps === 'function';
	
	      return _react2.default.createElement(
	        'ul',
	        _extends({ role: 'listbox' }, theme(sectionPrefix + 'items-list', 'itemsList')),
	        items.map(function (item, itemIndex) {
	          var isFocused = itemIndex === focusedItemIndex;
	          var itemKey = sectionPrefix + 'item-' + itemIndex;
	          var itemPropsObj = isItemPropsFunction ? itemProps({ sectionIndex: sectionIndex, itemIndex: itemIndex }) : itemProps;
	          var allItemProps = _extends({
	            id: getItemId(sectionIndex, itemIndex)
	          }, theme(itemKey, 'item', isFocused && 'itemFocused'), itemPropsObj);
	
	          if (isFocused) {
	            allItemProps.ref = _this2.storeFocusedItemReference;
	          }
	
	          // `key` is provided by theme()
	          /* eslint-disable react/jsx-key */
	          return _react2.default.createElement(_Item2.default, _extends({}, allItemProps, {
	            sectionIndex: sectionIndex,
	            itemIndex: itemIndex,
	            item: item,
	            renderItem: renderItem,
	            renderItemData: renderItemData
	          }));
	          /* eslint-enable react/jsx-key */
	        })
	      );
	    }
	  }]);
	
	  return ItemsList;
	}(_react.Component);
	
	ItemsList.propTypes = {
	  items: _react.PropTypes.array.isRequired,
	  itemProps: _react.PropTypes.oneOfType([_react.PropTypes.object, _react.PropTypes.func]),
	  renderItem: _react.PropTypes.func.isRequired,
	  renderItemData: _react.PropTypes.object.isRequired,
	  sectionIndex: _react.PropTypes.number,
	  focusedItemIndex: _react.PropTypes.number,
	  onFocusedItemChange: _react.PropTypes.func.isRequired,
	  getItemId: _react.PropTypes.func.isRequired,
	  theme: _react.PropTypes.func.isRequired,
	  keyPrefix: _react.PropTypes.string.isRequired
	};
	ItemsList.defaultProps = {
	  sectionIndex: null
	};
	exports.default = ItemsList;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _compareObjects = __webpack_require__(57);
	
	var _compareObjects2 = _interopRequireDefault(_compareObjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SectionTitle = function (_Component) {
	  _inherits(SectionTitle, _Component);
	
	  function SectionTitle() {
	    _classCallCheck(this, SectionTitle);
	
	    return _possibleConstructorReturn(this, (SectionTitle.__proto__ || Object.getPrototypeOf(SectionTitle)).apply(this, arguments));
	  }
	
	  _createClass(SectionTitle, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return (0, _compareObjects2.default)(nextProps, this.props);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var section = _props.section;
	      var renderSectionTitle = _props.renderSectionTitle;
	      var theme = _props.theme;
	      var sectionKeyPrefix = _props.sectionKeyPrefix;
	
	      var sectionTitle = renderSectionTitle(section);
	
	      if (!sectionTitle) {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        theme(sectionKeyPrefix + 'title', 'sectionTitle'),
	        sectionTitle
	      );
	    }
	  }]);
	
	  return SectionTitle;
	}(_react.Component);
	
	SectionTitle.propTypes = {
	  section: _react.PropTypes.any.isRequired,
	  renderSectionTitle: _react.PropTypes.func.isRequired,
	  theme: _react.PropTypes.func.isRequired,
	  sectionKeyPrefix: _react.PropTypes.string.isRequired
	};
	exports.default = SectionTitle;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(274).default;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(41);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _elementResizeDetector = __webpack_require__(231);
	
	var _elementResizeDetector2 = _interopRequireDefault(_elementResizeDetector);
	
	var _invariant = __webpack_require__(99);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContainerDimensions = function (_Component) {
	    _inherits(ContainerDimensions, _Component);
	
	    _createClass(ContainerDimensions, null, [{
	        key: 'getDomNodeDimensions',
	        value: function getDomNodeDimensions(node) {
	            var _node$getBoundingClie = node.getBoundingClientRect();
	
	            var top = _node$getBoundingClie.top;
	            var right = _node$getBoundingClie.right;
	            var bottom = _node$getBoundingClie.bottom;
	            var left = _node$getBoundingClie.left;
	            var width = _node$getBoundingClie.width;
	            var height = _node$getBoundingClie.height;
	
	            return { top: top, right: right, bottom: bottom, left: left, width: width, height: height };
	        }
	    }]);
	
	    function ContainerDimensions() {
	        _classCallCheck(this, ContainerDimensions);
	
	        var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(ContainerDimensions).call(this));
	
	        _this.state = {
	            initiated: false
	        };
	        _this.onResize = _this.onResize.bind(_this);
	        return _this;
	    }
	
	    _createClass(ContainerDimensions, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            this.parentNode = _reactDom2.default.findDOMNode(this).parentNode;
	            this.elementResizeDetector = (0, _elementResizeDetector2.default)({ strategy: 'scroll' });
	            this.elementResizeDetector.listenTo(this.parentNode, this.onResize);
	            this.onResize();
	        }
	    }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	            this.elementResizeDetector.removeListener(this.parentNode, this.onResize);
	        }
	    }, {
	        key: 'onResize',
	        value: function onResize() {
	            var clientRect = ContainerDimensions.getDomNodeDimensions(this.parentNode);
	            this.setState(_extends({
	                initiated: true
	            }, clientRect));
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            (0, _invariant2.default)(this.props.children, 'Expected children to be one of function or React.Element');
	
	            if (!this.state.initiated) {
	                return _react2.default.createElement('div', null);
	            }
	            if (typeof this.props.children === 'function') {
	                var renderedChildren = this.props.children(this.state);
	                return renderedChildren && _react.Children.only(renderedChildren);
	            }
	            return _react.Children.only(_react2.default.cloneElement(this.props.children, this.state));
	        }
	    }]);
	
	    return ContainerDimensions;
	}(_react.Component);
	
	ContainerDimensions.propTypes = {
	    children: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.func]).isRequired
	};
	exports.default = ContainerDimensions;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(41);
	var ExecutionEnvironment = __webpack_require__(238);
	var ModalPortal = React.createFactory(__webpack_require__(281));
	var ariaAppHider = __webpack_require__(282);
	var elementClass = __webpack_require__(228);
	var renderSubtreeIntoContainer = __webpack_require__(41).unstable_renderSubtreeIntoContainer;
	var Assign = __webpack_require__(103);
	
	var SafeHTMLElement = ExecutionEnvironment.canUseDOM ? window.HTMLElement : {};
	var AppElement = ExecutionEnvironment.canUseDOM ? document.body : {appendChild: function() {}};
	
	var Modal = React.createClass({
	
	  displayName: 'Modal',
	  statics: {
	    setAppElement: function(element) {
	        AppElement = ariaAppHider.setElement(element);
	    },
	    injectCSS: function() {
	      "production" !== ("production")
	        && console.warn('React-Modal: injectCSS has been deprecated ' +
	                        'and no longer has any effect. It will be removed in a later version');
	    }
	  },
	
	  propTypes: {
	    isOpen: React.PropTypes.bool.isRequired,
	    style: React.PropTypes.shape({
	      content: React.PropTypes.object,
	      overlay: React.PropTypes.object
	    }),
	    portalClassName: React.PropTypes.string,
	    appElement: React.PropTypes.instanceOf(SafeHTMLElement),
	    onAfterOpen: React.PropTypes.func,
	    onRequestClose: React.PropTypes.func,
	    closeTimeoutMS: React.PropTypes.number,
	    ariaHideApp: React.PropTypes.bool,
	    shouldCloseOnOverlayClick: React.PropTypes.bool,
	    role: React.PropTypes.string
	  },
	
	  getDefaultProps: function () {
	    return {
	      isOpen: false,
	      portalClassName: 'ReactModalPortal',
	      ariaHideApp: true,
	      closeTimeoutMS: 0,
	      shouldCloseOnOverlayClick: true
	    };
	  },
	
	  componentDidMount: function() {
	    this.node = document.createElement('div');
	    this.node.className = this.props.portalClassName;
	    document.body.appendChild(this.node);
	    this.renderPortal(this.props);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    this.renderPortal(newProps);
	  },
	
	  componentWillUnmount: function() {
	    ReactDOM.unmountComponentAtNode(this.node);
	    document.body.removeChild(this.node);
	    elementClass(document.body).remove('ReactModal__Body--open');
	  },
	
	  renderPortal: function(props) {
	    if (props.isOpen) {
	      elementClass(document.body).add('ReactModal__Body--open');
	    } else {
	      elementClass(document.body).remove('ReactModal__Body--open');
	    }
	
	    if (props.ariaHideApp) {
	      ariaAppHider.toggle(props.isOpen, props.appElement);
	    }
	
	    this.portal = renderSubtreeIntoContainer(this, ModalPortal(Assign({}, props, {defaultStyles: Modal.defaultStyles})), this.node);
	  },
	
	  render: function () {
	    return React.DOM.noscript();
	  }
	});
	
	Modal.defaultStyles = {
	  overlay: {
	    position        : 'fixed',
	    top             : 0,
	    left            : 0,
	    right           : 0,
	    bottom          : 0,
	    backgroundColor : 'rgba(255, 255, 255, 0.75)'
	  },
	  content: {
	    position                : 'absolute',
	    top                     : '40px',
	    left                    : '40px',
	    right                   : '40px',
	    bottom                  : '40px',
	    border                  : '1px solid #ccc',
	    background              : '#fff',
	    overflow                : 'auto',
	    WebkitOverflowScrolling : 'touch',
	    borderRadius            : '4px',
	    outline                 : 'none',
	    padding                 : '20px'
	  }
	}
	
	module.exports = Modal


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var React = __webpack_require__(1);
	var div = React.DOM.div;
	var focusManager = __webpack_require__(283);
	var scopeTab = __webpack_require__(284);
	var Assign = __webpack_require__(103);
	
	// so that our CSS is statically analyzable
	var CLASS_NAMES = {
	  overlay: {
	    base: 'ReactModal__Overlay',
	    afterOpen: 'ReactModal__Overlay--after-open',
	    beforeClose: 'ReactModal__Overlay--before-close'
	  },
	  content: {
	    base: 'ReactModal__Content',
	    afterOpen: 'ReactModal__Content--after-open',
	    beforeClose: 'ReactModal__Content--before-close'
	  }
	};
	
	var ModalPortal = module.exports = React.createClass({
	
	  displayName: 'ModalPortal',
	  shouldClose: null,
	
	  getDefaultProps: function() {
	    return {
	      style: {
	        overlay: {},
	        content: {}
	      }
	    };
	  },
	
	  getInitialState: function() {
	    return {
	      afterOpen: false,
	      beforeClose: false
	    };
	  },
	
	  componentDidMount: function() {
	    // Focus needs to be set when mounting and already open
	    if (this.props.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    }
	  },
	
	  componentWillUnmount: function() {
	    clearTimeout(this.closeTimer);
	  },
	
	  componentWillReceiveProps: function(newProps) {
	    // Focus only needs to be set once when the modal is being opened
	    if (!this.props.isOpen && newProps.isOpen) {
	      this.setFocusAfterRender(true);
	      this.open();
	    } else if (this.props.isOpen && !newProps.isOpen) {
	      this.close();
	    }
	  },
	
	  componentDidUpdate: function () {
	    if (this.focusAfterRender) {
	      this.focusContent();
	      this.setFocusAfterRender(false);
	    }
	  },
	
	  setFocusAfterRender: function (focus) {
	    this.focusAfterRender = focus;
	  },
	
	  open: function() {
	    if (this.state.afterOpen && this.state.beforeClose) {
	      clearTimeout(this.closeTimer);
	      this.setState({ beforeClose: false });
	    } else {
	      focusManager.setupScopedFocus(this.node);
	      focusManager.markForFocusLater();
	      this.setState({isOpen: true}, function() {
	        this.setState({afterOpen: true});
	
	        if (this.props.isOpen && this.props.onAfterOpen) {
	          this.props.onAfterOpen();
	        }
	      }.bind(this));
	    }
	  },
	
	  close: function() {
	    if (!this.ownerHandlesClose())
	      return;
	    if (this.props.closeTimeoutMS > 0)
	      this.closeWithTimeout();
	    else
	      this.closeWithoutTimeout();
	  },
	
	  focusContent: function() {
	    // Don't steal focus from inner elements
	    if (!this.contentHasFocus()) {
	      this.refs.content.focus();
	    }
	  },
	
	  closeWithTimeout: function() {
	    this.setState({beforeClose: true}, function() {
	      this.closeTimer = setTimeout(this.closeWithoutTimeout, this.props.closeTimeoutMS);
	    }.bind(this));
	  },
	
	  closeWithoutTimeout: function() {
	    this.setState({
	      beforeClose: false,
	      isOpen: false,
	      afterOpen: false,
	    }, this.afterClose);
	  },
	
	  afterClose: function() {
	    focusManager.returnFocus();
	    focusManager.teardownScopedFocus();
	  },
	
	  handleKeyDown: function(event) {
	    if (event.keyCode == 9 /*tab*/) scopeTab(this.refs.content, event);
	    if (event.keyCode == 27 /*esc*/) {
	      event.preventDefault();
	      this.requestClose(event);
	    }
	  },
	
	  handleOverlayMouseDown: function(event) {
	    if (this.shouldClose === null) {
	      this.shouldClose = true;
	    }
	  },
	
	  handleOverlayMouseUp: function(event) {
	    if (this.shouldClose && this.props.shouldCloseOnOverlayClick) {
	      if (this.ownerHandlesClose())
	        this.requestClose(event);
	      else
	        this.focusContent();
	    }
	    this.shouldClose = null;
	  },
	
	  handleContentMouseDown: function(event) {
	    this.shouldClose = false;
	  },
	
	  handleContentMouseUp: function(event) {
	    this.shouldClose = false;
	  },
	
	  requestClose: function(event) {
	    if (this.ownerHandlesClose())
	      this.props.onRequestClose(event);
	  },
	
	  ownerHandlesClose: function() {
	    return this.props.onRequestClose;
	  },
	
	  shouldBeClosed: function() {
	    return !this.props.isOpen && !this.state.beforeClose;
	  },
	
	  contentHasFocus: function() {
	    return document.activeElement === this.refs.content || this.refs.content.contains(document.activeElement);
	  },
	
	  buildClassName: function(which, additional) {
	    var className = CLASS_NAMES[which].base;
	    if (this.state.afterOpen)
	      className += ' '+CLASS_NAMES[which].afterOpen;
	    if (this.state.beforeClose)
	      className += ' '+CLASS_NAMES[which].beforeClose;
	    return additional ? className + ' ' + additional : className;
	  },
	
	  render: function() {
	    var contentStyles = (this.props.className) ? {} : this.props.defaultStyles.content;
	    var overlayStyles = (this.props.overlayClassName) ? {} : this.props.defaultStyles.overlay;
	
	    return this.shouldBeClosed() ? div() : (
	      div({
	        ref: "overlay",
	        className: this.buildClassName('overlay', this.props.overlayClassName),
	        style: Assign({}, overlayStyles, this.props.style.overlay || {}),
	        onMouseDown: this.handleOverlayMouseDown,
	        onMouseUp: this.handleOverlayMouseUp
	      },
	        div({
	          ref: "content",
	          style: Assign({}, contentStyles, this.props.style.content || {}),
	          className: this.buildClassName('content', this.props.className),
	          tabIndex: "-1",
	          onKeyDown: this.handleKeyDown,
	          onMouseDown: this.handleContentMouseDown,
	          onMouseUp: this.handleContentMouseUp,
	          role: this.props.role
	        },
	          this.props.children
	        )
	      )
	    );
	  }
	});


/***/ },
/* 282 */
/***/ function(module, exports) {

	var _element = typeof document !== 'undefined' ? document.body : null;
	
	function setElement(element) {
	  if (typeof element === 'string') {
	    var el = document.querySelectorAll(element);
	    element = 'length' in el ? el[0] : el;
	  }
	  _element = element || _element;
	  return _element;
	}
	
	function hide(appElement) {
	  validateElement(appElement);
	  (appElement || _element).setAttribute('aria-hidden', 'true');
	}
	
	function show(appElement) {
	  validateElement(appElement);
	  (appElement || _element).removeAttribute('aria-hidden');
	}
	
	function toggle(shouldHide, appElement) {
	  if (shouldHide)
	    hide(appElement);
	  else
	    show(appElement);
	}
	
	function validateElement(appElement) {
	  if (!appElement && !_element)
	    throw new Error('react-modal: You must set an element with `Modal.setAppElement(el)` to make this accessible');
	}
	
	function resetForTesting() {
	  _element = document.body;
	}
	
	exports.toggle = toggle;
	exports.setElement = setElement;
	exports.show = show;
	exports.hide = hide;
	exports.resetForTesting = resetForTesting;


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(102);
	var modalElement = null;
	var focusLaterElement = null;
	var needToFocus = false;
	
	function handleBlur(event) {
	  needToFocus = true;
	}
	
	function handleFocus(event) {
	  if (needToFocus) {
	    needToFocus = false;
	    if (!modalElement) {
	      return;
	    }
	    // need to see how jQuery shims document.on('focusin') so we don't need the
	    // setTimeout, firefox doesn't support focusin, if it did, we could focus
	    // the element outside of a setTimeout. Side-effect of this implementation 
	    // is that the document.body gets focus, and then we focus our element right 
	    // after, seems fine.
	    setTimeout(function() {
	      if (modalElement.contains(document.activeElement))
	        return;
	      var el = (findTabbable(modalElement)[0] || modalElement);
	      el.focus();
	    }, 0);
	  }
	}
	
	exports.markForFocusLater = function() {
	  focusLaterElement = document.activeElement;
	};
	
	exports.returnFocus = function() {
	  try {
	    focusLaterElement.focus();
	  }
	  catch (e) {
	    console.warn('You tried to return focus to '+focusLaterElement+' but it is not in the DOM anymore');
	  }
	  focusLaterElement = null;
	};
	
	exports.setupScopedFocus = function(element) {
	  modalElement = element;
	
	  if (window.addEventListener) {
	    window.addEventListener('blur', handleBlur, false);
	    document.addEventListener('focus', handleFocus, true);
	  } else {
	    window.attachEvent('onBlur', handleBlur);
	    document.attachEvent('onFocus', handleFocus);
	  }
	};
	
	exports.teardownScopedFocus = function() {
	  modalElement = null;
	
	  if (window.addEventListener) {
	    window.removeEventListener('blur', handleBlur);
	    document.removeEventListener('focus', handleFocus);
	  } else {
	    window.detachEvent('onBlur', handleBlur);
	    document.detachEvent('onFocus', handleFocus);
	  }
	};
	
	


/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	var findTabbable = __webpack_require__(102);
	
	module.exports = function(node, event) {
	  var tabbable = findTabbable(node);
	  if (!tabbable.length) {
	      event.preventDefault();
	      return;
	  }
	  var finalTabbable = tabbable[event.shiftKey ? 0 : tabbable.length - 1];
	  var leavingFinalTabbable = (
	    finalTabbable === document.activeElement ||
	    // handle immediate shift+tab after opening with mouse
	    node === document.activeElement
	  );
	  if (!leavingFinalTabbable) return;
	  event.preventDefault();
	  var target = tabbable[event.shiftKey ? tabbable.length - 1 : 0];
	  target.focus();
	};


/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(280);
	


/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(104);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(105);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    return _react.Children.only(this.props.children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(104);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(289);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(290);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(105);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(55);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(253);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(99);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = void 0;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure,
	      pure = _options$pure === undefined ? true : _options$pure,
	      _options$withRef = options.withRef,
	      withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged,
	            hasStoreStateChanged = this.hasStoreStateChanged,
	            haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated,
	            statePropsPrecalculationError = this.statePropsPrecalculationError,
	            renderedElement = this.renderedElement;
	
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(286);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(287);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 289 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(134);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	(function webpackUniversalModuleDefinition(root, factory) {
		if(true)
			module.exports = factory(__webpack_require__(1));
		else if(typeof define === 'function' && define.amd)
			define(["react"], factory);
		else {
			var a = typeof exports === 'object' ? factory(require("react")) : factory(root["React"]);
			for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
		}
	})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
	return /******/ (function(modules) { // webpackBootstrap
	/******/ 	// The module cache
	/******/ 	var installedModules = {};
	
	/******/ 	// The require function
	/******/ 	function __webpack_require__(moduleId) {
	
	/******/ 		// Check if module is in cache
	/******/ 		if(installedModules[moduleId])
	/******/ 			return installedModules[moduleId].exports;
	
	/******/ 		// Create a new module (and put it into the cache)
	/******/ 		var module = installedModules[moduleId] = {
	/******/ 			exports: {},
	/******/ 			id: moduleId,
	/******/ 			loaded: false
	/******/ 		};
	
	/******/ 		// Execute the module function
	/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
	
	/******/ 		// Flag the module as loaded
	/******/ 		module.loaded = true;
	
	/******/ 		// Return the exports of the module
	/******/ 		return module.exports;
	/******/ 	}
	
	
	/******/ 	// expose the modules object (__webpack_modules__)
	/******/ 	__webpack_require__.m = modules;
	
	/******/ 	// expose the module cache
	/******/ 	__webpack_require__.c = installedModules;
	
	/******/ 	// __webpack_public_path__
	/******/ 	__webpack_require__.p = "";
	
	/******/ 	// Load entry module and return exports
	/******/ 	return __webpack_require__(0);
	/******/ })
	/************************************************************************/
	/******/ ([
	/* 0 */
	/***/ function(module, exports, __webpack_require__) {
	
		'use strict';
	
		Object.defineProperty(exports, "__esModule", {
		  value: true
		});
	
		var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
		var _react = __webpack_require__(1);
	
		var _react2 = _interopRequireDefault(_react);
	
		var _svgInjector = __webpack_require__(2);
	
		var _svgInjector2 = _interopRequireDefault(_svgInjector);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
		function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
		function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
		var ReactSVG = function (_Component) {
		  _inherits(ReactSVG, _Component);
	
		  function ReactSVG() {
		    _classCallCheck(this, ReactSVG);
	
		    return _possibleConstructorReturn(this, (ReactSVG.__proto__ || Object.getPrototypeOf(ReactSVG)).apply(this, arguments));
		  }
	
		  _createClass(ReactSVG, [{
		    key: 'render',
		    value: function render() {
		      var _this2 = this;
	
		      var _props = this.props;
		      var className = _props.className;
		      var path = _props.path;
		      var fallbackPath = _props.fallbackPath;
	
	
		      return _react2.default.createElement('img', {
		        className: className,
		        'data-src': path,
		        'data-fallback': fallbackPath,
		        ref: function ref(img) {
		          return _this2._img = img;
		        }
		      });
		    }
		  }, {
		    key: 'componentDidMount',
		    value: function componentDidMount() {
		      this.updateSVG();
		    }
		  }, {
		    key: 'componentDidUpdate',
		    value: function componentDidUpdate() {
		      this.updateSVG();
		    }
		  }, {
		    key: 'updateSVG',
		    value: function updateSVG() {
		      var _props2 = this.props;
		      var evalScripts = _props2.evalScripts;
		      var each = _props2.callback;
	
	
		      (0, _svgInjector2.default)(this._img, {
		        evalScripts: evalScripts,
		        each: each
		      });
		    }
		  }]);
	
		  return ReactSVG;
		}(_react.Component);
	
		ReactSVG.defaultProps = {
		  evalScripts: 'never',
		  callback: function callback() {}
		};
		ReactSVG.propTypes = {
		  path: _react.PropTypes.string.isRequired,
		  className: _react.PropTypes.string,
		  evalScripts: _react.PropTypes.oneOf(['always', 'once', 'never']),
		  fallbackPath: _react.PropTypes.string,
		  callback: _react.PropTypes.func
		};
		exports.default = ReactSVG;
	
	/***/ },
	/* 1 */
	/***/ function(module, exports) {
	
		module.exports = __WEBPACK_EXTERNAL_MODULE_1__;
	
	/***/ },
	/* 2 */
	/***/ function(module, exports, __webpack_require__) {
	
		var __WEBPACK_AMD_DEFINE_RESULT__;/**
		 * SVGInjector v1.1.3 - Fast, caching, dynamic inline SVG DOM injection library
		 * https://github.com/iconic/SVGInjector
		 *
		 * Copyright (c) 2014-2015 Waybury <hello@waybury.com>
		 * @license MIT
		 */
	
		(function (window, document) {
	
		  'use strict';
	
		  // Environment
		  var isLocal = window.location.protocol === 'file:';
		  var hasSvgSupport = document.implementation.hasFeature('http://www.w3.org/TR/SVG11/feature#BasicStructure', '1.1');
	
		  function uniqueClasses(list) {
		    list = list.split(' ');
	
		    var hash = {};
		    var i = list.length;
		    var out = [];
	
		    while (i--) {
		      if (!hash.hasOwnProperty(list[i])) {
		        hash[list[i]] = 1;
		        out.unshift(list[i]);
		      }
		    }
	
		    return out.join(' ');
		  }
	
		  /**
		   * cache (or polyfill for <= IE8) Array.forEach()
		   * source: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
		   */
		  var forEach = Array.prototype.forEach || function (fn, scope) {
		    if (this === void 0 || this === null || typeof fn !== 'function') {
		      throw new TypeError();
		    }
	
		    /* jshint bitwise: false */
		    var i, len = this.length >>> 0;
		    /* jshint bitwise: true */
	
		    for (i = 0; i < len; ++i) {
		      if (i in this) {
		        fn.call(scope, this[i], i, this);
		      }
		    }
		  };
	
		  // SVG Cache
		  var svgCache = {};
	
		  var injectCount = 0;
		  var injectedElements = [];
	
		  // Request Queue
		  var requestQueue = [];
	
		  // Script running status
		  var ranScripts = {};
	
		  var cloneSvg = function (sourceSvg) {
		    return sourceSvg.cloneNode(true);
		  };
	
		  var queueRequest = function (url, callback) {
		    requestQueue[url] = requestQueue[url] || [];
		    requestQueue[url].push(callback);
		  };
	
		  var processRequestQueue = function (url) {
		    for (var i = 0, len = requestQueue[url].length; i < len; i++) {
		      // Make these calls async so we avoid blocking the page/renderer
		      /* jshint loopfunc: true */
		      (function (index) {
		        setTimeout(function () {
		          requestQueue[url][index](cloneSvg(svgCache[url]));
		        }, 0);
		      })(i);
		      /* jshint loopfunc: false */
		    }
		  };
	
		  var loadSvg = function (url, callback) {
		    if (svgCache[url] !== undefined) {
		      if (svgCache[url] instanceof SVGSVGElement) {
		        // We already have it in cache, so use it
		        callback(cloneSvg(svgCache[url]));
		      }
		      else {
		        // We don't have it in cache yet, but we are loading it, so queue this request
		        queueRequest(url, callback);
		      }
		    }
		    else {
	
		      if (!window.XMLHttpRequest) {
		        callback('Browser does not support XMLHttpRequest');
		        return false;
		      }
	
		      // Seed the cache to indicate we are loading this URL already
		      svgCache[url] = {};
		      queueRequest(url, callback);
	
		      var httpRequest = new XMLHttpRequest();
	
		      httpRequest.onreadystatechange = function () {
		        // readyState 4 = complete
		        if (httpRequest.readyState === 4) {
	
		          // Handle status
		          if (httpRequest.status === 404 || httpRequest.responseXML === null) {
		            callback('Unable to load SVG file: ' + url);
	
		            if (isLocal) callback('Note: SVG injection ajax calls do not work locally without adjusting security setting in your browser. Or consider using a local webserver.');
	
		            callback();
		            return false;
		          }
	
		          // 200 success from server, or 0 when using file:// protocol locally
		          if (httpRequest.status === 200 || (isLocal && httpRequest.status === 0)) {
	
		            /* globals Document */
		            if (httpRequest.responseXML instanceof Document) {
		              // Cache it
		              svgCache[url] = httpRequest.responseXML.documentElement;
		            }
		            /* globals -Document */
	
		            // IE9 doesn't create a responseXML Document object from loaded SVG,
		            // and throws a "DOM Exception: HIERARCHY_REQUEST_ERR (3)" error when injected.
		            //
		            // So, we'll just create our own manually via the DOMParser using
		            // the the raw XML responseText.
		            //
		            // :NOTE: IE8 and older doesn't have DOMParser, but they can't do SVG either, so...
		            else if (DOMParser && (DOMParser instanceof Function)) {
		              var xmlDoc;
		              try {
		                var parser = new DOMParser();
		                xmlDoc = parser.parseFromString(httpRequest.responseText, 'text/xml');
		              }
		              catch (e) {
		                xmlDoc = undefined;
		              }
	
		              if (!xmlDoc || xmlDoc.getElementsByTagName('parsererror').length) {
		                callback('Unable to parse SVG file: ' + url);
		                return false;
		              }
		              else {
		                // Cache it
		                svgCache[url] = xmlDoc.documentElement;
		              }
		            }
	
		            // We've loaded a new asset, so process any requests waiting for it
		            processRequestQueue(url);
		          }
		          else {
		            callback('There was a problem injecting the SVG: ' + httpRequest.status + ' ' + httpRequest.statusText);
		            return false;
		          }
		        }
		      };
	
		      httpRequest.open('GET', url);
	
		      // Treat and parse the response as XML, even if the
		      // server sends us a different mimetype
		      if (httpRequest.overrideMimeType) httpRequest.overrideMimeType('text/xml');
	
		      httpRequest.send();
		    }
		  };
	
		  // Inject a single element
		  var injectElement = function (el, evalScripts, pngFallback, callback) {
	
		    // Grab the src or data-src attribute
		    var imgUrl = el.getAttribute('data-src') || el.getAttribute('src');
	
		    // We can only inject SVG
		    if (!(/\.svg/i).test(imgUrl)) {
		      callback('Attempted to inject a file with a non-svg extension: ' + imgUrl);
		      return;
		    }
	
		    // If we don't have SVG support try to fall back to a png,
		    // either defined per-element via data-fallback or data-png,
		    // or globally via the pngFallback directory setting
		    if (!hasSvgSupport) {
		      var perElementFallback = el.getAttribute('data-fallback') || el.getAttribute('data-png');
	
		      // Per-element specific PNG fallback defined, so use that
		      if (perElementFallback) {
		        el.setAttribute('src', perElementFallback);
		        callback(null);
		      }
		      // Global PNG fallback directoriy defined, use the same-named PNG
		      else if (pngFallback) {
		        el.setAttribute('src', pngFallback + '/' + imgUrl.split('/').pop().replace('.svg', '.png'));
		        callback(null);
		      }
		      // um...
		      else {
		        callback('This browser does not support SVG and no PNG fallback was defined.');
		      }
	
		      return;
		    }
	
		    // Make sure we aren't already in the process of injecting this element to
		    // avoid a race condition if multiple injections for the same element are run.
		    // :NOTE: Using indexOf() only _after_ we check for SVG support and bail,
		    // so no need for IE8 indexOf() polyfill
		    if (injectedElements.indexOf(el) !== -1) {
		      return;
		    }
	
		    // Remember the request to inject this element, in case other injection
		    // calls are also trying to replace this element before we finish
		    injectedElements.push(el);
	
		    // Try to avoid loading the orginal image src if possible.
		    el.setAttribute('src', '');
	
		    // Load it up
		    loadSvg(imgUrl, function (svg) {
	
		      if (typeof svg === 'undefined' || typeof svg === 'string') {
		        callback(svg);
		        return false;
		      }
	
		      var imgId = el.getAttribute('id');
		      if (imgId) {
		        svg.setAttribute('id', imgId);
		      }
	
		      var imgTitle = el.getAttribute('title');
		      if (imgTitle) {
		        svg.setAttribute('title', imgTitle);
		      }
	
		      // Concat the SVG classes + 'injected-svg' + the img classes
		      var classMerge = [].concat(svg.getAttribute('class') || [], 'injected-svg', el.getAttribute('class') || []).join(' ');
		      svg.setAttribute('class', uniqueClasses(classMerge));
	
		      var imgStyle = el.getAttribute('style');
		      if (imgStyle) {
		        svg.setAttribute('style', imgStyle);
		      }
	
		      // Copy all the data elements to the svg
		      var imgData = [].filter.call(el.attributes, function (at) {
		        return (/^data-\w[\w\-]*$/).test(at.name);
		      });
		      forEach.call(imgData, function (dataAttr) {
		        if (dataAttr.name && dataAttr.value) {
		          svg.setAttribute(dataAttr.name, dataAttr.value);
		        }
		      });
	
		      // Make sure any internally referenced clipPath ids and their
		      // clip-path references are unique.
		      //
		      // This addresses the issue of having multiple instances of the
		      // same SVG on a page and only the first clipPath id is referenced.
		      //
		      // Browsers often shortcut the SVG Spec and don't use clipPaths
		      // contained in parent elements that are hidden, so if you hide the first
		      // SVG instance on the page, then all other instances lose their clipping.
		      // Reference: https://bugzilla.mozilla.org/show_bug.cgi?id=376027
	
		      // Handle all defs elements that have iri capable attributes as defined by w3c: http://www.w3.org/TR/SVG/linking.html#processingIRI
		      // Mapping IRI addressable elements to the properties that can reference them:
		      var iriElementsAndProperties = {
		        'clipPath': ['clip-path'],
		        'color-profile': ['color-profile'],
		        'cursor': ['cursor'],
		        'filter': ['filter'],
		        'linearGradient': ['fill', 'stroke'],
		        'marker': ['marker', 'marker-start', 'marker-mid', 'marker-end'],
		        'mask': ['mask'],
		        'pattern': ['fill', 'stroke'],
		        'radialGradient': ['fill', 'stroke']
		      };
	
		      var element, elementDefs, properties, currentId, newId;
		      Object.keys(iriElementsAndProperties).forEach(function (key) {
		        element = key;
		        properties = iriElementsAndProperties[key];
	
		        elementDefs = svg.querySelectorAll('defs ' + element + '[id]');
		        for (var i = 0, elementsLen = elementDefs.length; i < elementsLen; i++) {
		          currentId = elementDefs[i].id;
		          newId = currentId + '-' + injectCount;
	
		          // All of the properties that can reference this element type
		          var referencingElements;
		          forEach.call(properties, function (property) {
		            // :NOTE: using a substring match attr selector here to deal with IE "adding extra quotes in url() attrs"
		            referencingElements = svg.querySelectorAll('[' + property + '*="' + currentId + '"]');
		            for (var j = 0, referencingElementLen = referencingElements.length; j < referencingElementLen; j++) {
		              referencingElements[j].setAttribute(property, 'url(#' + newId + ')');
		            }
		          });
	
		          elementDefs[i].id = newId;
		        }
		      });
	
		      // Remove any unwanted/invalid namespaces that might have been added by SVG editing tools
		      svg.removeAttribute('xmlns:a');
	
		      // Post page load injected SVGs don't automatically have their script
		      // elements run, so we'll need to make that happen, if requested
	
		      // Find then prune the scripts
		      var scripts = svg.querySelectorAll('script');
		      var scriptsToEval = [];
		      var script, scriptType;
	
		      for (var k = 0, scriptsLen = scripts.length; k < scriptsLen; k++) {
		        scriptType = scripts[k].getAttribute('type');
	
		        // Only process javascript types.
		        // SVG defaults to 'application/ecmascript' for unset types
		        if (!scriptType || scriptType === 'application/ecmascript' || scriptType === 'application/javascript') {
	
		          // innerText for IE, textContent for other browsers
		          script = scripts[k].innerText || scripts[k].textContent;
	
		          // Stash
		          scriptsToEval.push(script);
	
		          // Tidy up and remove the script element since we don't need it anymore
		          svg.removeChild(scripts[k]);
		        }
		      }
	
		      // Run/Eval the scripts if needed
		      if (scriptsToEval.length > 0 && (evalScripts === 'always' || (evalScripts === 'once' && !ranScripts[imgUrl]))) {
		        for (var l = 0, scriptsToEvalLen = scriptsToEval.length; l < scriptsToEvalLen; l++) {
	
		          // :NOTE: Yup, this is a form of eval, but it is being used to eval code
		          // the caller has explictely asked to be loaded, and the code is in a caller
		          // defined SVG file... not raw user input.
		          //
		          // Also, the code is evaluated in a closure and not in the global scope.
		          // If you need to put something in global scope, use 'window'
		          new Function(scriptsToEval[l])(window); // jshint ignore:line
		        }
	
		        // Remember we already ran scripts for this svg
		        ranScripts[imgUrl] = true;
		      }
	
		      // :WORKAROUND:
		      // IE doesn't evaluate <style> tags in SVGs that are dynamically added to the page.
		      // This trick will trigger IE to read and use any existing SVG <style> tags.
		      //
		      // Reference: https://github.com/iconic/SVGInjector/issues/23
		      var styleTags = svg.querySelectorAll('style');
		      forEach.call(styleTags, function (styleTag) {
		        styleTag.textContent += '';
		      });
	
		      // Replace the image with the svg
		      el.parentNode.replaceChild(svg, el);
	
		      // Now that we no longer need it, drop references
		      // to the original element so it can be GC'd
		      delete injectedElements[injectedElements.indexOf(el)];
		      el = null;
	
		      // Increment the injected count
		      injectCount++;
	
		      callback(svg);
		    });
		  };
	
		  /**
		   * SVGInjector
		   *
		   * Replace the given elements with their full inline SVG DOM elements.
		   *
		   * :NOTE: We are using get/setAttribute with SVG because the SVG DOM spec differs from HTML DOM and
		   * can return other unexpected object types when trying to directly access svg properties.
		   * ex: "className" returns a SVGAnimatedString with the class value found in the "baseVal" property,
		   * instead of simple string like with HTML Elements.
		   *
		   * @param {mixes} Array of or single DOM element
		   * @param {object} options
		   * @param {function} callback
		   * @return {object} Instance of SVGInjector
		   */
		  var SVGInjector = function (elements, options, done) {
	
		    // Options & defaults
		    options = options || {};
	
		    // Should we run the scripts blocks found in the SVG
		    // 'always' - Run them every time
		    // 'once' - Only run scripts once for each SVG
		    // [false|'never'] - Ignore scripts
		    var evalScripts = options.evalScripts || 'always';
	
		    // Location of fallback pngs, if desired
		    var pngFallback = options.pngFallback || false;
	
		    // Callback to run during each SVG injection, returning the SVG injected
		    var eachCallback = options.each;
	
		    // Do the injection...
		    if (elements.length !== undefined) {
		      var elementsLoaded = 0;
		      forEach.call(elements, function (element) {
		        injectElement(element, evalScripts, pngFallback, function (svg) {
		          if (eachCallback && typeof eachCallback === 'function') eachCallback(svg);
		          if (done && elements.length === ++elementsLoaded) done(elementsLoaded);
		        });
		      });
		    }
		    else {
		      if (elements) {
		        injectElement(elements, evalScripts, pngFallback, function (svg) {
		          if (eachCallback && typeof eachCallback === 'function') eachCallback(svg);
		          if (done) done(1);
		          elements = null;
		        });
		      }
		      else {
		        if (done) done(0);
		      }
		    }
		  };
	
		  /* global module, exports: true, define */
		  // Node.js or CommonJS
		  if (typeof module === 'object' && typeof module.exports === 'object') {
		    module.exports = exports = SVGInjector;
		  }
		  // AMD support
		  else if (true) {
		    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
		      return SVGInjector;
		    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		  }
		  // Otherwise, attach to window as global
		  else if (typeof window === 'object') {
		    window.SVGInjector = SVGInjector;
		  }
		  /* global -module, -exports, -define */
	
		}(window, document));
	
	
	/***/ }
	/******/ ])
	});
	;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }
	
	var _objectAssign = __webpack_require__(293);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var truthy = function truthy(x) {
	  return x;
	};
	
	exports['default'] = function (input) {
	  var _ref = Array.isArray(input) && input.length === 2 ? input : [input, null];
	
	  var _ref2 = _slicedToArray(_ref, 2);
	
	  var theme = _ref2[0];
	  var classNameDecorator = _ref2[1];
	
	  return function (key) {
	    for (var _len = arguments.length, names = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      names[_key - 1] = arguments[_key];
	    }
	
	    var styles = names.map(function (name) {
	      return theme[name];
	    }).filter(truthy);
	
	    return typeof styles[0] === 'string' || typeof classNameDecorator === 'function' ? { key: key, className: classNameDecorator ? classNameDecorator.apply(undefined, _toConsumableArray(styles)) : styles.join(' ') } : { key: key, style: _objectAssign2['default'].apply(undefined, [{}].concat(_toConsumableArray(styles))) };
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports) {

	'use strict';
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function ToObject(val) {
		if (val == null) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function ownEnumerableKeys(obj) {
		var keys = Object.getOwnPropertyNames(obj);
	
		if (Object.getOwnPropertySymbols) {
			keys = keys.concat(Object.getOwnPropertySymbols(obj));
		}
	
		return keys.filter(function (key) {
			return propIsEnumerable.call(obj, key);
		});
	}
	
	module.exports = Object.assign || function (target, source) {
		var from;
		var keys;
		var to = ToObject(target);
	
		for (var s = 1; s < arguments.length; s++) {
			from = arguments[s];
			keys = ownEnumerableKeys(Object(from));
	
			for (var i = 0; i < keys.length; i++) {
				to[keys[i]] = from[keys[i]];
			}
		}
	
		return to;
	};


/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var focusNode = __webpack_require__(97);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventPropagators = __webpack_require__(33);
	var ExecutionEnvironment = __webpack_require__(9);
	var FallbackCompositionState = __webpack_require__(301);
	var SyntheticCompositionEvent = __webpack_require__(339);
	var SyntheticInputEvent = __webpack_require__(342);
	
	var keyOf = __webpack_require__(18);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(106);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactInstrumentation = __webpack_require__(11);
	
	var camelizeStyleName = __webpack_require__(240);
	var dangerousStyleValue = __webpack_require__(349);
	var hyphenateStyleName = __webpack_require__(247);
	var memoizeStringOnly = __webpack_require__(250);
	var warning = __webpack_require__(6);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventPluginHub = __webpack_require__(32);
	var EventPropagators = __webpack_require__(33);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(15);
	var SyntheticEvent = __webpack_require__(17);
	
	var getEventTarget = __webpack_require__(77);
	var isEventSupported = __webpack_require__(78);
	var isTextInputElement = __webpack_require__(130);
	var keyOf = __webpack_require__(18);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var DOMLazyTree = __webpack_require__(24);
	var ExecutionEnvironment = __webpack_require__(9);
	
	var createNodesFromMarkup = __webpack_require__(243);
	var emptyFunction = __webpack_require__(10);
	var invariant = __webpack_require__(2);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(18);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventPropagators = __webpack_require__(33);
	var ReactDOMComponentTree = __webpack_require__(8);
	var SyntheticMouseEvent = __webpack_require__(44);
	
	var keyOf = __webpack_require__(18);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(19);
	
	var getTextContentAccessor = __webpack_require__(128);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(25);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactChildren = __webpack_require__(109);
	var ReactComponent = __webpack_require__(65);
	var ReactPureComponent = __webpack_require__(329);
	var ReactClass = __webpack_require__(110);
	var ReactDOMFactories = __webpack_require__(312);
	var ReactElement = __webpack_require__(14);
	var ReactPropTypes = __webpack_require__(120);
	var ReactVersion = __webpack_require__(121);
	
	var onlyChild = __webpack_require__(355);
	var warning = __webpack_require__(6);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(26);
	
	var instantiateReactComponent = __webpack_require__(129);
	var KeyEscapeUtils = __webpack_require__(63);
	var shouldUpdateReactComponent = __webpack_require__(79);
	var traverseAllChildren = __webpack_require__(80);
	var warning = __webpack_require__(6);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(67);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('./ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // 0 in production and for roots
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID // 0 in production and for roots
	  ) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(59);
	var ReactDOMIDOperations = __webpack_require__(314);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var ReactComponentEnvironment = __webpack_require__(66);
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactElement = __webpack_require__(14);
	var ReactErrorUtils = __webpack_require__(68);
	var ReactInstanceMap = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactNodeTypes = __webpack_require__(119);
	var ReactPropTypeLocations = __webpack_require__(71);
	var ReactReconciler = __webpack_require__(26);
	
	var checkReactTypeSpec = __webpack_require__(348);
	var emptyObject = __webpack_require__(31);
	var invariant = __webpack_require__(2);
	var shallowEqual = __webpack_require__(52);
	var shouldUpdateReactComponent = __webpack_require__(79);
	var warning = __webpack_require__(6);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedComponent;
	
	    if (false) {
	      renderedComponent = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedComponent = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDefaultInjection = __webpack_require__(322);
	var ReactMount = __webpack_require__(117);
	var ReactReconciler = __webpack_require__(26);
	var ReactUpdates = __webpack_require__(15);
	var ReactVersion = __webpack_require__(121);
	
	var findDOMNode = __webpack_require__(350);
	var getHostComponentFromComposite = __webpack_require__(126);
	var renderSubtreeIntoContainer = __webpack_require__(357);
	var warning = __webpack_require__(6);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(42);
	
	/**
	 * Implements a <button> host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getHostProps: DisabledInputUtils.getHostProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var AutoFocusUtils = __webpack_require__(294);
	var CSSPropertyOperations = __webpack_require__(296);
	var DOMLazyTree = __webpack_require__(24);
	var DOMNamespaces = __webpack_require__(60);
	var DOMProperty = __webpack_require__(25);
	var DOMPropertyOperations = __webpack_require__(108);
	var EventConstants = __webpack_require__(16);
	var EventPluginHub = __webpack_require__(32);
	var EventPluginRegistry = __webpack_require__(61);
	var ReactBrowserEventEmitter = __webpack_require__(43);
	var ReactDOMButton = __webpack_require__(308);
	var ReactDOMComponentFlags = __webpack_require__(111);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMInput = __webpack_require__(315);
	var ReactDOMOption = __webpack_require__(316);
	var ReactDOMSelect = __webpack_require__(112);
	var ReactDOMTextarea = __webpack_require__(319);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactMultiChild = __webpack_require__(327);
	var ReactServerRenderingTransaction = __webpack_require__(332);
	
	var emptyFunction = __webpack_require__(10);
	var escapeTextContentForBrowser = __webpack_require__(45);
	var invariant = __webpack_require__(2);
	var isEventSupported = __webpack_require__(78);
	var keyOf = __webpack_require__(18);
	var shallowEqual = __webpack_require__(52);
	var validateDOMNesting = __webpack_require__(81);
	var warning = __webpack_require__(6);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getHostProps(this, props, hostParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getHostProps(this, lastProps);
	        nextProps = ReactDOMButton.getHostProps(this, nextProps);
	        break;
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(81);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var DOMLazyTree = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(14);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 313 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(59);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var DisabledInputUtils = __webpack_require__(42);
	var DOMPropertyOperations = __webpack_require__(108);
	var LinkedValueUtils = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(15);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, DisabledInputUtils.getHostProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactChildren = __webpack_require__(109);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMSelect = __webpack_require__(112);
	
	var warning = __webpack_require__(6);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  ReactChildren.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	var getNodeForCharacterOffset = __webpack_require__(353);
	var getTextContentAccessor = __webpack_require__(128);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var DOMChildrenOperations = __webpack_require__(59);
	var DOMLazyTree = __webpack_require__(24);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var escapeTextContentForBrowser = __webpack_require__(45);
	var invariant = __webpack_require__(2);
	var validateDOMNesting = __webpack_require__(81);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5),
	    _assign = __webpack_require__(7);
	
	var DisabledInputUtils = __webpack_require__(42);
	var LinkedValueUtils = __webpack_require__(64);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(15);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactUpdates = __webpack_require__(15);
	var Transaction = __webpack_require__(36);
	
	var emptyFunction = __webpack_require__(10);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(295);
	var ChangeEventPlugin = __webpack_require__(297);
	var DefaultEventPluginOrder = __webpack_require__(299);
	var EnterLeaveEventPlugin = __webpack_require__(300);
	var HTMLDOMPropertyConfig = __webpack_require__(302);
	var ReactComponentBrowserEnvironment = __webpack_require__(305);
	var ReactDOMComponent = __webpack_require__(309);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMEmptyComponent = __webpack_require__(311);
	var ReactDOMTreeTraversal = __webpack_require__(320);
	var ReactDOMTextComponent = __webpack_require__(318);
	var ReactDefaultBatchingStrategy = __webpack_require__(321);
	var ReactEventListener = __webpack_require__(324);
	var ReactInjection = __webpack_require__(325);
	var ReactReconcileTransaction = __webpack_require__(330);
	var SVGDOMPropertyConfig = __webpack_require__(334);
	var SelectEventPlugin = __webpack_require__(335);
	var SimpleEventPlugin = __webpack_require__(336);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(32);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventListener = __webpack_require__(96);
	var ExecutionEnvironment = __webpack_require__(9);
	var PooledClass = __webpack_require__(19);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(15);
	
	var getEventTarget = __webpack_require__(77);
	var getUnboundedScrollPosition = __webpack_require__(245);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(25);
	var EventPluginHub = __webpack_require__(32);
	var EventPluginUtils = __webpack_require__(62);
	var ReactComponentEnvironment = __webpack_require__(66);
	var ReactClass = __webpack_require__(110);
	var ReactEmptyComponent = __webpack_require__(113);
	var ReactBrowserEventEmitter = __webpack_require__(43);
	var ReactHostComponent = __webpack_require__(115);
	var ReactUpdates = __webpack_require__(15);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(347);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactComponentEnvironment = __webpack_require__(66);
	var ReactInstanceMap = __webpack_require__(34);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactMultiChildUpdateTypes = __webpack_require__(118);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactReconciler = __webpack_require__(26);
	var ReactChildReconciler = __webpack_require__(304);
	
	var emptyFunction = __webpack_require__(10);
	var flattenChildren = __webpack_require__(351);
	var invariant = __webpack_require__(2);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPureComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactComponent = __webpack_require__(65);
	var ReactNoopUpdateQueue = __webpack_require__(69);
	
	var emptyObject = __webpack_require__(31);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = ReactPureComponent;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(107);
	var PooledClass = __webpack_require__(19);
	var ReactBrowserEventEmitter = __webpack_require__(43);
	var ReactInputSelection = __webpack_require__(116);
	var ReactInstrumentation = __webpack_require__(11);
	var Transaction = __webpack_require__(36);
	var ReactUpdateQueue = __webpack_require__(73);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(328);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return (
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement.ref !== prevElement.ref ||
	    // If owner changes but we have an unchanged function ref, don't update refs
	    typeof nextElement.ref === 'string' && nextElement._owner !== prevElement._owner
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(19);
	var Transaction = __webpack_require__(36);
	var ReactInstrumentation = __webpack_require__(11);
	var ReactServerUpdateQueue = __webpack_require__(333);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerUpdateQueue
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(73);
	var Transaction = __webpack_require__(36);
	var warning = __webpack_require__(6);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  /* :: transaction: Transaction; */
	
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 334 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(16);
	var EventPropagators = __webpack_require__(33);
	var ExecutionEnvironment = __webpack_require__(9);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInputSelection = __webpack_require__(116);
	var SyntheticEvent = __webpack_require__(17);
	
	var getActiveElement = __webpack_require__(98);
	var isTextInputElement = __webpack_require__(130);
	var keyOf = __webpack_require__(18);
	var shallowEqual = __webpack_require__(52);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var EventConstants = __webpack_require__(16);
	var EventListener = __webpack_require__(96);
	var EventPropagators = __webpack_require__(33);
	var ReactDOMComponentTree = __webpack_require__(8);
	var SyntheticAnimationEvent = __webpack_require__(337);
	var SyntheticClipboardEvent = __webpack_require__(338);
	var SyntheticEvent = __webpack_require__(17);
	var SyntheticFocusEvent = __webpack_require__(341);
	var SyntheticKeyboardEvent = __webpack_require__(343);
	var SyntheticMouseEvent = __webpack_require__(44);
	var SyntheticDragEvent = __webpack_require__(340);
	var SyntheticTouchEvent = __webpack_require__(344);
	var SyntheticTransitionEvent = __webpack_require__(345);
	var SyntheticUIEvent = __webpack_require__(35);
	var SyntheticWheelEvent = __webpack_require__(346);
	
	var emptyFunction = __webpack_require__(10);
	var getEventCharCode = __webpack_require__(75);
	var invariant = __webpack_require__(2);
	var keyOf = __webpack_require__(18);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(17);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(17);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(17);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(44);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(35);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(17);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(35);
	
	var getEventCharCode = __webpack_require__(75);
	var getEventKey = __webpack_require__(352);
	var getEventModifierState = __webpack_require__(76);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(35);
	
	var getEventModifierState = __webpack_require__(76);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(17);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(44);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 347 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule checkReactTypeSpec
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactPropTypeLocationNames = __webpack_require__(70);
	var ReactPropTypesSecret = __webpack_require__(72);
	
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(67);
	}
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          if (!ReactComponentTreeHook) {
	            ReactComponentTreeHook = require('./ReactComponentTreeHook');
	          }
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeHook.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeHook.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(106);
	var warning = __webpack_require__(6);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactCurrentOwner = __webpack_require__(20);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstanceMap = __webpack_require__(34);
	
	var getHostComponentFromComposite = __webpack_require__(126);
	var invariant = __webpack_require__(2);
	var warning = __webpack_require__(6);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(63);
	var traverseAllChildren = __webpack_require__(80);
	var warning = __webpack_require__(6);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && process.env && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(67);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('./ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(56)))

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(75);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 353 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(9);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(5);
	
	var ReactElement = __webpack_require__(14);
	
	var invariant = __webpack_require__(2);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(45);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(117);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(132);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 359 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(133);
	
	var _isPlainObject = __webpack_require__(55);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(135);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  if (false) {
	    var unexpectedKeyCache = {};
	  }
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 361 */
/***/ function(module, exports) {

	"use strict";
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	module.exports = function (_ref) {
	  var data = _ref.data;
	  var multiSection = _ref.multiSection;
	
	  function nextNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = 0;
	    } else {
	      sectionIndex++;
	    }
	
	    while (sectionIndex < data.length && data[sectionIndex] === 0) {
	      sectionIndex++;
	    }
	
	    return sectionIndex === data.length ? null : sectionIndex;
	  }
	
	  function prevNonEmptySectionIndex(sectionIndex) {
	    if (sectionIndex === null) {
	      sectionIndex = data.length - 1;
	    } else {
	      sectionIndex--;
	    }
	
	    while (sectionIndex >= 0 && data[sectionIndex] === 0) {
	      sectionIndex--;
	    }
	
	    return sectionIndex === -1 ? null : sectionIndex;
	  }
	
	  function next(position) {
	    var _position = _slicedToArray(position, 2);
	
	    var sectionIndex = _position[0];
	    var itemIndex = _position[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === data[sectionIndex] - 1) {
	        sectionIndex = nextNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, 0];
	      }
	
	      return [sectionIndex, itemIndex + 1];
	    }
	
	    if (data === 0 || itemIndex === data - 1) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, 0];
	    }
	
	    return [null, itemIndex + 1];
	  }
	
	  function prev(position) {
	    var _position2 = _slicedToArray(position, 2);
	
	    var sectionIndex = _position2[0];
	    var itemIndex = _position2[1];
	
	
	    if (multiSection) {
	      if (itemIndex === null || itemIndex === 0) {
	        sectionIndex = prevNonEmptySectionIndex(sectionIndex);
	
	        if (sectionIndex === null) {
	          return [null, null];
	        }
	
	        return [sectionIndex, data[sectionIndex] - 1];
	      }
	
	      return [sectionIndex, itemIndex - 1];
	    }
	
	    if (data === 0 || itemIndex === 0) {
	      return [null, null];
	    }
	
	    if (itemIndex === null) {
	      return [null, data - 1];
	    }
	
	    return [null, itemIndex - 1];
	  }
	
	  function isLast(position) {
	    return next(position)[1] === null;
	  }
	
	  return {
	    next: next,
	    prev: prev,
	    isLast: isLast
	  };
	};


/***/ },
/* 362 */
/***/ function(module, exports) {

	module.exports = function shallowEqualArrays(arrA, arrB) {
	  if (arrA === arrB) {
	    return true;
	  }
	
	  var len = arrA.length;
	
	  if (arrB.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (arrA[i] !== arrB[i]) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(188);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/sass-loader/index.js?outputStyle=expanded!./Masthead.scss", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/sass-loader/index.js?outputStyle=expanded!./Masthead.scss");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(189);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./footer.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./footer.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(190);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./identificator.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./identificator.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(191);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./linechart.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./linechart.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(192);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./lineChartMultiple.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./lineChartMultiple.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(193);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section1.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section1.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(194);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section2.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section2.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(195);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section3.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section3.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(196);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section4.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section4.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(197);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section5.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section5.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(198);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section6.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./section6.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(199);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./storyhead.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./storyhead.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(200);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./svgMap.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./svgMap.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(201);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./tooltip.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./tooltip.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(202);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./video.styl", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./../../../node_modules/stylus-loader/index.js!./video.styl");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(203);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./accordion.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./accordion.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(211);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./icon.min.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./icon.min.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(213);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./input.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./input.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(214);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./label.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./label.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(215);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./list.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./list.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(218);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./segment.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./segment.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(220);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./table.css", function() {
				var newContent = require("!!./../../../../css-loader/index.js!./../../../../postcss-loader/index.js!./table.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(221);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./search.css", function() {
				var newContent = require("!!./../../../node_modules/css-loader/index.js!./../../../node_modules/postcss-loader/index.js!./search.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	// style-loader: Adds some css to the DOM by adding a <style> tag
	
	// load the styles
	var content = __webpack_require__(222);
	if(typeof content === 'string') content = [[module.id, content, '']];
	// add the styles to the DOM
	var update = __webpack_require__(4)(content, {});
	if(content.locals) module.exports = content.locals;
	// Hot Module Replacement
	if(false) {
		// When the styles change, update the <style> tags
		if(!content.locals) {
			module.hot.accept("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./App.css", function() {
				var newContent = require("!!./../../node_modules/css-loader/index.js!./../../node_modules/postcss-loader/index.js!./App.css");
				if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
				update(newContent);
			});
		}
		// When the module is disposed, remove the <style> tags
		module.hot.dispose(function() { update(); });
	}

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(388);


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(389);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(400)(module)))

/***/ },
/* 389 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file Insert Google Analytics code into the page.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var GoogleAnalytics = function (_React$Component) {
	  _inherits(GoogleAnalytics, _React$Component);
	
	  function GoogleAnalytics() {
	    _classCallCheck(this, GoogleAnalytics);
	
	    return _possibleConstructorReturn(this, (GoogleAnalytics.__proto__ || Object.getPrototypeOf(GoogleAnalytics)).apply(this, arguments));
	  }
	
	  _createClass(GoogleAnalytics, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Since the component did mount, we can change the DOM -> add the Google
	      // Tracking code
	      (function (i, s, o, g, r, a, m) {
	        i['GoogleAnalyticsObject'] = r;
	        i[r] = i[r] || function () {
	          (i[r].q = i[r].q || []).push(arguments);
	        }, i[r].l = 1 * new Date();
	        a = s.createElement(o), m = s.getElementsByTagName(o)[0];
	        a.async = 1;
	        a.src = g;
	        m.parentNode.insertBefore(a, m);
	      })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');
	
	      this.props.trackers.map(function (tracker) {
	        // When creating more than one tracker, each tracker needs to be
	        // given its own name, otherwise just one tracker will be created
	        window.ga('create', tracker.id, 'auto', tracker.name);
	        // When a tracker sends a command, it will have to send the
	        // command prefixed with the tracker name, so it will work correctly.
	        window.ga(tracker.name + '.send', 'pageview');
	      });
	    }
	
	    /**
	     * There's nothing to render, the DOM changes should happen in
	     * componentDidMount() already.
	     *
	     * @returns {null}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return GoogleAnalytics;
	}(_react2.default.Component);
	
	GoogleAnalytics.propTypes = {
	  trackers: _react2.default.PropTypes.array.isRequired
	};
	
	GoogleAnalytics.defaultProps = {
	  trackers: []
	};
	
	exports.default = GoogleAnalytics;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file Component to use Google Tag Manager on the page.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var GoogleTagManager = function (_React$Component) {
	  _inherits(GoogleTagManager, _React$Component);
	
	  function GoogleTagManager() {
	    _classCallCheck(this, GoogleTagManager);
	
	    return _possibleConstructorReturn(this, (GoogleTagManager.__proto__ || Object.getPrototypeOf(GoogleTagManager)).apply(this, arguments));
	  }
	
	  _createClass(GoogleTagManager, [{
	    key: 'componentDidMount',
	
	
	    /**
	     * Calling the GTM snippet should make sure that the code and the DOM
	     * changes are executed once after loading the component. (That's the
	     * theory, anyways)
	     */
	    value: function componentDidMount() {
	      //region Code Snippet from Google
	      (function (w, d, s, l, i) {
	        w[l] = w[l] || [];
	        w[l].push({
	          'gtm.start': new Date().getTime(),
	          event: 'gtm.js'
	        });
	        var f = d.getElementsByTagName(s)[0],
	            j = d.createElement(s),
	            dl = l != 'dataLayer' ? '&l=' + l : '';
	        j.async = true;
	        j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;
	        f.parentNode.insertBefore(j, f);
	      })(window, document, 'script', 'dataLayer', this.props.gtmId);
	      //endregion
	    }
	
	    /**
	     * Renders the noscript fallback.
	     *
	     * Does rendering something using a noscript tag make much sense? Not at
	     * first, but according to
	     * https://twitter.com/bockph/status/793399813089923072 it can be useful
	     * in isomorphic environments (where parts of the code is rendered on the
	     * server).
	     *
	     * @returns {null | XML}
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	
	      if (this.props.gtmId === '') {
	        return null;
	      }
	
	      return _react2.default.createElement(
	        'noscript',
	        null,
	        _react2.default.createElement('iframe', {
	          src: '//www.googletagmanager.com/ns.html?id=' + this.props.gtmId,
	          height: '0', width: '0',
	          style: { display: 'none', visibility: 'hidden' } })
	      );
	    }
	  }]);
	
	  return GoogleTagManager;
	}(_react2.default.Component);
	
	GoogleTagManager.propTypes = {
	  gtmId: _react2.default.PropTypes.string.isRequired
	};
	
	GoogleTagManager.defaultProps = {};
	
	exports.default = GoogleTagManager;

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taReactTrackingpixel = __webpack_require__(142);
	
	var _taReactTrackingpixel2 = _interopRequireDefault(_taReactTrackingpixel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @file NewsnetTracker component class to render an invisible pixel image
	 * that tracks the hits on the page.
	 */
	
	var NewsnetTracker = function NewsnetTracker(props) {
	
	  if (!props.articleId) {
	    return null;
	  }
	
	  return _react2.default.createElement(_taReactTrackingpixel2.default, {
	    url: 'http://www.tagesanzeiger.ch/' + props.articleId + '/pixel.gif?nocache=' + Math.random() * 100000 });
	};
	
	NewsnetTracker.propTypes = {
	  /**
	   * The article ID as displayed in CD.
	   */
	  articleId: _react2.default.PropTypes.string.isRequired
	};
	
	exports.default = NewsnetTracker;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _d3Request = __webpack_require__(92);
	
	var _taReactWemftracking = __webpack_require__(394);
	
	var _taReactWemftracking2 = _interopRequireDefault(_taReactWemftracking);
	
	var _taReactGa = __webpack_require__(390);
	
	var _taReactGa2 = _interopRequireDefault(_taReactGa);
	
	var _taReactGtm = __webpack_require__(391);
	
	var _taReactGtm2 = _interopRequireDefault(_taReactGtm);
	
	var _taReactNewsnettracker = __webpack_require__(392);
	
	var _taReactNewsnettracker2 = _interopRequireDefault(_taReactNewsnettracker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @file One-size-fits-all tracking component, supports Google Analytics,
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *   Google Tag Manager, WEMF NetMetrix and internal Newsnet tracker.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Tracking = function (_React$Component) {
	  _inherits(Tracking, _React$Component);
	
	  function Tracking(props) {
	    _classCallCheck(this, Tracking);
	
	    // Use props to populate the default state
	    var _this = _possibleConstructorReturn(this, (Tracking.__proto__ || Object.getPrototypeOf(Tracking)).call(this, props));
	
	    _this.state = _extends({}, props);
	    return _this;
	  }
	
	  _createClass(Tracking, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.rawSiteData) {
	        this.extractDataAndSetState(nextProps.rawSiteData);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'small',
	        null,
	        this.state.wemfTrackingUrls && this.state.wemfTrackingUrls.length > 0 ? _react2.default.createElement(_taReactWemftracking2.default, { trackingUrls: this.state.wemfTrackingUrls }) : '',
	        this.state.gaTrackers && this.state.gaTrackers.length > 0 ? _react2.default.createElement(_taReactGa2.default, { trackers: this.state.gaTrackers }) : '',
	        this.state.gtmId ? _react2.default.createElement(_taReactGtm2.default, { gtmId: this.state.gtmId }) : '',
	        this.props.articleId ? _react2.default.createElement(_taReactNewsnettracker2.default, { articleId: this.props.articleId }) : ''
	      );
	    }
	
	    /**
	     * Called once, after the initial rendering. Since we only try and request the
	     * Site Data object now, we have to make sure that the render() method
	     * won't render anything without having the required properties of it's
	     * children elements.
	     */
	
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // Raw Site Data has not been provided, start our own request to get it.
	      if (!this.props.rawSiteData) {
	        var hostname = window.location.hostname;
	
	        // to avoid a error message on localhost
	        if (hostname == 'localhost') {
	          hostname = 'www.tagesanzeiger.ch';
	          //return;
	        }
	
	        hostname = hostname.substring(hostname.lastIndexOf('.', hostname.lastIndexOf('.') - 1) + 1); // extract domain name from
	        // host (crops subdomains like
	        // interaktiv.)
	
	        (0, _d3Request.json)('http://www.' + hostname + '/api/sites/default').get(function (error, siteData) {
	          if (error) {
	            console.log(error);
	          }
	
	          _this2.extractDataAndSetState(siteData);
	        });
	      } else {
	        // We have been provided by the raw Site Data object, we just have to
	        // parse it and get the data out
	        this.extractDataAndSetState(this.props.rawSiteData);
	      }
	    }
	  }, {
	    key: 'extractDataAndSetState',
	    value: function extractDataAndSetState(siteData) {
	      var _this3 = this;
	
	      var urlList = [];
	
	      siteData.site.statistics.map(function (stat) {
	        urlList.push(stat.desktop_url + 'interactive/' + _this3.props.projectId);
	      });
	
	      this.setState({
	        gaTrackers: siteData.site.google_analytics_information.trackers,
	        gtmId: siteData.site.gtm_id,
	        wemfTrackingUrls: urlList
	      });
	    }
	  }]);
	
	  return Tracking;
	}(_react2.default.Component);
	
	Tracking.propTypes = {
	  projectId: _react2.default.PropTypes.string,
	  rawSiteData: _react2.default.PropTypes.object,
	  articleId: _react2.default.PropTypes.string
	};
	
	Tracking.defaultProps = {
	  projectId: 'default-project'
	};
	
	exports.default = Tracking;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _taReactTrackingpixel = __webpack_require__(142);
	
	var _taReactTrackingpixel2 = _interopRequireDefault(_taReactTrackingpixel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * @file React component used to display invisible tracking pixel using the
	 * WEMF endpoint.
	 */
	
	var WemfTracking = function WemfTracking(props) {
	  var pixels = [];
	
	  props.trackingUrls.map(function (url) {
	    pixels.push(_react2.default.createElement(_taReactTrackingpixel2.default, {
	      url: url + '?r=' + encodeURIComponent(document.referrer) + '&d=' + Date.now(),
	      key: url }));
	  });
	
	  return _react2.default.createElement(
	    'span',
	    null,
	    pixels
	  );
	};
	
	WemfTracking.propTypes = {
	  /**
	   * List of Tracking pixel source URLs for use with WEMF tracking.
	   */
	  trackingUrls: _react2.default.PropTypes.arrayOf(_react2.default.PropTypes.string).isRequired
	};
	
	WemfTracking.defaultProps = {};
	
	exports.default = WemfTracking;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "6187f6c5dfa7f756dca5f6f069953529.jpg";

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "e36fffa0bb33ada6c79159fff14d57e6.jpg";

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "a4f1bbf05e03898cfb70617b61bd8894.jpg";

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "96574ccd1ed22ce6497f91fdcb14939f.jpg";

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "2b0823211c60bbe598f514fe0a7331c3.jpg";

/***/ },
/* 400 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }
/******/ ])));


// WEBPACK FOOTER //
// app.12af42bad6fb21a6c3c6.js